import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
};

export type AcceptDealSuggestion = {
  __typename?: 'AcceptDealSuggestion';
  dealSuggestion?: Maybe<DealSuggestion>;
};

export type AcceptDealSuggestionInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type AcceptTaskSuggestion = {
  __typename?: 'AcceptTaskSuggestion';
  taskSuggestion?: Maybe<TaskSuggestion>;
};

export type AcceptTaskSuggestionInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type Account = Node & {
  __typename?: 'Account';
  accountAssociations: Array<EntityAssociation>;
  additionalOwners?: Maybe<Array<Maybe<User>>>;
  asOfTs?: Maybe<Scalars['DateTime']['output']>;
  associatedAccounts?: Maybe<Array<Maybe<Account>>>;
  associations: Array<EntityAssociation>;
  contactAssociations: Array<EntityAssociation>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  customProperties?: Maybe<Scalars['GenericScalar']['output']>;
  dealSnapshots?: Maybe<DealSnapshotConnection>;
  deals?: Maybe<DealConnection>;
  domain?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastEmail?: Maybe<Engagement>;
  lastEmailId?: Maybe<Scalars['String']['output']>;
  lastEmailTime?: Maybe<Scalars['DateTime']['output']>;
  lastEngagement?: Maybe<Engagement>;
  location?: Maybe<Scalars['String']['output']>;
  nextEngagement?: Maybe<Engagement>;
  owner?: Maybe<User>;
  owners?: Maybe<Array<Maybe<User>>>;
  postgresId?: Maybe<Scalars['Int']['output']>;
  properties?: Maybe<AccountProperties>;
  /** @deprecated Duplicates `properties`; use the structured `properties` field instead. */
  propertiesJson?: Maybe<Scalars['String']['output']>;
  /** Original CRM (HubSpot/Salesforce) record id; null for Coffee-native records */
  sourceId?: Maybe<Scalars['String']['output']>;
  userLists?: Maybe<UserListConnection>;
  workspaceId: Scalars['Int']['output'];
};


export type AccountDealSnapshotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountDealsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountUserListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountCandidate = {
  __typename?: 'AccountCandidate';
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AccountConnection = {
  __typename?: 'AccountConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AccountEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Account` and its cursor. */
export type AccountEdge = {
  __typename?: 'AccountEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<Account>;
};

export type AccountFilter = {
  annualRevenue?: InputMaybe<Array<InputMaybe<FloatRangeFilterInput>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customProperties?: InputMaybe<Array<InputMaybe<CustomPropertyFilterInput>>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  geoFilter?: InputMaybe<GeoFilterInput>;
  geoFilters?: InputMaybe<Array<InputMaybe<GeoFilterInput>>>;
  hasDeals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  industry?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastActivity?: InputMaybe<ActivityDateFilterInput>;
  lastEmail?: InputMaybe<EngagementDateFilterInput>;
  listMembership?: InputMaybe<Scalars['ID']['input']>;
  locations?: InputMaybe<Array<InputMaybe<LocationFilterInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextActivity?: InputMaybe<ActivityDateFilterInput>;
  numberOfEmployees?: InputMaybe<Array<InputMaybe<FloatRangeFilterInput>>>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  primaryDomain?: InputMaybe<Scalars['String']['input']>;
  raisedAmount?: InputMaybe<Array<InputMaybe<FloatRangeFilterInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sizeCategory?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  techTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccountGridSummary = {
  __typename?: 'AccountGridSummary';
  fillRates?: Maybe<Array<Maybe<FillRateDatum>>>;
};

export type AccountProperties = {
  __typename?: 'AccountProperties';
  abmTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  aboutUs?: Maybe<Scalars['String']['output']>;
  additionalDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  aiSummary?: Maybe<Scalars['String']['output']>;
  analyticsTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  annualRevenue?: Maybe<Scalars['String']['output']>;
  applicationSecurityTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  avatarBackground?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cloudProviderTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cloudSecurityTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cmsTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  companySizeCategory?: Maybe<Scalars['String']['output']>;
  continent?: Maybe<Scalars['String']['output']>;
  conversationIntelligenceTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  country?: Maybe<Scalars['String']['output']>;
  crmTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  developmentTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  eCommercePlatformTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email?: Maybe<Scalars['String']['output']>;
  emailHostingTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emailSecurityTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  employeeCount?: Maybe<Scalars['String']['output']>;
  employeeCountMax?: Maybe<Scalars['Float']['output']>;
  employeeCountMin?: Maybe<Scalars['Float']['output']>;
  entitySubtype?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  foundedYear?: Maybe<Scalars['Int']['output']>;
  highlight?: Maybe<Scalars['String']['output']>;
  industries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  industry?: Maybe<Scalars['String']['output']>;
  lastActivityText?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketingAutomationTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  martechCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  nextActivityText?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['Float']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  raisedAmount?: Maybe<Scalars['String']['output']>;
  revenueMax?: Maybe<Scalars['Float']['output']>;
  revenueMin?: Maybe<Scalars['Float']['output']>;
  revenueRange?: Maybe<Scalars['String']['output']>;
  salesAutomationTech?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  state?: Maybe<Scalars['String']['output']>;
  techTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type AccountPropertiesInput = {
  abmTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aboutUs?: InputMaybe<Scalars['String']['input']>;
  additionalDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalOwnerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  analyticsTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  annualRevenue?: InputMaybe<Scalars['String']['input']>;
  applicationSecurityTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  cloudProviderTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cloudSecurityTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cmsTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySizeCategory?: InputMaybe<Scalars['String']['input']>;
  continent?: InputMaybe<Scalars['String']['input']>;
  conversationIntelligenceTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  crmTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  developmentTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  eCommercePlatformTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHostingTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailSecurityTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employeeCount?: InputMaybe<Scalars['String']['input']>;
  employeeCountMax?: InputMaybe<Scalars['Float']['input']>;
  employeeCountMin?: InputMaybe<Scalars['Float']['input']>;
  entitySubtype?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  foundedYear?: InputMaybe<Scalars['Int']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastActivityText?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  marketingAutomationTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  martechCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextActivityText?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Float']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  raisedAmount?: InputMaybe<Scalars['String']['input']>;
  revenueMax?: InputMaybe<Scalars['Float']['input']>;
  revenueMin?: InputMaybe<Scalars['Float']['input']>;
  revenueRange?: InputMaybe<Scalars['String']['input']>;
  salesAutomationTech?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  techTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateAutomationRule = {
  __typename?: 'ActivateAutomationRule';
  rule?: Maybe<AutomationRule>;
};

export type ActivityDateFilterInput = {
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  withinLast?: InputMaybe<RelativeDurationInput>;
  withinNext?: InputMaybe<RelativeDurationInput>;
};

export type ActivityDetails = {
  __typename?: 'ActivityDetails';
  lastActivity?: Maybe<Scalars['String']['output']>;
  lastActivityId?: Maybe<Scalars['String']['output']>;
  nextStep?: Maybe<Scalars['String']['output']>;
  nextStepId?: Maybe<Scalars['String']['output']>;
};

export type AddAiChatMessageFeedback = {
  __typename?: 'AddAiChatMessageFeedback';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AddAiChatMessageFeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['Int']['input'];
  vote: Scalars['Int']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type AddEmailSuppressionMutation = {
  __typename?: 'AddEmailSuppressionMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AddFavorite = {
  __typename?: 'AddFavorite';
  favorite?: Maybe<UserFavoriteType>;
};

export type AddFavoriteInput = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type AddRecordsToList = {
  __typename?: 'AddRecordsToList';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AddRecordsToListInput = {
  listId: Scalars['ID']['input'];
  recordIds: Array<InputMaybe<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type AddUserGroupMembers = {
  __typename?: 'AddUserGroupMembers';
  userGroup?: Maybe<UserGroupType>;
};

export type AddUserManager = {
  __typename?: 'AddUserManager';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddUserManagerInput = {
  managerId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type AddWorkspaceDomain = {
  __typename?: 'AddWorkspaceDomain';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  workspace?: Maybe<Workspace>;
};

export type AddWorkspaceDomainInput = {
  /** A non-free email domain, e.g. acme.io */
  domain: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export enum AgeComparator {
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte'
}

export type AgeFilterInput = {
  comparator?: InputMaybe<AgeComparator>;
  unit?: InputMaybe<AgeUnit>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum AgeUnit {
  Days = 'days',
  Months = 'months',
  Weeks = 'weeks',
  Years = 'years'
}

/** Per-agent credit usage within a billing period. */
export type AgentCreditUsage = {
  __typename?: 'AgentCreditUsage';
  /** Action label (e.g. 'Per meeting') */
  actionType: Scalars['String']['output'];
  /** Display name (e.g. 'Meeting Agent') */
  agentName: Scalars['String']['output'];
  /** Cost label (e.g. '1 credit') */
  creditCost: Scalars['String']['output'];
  /** Credits consumed this period */
  creditsUsed: Scalars['Int']['output'];
  /** Whether this agent is currently active */
  enabled: Scalars['Boolean']['output'];
  /** Backend enum value (e.g. 'MEETING_AGENT') */
  sourceFeature: Scalars['String']['output'];
};

export type AgentDefinition = {
  __typename?: 'AgentDefinition';
  allowedTools: Array<Maybe<Scalars['String']['output']>>;
  conditions?: Maybe<Scalars['JSONString']['output']>;
  guardActions?: Maybe<Scalars['JSONString']['output']>;
  id: Scalars['ID']['output'];
  maxIterations: Scalars['Int']['output'];
  modelUseCase: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifyEmail?: Maybe<Scalars['Boolean']['output']>;
  notifySlack?: Maybe<Scalars['Boolean']['output']>;
  notifyTarget?: Maybe<Scalars['String']['output']>;
  notifyUserIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  ownerUserId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  systemPrompt: Scalars['String']['output'];
  trigger?: Maybe<AgentTrigger>;
  updateTs?: Maybe<Scalars['String']['output']>;
  visibility: Scalars['String']['output'];
  workspaceId: Scalars['Int']['output'];
};

/**
 * What a preview is doing right now. Polled alongside the in-flight testAgentDefinition
 * mutation — the mutation is synchronous and can run for minutes, which is indistinguishable
 * from a hang without this.
 */
export type AgentPreviewProgress = {
  __typename?: 'AgentPreviewProgress';
  iteration: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  phase: Scalars['String']['output'];
  toolsUsed: Array<Maybe<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * One recorded agent run. The durable answer to "what did this agent actually do?" —
 * Temporal holds the same story for 24 hours on prd and then drops it.
 */
export type AgentRun = {
  __typename?: 'AgentRun';
  attempt: Scalars['Int']['output'];
  definitionName?: Maybe<Scalars['String']['output']>;
  definitionRef: Scalars['String']['output'];
  delivered?: Maybe<Scalars['Boolean']['output']>;
  delivery?: Maybe<Scalars['JSONString']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  iterations: Scalars['Int']['output'];
  objectType?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Array<Maybe<AgentSource>>>;
  startedAt?: Maybe<Scalars['String']['output']>;
  stopReason?: Maybe<Scalars['String']['output']>;
  toolsCalled: Array<Maybe<Scalars['String']['output']>>;
};

/**
 * Where one data domain an agent reads comes from, in this workspace.
 *
 * Every field is STRUCTURED and ``summary`` is the sentence to show — the same one the starter
 * card's unavailable reason and the run-history row carry, rendered once by
 * ``connections.resolver.SourceState.summary``. #4579's rule applies here as much as to a
 * figure: a fact a surface states must arrive as a field, never as prose somebody re-derives.
 */
export type AgentSource = {
  __typename?: 'AgentSource';
  domain: Scalars['String']['output'];
  label: Scalars['String']['output'];
  lastSyncAt?: Maybe<Scalars['String']['output']>;
  providers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stale?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

/** The read-only seeded catalog ("Suggested agents"). */
export type AgentTemplate = {
  __typename?: 'AgentTemplate';
  allowedTools: Array<Maybe<Scalars['String']['output']>>;
  available: Scalars['Boolean']['output'];
  category?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['JSONString']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notifySlack: Scalars['Boolean']['output'];
  systemPrompt: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  trigger?: Maybe<AgentTrigger>;
  unavailableReasons: Array<Maybe<Scalars['String']['output']>>;
  visibility: Scalars['String']['output'];
};

/**
 * Whether one template-derived agent is running an old revision of its starter, and what
 * could safely be brought forward.
 *
 * Three lists, and they are not interchangeable. ``updates`` are fields the template moved and
 * the author never touched — safe to apply. ``authorEdited`` are fields the author changed and
 * the upgrade will LEAVE ALONE. ``conflicts`` are fields both moved; only a person can settle
 * one, so an upgrade reports them and applies nothing.
 */
export type AgentTemplateDrift = {
  __typename?: 'AgentTemplateDrift';
  authorEdited: Array<Maybe<Scalars['String']['output']>>;
  conflicts: Array<Maybe<Scalars['String']['output']>>;
  currentVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  instanceVersion?: Maybe<Scalars['Int']['output']>;
  outdated: Scalars['Boolean']['output'];
  sourceTemplate: Scalars['String']['output'];
  unknownTemplate: Scalars['Boolean']['output'];
  updates: Scalars['JSONString']['output'];
};

export type AgentTrigger = {
  __typename?: 'AgentTrigger';
  anchorField?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Scalars['JSONString']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  daysBefore?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  event?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['JSONString']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  pathPattern?: Maybe<Scalars['String']['output']>;
  repeat?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  stageIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Scalars['String']['output'];
  usage?: Maybe<Scalars['JSONString']['output']>;
};

export type AgentTriggerInput = {
  anchorField?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['JSONString']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  daysBefore?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  event?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  pathPattern?: InputMaybe<Scalars['String']['input']>;
  repeat?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
  usage?: InputMaybe<Scalars['JSONString']['input']>;
};

export type AggregateChange = {
  __typename?: 'AggregateChange';
  current: Scalars['Float']['output'];
  diff: Scalars['Float']['output'];
  previous: Scalars['Float']['output'];
};

export type AiChatConversationType = {
  __typename?: 'AiChatConversationType';
  agentSessionId?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['String']['output']>;
  contextType?: Maybe<Scalars['String']['output']>;
  createTs?: Maybe<Scalars['DateTime']['output']>;
  firstMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updateTs?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type AiChatMessageType = {
  __typename?: 'AiChatMessageType';
  content?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  createTs?: Maybe<Scalars['DateTime']['output']>;
  feedbackComment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  vote?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

/** Preview result for a single entity */
export type AiFieldPreviewResult = {
  __typename?: 'AiFieldPreviewResult';
  entityId: Scalars['String']['output'];
  /** Display name of entity (contact/account/deal) */
  entityName: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  generatedValue: Scalars['String']['output'];
};

/** GraphQL type for AI job execution */
export type AiJobExecutionType = {
  __typename?: 'AiJobExecutionType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  failedRecords?: Maybe<Scalars['Int']['output']>;
  fieldId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  listId?: Maybe<Scalars['Int']['output']>;
  processedRecords?: Maybe<Scalars['Int']['output']>;
  progressPercentage?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  temporalWorkflowId?: Maybe<Scalars['String']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum AppType {
  Crm = 'CRM',
  CrmGrader = 'CRM_GRADER'
}

/**
 * Run one policy request on the caller's authority.
 *
 * This is the surface ``run_policy_request`` was written for. The rule tools refuse any run that
 * carries no ``authoring_user_id``, and no other run path supplies one — the fire path
 * deliberately does not, because standing governance should be written by a person who is asking
 * for it. Until this mutation existed the tools were correct and unreachable.
 *
 * The admin check is NOT repeated here: it lives once in ``rules.rule_authoring``, and a second
 * copy in the API layer is how two gates start disagreeing. Entitlement is checked by narrowing
 * the toolset instead of refusing outright, so a workspace that has not opted into agent-authored
 * policy can still ask what it is already enforcing.
 */
export type AuthorPolicy = {
  __typename?: 'AuthorPolicy';
  result: PolicyRequestResult;
};

export type AuthorPolicyInput = {
  previewId?: InputMaybe<Scalars['String']['input']>;
  request: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type AutomationRule = Node & {
  __typename?: 'AutomationRule';
  actions?: Maybe<Scalars['JSONString']['output']>;
  conditions?: Maybe<Scalars['JSONString']['output']>;
  createTs?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextRunAt?: Maybe<Scalars['String']['output']>;
  objectType: Scalars['String']['output'];
  ownerUserId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  trigger?: Maybe<Scalars['JSONString']['output']>;
  updateTs?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['Int']['output'];
};

/** Billing cycle enum. */
export enum BillingCycle {
  Monthly = 'monthly',
  Yearly = 'yearly'
}

/** Input for billing portal flow_data to direct the user to a specific flow. */
export type BillingPortalFlowDataInput = {
  /** Required when type is 'subscription_update'. Omit for 'payment_method_update'. */
  subscriptionUpdate?: InputMaybe<BillingPortalSubscriptionUpdateInput>;
  /** Flow type: 'subscription_update' (change plan) or 'payment_method_update' (add/update payment method) */
  type: Scalars['String']['input'];
};

/** Input for subscription_update flow data. */
export type BillingPortalSubscriptionUpdateInput = {
  /** Stripe subscription ID to update */
  subscriptionId: Scalars['String']['input'];
};

/** Billing settings. */
export type BillingSettings = {
  __typename?: 'BillingSettings';
  /** Credits to USD conversion rate */
  creditsToUsdRate: Scalars['Float']['output'];
  /** Last updated timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

export type BriefTemplateClass = Node & {
  __typename?: 'BriefTemplateClass';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isWorkspaceWide?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<BriefTemplateSection>>>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type BriefTemplateConnection = {
  __typename?: 'BriefTemplateConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BriefTemplateEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `BriefTemplate` and its cursor. */
export type BriefTemplateEdge = {
  __typename?: 'BriefTemplateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<BriefTemplateClass>;
};

export type BriefTemplateFilter = {
  createdByUserId?: InputMaybe<Scalars['Int']['input']>;
  isWorkspaceWide?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** A section within a brief template (output type). */
export type BriefTemplateSection = {
  __typename?: 'BriefTemplateSection';
  heading: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
};

/** A section within a brief template (input type). */
export type BriefTemplateSectionInput = {
  heading: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

/**
 * Direct, CSV-free company list build. icp-builder resolves the companies
 * (validity-gated, deduped, excluded) and writes them as NDJSON to S3; this
 * mutation starts a lean Temporal workflow that creates the accounts + static
 * list directly. Additive — the existing csvIngest path is untouched.
 */
export type BuildAccountList = {
  __typename?: 'BuildAccountList';
  ok?: Maybe<Scalars['Boolean']['output']>;
  run?: Maybe<CrmIngestionRun>;
};

export type BuildAccountListInput = {
  listName?: InputMaybe<Scalars['String']['input']>;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3Key: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/**
 * Direct, CSV-free people list build. icp-builder resolves the people
 * (the user's selected person_ids) and writes them as NDJSON to S3; this
 * mutation starts a lean Temporal workflow that creates the contacts + static
 * list directly and charges credits for the people created. Additive — the
 * existing csvIngest path is untouched.
 */
export type BuildContactList = {
  __typename?: 'BuildContactList';
  ok?: Maybe<Scalars['Boolean']['output']>;
  run?: Maybe<CrmIngestionRun>;
};

export type BuildContactListInput = {
  listName?: InputMaybe<Scalars['String']['input']>;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3Key: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type BulkAssignAccountOwner = {
  __typename?: 'BulkAssignAccountOwner';
  message?: Maybe<Scalars['String']['output']>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

export type BulkAssignOwner = {
  __typename?: 'BulkAssignOwner';
  message?: Maybe<Scalars['String']['output']>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

export type BulkAssignOwnerInput = {
  additionalOwnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ownerId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

/**
 * One row per BYOA agent, rolled up from its recent runs.
 *
 * Keyed on (workspace_id, definition_ref) rather than on the agent_definition PK, because
 * two populations of agent have no live definition row and both matter here: SEEDED
 * templates run under their template name and were never persisted, and a DELETED agent's
 * runs outlive it on purpose. Keying on the definition table would drop both.
 */
export type ByoaAgentHealth = {
  __typename?: 'ByoaAgentHealth';
  agentName?: Maybe<Scalars['String']['output']>;
  avgDurationMs?: Maybe<Scalars['Int']['output']>;
  /** 'ad|<pk>' for a persisted agent, else the seeded template name */
  definitionRef: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  deliveredFires: Scalars['Int']['output'];
  erroredFires: Scalars['Int']['output'];
  /** Runs with attempt=1 in the window -- the fire count, not the row count */
  fires: Scalars['Int']['output'];
  health: IntegrationHealthLevel;
  healthReason?: Maybe<Scalars['String']['output']>;
  lastDeliveredTs?: Maybe<Scalars['DateTime']['output']>;
  lastRunTs?: Maybe<Scalars['DateTime']['output']>;
  /** Highest Temporal retry counter seen; >3 means the retry cap is not holding */
  maxAttempt?: Maybe<Scalars['Int']['output']>;
  /** delivered IS NULL -- the run called no sink at all */
  noSinkFires: Scalars['Int']['output'];
  objectType?: Maybe<Scalars['String']['output']>;
  /** Runs exist but no agent_definition row does -- a seeded template */
  orphaned: Scalars['Boolean']['output'];
  /** Null for workspace-visible agents, which have no owner */
  ownerEmail?: Maybe<Scalars['String']['output']>;
  /** delivered IS FALSE -- a sink was called and refused */
  refusedFires: Scalars['Int']['output'];
  sourceTemplate?: Maybe<Scalars['String']['output']>;
  /** draft / active / paused */
  status?: Maybe<Scalars['String']['output']>;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  templateVersion?: Maybe<Scalars['Int']['output']>;
  /** Cron expression or event name */
  triggerDetail?: Maybe<Scalars['String']['output']>;
  triggerScope?: Maybe<Scalars['String']['output']>;
  triggerType?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['Int']['output'];
  workspaceName?: Maybe<Scalars['String']['output']>;
};

/**
 * One row per BYOA agent run.
 *
 * ``output`` is deliberately absent. A private agent's narration is content that was DM'd to
 * its owner, and superuser access is a reason we CAN read it, not a reason to put it on a
 * fleet dashboard. Nothing in the health verdict needs it.
 */
export type ByoaAgentRunHealth = {
  __typename?: 'ByoaAgentRunHealth';
  attempt: Scalars['Int']['output'];
  definitionName?: Maybe<Scalars['String']['output']>;
  definitionRef: Scalars['String']['output'];
  /** TRI-STATE: null = called no sink at all, false = a sink refused */
  delivered?: Maybe<Scalars['Boolean']['output']>;
  /** Per-sink verdict, e.g. 'notify_slack ok, send_email failed: channel_not_found' */
  deliverySummary?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Null on a PER_PERIOD digest -- no record in scope */
  entityId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  health: IntegrationHealthLevel;
  healthReason?: Maybe<Scalars['String']['output']>;
  iterations?: Maybe<Scalars['Int']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  runId: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  stopReason?: Maybe<Scalars['String']['output']>;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  /** Deduped and comma-joined for a table cell; a repeated tool carries a ×N count */
  toolsCalled?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['Int']['output'];
  workspaceName?: Maybe<Scalars['String']['output']>;
};

export type Campaign = Node & {
  __typename?: 'Campaign';
  additionalListIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  createTs?: Maybe<Scalars['String']['output']>;
  dailySendLimit?: Maybe<Scalars['Int']['output']>;
  enrollmentCounts?: Maybe<CampaignEnrollmentCounts>;
  id: Scalars['ID']['output'];
  lastDynamicRefreshAt?: Maybe<Scalars['String']['output']>;
  listId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerUserId: Scalars['Int']['output'];
  pausedAt?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['JSONString']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  stepStats?: Maybe<Array<Maybe<CampaignStepStats>>>;
  steps?: Maybe<Array<Maybe<CampaignStep>>>;
  updateTs?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['Int']['output'];
};

/** Lightweight aggregates over `campaign_enrollment` for the index view. */
export type CampaignEnrollmentCounts = {
  __typename?: 'CampaignEnrollmentCounts';
  active: Scalars['Int']['output'];
  bounced: Scalars['Int']['output'];
  clicked: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  enrolled: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  opened: Scalars['Int']['output'];
  skippedUndeliverable: Scalars['Int']['output'];
  undeliverable: Scalars['Int']['output'];
  unenrolled: Scalars['Int']['output'];
  unsubscribed: Scalars['Int']['output'];
};

/**
 * A contact in the per-step drill-down, sourced from the enrollment's
 * `merge_vars` snapshot (no live contact fetch).
 */
export type CampaignRecipient = {
  __typename?: 'CampaignRecipient';
  company?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CampaignStep = {
  __typename?: 'CampaignStep';
  attachments?: Maybe<Scalars['JSONString']['output']>;
  body: Scalars['String']['output'];
  delayDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  stepOrder: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
  templateId?: Maybe<Scalars['String']['output']>;
};

export type CampaignStepInput = {
  attachments?: InputMaybe<Scalars['JSONString']['input']>;
  body: Scalars['String']['input'];
  delayDays: Scalars['Int']['input'];
  subject: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Real per-step aggregates. See `campaigns/stats.py` for how each figure is
 * derived (sent = outbound engagements; replies = replied_step_order; opened /
 * clicked = distinct enrollments in campaign_email_event; bounced = bounced
 * enrollments at that step).
 *
 * `opened` / `clicked` / `bounced` use the same definitions as the
 * campaign-wide `CampaignEnrollmentCounts`, so a client can show the per-step
 * breakdown and the campaign total together without them disagreeing. Opens
 * and clicks both exclude machine traffic.
 */
export type CampaignStepStats = {
  __typename?: 'CampaignStepStats';
  bounced: Scalars['Int']['output'];
  clicked: Scalars['Int']['output'];
  opened: Scalars['Int']['output'];
  replies: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  stepOrder: Scalars['Int']['output'];
  unsubscribed: Scalars['Int']['output'];
};

/**
 * Inspect a pasted Fireflies key before connecting, so the dialog only
 * offers "Everyone in the workspace" when it can work. A mutation (not a
 * query) so the key never lands in Apollo's query cache. Stores nothing.
 *
 * canConnectWorkspace = valid key AND Fireflies admin key AND the caller is
 * a Coffee workspace admin. connectFirefliesWorkspace re-checks all three.
 */
export type CheckFirefliesKey = {
  __typename?: 'CheckFirefliesKey';
  canConnectWorkspace?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firefliesAdmin?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

/** Output type for Stripe Checkout session. */
export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  /** The Stripe Checkout URL to redirect to */
  checkoutUrl: Scalars['String']['output'];
  /** The Stripe session ID for reference */
  sessionId: Scalars['String']['output'];
};

/**
 * Locked-down public payload. Deliberately omits the source recording
 * URL and the full meeting transcript.
 */
export type ClipShareType = {
  __typename?: 'ClipShareType';
  clipVideoUrl?: Maybe<Scalars['String']['output']>;
  endSec?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startSec?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Array<Maybe<ClipTranscriptSegmentType>>>;
};

export type ClipTranscriptSegmentType = {
  __typename?: 'ClipTranscriptSegmentType';
  end?: Maybe<Scalars['Float']['output']>;
  speaker?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ClipType = {
  __typename?: 'ClipType';
  clipVideoUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endSec?: Maybe<Scalars['Float']['output']>;
  engagementId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shareSlug?: Maybe<Scalars['String']['output']>;
  startSec?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusError?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Array<Maybe<ClipTranscriptSegmentType>>>;
};

export type Company = {
  __typename?: 'Company';
  createTs?: Maybe<Scalars['DateTime']['output']>;
  curatedAt?: Maybe<Scalars['DateTime']['output']>;
  employeeCountMin?: Maybe<Scalars['Int']['output']>;
  /** Employee band label, e.g. '201 to 500'. Derived from employee_count_min and employee_count_max; null when the pair matches no band. */
  employeeRange?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  linkedinFollowers?: Maybe<Scalars['Float']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primaryDomain?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<CompanyProperties>;
  revenueMin?: Maybe<Scalars['Float']['output']>;
  /** Revenue band label, e.g. 'Under $1M'. Derived from revenue_min and revenue_max; null when the pair matches no band. */
  revenueRange?: Maybe<Scalars['String']['output']>;
  secondaryDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  updateTs?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyProperties = {
  __typename?: 'CompanyProperties';
  appStoreRating?: Maybe<Scalars['Float']['output']>;
  appStoreUrl?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  continent?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  employeeCount?: Maybe<Scalars['String']['output']>;
  foundedYear?: Maybe<Scalars['Int']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  industryNaicsCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  industryTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastFundingAmount?: Maybe<Scalars['Int']['output']>;
  lastFundingDate?: Maybe<Scalars['Date']['output']>;
  lastFundingType?: Maybe<Scalars['String']['output']>;
  leadInvestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  playStoreRating?: Maybe<Scalars['Float']['output']>;
  playStoreUrl?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  raisedAmount?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  techTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Finish the authorization flow: exchange the code, then discover and classify. */
export type CompleteMcpConnection = {
  __typename?: 'CompleteMcpConnection';
  connection?: Maybe<WorkspaceConnectionType>;
};

/**
 * Complete a pending Slack installation using stored OAuth tokens.
 * Called from frontend after Auth0 callback when pending_slack_install is present.
 */
export type CompleteSlackInstall = {
  __typename?: 'CompleteSlackInstall';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CompleteSlackInstallInput = {
  /** Pending Slack install ID from callback */
  pendingInstallId: Scalars['String']['input'];
  /** Workspace to connect Slack to */
  workspaceId: Scalars['ID']['input'];
};

/**
 * The admin's ruling on what we guessed the server supplies (D13).
 *
 * CONFIRMED is the activation: authoritative from here on, and it survives a re-discovery for as
 * long as the tools it names still exist. Without this step a misclassified server silently feeds
 * agents the wrong domain, and honest absence cannot catch it because the read SUCCEEDS.
 *
 * CONTACT_SUPPORT is the other half of the same question, and it has to be a real outcome rather
 * than a mailto: link — a workspace whose server we read as empty has nothing else it can do, and
 * an admin who has told us we are wrong must not keep being asked the same question by the card.
 */
export type ConfirmConnection = {
  __typename?: 'ConfirmConnection';
  connection?: Maybe<WorkspaceConnectionType>;
};

/**
 * Connect Fireflies.ai via a pasted personal API key (Fireflies has no OAuth
 * for its data API). Validates the key, stores it, retires any other external
 * recorder the user had, disables Coffee's own VC recording for this user, and
 * starts a backfill. Disconnect reuses DisconnectUserIntegration with
 * platform="FIREFLIES".
 */
export type ConnectFireflies = {
  __typename?: 'ConnectFireflies';
  integration?: Maybe<Integration>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Connect Fireflies for EVERYONE in the workspace (admin only) with a
 * Fireflies admin's API key. Every meeting the key can see is imported, owned
 * by the Coffee member it was recorded for — else by the connecting admin.
 * `error` is "invalid_key" or "not_admin_key" when ok is false.
 * Disconnect: disconnectIntegration(platform: "FIREFLIES").
 */
export type ConnectFirefliesWorkspace = {
  __typename?: 'ConnectFirefliesWorkspace';
  error?: Maybe<Scalars['String']['output']>;
  integration?: Maybe<Integration>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Connect Granola via a pasted personal API key (Granola has no OAuth for
 * the data API). Validates the key, stores it, and starts a backfill. By
 * default Granola runs alongside Coffee's recorder; with
 * keepCoffeeRecording=false ("Replace Coffee's recorder") Coffee recording is
 * turned off for this user. Disconnect reuses DisconnectUserIntegration with
 * platform="GRANOLA".
 */
export type ConnectGranola = {
  __typename?: 'ConnectGranola';
  integration?: Maybe<Integration>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Begin connecting an MCP server. Discovery decides which flow the admin sees. */
export type ConnectMcpServer = {
  __typename?: 'ConnectMcpServer';
  result?: Maybe<McpConnectStart>;
};

/**
 * The two buttons on the confirmation dialog.
 *
 * An enum rather than a boolean or a free string: the screen has exactly two answers, and both
 * are decisions a person made about a connection, so neither is the absence of the other.
 */
export enum ConnectionConfirmationOutcome {
  Confirmed = 'CONFIRMED',
  ContactSupport = 'CONTACT_SUPPORT'
}

export type Contact = Node & {
  __typename?: 'Contact';
  accountAssociations: Array<EntityAssociation>;
  accounts?: Maybe<AccountConnection>;
  additionalOwners?: Maybe<Array<Maybe<User>>>;
  asOfTs?: Maybe<Scalars['DateTime']['output']>;
  associations: Array<EntityAssociation>;
  contactAssociations: Array<EntityAssociation>;
  customProperties?: Maybe<Scalars['GenericScalar']['output']>;
  deals?: Maybe<DealConnection>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastEmail?: Maybe<Engagement>;
  lastEmailId?: Maybe<Scalars['String']['output']>;
  lastEmailTime?: Maybe<Scalars['DateTime']['output']>;
  lastEngagement?: Maybe<Engagement>;
  nextEngagement?: Maybe<Engagement>;
  owner?: Maybe<User>;
  owners?: Maybe<Array<Maybe<User>>>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<ContactProperties>;
  /** @deprecated Duplicates `properties`; use the structured `properties` field instead. */
  propertiesJson?: Maybe<Scalars['JSONString']['output']>;
  /** Original CRM (HubSpot/Salesforce) record id; null for Coffee-native records */
  sourceId?: Maybe<Scalars['String']['output']>;
  userLists?: Maybe<UserListConnection>;
  workspaceId: Scalars['ID']['output'];
};


export type ContactAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDealsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactUserListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** What the confirmation step states, from live data. */
export type ContactChangeImpactType = {
  __typename?: 'ContactChangeImpactType';
  accountCandidates?: Maybe<Array<Maybe<AccountCandidate>>>;
  accountMatch?: Maybe<Scalars['String']['output']>;
  dealCount?: Maybe<Scalars['Int']['output']>;
  dealNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  engagementCount?: Maybe<Scalars['Int']['output']>;
  existingContactId?: Maybe<Scalars['String']['output']>;
  existingContactName?: Maybe<Scalars['String']['output']>;
  syncedTo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContactChangeResultType = {
  __typename?: 'ContactChangeResultType';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  resolvedContactId?: Maybe<Scalars['String']['output']>;
  suggestion?: Maybe<ContactChangeSuggestionType>;
};

export type ContactChangeSuggestionType = {
  __typename?: 'ContactChangeSuggestionType';
  acceptMode?: Maybe<Scalars['String']['output']>;
  actedByName?: Maybe<Scalars['String']['output']>;
  actedByUserId?: Maybe<Scalars['Int']['output']>;
  actedTs?: Maybe<Scalars['DateTime']['output']>;
  availableModes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contactId?: Maybe<Scalars['String']['output']>;
  createTs?: Maybe<Scalars['DateTime']['output']>;
  dismissedByViewer?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['JSONString']['output']>;
  resolvedContactId?: Maybe<Scalars['String']['output']>;
  snapshot?: Maybe<Scalars['JSONString']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ContactConnection = {
  __typename?: 'ContactConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContactEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Contact` and its cursor. */
export type ContactEdge = {
  __typename?: 'ContactEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<Contact>;
};

export type ContactFilterInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  customProperties?: InputMaybe<Array<InputMaybe<CustomPropertyFilterInput>>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  geoFilter?: InputMaybe<GeoFilterInput>;
  geoFilters?: InputMaybe<Array<InputMaybe<GeoFilterInput>>>;
  hasDeals?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  industries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastActivity?: InputMaybe<ActivityDateFilterInput>;
  lastEmail?: InputMaybe<EngagementDateFilterInput>;
  listMembership?: InputMaybe<Scalars['ID']['input']>;
  locations?: InputMaybe<Array<InputMaybe<LocationFilterInput>>>;
  nextActivity?: InputMaybe<ActivityDateFilterInput>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type ContactGridSummary = {
  __typename?: 'ContactGridSummary';
  fillRates?: Maybe<Array<Maybe<FillRateDatum>>>;
};

export type ContactProperties = {
  __typename?: 'ContactProperties';
  additionalEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  aiSummary?: Maybe<Scalars['String']['output']>;
  avatarBackground?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  highlight?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastActivityText?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedinProfileUrl?: Maybe<Scalars['String']['output']>;
  nextActivityText?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ContactPropertiesInput = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalOwnerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastActivityText?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedinProfileUrl?: InputMaybe<Scalars['String']['input']>;
  nextActivityText?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAccount = {
  __typename?: 'CreateAccount';
  account?: Maybe<Account>;
};

export type CreateAccountInput = {
  customProperties?: InputMaybe<Scalars['GenericScalar']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<AccountPropertiesInput>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateAgentDefinition = {
  __typename?: 'CreateAgentDefinition';
  agent?: Maybe<AgentDefinition>;
};

export type CreateAgentDefinitionInput = {
  allowedTools?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  conditions?: InputMaybe<Scalars['JSONString']['input']>;
  guardActions?: InputMaybe<Scalars['JSONString']['input']>;
  maxIterations?: InputMaybe<Scalars['Int']['input']>;
  modelUseCase?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifyEmail?: InputMaybe<Scalars['Boolean']['input']>;
  notifySlack?: InputMaybe<Scalars['Boolean']['input']>;
  notifyTarget?: InputMaybe<Scalars['String']['input']>;
  notifyUserIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sourceTemplate?: InputMaybe<Scalars['String']['input']>;
  systemPrompt: Scalars['String']['input'];
  trigger?: InputMaybe<AgentTriggerInput>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type CreateAiChatConversation = {
  __typename?: 'CreateAiChatConversation';
  id?: Maybe<Scalars['Int']['output']>;
};

export type CreateAiChatConversationInput = {
  agentSessionId: Scalars['String']['input'];
  contextId?: InputMaybe<Scalars['String']['input']>;
  contextType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateAutomationRule = {
  __typename?: 'CreateAutomationRule';
  rule?: Maybe<AutomationRule>;
};

export type CreateAutomationRuleInput = {
  actions: Scalars['JSONString']['input'];
  conditions?: InputMaybe<Scalars['JSONString']['input']>;
  name: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  trigger: Scalars['JSONString']['input'];
  workspaceId: Scalars['Int']['input'];
};

export type CreateBadDataReport = {
  __typename?: 'CreateBadDataReport';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateBadDataReportInput = {
  correctValue?: InputMaybe<Scalars['String']['input']>;
  currentValue?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  model: EntityType;
  propertyName: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
  source: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/** Response type for creating a billing portal session. */
export type CreateBillingPortalSession = {
  __typename?: 'CreateBillingPortalSession';
  /** URL to redirect user to Stripe billing portal */
  url: Scalars['String']['output'];
};

/** Input type for creating a billing portal session. */
export type CreateBillingPortalSessionInput = {
  /** Optional flow data to direct user to a specific portal flow (e.g. subscription_update or payment_method_update for add payment). */
  flowData?: InputMaybe<BillingPortalFlowDataInput>;
  /** Optional return URL after billing portal. Defaults to configured app URL. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  /** Workspace ID */
  workspaceId: Scalars['ID']['input'];
};

export type CreateBriefTemplate = {
  __typename?: 'CreateBriefTemplate';
  briefTemplate?: Maybe<BriefTemplateClass>;
};

export type CreateBriefTemplateInput = {
  isWorkspaceWide?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sections: Array<InputMaybe<BriefTemplateSectionInput>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateCampaign = {
  __typename?: 'CreateCampaign';
  campaign?: Maybe<Campaign>;
};

export type CreateCampaignInput = {
  listId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  settings?: InputMaybe<Scalars['JSONString']['input']>;
  steps?: InputMaybe<Array<InputMaybe<CampaignStepInput>>>;
  workspaceId: Scalars['Int']['input'];
};

/** Input type for creating a Stripe Checkout session. */
export type CreateCheckoutSessionInput = {
  /** The Stripe Price ID for the subscription plan */
  priceId: Scalars['String']['input'];
  /** Optional callback URL after checkout. Defaults to configured app URL. */
  successUrl?: InputMaybe<Scalars['String']['input']>;
  /** The workspace ID */
  workspaceId: Scalars['ID']['input'];
};

export type CreateContact = {
  __typename?: 'CreateContact';
  contact?: Maybe<Contact>;
};

export type CreateContactInput = {
  customProperties?: InputMaybe<Scalars['GenericScalar']['input']>;
  primaryEmail: Scalars['String']['input'];
  properties?: InputMaybe<ContactPropertiesInput>;
  workspaceId: Scalars['ID']['input'];
};

/** Input type for creating a Stripe CustomerSession with pricing table. */
export type CreateCustomerSessionInput = {
  /** The workspace ID */
  workspaceId: Scalars['ID']['input'];
};

export type CreateDeal = {
  __typename?: 'CreateDeal';
  deal?: Maybe<Deal>;
};

/**
 * Create a new custom deal field for a workspace.
 * Used when users want to create custom fields beyond the default methodology fields.
 */
export type CreateDealField = {
  __typename?: 'CreateDealField';
  dealField?: Maybe<DealFieldClass>;
};

/** Input for creating a new custom deal field. */
export type CreateDealFieldInput = {
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateDealInput = {
  coffeeCustomProperties?: InputMaybe<Scalars['GenericScalar']['input']>;
  properties?: InputMaybe<DealPropertiesInput>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateDealStage = {
  __typename?: 'CreateDealStage';
  dealStage?: Maybe<DealStage>;
};

export type CreateDealStageInput = {
  color: Scalars['String']['input'];
  colorCode: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  isLost: Scalars['Boolean']['input'];
  isWon: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  probability: Scalars['Float']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateDefaultDealStages = {
  __typename?: 'CreateDefaultDealStages';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateDefaultEmailTemplates = {
  __typename?: 'CreateDefaultEmailTemplates';
  emailTemplates?: Maybe<Array<Maybe<EmailTemplateClass>>>;
};

export type CreateDesktopPairingCode = {
  __typename?: 'CreateDesktopPairingCode';
  code: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
};

export type CreateDomainAllowlist = {
  __typename?: 'CreateDomainAllowlist';
  domainAllowlist?: Maybe<DomainAllowlist>;
};

export type CreateDomainAllowlistInput = {
  domain: Scalars['String']['input'];
};

export type CreateEmailTemplate = {
  __typename?: 'CreateEmailTemplate';
  emailTemplate?: Maybe<EmailTemplateClass>;
};

export type CreateEmailTemplateInput = {
  attachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body: Scalars['String']['input'];
  isWorkspaceWide?: InputMaybe<Scalars['Boolean']['input']>;
  subject: Scalars['String']['input'];
  title: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateEngagementShare = {
  __typename?: 'CreateEngagementShare';
  message?: Maybe<Scalars['String']['output']>;
  notifyOnView?: Maybe<Scalars['Boolean']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type CreateFile = {
  __typename?: 'CreateFile';
  file?: Maybe<File>;
};

export type CreateFileInput = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dealIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileUrl: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateIngestionFieldInput = {
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  availableInRevgpt?: InputMaybe<Scalars['Boolean']['input']>;
  crmFieldType: CrmIngestionFieldType;
  crmLabel: Scalars['String']['input'];
  crmName: Scalars['String']['input'];
  customFieldType?: InputMaybe<CustomFieldType>;
  fieldConfig?: InputMaybe<Scalars['JSONString']['input']>;
  isStandardField?: InputMaybe<Scalars['Boolean']['input']>;
  objectType: CrmIngestionObjectType;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platform: CrmIngestionPlatform;
  sourceFieldType?: InputMaybe<CrmIngestionFieldType>;
  sourceName: Scalars['String']['input'];
  syncBack?: InputMaybe<Scalars['Boolean']['input']>;
  syncBackDestinationName?: InputMaybe<Scalars['String']['input']>;
  syncForward?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type CreateList = {
  __typename?: 'CreateList';
  list?: Maybe<List>;
};

export type CreateListFolder = {
  __typename?: 'CreateListFolder';
  listFolder?: Maybe<ListFolder>;
};

export type CreateListFolderInput = {
  modelType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ownerId: Scalars['ID']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateListInput = {
  modelType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ownerId: Scalars['ID']['input'];
  properties?: InputMaybe<Scalars['JSONString']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  static?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateNote = {
  __typename?: 'CreateNote';
  note?: Maybe<Note>;
};

export type CreateNoteInput = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocks: Scalars['JSONString']['input'];
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dealIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  engagementIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority?: InputMaybe<NotePriorityEnum>;
  status?: InputMaybe<NoteStatusEnum>;
  title: Scalars['String']['input'];
  type?: InputMaybe<NoteTypeEnum>;
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreatePipeline = {
  __typename?: 'CreatePipeline';
  pipeline?: Maybe<Pipeline>;
};

export type CreatePipelineInput = {
  name: Scalars['String']['input'];
  stages?: InputMaybe<Array<InputMaybe<PipelineStageInput>>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateProduct = {
  __typename?: 'CreateProduct';
  product?: Maybe<Product>;
};

export type CreateProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  productCode?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateReportDefinition = {
  __typename?: 'CreateReportDefinition';
  report?: Maybe<ReportDefinition>;
};

export type CreateReportDefinitionInput = {
  definition?: InputMaybe<Scalars['JSONString']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['JSONString']['input']>;
  templateKey?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateSummaryTemplate = {
  __typename?: 'CreateSummaryTemplate';
  summaryTemplate?: Maybe<SummaryTemplateClass>;
};

export type CreateSummaryTemplateInput = {
  isWorkspaceWide?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sections: Array<InputMaybe<TemplateSectionInput>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateSyncBackEntityInput = {
  modelPostgresId: Scalars['Int']['input'];
  modelType: CrmIngestionObjectType;
  workspaceId: Scalars['Int']['input'];
};

export type CreateSyncBackFieldInput = {
  platform: CrmIngestionPlatform;
  workspaceId: Scalars['Int']['input'];
};

export type CreateUserGroup = {
  __typename?: 'CreateUserGroup';
  userGroup?: Maybe<UserGroupType>;
};

/**
 * Create an in-app notification for a user, on behalf of an external producer.
 *
 * Exists for coffee-slack, which owns the three recurring digests: its hourly cron
 * already resolves each user's timezone and optimal send hour, and rebuilding that in
 * Python would be a straight duplication. When a user's delivery preferences include
 * WEB, that cron calls this alongside the Slack/email send.
 *
 * Authorization mirrors MarkFirstTimeNotificationsSent: M2M API tokens (which is what
 * coffee-slack is) may write for any user in the workspace, while a human caller may
 * only write to their own feed. Without that second half this would be an open relay
 * for putting arbitrary notifications in a colleague's bell.
 *
 * Preference gating, dedupe and the unknown-type check all live in emit_notification,
 * so a caller cannot bypass them by coming through this door.
 */
export type CreateWebNotification = {
  __typename?: 'CreateWebNotification';
  created?: Maybe<Scalars['Boolean']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Create a new workspace.
 *
 * For regular users:
 * - Domain is derived from their email (corporate domain or full email for personal domains)
 * - Name is derived from company MDM data or user's name for personal emails
 * - Logo is looked up from MDM for corporate domains
 * - User is automatically added as owner
 * - Cannot specify owners/users lists
 *
 * For superusers:
 * - Can specify custom domain, name, logo_url
 * - Can specify owners and users lists
 * - Can control add_creator_as_owner flag
 */
export type CreateWorkspace = {
  __typename?: 'CreateWorkspace';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  workspace?: Maybe<Workspace>;
};

/** Create a new custom knowledge area for a workspace. */
export type CreateWorkspaceCustomKnowledge = {
  __typename?: 'CreateWorkspaceCustomKnowledge';
  customKnowledge?: Maybe<WorkspaceCustomKnowledgeType>;
};

export type CreateWorkspaceCustomKnowledgeInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateWorkspaceInput = {
  addCreatorAsOwner?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Workspace name (optional for regular users, derived from email) */
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<InputMaybe<CreateWorkspaceUserInput>>>;
  users?: InputMaybe<Array<InputMaybe<CreateWorkspaceUserInput>>>;
};

export type CreateWorkspaceUserInput = {
  id: Scalars['Int']['input'];
};

/** Credit to USD exchange rates (user-facing). */
export type CreditExchangeRate = {
  __typename?: 'CreditExchangeRate';
  /** Rate per AI field generation ($0.25) */
  aiFieldRate: Scalars['Float']['output'];
  /** Rate per company record ($0.10) */
  companyRate: Scalars['Float']['output'];
  /** Default credits to USD conversion rate (deprecated, use operation-specific rates) */
  creditsToUsdRate: Scalars['Float']['output'];
  /** Rate per person record ($0.50) */
  personRate: Scalars['Float']['output'];
};

/** Result of a credit pack purchase attempt. */
export type CreditPackPurchaseResult = {
  __typename?: 'CreditPackPurchaseResult';
  /** Stripe Checkout URL (when no card on file) */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** Stripe invoice ID (when charged immediately) */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /** Stripe Checkout session ID (when no card on file) */
  sessionId?: Maybe<Scalars['String']['output']>;
  /** True if charged immediately (card on file) */
  success: Scalars['Boolean']['output'];
};

export type CreditResponse = {
  __typename?: 'CreditResponse';
  credits?: Maybe<Scalars['Int']['output']>;
};

/** One row in the per-source credit breakdown (subscription or pack). */
export type CreditSource = {
  __typename?: 'CreditSource';
  /** When the source expires (period end or pack expiry) */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** 'subscription' for the pool, else the PURCHASE event _id */
  id: Scalars['ID']['output'];
  /** SUBSCRIPTION or PACK */
  kind: CreditSourceKind;
  /** Human-readable label for the source */
  label: Scalars['String']['output'];
  /** When the source was created (null for subscription) */
  purchasedAt?: Maybe<Scalars['DateTime']['output']>;
  /** max(total - used, 0) */
  remainingCredits: Scalars['Int']['output'];
  /** Total credits originally allotted to this source */
  totalCredits: Scalars['Int']['output'];
  /** Credits consumed against this source */
  usedCredits: Scalars['Int']['output'];
};

/** The kind of credit source (subscription quota vs purchased pack). */
export enum CreditSourceKind {
  Pack = 'PACK',
  Subscription = 'SUBSCRIPTION'
}

/** Credit transaction entry (formerly credit usage log). */
export type CreditUsageLog = {
  __typename?: 'CreditUsageLog';
  /** Admin notes */
  adminNote?: Maybe<Scalars['String']['output']>;
  /** USD amount */
  amountUsd: Scalars['Float']['output'];
  /** Created timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Number of credits (positive for charges, negative for refunds) */
  credits: Scalars['Int']['output'];
  /** Human-readable description */
  description?: Maybe<Scalars['String']['output']>;
  /** Transaction ID */
  id: Scalars['ID']['output'];
  /** Stripe invoice ID (if invoiced/paid) */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /** Flexible metadata */
  metadata?: Maybe<Scalars['JSONString']['output']>;
  /** Legacy: same as source_feature */
  operation?: Maybe<CreditUsageOperation>;
  /** Parent transaction ID (for refunds) */
  parentTransactionId?: Maybe<Scalars['String']['output']>;
  /** External reference ID (workflow_id, order_id, etc.) */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Type of reference (workflow, order, etc.) */
  referenceType?: Maybe<Scalars['String']['output']>;
  /** Feature that consumed credits */
  sourceFeature: CreditUsageOperation;
  /** Billing status */
  status: CreditUsageStatus;
  /** Legacy: same as reference_id */
  transactionId?: Maybe<Scalars['String']['output']>;
  /** Transaction type (CHARGE/REFUND) */
  type: CreditUsageType;
  /** Updated timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** User email */
  userEmail?: Maybe<Scalars['String']['output']>;
  /** User ID who triggered the transaction */
  userId?: Maybe<Scalars['Int']['output']>;
  /** Workspace ID */
  workspaceId: Scalars['Int']['output'];
  /** Workspace name */
  workspaceName?: Maybe<Scalars['String']['output']>;
  /** Workspace owner email */
  workspaceOwnerEmail?: Maybe<Scalars['String']['output']>;
};

/** Paginated credit usage log results. */
export type CreditUsageLogConnection = {
  __typename?: 'CreditUsageLogConnection';
  /** Current page */
  page: Scalars['Int']['output'];
  /** Items per page */
  perPage: Scalars['Int']['output'];
  records: Array<Maybe<CreditUsageLog>>;
  /** Total count */
  total: Scalars['Int']['output'];
  /** Total pages */
  totalPages: Scalars['Int']['output'];
};

/** What operation consumed/generated the credits. */
export enum CreditUsageOperation {
  AiField = 'AI_FIELD',
  AiFieldAgent = 'AI_FIELD_AGENT',
  CreditPack = 'CREDIT_PACK',
  DealAgent = 'DEAL_AGENT',
  InvoiceAgent = 'INVOICE_AGENT',
  LeadAgent = 'LEAD_AGENT',
  ListBuilder = 'LIST_BUILDER',
  MeetingAgent = 'MEETING_AGENT',
  ProposalAgent = 'PROPOSAL_AGENT',
  ReportRun = 'REPORT_RUN',
  VisitorIdAgent = 'VISITOR_ID_AGENT'
}

/** Transaction billing status. */
export enum CreditUsageStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Invoiced = 'INVOICED',
  Paid = 'PAID',
  Requested = 'REQUESTED'
}

/** Workspace credit usage summary for the current billing period. */
export type CreditUsageSummary = {
  __typename?: 'CreditUsageSummary';
  /** End of current billing period */
  billingPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Start of current billing period */
  billingPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  /** Per-source credit breakdown (subscription first, then packs by expiry ASC) */
  creditSources: Array<Maybe<CreditSource>>;
  /** Per-agent breakdown */
  perAgent: Array<Maybe<AgentCreditUsage>>;
  /** Remaining credits from purchased packs (non-expired) */
  purchasedCreditsRemaining?: Maybe<Scalars['Int']['output']>;
  /** Number of seats */
  seats?: Maybe<Scalars['Int']['output']>;
  /** Credits from subscription plan (seats * tier rate) */
  subscriptionCreditsLimit?: Maybe<Scalars['Int']['output']>;
  /** Total credits available (subscription + purchased) */
  totalCreditsLimit: Scalars['Int']['output'];
  /** Total agent credits consumed this period */
  totalCreditsUsed: Scalars['Int']['output'];
};

/** Transaction types in the credit system. */
export enum CreditUsageType {
  Charge = 'CHARGE',
  Purchase = 'PURCHASE',
  Refund = 'REFUND'
}

export type CrmCreateIngestionField = {
  __typename?: 'CrmCreateIngestionField';
  ingestionField?: Maybe<CrmIngestionField>;
};

/** Counts of CRM objects for the sync wizard preview. */
export type CrmDataCounts = {
  __typename?: 'CrmDataCounts';
  /** Count of Account/company objects */
  accounts: Scalars['Int']['output'];
  /** Count of Contact/people objects */
  contacts: Scalars['Int']['output'];
  /** Count of Deal/opportunity objects */
  deals: Scalars['Int']['output'];
};

/** Input for the crmDataCounts query. */
export type CrmDataCountsInput = {
  /** Filter records on or before this date (optional) */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  platform: CrmIngestionPlatform;
  /** Filter records on or after this date (optional) */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The workspace with the CRM connection */
  workspaceId: Scalars['ID']['input'];
};

export type CrmDeleteIngestionField = {
  __typename?: 'CrmDeleteIngestionField';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CrmGraderReportInput = {
  shareToken?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type CrmIngest = {
  __typename?: 'CrmIngest';
  ok?: Maybe<Scalars['Boolean']['output']>;
  run?: Maybe<CrmIngestionRun>;
};

export type CrmIngestionAvailableField = {
  __typename?: 'CrmIngestionAvailableField';
  description: Scalars['String']['output'];
  /** Active options of an enumeration field, as value/label pairs; null when the field is not an enumeration. */
  enumerationChoices?: Maybe<Array<CrmIngestionEnumerationChoice>>;
  enumerationOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fieldType: CrmIngestionFieldType;
  isCalculated: Scalars['Boolean']['output'];
  isEnumeration: Scalars['Boolean']['output'];
  /** True for multi-select enumerations (Salesforce multipicklist, HubSpot checkbox). */
  isMultiSelect?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  objectType: CrmIngestionObjectType;
  platform: CrmIngestionPlatform;
};

export type CrmIngestionConfigObject = {
  __typename?: 'CrmIngestionConfigObject';
  pipelineId?: Maybe<Scalars['String']['output']>;
  selectedStageIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  syncBack?: Maybe<Scalars['Boolean']['output']>;
  syncBackEntityTypes?: Maybe<Scalars['JSONString']['output']>;
  syncForward?: Maybe<Scalars['Boolean']['output']>;
  syncForwardEntityTypes?: Maybe<Scalars['JSONString']['output']>;
  windowEndDate?: Maybe<Scalars['Date']['output']>;
  windowStartDate?: Maybe<Scalars['Date']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type CrmIngestionEnumerationChoice = {
  __typename?: 'CrmIngestionEnumerationChoice';
  /** What users see; what Coffee select fields hold. */
  label: Scalars['String']['output'];
  /** What the CRM stores and exports. */
  value: Scalars['String']['output'];
};

export type CrmIngestionField = Node & {
  __typename?: 'CrmIngestionField';
  availableInGrid: Scalars['Boolean']['output'];
  availableInRevgpt: Scalars['Boolean']['output'];
  crmFieldType: CrmIngestionFieldType;
  crmLabel: Scalars['String']['output'];
  crmName: Scalars['String']['output'];
  customFieldType: CustomFieldType;
  enumerationData?: Maybe<Scalars['JSONString']['output']>;
  fieldConfig?: Maybe<Scalars['JSONString']['output']>;
  id: Scalars['ID']['output'];
  isEnumeration: Scalars['Boolean']['output'];
  isStandardField: Scalars['Boolean']['output'];
  objectType: CrmIngestionObjectType;
  platform: CrmIngestionPlatform;
  sourceExternalId?: Maybe<Scalars['String']['output']>;
  sourceFieldType: CrmIngestionFieldType;
  sourceName: Scalars['String']['output'];
  syncBack: Scalars['Boolean']['output'];
  syncBackDestinationName?: Maybe<Scalars['String']['output']>;
  syncForward: Scalars['Boolean']['output'];
  workspaceId: Scalars['Int']['output'];
};

export type CrmIngestionFieldConnection = {
  __typename?: 'CrmIngestionFieldConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CrmIngestionFieldEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CrmIngestionField` and its cursor. */
export type CrmIngestionFieldEdge = {
  __typename?: 'CrmIngestionFieldEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CrmIngestionField>;
};

/** An enumeration. */
export enum CrmIngestionFieldType {
  Boolean = 'BOOLEAN',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  Percentage = 'PERCENTAGE',
  String = 'STRING'
}

/** An enumeration. */
export enum CrmIngestionObjectType {
  Account = 'ACCOUNT',
  Contact = 'CONTACT',
  Deal = 'DEAL',
  Email = 'EMAIL',
  File = 'FILE',
  LineItem = 'LINE_ITEM',
  Meeting = 'MEETING',
  Note = 'NOTE',
  Product = 'PRODUCT',
  Task = 'TASK'
}

/** An enumeration. */
export enum CrmIngestionPlatform {
  Coffee = 'COFFEE',
  Fireflies = 'FIREFLIES',
  Gong = 'GONG',
  GoogleCalendar = 'GOOGLE_CALENDAR',
  Granola = 'GRANOLA',
  Hubspot = 'HUBSPOT',
  HubspotMain = 'HUBSPOT_MAIN',
  Mailchimp = 'MAILCHIMP',
  ManualCsv = 'MANUAL_CSV',
  Microsoft = 'MICROSOFT',
  Quickbooks = 'QUICKBOOKS',
  Salesforce = 'SALESFORCE',
  SalesforceMain = 'SALESFORCE_MAIN',
  Slack = 'SLACK',
  StripeConnect = 'STRIPE_CONNECT',
  Zapier = 'ZAPIER',
  Zoom = 'ZOOM'
}

export type CrmIngestionRun = {
  __typename?: 'CrmIngestionRun';
  accountsListId?: Maybe<Scalars['Int']['output']>;
  asOfTs?: Maybe<Scalars['DateTime']['output']>;
  contactsListId?: Maybe<Scalars['Int']['output']>;
  dealsListId?: Maybe<Scalars['Int']['output']>;
  expectedNumKeySteps?: Maybe<Scalars['Int']['output']>;
  ledgerEntries?: Maybe<Array<Maybe<CrmIngestionRunLedgerEntry>>>;
  platform: CrmIngestionPlatform;
  progressPercent?: Maybe<Scalars['Int']['output']>;
  properties?: Maybe<CrmIngestionRunProperties>;
  runId: Scalars['Int']['output'];
  stats?: Maybe<CrmIngestionRunStats>;
  status: CrmIngestionStatus;
  workspaceId: Scalars['Int']['output'];
};

export type CrmIngestionRunConnection = {
  __typename?: 'CrmIngestionRunConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CrmIngestionRunEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CrmIngestionRun` and its cursor. */
export type CrmIngestionRunEdge = {
  __typename?: 'CrmIngestionRunEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CrmIngestionRun>;
};

export type CrmIngestionRunFilterInput = {
  includeIncremental?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type CrmIngestionRunLedgerEntry = {
  __typename?: 'CrmIngestionRunLedgerEntry';
  createTs?: Maybe<Scalars['DateTime']['output']>;
  delta?: Maybe<LedgerEntryDelta>;
  runId?: Maybe<Scalars['Int']['output']>;
};

export type CrmIngestionRunProperties = {
  __typename?: 'CrmIngestionRunProperties';
  endTs?: Maybe<Scalars['DateTime']['output']>;
  isIncremental?: Maybe<Scalars['Boolean']['output']>;
  lastStep?: Maybe<Scalars['String']['output']>;
  lastStepTs?: Maybe<Scalars['DateTime']['output']>;
  startTs?: Maybe<Scalars['DateTime']['output']>;
};

export type CrmIngestionRunStats = {
  __typename?: 'CrmIngestionRunStats';
  numNewAccounts?: Maybe<Scalars['Int']['output']>;
  numNewContacts?: Maybe<Scalars['Int']['output']>;
  numNewDeals?: Maybe<Scalars['Int']['output']>;
  numUpdatedAccounts?: Maybe<Scalars['Int']['output']>;
  numUpdatedContacts?: Maybe<Scalars['Int']['output']>;
  numUpdatedDeals?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum CrmIngestionStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type CrmIntegrationHealth = {
  __typename?: 'CrmIntegrationHealth';
  configId: Scalars['Int']['output'];
  credentialHealthy: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  health: IntegrationHealthLevel;
  healthReason?: Maybe<Scalars['String']['output']>;
  lastRunStatus?: Maybe<Scalars['String']['output']>;
  lastRunTs?: Maybe<Scalars['DateTime']['output']>;
  lastSuccessTs?: Maybe<Scalars['DateTime']['output']>;
  platform: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  /** True if no successful sync within the daily window (>24h) */
  syncOverdue?: Maybe<Scalars['Boolean']['output']>;
  workspaceId: Scalars['Int']['output'];
  workspaceName?: Maybe<Scalars['String']['output']>;
};

/** A deal stage fetched directly from the CRM API (read-only preview). */
export type CrmPreviewDealStage = {
  __typename?: 'CrmPreviewDealStage';
  hubspotId?: Maybe<Scalars['String']['output']>;
  isClosed: Scalars['Boolean']['output'];
  isWon: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pipelineId?: Maybe<Scalars['String']['output']>;
  pipelineName?: Maybe<Scalars['String']['output']>;
  probability?: Maybe<Scalars['Float']['output']>;
  salesforceId?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
};

export type CrmReIngest = {
  __typename?: 'CrmReIngest';
  ok?: Maybe<Scalars['Boolean']['output']>;
  run?: Maybe<CrmIngestionRun>;
};

export type CrmReport = {
  __typename?: 'CrmReport';
  accounts?: Maybe<ModelReport>;
  contacts?: Maybe<ModelReport>;
  deals?: Maybe<ModelReport>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  shareLink?: Maybe<Scalars['String']['output']>;
  workspaceName?: Maybe<Scalars['String']['output']>;
};

export type CrmSyncBackEntity = {
  __typename?: 'CrmSyncBackEntity';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CrmSyncBackField = {
  __typename?: 'CrmSyncBackField';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CrmUpdateIngestionConfig = {
  __typename?: 'CrmUpdateIngestionConfig';
  crmIngestionConfig?: Maybe<CrmIngestionConfigObject>;
};

export type CrmUpdateIngestionField = {
  __typename?: 'CrmUpdateIngestionField';
  ingestionFields?: Maybe<Array<Maybe<CrmIngestionField>>>;
};

/** One row per MANUAL_CSV import run (a one-shot event, not a recurring sync). */
export type CsvImportHealth = {
  __typename?: 'CsvImportHealth';
  health: IntegrationHealthLevel;
  healthReason?: Maybe<Scalars['String']['output']>;
  importedByEmail?: Maybe<Scalars['String']['output']>;
  lastUpdateTs?: Maybe<Scalars['DateTime']['output']>;
  /** Which of Account/Contact/Deal the import touched */
  objectTypes?: Maybe<Scalars['String']['output']>;
  rowsNew?: Maybe<Scalars['Int']['output']>;
  rowsTotal?: Maybe<Scalars['Int']['output']>;
  rowsUpdated?: Maybe<Scalars['Int']['output']>;
  runId: Scalars['Int']['output'];
  startedTs?: Maybe<Scalars['DateTime']['output']>;
  /** Ledger-derived run status (DONE/FAILED/RUNNING) */
  status?: Maybe<Scalars['String']['output']>;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['Int']['output'];
  workspaceName?: Maybe<Scalars['String']['output']>;
};

export type CsvIngest = {
  __typename?: 'CsvIngest';
  ok?: Maybe<Scalars['Boolean']['output']>;
  run?: Maybe<CrmIngestionRun>;
};

export type CsvIngestAccountInput = {
  /** S3 location of input data, relative to coffee-ai-work-dir-local/csv_ingest/ */
  data: Scalars['String']['input'];
};

export type CsvIngestContactInput = {
  contactAccountAssociation?: InputMaybe<Scalars['String']['input']>;
  /** S3 location of input data, relative to coffee-ai-work-dir-local/csv_ingest/ */
  data: Scalars['String']['input'];
};

export type CsvIngestDealInput = {
  /** S3 location of input data, relative to coffee-ai-work-dir-local/csv_ingest/ */
  data: Scalars['String']['input'];
  dealAccountAssociation?: InputMaybe<Scalars['String']['input']>;
  dealContactAssociation?: InputMaybe<Scalars['String']['input']>;
};

export type CsvIngestInput = {
  /** Account input */
  accountData?: InputMaybe<CsvIngestAccountInput>;
  /** Contact input */
  contactData?: InputMaybe<CsvIngestContactInput>;
  /** Deal input */
  dealData?: InputMaybe<CsvIngestDealInput>;
  ignoreUnchanged?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};

/** An enumeration. */
export enum CustomFieldType {
  AiSearch = 'AI_SEARCH',
  Checkbox = 'CHECKBOX',
  Currency = 'CURRENCY',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Email = 'EMAIL',
  Formula = 'FORMULA',
  Location = 'LOCATION',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  Phone = 'PHONE',
  SingleSelect = 'SINGLE_SELECT',
  String = 'STRING',
  TrafficLight = 'TRAFFIC_LIGHT',
  Url = 'URL'
}

/**
 * Match a custom field: any of ``values`` (case-insensitive substring).
 *
 * ``key`` is the property's crm_name, e.g. ``partner_type_9373_coffee``.
 */
export type CustomPropertyFilterInput = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type CustomPropertyInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Output type for Stripe CustomerSession. */
export type CustomerSession = {
  __typename?: 'CustomerSession';
  /** The Stripe client secret for the CustomerSession */
  clientSecret: Scalars['String']['output'];
};

export type DailyLead = Node & {
  __typename?: 'DailyLead';
  companyDomain?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  convertedContactExtId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leadScoreSnapshot?: Maybe<Scalars['Int']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personLinkedin?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personTitle?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  rankScore?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<DailyLeadSource>;
  status?: Maybe<DailyLeadStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type DailyLeadConnection = {
  __typename?: 'DailyLeadConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DailyLeadEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DailyLead` and its cursor. */
export type DailyLeadEdge = {
  __typename?: 'DailyLeadEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<DailyLead>;
};

export enum DailyLeadSource {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export enum DailyLeadStatus {
  Dismissed = 'DISMISSED',
  New = 'NEW',
  SavedAsContact = 'SAVED_AS_CONTACT'
}

export type DailyLeadsFilter = {
  date?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DailyLeadStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type DateRangeFilterInput = {
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** An enumeration. */
export enum DdbEngagementStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum DdbEngagementType {
  Call = 'CALL',
  Email = 'EMAIL',
  Meeting = 'MEETING'
}

export type Deal = Node & {
  __typename?: 'Deal';
  accountAssociations: Array<EntityAssociation>;
  accounts?: Maybe<AccountConnection>;
  additionalOwnerIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  additionalOwners?: Maybe<Array<Maybe<User>>>;
  asOfTs?: Maybe<Scalars['DateTime']['output']>;
  associations: Array<EntityAssociation>;
  contactAssociations: Array<EntityAssociation>;
  contacts?: Maybe<ContactConnection>;
  customProperties?: Maybe<Scalars['GenericScalar']['output']>;
  dealInfo?: Maybe<DealInfo>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inStageSince?: Maybe<Scalars['DateTime']['output']>;
  lastActivityEngagement?: Maybe<Engagement>;
  lastEmail?: Maybe<Engagement>;
  lastEmailId?: Maybe<Scalars['String']['output']>;
  lastEmailTime?: Maybe<Scalars['DateTime']['output']>;
  lastEngagement?: Maybe<Engagement>;
  lineItems?: Maybe<Array<Maybe<LineItem>>>;
  nextEngagement?: Maybe<Engagement>;
  nextStepEngagements?: Maybe<Array<Maybe<Engagement>>>;
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['Int']['output']>;
  owners?: Maybe<Array<Maybe<User>>>;
  postgresId?: Maybe<Scalars['Int']['output']>;
  properties?: Maybe<DealProperties>;
  /** @deprecated Duplicates `properties`; use the structured `properties` field instead. */
  propertiesJson?: Maybe<Scalars['String']['output']>;
  snapshots?: Maybe<Array<Maybe<DealSnapshot>>>;
  /** Original CRM (HubSpot/Salesforce) record id; null for Coffee-native records */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** Ordered stage-change timeline from the ledger (v1 embedded + v2 ledger collection) */
  stageHistory?: Maybe<Array<Maybe<DealStageChange>>>;
  userLists?: Maybe<UserListConnection>;
  workspace?: Maybe<Workspace>;
  workspaceId: Scalars['Int']['output'];
};


export type DealAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DealContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DealUserListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DealAggregateResult = {
  __typename?: 'DealAggregateResult';
  averageDaysToClose?: Maybe<AggregateChange>;
  averageDealSize?: Maybe<AggregateChange>;
  bestCase?: Maybe<AggregateChange>;
  closedWon?: Maybe<AggregateChange>;
  commit?: Maybe<AggregateChange>;
  forecast?: Maybe<AggregateChange>;
  fromDate?: Maybe<Scalars['String']['output']>;
  pipeline?: Maybe<AggregateChange>;
  toDate?: Maybe<Scalars['String']['output']>;
};

export type DealConnection = {
  __typename?: 'DealConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DealEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DealCreationField = Node & {
  __typename?: 'DealCreationField';
  createdAt: Scalars['DateTime']['output'];
  crmField?: Maybe<CrmIngestionField>;
  crmIngestionField?: Maybe<CrmIngestionField>;
  crmIngestionFieldId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kind: DealCreationFieldKindEnum;
  label?: Maybe<Scalars['String']['output']>;
  pipelineId?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  standardKey?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workspace?: Maybe<Workspace>;
  workspaceId: Scalars['Int']['output'];
};

export type DealCreationFieldConfigInput = {
  crmFieldId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind: DealCreationFieldKindEnum;
  position: Scalars['Int']['input'];
  required: Scalars['Boolean']['input'];
  standardKey?: InputMaybe<Scalars['String']['input']>;
};

export enum DealCreationFieldKindEnum {
  Custom = 'CUSTOM',
  Standard = 'STANDARD'
}

/** A Relay edge containing a `Deal` and its cursor. */
export type DealEdge = {
  __typename?: 'DealEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<Deal>;
};

/**
 * Deal field definition for a workspace.
 * These fields can be populated from engagement summaries and displayed on deals.
 */
export type DealFieldClass = Node & {
  __typename?: 'DealFieldClass';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type DealFieldConnection = {
  __typename?: 'DealFieldConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DealFieldEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DealField` and its cursor. */
export type DealFieldEdge = {
  __typename?: 'DealFieldEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<DealFieldClass>;
};

export type DealFieldFilter = {
  workspaceId: Scalars['ID']['input'];
};

/**
 * A single deal field with its values (list of bullets).
 * Represents a field from deal_info.properties.
 */
export type DealFieldValue = {
  __typename?: 'DealFieldValue';
  bullets: Array<Maybe<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
};

export type DealFilter = {
  age?: InputMaybe<AgeFilterInput>;
  amount?: InputMaybe<FloatRangeFilterInput>;
  closeDate?: InputMaybe<DateRangeFilterInput>;
  compareDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactsCount?: InputMaybe<FloatRangeFilterInput>;
  customProperties?: InputMaybe<Array<InputMaybe<CustomPropertyFilterInput>>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasContacts?: InputMaybe<Scalars['Boolean']['input']>;
  hasLastActivitiesLast2Weeks?: InputMaybe<Scalars['Boolean']['input']>;
  hasNextEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivity?: InputMaybe<ActivityDateFilterInput>;
  lastEmail?: InputMaybe<EngagementDateFilterInput>;
  listMembership?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextActivity?: InputMaybe<ActivityDateFilterInput>;
  onlyWithChanges?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeInStage?: InputMaybe<FloatRangeFilterInput>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type DealGridSummary = {
  __typename?: 'DealGridSummary';
  fillRates?: Maybe<Array<Maybe<FillRateDatum>>>;
  metrics?: Maybe<Array<Maybe<MetricDatum>>>;
};

/**
 * Deal info containing extended field data populated from engagement summaries.
 * Maps to MongoDB deal_info collection.
 */
export type DealInfo = {
  __typename?: 'DealInfo';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dealId?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<DealFieldValue>>>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Input for updating a single deal_info property field. */
export type DealInfoPropertyInput = {
  /** List of bullet points for this field */
  bullets: Array<InputMaybe<Scalars['String']['input']>>;
  /** Field ID (e.g., df|ddb|859|...) */
  fieldId: Scalars['String']['input'];
};

export type DealProperties = {
  __typename?: 'DealProperties';
  LastActivityDate?: Maybe<Scalars['String']['output']>;
  NextStep?: Maybe<Scalars['String']['output']>;
  aiSummary?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  closeDate?: Maybe<Scalars['DateTime']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  forecastCategory?: Maybe<Scalars['String']['output']>;
  highlight?: Maybe<Scalars['String']['output']>;
  lastActivityText?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextActivityText?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  probability?: Maybe<Scalars['Float']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  statusColor?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DealPropertiesInput = {
  NextStep?: InputMaybe<Scalars['String']['input']>;
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalOwnerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  closeDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createDate?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  forecastCategory?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  lastActivityText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextActivityText?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  statusColor?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DealSnapshot = Node & {
  __typename?: 'DealSnapshot';
  accounts?: Maybe<AccountConnection>;
  asOfTs?: Maybe<Scalars['DateTime']['output']>;
  contacts?: Maybe<ContactConnection>;
  customProperties?: Maybe<Scalars['GenericScalar']['output']>;
  dealId: Scalars['Int']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['Int']['output']>;
  properties?: Maybe<DealProperties>;
};


export type DealSnapshotAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DealSnapshotContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DealSnapshotConnection = {
  __typename?: 'DealSnapshotConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DealSnapshotEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DealSnapshot` and its cursor. */
export type DealSnapshotEdge = {
  __typename?: 'DealSnapshotEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<DealSnapshot>;
};

export type DealStage = Node & {
  __typename?: 'DealStage';
  color: Scalars['String']['output'];
  colorCode?: Maybe<Scalars['String']['output']>;
  createTs: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hubspotId?: Maybe<Scalars['String']['output']>;
  i18nKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lost: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pipeline?: Maybe<Pipeline>;
  pipelineId?: Maybe<Scalars['Int']['output']>;
  probability?: Maybe<Scalars['Float']['output']>;
  salesforceId?: Maybe<Scalars['String']['output']>;
  won: Scalars['Boolean']['output'];
  workspaceId: Scalars['Int']['output'];
};

/** One entry in a deal's stage-change timeline, reconstructed from the ledger. */
export type DealStageChange = {
  __typename?: 'DealStageChange';
  /** Seconds spent in this stage; open-ended for the current stage (runs to now) */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  enteredAt?: Maybe<Scalars['DateTime']['output']>;
  lost?: Maybe<Scalars['Boolean']['output']>;
  /** Human-readable origin of the change, e.g. 'HubSpot', 'Coffee AI' */
  source?: Maybe<Scalars['String']['output']>;
  stageExternalId?: Maybe<Scalars['String']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  won?: Maybe<Scalars['Boolean']['output']>;
};

export type DealStageConnection = {
  __typename?: 'DealStageConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DealStageEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DealStage` and its cursor. */
export type DealStageEdge = {
  __typename?: 'DealStageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DealStage>;
};

export type DealStageFilter = {
  allPipelines?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** An enumeration. */
export enum DealStageSortEnum {
  ColorAsc = 'COLOR_ASC',
  ColorCodeAsc = 'COLOR_CODE_ASC',
  ColorCodeDesc = 'COLOR_CODE_DESC',
  ColorDesc = 'COLOR_DESC',
  CreateTsAsc = 'CREATE_TS_ASC',
  CreateTsDesc = 'CREATE_TS_DESC',
  DeletedAsc = 'DELETED_ASC',
  DeletedDesc = 'DELETED_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  HubspotIdAsc = 'HUBSPOT_ID_ASC',
  HubspotIdDesc = 'HUBSPOT_ID_DESC',
  I18NKeyAsc = 'I18N_KEY_ASC',
  I18NKeyDesc = 'I18N_KEY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LostAsc = 'LOST_ASC',
  LostDesc = 'LOST_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PipelineIdAsc = 'PIPELINE_ID_ASC',
  PipelineIdDesc = 'PIPELINE_ID_DESC',
  ProbabilityAsc = 'PROBABILITY_ASC',
  ProbabilityDesc = 'PROBABILITY_DESC',
  SalesforceIdAsc = 'SALESFORCE_ID_ASC',
  SalesforceIdDesc = 'SALESFORCE_ID_DESC',
  WonAsc = 'WON_ASC',
  WonDesc = 'WON_DESC',
  WorkspaceIdAsc = 'WORKSPACE_ID_ASC',
  WorkspaceIdDesc = 'WORKSPACE_ID_DESC'
}

export type DealSuggestion = Node & {
  __typename?: 'DealSuggestion';
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  convertedDealId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dealName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dismissalReason?: Maybe<Scalars['String']['output']>;
  estimatedAmount?: Maybe<Scalars['Float']['output']>;
  estimatedCloseDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAccepted?: Maybe<Scalars['Boolean']['output']>;
  isDismissed?: Maybe<Scalars['Boolean']['output']>;
  sourceEngagement?: Maybe<Engagement>;
  sourceEngagementId?: Maybe<Scalars['String']['output']>;
  sourceQuote?: Maybe<Scalars['String']['output']>;
  suggestedAccount?: Maybe<Account>;
  suggestedAccountId?: Maybe<Scalars['String']['output']>;
  suggestedContactIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  suggestedContacts?: Maybe<Array<Maybe<Contact>>>;
  suggestedOwner?: Maybe<User>;
  suggestedOwnerId?: Maybe<Scalars['Int']['output']>;
  suggestedStageId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type DealSuggestionConnection = {
  __typename?: 'DealSuggestionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DealSuggestionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DealSuggestion` and its cursor. */
export type DealSuggestionEdge = {
  __typename?: 'DealSuggestionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<DealSuggestion>;
};

export type DealSuggestionFilter = {
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  isDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  sourceEngagementId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type DefaultRecordAclInput = {
  /** Default visibility for engagements: 'private' | 'manager' | 'managers_and_admins' | 'everyone'. */
  engagementsDefaultAcl?: InputMaybe<Scalars['String']['input']>;
  /** Default visibility for files: 'private' | 'manager' | 'managers_and_admins' | 'everyone'. */
  filesDefaultAcl?: InputMaybe<Scalars['String']['input']>;
  /** Default visibility for notes (excl. tasks): 'private' | 'manager' | 'managers_and_admins' | 'everyone'. */
  notesDefaultAcl?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAccount = {
  __typename?: 'DeleteAccount';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAgentDefinition = {
  __typename?: 'DeleteAgentDefinition';
  ok: Scalars['Boolean']['output'];
};

export type DeleteAutomationRule = {
  __typename?: 'DeleteAutomationRule';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBriefTemplate = {
  __typename?: 'DeleteBriefTemplate';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBriefTemplateInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type DeleteCampaign = {
  __typename?: 'DeleteCampaign';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteClip = {
  __typename?: 'DeleteClip';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteContact = {
  __typename?: 'DeleteContact';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDeal = {
  __typename?: 'DeleteDeal';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Soft delete a deal field.
 * Note: This doesn't remove existing data in deal_info.properties.
 */
export type DeleteDealField = {
  __typename?: 'DeleteDealField';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for deleting a deal field. */
export type DeleteDealFieldInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type DeleteDealStage = {
  __typename?: 'DeleteDealStage';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDealStageInput = {
  id: Scalars['ID']['input'];
  newStageId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteDomainAllowlist = {
  __typename?: 'DeleteDomainAllowlist';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDomainAllowlistInput = {
  id: Scalars['Int']['input'];
};

export type DeleteEmailTemplate = {
  __typename?: 'DeleteEmailTemplate';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteEmailTemplateInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type DeleteFile = {
  __typename?: 'DeleteFile';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteList = {
  __typename?: 'DeleteList';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteListFolder = {
  __typename?: 'DeleteListFolder';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteListFolderInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type DeleteListInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type DeleteNote = {
  __typename?: 'DeleteNote';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePipeline = {
  __typename?: 'DeletePipeline';
  ok?: Maybe<Scalars['Boolean']['output']>;
  pipeline?: Maybe<Pipeline>;
};

export type DeletePipelineInput = {
  deleteDeals: Scalars['Boolean']['input'];
  pipelineId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type DeleteProduct = {
  __typename?: 'DeleteProduct';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteReportDefinition = {
  __typename?: 'DeleteReportDefinition';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteReportDefinitionInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type DeleteSummaryTemplate = {
  __typename?: 'DeleteSummaryTemplate';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSummaryTemplateInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type DeleteUserGroup = {
  __typename?: 'DeleteUserGroup';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUserRole = {
  __typename?: 'DeleteUserRole';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUserRoleInput = {
  userId: Scalars['Int']['input'];
  workspaceId: Scalars['Int']['input'];
};

/**
 * Permanently delete (disable) a workspace — the Settings → Account → Danger
 * Zone flow. This is destructive and irreversible. Owner-only.
 *
 * It performs, in order:
 *   1. Marks the local subscription canceled and deactivates all CRM and user
 *      integrations.
 *   2. Marks the workspace inactive and soft-removes every membership so no
 *      one can log back into it (auth filters removed memberships already).
 *   3. Commits all of the above so the DB is in a consistent, disabled state.
 *   4. Cancels all scheduled recording bots for the workspace.
 *   5. Cancels the Stripe subscription / trial immediately — the irreversible
 *      external call is made LAST, after the commit, so a commit failure can
 *      never leave Stripe canceled while the workspace stays active.
 *   6. Logs the deletion to Slack.
 *
 * Cleanup failures (Stripe, bots) are logged but do not block the deletion —
 * the workspace is always disabled so the user can't get stuck in a
 * half-deleted state. When the Stripe cancellation fails, the Slack
 * notification reports `subscription_canceled: no` plus a Stripe deep-link so
 * ops can finish the cancellation manually.
 */
export type DeleteWorkspace = {
  __typename?: 'DeleteWorkspace';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Delete a custom knowledge area. */
export type DeleteWorkspaceCustomKnowledge = {
  __typename?: 'DeleteWorkspaceCustomKnowledge';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteWorkspaceInput = {
  /** Optional reason for deletion (for audit / Slack) */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** ID of the workspace to delete */
  workspaceId: Scalars['ID']['input'];
};

export type DesktopToken = Node & {
  __typename?: 'DesktopToken';
  createdAt: Scalars['DateTime']['output'];
  deviceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  tokenHash: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  workspace?: Maybe<Workspace>;
  workspaceId: Scalars['Int']['output'];
};

export type DesktopTokenConnection = {
  __typename?: 'DesktopTokenConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DesktopTokenEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DesktopToken` and its cursor. */
export type DesktopTokenEdge = {
  __typename?: 'DesktopTokenEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DesktopToken>;
};

export type DesktopTokenFilter = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** An enumeration. */
export enum DesktopTokenSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeviceNameAsc = 'DEVICE_NAME_ASC',
  DeviceNameDesc = 'DEVICE_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastSeenAtAsc = 'LAST_SEEN_AT_ASC',
  LastSeenAtDesc = 'LAST_SEEN_AT_DESC',
  RevokedAtAsc = 'REVOKED_AT_ASC',
  RevokedAtDesc = 'REVOKED_AT_DESC',
  TokenHashAsc = 'TOKEN_HASH_ASC',
  TokenHashDesc = 'TOKEN_HASH_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  WorkspaceIdAsc = 'WORKSPACE_ID_ASC',
  WorkspaceIdDesc = 'WORKSPACE_ID_DESC'
}

export type DisconnectIntegration = {
  __typename?: 'DisconnectIntegration';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Stop syncing (default), or also delete what this connection contributed (D12).
 *
 * Two operations behind one mutation because the screen has to offer both and say which: "stop
 * updating" and "remove what it told you" are different intentions, and a product offering only
 * the second loses history nobody asked to lose. Enabled agents that read this domain are NOT
 * disabled — their reads start answering "disconnected since …", which is an answer, where a
 * silently paused agent is the failure this layer exists to stop.
 */
export type DisconnectMcpConnection = {
  __typename?: 'DisconnectMcpConnection';
  connection?: Maybe<WorkspaceConnectionType>;
};

/** An enumeration. */
export enum DisconnectReason {
  Expired = 'EXPIRED',
  SubscriptionInactive = 'SUBSCRIPTION_INACTIVE',
  Unknown = 'UNKNOWN',
  UserInitiated = 'USER_INITIATED'
}

export type DisconnectUserIntegration = {
  __typename?: 'DisconnectUserIntegration';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DismissDailyLead = {
  __typename?: 'DismissDailyLead';
  dailyLead?: Maybe<DailyLead>;
};

export type DismissDealSuggestion = {
  __typename?: 'DismissDealSuggestion';
  dealSuggestion?: Maybe<DealSuggestion>;
};

export type DismissTaskSuggestion = {
  __typename?: 'DismissTaskSuggestion';
  taskSuggestion?: Maybe<TaskSuggestion>;
};

export type DomainAllowlist = Node & {
  __typename?: 'DomainAllowlist';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DomainAllowlistFilter = {
  domain?: InputMaybe<Scalars['String']['input']>;
};

export type EditPipeline = {
  __typename?: 'EditPipeline';
  pipeline?: Maybe<Pipeline>;
};

export type EditPipelineInput = {
  includeInForecast?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pipelineId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type EmailTemplateClass = Node & {
  __typename?: 'EmailTemplateClass';
  attachmentUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isWorkspaceWide?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type EmailVisibilityInput = {
  /** Who can see emails/calendar/notes/files: 'private', 'admins_and_owners', or 'everyone'. */
  emailVisibility: Scalars['String']['input'];
};

/**
 * Copy-on-enable a seeded template: instantiate it as a workspace ``agent_definition``
 * (copying its curated prompt / tools / trigger / conditions) and activate its backing rule
 * in one call. Each call creates a fresh instance — edits never mutate the shared template,
 * and enabling twice yields two independent agents (guard client-side if you want one-per-
 * template). ``trigger`` optionally overrides the template's cadence/event; ``notifyTarget``
 * sets where it posts.
 */
export type EnableAgentTemplate = {
  __typename?: 'EnableAgentTemplate';
  agent?: Maybe<AgentDefinition>;
};

export type Engagement = Node & {
  __typename?: 'Engagement';
  accounts?: Maybe<Array<Maybe<Account>>>;
  aiBrief?: Maybe<Scalars['String']['output']>;
  aiFollowup?: Maybe<Scalars['String']['output']>;
  aiSummary?: Maybe<Scalars['String']['output']>;
  aiSummaryByTemplate?: Maybe<Scalars['GenericScalar']['output']>;
  associatedDealIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  attachments?: Maybe<Array<Maybe<FileType>>>;
  body?: Maybe<Scalars['String']['output']>;
  bodyHtml?: Maybe<Scalars['String']['output']>;
  coffeeVideoUrl?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  currentUserRecordingEnabled: Scalars['Boolean']['output'];
  currentUserStatus?: Maybe<DdbEngagementStatus>;
  dealSuggestions?: Maybe<Array<Maybe<DealSuggestion>>>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  engagementType?: Maybe<DdbEngagementType>;
  firefliesTranscript?: Maybe<Array<Maybe<TranscriptEntryType>>>;
  firefliesVideoUrl?: Maybe<Scalars['String']['output']>;
  gongTranscript?: Maybe<Array<Maybe<TranscriptEntryType>>>;
  gongVideoUrl?: Maybe<Scalars['String']['output']>;
  granolaTranscript?: Maybe<Array<Maybe<TranscriptEntryType>>>;
  granolaVideoUrl?: Maybe<Scalars['String']['output']>;
  hasActiveBot: Scalars['Boolean']['output'];
  hasAiBrief: Scalars['Boolean']['output'];
  hasAiFollowup: Scalars['Boolean']['output'];
  hasAiSummary: Scalars['Boolean']['output'];
  hasTranscript: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInternal: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  metadataFrom?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  participantAccountIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  participantContactIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  participantUserIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  platform?: Maybe<Scalars['String']['output']>;
  privacy?: Maybe<Scalars['String']['output']>;
  recallTranscript?: Maybe<Array<Maybe<TranscriptEntryType>>>;
  recallVideoUrl?: Maybe<Scalars['String']['output']>;
  recordingEnabled: Scalars['Boolean']['output'];
  recordingOwnerUserId?: Maybe<Scalars['Int']['output']>;
  recordingRecorderType?: Maybe<Scalars['String']['output']>;
  rtmsTranscript?: Maybe<Array<Maybe<RtmsTranscriptEntryType>>>;
  source?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summaries?: Maybe<Array<Maybe<EngagementSummaryType>>>;
  taskSuggestions?: Maybe<Array<Maybe<TaskSuggestion>>>;
  transcriptIncomplete?: Maybe<Scalars['Boolean']['output']>;
  transcriptStatusMessage?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userStatus?: Maybe<Scalars['GenericScalar']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type EngagementBasicType = {
  __typename?: 'EngagementBasicType';
  displayName?: Maybe<Scalars['String']['output']>;
  sharedBy?: Maybe<SharedByUser>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
};

/** Engagement brief with structured data. */
export type EngagementBriefType = {
  __typename?: 'EngagementBriefType';
  brief?: Maybe<Scalars['GenericScalar']['output']>;
  briefTemplateId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  engagementId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EngagementConnection = {
  __typename?: 'EngagementConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EngagementEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EngagementDateFilterInput = {
  notWithinLast?: InputMaybe<RelativeDurationInput>;
  withinLast?: InputMaybe<RelativeDurationInput>;
};

/** A Relay edge containing a `Engagement` and its cursor. */
export type EngagementEdge = {
  __typename?: 'EngagementEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<Engagement>;
};

export type EngagementFilter = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  aiFollowup?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  engagementType?: InputMaybe<DdbEngagementType>;
  hasAiBrief?: InputMaybe<Scalars['Boolean']['input']>;
  hasAiFollowup?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotes?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<DateRangeFilterInput>;
  status?: InputMaybe<DdbEngagementStatus>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userStatus?: InputMaybe<Array<InputMaybe<DdbEngagementStatus>>>;
  workspaceId: Scalars['ID']['input'];
};

/** Engagement summary with structured data. */
export type EngagementSummaryType = {
  __typename?: 'EngagementSummaryType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  engagementId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  summary?: Maybe<Scalars['GenericScalar']['output']>;
  summaryTemplateId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Entitlements for a given pricing tier. */
export type EntitlementsType = {
  __typename?: 'EntitlementsType';
  /** AI-generated field updates */
  aiGeneratedFieldUpdates?: Maybe<Scalars['Boolean']['output']>;
  /** API access */
  apiAccess?: Maybe<Scalars['Boolean']['output']>;
  /** CRM integrations */
  crmIntegrations?: Maybe<Scalars['Boolean']['output']>;
  /** Deals feature */
  deals?: Maybe<Scalars['Boolean']['output']>;
  /** Integration limit (null = unlimited) */
  integrationLimit?: Maybe<Scalars['Int']['output']>;
  /** Can invite users */
  inviteUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of records (null = unlimited) */
  maxRecords?: Maybe<Scalars['Int']['output']>;
  /** Maximum number of users (null = unlimited) */
  maxUsers?: Maybe<Scalars['Int']['output']>;
  /** MCP access */
  mcpAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Meeting history retention in days (null = unlimited) */
  meetingHistoryDays?: Maybe<Scalars['Int']['output']>;
  /** Pipeline intelligence */
  pipelineIntelligence?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of read-only seats (null = unlimited) */
  readOnlyUsers?: Maybe<Scalars['Int']['output']>;
  /** Reports feature */
  reports?: Maybe<Scalars['Boolean']['output']>;
  /** Slack channel */
  slackChannel?: Maybe<Scalars['Boolean']['output']>;
  /** Slack DM */
  slackDm?: Maybe<Scalars['Boolean']['output']>;
  /** Slack integration */
  slackIntegration?: Maybe<Scalars['Boolean']['output']>;
};

/** One labeled, directed association edge (from the entity being read to `to_id`). */
export type EntityAssociation = {
  __typename?: 'EntityAssociation';
  fromType: Scalars['String']['output'];
  label: Scalars['String']['output'];
  source: Scalars['String']['output'];
  subLabel?: Maybe<Scalars['String']['output']>;
  toAccount?: Maybe<Account>;
  toId: Scalars['String']['output'];
  toType: Scalars['String']['output'];
};

export enum EntityType {
  Account = 'ACCOUNT',
  Contact = 'CONTACT',
  Deal = 'DEAL'
}

export type FieldAggregate = {
  __typename?: 'FieldAggregate';
  crm?: Maybe<SourceAggregateDatum>;
  fieldName?: Maybe<Scalars['String']['output']>;
  mdm?: Maybe<SourceAggregateDatum>;
};

export type FieldHistory = {
  __typename?: 'FieldHistory';
  entries: Array<FieldHistoryEntry>;
  hasMore: Scalars['Boolean']['output'];
  hiddenCount: Scalars['Int']['output'];
};

export enum FieldHistoryAction {
  Add = 'ADD',
  Clear = 'CLEAR',
  Created = 'CREATED',
  Remove = 'REMOVE',
  Restore = 'RESTORE',
  Set = 'SET'
}

export type FieldHistoryActor = {
  __typename?: 'FieldHistoryActor';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Coffee user id; null for a non-user source (HubSpot, Coffee AI, ...) */
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum FieldHistoryEntityType {
  Account = 'ACCOUNT',
  Contact = 'CONTACT',
  Deal = 'DEAL'
}

export type FieldHistoryEntry = {
  __typename?: 'FieldHistoryEntry';
  action: FieldHistoryAction;
  changedAt: Scalars['DateTime']['output'];
  /** Null when the change cannot be attributed */
  changedBy?: Maybe<FieldHistoryActor>;
  /** Raw ledger rows this entry stands for (>= 1) */
  collapsedCount: Scalars['Int']['output'];
  /** The field key as the caller passed it */
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAutomated: Scalars['Boolean']['output'];
  /** The ledger field this row was read from */
  ledgerField: Scalars['String']['output'];
  /** Association fields only: the records `values` point at, resolved (same order as `values`). Null for every other field. */
  records?: Maybe<Array<FieldHistoryRecordRef>>;
  /** Public source code (cu, hs, sf, ca, ce, cf, ...). Every enrichment provider reads `ce`, unknown codes `coffee`. */
  source: Scalars['String']['output'];
  sourceGroup: FieldHistorySourceGroup;
  sourceKind: FieldHistorySourceKind;
  /** Display-ready value; null when the change cleared the field */
  value?: Maybe<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
};

export type FieldHistoryRecordRef = {
  __typename?: 'FieldHistoryRecordRef';
  /** The record's ddb id when found (what the update mutations accept, so a client can restore by it); else the value as stored */
  id: Scalars['String']['output'];
  /** Null when MISSING or RESTRICTED */
  name?: Maybe<Scalars['String']['output']>;
  status: FieldHistoryRecordStatus;
};

export enum FieldHistoryRecordStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Missing = 'MISSING',
  Restricted = 'RESTRICTED'
}

/** Who the UI names as the author: a person, one of the customer's integrations, or Coffee. */
export enum FieldHistorySourceGroup {
  Coffee = 'COFFEE',
  Integration = 'INTEGRATION',
  User = 'USER'
}

export enum FieldHistorySourceKind {
  Ai = 'AI',
  CrmSync = 'CRM_SYNC',
  Enrichment = 'ENRICHMENT',
  Formula = 'FORMULA',
  Import = 'IMPORT',
  Integration = 'INTEGRATION',
  Merge = 'MERGE',
  Other = 'OTHER',
  User = 'USER'
}

export type File = Node & {
  __typename?: 'File';
  accounts?: Maybe<Array<Maybe<Account>>>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deals?: Maybe<Array<Maybe<Deal>>>;
  engagements?: Maybe<Array<Maybe<Engagement>>>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<FileSource>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type FileConnection = {
  __typename?: 'FileConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FileEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `File` and its cursor. */
export type FileEdge = {
  __typename?: 'FileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<File>;
};

export type FileFilter = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** GraphQL enum for file source; maps to DdbDeltaSource (e.g. Stripe, QuickBooks, Coffee AI). */
export enum FileSource {
  AiEnrichment = 'AI_ENRICHMENT',
  AiTitleExtraction = 'AI_TITLE_EXTRACTION',
  Ampersand = 'AMPERSAND',
  CoffeeAi = 'COFFEE_AI',
  CoffeeEnrichment = 'COFFEE_ENRICHMENT',
  CoffeeFormula = 'COFFEE_FORMULA',
  CoffeeUser = 'COFFEE_USER',
  EntityMerge = 'ENTITY_MERGE',
  Gmail = 'GMAIL',
  Gong = 'GONG',
  GoogleCalendar = 'GOOGLE_CALENDAR',
  Hubspot = 'HUBSPOT',
  Mailchimp = 'MAILCHIMP',
  ManualCsv = 'MANUAL_CSV',
  MicrosoftCalendar = 'MICROSOFT_CALENDAR',
  MicrosoftEmail = 'MICROSOFT_EMAIL',
  Quickbooks = 'QUICKBOOKS',
  Salesforce = 'SALESFORCE',
  Stripe = 'STRIPE',
  Zoom = 'ZOOM'
}

export type FileType = {
  __typename?: 'FileType';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FillRateDatum = {
  __typename?: 'FillRateDatum';
  columnName?: Maybe<Scalars['String']['output']>;
  fillRate?: Maybe<Scalars['Float']['output']>;
  filled?: Maybe<Scalars['Int']['output']>;
  missing?: Maybe<Scalars['Int']['output']>;
};

export type FloatRangeFilterInput = {
  gt?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
};

/** One record's evaluated formula value, for the builder's preview strip. */
export type FormulaPreviewEntry = {
  __typename?: 'FormulaPreviewEntry';
  entityId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GptResponse = {
  __typename?: 'GPTResponse';
  response?: Maybe<Scalars['String']['output']>;
};

/**
 * Generate engagement brief for a specific template on-demand.
 *
 * When user switches templates in UI:
 * 1. Check if brief already exists for this engagement + template
 * 2. If exists, return it immediately
 * 3. If not, generate it using AI, save to DB, and return
 */
export type GenerateBrief = {
  __typename?: 'GenerateBrief';
  brief?: Maybe<EngagementBriefType>;
};

export type GenerateBriefInput = {
  engagementId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/**
 * Result of turning a natural-language description into a formula expression.
 *
 * `gaps` lists concepts the model could not map onto an existing field, so the builder can
 * highlight the slots the user still has to fill in.
 */
export type GenerateFormulaResult = {
  __typename?: 'GenerateFormulaResult';
  error?: Maybe<Scalars['String']['output']>;
  expression?: Maybe<Scalars['String']['output']>;
  gaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resultType?: Maybe<Scalars['String']['output']>;
};

/**
 * Generate engagement summary for a specific template on-demand.
 *
 * When user switches templates in UI:
 * 1. Check if summary already exists for this engagement + template
 * 2. If exists, return it immediately
 * 3. If not, generate it using AI, save to DB, update deal fields, and return
 *
 * Deal field updates:
 * - Automatically updates deal fields from summary sections with crm_field mappings
 * - Uses LLM to intelligently merge old field values with new content
 * - Stores in MongoDB deal_info collection
 */
export type GenerateSummary = {
  __typename?: 'GenerateSummary';
  summary?: Maybe<EngagementSummaryType>;
};

export type GenerateSummaryInput = {
  engagementId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/**
 * Generate Intelligence section for a workspace: call Perplexity with the workspace's
 * domain, parse the response, and upsert the workspace_intelligence record.
 */
export type GenerateWorkspaceIntelligence = {
  __typename?: 'GenerateWorkspaceIntelligence';
  intelligence?: Maybe<WorkspaceIntelligenceType>;
};

export type GenerateWorkspaceIntelligenceInput = {
  sectionType: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type GeoFilterInput = {
  label: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  radiusMeters: Scalars['Float']['input'];
};

export type GraphQlUser = {
  __typename?: 'GraphQLUser';
  email: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  preferences?: Maybe<Preferences>;
  surname: Scalars['String']['output'];
  workspaceId: Scalars['Int']['output'];
};

export type GridSummary = {
  __typename?: 'GridSummary';
  account?: Maybe<AccountGridSummary>;
  contact?: Maybe<ContactGridSummary>;
  deal?: Maybe<DealGridSummary>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};


export type GridSummaryAccountArgs = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filter?: InputMaybe<AccountFilter>;
};


export type GridSummaryContactArgs = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filter?: InputMaybe<ContactFilterInput>;
};


export type GridSummaryDealArgs = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filter?: InputMaybe<DealFilter>;
};

/**
 * One help-center article returned by searchHelpCenter — the whole article
 * (small-to-big retrieval), ready for the agent to answer from and cite.
 */
export type HelpArticleResult = {
  __typename?: 'HelpArticleResult';
  collection?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Highlight = {
  __typename?: 'Highlight';
  field?: Maybe<Scalars['String']['output']>;
  snippets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Industry = Node & {
  __typename?: 'Industry';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type IndustryConnection = {
  __typename?: 'IndustryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IndustryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Industry` and its cursor. */
export type IndustryEdge = {
  __typename?: 'IndustryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Industry>;
};

export type IndustryFilter = {
  search: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export enum IngestionIndexEnum {
  Account = 'ACCOUNT',
  Contact = 'CONTACT',
  Deal = 'DEAL'
}

export type Integration = {
  __typename?: 'Integration';
  addedTs?: Maybe<Scalars['DateTime']['output']>;
  category: IntegrationPlatformCategory;
  disconnectReason?: Maybe<DisconnectReason>;
  platform: IntegrationPlatform;
  status?: Maybe<IntegrationStatus>;
  workspaceId: Scalars['Int']['output'];
};

/** Traffic-light health for an integration row. */
export enum IntegrationHealthLevel {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW'
}

/** An enumeration. */
export enum IntegrationPlatform {
  Coffee = 'COFFEE',
  Fireflies = 'FIREFLIES',
  Gong = 'GONG',
  GoogleCalendar = 'GOOGLE_CALENDAR',
  Granola = 'GRANOLA',
  Hubspot = 'HUBSPOT',
  HubspotMain = 'HUBSPOT_MAIN',
  Mailchimp = 'MAILCHIMP',
  ManualCsv = 'MANUAL_CSV',
  Microsoft = 'MICROSOFT',
  Quickbooks = 'QUICKBOOKS',
  Salesforce = 'SALESFORCE',
  SalesforceMain = 'SALESFORCE_MAIN',
  Slack = 'SLACK',
  StripeConnect = 'STRIPE_CONNECT',
  Zapier = 'ZAPIER',
  Zoom = 'ZOOM'
}

/** An enumeration. */
export enum IntegrationPlatformCategory {
  Analytics = 'ANALYTICS',
  Crm = 'CRM'
}

/** An enumeration. */
export enum IntegrationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type IntegrationWithToken = {
  __typename?: 'IntegrationWithToken';
  accessToken: Scalars['String']['output'];
  addedTs?: Maybe<Scalars['DateTime']['output']>;
  category: IntegrationPlatformCategory;
  platform: IntegrationPlatform;
  status: IntegrationStatus;
  workspaceId: Scalars['Int']['output'];
};

/** One write the agent would have made on a live run — a stubbed mutating tool call, captured. */
export type IntendedEffect = {
  __typename?: 'IntendedEffect';
  args?: Maybe<Scalars['JSONString']['output']>;
  tool?: Maybe<Scalars['String']['output']>;
};

export type InvalidateCache = {
  __typename?: 'InvalidateCache';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InvalidateCacheInput = {
  workspaceId: Scalars['ID']['input'];
};

export type InviteUser = {
  __typename?: 'InviteUser';
  user?: Maybe<User>;
};

export type InviteUserInput = {
  email: Scalars['String']['input'];
  role: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type JobTitle = Node & {
  __typename?: 'JobTitle';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type JobTitleConnection = {
  __typename?: 'JobTitleConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobTitleEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobTitle` and its cursor. */
export type JobTitleEdge = {
  __typename?: 'JobTitleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<JobTitle>;
};

export type JobTitleFilter = {
  search: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/**
 * Mutation to join an existing workspace.
 *
 * The user must be eligible to join:
 * 1. User has a corporate email (not personal like gmail, yahoo, etc.)
 * 2. Their email domain must match the workspace domain
 * 3. The workspace must not have a 'single_shot' subscription
 */
export type JoinWorkspace = {
  __typename?: 'JoinWorkspace';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  workspace?: Maybe<Workspace>;
};

export type JoinWorkspaceInput = {
  /** ID of the workspace to join */
  workspaceId: Scalars['ID']['input'];
};

export type LedgerEntryDelta = {
  __typename?: 'LedgerEntryDelta';
  action?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  customProperties?: Maybe<Scalars['GenericScalar']['output']>;
  dealId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<LineItemProperties>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

/** A single line item within SetDealLineItems. */
export type LineItemInput = {
  listPrice?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type LineItemProperties = {
  __typename?: 'LineItemProperties';
  discount?: Maybe<Scalars['Float']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

/**
 * Manually link or unlink an engagement and a deal. An escape hatch for when
 * the automatic engagement->deal association gets it wrong.
 */
export type LinkEngagementToDeal = {
  __typename?: 'LinkEngagementToDeal';
  engagement?: Maybe<Engagement>;
};

export type List = Node & {
  __typename?: 'List';
  /** Number of contacts in this list (CONTACT lists only; 0 otherwise) */
  contactCount?: Maybe<Scalars['Int']['output']>;
  createTs: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  folderId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  modelType: ListModelType;
  name: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  properties: Scalars['JSONString']['output'];
  public: Scalars['Boolean']['output'];
  static: Scalars['Boolean']['output'];
  updateTs: Scalars['DateTime']['output'];
  userLists?: Maybe<UserListConnection>;
  users?: Maybe<UserConnection>;
  workspaceId: Scalars['Int']['output'];
};


export type ListUserListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ListUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ListConnection = {
  __typename?: 'ListConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ListEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `List` and its cursor. */
export type ListEdge = {
  __typename?: 'ListEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<List>;
};

export type ListFolder = Node & {
  __typename?: 'ListFolder';
  createTs: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  modelType: ListModelType;
  name: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  public: Scalars['Boolean']['output'];
  updateTs: Scalars['DateTime']['output'];
  workspaceId: Scalars['Int']['output'];
};

/** An enumeration. */
export enum ListModelType {
  Account = 'ACCOUNT',
  Contact = 'CONTACT',
  Deal = 'DEAL'
}

export type LocationFilterInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type MailchimpAudience = {
  __typename?: 'MailchimpAudience';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * Mark every unread row read.
 *
 * Takes no ids on purpose. The feed is paginated, so a client holding 20 rows cannot
 * name the other 37 — marking "all" from the client's list would leave a badge that
 * refuses to clear. One server-side UPDATE, served by idx__notification__unread.
 */
export type MarkAllNotificationsRead = {
  __typename?: 'MarkAllNotificationsRead';
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type MarkFirstTimeNotificationsSent = {
  __typename?: 'MarkFirstTimeNotificationsSent';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Mark specific rows read. Returns the authoritative unread count. */
export type MarkNotificationsRead = {
  __typename?: 'MarkNotificationsRead';
  notifications?: Maybe<Array<Maybe<NotificationType>>>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type MarkNotificationsSeen = {
  __typename?: 'MarkNotificationsSeen';
  newCount?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Where to send the admin, or what the server still needs from them first. */
export type McpConnectStart = {
  __typename?: 'McpConnectStart';
  authorizationUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  needs?: Maybe<Scalars['String']['output']>;
  redirectUri?: Maybe<Scalars['String']['output']>;
};

/** One option for a field that is not free text. */
export type MdmAllowedValue = {
  __typename?: 'MdmAllowedValue';
  label: Scalars['String']['output'];
  /** The value to store. NULL is a REAL option for revenue_min -- the smallest band ('under $1M') genuinely has no lower bound. */
  value?: Maybe<Scalars['GenericScalar']['output']>;
};

export type MdmAttachImageFromUrl = {
  __typename?: 'MdmAttachImageFromUrl';
  result: MdmWriteResult;
};

/** One field going from one value to another. */
export type MdmChange = {
  __typename?: 'MdmChange';
  field: Scalars['String']['output'];
  fromValue?: Maybe<Scalars['GenericScalar']['output']>;
  /** Survivorship mode that will be recorded, when applicable. */
  mode?: Maybe<Scalars['String']['output']>;
  /** The vendor clock captured with the override. With from_value, this is what decides whether the vendor can later win the field back. */
  sourceUpdatedAtSeen?: Maybe<Scalars['DateTime']['output']>;
  toValue?: Maybe<Scalars['GenericScalar']['output']>;
};

export type MdmCompanyCandidate = {
  __typename?: 'MdmCompanyCandidate';
  company: Company;
  /** Wins because someone pinned it, rather than because the rule chose it. */
  isCurated: Scalars['Boolean']['output'];
  /** Currently wins this domain. */
  isParent: Scalars['Boolean']['output'];
};

export type MdmCompanyDetail = {
  __typename?: 'MdmCompanyDetail';
  audit: MdmEditAuditPage;
  company: Company;
  curatedAt?: Maybe<Scalars['DateTime']['output']>;
  domainOverride?: Maybe<MdmDomainOverride>;
  indexComparison?: Maybe<MdmIndexComparison>;
  isParentOfItsDomain: Scalars['Boolean']['output'];
  /** Where this company's logo LIVES, derived from its primary domain (coffee-logos/company/<domain>.png) rather than read from properties.logo. The current company feed ships no logo key at all, so reading properties would show a placeholder for a company whose logo is in the bucket; and where the key does exist its value is already this URL. Treat it as where to look, not proof an image is there -- fall back on a load error. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  overrides: Array<Maybe<MdmFieldOverride>>;
  rawProperties?: Maybe<Scalars['GenericScalar']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MdmCompanyLookup = {
  __typename?: 'MdmCompanyLookup';
  index: MdmIndexHits;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  postgresRecords: Array<Maybe<Company>>;
};

/**
 * HOW a person's company was decided. Two of these mean "no company" for very different
 * reasons, and telling them apart is the point: creating a company for a SUPPRESSED domain is
 * exactly the wrong response.
 */
export enum MdmCompanyResolutionPath {
  CuratedOverride = 'CURATED_OVERRIDE',
  None = 'NONE',
  ParentRule = 'PARENT_RULE',
  SourceCompanyId = 'SOURCE_COMPANY_ID',
  Suppressed = 'SUPPRESSED'
}

export type MdmCreateCompany = {
  __typename?: 'MdmCreateCompany';
  result: MdmWriteResult;
};

export type MdmCreateCompanyInput = {
  /** Start from this company: inherit every column and properties key not supplied here, including the whole insights bag (tech stack, role counts, NAICS/SIC, funding) that no form displays. The copy is a NEW company with source='coffee', so no reload can touch it -- and it competes with the original for its domain under parent selection. */
  copyFromCompanyId?: InputMaybe<Scalars['ID']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Feeds parent selection. */
  employeeCountMin?: InputMaybe<Scalars['Int']['input']>;
  /** Leads parent selection. */
  linkedinFollowers?: InputMaybe<Scalars['Float']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  primaryDomain: Scalars['String']['input'];
  /** The enrichment properties bag, keyed by the keys mdmEnrichmentFields returns. Unknown keys are REFUSED rather than dropped, so a typo fails loudly instead of producing a field nothing reads. */
  properties?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Feeds parent selection. */
  revenueMin?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type MdmCreatePerson = {
  __typename?: 'MdmCreatePerson';
  result: MdmWriteResult;
};

export type MdmCreatePersonInput = {
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Start from this person: inherit every column and properties key not supplied here, including the vendor keys no form displays. The sanctioned way round primary_email being locked -- copy to the corrected address and retire the original, rather than renaming a record the loader would re-create under its old address on the next load. */
  copyFromPersonId?: InputMaybe<Scalars['ID']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedinProfileUrl?: InputMaybe<Scalars['String']['input']>;
  /** Either this or linkedinProfileUrl is required. */
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  /** The enrichment properties bag, keyed by the keys mdmEnrichmentFields returns. Unknown keys are REFUSED rather than dropped, so a typo fails loudly instead of producing a field nothing reads. */
  properties?: InputMaybe<Scalars['GenericScalar']['input']>;
};

/**
 * Two things this record says that cannot both be true.
 *
 * Not "this value is wrong" -- we usually cannot know that. A contradiction is a much weaker
 * claim and a much more useful one: it is exactly the set of records worth a human's attention,
 * and exactly the set that should not be confidently suggested as a lead.
 */
export type MdmDataConflict = {
  __typename?: 'MdmDataConflict';
  code: Scalars['String']['output'];
  /** Why it is a contradiction, and where the values came from. */
  detail?: Maybe<Scalars['String']['output']>;
  /** The fields involved, for jumping straight to an edit. */
  fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** high | medium */
  severity: Scalars['String']['output'];
  /** What contradicts what, in one line. */
  summary: Scalars['String']['output'];
};

export type MdmDeleteDomainOverride = {
  __typename?: 'MdmDeleteDomainOverride';
  result: MdmWriteResult;
};

/** Every company on a domain, ranked by the live parent rule. */
export type MdmDomainCompanies = {
  __typename?: 'MdmDomainCompanies';
  domain: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  override?: Maybe<MdmDomainOverride>;
  page: Scalars['Int']['output'];
  parentCompanyId?: Maybe<Scalars['ID']['output']>;
  perPage: Scalars['Int']['output'];
  records: Array<Maybe<MdmCompanyCandidate>>;
  suppressed: Scalars['Boolean']['output'];
};

export type MdmDomainOverride = {
  __typename?: 'MdmDomainOverride';
  companyId?: Maybe<Scalars['ID']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  curatedAt?: Maybe<Scalars['DateTime']['output']>;
  curatedBy?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  /** The vendor id captured at curation time -- the drift checksum, since company.id is a SERIAL and a reload reassigns it. */
  sourceId?: Maybe<Scalars['String']['output']>;
  suppress: Scalars['Boolean']['output'];
  updateTs?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * A record that already exists and looks like the one being created.
 *
 * Entity-agnostic on purpose: a duplicate company on a shared domain and a duplicate LinkedIn
 * URL on a person are the same question to the person clicking Create -- "is this already
 * here?" -- even though only one of them is ever a refusal.
 */
export type MdmDuplicate = {
  __typename?: 'MdmDuplicate';
  /** Why it matters: whether it currently wins the domain, its firmographics, its email. */
  detail?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  /** TRUE when the create cannot proceed. Only ever true for a duplicate primary_email, which carries a UNIQUE constraint and is the person loader's upsert key -- a second row there is impossible, not merely unwise. Everything else is informational: a shared domain legitimately holds many companies, and MDM does not enforce LinkedIn uniqueness. */
  isBlocking: Scalars['Boolean']['output'];
  /** The name, for recognising it. */
  label?: Maybe<Scalars['String']['output']>;
  /** primary_domain | linkedin_url | linkedin_profile_url */
  matchedOn: Scalars['String']['output'];
  matchedValue?: Maybe<Scalars['String']['output']>;
};

export type MdmEditAudit = {
  __typename?: 'MdmEditAudit';
  action: Scalars['String']['output'];
  actorEmail?: Maybe<Scalars['String']['output']>;
  /** admin | reconciler | loader */
  actorKind: Scalars['String']['output'];
  createTs?: Maybe<Scalars['DateTime']['output']>;
  /** The person's employer domain, or the company's own domain. */
  entityDomain?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  /** A name a person recognises, for a cross-record list. NULL when the row's entity no longer resolves. */
  entityLabel?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** NULL for whole-record actions (create, reindex) */
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  newValue?: Maybe<Scalars['GenericScalar']['output']>;
  oldValue?: Maybe<Scalars['GenericScalar']['output']>;
  overrideId?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type MdmEditAuditPage = {
  __typename?: 'MdmEditAuditPage';
  hasNextPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  records: Array<Maybe<MdmEditAudit>>;
};

/**
 * One field on the create form, and why it is there.
 *
 * These are the keys CRM enrichment reads off `person.properties` / `company.properties` -- not
 * the columns. A record created without them is searchable but enriches almost nothing, which is
 * why the create forms collect them rather than leaving them for a later edit.
 */
export type MdmEnrichmentField = {
  __typename?: 'MdmEnrichmentField';
  /** Form section: Role, Location, Contact, Size... */
  group: Scalars['String']['output'];
  helpText?: Maybe<Scalars['String']['output']>;
  /** The properties key, and the enrichment translator key. */
  key: Scalars['String']['output'];
  /** text | textarea | number | date | select */
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Set when this key ALSO exists as a promoted column. The two are independent: the column drives parent selection and the Kotlin readers, the key drives enrichment and the search doc, so the writer fills both. */
  mirrorColumn?: Maybe<Scalars['String']['output']>;
  /** Present when kind == 'select'. */
  options?: Maybe<Array<Maybe<MdmAllowedValue>>>;
};

export type MdmFieldOverride = {
  __typename?: 'MdmFieldOverride';
  actorEmail?: Maybe<Scalars['String']['output']>;
  createTs?: Maybe<Scalars['DateTime']['output']>;
  /** The person's employer domain, or the company's own domain. */
  entityDomain?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  /** A name a person recognises, for a cross-record list. NULL when the row's entity no longer resolves. */
  entityLabel?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mode: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  /** The row's source_updated_at when the override was made. */
  sourceUpdatedAtSeen?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  supersededAt?: Maybe<Scalars['DateTime']['output']>;
  /** What the vendor said when it won the field back. */
  supersededByValue?: Maybe<Scalars['GenericScalar']['output']>;
  updateTs?: Maybe<Scalars['DateTime']['output']>;
  /** What we assert. JSON, because the covered fields are text, numbers, booleans and jsonb sub-objects. */
  value?: Maybe<Scalars['GenericScalar']['output']>;
  /** The value the human rejected. With the clock below, this is what decides supersession. */
  vendorValueSeen?: Maybe<Scalars['GenericScalar']['output']>;
};

export type MdmFieldOverridePage = {
  __typename?: 'MdmFieldOverridePage';
  hasNextPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  records: Array<Maybe<MdmFieldOverride>>;
};

/** Whether a field may be overridden, and its default survivorship mode. Drives the form. */
export type MdmFieldPolicy = {
  __typename?: 'MdmFieldPolicy';
  /** Present when the field holds one of a fixed set of values -- the admin must choose, not type. NULL means free text. */
  allowedValues?: Maybe<Array<Maybe<MdmAllowedValue>>>;
  /** NULL when the field is not editable */
  defaultMode?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  entityType: Scalars['String']['output'];
  field: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

/** The Postgres row rendered as a document, next to what is actually indexed. */
export type MdmIndexComparison = {
  __typename?: 'MdmIndexComparison';
  differingFields: Array<Maybe<Scalars['String']['output']>>;
  /** What a reindex would write from the row right now. */
  expected?: Maybe<Scalars['GenericScalar']['output']>;
  inSync: Scalars['Boolean']['output'];
  index: Scalars['String']['output'];
  /** What the index holds. NULL when the document is missing. */
  indexed?: Maybe<Scalars['GenericScalar']['output']>;
  missing: Scalars['Boolean']['output'];
};

/** What the OpenSearch index holds for a query -- i.e. what list-builder would see. */
export type MdmIndexHits = {
  __typename?: 'MdmIndexHits';
  docs: Array<Maybe<Scalars['GenericScalar']['output']>>;
  index: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  /** True when counting stopped at the cap; display as 'N+'. */
  totalIsLowerBound: Scalars['Boolean']['output'];
};

export type MdmOverrideDrift = {
  __typename?: 'MdmOverrideDrift';
  actualName?: Maybe<Scalars['String']['output']>;
  actualSourceId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['ID']['output']>;
  companyMissing: Scalars['Boolean']['output'];
  curatedAt?: Maybe<Scalars['DateTime']['output']>;
  curatedBy?: Maybe<Scalars['String']['output']>;
  curatedName?: Maybe<Scalars['String']['output']>;
  curatedSourceId?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
};

export type MdmOverrideSyncStatus = {
  __typename?: 'MdmOverrideSyncStatus';
  active: Scalars['Int']['output'];
  driftCount: Scalars['Int']['output'];
  /** Active overrides whose row no longer holds the value. Non-zero and not falling means the reconciler is not running -- otherwise invisible, because the override rows still look fine. */
  outOfSync: Scalars['Int']['output'];
  /** Last time the reconciler wrote anything -- NOT its last pass. A reconciler with nothing to do writes nothing, so an old value here is not by itself a problem; mdm_reconciler_heartbeat in CloudWatch is the liveness signal. */
  reconcilerLastWrite?: Maybe<Scalars['DateTime']['output']>;
  retired: Scalars['Int']['output'];
  /** Awaiting human review. */
  superseded: Scalars['Int']['output'];
  unaddressableFields: Array<Maybe<Scalars['String']['output']>>;
};

export type MdmPersonDetail = {
  __typename?: 'MdmPersonDetail';
  audit: MdmEditAuditPage;
  /** Contradictions within this record. Empty for a healthy one. */
  conflicts: Array<Maybe<MdmDataConflict>>;
  curatedAt?: Maybe<Scalars['DateTime']['output']>;
  indexComparison?: Maybe<MdmIndexComparison>;
  overrides: Array<Maybe<MdmFieldOverride>>;
  person: Person;
  /** The whole properties blob, unshaped. */
  rawProperties?: Maybe<Scalars['GenericScalar']['output']>;
  resolvedCompany: MdmResolvedCompany;
  /** Last human to edit this row; NULL if never hand-edited. */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MdmPersonLookup = {
  __typename?: 'MdmPersonLookup';
  index: MdmIndexHits;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  postgresRecords: Array<Maybe<Person>>;
};

/**
 * Push an MDM correction into the CRM records that already exist.
 *
 * Enrichment otherwise runs once, at record creation (`if is_new` in crud.py), so a contact
 * created in March carries what MDM said in March and today's fix never reaches it.
 *
 * Safe to run, and safe to run twice: this calls the same enrichment builders the ingestion
 * activities call, which skip any field a human, AI or formula authored, skip any field
 * sourced from HubSpot/Salesforce/CSV at apply time, and skip any field whose value has not
 * moved. A second run writes nothing.
 */
export type MdmReEnrich = {
  __typename?: 'MdmReEnrich';
  result?: Maybe<MdmReEnrichResult>;
};

/** One CRM field a re-enrichment would change, and what it is changing from. */
export type MdmReEnrichFieldChange = {
  __typename?: 'MdmReEnrichFieldChange';
  field: Scalars['String']['output'];
  /** Where the CRM's current value came from. A value sourced from a human, AI or a formula is never overwritten. */
  fromSource?: Maybe<Scalars['String']['output']>;
  fromValue?: Maybe<Scalars['GenericScalar']['output']>;
  toSource?: Maybe<Scalars['String']['output']>;
  toValue?: Maybe<Scalars['GenericScalar']['output']>;
};

export type MdmReEnrichInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  entityId: Scalars['ID']['input'];
  /** person | company */
  entityType: Scalars['String']['input'];
  /** The workspaces to update. Pass one, or every id from mdmReEnrichTargets to do them all. Each is an independent partition-scoped lookup, so a list is not a cross-workspace scan -- which IS the one access pattern the document store cannot serve, and the reason the ids have to be enumerated first rather than discovered inside the write. */
  workspaceIds: Array<Scalars['Int']['input']>;
};

export type MdmReEnrichRecord = {
  __typename?: 'MdmReEnrichRecord';
  applied: Scalars['Boolean']['output'];
  changes?: Maybe<Array<Maybe<MdmReEnrichFieldChange>>>;
  ddbId: Scalars['String']['output'];
  /** The MDM record the values came from. For an account this is the domain's PARENT as resolved now, which is not necessarily the company you were looking at -- so a parent pin propagates, and a non-parent company correctly enriches from the one that is. */
  enrichedFrom?: Maybe<Scalars['String']['output']>;
  /** This record failed; the others in the run still went through. */
  error?: Maybe<Scalars['String']['output']>;
  /** The email or domain that matched. */
  label: Scalars['String']['output'];
  /** contact | account */
  objectType: Scalars['String']['output'];
  workspaceId: Scalars['Int']['output'];
};

/**
 * What pushing an MDM correction into CRM did, or would do.
 *
 * A dry run is the identical computation stopping short of the write, not an approximation:
 * the same enrichment builders decide what changes, so what a preview shows is what a run does.
 */
export type MdmReEnrichResult = {
  __typename?: 'MdmReEnrichResult';
  /** Fields with a diff. See changed_records. */
  changedFields: Scalars['Int']['output'];
  /** Records with a DIFF. The number to show BEFORE writing -- 'what will this change'. NOT the outcome: a record whose write fails keeps its diff and is still counted here. */
  changedRecords: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  /** Records whose write raised. The reason is on the record's `error`. Re-running is safe: anything already written is skipped as unchanged. */
  failedRecords: Scalars['Int']['output'];
  /** The email or domain being propagated. */
  key?: Maybe<Scalars['String']['output']>;
  records?: Maybe<Array<Maybe<MdmReEnrichRecord>>>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields on records that were written. */
  writtenFields: Scalars['Int']['output'];
  /** Records actually written. Always 0 for a dry run. This -- not changed_records -- is what a confirmation may claim, because a failed write keeps its diff and would otherwise be reported as a success. */
  writtenRecords: Scalars['Int']['output'];
};

/**
 * A workspace holding a CRM record this MDM change would touch.
 *
 * Carries the NAME, not just the id: these writes land in a customer's workspace, and choosing
 * from "Workspace 1 / Workspace 2 / Workspace 5" asks someone to act on data they cannot
 * identify.
 */
export type MdmReEnrichTarget = {
  __typename?: 'MdmReEnrichTarget';
  domain?: Maybe<Scalars['String']['output']>;
  /** How many records in that workspace match. */
  matchingRecords?: Maybe<Scalars['Int']['output']>;
  /** NULL only if the workspace row is missing -- the target is still offered, because hiding a workspace that has matching records is worse than showing one without a name. */
  name?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['Int']['output'];
};

export type MdmReindex = {
  __typename?: 'MdmReindex';
  result: MdmWriteResult;
};

export type MdmReindexResult = {
  __typename?: 'MdmReindexResult';
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type MdmResolveSupersededOverride = {
  __typename?: 'MdmResolveSupersededOverride';
  result: MdmWriteResult;
};

export type MdmResolvedCompany = {
  __typename?: 'MdmResolvedCompany';
  company?: Maybe<Company>;
  /** Plain-English reason, safe to show as-is. */
  explanation: Scalars['String']['output'];
  override?: Maybe<MdmDomainOverride>;
  path: MdmCompanyResolutionPath;
};

export type MdmRetireFieldOverride = {
  __typename?: 'MdmRetireFieldOverride';
  result: MdmWriteResult;
};

export type MdmSetDomainOverride = {
  __typename?: 'MdmSetDomainOverride';
  result: MdmWriteResult;
};

export type MdmSetDomainOverrideInput = {
  /** The company to pin. Mutually exclusive with suppress. */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  domain: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Worklist group: marketplace | website_builder | ... */
  kind?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** No company legitimately owns this domain (github.io, wixsite.com). Removes every company on it from the index. */
  suppress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MdmSetFieldOverride = {
  __typename?: 'MdmSetFieldOverride';
  result: MdmWriteResult;
};

export type MdmSetFieldOverrideInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  entityId: Scalars['ID']['input'];
  /** person | company */
  entityType: Scalars['String']['input'];
  /** A column, or a dotted properties path. */
  field: Scalars['String']['input'];
  /** until_source_changes | hard | gapfill_once. Defaults to the field's policy. */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** Why. Shown in the review queue if the vendor later wins. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The value to assert. Omit or send null to clear the field deliberately. */
  value?: InputMaybe<Scalars['GenericScalar']['input']>;
};

/** The outcome of one admin write, or of a dry run of it. */
export type MdmWriteResult = {
  __typename?: 'MdmWriteResult';
  /** False for a dry run, or when nothing changed. */
  applied: Scalars['Boolean']['output'];
  changes: Array<Maybe<MdmChange>>;
  dryRun: Scalars['Boolean']['output'];
  /** Records that already look like the one being created. Informational on a shared domain or a shared LinkedIn page -- both legitimately hold more than one record -- and blocking only for a duplicate primary_email. Populated on the dry run, so it is visible BEFORE anything is written. */
  duplicates: Array<Maybe<MdmDuplicate>>;
  overrideId?: Maybe<Scalars['ID']['output']>;
  reindexed: Array<Maybe<MdmReindexResult>>;
  /** Consequences worth reading before confirming -- a suppression's blast radius, a cross-domain pin emitting no document, a created person not being reload-protected. */
  warnings: Array<Maybe<Scalars['String']['output']>>;
};

export type MergeAccounts = {
  __typename?: 'MergeAccounts';
  primaryAccount?: Maybe<Account>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MergeAccountsInput = {
  otherAccountIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  primaryAccountId: Scalars['ID']['input'];
};

export type MergeContacts = {
  __typename?: 'MergeContacts';
  primaryContact?: Maybe<Contact>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MergeContactsInput = {
  otherContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  primaryContactId: Scalars['ID']['input'];
};

export type MetricDatum = {
  __typename?: 'MetricDatum';
  avg?: Maybe<Scalars['Float']['output']>;
  columnName?: Maybe<Scalars['String']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type ModelReport = {
  __typename?: 'ModelReport';
  fieldAggregates?: Maybe<Array<Maybe<FieldAggregate>>>;
  percentage?: Maybe<Scalars['Float']['output']>;
  totalDocuments?: Maybe<Scalars['Int']['output']>;
};

export type MoveDealsAndDeletePipeline = {
  __typename?: 'MoveDealsAndDeletePipeline';
  fromPipeline?: Maybe<Pipeline>;
  movedDealsCount?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  toPipeline?: Maybe<Pipeline>;
};

export type MoveDealsAndDeletePipelineInput = {
  fromPipelineId: Scalars['ID']['input'];
  stageMappings: Array<InputMaybe<StageMappingInput>>;
  toPipelineId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type Mutations = {
  __typename?: 'Mutations';
  acceptContactChangeSuggestion?: Maybe<ContactChangeResultType>;
  acceptDealSuggestion?: Maybe<AcceptDealSuggestion>;
  acceptTaskSuggestion?: Maybe<AcceptTaskSuggestion>;
  activateAutomationRule?: Maybe<ActivateAutomationRule>;
  addAiChatMessageFeedback?: Maybe<AddAiChatMessageFeedback>;
  addEmailSuppression?: Maybe<AddEmailSuppressionMutation>;
  addFavorite?: Maybe<AddFavorite>;
  addRecordsToList?: Maybe<AddRecordsToList>;
  addUserGroupMembers?: Maybe<AddUserGroupMembers>;
  addUserManager?: Maybe<AddUserManager>;
  addWorkspaceDomain?: Maybe<AddWorkspaceDomain>;
  /**
   * Run one policy request on the caller's authority.
   *
   * This is the surface ``run_policy_request`` was written for. The rule tools refuse any run that
   * carries no ``authoring_user_id``, and no other run path supplies one — the fire path
   * deliberately does not, because standing governance should be written by a person who is asking
   * for it. Until this mutation existed the tools were correct and unreachable.
   *
   * The admin check is NOT repeated here: it lives once in ``rules.rule_authoring``, and a second
   * copy in the API layer is how two gates start disagreeing. Entitlement is checked by narrowing
   * the toolset instead of refusing outright, so a workspace that has not opted into agent-authored
   * policy can still ask what it is already enforcing.
   */
  authorPolicy?: Maybe<AuthorPolicy>;
  /**
   * Direct, CSV-free company list build. icp-builder resolves the companies
   * (validity-gated, deduped, excluded) and writes them as NDJSON to S3; this
   * mutation starts a lean Temporal workflow that creates the accounts + static
   * list directly. Additive — the existing csvIngest path is untouched.
   */
  buildAccountList?: Maybe<BuildAccountList>;
  /**
   * Direct, CSV-free people list build. icp-builder resolves the people
   * (the user's selected person_ids) and writes them as NDJSON to S3; this
   * mutation starts a lean Temporal workflow that creates the contacts + static
   * list directly and charges credits for the people created. Additive — the
   * existing csvIngest path is untouched.
   */
  buildContactList?: Maybe<BuildContactList>;
  bulkAssignAccountOwner?: Maybe<BulkAssignAccountOwner>;
  bulkAssignOwner?: Maybe<BulkAssignOwner>;
  /**
   * Inspect a pasted Fireflies key before connecting, so the dialog only
   * offers "Everyone in the workspace" when it can work. A mutation (not a
   * query) so the key never lands in Apollo's query cache. Stores nothing.
   */
  checkFirefliesKey?: Maybe<CheckFirefliesKey>;
  /** Finish the authorization flow: exchange the code, then discover and classify. */
  completeMcpConnection?: Maybe<CompleteMcpConnection>;
  /**
   * Complete a pending Slack installation using stored OAuth tokens.
   * Called from frontend after Auth0 callback when pending_slack_install is present.
   */
  completeSlackInstall?: Maybe<CompleteSlackInstall>;
  /**
   * The admin's ruling on what we guessed the server supplies (D13).
   *
   * CONFIRMED is the activation: authoritative from here on, and it survives a re-discovery for as
   * long as the tools it names still exist. Without this step a misclassified server silently feeds
   * agents the wrong domain, and honest absence cannot catch it because the read SUCCEEDS.
   *
   * CONTACT_SUPPORT is the other half of the same question, and it has to be a real outcome rather
   * than a mailto: link — a workspace whose server we read as empty has nothing else it can do, and
   * an admin who has told us we are wrong must not keep being asked the same question by the card.
   */
  confirmConnection?: Maybe<ConfirmConnection>;
  /**
   * Connect Fireflies.ai via a pasted personal API key (Fireflies has no OAuth
   * for its data API). Validates the key, stores it, retires any other external
   * recorder the user had, disables Coffee's own VC recording for this user, and
   * starts a backfill. Disconnect reuses DisconnectUserIntegration with
   * platform="FIREFLIES".
   */
  connectFireflies?: Maybe<ConnectFireflies>;
  /**
   * Connect Fireflies for EVERYONE in the workspace (admin only) with a
   * Fireflies admin's API key. Every meeting the key can see is imported, owned
   * by the Coffee member it was recorded for — else by the connecting admin.
   * `error` is "invalid_key" or "not_admin_key" when ok is false.
   * Disconnect: disconnectIntegration(platform: "FIREFLIES").
   */
  connectFirefliesWorkspace?: Maybe<ConnectFirefliesWorkspace>;
  /**
   * Connect Granola via a pasted personal API key (Granola has no OAuth for
   * the data API). Validates the key, stores it, and starts a backfill. By
   * default Granola runs alongside Coffee's recorder; with
   * keepCoffeeRecording=false ("Replace Coffee's recorder") Coffee recording is
   * turned off for this user. Disconnect reuses DisconnectUserIntegration with
   * platform="GRANOLA".
   */
  connectGranola?: Maybe<ConnectGranola>;
  /** Begin connecting an MCP server. Discovery decides which flow the admin sees. */
  connectMcpServer?: Maybe<ConnectMcpServer>;
  createAccount?: Maybe<CreateAccount>;
  createAgentDefinition?: Maybe<CreateAgentDefinition>;
  createAiChatConversation?: Maybe<CreateAiChatConversation>;
  createAutomationRule?: Maybe<CreateAutomationRule>;
  createBadDataReport?: Maybe<CreateBadDataReport>;
  /** Mutation to create a Stripe billing portal session. */
  createBillingPortalSession?: Maybe<CreateBillingPortalSession>;
  createBriefTemplate?: Maybe<CreateBriefTemplate>;
  createCampaign?: Maybe<CreateCampaign>;
  /**
   * Mutation to create a Stripe Checkout session for a subscription.
   *
   * This creates a Checkout session and returns the URL to redirect the user to.
   * After successful payment, Stripe will redirect to the success_url and send
   * a webhook event that creates the subscription record.
   */
  createCheckoutSession?: Maybe<CheckoutSession>;
  createClip?: Maybe<ClipType>;
  createContact?: Maybe<CreateContact>;
  /**
   * Mutation to create a Stripe CustomerSession with pricing table enabled.
   *
   * This creates a CustomerSession that can be used with Stripe's embedded pricing table.
   * The client_secret is used to initialize the pricing table component on the frontend.
   */
  createCustomerSession?: Maybe<CustomerSession>;
  createDeal?: Maybe<CreateDeal>;
  /**
   * Create a new custom deal field for a workspace.
   * Used when users want to create custom fields beyond the default methodology fields.
   */
  createDealField?: Maybe<CreateDealField>;
  createDealStage?: Maybe<CreateDealStage>;
  createDefaultDealStages?: Maybe<CreateDefaultDealStages>;
  createDefaultEmailTemplates?: Maybe<CreateDefaultEmailTemplates>;
  createDesktopPairingCode?: Maybe<CreateDesktopPairingCode>;
  createDomainAllowlist?: Maybe<CreateDomainAllowlist>;
  createEmailTemplate?: Maybe<CreateEmailTemplate>;
  createFile?: Maybe<CreateFile>;
  createIngestionField?: Maybe<CrmCreateIngestionField>;
  createList?: Maybe<CreateList>;
  createListFolder?: Maybe<CreateListFolder>;
  createNote?: Maybe<CreateNote>;
  createPipeline?: Maybe<CreatePipeline>;
  createProduct?: Maybe<CreateProduct>;
  createReportDefinition?: Maybe<CreateReportDefinition>;
  createSummaryTemplate?: Maybe<CreateSummaryTemplate>;
  createUserGroup?: Maybe<CreateUserGroup>;
  /**
   * Create an in-app notification for a user, on behalf of an external producer.
   *
   * Exists for coffee-slack, which owns the three recurring digests: its hourly cron
   * already resolves each user's timezone and optimal send hour, and rebuilding that in
   * Python would be a straight duplication. When a user's delivery preferences include
   * WEB, that cron calls this alongside the Slack/email send.
   *
   * Authorization mirrors MarkFirstTimeNotificationsSent: M2M API tokens (which is what
   * coffee-slack is) may write for any user in the workspace, while a human caller may
   * only write to their own feed. Without that second half this would be an open relay
   * for putting arbitrary notifications in a colleague's bell.
   *
   * Preference gating, dedupe and the unknown-type check all live in emit_notification,
   * so a caller cannot bypass them by coming through this door.
   */
  createWebNotification?: Maybe<CreateWebNotification>;
  /**
   * Create a new workspace.
   *
   * For regular users:
   * - Domain is derived from their email (corporate domain or full email for personal domains)
   * - Name is derived from company MDM data or user's name for personal emails
   * - Logo is looked up from MDM for corporate domains
   * - User is automatically added as owner
   * - Cannot specify owners/users lists
   *
   * For superusers:
   * - Can specify custom domain, name, logo_url
   * - Can specify owners and users lists
   * - Can control add_creator_as_owner flag
   */
  createWorkspace?: Maybe<CreateWorkspace>;
  /** Create a new custom knowledge area for a workspace. */
  createWorkspaceCustomKnowledge?: Maybe<CreateWorkspaceCustomKnowledge>;
  crmIngest?: Maybe<CrmIngest>;
  crmReIngest?: Maybe<CrmReIngest>;
  csvIngest?: Maybe<CsvIngest>;
  deleteAccount?: Maybe<DeleteAccount>;
  deleteAgentDefinition?: Maybe<DeleteAgentDefinition>;
  deleteAutomationRule?: Maybe<DeleteAutomationRule>;
  deleteBriefTemplate?: Maybe<DeleteBriefTemplate>;
  deleteCampaign?: Maybe<DeleteCampaign>;
  deleteClip?: Maybe<DeleteClip>;
  deleteContact?: Maybe<DeleteContact>;
  deleteDeal?: Maybe<DeleteDeal>;
  /**
   * Soft delete a deal field.
   * Note: This doesn't remove existing data in deal_info.properties.
   */
  deleteDealField?: Maybe<DeleteDealField>;
  deleteDealStage?: Maybe<DeleteDealStage>;
  deleteDomainAllowlist?: Maybe<DeleteDomainAllowlist>;
  deleteEmailTemplate?: Maybe<DeleteEmailTemplate>;
  deleteFile?: Maybe<DeleteFile>;
  deleteIngestionField?: Maybe<CrmDeleteIngestionField>;
  deleteList?: Maybe<DeleteList>;
  deleteListFolder?: Maybe<DeleteListFolder>;
  deleteNote?: Maybe<DeleteNote>;
  deleteOpenSearchItem?: Maybe<OpenSearchDeleteItem>;
  deletePipeline?: Maybe<DeletePipeline>;
  deleteProduct?: Maybe<DeleteProduct>;
  deleteReportDefinition?: Maybe<DeleteReportDefinition>;
  deleteSummaryTemplate?: Maybe<DeleteSummaryTemplate>;
  deleteUserGroup?: Maybe<DeleteUserGroup>;
  deleteUserRole?: Maybe<DeleteUserRole>;
  /**
   * Permanently delete (disable) a workspace — the Settings → Account → Danger
   * Zone flow. This is destructive and irreversible. Owner-only.
   *
   * It performs, in order:
   *   1. Marks the local subscription canceled and deactivates all CRM and user
   *      integrations.
   *   2. Marks the workspace inactive and soft-removes every membership so no
   *      one can log back into it (auth filters removed memberships already).
   *   3. Commits all of the above so the DB is in a consistent, disabled state.
   *   4. Cancels all scheduled recording bots for the workspace.
   *   5. Cancels the Stripe subscription / trial immediately — the irreversible
   *      external call is made LAST, after the commit, so a commit failure can
   *      never leave Stripe canceled while the workspace stays active.
   *   6. Logs the deletion to Slack.
   *
   * Cleanup failures (Stripe, bots) are logged but do not block the deletion —
   * the workspace is always disabled so the user can't get stuck in a
   * half-deleted state. When the Stripe cancellation fails, the Slack
   * notification reports `subscription_canceled: no` plus a Stripe deep-link so
   * ops can finish the cancellation manually.
   */
  deleteWorkspace?: Maybe<DeleteWorkspace>;
  /** Delete a custom knowledge area. */
  deleteWorkspaceCustomKnowledge?: Maybe<DeleteWorkspaceCustomKnowledge>;
  disconnectIntegration?: Maybe<DisconnectIntegration>;
  /**
   * Stop syncing (default), or also delete what this connection contributed (D12).
   *
   * Two operations behind one mutation because the screen has to offer both and say which: "stop
   * updating" and "remove what it told you" are different intentions, and a product offering only
   * the second loses history nobody asked to lose. Enabled agents that read this domain are NOT
   * disabled — their reads start answering "disconnected since …", which is an answer, where a
   * silently paused agent is the failure this layer exists to stop.
   */
  disconnectMcpConnection?: Maybe<DisconnectMcpConnection>;
  disconnectUserIntegration?: Maybe<DisconnectUserIntegration>;
  /** Hide it for the caller only. Others still see it until they act or dismiss. */
  dismissContactChangeSuggestion?: Maybe<ContactChangeResultType>;
  dismissDailyLead?: Maybe<DismissDailyLead>;
  dismissDealSuggestion?: Maybe<DismissDealSuggestion>;
  dismissTaskSuggestion?: Maybe<DismissTaskSuggestion>;
  editPipeline?: Maybe<EditPipeline>;
  /**
   * Copy-on-enable a seeded template: instantiate it as a workspace ``agent_definition``
   * (copying its curated prompt / tools / trigger / conditions) and activate its backing rule
   * in one call. Each call creates a fresh instance — edits never mutate the shared template,
   * and enabling twice yields two independent agents (guard client-side if you want one-per-
   * template). ``trigger`` optionally overrides the template's cadence/event; ``notifyTarget``
   * sets where it posts.
   */
  enableAgentTemplate?: Maybe<EnableAgentTemplate>;
  /**
   * Generate engagement brief for a specific template on-demand.
   *
   * When user switches templates in UI:
   * 1. Check if brief already exists for this engagement + template
   * 2. If exists, return it immediately
   * 3. If not, generate it using AI, save to DB, and return
   */
  generateBrief?: Maybe<GenerateBrief>;
  /**
   * Generate engagement summary for a specific template on-demand.
   *
   * When user switches templates in UI:
   * 1. Check if summary already exists for this engagement + template
   * 2. If exists, return it immediately
   * 3. If not, generate it using AI, save to DB, update deal fields, and return
   *
   * Deal field updates:
   * - Automatically updates deal fields from summary sections with crm_field mappings
   * - Uses LLM to intelligently merge old field values with new content
   * - Stores in MongoDB deal_info collection
   */
  generateSummary?: Maybe<GenerateSummary>;
  /**
   * Generate Intelligence section for a workspace: call Perplexity with the workspace's
   * domain, parse the response, and upsert the workspace_intelligence record.
   */
  generateWorkspaceIntelligence?: Maybe<GenerateWorkspaceIntelligence>;
  invalidateCache?: Maybe<InvalidateCache>;
  inviteUser?: Maybe<InviteUser>;
  /**
   * Mutation to join an existing workspace.
   *
   * The user must be eligible to join:
   * 1. User has a corporate email (not personal like gmail, yahoo, etc.)
   * 2. Their email domain must match the workspace domain
   * 3. The workspace must not have a 'single_shot' subscription
   */
  joinWorkspace?: Maybe<JoinWorkspace>;
  /**
   * Manually link or unlink an engagement and a deal. An escape hatch for when
   * the automatic engagement->deal association gets it wrong.
   */
  linkEngagementToDeal?: Maybe<LinkEngagementToDeal>;
  /**
   * Mark every unread row read.
   *
   * Takes no ids on purpose. The feed is paginated, so a client holding 20 rows cannot
   * name the other 37 — marking "all" from the client's list would leave a badge that
   * refuses to clear. One server-side UPDATE, served by idx__notification__unread.
   */
  markAllNotificationsRead?: Maybe<MarkAllNotificationsRead>;
  markFirstTimeNotificationsSent?: Maybe<MarkFirstTimeNotificationsSent>;
  /** Mark specific rows read. Returns the authoritative unread count. */
  markNotificationsRead?: Maybe<MarkNotificationsRead>;
  markNotificationsSeen?: Maybe<MarkNotificationsSeen>;
  mdmAttachImageFromUrl?: Maybe<MdmAttachImageFromUrl>;
  mdmCreateCompany?: Maybe<MdmCreateCompany>;
  mdmCreatePerson?: Maybe<MdmCreatePerson>;
  mdmDeleteDomainOverride?: Maybe<MdmDeleteDomainOverride>;
  /**
   * Push an MDM correction into the CRM records that already exist.
   *
   * Enrichment otherwise runs once, at record creation (`if is_new` in crud.py), so a contact
   * created in March carries what MDM said in March and today's fix never reaches it.
   *
   * Safe to run, and safe to run twice: this calls the same enrichment builders the ingestion
   * activities call, which skip any field a human, AI or formula authored, skip any field
   * sourced from HubSpot/Salesforce/CSV at apply time, and skip any field whose value has not
   * moved. A second run writes nothing.
   */
  mdmReEnrich?: Maybe<MdmReEnrich>;
  mdmReindex?: Maybe<MdmReindex>;
  mdmResolveSupersededOverride?: Maybe<MdmResolveSupersededOverride>;
  mdmRetireFieldOverride?: Maybe<MdmRetireFieldOverride>;
  mdmSetDomainOverride?: Maybe<MdmSetDomainOverride>;
  mdmSetFieldOverride?: Maybe<MdmSetFieldOverride>;
  mergeAccounts?: Maybe<MergeAccounts>;
  mergeContacts?: Maybe<MergeContacts>;
  moveDealsAndDeletePipeline?: Maybe<MoveDealsAndDeletePipeline>;
  pauseAutomationRule?: Maybe<PauseAutomationRule>;
  pauseCampaign?: Maybe<PauseCampaign>;
  /**
   * Purchase a one-time credit pack.
   *
   * If the workspace has a valid payment method on file, charges immediately
   * via Stripe Invoice API and records a PURCHASE event in the credit ledger.
   *
   * If no payment method, returns a Stripe Checkout URL for the user to complete payment.
   * The webhook handler records the PURCHASE event on payment completion.
   */
  purchaseCreditPack?: Maybe<CreditPackPurchaseResult>;
  recreateIndex?: Maybe<OpenSearchRecreateIndex>;
  /**
   * Record (or refresh) this device's push subscription.
   *
   * Upserts on `endpoint`: re-subscribing the same browser profile returns the same endpoint, so
   * calling this on page load must not accumulate rows. The upsert also reassigns the row to the
   * current user and clears `revoked_at` — on a shared machine a second person signing in should
   * receive their own pushes, not the first person's, and a device that comes back after being
   * revoked is alive again.
   */
  registerPushSubscription?: Maybe<RegisterPushSubscription>;
  removeEmailSuppression?: Maybe<RemoveEmailSuppressionMutation>;
  /**
   * Soft-delete a labeled association (both directed edges) and rebuild both entities'
   * denormalized `associations` arrays (plan PR 9). History is preserved in the collection.
   *
   * Accepts either canonical ddb ids or Postgres ids (see `SetEntityAssociation`).
   */
  removeEntityAssociation?: Maybe<RemoveEntityAssociation>;
  removeFavorite?: Maybe<RemoveFavorite>;
  removeFutureBots?: Maybe<RemoveFutureMeetingBot>;
  removeRecordsFromList?: Maybe<RemoveRecordsFromList>;
  removeUserGroupMembers?: Maybe<RemoveUserGroupMembers>;
  removeWorkspaceDomain?: Maybe<RemoveWorkspaceDomain>;
  /** Undo the caller's own "Not now". */
  reopenContactChangeSuggestion?: Maybe<ContactChangeResultType>;
  /**
   * Set the display order of custom knowledge areas for a workspace.
   *
   * Accepts the full ordered list of ids; rows not present in the list keep
   * their current position (defensive: avoid orphaning anything if the client
   * sends a partial list).
   */
  reorderWorkspaceCustomKnowledge?: Maybe<ReorderWorkspaceCustomKnowledge>;
  resumeCampaign?: Maybe<ResumeCampaign>;
  revokeDesktopToken?: Maybe<RevokeDesktopToken>;
  /**
   * Mutation to trigger AI custom field generation
   *
   * Input:
   * - workspace_id: Workspace ID (required)
   * - field_id: The custom field configuration ID (required)
   * - list_id: (Optional) List to fetch entity IDs from
   * - entity_ids: (Optional) Explicit array of entity IDs to process
   * - filter: (Optional) Filter dict to dynamically fetch entities matching criteria
   *
   * Must provide at least one of: list_id, entity_ids, or filter
   *
   * Returns the job execution for tracking progress
   */
  runAiCustomField?: Maybe<RunAiCustomField>;
  /**
   * Recompute one formula field across the workspace.
   *
   * Deliberately narrower than RunAiCustomField: no list_id, no entity_ids, no filter, no
   * row_limit. A formula is deterministic and free, so "recompute the subset the user is
   * looking at" has no cost advantage and would leave the rest of the column stale.
   */
  runFormulaField?: Maybe<RunFormulaField>;
  /**
   * Queue a run of one report. Any member who can VIEW the report may run
   * it (@require_workspace_data_write already excludes read-only members);
   * returns the queued ReportRun — the FE polls reportRun as block_results
   * fill progressively.
   */
  runReport?: Maybe<RunReport>;
  saveAiChatMessage?: Maybe<SaveAiChatMessage>;
  /**
   * Mark a daily lead as ``saved_as_contact`` and link it to the
   * Contact the frontend just created.
   *
   * The frontend orchestrates the two-step flow: it calls the existing
   * ``createContact`` mutation, then calls this mutation with the
   * returned ``ext_id``. Keeping the Contact-creation logic out of this
   * file means we never duplicate field-mapping behaviour that already
   * exists in the canonical mutation, and Contact creation continues to
   * benefit from CRM hooks (account upsert, source attribution, etc.).
   */
  saveDailyLeadAsContact?: Maybe<SaveDailyLeadAsContact>;
  sendContactToMailchimp?: Maybe<SendContact>;
  /**
   * Kick off a background Temporal workflow to send one or more emails.
   *
   * When send_individually=True:  one email is sent per entry in resolved_emails
   *                               (merge fields pre-resolved by the frontend).
   * When send_individually=False: one email is sent to all to_emails with optional
   *                               cc_emails / bcc_emails.
   */
  sendEmails?: Maybe<SendEmails>;
  /**
   * Send a one-off TEST of an async alert recipe to the CURRENT user only, so they can
   * see what it looks like without waiting for the real event. Only notification/email
   * recipes qualify; the recipient is always the acting user — never the rule's real
   * targets — so there's no deliverability/blast-radius risk. Replaces the misleading
   * match-count "test run" for alert recipes.
   */
  sendRuleTestMessage?: Maybe<SendRuleTestMessage>;
  /**
   * Write one sample notification into the CALLER'S OWN feed.
   *
   * Exists so the team can see a type's real row — icon, copy, CTA — in production before
   * its producer has ever fired. Without it, launch day is the first time anyone sees
   * these rendered against real data.
   *
   * Deliberately cannot target another user: it writes to `user.id` from the request, and
   * takes no recipient argument. Admin-gated because it writes rows, not because the rows
   * are dangerous.
   */
  sendTestNotification?: Maybe<SendTestNotification>;
  sendWelcomeEmail?: Maybe<SendWorkspaceWelcomeEmail>;
  setAgentEnabled?: Maybe<SetAgentEnabled>;
  /**
   * Replace all line items for a deal with the provided list.
   *
   * Passing an empty list removes all line items.
   * Existing line items for the deal are soft-deleted and replaced.
   */
  setDealLineItems?: Maybe<SetDealLineItems>;
  /**
   * Create or refresh a labeled association between two entities. Writes both directed
   * edges in the canonical `entity_association` collection and rebuilds each entity's
   * denormalized `associations` array (plan PR 9). Idempotent.
   *
   * Accepts either canonical ddb ids or Postgres ids (translated to ddb ids before storage
   * — see `_canonical_ddb_id_and_type`), so GraphQL clients that only hold Postgres ids can
   * call it directly.
   */
  setEntityAssociation?: Maybe<SetEntityAssociation>;
  /** Connect with a pasted access token, for a server with no authorization server. */
  setMcpConnectionToken?: Maybe<SetMcpConnectionToken>;
  setRecordGrants?: Maybe<SetRecordGrants>;
  setRecordGrantsBulk?: Maybe<SetRecordGrantsBulk>;
  setUserQuotas?: Maybe<SetUserQuotas>;
  /**
   * Attach, replace, or remove the file on a built-in intelligence section.
   *
   * Text is extracted inline (same pipeline as custom knowledge files) and
   * appended to that section in the AI prompt knowledge block.
   */
  setWorkspaceIntelligenceSectionFile?: Maybe<SetWorkspaceIntelligenceSectionFile>;
  shareEngagement?: Maybe<CreateEngagementShare>;
  startCampaign?: Maybe<StartCampaign>;
  /**
   * Start a 14-day Grande free trial for a workspace (no credit card required).
   *
   * Creates a Stripe customer if needed and a Stripe subscription in trialing state,
   * then persists the subscription in the DB. Idempotent if workspace already has
   * an active or trialing subscription (returns success without changing anything).
   */
  startFreeTrial?: Maybe<StartFreeTrialResponse>;
  syncBackEntity?: Maybe<CrmSyncBackEntity>;
  syncBackIngestionField?: Maybe<CrmSyncBackField>;
  /**
   * Manual Fireflies sync. When `lookbackDays` is omitted, reuse the import
   * window chosen at connect time; a new value is saved for next time.
   */
  syncFireflies?: Maybe<SyncFireflies>;
  /** Manual sync of the workspace Fireflies connection (admin only). */
  syncFirefliesWorkspace?: Maybe<SyncFirefliesWorkspace>;
  /**
   * Manual Granola sync. When `lookbackDays` is omitted, reuse the import
   * window the user chose at connect time (stored in the connection's watches).
   * Used by the Sync button on the connected Granola card.
   */
  syncGranola?: Maybe<SyncGranola>;
  /**
   * Dry-run a draft agent against a live model with stub tools (no CRM/Slack/Temporal side
   * effects) so an author can see the tool-call plan + whether the instruction is feasible BEFORE
   * saving/enabling. Read-only preview — off the real fire path. See
   * docs/archive/byoa-agents-ui-backend-contract.md.
   */
  testAgentDefinition?: Maybe<TestAgentDefinition>;
  /**
   * Blast-radius preview: evaluate the rule against current data and report what it
   * WOULD do, executing nothing. Resolves the rule's target entities via its stored
   * filter (empty filter = all entities of its object type), then describes each
   * matched entity's actions. Bounded by the sample cap so it stays cheap.
   */
  testRunAutomationRule?: Maybe<TestRunAutomationRule>;
  trackEngagementView?: Maybe<TrackEngagementViewType>;
  /**
   * Turn push off for this device.
   *
   * Soft: sets `revoked_at` rather than deleting, so the row stays auditable and the retention
   * pruner is the only thing that removes it. Scoped to the caller, so knowing someone else's
   * endpoint does not let you silence their phone.
   */
  unregisterPushSubscription?: Maybe<UnregisterPushSubscription>;
  updateAccount?: Maybe<UpdateAccount>;
  updateAgentDefinition?: Maybe<UpdateAgentDefinition>;
  updateAutoRecharge?: Maybe<UpdateAutoRechargePreferences>;
  updateAutomationRule?: Maybe<UpdateAutomationRule>;
  /** Update billing settings. */
  updateBillingSettings?: Maybe<UpdateBillingSettingsMutation>;
  updateBriefTemplate?: Maybe<UpdateBriefTemplate>;
  updateCampaign?: Maybe<UpdateCampaign>;
  updateClip?: Maybe<ClipType>;
  updateContact?: Maybe<UpdateContact>;
  /** Update credit transaction status and details. */
  updateCreditUsageLog?: Maybe<UpdateCreditUsageLogMutation>;
  updateDeal?: Maybe<UpdateDeal>;
  updateDealCreationFields?: Maybe<UpdateDealCreationFields>;
  /**
   * Update an existing deal field.
   * Note: field_name cannot be changed as it's used as the key in deal_info.properties.
   */
  updateDealField?: Maybe<UpdateDealField>;
  updateDealStage?: Maybe<UpdateDealStage>;
  /**
   * Set (or clear) the workspace default language.
   *
   * Admin-only: it changes what every member without a personal language
   * preference sees. Writes exactly one JSONB key so it never clobbers the rest
   * of the workspace preferences blob.
   */
  updateDefaultLanguage?: Maybe<UpdateWorkspaceDefaultLanguage>;
  /**
   * Set per-entity default record visibility (default-record-acl plan). Only
   * the supplied fields change. When record sharing is enabled, each CHANGED
   * entity kicks off the record_acl_backfill workflow, which restamps every
   * existing default-managed (acl_source != 'custom') record of that entity;
   * while sharing is off, values are stored and reconciled on enable.
   */
  updateDefaultRecordAcl?: Maybe<UpdateDefaultRecordAcl>;
  updateDomainAllowlist?: Maybe<UpdateDomainAllowlist>;
  updateEmailTemplate?: Maybe<UpdateEmailTemplate>;
  updateEmailVisibility?: Maybe<UpdateEmailVisibilityPreferences>;
  /**
   * Save a user's correction to a meeting summary (the meeting sheet's Summary tab).
   *
   * Writes only the summary text. It never re-runs deal-field updates from the edited
   * sections, and keeps the deal-field applied stamps, so the late-link reconciler's
   * "applied once" bookkeeping is unchanged. The doc is marked ``user_edited_at`` so a
   * later regeneration (save_engagement_summary_to_db) keeps the edit.
   *
   * Gated on the ``meeting-summary-edit`` workspace preference (default off).
   */
  updateEngagementSummary?: Maybe<UpdateEngagementSummary>;
  updateIngestionConfig?: Maybe<CrmUpdateIngestionConfig>;
  updateIngestionField?: Maybe<CrmUpdateIngestionField>;
  updateList?: Maybe<UpdateList>;
  updateListFolder?: Maybe<UpdateListFolder>;
  updateMeetingBot?: Maybe<UpdateMeetingBot>;
  updateMeetingRecording?: Maybe<UpdateMeetingRecording>;
  updateNote?: Maybe<UpdateNote>;
  updateNtfPreferences?: Maybe<UpdateNtfPreferences>;
  updatePcPreferences?: Maybe<UpdatePcPreferences>;
  updatePreferences?: Maybe<UpdateWorkspacePreferences>;
  updatePrivacy?: Maybe<UpdatePublicVisibilityPreferences>;
  updateProduct?: Maybe<UpdateProduct>;
  updateRecordSharing?: Maybe<UpdateRecordSharingPreferences>;
  updateReportDefinition?: Maybe<UpdateReportDefinition>;
  updateSummaryTemplate?: Maybe<UpdateSummaryTemplate>;
  updateTasksVisibility?: Maybe<UpdateTasksVisibilityPreferences>;
  updateUser?: Maybe<UpdateUser>;
  updateUserGroup?: Maybe<UpdateUserGroup>;
  /**
   * Set the signed-in user's language.
   *
   * Deliberately NOT a field on NTFPreferencesInput: that input has eight
   * required booleans, so folding language into it would force the language
   * picker to resubmit the whole notification form (and race anyone editing it).
   * A dedicated single-purpose mutation writes exactly one JSONB key.
   *
   * Authorized with require_workspace_membership rather than
   * require_workspace_data_write: this is a per-user display preference, not
   * workspace data, so read-only seats must be able to set their own language.
   */
  updateUserLanguage?: Maybe<UpdateUserLanguage>;
  updateUserList?: Maybe<UpdateUserList>;
  updateVcPreferences?: Maybe<UpdateVcPreferences>;
  updateWorkspace?: Maybe<UpdateWorkspace>;
  /** Update a custom knowledge area's name, content, or attached file. */
  updateWorkspaceCustomKnowledge?: Maybe<UpdateWorkspaceCustomKnowledge>;
  /** Update or create workspace intelligence. */
  updateWorkspaceIntelligence?: Maybe<UpdateWorkspaceIntelligence>;
  /**
   * Bring one starter-derived agent forward to its template's current revision.
   *
   * Applies only the fields the template moved and the author never edited; ``conflicts`` — where
   * both moved — are reported and left as the author wrote them unless ``includeConflicts`` is
   * set. That default is the whole point: a template change that silently reverted an author's
   * edits would be a worse failure than one that does nothing
   * (docs/reference/byoa-template-change-policy.md).
   *
   * Admin/owner-gated exactly like an edit, because that is what it is.
   */
  upgradeAgentFromTemplate?: Maybe<UpgradeAgentFromTemplate>;
  upsertAccount?: Maybe<UpsertAccount>;
  upsertContact?: Maybe<UpsertContact>;
  upsertDeal?: Maybe<UpsertDeal>;
  userIntegrationSync?: Maybe<UserIntegrationSync>;
};


export type MutationsAcceptContactChangeSuggestionArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  createCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  mode: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationsAcceptDealSuggestionArgs = {
  input: AcceptDealSuggestionInput;
};


export type MutationsAcceptTaskSuggestionArgs = {
  input: AcceptTaskSuggestionInput;
};


export type MutationsActivateAutomationRuleArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsAddAiChatMessageFeedbackArgs = {
  input: AddAiChatMessageFeedbackInput;
};


export type MutationsAddEmailSuppressionArgs = {
  email: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsAddFavoriteArgs = {
  input: AddFavoriteInput;
};


export type MutationsAddRecordsToListArgs = {
  input: AddRecordsToListInput;
};


export type MutationsAddUserGroupMembersArgs = {
  groupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsAddUserManagerArgs = {
  input: AddUserManagerInput;
};


export type MutationsAddWorkspaceDomainArgs = {
  input: AddWorkspaceDomainInput;
};


export type MutationsAuthorPolicyArgs = {
  input: AuthorPolicyInput;
};


export type MutationsBuildAccountListArgs = {
  input: BuildAccountListInput;
};


export type MutationsBuildContactListArgs = {
  input: BuildContactListInput;
};


export type MutationsBulkAssignAccountOwnerArgs = {
  input: BulkAssignOwnerInput;
};


export type MutationsBulkAssignOwnerArgs = {
  input: BulkAssignOwnerInput;
};


export type MutationsCheckFirefliesKeyArgs = {
  apiKey: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsCompleteMcpConnectionArgs = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsCompleteSlackInstallArgs = {
  input: CompleteSlackInstallInput;
};


export type MutationsConfirmConnectionArgs = {
  connectionId: Scalars['ID']['input'];
  domainMap?: InputMaybe<Scalars['JSONString']['input']>;
  outcome: ConnectionConfirmationOutcome;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsConnectFirefliesArgs = {
  apiKey: Scalars['String']['input'];
  keepCoffeeRecording?: InputMaybe<Scalars['Boolean']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsConnectFirefliesWorkspaceArgs = {
  apiKey: Scalars['String']['input'];
  keepCoffeeRecording?: InputMaybe<Scalars['Boolean']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsConnectGranolaArgs = {
  apiKey: Scalars['String']['input'];
  keepCoffeeRecording?: InputMaybe<Scalars['Boolean']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsConnectMcpServerArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  serverUrl: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationsCreateAgentDefinitionArgs = {
  input: CreateAgentDefinitionInput;
};


export type MutationsCreateAiChatConversationArgs = {
  input: CreateAiChatConversationInput;
};


export type MutationsCreateAutomationRuleArgs = {
  input: CreateAutomationRuleInput;
};


export type MutationsCreateBadDataReportArgs = {
  input: CreateBadDataReportInput;
};


export type MutationsCreateBillingPortalSessionArgs = {
  input: CreateBillingPortalSessionInput;
};


export type MutationsCreateBriefTemplateArgs = {
  input: CreateBriefTemplateInput;
};


export type MutationsCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationsCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


export type MutationsCreateClipArgs = {
  endSec: Scalars['Float']['input'];
  engagementId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startSec: Scalars['Float']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationsCreateCustomerSessionArgs = {
  input: CreateCustomerSessionInput;
};


export type MutationsCreateDealArgs = {
  input: CreateDealInput;
};


export type MutationsCreateDealFieldArgs = {
  input: CreateDealFieldInput;
};


export type MutationsCreateDealStageArgs = {
  input: CreateDealStageInput;
};


export type MutationsCreateDefaultDealStagesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsCreateDefaultEmailTemplatesArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type MutationsCreateDesktopPairingCodeArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationsCreateDomainAllowlistArgs = {
  input: CreateDomainAllowlistInput;
};


export type MutationsCreateEmailTemplateArgs = {
  input: CreateEmailTemplateInput;
};


export type MutationsCreateFileArgs = {
  input: CreateFileInput;
};


export type MutationsCreateIngestionFieldArgs = {
  args: CreateIngestionFieldInput;
};


export type MutationsCreateListArgs = {
  input: CreateListInput;
};


export type MutationsCreateListFolderArgs = {
  input: CreateListFolderInput;
};


export type MutationsCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationsCreatePipelineArgs = {
  input: CreatePipelineInput;
};


export type MutationsCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationsCreateReportDefinitionArgs = {
  input: CreateReportDefinitionInput;
};


export type MutationsCreateSummaryTemplateArgs = {
  input: CreateSummaryTemplateInput;
};


export type MutationsCreateUserGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  memberUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationsCreateWebNotificationArgs = {
  dedupeKey?: InputMaybe<Scalars['String']['input']>;
  fallbackBody?: InputMaybe<Scalars['String']['input']>;
  fallbackTitle: Scalars['String']['input'];
  params?: InputMaybe<Scalars['JSONString']['input']>;
  target?: InputMaybe<Scalars['JSONString']['input']>;
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationsCreateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


export type MutationsCreateWorkspaceCustomKnowledgeArgs = {
  input: CreateWorkspaceCustomKnowledgeInput;
};


export type MutationsCrmIngestArgs = {
  platform: CrmIngestionPlatform;
  useJava?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsCrmReIngestArgs = {
  ignoreUnchanged?: InputMaybe<Scalars['Boolean']['input']>;
  runId: Scalars['Int']['input'];
  useDownloadedData?: InputMaybe<Scalars['Boolean']['input']>;
  useJava?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsCsvIngestArgs = {
  input: CsvIngestInput;
};


export type MutationsDeleteAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteAgentDefinitionArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsDeleteAutomationRuleArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsDeleteBriefTemplateArgs = {
  input: DeleteBriefTemplateInput;
};


export type MutationsDeleteCampaignArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsDeleteClipArgs = {
  id: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsDeleteContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteDealArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteDealFieldArgs = {
  input: DeleteDealFieldInput;
};


export type MutationsDeleteDealStageArgs = {
  input: DeleteDealStageInput;
};


export type MutationsDeleteDomainAllowlistArgs = {
  input: DeleteDomainAllowlistInput;
};


export type MutationsDeleteEmailTemplateArgs = {
  input: DeleteEmailTemplateInput;
};


export type MutationsDeleteFileArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationsDeleteIngestionFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteListArgs = {
  input: DeleteListInput;
};


export type MutationsDeleteListFolderArgs = {
  input: DeleteListFolderInput;
};


export type MutationsDeleteNoteArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationsDeleteOpenSearchItemArgs = {
  input?: InputMaybe<OpenSearchDeleteItemInput>;
};


export type MutationsDeletePipelineArgs = {
  input: DeletePipelineInput;
};


export type MutationsDeleteProductArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationsDeleteReportDefinitionArgs = {
  input: DeleteReportDefinitionInput;
};


export type MutationsDeleteSummaryTemplateArgs = {
  input: DeleteSummaryTemplateInput;
};


export type MutationsDeleteUserGroupArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationsDeleteUserRoleArgs = {
  input: DeleteUserRoleInput;
};


export type MutationsDeleteWorkspaceArgs = {
  input: DeleteWorkspaceInput;
};


export type MutationsDeleteWorkspaceCustomKnowledgeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDisconnectIntegrationArgs = {
  platform?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsDisconnectMcpConnectionArgs = {
  connectionId: Scalars['ID']['input'];
  deleteData?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsDisconnectUserIntegrationArgs = {
  platform?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsDismissContactChangeSuggestionArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationsDismissDailyLeadArgs = {
  input: _MutationInput;
};


export type MutationsDismissDealSuggestionArgs = {
  input: AcceptDealSuggestionInput;
};


export type MutationsDismissTaskSuggestionArgs = {
  input: AcceptTaskSuggestionInput;
};


export type MutationsEditPipelineArgs = {
  input: EditPipelineInput;
};


export type MutationsEnableAgentTemplateArgs = {
  notifyTarget?: InputMaybe<Scalars['String']['input']>;
  templateName: Scalars['String']['input'];
  trigger?: InputMaybe<AgentTriggerInput>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsGenerateBriefArgs = {
  input: GenerateBriefInput;
};


export type MutationsGenerateSummaryArgs = {
  input: GenerateSummaryInput;
};


export type MutationsGenerateWorkspaceIntelligenceArgs = {
  input: GenerateWorkspaceIntelligenceInput;
};


export type MutationsInvalidateCacheArgs = {
  args: InvalidateCacheInput;
};


export type MutationsInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationsJoinWorkspaceArgs = {
  input: JoinWorkspaceInput;
};


export type MutationsLinkEngagementToDealArgs = {
  dealId: Scalars['ID']['input'];
  engagementId: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsMarkAllNotificationsReadArgs = {
  workspaceId: Scalars['String']['input'];
};


export type MutationsMarkFirstTimeNotificationsSentArgs = {
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationsMarkNotificationsReadArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationsMarkNotificationsSeenArgs = {
  workspaceId: Scalars['String']['input'];
};


export type MutationsMdmAttachImageFromUrlArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationsMdmCreateCompanyArgs = {
  input: MdmCreateCompanyInput;
};


export type MutationsMdmCreatePersonArgs = {
  input: MdmCreatePersonInput;
};


export type MutationsMdmDeleteDomainOverrideArgs = {
  domain: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsMdmReEnrichArgs = {
  input: MdmReEnrichInput;
};


export type MutationsMdmReindexArgs = {
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
};


export type MutationsMdmResolveSupersededOverrideArgs = {
  action: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  overrideId: Scalars['ID']['input'];
};


export type MutationsMdmRetireFieldOverrideArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  overrideId: Scalars['ID']['input'];
  restoreVendorValue?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsMdmSetDomainOverrideArgs = {
  input: MdmSetDomainOverrideInput;
};


export type MutationsMdmSetFieldOverrideArgs = {
  input: MdmSetFieldOverrideInput;
};


export type MutationsMergeAccountsArgs = {
  args: MergeAccountsInput;
};


export type MutationsMergeContactsArgs = {
  args: MergeContactsInput;
};


export type MutationsMoveDealsAndDeletePipelineArgs = {
  input: MoveDealsAndDeletePipelineInput;
};


export type MutationsPauseAutomationRuleArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsPauseCampaignArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsPurchaseCreditPackArgs = {
  input: PurchaseCreditPackInput;
};


export type MutationsRecreateIndexArgs = {
  input?: InputMaybe<RecreateIndexInput>;
};


export type MutationsRegisterPushSubscriptionArgs = {
  auth: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationsRemoveEmailSuppressionArgs = {
  email: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsRemoveEntityAssociationArgs = {
  fromId: Scalars['String']['input'];
  fromType?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  toId: Scalars['String']['input'];
  toType?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsRemoveFavoriteArgs = {
  input: RemoveFavoriteInput;
};


export type MutationsRemoveFutureBotsArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsRemoveRecordsFromListArgs = {
  input: RemoveRecordsFromListInput;
};


export type MutationsRemoveUserGroupMembersArgs = {
  groupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsRemoveWorkspaceDomainArgs = {
  input: RemoveWorkspaceDomainInput;
};


export type MutationsReopenContactChangeSuggestionArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationsReorderWorkspaceCustomKnowledgeArgs = {
  input: ReorderWorkspaceCustomKnowledgeInput;
};


export type MutationsResumeCampaignArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsRevokeDesktopTokenArgs = {
  input: RevokeDesktopTokenInput;
};


export type MutationsRunAiCustomFieldArgs = {
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId: Scalars['Int']['input'];
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  listId?: InputMaybe<Scalars['Int']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  rowLimit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsRunFormulaFieldArgs = {
  fieldId: Scalars['Int']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsRunReportArgs = {
  input: RunReportInput;
};


export type MutationsSaveAiChatMessageArgs = {
  input: SaveAiChatMessageInput;
};


export type MutationsSaveDailyLeadAsContactArgs = {
  input: _SaveAsContactInput;
};


export type MutationsSendContactToMailchimpArgs = {
  contactIds: Array<InputMaybe<Scalars['ID']['input']>>;
  listId: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsSendEmailsArgs = {
  attachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bccEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  ccEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromEmail: Scalars['String']['input'];
  fromName: Scalars['String']['input'];
  resolvedEmails?: InputMaybe<Array<InputMaybe<ResolvedEmailInput>>>;
  sendIndividually: Scalars['Boolean']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  toEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsSendRuleTestMessageArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsSendTestNotificationArgs = {
  type: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationsSendWelcomeEmailArgs = {
  input: SendWorkspaceWelcomeEmailInput;
};


export type MutationsSetAgentEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsSetDealLineItemsArgs = {
  dealId: Scalars['String']['input'];
  lineItems: Array<LineItemInput>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsSetEntityAssociationArgs = {
  input: SetAssociationInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsSetMcpConnectionTokenArgs = {
  serverUrl: Scalars['String']['input'];
  token: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsSetRecordGrantsArgs = {
  grants: Array<RecordGrantInput>;
  recordId: Scalars['String']['input'];
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  userGrants?: InputMaybe<Array<RecordUserGrantInput>>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsSetRecordGrantsBulkArgs = {
  grants: Array<RecordGrantInput>;
  recordIds: Array<Scalars['String']['input']>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  userGrants?: InputMaybe<Array<RecordUserGrantInput>>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsSetUserQuotasArgs = {
  quotas: Array<UserQuotaInput>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsSetWorkspaceIntelligenceSectionFileArgs = {
  input: SetWorkspaceIntelligenceSectionFileInput;
};


export type MutationsShareEngagementArgs = {
  engagementId: Scalars['String']['input'];
  notifyOnView?: InputMaybe<Scalars['Boolean']['input']>;
  summaryTemplateId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsStartCampaignArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsStartFreeTrialArgs = {
  input: StartFreeTrialInput;
};


export type MutationsSyncBackEntityArgs = {
  args: CreateSyncBackEntityInput;
};


export type MutationsSyncBackIngestionFieldArgs = {
  args: CreateSyncBackFieldInput;
};


export type MutationsSyncFirefliesArgs = {
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsSyncFirefliesWorkspaceArgs = {
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsSyncGranolaArgs = {
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsTestAgentDefinitionArgs = {
  input: TestAgentDefinitionInput;
};


export type MutationsTestRunAutomationRuleArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsTrackEngagementViewArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationsUnregisterPushSubscriptionArgs = {
  endpoint: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationsUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationsUpdateAgentDefinitionArgs = {
  input: UpdateAgentDefinitionInput;
};


export type MutationsUpdateAutoRechargeArgs = {
  input: UpdateAutoRechargeInput;
};


export type MutationsUpdateAutomationRuleArgs = {
  input: UpdateAutomationRuleInput;
};


export type MutationsUpdateBillingSettingsArgs = {
  input: UpdateBillingSettingsInput;
};


export type MutationsUpdateBriefTemplateArgs = {
  input: UpdateBriefTemplateInput;
};


export type MutationsUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationsUpdateClipArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationsUpdateCreditUsageLogArgs = {
  input: UpdateCreditUsageLogInput;
};


export type MutationsUpdateDealArgs = {
  input: UpdateDealInput;
};


export type MutationsUpdateDealCreationFieldsArgs = {
  fields: Array<InputMaybe<DealCreationFieldConfigInput>>;
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdateDealFieldArgs = {
  input: UpdateDealFieldInput;
};


export type MutationsUpdateDealStageArgs = {
  input: UpdateDealStageInput;
};


export type MutationsUpdateDefaultLanguageArgs = {
  input: UpdateWorkspaceDefaultLanguageInput;
};


export type MutationsUpdateDefaultRecordAclArgs = {
  input: DefaultRecordAclInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdateDomainAllowlistArgs = {
  input: UpdateDomainAllowlistInput;
};


export type MutationsUpdateEmailTemplateArgs = {
  input: UpdateEmailTemplateInput;
};


export type MutationsUpdateEmailVisibilityArgs = {
  input: EmailVisibilityInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdateEngagementSummaryArgs = {
  input: UpdateEngagementSummaryInput;
};


export type MutationsUpdateIngestionConfigArgs = {
  args: UpdateCrmIngestionConfigInput;
};


export type MutationsUpdateIngestionFieldArgs = {
  args: Array<InputMaybe<UpdateIngestionFieldInput>>;
};


export type MutationsUpdateListArgs = {
  input: UpdateListInput;
};


export type MutationsUpdateListFolderArgs = {
  input: UpdateListFolderInput;
};


export type MutationsUpdateMeetingBotArgs = {
  action: Scalars['String']['input'];
  id: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationsUpdateMeetingRecordingArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  override?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationsUpdateNtfPreferencesArgs = {
  input: NtfPreferencesInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdatePcPreferencesArgs = {
  input: PcPreferencesInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdatePreferencesArgs = {
  input: UpdateWorkspacePreferencesInput;
};


export type MutationsUpdatePrivacyArgs = {
  input: PublicVisibilityInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationsUpdateRecordSharingArgs = {
  input: RecordSharingInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdateReportDefinitionArgs = {
  input: UpdateReportDefinitionInput;
};


export type MutationsUpdateSummaryTemplateArgs = {
  input: UpdateSummaryTemplateInput;
};


export type MutationsUpdateTasksVisibilityArgs = {
  input: TasksVisibilityInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationsUpdateUserGroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdateUserLanguageArgs = {
  language: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdateUserListArgs = {
  input: UpdateUserListInput;
};


export type MutationsUpdateVcPreferencesArgs = {
  input: VcPreferencesInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationsUpdateWorkspaceArgs = {
  input: UpdateWorkspaceInput;
};


export type MutationsUpdateWorkspaceCustomKnowledgeArgs = {
  input: UpdateWorkspaceCustomKnowledgeInput;
};


export type MutationsUpdateWorkspaceIntelligenceArgs = {
  input: UpdateWorkspaceIntelligenceInput;
};


export type MutationsUpgradeAgentFromTemplateArgs = {
  id: Scalars['ID']['input'];
  includeConflicts?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type MutationsUpsertAccountArgs = {
  input: UpsertAccountInput;
};


export type MutationsUpsertContactArgs = {
  input: UpsertContactInput;
};


export type MutationsUpsertDealArgs = {
  input: UpsertDealInput;
};


export type MutationsUserIntegrationSyncArgs = {
  platform: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type NtfPreferencesInput = {
  actionItemsDue: Scalars['Boolean']['input'];
  closeDateInPast: Scalars['Boolean']['input'];
  deliveryMethod?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalMeetings: Scalars['Boolean']['input'];
  fewContacts: Scalars['Boolean']['input'];
  followUpEmails: Scalars['Boolean']['input'];
  noActivity: Scalars['Boolean']['input'];
  noNextSteps: Scalars['Boolean']['input'];
  notificationChannels?: InputMaybe<Scalars['JSONString']['input']>;
  suggestedChanges: Scalars['Boolean']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type NextLastActivityResponse = {
  __typename?: 'NextLastActivityResponse';
  response?: Maybe<ActivityDetails>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type Note = Node & {
  __typename?: 'Note';
  accounts?: Maybe<Array<Maybe<Account>>>;
  aiGenerated?: Maybe<Scalars['Boolean']['output']>;
  aiNotesContent?: Maybe<Scalars['JSONString']['output']>;
  blocks?: Maybe<Scalars['JSONString']['output']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ddbAccountIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ddbContactIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ddbDealIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ddbEngagementIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deals?: Maybe<Array<Maybe<Deal>>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  engagements?: Maybe<Array<Maybe<Engagement>>>;
  id: Scalars['ID']['output'];
  primaryAssociation?: Maybe<NoteAssociation>;
  priority?: Maybe<NotePriorityEnum>;
  privacy?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<NoteStatusEnum>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NoteTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type NoteAssociation = Account | Contact | Deal;

export type NoteConnection = {
  __typename?: 'NoteConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NoteEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Note` and its cursor. */
export type NoteEdge = {
  __typename?: 'NoteEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<Note>;
};

export type NoteFilter = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dueDateAfter?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateBefore?: InputMaybe<Scalars['DateTime']['input']>;
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  hasMeaningfulContent?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<NoteStatusEnum>;
  type?: InputMaybe<NoteTypeEnum>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** An enumeration. */
export enum NotePriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** An enumeration. */
export enum NoteStatusEnum {
  Completed = 'COMPLETED',
  Todo = 'TODO'
}

/** An enumeration. */
export enum NoteTypeEnum {
  Note = 'NOTE',
  Task = 'TASK'
}

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  nodes?: Maybe<Array<Maybe<NotificationType>>>;
};

export type NotificationEmailRecipient = {
  __typename?: 'NotificationEmailRecipient';
  user?: Maybe<GraphQlUser>;
  workspace?: Maybe<Workspace>;
  workspaceId: Scalars['Int']['output'];
};

export type NotificationType = {
  __typename?: 'NotificationType';
  createTs?: Maybe<Scalars['DateTime']['output']>;
  fallbackBody?: Maybe<Scalars['String']['output']>;
  fallbackTitle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  params?: Maybe<Scalars['JSONString']['output']>;
  readTs?: Maybe<Scalars['DateTime']['output']>;
  target?: Maybe<Scalars['JSONString']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  viewedTs?: Maybe<Scalars['DateTime']['output']>;
};

export type OpenSearchDeleteItem = {
  __typename?: 'OpenSearchDeleteItem';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OpenSearchDeleteItemInput = {
  index: IngestionIndexEnum;
  itemId: Scalars['String']['input'];
};

export type OpenSearchRecreateIndex = {
  __typename?: 'OpenSearchRecreateIndex';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PcPreferencesInput = {
  pcContactsAccountsFromEmails: Scalars['Boolean']['input'];
  pcContactsAccountsFromMeetings: Scalars['Boolean']['input'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PauseAutomationRule = {
  __typename?: 'PauseAutomationRule';
  rule?: Maybe<AutomationRule>;
};

export type PauseCampaign = {
  __typename?: 'PauseCampaign';
  campaign?: Maybe<Campaign>;
};

/** Payment method status for a workspace. */
export type PaymentMethodStatus = {
  __typename?: 'PaymentMethodStatus';
  /** Whether workspace has valid payment method */
  hasValidCard: Scalars['Boolean']['output'];
};

export type Person = {
  __typename?: 'Person';
  companyDomain?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createTs?: Maybe<Scalars['DateTime']['output']>;
  curatedAt?: Maybe<Scalars['DateTime']['output']>;
  emailLastVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  jobIsCurrent?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedinProfileUrl?: Maybe<Scalars['String']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<PersonProperties>;
  source?: Maybe<Scalars['String']['output']>;
  sourceCompanyId?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  updateTs?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PersonProperties = {
  __typename?: 'PersonProperties';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  jobFunction?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  linkedinProfileUrl?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  seniority?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type Pipeline = Node & {
  __typename?: 'Pipeline';
  createTs: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  fromExternalSource?: Maybe<Scalars['Boolean']['output']>;
  hasActiveDeals?: Maybe<Scalars['Boolean']['output']>;
  i18nKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includeInForecast: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sourceIds: Scalars['JSONString']['output'];
  stages?: Maybe<DealStageConnection>;
  updateTs: Scalars['DateTime']['output'];
  workspaceId: Scalars['Int']['output'];
};


export type PipelineStagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PipelineConnection = {
  __typename?: 'PipelineConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PipelineEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Pipeline` and its cursor. */
export type PipelineEdge = {
  __typename?: 'PipelineEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Pipeline>;
};

export type PipelineFilter = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Open-pipeline health with per-stage conversion. */
export type PipelineHealthReport = {
  __typename?: 'PipelineHealthReport';
  funnel: Array<ReportStageFunnelEntry>;
  totalOpenAmount: Scalars['Float']['output'];
  totalOpenCount: Scalars['Int']['output'];
  /** True when the stage-history metrics are incomplete: the scoped deal set exceeded the OpenSearch 10k result window, the snapshot scan hit its row cap, or the history pass failed and was skipped. Funnel counts and amounts are never truncated — they come from an aggregation, not a document scan. */
  truncated: Scalars['Boolean']['output'];
  /** Sum of weightedAmount across stages that have a configured probability. Stages without one contribute 0, so this is a lower bound. */
  weightedPipeline: Scalars['Float']['output'];
};

/** An enumeration. */
export enum PipelineSortEnum {
  CreateTsAsc = 'CREATE_TS_ASC',
  CreateTsDesc = 'CREATE_TS_DESC',
  DeletedAsc = 'DELETED_ASC',
  DeletedDesc = 'DELETED_DESC',
  I18NKeyAsc = 'I18N_KEY_ASC',
  I18NKeyDesc = 'I18N_KEY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IncludeInForecastAsc = 'INCLUDE_IN_FORECAST_ASC',
  IncludeInForecastDesc = 'INCLUDE_IN_FORECAST_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  SourceIdsAsc = 'SOURCE_IDS_ASC',
  SourceIdsDesc = 'SOURCE_IDS_DESC',
  UpdateTsAsc = 'UPDATE_TS_ASC',
  UpdateTsDesc = 'UPDATE_TS_DESC',
  WorkspaceIdAsc = 'WORKSPACE_ID_ASC',
  WorkspaceIdDesc = 'WORKSPACE_ID_DESC'
}

export type PipelineStageInput = {
  color: Scalars['String']['input'];
  colorCode: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  isLost: Scalars['Boolean']['input'];
  isWon: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  probability: Scalars['Float']['input'];
};

/**
 * What one natural-language policy request did.
 *
 * ``output`` is the agent's own account of it — what the builder shows the person. ``error``
 * carries a *structural* refusal (not entitled, not an admin, no tools) so a request someone can
 * fix themselves comes back as an answer rather than a 500, the same contract testAgentDefinition
 * already uses.
 */
export type PolicyRequestResult = {
  __typename?: 'PolicyRequestResult';
  error?: Maybe<Scalars['String']['output']>;
  iterations: Scalars['Int']['output'];
  output: Scalars['String']['output'];
  stopReason?: Maybe<Scalars['String']['output']>;
  toolsCalled: Array<Maybe<Scalars['String']['output']>>;
};

export type PostalCode = Node & {
  __typename?: 'PostalCode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type PostalCodeConnection = {
  __typename?: 'PostalCodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PostalCodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PostalCode` and its cursor. */
export type PostalCodeEdge = {
  __typename?: 'PostalCodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PostalCode>;
};

export type PostalCodeFilter = {
  search: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type Preferences = {
  __typename?: 'Preferences';
  preferences?: Maybe<Scalars['JSONString']['output']>;
};

/** Result from previewing AI field generation */
export type PreviewAiFieldResult = {
  __typename?: 'PreviewAiFieldResult';
  previewResults: Array<Maybe<AiFieldPreviewResult>>;
  /** Total entities that would be processed */
  totalEntitiesFound: Scalars['Int']['output'];
};

export type PreviewFormulaFieldResult = {
  __typename?: 'PreviewFormulaFieldResult';
  /** Set when the expression itself is invalid (parse/validation failure). */
  error?: Maybe<Scalars['String']['output']>;
  previewResults?: Maybe<Array<Maybe<FormulaPreviewEntry>>>;
  totalEntitiesFound?: Maybe<Scalars['Int']['output']>;
};

/** Pricing tier enum. */
export enum PricingTier {
  Free = 'free',
  Grande = 'grande',
  SingleShot = 'single_shot',
  Tall = 'tall',
  Venti = 'venti'
}

export type Product = {
  __typename?: 'Product';
  customProperties?: Maybe<Scalars['GenericScalar']['output']>;
  id: Scalars['ID']['output'];
  properties?: Maybe<ProductProperties>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type ProductProperties = {
  __typename?: 'ProductProperties';
  description?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type PublicVisibilityInput = {
  publicVisibility: Scalars['Boolean']['input'];
};

/** Input type for purchasing a credit pack. */
export type PurchaseCreditPackInput = {
  /** Credit pack ID (e.g. pack_5000) */
  packId: Scalars['String']['input'];
  /** Optional redirect URL after checkout (for no-card path) */
  successUrl?: InputMaybe<Scalars['String']['input']>;
  /** Workspace ID */
  workspaceId: Scalars['ID']['input'];
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accounts?: Maybe<AccountConnection>;
  activeAiExecutions?: Maybe<Array<Maybe<AiJobExecutionType>>>;
  agentDefinition?: Maybe<AgentDefinition>;
  agentDefinitions?: Maybe<Array<Maybe<AgentDefinition>>>;
  agentPreviewProgress?: Maybe<AgentPreviewProgress>;
  agentRuns?: Maybe<Array<Maybe<AgentRun>>>;
  agentTemplateDrift?: Maybe<Array<Maybe<AgentTemplateDrift>>>;
  agentTemplates?: Maybe<Array<Maybe<AgentTemplate>>>;
  aiChatConversations?: Maybe<Array<Maybe<AiChatConversationType>>>;
  aiChatMessages?: Maybe<Array<Maybe<AiChatMessageType>>>;
  aiJobExecution?: Maybe<AiJobExecutionType>;
  automationRule?: Maybe<AutomationRule>;
  automationRules?: Maybe<Array<Maybe<AutomationRule>>>;
  /** List of workspaces the current user can join based on email domain */
  availableWorkspaces?: Maybe<Array<Maybe<Workspace>>>;
  /** Get current billing settings */
  billingSettings?: Maybe<BillingSettings>;
  briefTemplates?: Maybe<BriefTemplateConnection>;
  /** Health of BYOA agents (per agent) for paid+trial workspaces (superuser only) */
  byoaAgentHealth?: Maybe<Array<Maybe<ByoaAgentHealth>>>;
  /** Health of BYOA agent runs (per run) for paid+trial workspaces (superuser only) */
  byoaAgentRunHealth?: Maybe<Array<Maybe<ByoaAgentRunHealth>>>;
  campaign?: Maybe<Campaign>;
  campaignStepRecipients?: Maybe<Array<Maybe<CampaignRecipient>>>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  clip?: Maybe<ClipType>;
  clipShare?: Maybe<ClipShareType>;
  clips?: Maybe<Array<Maybe<ClipType>>>;
  contact?: Maybe<Contact>;
  contactChangeImpact?: Maybe<ContactChangeImpactType>;
  contactChangeSuggestion?: Maybe<ContactChangeSuggestionType>;
  contacts?: Maybe<ContactConnection>;
  /** Get current credit to USD exchange rate (user-facing) */
  creditExchangeRate?: Maybe<CreditExchangeRate>;
  creditResponse?: Maybe<CreditResponse>;
  /** List credit transactions for admin */
  creditUsageLogs?: Maybe<CreditUsageLogConnection>;
  /** Get agent credit usage summary for the current billing period */
  creditUsageSummary?: Maybe<CreditUsageSummary>;
  /** Get counts of CRM objects (contacts, accounts, deals) for a workspace */
  crmDataCounts?: Maybe<CrmDataCounts>;
  crmGraderReport?: Maybe<CrmReport>;
  crmIngestionAvailableFields?: Maybe<Array<Maybe<CrmIngestionAvailableField>>>;
  crmIngestionConfig?: Maybe<CrmIngestionConfigObject>;
  crmIngestionFields?: Maybe<CrmIngestionFieldConnection>;
  crmIngestionRun?: Maybe<CrmIngestionRun>;
  crmIngestionRuns?: Maybe<CrmIngestionRunConnection>;
  crmIngestionSyncLog?: Maybe<CrmIngestionRunConnection>;
  /** Health of HubSpot/Salesforce CRM integrations for paid+trial workspaces (superuser only) */
  crmIntegrationHealth?: Maybe<Array<Maybe<CrmIntegrationHealth>>>;
  crmOauthUrl?: Maybe<Scalars['String']['output']>;
  crmPreviewDealStages?: Maybe<Array<Maybe<CrmPreviewDealStage>>>;
  /** Health of MANUAL_CSV imports (per import) for paid+trial workspaces (superuser only) */
  csvImportHealth?: Maybe<Array<Maybe<CsvImportHealth>>>;
  dailyLeads?: Maybe<DailyLeadConnection>;
  deal?: Maybe<Deal>;
  dealCreationFields?: Maybe<Array<Maybe<DealCreationField>>>;
  dealFields?: Maybe<DealFieldConnection>;
  dealLineItems?: Maybe<Array<Maybe<LineItem>>>;
  dealStages?: Maybe<DealStageConnection>;
  dealSuggestion?: Maybe<DealSuggestion>;
  dealSuggestions?: Maybe<DealSuggestionConnection>;
  deals?: Maybe<DealConnection>;
  dealsCompareAggregates?: Maybe<DealAggregateResult>;
  desktopTokens?: Maybe<DesktopTokenConnection>;
  domainAllowlist?: Maybe<DomainAllowlist>;
  domainAllowlists?: Maybe<Array<Maybe<DomainAllowlist>>>;
  emailTemplates?: Maybe<Array<EmailTemplateClass>>;
  engagement?: Maybe<Engagement>;
  engagementBasic?: Maybe<EngagementBasicType>;
  engagements?: Maybe<EngagementConnection>;
  /** One field's change history on one record, newest first, sanitized by the field-history policy (automated rows, no-ops, bursts and flapping hidden). */
  fieldHistory: FieldHistory;
  file?: Maybe<File>;
  files?: Maybe<FileConnection>;
  findCompanyByDomain?: Maybe<Company>;
  findCompanyByLinkedinUrl?: Maybe<Company>;
  findPersonByLinkedinUrl?: Maybe<Person>;
  generateFormula?: Maybe<GenerateFormulaResult>;
  getAccountByDomain?: Maybe<Account>;
  getAccountByLinkedinUrl?: Maybe<Account>;
  getAccountsByName?: Maybe<Array<Maybe<Account>>>;
  getContactByEmail?: Maybe<Contact>;
  getContactByLinkedinUrl?: Maybe<Contact>;
  gongWebhookUrl?: Maybe<Scalars['String']['output']>;
  googleAnalyticsOauthUrl?: Maybe<Scalars['String']['output']>;
  gptResponse?: Maybe<GptResponse>;
  gridSummary?: Maybe<GridSummary>;
  industries?: Maybe<IndustryConnection>;
  integration?: Maybe<IntegrationWithToken>;
  integrations?: Maybe<Array<Maybe<Integration>>>;
  integrationsWithScope?: Maybe<Array<Maybe<Integration>>>;
  isIngestionRunning?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<JobTitleConnection>;
  /** Folders visible to the caller: shared (public) folders plus the caller's own personal folders. */
  listFolders: Array<ListFolder>;
  mailchimpAudiences?: Maybe<Array<MailchimpAudience>>;
  mdmCompany?: Maybe<MdmCompanyDetail>;
  mdmCompanyLookup?: Maybe<MdmCompanyLookup>;
  /** Every company on a domain, ranked by the live parent rule, with the current parent and any curated pin flagged. */
  mdmDomainCompanies?: Maybe<MdmDomainCompanies>;
  /** The properties fields the create form should collect. These are the keys CRM enrichment actually reads -- a record created without them is searchable but contributes almost nothing to a matched contact or account. */
  mdmEnrichmentFields?: Maybe<Array<Maybe<MdmEnrichmentField>>>;
  /** `properties` keys the edit form must NOT offer, because something else owns them: the properties half of a mirrored column pair, a band's label and ceiling, the technology categories with their merged tech_tags, and the logo / profile image owned by the upload flow. Bare keys, no `properties.` prefix. The form discovers editable paths from the record itself, so without this it offers `properties.name` beside the Name column -- two controls for one fact, where the wrong one is a silent half-write -- and a text box for an image URL that bypasses the fetch, the size and content-type checks and the SSRF guard. */
  mdmExcludedPropertyKeys: Array<Scalars['String']['output']>;
  /** Which fields the admin may override, and their default modes. */
  mdmFieldPolicy?: Maybe<Array<Maybe<MdmFieldPolicy>>>;
  mdmMyRecentEdits?: Maybe<MdmEditAuditPage>;
  /** Parent pins whose company has vanished or been reassigned. */
  mdmOverrideDrift?: Maybe<Array<Maybe<MdmOverrideDrift>>>;
  mdmOverrideSyncStatus?: Maybe<MdmOverrideSyncStatus>;
  mdmPerson?: Maybe<MdmPersonDetail>;
  /** Find people. Postgres answers the indexed keys (email, LinkedIn URL); company_domain and name are index-only, since person has no index on either. At least one criterion is required. */
  mdmPersonLookup?: Maybe<MdmPersonLookup>;
  /** Which workspaces hold a CRM record this MDM change would touch. Answered from Postgres, because the document store has no cross-workspace access path -- every one of its lookups is wksp_id-scoped by design. */
  mdmReEnrichTargets?: Maybe<Array<Maybe<MdmReEnrichTarget>>>;
  /** Review queue: fixes the vendor has won back. */
  mdmSupersededOverrides?: Maybe<MdmFieldOverridePage>;
  me?: Maybe<User>;
  nextLastActivityResponse?: Maybe<NextLastActivityResponse>;
  note?: Maybe<Note>;
  notes?: Maybe<NoteConnection>;
  notificationNewCount?: Maybe<Scalars['Int']['output']>;
  notificationUnreadCount?: Maybe<Scalars['Int']['output']>;
  notifications?: Maybe<NotificationConnection>;
  /** Check if workspace has valid payment method (user-facing) */
  paymentMethodStatus?: Maybe<PaymentMethodStatus>;
  pendingContactChangeSuggestion?: Maybe<ContactChangeSuggestionType>;
  /** Open pipeline by stage, with per-stage conversion and velocity. */
  pipelineHealthReport?: Maybe<PipelineHealthReport>;
  pipelines?: Maybe<PipelineConnection>;
  postalCodes?: Maybe<PostalCodeConnection>;
  previewAiField?: Maybe<PreviewAiFieldResult>;
  previewFormulaField?: Maybe<PreviewFormulaFieldResult>;
  products?: Maybe<Array<Maybe<Product>>>;
  /** Get counts of QuickBooks customers and paid invoices for a workspace */
  quickbooksDataCounts?: Maybe<QuickBooksDataCounts>;
  /** Generic group-by/metric aggregation over CRM records — the executor for report kpi/chart/table blocks. */
  recordAggregate?: Maybe<RecordAggregateResult>;
  /** The share dialog's read-back: this record's current group grants. */
  recordGrants?: Maybe<RecordGrants>;
  /** Row-level listing for report record_list blocks: grammar filters, projected columns, display values off the same field catalog as recordAggregate (capped at 200 rows). */
  recordList?: Maybe<RecordListResult>;
  /** Batch lookup of static-list membership for a set of records. */
  recordListMemberships: Array<RecordListMembership>;
  /** Current record count vs the workspace's plan cap (user-facing) */
  recordUsage?: Maybe<RecordUsage>;
  /** The report grammar vocabulary: per-object fields (standard + this workspace's custom fields), time ranges, ops, templates. Drafting and the FE read this, never a local copy. */
  reportCatalog?: Maybe<ReportCatalog>;
  reportDefinition?: Maybe<ReportDefinition>;
  /** Reports visible to the caller: workspace-shared plus their own private ones. */
  reportDefinitions: Array<ReportDefinition>;
  /** One run — the poll target while a run executes. */
  reportRun?: Maybe<ReportRun>;
  /** Run history for one report, newest first (keyset-paginated on id). */
  reportRuns: Array<ReportRun>;
  /** Ready-made report catalog; save one via createReportDefinition(templateKey). */
  reportTemplates: Array<ReportTemplateEntry>;
  search?: Maybe<SearchResponse>;
  /** Search the Coffee help center; returns the most relevant whole articles. */
  searchHelpCenter?: Maybe<Array<Maybe<HelpArticleResult>>>;
  /** Get counts of Stripe objects (customers, subscriptions, paid charges, paid invoices) for a workspace */
  stripeDataCounts?: Maybe<StripeDataCounts>;
  /** Get subscription for a workspace */
  subscription?: Maybe<Subscription>;
  summaryTemplates?: Maybe<SummaryTemplateConnection>;
  systemBriefSections?: Maybe<Array<Maybe<BriefTemplateSection>>>;
  taskSuggestion?: Maybe<TaskSuggestion>;
  taskSuggestions?: Maybe<TaskSuggestionConnection>;
  techTags?: Maybe<TechTagConnection>;
  temporalTaskRun?: Maybe<TemporalTrackerRun>;
  user?: Maybe<User>;
  userFavorites?: Maybe<Array<Maybe<UserFavoriteType>>>;
  userGroups: Array<UserGroupType>;
  /** Health of Google/Microsoft user integrations for paid+trial workspaces (superuser only) */
  userIntegrationHealth?: Maybe<Array<Maybe<UserIntegrationHealth>>>;
  userIntegrations?: Maybe<Array<Maybe<UserIntegration>>>;
  userIntegrationsByPlatform?: Maybe<Array<Maybe<UserIntegration>>>;
  userLists?: Maybe<UserListConnection>;
  userPreferences?: Maybe<UserPreferences>;
  userQuotas: Array<UserQuotaType>;
  users?: Maybe<UserConnection>;
  usersForEmailNotifications?: Maybe<Array<Maybe<NotificationEmailRecipient>>>;
  workflowStatus?: Maybe<WorkflowStatusType>;
  workspace?: Maybe<Workspace>;
  workspaceAgentSources?: Maybe<Scalars['JSONString']['output']>;
  workspaceConnections?: Maybe<Array<Maybe<WorkspaceConnectionType>>>;
  workspaceEmailSuppressions?: Maybe<Array<Maybe<WorkspaceEmailSuppression>>>;
  workspaceIntelligence?: Maybe<WorkspaceIntelligenceType>;
  workspaceLeadFinderSuggestions?: Maybe<WorkspaceLeadFinderSuggestionsType>;
  workspacePreferences?: Maybe<WorkspacePreferences>;
  workspaces?: Maybe<WorkspaceConnection>;
};


export type QueryAccountArgs = {
  filter?: InputMaybe<AccountFilter>;
  id: Scalars['ID']['input'];
};


export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryActiveAiExecutionsArgs = {
  fieldId?: InputMaybe<Scalars['Int']['input']>;
  listId?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type QueryAgentDefinitionArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type QueryAgentDefinitionsArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryAgentPreviewProgressArgs = {
  previewId: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type QueryAgentRunsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type QueryAgentTemplateDriftArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryAgentTemplatesArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryAiChatConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryAiChatMessagesArgs = {
  conversationId: Scalars['Int']['input'];
};


export type QueryAiJobExecutionArgs = {
  executionId: Scalars['String']['input'];
};


export type QueryAutomationRuleArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type QueryAutomationRulesArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryBriefTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BriefTemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryByoaAgentHealthArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryByoaAgentRunHealthArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyProblems?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCampaignArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type QueryCampaignStepRecipientsArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  stepOrder: Scalars['Int']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type QueryCampaignsArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryClipArgs = {
  id: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type QueryClipShareArgs = {
  slug: Scalars['String']['input'];
};


export type QueryClipsArgs = {
  engagementId: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactChangeImpactArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryContactChangeSuggestionArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryCreditResponseArgs = {
  workspaceId: Scalars['String']['input'];
};


export type QueryCreditUsageLogsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CreditUsageStatus>;
};


export type QueryCreditUsageSummaryArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryCrmDataCountsArgs = {
  input: CrmDataCountsInput;
};


export type QueryCrmGraderReportArgs = {
  input?: InputMaybe<CrmGraderReportInput>;
};


export type QueryCrmIngestionAvailableFieldsArgs = {
  objectType: CrmIngestionObjectType;
  platform: CrmIngestionPlatform;
  workspaceId: Scalars['Int']['input'];
};


export type QueryCrmIngestionConfigArgs = {
  platform?: InputMaybe<CrmIngestionPlatform>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryCrmIngestionFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<CrmIngestionPlatform>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCrmIngestionRunArgs = {
  runId: Scalars['ID']['input'];
};


export type QueryCrmIngestionRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CrmIngestionRunFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryCrmIngestionSyncLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CrmIngestionRunFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCrmIntegrationHealthArgs = {
  staleHours?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCrmOauthUrlArgs = {
  platform: Scalars['String']['input'];
  redirectTo?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type QueryCrmPreviewDealStagesArgs = {
  platform: CrmIngestionPlatform;
  workspaceId: Scalars['Int']['input'];
};


export type QueryCsvImportHealthArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDailyLeadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: DailyLeadsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDealArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDealCreationFieldsArgs = {
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryDealFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: DealFieldFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDealLineItemsArgs = {
  dealId: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryDealStagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DealStageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DealStageSortEnum>>>;
};


export type QueryDealSuggestionArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryDealSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: DealSuggestionFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDealsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DealFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryDealsCompareAggregatesArgs = {
  filter?: InputMaybe<DealFilter>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryDesktopTokensArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DesktopTokenFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DesktopTokenSortEnum>>>;
};


export type QueryDomainAllowlistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDomainAllowlistsArgs = {
  filter?: InputMaybe<DomainAllowlistFilter>;
};


export type QueryEmailTemplatesArgs = {
  isWorkspaceWide?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type QueryEngagementArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryEngagementBasicArgs = {
  slug: Scalars['String']['input'];
};


export type QueryEngagementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: EngagementFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryFieldHistoryArgs = {
  entityId: Scalars['ID']['input'];
  entityType?: InputMaybe<FieldHistoryEntityType>;
  field: Scalars['String']['input'];
  includeAutomated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFileArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: FileFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryFindCompanyByDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryFindCompanyByLinkedinUrlArgs = {
  linkedinUrl: Scalars['String']['input'];
};


export type QueryFindPersonByLinkedinUrlArgs = {
  linkedinUrl: Scalars['String']['input'];
};


export type QueryGenerateFormulaArgs = {
  description: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type QueryGetAccountByDomainArgs = {
  domain: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryGetAccountByLinkedinUrlArgs = {
  linkedinUrl: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryGetAccountsByNameArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryGetContactByEmailArgs = {
  email: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryGetContactByLinkedinUrlArgs = {
  linkedinUrl: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryGongWebhookUrlArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryGptResponseArgs = {
  summaryTemplate?: InputMaybe<SummaryTemplate>;
  timezone: Scalars['String']['input'];
  transcript?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGridSummaryArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryIndustriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<IndustryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntegrationArgs = {
  platform: IntegrationPlatform;
  workspaceId: Scalars['Int']['input'];
};


export type QueryIntegrationsArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryIsIngestionRunningArgs = {
  platform?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryJobTitleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<JobTitleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListFoldersArgs = {
  modelType: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryMailchimpAudiencesArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryMdmCompanyArgs = {
  auditPage?: InputMaybe<Scalars['Int']['input']>;
  auditPerPage?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  includeIndexComparison?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMdmCompanyLookupArgs = {
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  primaryDomain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMdmDomainCompaniesArgs = {
  domain: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMdmEnrichmentFieldsArgs = {
  entityType: Scalars['String']['input'];
};


export type QueryMdmExcludedPropertyKeysArgs = {
  entityType: Scalars['String']['input'];
};


export type QueryMdmFieldPolicyArgs = {
  entityType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMdmMyRecentEditsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMdmPersonArgs = {
  auditPage?: InputMaybe<Scalars['Int']['input']>;
  auditPerPage?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  includeIndexComparison?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMdmPersonLookupArgs = {
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMdmReEnrichTargetsArgs = {
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
};


export type QueryMdmSupersededOverridesArgs = {
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNextLastActivityResponseArgs = {
  entityId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  type: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryNoteArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: NoteFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryNotificationNewCountArgs = {
  workspaceId: Scalars['String']['input'];
};


export type QueryNotificationUnreadCountArgs = {
  workspaceId: Scalars['String']['input'];
};


export type QueryNotificationsArgs = {
  beforeId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryPaymentMethodStatusArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryPendingContactChangeSuggestionArgs = {
  contactId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryPipelineHealthReportArgs = {
  filter: ReportFilterInput;
};


export type QueryPipelinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PipelineFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PipelineSortEnum>>>;
};


export type QueryPostalCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PostalCodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPreviewAiFieldArgs = {
  aiModelName?: InputMaybe<Scalars['String']['input']>;
  aiModelProvider?: InputMaybe<Scalars['String']['input']>;
  aiOutputInstructionText?: InputMaybe<Scalars['String']['input']>;
  aiPromptText?: InputMaybe<Scalars['String']['input']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Scalars['Int']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  listId?: InputMaybe<Scalars['Int']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};


export type QueryPreviewFormulaFieldArgs = {
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expression: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type QueryProductsArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryQuickbooksDataCountsArgs = {
  input: QuickBooksDataCountsInput;
};


export type QueryRecordAggregateArgs = {
  input: RecordAggregateInput;
};


export type QueryRecordGrantsArgs = {
  recordId: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryRecordListArgs = {
  input: RecordListInput;
};


export type QueryRecordListMembershipsArgs = {
  modelType: Scalars['String']['input'];
  recordIds: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryRecordUsageArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryReportCatalogArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryReportDefinitionArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryReportDefinitionsArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryReportRunArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryReportRunsArgs = {
  beforeId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryReportTemplatesArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QuerySearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QuerySearchHelpCenterArgs = {
  k?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryStripeDataCountsArgs = {
  input: StripeDataCountsInput;
};


export type QuerySubscriptionArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QuerySummaryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SummaryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskSuggestionArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryTaskSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: TaskSuggestionFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTechTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TechTagFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTemporalTaskRunArgs = {
  workflowId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserFavoritesArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryUserGroupsArgs = {
  includeSystem?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryUserIntegrationHealthArgs = {
  staleDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserIntegrationsArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryUserIntegrationsByPlatformArgs = {
  platform: Scalars['String']['input'];
};


export type QueryUserListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserListFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryUserPreferencesArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryUserQuotasArgs = {
  from: Scalars['Date']['input'];
  periodType: QuotaPeriodType;
  to: Scalars['Date']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserSortEnum>>>;
};


export type QueryWorkflowStatusArgs = {
  workflowId: Scalars['String']['input'];
};


export type QueryWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkspaceAgentSourcesArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryWorkspaceConnectionsArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryWorkspaceEmailSuppressionsArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type QueryWorkspaceIntelligenceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryWorkspaceLeadFinderSuggestionsArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryWorkspacePreferencesArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryWorkspacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<WorkspaceSortEnum>>>;
};

/** Counts of QuickBooks objects for the sync wizard preview. */
export type QuickBooksDataCounts = {
  __typename?: 'QuickBooksDataCounts';
  /** Count of QuickBooks Customer objects */
  customers: Scalars['Int']['output'];
  /** Count of paid invoices (Balance = 0) */
  paidInvoices: Scalars['Int']['output'];
};

/** Input for the quickBooksDataCounts query. */
export type QuickBooksDataCountsInput = {
  /** Filter records on or before this date (TxnDate for invoices, MetaData.CreateTime for customers) */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records on or after this date (TxnDate for invoices, MetaData.CreateTime for customers) */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The workspace with the QuickBooks connection */
  workspaceId: Scalars['ID']['input'];
};

/** An enumeration. */
export enum QuotaPeriodType {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR'
}

export type RecordAggregateBucket = {
  __typename?: 'RecordAggregateBucket';
  docCount: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  metrics: Scalars['JSONString']['output'];
};

export type RecordAggregateInput = {
  /** [{"field","op","values"}] — the report grammar filter list. */
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  /** Date group_by only: week | month | quarter. */
  groupInterval?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** [{"op","field"?,"label"?}]. */
  metrics: Scalars['JSONString']['input'];
  /** deals | companies | people */
  objectType: Scalars['String']['input'];
  /** Metric label to order buckets by (terms groups only). */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  /** Date field the from/to window applies to (deals default: closeDate). */
  timeField?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type RecordAggregateResult = {
  __typename?: 'RecordAggregateResult';
  buckets: Array<RecordAggregateBucket>;
  /** Ungrouped (KPI) metric values by label; null when grouped. */
  metrics?: Maybe<Scalars['JSONString']['output']>;
  /** Docs beyond the bucket cap (terms sum_other_doc_count). */
  otherCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export type RecordGrantError = {
  __typename?: 'RecordGrantError';
  message: Scalars['String']['output'];
  recordId: Scalars['String']['output'];
};

export type RecordGrantInput = {
  groupId: Scalars['ID']['input'];
  level: RecordGrantLevel;
};

export enum RecordGrantLevel {
  Edit = 'EDIT',
  View = 'VIEW'
}

export type RecordGrants = {
  __typename?: 'RecordGrants';
  editGroupIds: Array<Scalars['ID']['output']>;
  editUserIds: Array<Scalars['ID']['output']>;
  recordId: Scalars['String']['output'];
  /** Who manages these grants: 'default' (the workspace's per-entity default; backfills may restamp) or 'custom' (set via the share dialog; hands-off for backfills). */
  source: Scalars['String']['output'];
  viewGroupIds: Array<Scalars['ID']['output']>;
  /** Person-level VIEW grants: PG user ids shared on this record. */
  viewUserIds: Array<Scalars['ID']['output']>;
  /** The per-entity default visibility that would apply on reset ('private' | 'manager' | 'managers_and_admins' | 'everyone'); null for entities without a default (account/contact/deal) and for type=task notes, which stay under tasks_visibility. */
  workspaceDefault?: Maybe<Scalars['String']['output']>;
};

export type RecordListInput = {
  /** Ordered field keys to return per row. */
  columns: Scalars['JSONString']['input'];
  /** [{"field","op","values"}] — the report grammar filter list. */
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** deals | companies | people */
  objectType: Scalars['String']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/**
 * Which static lists a single record currently belongs to.
 *
 * `list_ids` are the ListModel ids (as strings) that both appear in the
 * record's `properties.list_membership` AND still exist in this workspace
 * for this model_type (stale/deleted/foreign ids are dropped). Lets the
 * frontend Add-to-List dialog show and toggle membership across a bulk
 * selection without firing one query per record.
 */
export type RecordListMembership = {
  __typename?: 'RecordListMembership';
  listIds: Array<Scalars['ID']['output']>;
  recordId: Scalars['ID']['output'];
};

export type RecordListResult = {
  __typename?: 'RecordListResult';
  columns: Array<Scalars['String']['output']>;
  rows: Array<RecordListRow>;
  total: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export type RecordListRow = {
  __typename?: 'RecordListRow';
  /** {column: display value} */
  values: Scalars['JSONString']['output'];
};

export type RecordSharingInput = {
  /** Enable group-based per-record sharing for this workspace. */
  recordSharingEnabled: Scalars['Boolean']['input'];
};

/** A workspace's active record count vs its plan cap. */
export type RecordUsage = {
  __typename?: 'RecordUsage';
  /** Plan record cap; null = unlimited */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Active records (accounts + contacts + deals) */
  used?: Maybe<Scalars['Int']['output']>;
};

/**
 * Person-level grant (grid Privacy popover): share a record with one
 * specific workspace member, independent of any group.
 */
export type RecordUserGrantInput = {
  level: RecordGrantLevel;
  userId: Scalars['ID']['input'];
};

export type RecreateIndexInput = {
  indexType?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};

/**
 * Record (or refresh) this device's push subscription.
 *
 * Upserts on `endpoint`: re-subscribing the same browser profile returns the same endpoint, so
 * calling this on page load must not accumulate rows. The upsert also reassigns the row to the
 * current user and clears `revoked_at` — on a shared machine a second person signing in should
 * receive their own pushes, not the first person's, and a device that comes back after being
 * revoked is alive again.
 */
export type RegisterPushSubscription = {
  __typename?: 'RegisterPushSubscription';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RelativeDurationInput = {
  unit: AgeUnit;
  value: Scalars['Int']['input'];
};

export type RemoveEmailSuppressionMutation = {
  __typename?: 'RemoveEmailSuppressionMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Soft-delete a labeled association (both directed edges) and rebuild both entities'
 * denormalized `associations` arrays (plan PR 9). History is preserved in the collection.
 *
 * Accepts either canonical ddb ids or Postgres ids (see `SetEntityAssociation`).
 */
export type RemoveEntityAssociation = {
  __typename?: 'RemoveEntityAssociation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveFavorite = {
  __typename?: 'RemoveFavorite';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveFavoriteInput = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type RemoveFutureMeetingBot = {
  __typename?: 'RemoveFutureMeetingBot';
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveRecordsFromList = {
  __typename?: 'RemoveRecordsFromList';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveRecordsFromListInput = {
  listId: Scalars['ID']['input'];
  recordIds: Array<InputMaybe<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type RemoveUserGroupMembers = {
  __typename?: 'RemoveUserGroupMembers';
  userGroup?: Maybe<UserGroupType>;
};

export type RemoveWorkspaceDomain = {
  __typename?: 'RemoveWorkspaceDomain';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  workspace?: Maybe<Workspace>;
};

export type RemoveWorkspaceDomainInput = {
  domain: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/**
 * Set the display order of custom knowledge areas for a workspace.
 *
 * Accepts the full ordered list of ids; rows not present in the list keep
 * their current position (defensive: avoid orphaning anything if the client
 * sends a partial list).
 */
export type ReorderWorkspaceCustomKnowledge = {
  __typename?: 'ReorderWorkspaceCustomKnowledge';
  customKnowledgeAreas?: Maybe<Array<Maybe<WorkspaceCustomKnowledgeType>>>;
};

export type ReorderWorkspaceCustomKnowledgeInput = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type ReportCatalog = {
  __typename?: 'ReportCatalog';
  filterOps: Array<Scalars['String']['output']>;
  groupIntervals: Array<Scalars['String']['output']>;
  metricOps: Array<Scalars['String']['output']>;
  /** {deals|companies|people: [{key,label,type,filterable,groupable,sortable,metric_ops}]} */
  objects: Scalars['JSONString']['output'];
  /** [{id,name}] — this workspace's deal pipelines. `name` is what a `pipeline` filter takes; `id` is what a funnel block's pipelineId takes ("0" = the default stage set). */
  pipelines: Scalars['JSONString']['output'];
  templateKeys: Array<Scalars['String']['output']>;
  timeRangeKeys: Array<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  vizKinds: Array<Scalars['String']['output']>;
};

export type ReportDefinition = Node & {
  __typename?: 'ReportDefinition';
  createTs?: Maybe<Scalars['DateTime']['output']>;
  definition: Scalars['JSONString']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestRun?: Maybe<ReportRun>;
  legacy: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ownerUserId: Scalars['Int']['output'];
  schedule?: Maybe<Scalars['JSONString']['output']>;
  status: Scalars['String']['output'];
  templateKey?: Maybe<Scalars['String']['output']>;
  updateTs?: Maybe<Scalars['DateTime']['output']>;
  visibility: Scalars['String']['output'];
  workspaceId: Scalars['Int']['output'];
};

/**
 * Scope for a report.
 *
 * ``from``/``to`` bound the *stage-history window* used for the velocity and
 * conversion metrics. They intentionally do NOT filter the deal set: the
 * funnel counts and amounts are a point-in-time view of the currently-open
 * pipeline, so ``totalOpenAmount`` stays consistent with the deals grid's
 * open-deal total regardless of the window.
 */
export type ReportFilterInput = {
  /** Start of the stage-history window (inclusive). Does not filter the deal set. */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** Coffee user ids; mapped to CRM-external owner ids server-side. */
  ownerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Restrict to one pipeline. Pass 0 for the default (pipeline-less) stage set. */
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  /** End of the stage-history window (inclusive). Does not filter the deal set. */
  to?: InputMaybe<Scalars['DateTime']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/**
 * One persisted execution snapshot. blockResults fills progressively while
 * the run executes — the FE polls reportRun and renders block-by-block.
 */
export type ReportRun = {
  __typename?: 'ReportRun';
  blockResults: Scalars['JSONString']['output'];
  createTs?: Maybe<Scalars['DateTime']['output']>;
  creditsCharged: Scalars['Int']['output'];
  definitionSnapshot: Scalars['JSONString']['output'];
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  narrative?: Maybe<Scalars['String']['output']>;
  reportId: Scalars['ID']['output'];
  requestedBy?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  triggerSource: Scalars['String']['output'];
  workspaceId: Scalars['Int']['output'];
};

/** One stage of the open pipeline, plus its historical velocity metrics. */
export type ReportStageFunnelEntry = {
  __typename?: 'ReportStageFunnelEntry';
  /** Mean age of the deals currently in this stage, from in_stage_since. Null when no document carries in_stage_since. */
  avgAgeInStageDays?: Maybe<Scalars['Float']['output']>;
  /** Mean duration of completed stays in this stage during the window. Deals still sitting in the stage are excluded (their stay has no end). Null when no completed stay was observed. */
  avgDaysInStage?: Maybe<Scalars['Float']['output']>;
  /** Of the deals observed in this stage during the window, the percentage that were later observed in a higher-ordered, non-lost stage. Null when no deal was observed in this stage during the window. */
  conversionToNextPct?: Maybe<Scalars['Float']['output']>;
  /** Sum of amount over those open deals. */
  openAmount: Scalars['Float']['output'];
  /** Open deals currently sitting in this stage. */
  openCount: Scalars['Int']['output'];
  /** Stage display order; null when unset on the stage record. */
  order?: Maybe<Scalars['Int']['output']>;
  /** Configured win probability as a 0..1 fraction; null when unset. */
  probability?: Maybe<Scalars['Float']['output']>;
  /** Stage external id as stored on the deal document (falls back to the raw bucket key). */
  stageId: Scalars['ID']['output'];
  stageName: Scalars['String']['output'];
  /** openAmount * probability; null when the stage has no configured probability. */
  weightedAmount?: Maybe<Scalars['Float']['output']>;
};

/**
 * One ready-made report from the code catalog (reports/templates.py).
 * Materialized into a real ReportDefinition only when a user saves it.
 */
export type ReportTemplateEntry = {
  __typename?: 'ReportTemplateEntry';
  definition: Scalars['JSONString']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  templateKey: Scalars['String']['output'];
};

/** A single pre-resolved email (merge fields already substituted by the frontend). */
export type ResolvedEmailInput = {
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type ResumeCampaign = {
  __typename?: 'ResumeCampaign';
  campaign?: Maybe<Campaign>;
};

export type RevenueGptPreferences = {
  __typename?: 'RevenueGptPreferences';
  /** Strict mode for RevenueGPT */
  strictMode?: Maybe<Scalars['Boolean']['output']>;
};

export type RevenueGptPreferencesInput = {
  strictMode: Scalars['Boolean']['input'];
};

export type RevokeDesktopToken = {
  __typename?: 'RevokeDesktopToken';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RevokeDesktopTokenInput = {
  id: Scalars['ID']['input'];
};

export type RtmsTranscriptEntryType = {
  __typename?: 'RtmsTranscriptEntryType';
  data?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type RuleActionPreview = {
  __typename?: 'RuleActionPreview';
  detail: Scalars['String']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
};

export type RuleTestRunResult = {
  __typename?: 'RuleTestRunResult';
  evaluatedCount: Scalars['Int']['output'];
  matchedCount: Scalars['Int']['output'];
  previews?: Maybe<Array<Maybe<RuleActionPreview>>>;
  truncated: Scalars['Boolean']['output'];
};

/**
 * Mutation to trigger AI custom field generation
 *
 * Input:
 * - workspace_id: Workspace ID (required)
 * - field_id: The custom field configuration ID (required)
 * - list_id: (Optional) List to fetch entity IDs from
 * - entity_ids: (Optional) Explicit array of entity IDs to process
 * - filter: (Optional) Filter dict to dynamically fetch entities matching criteria
 *
 * Must provide at least one of: list_id, entity_ids, or filter
 *
 * Returns the job execution for tracking progress
 */
export type RunAiCustomField = {
  __typename?: 'RunAiCustomField';
  execution?: Maybe<AiJobExecutionType>;
};

/**
 * Recompute one formula field across the workspace.
 *
 * Deliberately narrower than RunAiCustomField: no list_id, no entity_ids, no filter, no
 * row_limit. A formula is deterministic and free, so "recompute the subset the user is
 * looking at" has no cost advantage and would leave the rest of the column stale.
 */
export type RunFormulaField = {
  __typename?: 'RunFormulaField';
  execution?: Maybe<AiJobExecutionType>;
};

/**
 * Queue a run of one report. Any member who can VIEW the report may run
 * it (@require_workspace_data_write already excludes read-only members);
 * returns the queued ReportRun — the FE polls reportRun as block_results
 * fill progressively.
 */
export type RunReport = {
  __typename?: 'RunReport';
  run?: Maybe<ReportRun>;
};

export type RunReportInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type SaveAiChatMessage = {
  __typename?: 'SaveAiChatMessage';
  id?: Maybe<Scalars['Int']['output']>;
};

export type SaveAiChatMessageInput = {
  content: Scalars['String']['input'];
  conversationId: Scalars['Int']['input'];
  role: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/**
 * Mark a daily lead as ``saved_as_contact`` and link it to the
 * Contact the frontend just created.
 *
 * The frontend orchestrates the two-step flow: it calls the existing
 * ``createContact`` mutation, then calls this mutation with the
 * returned ``ext_id``. Keeping the Contact-creation logic out of this
 * file means we never duplicate field-mapping behaviour that already
 * exists in the canonical mutation, and Contact creation continues to
 * benefit from CRM hooks (account upsert, source attribution, etc.).
 */
export type SaveDailyLeadAsContact = {
  __typename?: 'SaveDailyLeadAsContact';
  dailyLead?: Maybe<DailyLead>;
};

/** Results for a specific entity type */
export type SearchEntityResults = {
  __typename?: 'SearchEntityResults';
  entityType: Scalars['String']['output'];
  results?: Maybe<Array<Maybe<SearchResult>>>;
  total: Scalars['Int']['output'];
};

/** Combined search response across all entity types */
export type SearchResponse = {
  __typename?: 'SearchResponse';
  accounts?: Maybe<SearchEntityResults>;
  contacts?: Maybe<SearchEntityResults>;
  deals?: Maybe<SearchEntityResults>;
  emails?: Maybe<SearchEntityResults>;
  files?: Maybe<SearchEntityResults>;
  meetings?: Maybe<SearchEntityResults>;
  notes?: Maybe<SearchEntityResults>;
  totalResults: Scalars['Int']['output'];
};

/** Individual search result from OpenSearch */
export type SearchResult = {
  __typename?: 'SearchResult';
  data: Scalars['GenericScalar']['output'];
  highlight?: Maybe<Scalars['GenericScalar']['output']>;
  id: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
};

export type SendContact = {
  __typename?: 'SendContact';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Kick off a background Temporal workflow to send one or more emails.
 *
 * When send_individually=True:  one email is sent per entry in resolved_emails
 *                               (merge fields pre-resolved by the frontend).
 * When send_individually=False: one email is sent to all to_emails with optional
 *                               cc_emails / bcc_emails.
 */
export type SendEmails = {
  __typename?: 'SendEmails';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Send a one-off TEST of an async alert recipe to the CURRENT user only, so they can
 * see what it looks like without waiting for the real event. Only notification/email
 * recipes qualify; the recipient is always the acting user — never the rule's real
 * targets — so there's no deliverability/blast-radius risk. Replaces the misleading
 * match-count "test run" for alert recipes.
 */
export type SendRuleTestMessage = {
  __typename?: 'SendRuleTestMessage';
  detail?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * Write one sample notification into the CALLER'S OWN feed.
 *
 * Exists so the team can see a type's real row — icon, copy, CTA — in production before
 * its producer has ever fired. Without it, launch day is the first time anyone sees
 * these rendered against real data.
 *
 * Deliberately cannot target another user: it writes to `user.id` from the request, and
 * takes no recipient argument. Admin-gated because it writes rows, not because the rows
 * are dangerous.
 */
export type SendTestNotification = {
  __typename?: 'SendTestNotification';
  notification?: Maybe<NotificationType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SendWorkspaceWelcomeEmail = {
  __typename?: 'SendWorkspaceWelcomeEmail';
  workspace?: Maybe<Workspace>;
};

export type SendWorkspaceWelcomeEmailInput = {
  id: Scalars['Int']['input'];
};

export type SetAgentEnabled = {
  __typename?: 'SetAgentEnabled';
  agent?: Maybe<AgentDefinition>;
};

export type SetAssociationInput = {
  fromId: Scalars['String']['input'];
  fromType?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  toId: Scalars['String']['input'];
  toType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Replace all line items for a deal with the provided list.
 *
 * Passing an empty list removes all line items.
 * Existing line items for the deal are soft-deleted and replaced.
 */
export type SetDealLineItems = {
  __typename?: 'SetDealLineItems';
  lineItems?: Maybe<Array<Maybe<LineItem>>>;
};

/**
 * Create or refresh a labeled association between two entities. Writes both directed
 * edges in the canonical `entity_association` collection and rebuilds each entity's
 * denormalized `associations` array (plan PR 9). Idempotent.
 *
 * Accepts either canonical ddb ids or Postgres ids (translated to ddb ids before storage
 * — see `_canonical_ddb_id_and_type`), so GraphQL clients that only hold Postgres ids can
 * call it directly.
 */
export type SetEntityAssociation = {
  __typename?: 'SetEntityAssociation';
  association?: Maybe<EntityAssociation>;
};

/** Connect with a pasted access token, for a server with no authorization server. */
export type SetMcpConnectionToken = {
  __typename?: 'SetMcpConnectionToken';
  connection?: Maybe<WorkspaceConnectionType>;
};

export type SetRecordGrants = {
  __typename?: 'SetRecordGrants';
  recordGrants?: Maybe<RecordGrants>;
};

export type SetRecordGrantsBulk = {
  __typename?: 'SetRecordGrantsBulk';
  errors: Array<RecordGrantError>;
  updatedCount: Scalars['Int']['output'];
};

export type SetUserQuotas = {
  __typename?: 'SetUserQuotas';
  quotas: Array<UserQuotaType>;
};

/**
 * Attach, replace, or remove the file on a built-in intelligence section.
 *
 * Text is extracted inline (same pipeline as custom knowledge files) and
 * appended to that section in the AI prompt knowledge block.
 */
export type SetWorkspaceIntelligenceSectionFile = {
  __typename?: 'SetWorkspaceIntelligenceSectionFile';
  sectionFile?: Maybe<WorkspaceIntelligenceSectionFileType>;
};

export type SetWorkspaceIntelligenceSectionFileInput = {
  fileId?: InputMaybe<Scalars['String']['input']>;
  section: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type SharedByUser = {
  __typename?: 'SharedByUser';
  givenName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type SortInput = {
  field: Scalars['String']['input'];
  sort: Scalars['String']['input'];
};

export type SourceAggregateDatum = {
  __typename?: 'SourceAggregateDatum';
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type StageMappingInput = {
  fromStageId: Scalars['ID']['input'];
  toStageId: Scalars['ID']['input'];
};

export type StartCampaign = {
  __typename?: 'StartCampaign';
  campaign?: Maybe<Campaign>;
  enrolledCount?: Maybe<Scalars['Int']['output']>;
  flaggedCount?: Maybe<Scalars['Int']['output']>;
  skippedInvalidEmailCount?: Maybe<Scalars['Int']['output']>;
  skippedUndeliverableCount?: Maybe<Scalars['Int']['output']>;
};

/** Input type for starting the 14-day Grande free trial. */
export type StartFreeTrialInput = {
  /** Workspace ID */
  workspaceId: Scalars['ID']['input'];
};

/** Response type for start free trial. */
export type StartFreeTrialResponse = {
  __typename?: 'StartFreeTrialResponse';
  /** Whether the trial was started */
  success: Scalars['Boolean']['output'];
};

/** Counts of Stripe objects for the sync wizard preview. */
export type StripeDataCounts = {
  __typename?: 'StripeDataCounts';
  /** Count of Stripe Customer objects */
  customers: Scalars['Int']['output'];
  /** Count of Stripe Charge objects where status = 'succeeded' */
  paidCharges: Scalars['Int']['output'];
  /** Count of Stripe Invoice objects where status = 'paid' */
  paidInvoices: Scalars['Int']['output'];
  /** Count of Stripe Subscription objects */
  subscriptions: Scalars['Int']['output'];
};

/** Input for the stripeDataCounts query. */
export type StripeDataCountsInput = {
  /** Filter records created before this date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records created after this date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The workspace with the Stripe connection */
  workspaceId: Scalars['ID']['input'];
};

/** Subscription type. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Monthly/annual price in cents */
  amountInCents?: Maybe<Scalars['Int']['output']>;
  /** Billing cycle (monthly or yearly) */
  billingCycle: BillingCycle;
  /** Future date when subscription will auto-cancel */
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  /** When user requested cancellation */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  /** User-provided comment about cancellation */
  cancellationComment?: Maybe<Scalars['String']['output']>;
  /** Reason for cancellation (e.g., too_expensive, missing_features) */
  cancellationReason?: Maybe<Scalars['String']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  creditsPerSeatOverride?: Maybe<Scalars['Int']['output']>;
  /** Currency code (e.g., USD, EUR) */
  currency?: Maybe<Scalars['String']['output']>;
  /** Current billing period end */
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Current billing period start */
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  /** Entitlements for this tier */
  entitlements?: Maybe<EntitlementsType>;
  /** External ID from provider */
  externalId: Scalars['String']['output'];
  /** Free trial end date */
  freeTrialEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Free trial start date */
  freeTrialStart?: Maybe<Scalars['DateTime']['output']>;
  /** Subscription ID */
  id: Scalars['ID']['output'];
  /** Plan ID */
  planId: Scalars['String']['output'];
  /** Pricing tier */
  pricingTier: PricingTier;
  /** Provider */
  provider: SubscriptionProvider;
  /** Number of seats they're paying for */
  seats?: Maybe<Scalars['Int']['output']>;
  /** Subscription status */
  status: SubscriptionStatus;
  stripeEventCreatedAt?: Maybe<Scalars['Float']['output']>;
  /** Days remaining in trial (null if not trialing) */
  trialDaysRemaining?: Maybe<Scalars['Int']['output']>;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
  workspace?: Maybe<Workspace>;
  /** Workspace ID */
  workspaceId: Scalars['ID']['output'];
};

/** Subscription provider enum. */
export enum SubscriptionProvider {
  Coffee = 'coffee',
  Stripe = 'stripe'
}

/** Subscription status enum (Stripe standard states). */
export enum SubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Paused = 'paused',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

/** An enumeration. */
export enum SummaryTemplate {
  Bant = 'BANT',
  Default = 'DEFAULT',
  Meddic = 'MEDDIC',
  Meddpicc = 'MEDDPICC',
  Spiced = 'SPICED'
}

export type SummaryTemplateClass = Node & {
  __typename?: 'SummaryTemplateClass';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isWorkspaceWide?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<TemplateSection>>>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type SummaryTemplateConnection = {
  __typename?: 'SummaryTemplateConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SummaryTemplateEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SummaryTemplate` and its cursor. */
export type SummaryTemplateEdge = {
  __typename?: 'SummaryTemplateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<SummaryTemplateClass>;
};

export type SummaryTemplateFilter = {
  createdByUserId?: InputMaybe<Scalars['Int']['input']>;
  isWorkspaceWide?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type SummaryTemplateType = {
  __typename?: 'SummaryTemplateType';
  id?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isWorkspaceWide?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<TemplateSectionType>>>;
  wkspId?: Maybe<Scalars['Int']['output']>;
};

/**
 * Manual Fireflies sync. When `lookbackDays` is omitted, reuse the import
 * window chosen at connect time; a new value is saved for next time.
 */
export type SyncFireflies = {
  __typename?: 'SyncFireflies';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Manual sync of the workspace Fireflies connection (admin only). */
export type SyncFirefliesWorkspace = {
  __typename?: 'SyncFirefliesWorkspace';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Manual Granola sync. When `lookbackDays` is omitted, reuse the import
 * window the user chose at connect time (stored in the connection's watches).
 * Used by the Sync button on the connected Granola card.
 */
export type SyncGranola = {
  __typename?: 'SyncGranola';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskSuggestion = Node & {
  __typename?: 'TaskSuggestion';
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  convertedTaskId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAccepted?: Maybe<Scalars['Boolean']['output']>;
  isDismissed?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  sourceEngagement?: Maybe<Engagement>;
  sourceEngagementId?: Maybe<Scalars['String']['output']>;
  sourceQuote?: Maybe<Scalars['String']['output']>;
  suggestedAccountIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  suggestedAccounts?: Maybe<Array<Maybe<Account>>>;
  suggestedAssigneeId?: Maybe<Scalars['Int']['output']>;
  suggestedContactIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  suggestedContacts?: Maybe<Array<Maybe<Contact>>>;
  suggestedDueDate?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type TaskSuggestionConnection = {
  __typename?: 'TaskSuggestionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaskSuggestionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TaskSuggestion` and its cursor. */
export type TaskSuggestionEdge = {
  __typename?: 'TaskSuggestionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<TaskSuggestion>;
};

export type TaskSuggestionFilter = {
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  isDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  sourceEngagementId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type TasksVisibilityInput = {
  /** Who can see tasks: 'assignee', 'admins_and_owners', or 'everyone'. */
  tasksVisibility: Scalars['String']['input'];
};

export type TechTag = Node & {
  __typename?: 'TechTag';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type TechTagConnection = {
  __typename?: 'TechTagConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TechTagEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TechTag` and its cursor. */
export type TechTagEdge = {
  __typename?: 'TechTagEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TechTag>;
};

export type TechTagFilter = {
  search: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/** A section within a summary template (output type). */
export type TemplateSection = {
  __typename?: 'TemplateSection';
  crmField?: Maybe<Scalars['String']['output']>;
  heading: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
};

/** A section within a summary template (input type). */
export type TemplateSectionInput = {
  crmField?: InputMaybe<Scalars['String']['input']>;
  heading: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type TemplateSectionType = {
  __typename?: 'TemplateSectionType';
  crmField?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
};

export type TemporalTrackerEntry = {
  __typename?: 'TemporalTrackerEntry';
  createTs: Scalars['DateTime']['output'];
  runId: Scalars['String']['output'];
  stepName: Scalars['String']['output'];
};

export type TemporalTrackerRun = {
  __typename?: 'TemporalTrackerRun';
  entries?: Maybe<Array<Maybe<TemporalTrackerEntry>>>;
  expectedNumSteps?: Maybe<Scalars['Int']['output']>;
  runId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
  workflowType: Scalars['String']['output'];
  workspaceId: Scalars['Int']['output'];
};

/**
 * Dry-run a draft agent against a live model with stub tools (no CRM/Slack/Temporal side
 * effects) so an author can see the tool-call plan + whether the instruction is feasible BEFORE
 * saving/enabling. Read-only preview — off the real fire path. See
 * docs/archive/byoa-agents-ui-backend-contract.md.
 */
export type TestAgentDefinition = {
  __typename?: 'TestAgentDefinition';
  result?: Maybe<TestAgentResult>;
};

/** A draft agent to preview — same shape as create, but nothing is persisted. */
export type TestAgentDefinitionInput = {
  allowedTools?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  conditions?: InputMaybe<Scalars['JSONString']['input']>;
  guardActions?: InputMaybe<Scalars['JSONString']['input']>;
  maxIterations?: InputMaybe<Scalars['Int']['input']>;
  modelUseCase?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyEmail?: InputMaybe<Scalars['Boolean']['input']>;
  notifySlack?: InputMaybe<Scalars['Boolean']['input']>;
  notifyTarget?: InputMaybe<Scalars['String']['input']>;
  notifyUserIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  previewId?: InputMaybe<Scalars['String']['input']>;
  sampleEntityId?: InputMaybe<Scalars['String']['input']>;
  systemPrompt: Scalars['String']['input'];
  trigger?: InputMaybe<AgentTriggerInput>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};

/**
 * The dry-run preview: what the agent WOULD do against real workspace data, with every
 * mutating tool stubbed.
 *
 * Everything the UI states as fact about the run comes from a structured field here.
 * ``output`` is the model's prose and is the ONE field that isn't evidence — it is a draft of
 * the message the agent would send, and it will happily narrate "I sent this" in the past
 * tense. Render it labelled as a draft; never as the record of what happened.
 */
export type TestAgentResult = {
  __typename?: 'TestAgentResult';
  allowedTools: Array<Maybe<Scalars['String']['output']>>;
  anchorField?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Scalars['JSONString']['output']>;
  campaignDescription?: Maybe<Scalars['String']['output']>;
  daysBefore?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  deliverySinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  feasible: Scalars['Boolean']['output'];
  intendedEffects?: Maybe<Array<Maybe<IntendedEffect>>>;
  iterations?: Maybe<Scalars['Int']['output']>;
  notifyTarget?: Maybe<Scalars['String']['output']>;
  notifyTargetLabel?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  pathPattern?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  recordsRead?: Maybe<Array<Maybe<ToolReadCount>>>;
  repeat?: Maybe<Scalars['String']['output']>;
  sampleEntityId?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Array<Maybe<AgentSource>>>;
  stopReason?: Maybe<Scalars['String']['output']>;
  toolsCalled: Array<Maybe<Scalars['String']['output']>>;
  truncated?: Maybe<Scalars['Boolean']['output']>;
  usage?: Maybe<Scalars['JSONString']['output']>;
  usageDescription?: Maybe<Scalars['String']['output']>;
  validationError?: Maybe<Scalars['String']['output']>;
};

/**
 * Blast-radius preview: evaluate the rule against current data and report what it
 * WOULD do, executing nothing. Resolves the rule's target entities via its stored
 * filter (empty filter = all entities of its object type), then describes each
 * matched entity's actions. Bounded by the sample cap so it stays cheap.
 */
export type TestRunAutomationRule = {
  __typename?: 'TestRunAutomationRule';
  result?: Maybe<RuleTestRunResult>;
};

/** How many records one read tool returned during the preview. */
export type ToolReadCount = {
  __typename?: 'ToolReadCount';
  count: Scalars['Int']['output'];
  tool: Scalars['String']['output'];
};

export type TrackEngagementViewType = {
  __typename?: 'TrackEngagementViewType';
  aiSummary?: Maybe<Scalars['String']['output']>;
  coffeeVideoUrl?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  firefliesTranscript?: Maybe<Array<Maybe<TranscriptEntryType>>>;
  firefliesVideoUrl?: Maybe<Scalars['String']['output']>;
  gongTranscript?: Maybe<Array<Maybe<TranscriptEntryType>>>;
  gongVideoUrl?: Maybe<Scalars['String']['output']>;
  granolaTranscript?: Maybe<Array<Maybe<TranscriptEntryType>>>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  platform?: Maybe<Scalars['String']['output']>;
  recallTranscript?: Maybe<Array<Maybe<TranscriptEntryType>>>;
  recallVideoUrl?: Maybe<Scalars['String']['output']>;
  sharedBy?: Maybe<SharedByUser>;
  summaries?: Maybe<Array<Maybe<EngagementSummaryType>>>;
  summaryTemplates?: Maybe<Array<Maybe<SummaryTemplateType>>>;
};

export type TranscriptEntryType = {
  __typename?: 'TranscriptEntryType';
  language?: Maybe<Scalars['String']['output']>;
  speaker?: Maybe<Scalars['String']['output']>;
  speakerId?: Maybe<Scalars['Int']['output']>;
  words?: Maybe<Array<Maybe<TranscriptWordType>>>;
};

export type TranscriptWordType = {
  __typename?: 'TranscriptWordType';
  confidence?: Maybe<Scalars['Float']['output']>;
  endTimestamp?: Maybe<Scalars['Float']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/**
 * Turn push off for this device.
 *
 * Soft: sets `revoked_at` rather than deleting, so the row stays auditable and the retention
 * pruner is the only thing that removes it. Scoped to the caller, so knowing someone else's
 * endpoint does not let you silence their phone.
 */
export type UnregisterPushSubscription = {
  __typename?: 'UnregisterPushSubscription';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAccount = {
  __typename?: 'UpdateAccount';
  account?: Maybe<Account>;
};

export type UpdateAccountInput = {
  associatedAccountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customProperties?: InputMaybe<Scalars['GenericScalar']['input']>;
  id: Scalars['ID']['input'];
  properties?: InputMaybe<AccountPropertiesInput>;
};

export type UpdateAgentDefinition = {
  __typename?: 'UpdateAgentDefinition';
  agent?: Maybe<AgentDefinition>;
};

export type UpdateAgentDefinitionInput = {
  allowedTools?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  conditions?: InputMaybe<Scalars['JSONString']['input']>;
  guardActions?: InputMaybe<Scalars['JSONString']['input']>;
  id: Scalars['ID']['input'];
  maxIterations?: InputMaybe<Scalars['Int']['input']>;
  modelUseCase?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyEmail?: InputMaybe<Scalars['Boolean']['input']>;
  notifySlack?: InputMaybe<Scalars['Boolean']['input']>;
  notifyTarget?: InputMaybe<Scalars['String']['input']>;
  notifyUserIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<AgentTriggerInput>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type UpdateAutoRechargeInput = {
  enabled: Scalars['Boolean']['input'];
  /** Credit pack id to auto-purchase; required when enabled=true. */
  packId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateAutoRechargePreferences = {
  __typename?: 'UpdateAutoRechargePreferences';
  preferences?: Maybe<WorkspacePreferences>;
};

export type UpdateAutomationRule = {
  __typename?: 'UpdateAutomationRule';
  rule?: Maybe<AutomationRule>;
};

export type UpdateAutomationRuleInput = {
  actions?: InputMaybe<Scalars['JSONString']['input']>;
  conditions?: InputMaybe<Scalars['JSONString']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['JSONString']['input']>;
  workspaceId: Scalars['Int']['input'];
};

/** Input for updating billing settings. */
export type UpdateBillingSettingsInput = {
  /** Credits to USD rate */
  creditsToUsdRate: Scalars['Float']['input'];
};

/** Update billing settings. */
export type UpdateBillingSettingsMutation = {
  __typename?: 'UpdateBillingSettingsMutation';
  billingSettings?: Maybe<BillingSettings>;
};

export type UpdateBriefTemplate = {
  __typename?: 'UpdateBriefTemplate';
  briefTemplate?: Maybe<BriefTemplateClass>;
};

export type UpdateBriefTemplateInput = {
  id: Scalars['ID']['input'];
  isWorkspaceWide?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<InputMaybe<BriefTemplateSectionInput>>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateCampaign = {
  __typename?: 'UpdateCampaign';
  campaign?: Maybe<Campaign>;
};

export type UpdateCampaignInput = {
  additionalListIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id: Scalars['ID']['input'];
  listId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSONString']['input']>;
  steps?: InputMaybe<Array<InputMaybe<CampaignStepInput>>>;
  workspaceId: Scalars['Int']['input'];
};

export type UpdateContact = {
  __typename?: 'UpdateContact';
  contact?: Maybe<Contact>;
};

export type UpdateContactInput = {
  customProperties?: InputMaybe<Scalars['GenericScalar']['input']>;
  id: Scalars['ID']['input'];
  properties?: InputMaybe<ContactPropertiesInput>;
};

/** Input for updating credit transaction. */
export type UpdateCreditUsageLogInput = {
  /** Admin note */
  adminNote?: InputMaybe<Scalars['String']['input']>;
  /** Transaction ID */
  id: Scalars['ID']['input'];
  /** Stripe invoice ID */
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  /** New status */
  status?: InputMaybe<CreditUsageStatus>;
};

/** Update credit transaction status and details. */
export type UpdateCreditUsageLogMutation = {
  __typename?: 'UpdateCreditUsageLogMutation';
  creditUsageLog?: Maybe<CreditUsageLog>;
};

export type UpdateCrmIngestionConfigInput = {
  pipelineId?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<CrmIngestionPlatform>;
  selectedStageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  syncBack?: InputMaybe<Scalars['Boolean']['input']>;
  syncBackEntityTypes?: InputMaybe<Scalars['JSONString']['input']>;
  syncForward?: InputMaybe<Scalars['Boolean']['input']>;
  syncForwardEntityTypes?: InputMaybe<Scalars['JSONString']['input']>;
  windowEndDate?: InputMaybe<Scalars['Date']['input']>;
  windowStartDate?: InputMaybe<Scalars['Date']['input']>;
  workspaceId: Scalars['Int']['input'];
};

export type UpdateDeal = {
  __typename?: 'UpdateDeal';
  deal?: Maybe<Deal>;
};

export type UpdateDealCreationFields = {
  __typename?: 'UpdateDealCreationFields';
  fields?: Maybe<Array<Maybe<DealCreationField>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Update an existing deal field.
 * Note: field_name cannot be changed as it's used as the key in deal_info.properties.
 */
export type UpdateDealField = {
  __typename?: 'UpdateDealField';
  dealField?: Maybe<DealFieldClass>;
};

/** Input for updating an existing deal field. */
export type UpdateDealFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type UpdateDealInput = {
  coffeeCustomProperties?: InputMaybe<Scalars['GenericScalar']['input']>;
  customProperties?: InputMaybe<Array<InputMaybe<CustomPropertyInput>>>;
  /** Update deal_info field values */
  dealInfoProperties?: InputMaybe<Array<InputMaybe<DealInfoPropertyInput>>>;
  id: Scalars['ID']['input'];
  properties?: InputMaybe<DealPropertiesInput>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDealStage = {
  __typename?: 'UpdateDealStage';
  dealStage?: Maybe<DealStage>;
};

export type UpdateDealStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  colorCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isLost?: InputMaybe<Scalars['Boolean']['input']>;
  isWon?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  probability?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Set per-entity default record visibility (default-record-acl plan). Only
 * the supplied fields change. When record sharing is enabled, each CHANGED
 * entity kicks off the record_acl_backfill workflow, which restamps every
 * existing default-managed (acl_source != 'custom') record of that entity;
 * while sharing is off, values are stored and reconciled on enable.
 */
export type UpdateDefaultRecordAcl = {
  __typename?: 'UpdateDefaultRecordAcl';
  preferences?: Maybe<WorkspacePreferences>;
};

export type UpdateDomainAllowlist = {
  __typename?: 'UpdateDomainAllowlist';
  domainAllowlist?: Maybe<DomainAllowlist>;
};

export type UpdateDomainAllowlistInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateEmailTemplate = {
  __typename?: 'UpdateEmailTemplate';
  emailTemplate?: Maybe<EmailTemplateClass>;
};

export type UpdateEmailTemplateInput = {
  attachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isWorkspaceWide?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateEmailVisibilityPreferences = {
  __typename?: 'UpdateEmailVisibilityPreferences';
  preferences?: Maybe<WorkspacePreferences>;
};

/**
 * Save a user's correction to a meeting summary (the meeting sheet's Summary tab).
 *
 * Writes only the summary text. It never re-runs deal-field updates from the edited
 * sections, and keeps the deal-field applied stamps, so the late-link reconciler's
 * "applied once" bookkeeping is unchanged. The doc is marked ``user_edited_at`` so a
 * later regeneration (save_engagement_summary_to_db) keeps the edit.
 *
 * Gated on the ``meeting-summary-edit`` workspace preference (default off).
 */
export type UpdateEngagementSummary = {
  __typename?: 'UpdateEngagementSummary';
  aiSummary?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<EngagementSummaryType>;
};

export type UpdateEngagementSummaryInput = {
  engagementId: Scalars['String']['input'];
  sections: Scalars['JSONString']['input'];
  summaryTemplateId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateIngestionFieldInput = {
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  availableInRevgpt?: InputMaybe<Scalars['Boolean']['input']>;
  crmFieldType?: InputMaybe<CrmIngestionFieldType>;
  crmLabel?: InputMaybe<Scalars['String']['input']>;
  crmName?: InputMaybe<Scalars['String']['input']>;
  customFieldType?: InputMaybe<CustomFieldType>;
  fieldConfig?: InputMaybe<Scalars['JSONString']['input']>;
  id: Scalars['Int']['input'];
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceFieldType?: InputMaybe<CrmIngestionFieldType>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  syncBack?: InputMaybe<Scalars['Boolean']['input']>;
  syncBackDestinationName?: InputMaybe<Scalars['String']['input']>;
  syncForward?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateList = {
  __typename?: 'UpdateList';
  list?: Maybe<List>;
};

export type UpdateListFolder = {
  __typename?: 'UpdateListFolder';
  listFolder?: Maybe<ListFolder>;
};

export type UpdateListFolderInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateListInput = {
  ensureUniqueName?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSONString']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMeetingBot = {
  __typename?: 'UpdateMeetingBot';
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateMeetingRecording = {
  __typename?: 'UpdateMeetingRecording';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateNtfPreferences = {
  __typename?: 'UpdateNTFPreferences';
  preferences?: Maybe<UserPreferences>;
};

export type UpdateNote = {
  __typename?: 'UpdateNote';
  note?: Maybe<Note>;
};

export type UpdateNoteInput = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiNotesContent?: InputMaybe<Scalars['JSONString']['input']>;
  blocks?: InputMaybe<Scalars['JSONString']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dealIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  engagementIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
  priority?: InputMaybe<NotePriorityEnum>;
  status?: InputMaybe<NoteStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdatePcPreferences = {
  __typename?: 'UpdatePCPreferences';
  preferences?: Maybe<UserPreferences>;
};

export type UpdateProduct = {
  __typename?: 'UpdateProduct';
  product?: Maybe<Product>;
};

export type UpdateProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdatePublicVisibilityPreferences = {
  __typename?: 'UpdatePublicVisibilityPreferences';
  preferences?: Maybe<WorkspacePreferences>;
};

export type UpdateRecordSharingPreferences = {
  __typename?: 'UpdateRecordSharingPreferences';
  preferences?: Maybe<WorkspacePreferences>;
};

export type UpdateReportDefinition = {
  __typename?: 'UpdateReportDefinition';
  report?: Maybe<ReportDefinition>;
};

export type UpdateReportDefinitionInput = {
  definition?: InputMaybe<Scalars['JSONString']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['JSONString']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateSummaryTemplate = {
  __typename?: 'UpdateSummaryTemplate';
  summaryTemplate?: Maybe<SummaryTemplateClass>;
};

export type UpdateSummaryTemplateInput = {
  id: Scalars['ID']['input'];
  isWorkspaceWide?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<InputMaybe<TemplateSectionInput>>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateTasksVisibilityPreferences = {
  __typename?: 'UpdateTasksVisibilityPreferences';
  preferences?: Maybe<WorkspacePreferences>;
};

export type UpdateUser = {
  __typename?: 'UpdateUser';
  user?: Maybe<User>;
};

export type UpdateUserGroup = {
  __typename?: 'UpdateUserGroup';
  userGroup?: Maybe<UserGroupType>;
};

export type UpdateUserInput = {
  defaultBriefTemplateId?: InputMaybe<Scalars['String']['input']>;
  defaultSummaryTemplateId?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
  workspaceRole?: InputMaybe<WorkspaceRoleInput>;
};

/**
 * Set the signed-in user's language.
 *
 * Deliberately NOT a field on NTFPreferencesInput: that input has eight
 * required booleans, so folding language into it would force the language
 * picker to resubmit the whole notification form (and race anyone editing it).
 * A dedicated single-purpose mutation writes exactly one JSONB key.
 *
 * Authorized with require_workspace_membership rather than
 * require_workspace_data_write: this is a per-user display preference, not
 * workspace data, so read-only seats must be able to set their own language.
 */
export type UpdateUserLanguage = {
  __typename?: 'UpdateUserLanguage';
  preferences?: Maybe<UserPreferences>;
};

export type UpdateUserList = {
  __typename?: 'UpdateUserList';
  userList?: Maybe<UserList>;
};

export type UpdateUserListInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  listId: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateVcPreferences = {
  __typename?: 'UpdateVCPreferences';
  preferences?: Maybe<UserPreferences>;
};

export type UpdateWorkspace = {
  __typename?: 'UpdateWorkspace';
  workspace?: Maybe<Workspace>;
};

/** Update a custom knowledge area's name, content, or attached file. */
export type UpdateWorkspaceCustomKnowledge = {
  __typename?: 'UpdateWorkspaceCustomKnowledge';
  customKnowledge?: Maybe<WorkspaceCustomKnowledgeType>;
};

export type UpdateWorkspaceCustomKnowledgeInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Set (or clear) the workspace default language.
 *
 * Admin-only: it changes what every member without a personal language
 * preference sees. Writes exactly one JSONB key so it never clobbers the rest
 * of the workspace preferences blob.
 */
export type UpdateWorkspaceDefaultLanguage = {
  __typename?: 'UpdateWorkspaceDefaultLanguage';
  preferences?: Maybe<WorkspacePreferences>;
};

export type UpdateWorkspaceDefaultLanguageInput = {
  /** Language tag, e.g. 'pt' or 'pt-BR'. Normalized to one of: en, es, fr, nl, de, it, ja, zh, da, pt. Pass null or an empty string to clear the workspace default. */
  language?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateWorkspaceInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  currentApp?: InputMaybe<AppType>;
  domain?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Update or create workspace intelligence. */
export type UpdateWorkspaceIntelligence = {
  __typename?: 'UpdateWorkspaceIntelligence';
  intelligence?: Maybe<WorkspaceIntelligenceType>;
};

export type UpdateWorkspaceIntelligenceInput = {
  buyerPersonas?: InputMaybe<Scalars['String']['input']>;
  competitorList?: InputMaybe<Scalars['String']['input']>;
  defaultBriefTemplateId?: InputMaybe<Scalars['String']['input']>;
  defaultSummaryTemplateId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icp?: InputMaybe<Scalars['String']['input']>;
  personalPreferences?: InputMaybe<Scalars['String']['input']>;
  productsServices?: InputMaybe<Scalars['String']['input']>;
  salesProcess?: InputMaybe<Scalars['String']['input']>;
  valuePropositions?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateWorkspacePreferences = {
  __typename?: 'UpdateWorkspacePreferences';
  preferences?: Maybe<WorkspacePreferences>;
};

export type UpdateWorkspacePreferencesInput = {
  fiscalYearStartDay?: InputMaybe<Scalars['Int']['input']>;
  fiscalYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  leadFinderResultCap?: InputMaybe<Scalars['Int']['input']>;
  preferences?: InputMaybe<Scalars['GenericScalar']['input']>;
  revenueGpt?: InputMaybe<RevenueGptPreferencesInput>;
  workspaceId: Scalars['ID']['input'];
};

/**
 * Bring one starter-derived agent forward to its template's current revision.
 *
 * Applies only the fields the template moved and the author never edited; ``conflicts`` — where
 * both moved — are reported and left as the author wrote them unless ``includeConflicts`` is
 * set. That default is the whole point: a template change that silently reverted an author's
 * edits would be a worse failure than one that does nothing
 * (docs/reference/byoa-template-change-policy.md).
 *
 * Admin/owner-gated exactly like an edit, because that is what it is.
 */
export type UpgradeAgentFromTemplate = {
  __typename?: 'UpgradeAgentFromTemplate';
  agent?: Maybe<AgentDefinition>;
  applied: Array<Maybe<Scalars['String']['output']>>;
  authorEdited: Array<Maybe<Scalars['String']['output']>>;
  conflicts: Array<Maybe<Scalars['String']['output']>>;
};

export type UpsertAccount = {
  __typename?: 'UpsertAccount';
  account?: Maybe<Account>;
};

export type UpsertAccountInput = {
  associatedAccountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customProperties?: InputMaybe<Scalars['GenericScalar']['input']>;
  key: UpsertAccountKey;
  properties?: InputMaybe<AccountPropertiesInput>;
  workspaceId: Scalars['ID']['input'];
};

export type UpsertAccountKey = {
  domain?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertContact = {
  __typename?: 'UpsertContact';
  contact?: Maybe<Contact>;
};

export type UpsertContactInput = {
  customProperties?: InputMaybe<Scalars['GenericScalar']['input']>;
  key: UpsertContactKey;
  properties?: InputMaybe<ContactPropertiesInput>;
  workspaceId: Scalars['ID']['input'];
};

export type UpsertContactKey = {
  linkedin?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDeal = {
  __typename?: 'UpsertDeal';
  deal?: Maybe<Deal>;
};

export type UpsertDealInput = {
  customProperties?: InputMaybe<Scalars['GenericScalar']['input']>;
  key: UpsertDealKey;
  properties?: InputMaybe<DealPropertiesInput>;
  workspaceId: Scalars['ID']['input'];
};

export type UpsertDealKey = {
  domain?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
};

export type User = Node & {
  __typename?: 'User';
  avatarBackground?: Maybe<Scalars['String']['output']>;
  defaultBriefTemplateId?: Maybe<Scalars['String']['output']>;
  defaultSummaryTemplateId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailSignature?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inviteStatus?: Maybe<UserInviteStatusEnum>;
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastLoginTs?: Maybe<Scalars['String']['output']>;
  lastWorkspaceId?: Maybe<Scalars['Int']['output']>;
  lists?: Maybe<ListConnection>;
  manager?: Maybe<User>;
  oauthPlatform?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  referralSource?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  source?: Maybe<UserWorkspaceSourceEnum>;
  surname?: Maybe<Scalars['String']['output']>;
  userLists?: Maybe<UserListConnection>;
  workspaces?: Maybe<Array<Maybe<Workspace>>>;
};


export type UserInviteStatusArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type UserLastLoginTsArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type UserListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserManagerArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type UserRoleArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type UserSourceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type UserUserListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `User` and its cursor. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<User>;
};

export type UserFavoriteType = {
  __typename?: 'UserFavoriteType';
  createTs?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  extraData?: Maybe<Scalars['JSONString']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type UserFilterInput = {
  hasDeal?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UserGroupType = {
  __typename?: 'UserGroupType';
  createTs?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  memberUserIds: Array<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Non-null for auto-managed system groups ('admins', 'manager_of:<user_id>', 'private'); their rosters are computed, not stored, and their mutations are refused. */
  systemKey?: Maybe<Scalars['String']['output']>;
  updateTs?: Maybe<Scalars['DateTime']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type UserIntegration = {
  __typename?: 'UserIntegration';
  accessToken?: Maybe<Scalars['String']['output']>;
  addedTs?: Maybe<Scalars['DateTime']['output']>;
  disconnectReason?: Maybe<DisconnectReason>;
  keepCoffeeRecording?: Maybe<Scalars['Boolean']['output']>;
  lookbackDays?: Maybe<Scalars['Int']['output']>;
  platform: UserIntegrationPlatform;
  status?: Maybe<UserIntegrationStatus>;
  user?: Maybe<GraphQlUser>;
  watches?: Maybe<Scalars['JSONString']['output']>;
  webhookSecret?: Maybe<Scalars['String']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
  workspaceId: Scalars['Int']['output'];
};

export type UserIntegrationHealth = {
  __typename?: 'UserIntegrationHealth';
  daysSinceLastEngagement?: Maybe<Scalars['Int']['output']>;
  health: IntegrationHealthLevel;
  healthReason?: Maybe<Scalars['String']['output']>;
  lastEngagementTs?: Maybe<Scalars['DateTime']['output']>;
  lastLoginTs?: Maybe<Scalars['DateTime']['output']>;
  platform: Scalars['String']['output'];
  /** Raw integration status (active/inactive); context only -- not the health signal */
  status: Scalars['String']['output'];
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  workspaceId: Scalars['Int']['output'];
  workspaceName?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum UserIntegrationPlatform {
  Fireflies = 'FIREFLIES',
  GoogleCalendar = 'GOOGLE_CALENDAR',
  Granola = 'GRANOLA',
  Microsoft = 'MICROSOFT',
  Slack = 'SLACK',
  Zoom = 'ZOOM'
}

/** An enumeration. */
export enum UserIntegrationStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type UserIntegrationSync = {
  __typename?: 'UserIntegrationSync';
  ok?: Maybe<Scalars['Boolean']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
};

export enum UserInviteStatusEnum {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type UserList = Node & {
  __typename?: 'UserList';
  createTs: Scalars['DateTime']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  list: List;
  listId: Scalars['ID']['output'];
  pinned: Scalars['Boolean']['output'];
  updateTs: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type UserListConnection = {
  __typename?: 'UserListConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserListEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `UserList` and its cursor. */
export type UserListEdge = {
  __typename?: 'UserListEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  /** The item at the end of the edge */
  node?: Maybe<UserList>;
};

export type UserListFilter = {
  listId?: InputMaybe<Scalars['ID']['input']>;
  modelType?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  /** Action Items Due Today */
  actionItemsDue?: Maybe<Scalars['Boolean']['output']>;
  /** Close date in the past */
  closeDateInPast?: Maybe<Scalars['Boolean']['output']>;
  createTs: Scalars['DateTime']['output'];
  /** Whether default email templates have been seeded for this user */
  createdDefaultEmailTemplates?: Maybe<Scalars['Boolean']['output']>;
  /** Notification delivery method (EMAIL, SLACK, or both) */
  deliveryMethod?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Today's External Meetings */
  externalMeetings?: Maybe<Scalars['Boolean']['output']>;
  /** 1 or fewer linked contacts */
  fewContacts?: Maybe<Scalars['Boolean']['output']>;
  /** List of meetings with follow-up email links */
  followUpEmails?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** UI/content language for this user (one of: en, es, fr, nl, de, it, ja, zh, da, pt). Null means no explicit choice — the workspace default or Accept-Language applies. Read-only here; set it with updateUserLanguage. */
  language?: Maybe<Scalars['String']['output']>;
  /** No activity in past 2 weeks */
  noActivity?: Maybe<Scalars['Boolean']['output']>;
  /** No next steps */
  noNextSteps?: Maybe<Scalars['Boolean']['output']>;
  notificationChannels?: Maybe<Scalars['JSONString']['output']>;
  /** Productivity & Collaboration contacts accounts from emails */
  pcContactsAccountsFromEmails?: Maybe<Scalars['Boolean']['output']>;
  /** Productivity & Collaboration contacts accounts from meetings */
  pcContactsAccountsFromMeetings?: Maybe<Scalars['Boolean']['output']>;
  preferences: Scalars['JSONString']['output'];
  /** Suggested changes to deals based on meeting transcripts/emails */
  suggestedChanges?: Maybe<Scalars['Boolean']['output']>;
  /** Resolved IANA timezone used to schedule notification digests */
  timezone?: Maybe<Scalars['String']['output']>;
  updateTs: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
  /** Video Conferencing bot name */
  vcBotName?: Maybe<Scalars['String']['output']>;
  /** Video Conferencing record meetings */
  vcRecordMeetings?: Maybe<Scalars['Boolean']['output']>;
  /** Video Conferencing record meetings type */
  vcRecordMeetingsType?: Maybe<Scalars['String']['output']>;
  /** Recorder in-call appearance: default|minimal|custom */
  vcRecorderAppearance?: Maybe<Scalars['String']['output']>;
  /** Public S3 URL of the custom recorder image */
  vcRecorderCustomImageUrl?: Maybe<Scalars['String']['output']>;
  /** Video Conferencing recorder type */
  vcRecorderType?: Maybe<Scalars['String']['output']>;
  /** Video Conferencinguse custom bot name */
  vcUseCustomBotName?: Maybe<Scalars['Boolean']['output']>;
  workspaceId: Scalars['Int']['output'];
};

export type UserQuotaInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  periodStart: Scalars['Date']['input'];
  periodType: QuotaPeriodType;
  userId: Scalars['ID']['input'];
};

export type UserQuotaType = {
  __typename?: 'UserQuotaType';
  amount?: Maybe<Scalars['Float']['output']>;
  createTs?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  periodStart?: Maybe<Scalars['Date']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  updateTs?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum UserSortEnum {
  AvatarBackgroundAsc = 'AVATAR_BACKGROUND_ASC',
  AvatarBackgroundDesc = 'AVATAR_BACKGROUND_DESC',
  DefaultBriefTemplateIdAsc = 'DEFAULT_BRIEF_TEMPLATE_ID_ASC',
  DefaultBriefTemplateIdDesc = 'DEFAULT_BRIEF_TEMPLATE_ID_DESC',
  DefaultSummaryTemplateIdAsc = 'DEFAULT_SUMMARY_TEMPLATE_ID_ASC',
  DefaultSummaryTemplateIdDesc = 'DEFAULT_SUMMARY_TEMPLATE_ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EmailSignatureAsc = 'EMAIL_SIGNATURE_ASC',
  EmailSignatureDesc = 'EMAIL_SIGNATURE_DESC',
  GivenNameAsc = 'GIVEN_NAME_ASC',
  GivenNameDesc = 'GIVEN_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOnboardedAsc = 'IS_ONBOARDED_ASC',
  IsOnboardedDesc = 'IS_ONBOARDED_DESC',
  IsSuperuserAsc = 'IS_SUPERUSER_ASC',
  IsSuperuserDesc = 'IS_SUPERUSER_DESC',
  LastLoginAsc = 'LAST_LOGIN_ASC',
  LastLoginDesc = 'LAST_LOGIN_DESC',
  LastWorkspaceIdAsc = 'LAST_WORKSPACE_ID_ASC',
  LastWorkspaceIdDesc = 'LAST_WORKSPACE_ID_DESC',
  PreferredNameAsc = 'PREFERRED_NAME_ASC',
  PreferredNameDesc = 'PREFERRED_NAME_DESC',
  ProfileImageUrlAsc = 'PROFILE_IMAGE_URL_ASC',
  ProfileImageUrlDesc = 'PROFILE_IMAGE_URL_DESC',
  ReferralSourceAsc = 'REFERRAL_SOURCE_ASC',
  ReferralSourceDesc = 'REFERRAL_SOURCE_DESC',
  SurnameAsc = 'SURNAME_ASC',
  SurnameDesc = 'SURNAME_DESC'
}

export enum UserWorkspaceSourceEnum {
  Crm = 'CRM',
  Invite = 'INVITE',
  Signup = 'SIGNUP'
}

export type VcPreferencesInput = {
  vcBotName: Scalars['String']['input'];
  vcRecordMeetings: Scalars['Boolean']['input'];
  vcRecordMeetingsType: Scalars['String']['input'];
  vcRecorderAppearance?: InputMaybe<Scalars['String']['input']>;
  vcRecorderCustomImageUrl?: InputMaybe<Scalars['String']['input']>;
  vcRecorderType: Scalars['String']['input'];
  vcUseCustomBotName: Scalars['Boolean']['input'];
};

export type WorkflowStatusType = {
  __typename?: 'WorkflowStatusType';
  ok?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Workspace = Node & {
  __typename?: 'Workspace';
  /** Company name from MDM, populated at workspace creation */
  companyName?: Maybe<Scalars['String']['output']>;
  currentApp: AppType;
  domain: Scalars['String']['output'];
  /** All email domains that map to this workspace (primary + alternates) */
  domains?: Maybe<Array<Maybe<WorkspaceDomain>>>;
  earliestCompareDate?: Maybe<Scalars['DateTime']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the requesting user is a member of this workspace (set by superuser workspace resolver) */
  isMember?: Maybe<Scalars['Boolean']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboarding?: Maybe<WorkspaceOnboarding>;
  sourceApp: AppType;
  status?: Maybe<Scalars['String']['output']>;
  /** Stripe customer ID for this workspace */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Subscription information for this workspace */
  subscription?: Maybe<Subscription>;
  users?: Maybe<UserConnection>;
};


export type WorkspaceUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkspaceConnection = {
  __typename?: 'WorkspaceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkspaceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** One connection, as a Settings card reads it. */
export type WorkspaceConnectionType = {
  __typename?: 'WorkspaceConnectionType';
  auth: Scalars['String']['output'];
  disconnectReason?: Maybe<Scalars['String']['output']>;
  discoveredTools?: Maybe<Scalars['JSONString']['output']>;
  domainLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  domainMap?: Maybe<Scalars['JSONString']['output']>;
  domains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  domainsConfirmed?: Maybe<Scalars['Boolean']['output']>;
  entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityMap?: Maybe<Scalars['JSONString']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastSyncAt?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  reconfirmReason?: Maybe<Scalars['String']['output']>;
  serverUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** GraphQL type for a single user-defined knowledge area on a workspace. */
export type WorkspaceCustomKnowledgeType = {
  __typename?: 'WorkspaceCustomKnowledgeType';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  extractedAt?: Maybe<Scalars['DateTime']['output']>;
  extractedText?: Maybe<Scalars['String']['output']>;
  extractionStatus?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceDomain = {
  __typename?: 'WorkspaceDomain';
  domain: Scalars['String']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  /** True when ownership was corroborated (e.g. same Microsoft tenant); admin-trusted otherwise */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** A Relay edge containing a `Workspace` and its cursor. */
export type WorkspaceEdge = {
  __typename?: 'WorkspaceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Workspace>;
};

export type WorkspaceEmailSuppression = {
  __typename?: 'WorkspaceEmailSuppression';
  createTs?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  sourceCampaignId?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceFilter = {
  hasActiveSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** GraphQL type for a file attached to a built-in intelligence section. */
export type WorkspaceIntelligenceSectionFileType = {
  __typename?: 'WorkspaceIntelligenceSectionFileType';
  extractedAt?: Maybe<Scalars['DateTime']['output']>;
  extractedText?: Maybe<Scalars['String']['output']>;
  extractionStatus?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
};

/** GraphQL type for the workspace-level Intelligence section. */
export type WorkspaceIntelligenceType = {
  __typename?: 'WorkspaceIntelligenceType';
  buyerPersonas?: Maybe<Scalars['String']['output']>;
  competitorList?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customKnowledgeAreas?: Maybe<Array<Maybe<WorkspaceCustomKnowledgeType>>>;
  defaultBriefTemplateId?: Maybe<Scalars['String']['output']>;
  defaultSummaryTemplateId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  formattedContext?: Maybe<Scalars['String']['output']>;
  icp?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  personalPreferences?: Maybe<Scalars['String']['output']>;
  productsServices?: Maybe<Scalars['String']['output']>;
  salesProcess?: Maybe<Scalars['String']['output']>;
  sectionFiles?: Maybe<Array<Maybe<WorkspaceIntelligenceSectionFileType>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  valuePropositions?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

/**
 * Precomputed Lead Finder suggestion pills for a workspace.
 *
 * ``people`` / ``companies`` are lists of ``{label, criteria}`` pills where
 * each ``criteria`` is an arbitrary structured search-filter dict. Because
 * the criteria shape is owned by icp-builder (not modelled in coffee), the
 * lists are exposed as GenericScalar (opaque JSON) and passed through
 * verbatim to the Lead Finder UI.
 */
export type WorkspaceLeadFinderSuggestionsType = {
  __typename?: 'WorkspaceLeadFinderSuggestionsType';
  companies?: Maybe<Array<Maybe<Scalars['GenericScalar']['output']>>>;
  people?: Maybe<Array<Maybe<Scalars['GenericScalar']['output']>>>;
};

export type WorkspaceOnboarding = {
  __typename?: 'WorkspaceOnboarding';
  hasConnectedCrm?: Maybe<Scalars['Boolean']['output']>;
  hasCustomizedWorkspace?: Maybe<Scalars['Boolean']['output']>;
  hasInvitedUsers?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkspacePreferences = {
  __typename?: 'WorkspacePreferences';
  /** Whether auto-reload of a credit pack is enabled when an offline charge exhausts the balance. */
  autoRechargeEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Credit pack id to auto-purchase when auto-reload is enabled (null when disabled). */
  autoRechargePackId?: Maybe<Scalars['String']['output']>;
  createTs: Scalars['DateTime']['output'];
  /** Workspace default language (one of: en, es, fr, nl, de, it, ja, zh, da, pt). Applies to users who have not picked one themselves; null means fall back to Accept-Language then English. */
  defaultLanguage?: Maybe<Scalars['String']['output']>;
  /** Who can see emails/calendar/notes/files: 'private' (only the owner/participant, default), 'admins_and_owners' (owner plus workspace admins/owners), or 'everyone' (whole workspace). Supersedes public_visibility (kept in sync). */
  emailVisibility?: Maybe<Scalars['String']['output']>;
  /** Default visibility stamped onto NEW engagements (emails/meetings/calls) and backfilled onto existing default-managed ones; same values and caveats as notesDefaultAcl. Multi-participant engagements grant every internal participant's manager. */
  engagementsDefaultAcl?: Maybe<Scalars['String']['output']>;
  /** Default visibility stamped onto NEW files and backfilled onto existing default-managed ones; same values and caveats as notesDefaultAcl. Ownerless files are never stamped (stay workspace-visible). */
  filesDefaultAcl?: Maybe<Scalars['String']['output']>;
  /** Day of month (1-31) on which the workspace's fiscal year starts. Defaults to 1. */
  fiscalYearStartDay?: Maybe<Scalars['Int']['output']>;
  /** Month (1-12) on which the workspace's fiscal year starts. Defaults to 1 (January). */
  fiscalYearStartMonth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Max people/companies a single Lead Finder query can preview / select / build. Defaults to 2500; max 10000. */
  leadFinderResultCap?: Maybe<Scalars['Int']['output']>;
  /** Default visibility stamped onto NEW notes (and backfilled onto existing default-managed ones): 'private' (owner only — admins excluded), 'manager' (owner + their direct manager(s) via the reporting line), 'managers_and_admins', or 'everyone' (default; no grants). Task-typed notes stay under tasksVisibility. Composes AND with the legacy emailVisibility tier; BYOA agents and Zapier see only ungoverned records, so any value but 'everyone' hides governed records from them. */
  notesDefaultAcl?: Maybe<Scalars['String']['output']>;
  preferences: Scalars['JSONString']['output'];
  /** Privacy settings (everyone can see people, companies, deals, meetings; only you see emails, notes, calendar, files) */
  publicVisibility?: Maybe<Scalars['Boolean']['output']>;
  /** Whether group-based per-record sharing is enabled: records with grants are visible/editable only to the granted groups and the record owners (workspace admins get access only through the auto-managed Admins group; superusers/support always see). Off (default) = all records workspace-visible. */
  recordSharingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** RevenueGPT preferences */
  revenueGpt?: Maybe<RevenueGptPreferences>;
  /** Who can see tasks: 'assignee' (only the assigned user, default), 'admins_and_owners' (assignee plus workspace admins/owners), or 'everyone' (whole workspace). */
  tasksVisibility?: Maybe<Scalars['String']['output']>;
  updateTs: Scalars['DateTime']['output'];
  workspaceId: Scalars['Int']['output'];
};

export type WorkspaceRoleInput = {
  role: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};

/** An enumeration. */
export enum WorkspaceSortEnum {
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  CurrentAppAsc = 'CURRENT_APP_ASC',
  CurrentAppDesc = 'CURRENT_APP_DESC',
  DomainAsc = 'DOMAIN_ASC',
  DomainDesc = 'DOMAIN_DESC',
  HandleAsc = 'HANDLE_ASC',
  HandleDesc = 'HANDLE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LogoUrlAsc = 'LOGO_URL_ASC',
  LogoUrlDesc = 'LOGO_URL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  SourceAppAsc = 'SOURCE_APP_ASC',
  SourceAppDesc = 'SOURCE_APP_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StripeCustomerIdAsc = 'STRIPE_CUSTOMER_ID_ASC',
  StripeCustomerIdDesc = 'STRIPE_CUSTOMER_ID_DESC'
}

export type _MutationInput = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type _SaveAsContactInput = {
  contactExtId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type AccountBaseFieldsFragment = { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null };

export type AssociatedAccountsFragment = { __typename?: 'Account', associatedAccounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null };

export type AccountAssociationsFragment = { __typename?: 'Account', accountAssociations: Array<{ __typename?: 'EntityAssociation', label: string, toId: string, toAccount?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null }> };

export type AccountFieldsFragment = { __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'AccountProperties', name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null };

export type AccountEngagementsFragment = { __typename?: 'Account', lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null };

export type GetAccountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AccountFilter>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetAccountsQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountConnection', totalCount?: number | null, edges: Array<{ __typename?: 'AccountEdge', cursor: string, node?: { __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, avatarBackground?: string | null } | null, properties?: { __typename?: 'AccountProperties', name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, associatedAccounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, accountAssociations: Array<{ __typename?: 'EntityAssociation', label: string, toId: string, toAccount?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null }> } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filter?: InputMaybe<AccountFilter>;
}>;


export type GetAccountQuery = { __typename?: 'Query', account?: { __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'AccountProperties', aiSummary?: string | null, name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, deals?: { __typename?: 'DealConnection', edges: Array<{ __typename?: 'DealEdge', node?: { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null } | null } | null> } | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, userLists?: { __typename?: 'UserListConnection', edges: Array<{ __typename?: 'UserListEdge', node?: { __typename?: 'UserList', list: { __typename: 'List', id: string, name: string, properties: any, public: boolean, modelType: ListModelType, deleted: boolean, ownerId: number, createTs: any, updateTs: any, workspaceId: number, static: boolean } } | null } | null> } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, associatedAccounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, accountAssociations: Array<{ __typename?: 'EntityAssociation', label: string, toId: string, toAccount?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null }> } | null };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutations', createAccount?: { __typename?: 'CreateAccount', account?: { __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'AccountProperties', name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null } | null } | null };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutations', updateAccount?: { __typename?: 'UpdateAccount', account?: { __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, deals?: { __typename?: 'DealConnection', edges: Array<{ __typename?: 'DealEdge', node?: { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null } | null } | null> } | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, properties?: { __typename?: 'AccountProperties', name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, associatedAccounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null } | null } | null };

export type DeleteAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutations', deleteAccount?: { __typename?: 'DeleteAccount', success?: boolean | null } | null };

export type MergeAccountsMutationVariables = Exact<{
  args: MergeAccountsInput;
}>;


export type MergeAccountsMutation = { __typename?: 'Mutations', mergeAccounts?: { __typename?: 'MergeAccounts', success?: boolean | null, primaryAccount?: { __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, deals?: { __typename?: 'DealConnection', edges: Array<{ __typename?: 'DealEdge', node?: { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null } | null } | null> } | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, properties?: { __typename?: 'AccountProperties', name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, associatedAccounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null } | null } | null };

export type SetEntityAssociationMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  input: SetAssociationInput;
}>;


export type SetEntityAssociationMutation = { __typename?: 'Mutations', setEntityAssociation?: { __typename?: 'SetEntityAssociation', association?: { __typename?: 'EntityAssociation', label: string, toId: string, toAccount?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null } | null };

export type RemoveEntityAssociationMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  fromId: Scalars['String']['input'];
  toId: Scalars['String']['input'];
  label: Scalars['String']['input'];
  fromType?: InputMaybe<Scalars['String']['input']>;
  toType?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveEntityAssociationMutation = { __typename?: 'Mutations', removeEntityAssociation?: { __typename?: 'RemoveEntityAssociation', ok?: boolean | null } | null };

export type AgentTriggerFieldsFragment = { __typename: 'AgentTrigger', type: string, event?: string | null, cron?: string | null, filter?: any | null, stageIds?: Array<string | null> | null, scope?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, pathPattern?: string | null, usage?: any | null, campaign?: any | null };

export type AgentDefinitionFieldsFragment = { __typename: 'AgentDefinition', id: string, workspaceId: number, ownerUserId?: number | null, name: string, systemPrompt: string, allowedTools: Array<string | null>, modelUseCase: string, maxIterations: number, visibility: string, status: string, updateTs?: string | null, conditions?: any | null, notifyTarget?: string | null, notifyEmail?: boolean | null, notifyUserIds?: Array<number | null> | null, notifySlack?: boolean | null, guardActions?: any | null, trigger?: { __typename: 'AgentTrigger', type: string, event?: string | null, cron?: string | null, filter?: any | null, stageIds?: Array<string | null> | null, scope?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, pathPattern?: string | null, usage?: any | null, campaign?: any | null } | null };

export type AgentTemplateFieldsFragment = { __typename: 'AgentTemplate', templateName: string, name: string, description?: string | null, category?: string | null, systemPrompt: string, allowedTools: Array<string | null>, visibility: string, conditions?: any | null, notifySlack: boolean, available: boolean, unavailableReasons: Array<string | null>, trigger?: { __typename: 'AgentTrigger', type: string, event?: string | null, cron?: string | null, filter?: any | null, stageIds?: Array<string | null> | null, scope?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, pathPattern?: string | null, usage?: any | null, campaign?: any | null } | null };

export type GetAgentTemplatesQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type GetAgentTemplatesQuery = { __typename?: 'Query', agentTemplates?: Array<{ __typename: 'AgentTemplate', templateName: string, name: string, description?: string | null, category?: string | null, systemPrompt: string, allowedTools: Array<string | null>, visibility: string, conditions?: any | null, notifySlack: boolean, available: boolean, unavailableReasons: Array<string | null>, trigger?: { __typename: 'AgentTrigger', type: string, event?: string | null, cron?: string | null, filter?: any | null, stageIds?: Array<string | null> | null, scope?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, pathPattern?: string | null, usage?: any | null, campaign?: any | null } | null } | null> | null };

export type GetAgentDefinitionsQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type GetAgentDefinitionsQuery = { __typename?: 'Query', agentDefinitions?: Array<{ __typename: 'AgentDefinition', id: string, workspaceId: number, ownerUserId?: number | null, name: string, systemPrompt: string, allowedTools: Array<string | null>, modelUseCase: string, maxIterations: number, visibility: string, status: string, updateTs?: string | null, conditions?: any | null, notifyTarget?: string | null, notifyEmail?: boolean | null, notifyUserIds?: Array<number | null> | null, notifySlack?: boolean | null, guardActions?: any | null, trigger?: { __typename: 'AgentTrigger', type: string, event?: string | null, cron?: string | null, filter?: any | null, stageIds?: Array<string | null> | null, scope?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, pathPattern?: string | null, usage?: any | null, campaign?: any | null } | null } | null> | null };

export type GetAgentDefinitionQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type GetAgentDefinitionQuery = { __typename?: 'Query', agentDefinition?: { __typename: 'AgentDefinition', id: string, workspaceId: number, ownerUserId?: number | null, name: string, systemPrompt: string, allowedTools: Array<string | null>, modelUseCase: string, maxIterations: number, visibility: string, status: string, updateTs?: string | null, conditions?: any | null, notifyTarget?: string | null, notifyEmail?: boolean | null, notifyUserIds?: Array<number | null> | null, notifySlack?: boolean | null, guardActions?: any | null, trigger?: { __typename: 'AgentTrigger', type: string, event?: string | null, cron?: string | null, filter?: any | null, stageIds?: Array<string | null> | null, scope?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, pathPattern?: string | null, usage?: any | null, campaign?: any | null } | null } | null };

export type CreateAgentDefinitionMutationVariables = Exact<{
  input: CreateAgentDefinitionInput;
}>;


export type CreateAgentDefinitionMutation = { __typename?: 'Mutations', createAgentDefinition?: { __typename?: 'CreateAgentDefinition', agent?: { __typename: 'AgentDefinition', id: string, workspaceId: number, ownerUserId?: number | null, name: string, systemPrompt: string, allowedTools: Array<string | null>, modelUseCase: string, maxIterations: number, visibility: string, status: string, updateTs?: string | null, conditions?: any | null, notifyTarget?: string | null, notifyEmail?: boolean | null, notifyUserIds?: Array<number | null> | null, notifySlack?: boolean | null, guardActions?: any | null, trigger?: { __typename: 'AgentTrigger', type: string, event?: string | null, cron?: string | null, filter?: any | null, stageIds?: Array<string | null> | null, scope?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, pathPattern?: string | null, usage?: any | null, campaign?: any | null } | null } | null } | null };

export type UpdateAgentDefinitionMutationVariables = Exact<{
  input: UpdateAgentDefinitionInput;
}>;


export type UpdateAgentDefinitionMutation = { __typename?: 'Mutations', updateAgentDefinition?: { __typename?: 'UpdateAgentDefinition', agent?: { __typename: 'AgentDefinition', id: string, workspaceId: number, ownerUserId?: number | null, name: string, systemPrompt: string, allowedTools: Array<string | null>, modelUseCase: string, maxIterations: number, visibility: string, status: string, updateTs?: string | null, conditions?: any | null, notifyTarget?: string | null, notifyEmail?: boolean | null, notifyUserIds?: Array<number | null> | null, notifySlack?: boolean | null, guardActions?: any | null, trigger?: { __typename: 'AgentTrigger', type: string, event?: string | null, cron?: string | null, filter?: any | null, stageIds?: Array<string | null> | null, scope?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, pathPattern?: string | null, usage?: any | null, campaign?: any | null } | null } | null } | null };

export type DeleteAgentDefinitionMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteAgentDefinitionMutation = { __typename?: 'Mutations', deleteAgentDefinition?: { __typename?: 'DeleteAgentDefinition', ok: boolean } | null };

export type EnableAgentTemplateMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  templateName: Scalars['String']['input'];
}>;


export type EnableAgentTemplateMutation = { __typename?: 'Mutations', enableAgentTemplate?: { __typename?: 'EnableAgentTemplate', agent?: { __typename: 'AgentDefinition', id: string, workspaceId: number, ownerUserId?: number | null, name: string, systemPrompt: string, allowedTools: Array<string | null>, modelUseCase: string, maxIterations: number, visibility: string, status: string, updateTs?: string | null, conditions?: any | null, notifyTarget?: string | null, notifyEmail?: boolean | null, notifyUserIds?: Array<number | null> | null, notifySlack?: boolean | null, guardActions?: any | null, trigger?: { __typename: 'AgentTrigger', type: string, event?: string | null, cron?: string | null, filter?: any | null, stageIds?: Array<string | null> | null, scope?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, pathPattern?: string | null, usage?: any | null, campaign?: any | null } | null } | null } | null };

export type SetAgentEnabledMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetAgentEnabledMutation = { __typename?: 'Mutations', setAgentEnabled?: { __typename?: 'SetAgentEnabled', agent?: { __typename: 'AgentDefinition', id: string, workspaceId: number, ownerUserId?: number | null, name: string, systemPrompt: string, allowedTools: Array<string | null>, modelUseCase: string, maxIterations: number, visibility: string, status: string, updateTs?: string | null, conditions?: any | null, notifyTarget?: string | null, notifyEmail?: boolean | null, notifyUserIds?: Array<number | null> | null, notifySlack?: boolean | null, guardActions?: any | null, trigger?: { __typename: 'AgentTrigger', type: string, event?: string | null, cron?: string | null, filter?: any | null, stageIds?: Array<string | null> | null, scope?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, pathPattern?: string | null, usage?: any | null, campaign?: any | null } | null } | null } | null };

export type TestAgentDefinitionMutationVariables = Exact<{
  input: TestAgentDefinitionInput;
}>;


export type TestAgentDefinitionMutation = { __typename?: 'Mutations', testAgentDefinition?: { __typename?: 'TestAgentDefinition', result?: { __typename?: 'TestAgentResult', feasible: boolean, reason: string, outcome?: string | null, truncated?: boolean | null, notifyTarget?: string | null, notifyTargetLabel?: string | null, deliverySinks?: Array<string | null> | null, toolsCalled: Array<string | null>, allowedTools: Array<string | null>, output?: string | null, stopReason?: string | null, iterations?: number | null, validationError?: string | null, objectType?: string | null, repeat?: string | null, anchorField?: string | null, daysBefore?: Array<number | null> | null, sampleEntityId?: string | null, pathPattern?: string | null, usageDescription?: string | null, campaignDescription?: string | null, scope?: string | null, recordsRead?: Array<{ __typename?: 'ToolReadCount', tool: string, count: number } | null> | null, intendedEffects?: Array<{ __typename?: 'IntendedEffect', tool?: string | null, args?: any | null } | null> | null } | null } | null };

export type AgentPreviewProgressQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  previewId: Scalars['String']['input'];
}>;


export type AgentPreviewProgressQuery = { __typename?: 'Query', agentPreviewProgress?: { __typename?: 'AgentPreviewProgress', phase: string, label: string, iteration: number, toolsUsed: Array<string | null> } | null };

export type GetAiChatConversationsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAiChatConversationsQuery = { __typename?: 'Query', aiChatConversations?: Array<{ __typename?: 'AiChatConversationType', id?: number | null, agentSessionId?: string | null, contextType?: string | null, contextId?: string | null, firstMessage?: string | null, updateTs?: any | null, createTs?: any | null } | null> | null };

export type GetAiChatMessagesQueryVariables = Exact<{
  conversationId: Scalars['Int']['input'];
}>;


export type GetAiChatMessagesQuery = { __typename?: 'Query', aiChatMessages?: Array<{ __typename?: 'AiChatMessageType', id?: number | null, role?: string | null, content?: string | null, createTs?: any | null, vote?: number | null, feedbackComment?: string | null } | null> | null };

export type AddAiChatMessageFeedbackMutationVariables = Exact<{
  input: AddAiChatMessageFeedbackInput;
}>;


export type AddAiChatMessageFeedbackMutation = { __typename?: 'Mutations', addAiChatMessageFeedback?: { __typename?: 'AddAiChatMessageFeedback', ok?: boolean | null } | null };

export type PreviewAiFieldQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  fieldId?: InputMaybe<Scalars['Int']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  aiPromptText?: InputMaybe<Scalars['String']['input']>;
  aiOutputInstructionText?: InputMaybe<Scalars['String']['input']>;
  aiModelProvider?: InputMaybe<Scalars['String']['input']>;
  aiModelName?: InputMaybe<Scalars['String']['input']>;
  listId?: InputMaybe<Scalars['Int']['input']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type PreviewAiFieldQuery = { __typename?: 'Query', previewAiField?: { __typename?: 'PreviewAiFieldResult', totalEntitiesFound: number, previewResults: Array<{ __typename?: 'AiFieldPreviewResult', entityId: string, entityName: string, generatedValue: string, error?: string | null } | null> } | null };

export type RunAiCustomFieldMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  fieldId: Scalars['Int']['input'];
  listId?: InputMaybe<Scalars['Int']['input']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  rowLimit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
}>;


export type RunAiCustomFieldMutation = { __typename?: 'Mutations', runAiCustomField?: { __typename?: 'RunAiCustomField', execution?: { __typename?: 'AiJobExecutionType', id?: string | null, workspaceId?: number | null, userId?: number | null, fieldId?: number | null, listId?: number | null, status?: string | null, totalRecords?: number | null, processedRecords?: number | null, failedRecords?: number | null, progressPercentage?: number | null, temporalWorkflowId?: string | null, createdAt?: any | null } | null } | null };

export type GetAiJobExecutionQueryVariables = Exact<{
  executionId: Scalars['String']['input'];
}>;


export type GetAiJobExecutionQuery = { __typename?: 'Query', aiJobExecution?: { __typename?: 'AiJobExecutionType', id?: string | null, workspaceId?: number | null, userId?: number | null, fieldId?: number | null, listId?: number | null, status?: string | null, totalRecords?: number | null, processedRecords?: number | null, failedRecords?: number | null, progressPercentage?: number | null, temporalWorkflowId?: string | null, createdAt?: any | null } | null };

export type ActiveAiExecutionsQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  listId?: InputMaybe<Scalars['Int']['input']>;
  fieldId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ActiveAiExecutionsQuery = { __typename?: 'Query', activeAiExecutions?: Array<{ __typename?: 'AiJobExecutionType', id?: string | null, workspaceId?: number | null, userId?: number | null, fieldId?: number | null, listId?: number | null, status?: string | null, totalRecords?: number | null, processedRecords?: number | null, failedRecords?: number | null, progressPercentage?: number | null, temporalWorkflowId?: string | null, createdAt?: any | null } | null> | null };

export type CreateBadDataReportMutationVariables = Exact<{
  input: CreateBadDataReportInput;
}>;


export type CreateBadDataReportMutation = { __typename?: 'Mutations', createBadDataReport?: { __typename?: 'CreateBadDataReport', ok?: boolean | null } | null };

export type CheckPaymentStatusQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type CheckPaymentStatusQuery = { __typename?: 'Query', paymentMethodStatus?: { __typename?: 'PaymentMethodStatus', hasValidCard: boolean } | null };

export type GetExchangeRateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExchangeRateQuery = { __typename?: 'Query', creditExchangeRate?: { __typename?: 'CreditExchangeRate', creditsToUsdRate: number, companyRate: number, personRate: number, aiFieldRate: number } | null };

export type GetCreditUsageSummaryQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type GetCreditUsageSummaryQuery = { __typename?: 'Query', creditUsageSummary?: { __typename?: 'CreditUsageSummary', totalCreditsUsed: number, totalCreditsLimit: number, billingPeriodStart?: any | null, billingPeriodEnd?: any | null, seats?: number | null, subscriptionCreditsLimit?: number | null, purchasedCreditsRemaining?: number | null, creditSources: Array<{ __typename?: 'CreditSource', id: string, kind: CreditSourceKind, label: string, totalCredits: number, usedCredits: number, remainingCredits: number, expiresAt?: any | null, purchasedAt?: any | null } | null>, perAgent: Array<{ __typename?: 'AgentCreditUsage', agentName: string, sourceFeature: string, creditsUsed: number, actionType: string, creditCost: string, enabled: boolean } | null> } | null };

export type BriefTemplateSectionFieldsFragment = { __typename?: 'BriefTemplateSection', heading: string, prompt: string, order: number };

export type BriefTemplateFieldsFragment = { __typename?: 'BriefTemplateClass', id: string, workspaceId?: number | null, name?: string | null, createdByUserId?: number | null, createdAt?: any | null, isWorkspaceWide?: boolean | null, isDefault?: boolean | null, deleted?: boolean | null, sections?: Array<{ __typename?: 'BriefTemplateSection', heading: string, prompt: string, order: number } | null> | null };

export type GetWorkspaceBriefTemplatesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetWorkspaceBriefTemplatesQuery = { __typename?: 'Query', briefTemplates?: { __typename?: 'BriefTemplateConnection', edges: Array<{ __typename?: 'BriefTemplateEdge', cursor: string, node?: { __typename?: 'BriefTemplateClass', id: string, workspaceId?: number | null, name?: string | null, createdByUserId?: number | null, createdAt?: any | null, isWorkspaceWide?: boolean | null, isDefault?: boolean | null, deleted?: boolean | null, sections?: Array<{ __typename?: 'BriefTemplateSection', heading: string, prompt: string, order: number } | null> | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null, systemBriefSections?: Array<{ __typename?: 'BriefTemplateSection', heading: string, prompt: string, order: number } | null> | null };

export type CreateBriefTemplateMutationVariables = Exact<{
  input: CreateBriefTemplateInput;
}>;


export type CreateBriefTemplateMutation = { __typename?: 'Mutations', createBriefTemplate?: { __typename?: 'CreateBriefTemplate', briefTemplate?: { __typename?: 'BriefTemplateClass', id: string, workspaceId?: number | null, name?: string | null, createdByUserId?: number | null, createdAt?: any | null, isWorkspaceWide?: boolean | null, isDefault?: boolean | null, deleted?: boolean | null, sections?: Array<{ __typename?: 'BriefTemplateSection', heading: string, prompt: string, order: number } | null> | null } | null } | null };

export type UpdateBriefTemplateMutationVariables = Exact<{
  input: UpdateBriefTemplateInput;
}>;


export type UpdateBriefTemplateMutation = { __typename?: 'Mutations', updateBriefTemplate?: { __typename?: 'UpdateBriefTemplate', briefTemplate?: { __typename?: 'BriefTemplateClass', id: string, workspaceId?: number | null, name?: string | null, createdByUserId?: number | null, createdAt?: any | null, isWorkspaceWide?: boolean | null, isDefault?: boolean | null, deleted?: boolean | null, sections?: Array<{ __typename?: 'BriefTemplateSection', heading: string, prompt: string, order: number } | null> | null } | null } | null };

export type DeleteBriefTemplateMutationVariables = Exact<{
  input: DeleteBriefTemplateInput;
}>;


export type DeleteBriefTemplateMutation = { __typename?: 'Mutations', deleteBriefTemplate?: { __typename?: 'DeleteBriefTemplate', success?: boolean | null } | null };

export type GenerateBriefMutationVariables = Exact<{
  input: GenerateBriefInput;
}>;


export type GenerateBriefMutation = { __typename?: 'Mutations', generateBrief?: { __typename?: 'GenerateBrief', brief?: { __typename?: 'EngagementBriefType', id?: string | null, engagementId?: string | null, briefTemplateId?: string | null, brief?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type CampaignStepFieldsFragment = { __typename: 'CampaignStep', id: string, stepOrder: number, templateId?: string | null, subject: string, body: string, attachments?: any | null, delayDays: number };

export type CampaignEnrollmentCountsFieldsFragment = { __typename: 'CampaignEnrollmentCounts', enrolled: number, active: number, completed: number, unenrolled: number, failed: number, bounced: number, unsubscribed: number, opened: number, clicked: number };

export type CampaignStepStatsFieldsFragment = { __typename: 'CampaignStepStats', stepOrder: number, sent: number, replies: number, opened: number, clicked: number, bounced: number, unsubscribed: number };

export type CampaignRecipientFieldsFragment = { __typename: 'CampaignRecipient', contactId?: string | null, name?: string | null, email?: string | null, title?: string | null, company?: string | null };

export type CampaignFieldsFragment = { __typename: 'Campaign', id: string, workspaceId: number, ownerUserId: number, ownerName?: string | null, ownerEmail?: string | null, name: string, listId?: number | null, additionalListIds?: Array<number | null> | null, status: string, settings?: any | null, startedAt?: string | null, pausedAt?: string | null, lastDynamicRefreshAt?: string | null, createTs?: string | null, updateTs?: string | null, dailySendLimit?: number | null, steps?: Array<{ __typename: 'CampaignStep', id: string, stepOrder: number, templateId?: string | null, subject: string, body: string, attachments?: any | null, delayDays: number } | null> | null, enrollmentCounts?: { __typename: 'CampaignEnrollmentCounts', enrolled: number, active: number, completed: number, unenrolled: number, failed: number, bounced: number, unsubscribed: number, opened: number, clicked: number } | null, stepStats?: Array<{ __typename: 'CampaignStepStats', stepOrder: number, sent: number, replies: number, opened: number, clicked: number, bounced: number, unsubscribed: number } | null> | null };

export type GetCampaignsQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type GetCampaignsQuery = { __typename?: 'Query', campaigns?: Array<{ __typename: 'Campaign', id: string, workspaceId: number, ownerUserId: number, ownerName?: string | null, ownerEmail?: string | null, name: string, listId?: number | null, additionalListIds?: Array<number | null> | null, status: string, settings?: any | null, startedAt?: string | null, pausedAt?: string | null, lastDynamicRefreshAt?: string | null, createTs?: string | null, updateTs?: string | null, dailySendLimit?: number | null, steps?: Array<{ __typename: 'CampaignStep', id: string, stepOrder: number, templateId?: string | null, subject: string, body: string, attachments?: any | null, delayDays: number } | null> | null, enrollmentCounts?: { __typename: 'CampaignEnrollmentCounts', enrolled: number, active: number, completed: number, unenrolled: number, failed: number, bounced: number, unsubscribed: number, opened: number, clicked: number } | null, stepStats?: Array<{ __typename: 'CampaignStepStats', stepOrder: number, sent: number, replies: number, opened: number, clicked: number, bounced: number, unsubscribed: number } | null> | null } | null> | null };

export type GetCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
}>;


export type GetCampaignQuery = { __typename?: 'Query', campaign?: { __typename: 'Campaign', id: string, workspaceId: number, ownerUserId: number, ownerName?: string | null, ownerEmail?: string | null, name: string, listId?: number | null, additionalListIds?: Array<number | null> | null, status: string, settings?: any | null, startedAt?: string | null, pausedAt?: string | null, lastDynamicRefreshAt?: string | null, createTs?: string | null, updateTs?: string | null, dailySendLimit?: number | null, steps?: Array<{ __typename: 'CampaignStep', id: string, stepOrder: number, templateId?: string | null, subject: string, body: string, attachments?: any | null, delayDays: number } | null> | null, enrollmentCounts?: { __typename: 'CampaignEnrollmentCounts', enrolled: number, active: number, completed: number, unenrolled: number, failed: number, bounced: number, unsubscribed: number, opened: number, clicked: number } | null, stepStats?: Array<{ __typename: 'CampaignStepStats', stepOrder: number, sent: number, replies: number, opened: number, clicked: number, bounced: number, unsubscribed: number } | null> | null } | null };

export type GetCampaignStepRecipientsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['Int']['input'];
  stepOrder: Scalars['Int']['input'];
  status: Scalars['String']['input'];
}>;


export type GetCampaignStepRecipientsQuery = { __typename?: 'Query', campaignStepRecipients?: Array<{ __typename: 'CampaignRecipient', contactId?: string | null, name?: string | null, email?: string | null, title?: string | null, company?: string | null } | null> | null };

export type CreateCampaignMutationVariables = Exact<{
  input: CreateCampaignInput;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutations', createCampaign?: { __typename?: 'CreateCampaign', campaign?: { __typename: 'Campaign', id: string, workspaceId: number, ownerUserId: number, ownerName?: string | null, ownerEmail?: string | null, name: string, listId?: number | null, additionalListIds?: Array<number | null> | null, status: string, settings?: any | null, startedAt?: string | null, pausedAt?: string | null, lastDynamicRefreshAt?: string | null, createTs?: string | null, updateTs?: string | null, dailySendLimit?: number | null, steps?: Array<{ __typename: 'CampaignStep', id: string, stepOrder: number, templateId?: string | null, subject: string, body: string, attachments?: any | null, delayDays: number } | null> | null, enrollmentCounts?: { __typename: 'CampaignEnrollmentCounts', enrolled: number, active: number, completed: number, unenrolled: number, failed: number, bounced: number, unsubscribed: number, opened: number, clicked: number } | null, stepStats?: Array<{ __typename: 'CampaignStepStats', stepOrder: number, sent: number, replies: number, opened: number, clicked: number, bounced: number, unsubscribed: number } | null> | null } | null } | null };

export type UpdateCampaignMutationVariables = Exact<{
  input: UpdateCampaignInput;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutations', updateCampaign?: { __typename?: 'UpdateCampaign', campaign?: { __typename: 'Campaign', id: string, workspaceId: number, ownerUserId: number, ownerName?: string | null, ownerEmail?: string | null, name: string, listId?: number | null, additionalListIds?: Array<number | null> | null, status: string, settings?: any | null, startedAt?: string | null, pausedAt?: string | null, lastDynamicRefreshAt?: string | null, createTs?: string | null, updateTs?: string | null, dailySendLimit?: number | null, steps?: Array<{ __typename: 'CampaignStep', id: string, stepOrder: number, templateId?: string | null, subject: string, body: string, attachments?: any | null, delayDays: number } | null> | null, enrollmentCounts?: { __typename: 'CampaignEnrollmentCounts', enrolled: number, active: number, completed: number, unenrolled: number, failed: number, bounced: number, unsubscribed: number, opened: number, clicked: number } | null, stepStats?: Array<{ __typename: 'CampaignStepStats', stepOrder: number, sent: number, replies: number, opened: number, clicked: number, bounced: number, unsubscribed: number } | null> | null } | null } | null };

export type DeleteCampaignMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteCampaignMutation = { __typename?: 'Mutations', deleteCampaign?: { __typename?: 'DeleteCampaign', ok?: boolean | null } | null };

export type StartCampaignMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type StartCampaignMutation = { __typename?: 'Mutations', startCampaign?: { __typename?: 'StartCampaign', campaign?: { __typename: 'Campaign', id: string, workspaceId: number, ownerUserId: number, ownerName?: string | null, ownerEmail?: string | null, name: string, listId?: number | null, additionalListIds?: Array<number | null> | null, status: string, settings?: any | null, startedAt?: string | null, pausedAt?: string | null, lastDynamicRefreshAt?: string | null, createTs?: string | null, updateTs?: string | null, dailySendLimit?: number | null, steps?: Array<{ __typename: 'CampaignStep', id: string, stepOrder: number, templateId?: string | null, subject: string, body: string, attachments?: any | null, delayDays: number } | null> | null, enrollmentCounts?: { __typename: 'CampaignEnrollmentCounts', enrolled: number, active: number, completed: number, unenrolled: number, failed: number, bounced: number, unsubscribed: number, opened: number, clicked: number } | null, stepStats?: Array<{ __typename: 'CampaignStepStats', stepOrder: number, sent: number, replies: number, opened: number, clicked: number, bounced: number, unsubscribed: number } | null> | null } | null } | null };

export type PauseCampaignMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type PauseCampaignMutation = { __typename?: 'Mutations', pauseCampaign?: { __typename?: 'PauseCampaign', campaign?: { __typename: 'Campaign', id: string, workspaceId: number, ownerUserId: number, ownerName?: string | null, ownerEmail?: string | null, name: string, listId?: number | null, additionalListIds?: Array<number | null> | null, status: string, settings?: any | null, startedAt?: string | null, pausedAt?: string | null, lastDynamicRefreshAt?: string | null, createTs?: string | null, updateTs?: string | null, dailySendLimit?: number | null, steps?: Array<{ __typename: 'CampaignStep', id: string, stepOrder: number, templateId?: string | null, subject: string, body: string, attachments?: any | null, delayDays: number } | null> | null, enrollmentCounts?: { __typename: 'CampaignEnrollmentCounts', enrolled: number, active: number, completed: number, unenrolled: number, failed: number, bounced: number, unsubscribed: number, opened: number, clicked: number } | null, stepStats?: Array<{ __typename: 'CampaignStepStats', stepOrder: number, sent: number, replies: number, opened: number, clicked: number, bounced: number, unsubscribed: number } | null> | null } | null } | null };

export type ResumeCampaignMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type ResumeCampaignMutation = { __typename?: 'Mutations', resumeCampaign?: { __typename?: 'ResumeCampaign', campaign?: { __typename: 'Campaign', id: string, workspaceId: number, ownerUserId: number, ownerName?: string | null, ownerEmail?: string | null, name: string, listId?: number | null, additionalListIds?: Array<number | null> | null, status: string, settings?: any | null, startedAt?: string | null, pausedAt?: string | null, lastDynamicRefreshAt?: string | null, createTs?: string | null, updateTs?: string | null, dailySendLimit?: number | null, steps?: Array<{ __typename: 'CampaignStep', id: string, stepOrder: number, templateId?: string | null, subject: string, body: string, attachments?: any | null, delayDays: number } | null> | null, enrollmentCounts?: { __typename: 'CampaignEnrollmentCounts', enrolled: number, active: number, completed: number, unenrolled: number, failed: number, bounced: number, unsubscribed: number, opened: number, clicked: number } | null, stepStats?: Array<{ __typename: 'CampaignStepStats', stepOrder: number, sent: number, replies: number, opened: number, clicked: number, bounced: number, unsubscribed: number } | null> | null } | null } | null };

export type ClipFieldsFragment = { __typename: 'ClipType', id?: string | null, engagementId?: string | null, name?: string | null, startSec?: number | null, endSec?: number | null, status?: string | null, statusError?: string | null, clipVideoUrl?: string | null, shareSlug?: string | null, createdAt?: any | null, transcript?: Array<{ __typename?: 'ClipTranscriptSegmentType', speaker?: string | null, text?: string | null, start?: number | null, end?: number | null } | null> | null };

export type GetClipsQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  engagementId: Scalars['String']['input'];
}>;


export type GetClipsQuery = { __typename?: 'Query', clips?: Array<{ __typename: 'ClipType', id?: string | null, engagementId?: string | null, name?: string | null, startSec?: number | null, endSec?: number | null, status?: string | null, statusError?: string | null, clipVideoUrl?: string | null, shareSlug?: string | null, createdAt?: any | null, transcript?: Array<{ __typename?: 'ClipTranscriptSegmentType', speaker?: string | null, text?: string | null, start?: number | null, end?: number | null } | null> | null } | null> | null };

export type GetClipQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['String']['input'];
}>;


export type GetClipQuery = { __typename?: 'Query', clip?: { __typename: 'ClipType', id?: string | null, engagementId?: string | null, name?: string | null, startSec?: number | null, endSec?: number | null, status?: string | null, statusError?: string | null, clipVideoUrl?: string | null, shareSlug?: string | null, createdAt?: any | null, transcript?: Array<{ __typename?: 'ClipTranscriptSegmentType', speaker?: string | null, text?: string | null, start?: number | null, end?: number | null } | null> | null } | null };

export type CreateClipMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  engagementId: Scalars['String']['input'];
  startSec: Scalars['Float']['input'];
  endSec: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateClipMutation = { __typename?: 'Mutations', createClip?: { __typename: 'ClipType', id?: string | null, engagementId?: string | null, name?: string | null, startSec?: number | null, endSec?: number | null, status?: string | null, statusError?: string | null, clipVideoUrl?: string | null, shareSlug?: string | null, createdAt?: any | null, transcript?: Array<{ __typename?: 'ClipTranscriptSegmentType', speaker?: string | null, text?: string | null, start?: number | null, end?: number | null } | null> | null } | null };

export type UpdateClipMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateClipMutation = { __typename?: 'Mutations', updateClip?: { __typename: 'ClipType', id?: string | null, engagementId?: string | null, name?: string | null, startSec?: number | null, endSec?: number | null, status?: string | null, statusError?: string | null, clipVideoUrl?: string | null, shareSlug?: string | null, createdAt?: any | null, transcript?: Array<{ __typename?: 'ClipTranscriptSegmentType', speaker?: string | null, text?: string | null, start?: number | null, end?: number | null } | null> | null } | null };

export type DeleteClipMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['String']['input'];
}>;


export type DeleteClipMutation = { __typename?: 'Mutations', deleteClip?: { __typename?: 'DeleteClip', ok?: boolean | null } | null };

export type ClipShareQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ClipShareQuery = { __typename?: 'Query', clipShare?: { __typename?: 'ClipShareType', name?: string | null, status?: string | null, clipVideoUrl?: string | null, startSec?: number | null, endSec?: number | null, transcript?: Array<{ __typename?: 'ClipTranscriptSegmentType', speaker?: string | null, text?: string | null, start?: number | null, end?: number | null } | null> | null } | null };

export type ContactChangeSuggestionFieldsFragment = { __typename?: 'ContactChangeSuggestionType', id?: string | null, kind?: string | null, status?: string | null, contactId?: string | null, snapshot?: any | null, availableModes?: Array<string | null> | null, acceptMode?: string | null, actedByUserId?: number | null, actedByName?: string | null, actedTs?: any | null, resolvedContactId?: string | null, dismissedByViewer?: boolean | null, createTs?: any | null };

export type PendingContactChangeSuggestionQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
}>;


export type PendingContactChangeSuggestionQuery = { __typename?: 'Query', pendingContactChangeSuggestion?: { __typename?: 'ContactChangeSuggestionType', id?: string | null, kind?: string | null, status?: string | null, contactId?: string | null, snapshot?: any | null, availableModes?: Array<string | null> | null, acceptMode?: string | null, actedByUserId?: number | null, actedByName?: string | null, actedTs?: any | null, resolvedContactId?: string | null, dismissedByViewer?: boolean | null, createTs?: any | null } | null };

export type ContactChangeSuggestionQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type ContactChangeSuggestionQuery = { __typename?: 'Query', contactChangeSuggestion?: { __typename?: 'ContactChangeSuggestionType', id?: string | null, kind?: string | null, status?: string | null, contactId?: string | null, snapshot?: any | null, availableModes?: Array<string | null> | null, acceptMode?: string | null, actedByUserId?: number | null, actedByName?: string | null, actedTs?: any | null, resolvedContactId?: string | null, dismissedByViewer?: boolean | null, createTs?: any | null } | null };

export type ContactChangeImpactQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type ContactChangeImpactQuery = { __typename?: 'Query', contactChangeImpact?: { __typename?: 'ContactChangeImpactType', engagementCount?: number | null, dealNames?: Array<string | null> | null, dealCount?: number | null, existingContactId?: string | null, existingContactName?: string | null, accountMatch?: string | null, syncedTo?: Array<string | null> | null, accountCandidates?: Array<{ __typename?: 'AccountCandidate', id?: string | null, name?: string | null, domain?: string | null } | null> | null } | null };

export type AcceptContactChangeSuggestionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  mode: Scalars['String']['input'];
  createCompany?: InputMaybe<Scalars['Boolean']['input']>;
  accountId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AcceptContactChangeSuggestionMutation = { __typename?: 'Mutations', acceptContactChangeSuggestion?: { __typename?: 'ContactChangeResultType', ok?: boolean | null, errorCode?: string | null, errorMessage?: string | null, resolvedContactId?: string | null, suggestion?: { __typename?: 'ContactChangeSuggestionType', id?: string | null, kind?: string | null, status?: string | null, contactId?: string | null, snapshot?: any | null, availableModes?: Array<string | null> | null, acceptMode?: string | null, actedByUserId?: number | null, actedByName?: string | null, actedTs?: any | null, resolvedContactId?: string | null, dismissedByViewer?: boolean | null, createTs?: any | null } | null } | null };

export type DismissContactChangeSuggestionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type DismissContactChangeSuggestionMutation = { __typename?: 'Mutations', dismissContactChangeSuggestion?: { __typename?: 'ContactChangeResultType', ok?: boolean | null, errorCode?: string | null, errorMessage?: string | null, suggestion?: { __typename?: 'ContactChangeSuggestionType', id?: string | null, kind?: string | null, status?: string | null, contactId?: string | null, snapshot?: any | null, availableModes?: Array<string | null> | null, acceptMode?: string | null, actedByUserId?: number | null, actedByName?: string | null, actedTs?: any | null, resolvedContactId?: string | null, dismissedByViewer?: boolean | null, createTs?: any | null } | null } | null };

export type ReopenContactChangeSuggestionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type ReopenContactChangeSuggestionMutation = { __typename?: 'Mutations', reopenContactChangeSuggestion?: { __typename?: 'ContactChangeResultType', ok?: boolean | null, errorCode?: string | null, errorMessage?: string | null, suggestion?: { __typename?: 'ContactChangeSuggestionType', id?: string | null, kind?: string | null, status?: string | null, contactId?: string | null, snapshot?: any | null, availableModes?: Array<string | null> | null, acceptMode?: string | null, actedByUserId?: number | null, actedByName?: string | null, actedTs?: any | null, resolvedContactId?: string | null, dismissedByViewer?: boolean | null, createTs?: any | null } | null } | null };

export type ContactBaseFieldsFragment = { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null };

export type ContactFieldsFragment = { __typename: 'Contact', id: string, externalId: string, primaryEmail?: string | null, profileImageUrl?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, phone?: string | null, city?: string | null, state?: string | null, country?: string | null, linkedinProfileUrl?: string | null, note?: string | null, highlight?: string | null, additionalEmails?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null, ownerId?: string | null, profileImageUrl?: string | null } | null };

export type ContactEngagementsFragment = { __typename?: 'Contact', lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null };

export type GetContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetContactsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ContactEdge', cursor: string, node?: { __typename: 'Contact', id: string, externalId: string, primaryEmail?: string | null, profileImageUrl?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, avatarBackground?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, phone?: string | null, city?: string | null, state?: string | null, country?: string | null, linkedinProfileUrl?: string | null, note?: string | null, highlight?: string | null, additionalEmails?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null, ownerId?: string | null, profileImageUrl?: string | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetContactQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContactQuery = { __typename?: 'Query', contact?: { __typename: 'Contact', id: string, externalId: string, primaryEmail?: string | null, profileImageUrl?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'ContactProperties', aiSummary?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, phone?: string | null, city?: string | null, state?: string | null, country?: string | null, linkedinProfileUrl?: string | null, note?: string | null, highlight?: string | null, additionalEmails?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null, ownerId?: string | null, profileImageUrl?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, deals?: { __typename?: 'DealConnection', edges: Array<{ __typename?: 'DealEdge', node?: { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null } | null } | null> } | null, userLists?: { __typename?: 'UserListConnection', edges: Array<{ __typename?: 'UserListEdge', node?: { __typename?: 'UserList', list: { __typename: 'List', id: string, name: string, properties: any, public: boolean, modelType: ListModelType, deleted: boolean, ownerId: number, createTs: any, updateTs: any, workspaceId: number, static: boolean } } | null } | null> } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null } | null };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutations', createContact?: { __typename?: 'CreateContact', contact?: { __typename: 'Contact', id: string, externalId: string, primaryEmail?: string | null, profileImageUrl?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, phone?: string | null, city?: string | null, state?: string | null, country?: string | null, linkedinProfileUrl?: string | null, note?: string | null, highlight?: string | null, additionalEmails?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null, ownerId?: string | null, profileImageUrl?: string | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null } | null } | null };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutations', updateContact?: { __typename?: 'UpdateContact', contact?: { __typename: 'Contact', id: string, externalId: string, primaryEmail?: string | null, profileImageUrl?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, deals?: { __typename?: 'DealConnection', edges: Array<{ __typename?: 'DealEdge', node?: { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null } | null } | null> } | null, userLists?: { __typename?: 'UserListConnection', edges: Array<{ __typename?: 'UserListEdge', node?: { __typename?: 'UserList', list: { __typename: 'List', id: string, name: string, properties: any, public: boolean, modelType: ListModelType, deleted: boolean, ownerId: number, createTs: any, updateTs: any, workspaceId: number, static: boolean } } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, phone?: string | null, city?: string | null, state?: string | null, country?: string | null, linkedinProfileUrl?: string | null, note?: string | null, highlight?: string | null, additionalEmails?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null, ownerId?: string | null, profileImageUrl?: string | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null } | null } | null };

export type DeleteContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContactMutation = { __typename?: 'Mutations', deleteContact?: { __typename?: 'DeleteContact', success?: boolean | null } | null };

export type MergeContactsMutationVariables = Exact<{
  args: MergeContactsInput;
}>;


export type MergeContactsMutation = { __typename?: 'Mutations', mergeContacts?: { __typename?: 'MergeContacts', success?: boolean | null, primaryContact?: { __typename: 'Contact', id: string, externalId: string, primaryEmail?: string | null, profileImageUrl?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, phone?: string | null, city?: string | null, state?: string | null, country?: string | null, linkedinProfileUrl?: string | null, note?: string | null, highlight?: string | null, additionalEmails?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null, ownerId?: string | null, profileImageUrl?: string | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null, nextEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null } | null } | null } | null };

export type GetCreditResponseQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetCreditResponseQuery = { __typename?: 'Query', creditResponse?: { __typename?: 'CreditResponse', credits?: number | null } | null };

export type GetCrmGraderReportQueryVariables = Exact<{
  input: CrmGraderReportInput;
}>;


export type GetCrmGraderReportQuery = { __typename?: 'Query', crmGraderReport?: { __typename?: 'CrmReport', shareLink?: string | null, generatedAt?: any | null, workspaceName?: string | null, contacts?: { __typename?: 'ModelReport', totalDocuments?: number | null, fieldAggregates?: Array<{ __typename?: 'FieldAggregate', fieldName?: string | null, crm?: { __typename?: 'SourceAggregateDatum', count?: number | null, percentage?: number | null } | null, mdm?: { __typename?: 'SourceAggregateDatum', count?: number | null, percentage?: number | null } | null } | null> | null } | null, accounts?: { __typename?: 'ModelReport', totalDocuments?: number | null, fieldAggregates?: Array<{ __typename?: 'FieldAggregate', fieldName?: string | null, crm?: { __typename?: 'SourceAggregateDatum', count?: number | null, percentage?: number | null } | null, mdm?: { __typename?: 'SourceAggregateDatum', count?: number | null, percentage?: number | null } | null } | null> | null } | null, deals?: { __typename?: 'ModelReport', totalDocuments?: number | null, fieldAggregates?: Array<{ __typename?: 'FieldAggregate', fieldName?: string | null, crm?: { __typename?: 'SourceAggregateDatum', count?: number | null, percentage?: number | null } | null, mdm?: { __typename?: 'SourceAggregateDatum', count?: number | null, percentage?: number | null } | null } | null> | null } | null } | null };

export type GetCrmIngestionFieldsQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
  platform: CrmIngestionPlatform;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCrmIngestionFieldsQuery = { __typename?: 'Query', crmIngestionFields?: { __typename?: 'CrmIngestionFieldConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CrmIngestionFieldEdge', cursor: string, node?: { __typename: 'CrmIngestionField', id: string, workspaceId: number, platform: CrmIngestionPlatform, objectType: CrmIngestionObjectType, sourceExternalId?: string | null, isStandardField: boolean, crmLabel: string, crmName: string, sourceName: string, crmFieldType: CrmIngestionFieldType, sourceFieldType: CrmIngestionFieldType, isEnumeration: boolean, enumerationData?: any | null, availableInGrid: boolean, availableInRevgpt: boolean, syncBack: boolean, syncBackDestinationName?: string | null, customFieldType: CustomFieldType, syncForward: boolean, fieldConfig?: any | null } | null } | null> } | null };

export type GetCrmIngestionConfigQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  platform?: InputMaybe<CrmIngestionPlatform>;
}>;


export type GetCrmIngestionConfigQuery = { __typename?: 'Query', crmIngestionConfig?: { __typename?: 'CrmIngestionConfigObject', workspaceId?: string | null, syncForward?: boolean | null, syncBack?: boolean | null, syncForwardEntityTypes?: any | null, windowStartDate?: any | null, windowEndDate?: any | null, selectedStageIds?: Array<string | null> | null, pipelineId?: string | null } | null };

export type GetCrmPreviewDealStagesQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  platform: CrmIngestionPlatform;
}>;


export type GetCrmPreviewDealStagesQuery = { __typename?: 'Query', crmPreviewDealStages?: Array<{ __typename?: 'CrmPreviewDealStage', salesforceId?: string | null, hubspotId?: string | null, pipelineId?: string | null, pipelineName?: string | null, name: string, probability?: number | null, isClosed: boolean, isWon: boolean, sortOrder: number } | null> | null };

export type GeCrmIngestionAvailableFieldsQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  platform: CrmIngestionPlatform;
  objectType: CrmIngestionObjectType;
}>;


export type GeCrmIngestionAvailableFieldsQuery = { __typename?: 'Query', crmIngestionAvailableFields?: Array<{ __typename?: 'CrmIngestionAvailableField', platform: CrmIngestionPlatform, objectType: CrmIngestionObjectType, label: string, name: string, description: string, isCalculated: boolean, isEnumeration: boolean, enumerationOptions?: Array<string | null> | null, isMultiSelect?: boolean | null, fieldType: CrmIngestionFieldType, enumerationChoices?: Array<{ __typename?: 'CrmIngestionEnumerationChoice', value: string, label: string }> | null } | null> | null };

export type CreateIngestionFieldMutationVariables = Exact<{
  args: CreateIngestionFieldInput;
}>;


export type CreateIngestionFieldMutation = { __typename?: 'Mutations', createIngestionField?: { __typename?: 'CrmCreateIngestionField', ingestionField?: { __typename: 'CrmIngestionField', id: string, workspaceId: number, platform: CrmIngestionPlatform, objectType: CrmIngestionObjectType, sourceExternalId?: string | null, isStandardField: boolean, crmLabel: string, crmName: string, sourceName: string, crmFieldType: CrmIngestionFieldType, sourceFieldType: CrmIngestionFieldType, isEnumeration: boolean, enumerationData?: any | null, availableInGrid: boolean, availableInRevgpt: boolean, syncBack: boolean, syncBackDestinationName?: string | null, customFieldType: CustomFieldType, syncForward: boolean, fieldConfig?: any | null } | null } | null };

export type UpdateIngestionFieldMutationVariables = Exact<{
  args: Array<InputMaybe<UpdateIngestionFieldInput>> | InputMaybe<UpdateIngestionFieldInput>;
}>;


export type UpdateIngestionFieldMutation = { __typename?: 'Mutations', updateIngestionField?: { __typename?: 'CrmUpdateIngestionField', ingestionFields?: Array<{ __typename: 'CrmIngestionField', id: string, workspaceId: number, platform: CrmIngestionPlatform, objectType: CrmIngestionObjectType, sourceExternalId?: string | null, isStandardField: boolean, crmLabel: string, crmName: string, sourceName: string, crmFieldType: CrmIngestionFieldType, sourceFieldType: CrmIngestionFieldType, isEnumeration: boolean, enumerationData?: any | null, availableInGrid: boolean, availableInRevgpt: boolean, syncBack: boolean, syncBackDestinationName?: string | null, customFieldType: CustomFieldType, syncForward: boolean, fieldConfig?: any | null } | null> | null } | null };

export type DeleteIngestionFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteIngestionFieldMutation = { __typename?: 'Mutations', deleteIngestionField?: { __typename?: 'CrmDeleteIngestionField', success?: boolean | null } | null };

export type UpdateIngestionConfigMutationVariables = Exact<{
  args: UpdateCrmIngestionConfigInput;
}>;


export type UpdateIngestionConfigMutation = { __typename?: 'Mutations', updateIngestionConfig?: { __typename?: 'CrmUpdateIngestionConfig', crmIngestionConfig?: { __typename?: 'CrmIngestionConfigObject', workspaceId?: string | null, syncForward?: boolean | null, syncBack?: boolean | null, syncForwardEntityTypes?: any | null, windowStartDate?: any | null, windowEndDate?: any | null, selectedStageIds?: Array<string | null> | null, pipelineId?: string | null } | null } | null };

export type CrmReIngestMutationVariables = Exact<{
  ignoreUnchanged?: InputMaybe<Scalars['Boolean']['input']>;
  runId: Scalars['Int']['input'];
  useDownloadedData?: InputMaybe<Scalars['Boolean']['input']>;
  useJava?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CrmReIngestMutation = { __typename?: 'Mutations', crmReIngest?: { __typename?: 'CrmReIngest', ok?: boolean | null } | null };

export type CrmIngestionFieldsFragment = { __typename: 'CrmIngestionField', id: string, workspaceId: number, platform: CrmIngestionPlatform, objectType: CrmIngestionObjectType, sourceExternalId?: string | null, isStandardField: boolean, crmLabel: string, crmName: string, sourceName: string, crmFieldType: CrmIngestionFieldType, sourceFieldType: CrmIngestionFieldType, isEnumeration: boolean, enumerationData?: any | null, availableInGrid: boolean, availableInRevgpt: boolean, syncBack: boolean, syncBackDestinationName?: string | null, customFieldType: CustomFieldType, syncForward: boolean, fieldConfig?: any | null };

export type CrmIngestionAvailableFieldsFragment = { __typename?: 'CrmIngestionAvailableField', platform: CrmIngestionPlatform, objectType: CrmIngestionObjectType, label: string, name: string, description: string, isCalculated: boolean, isEnumeration: boolean, enumerationOptions?: Array<string | null> | null, isMultiSelect?: boolean | null, fieldType: CrmIngestionFieldType, enumerationChoices?: Array<{ __typename?: 'CrmIngestionEnumerationChoice', value: string, label: string }> | null };

export type DailyLeadFieldsFragment = { __typename?: 'DailyLead', id: string, workspaceId?: number | null, userId?: number | null, date?: string | null, rank?: number | null, personEmail?: string | null, personName?: string | null, personTitle?: string | null, personLinkedin?: string | null, companyName?: string | null, companyDomain?: string | null, reason?: string | null, rankScore?: number | null, leadScoreSnapshot?: number | null, source?: DailyLeadSource | null, status?: DailyLeadStatus | null, convertedContactExtId?: string | null, createdAt?: any | null, updatedAt?: any | null };

export type GetDailyLeadsQueryVariables = Exact<{
  filter: DailyLeadsFilter;
}>;


export type GetDailyLeadsQuery = { __typename?: 'Query', dailyLeads?: { __typename?: 'DailyLeadConnection', edges: Array<{ __typename?: 'DailyLeadEdge', node?: { __typename?: 'DailyLead', id: string, workspaceId?: number | null, userId?: number | null, date?: string | null, rank?: number | null, personEmail?: string | null, personName?: string | null, personTitle?: string | null, personLinkedin?: string | null, companyName?: string | null, companyDomain?: string | null, reason?: string | null, rankScore?: number | null, leadScoreSnapshot?: number | null, source?: DailyLeadSource | null, status?: DailyLeadStatus | null, convertedContactExtId?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null> } | null };

export type DismissDailyLeadMutationVariables = Exact<{
  input: _MutationInput;
}>;


export type DismissDailyLeadMutation = { __typename?: 'Mutations', dismissDailyLead?: { __typename?: 'DismissDailyLead', dailyLead?: { __typename?: 'DailyLead', id: string, workspaceId?: number | null, userId?: number | null, date?: string | null, rank?: number | null, personEmail?: string | null, personName?: string | null, personTitle?: string | null, personLinkedin?: string | null, companyName?: string | null, companyDomain?: string | null, reason?: string | null, rankScore?: number | null, leadScoreSnapshot?: number | null, source?: DailyLeadSource | null, status?: DailyLeadStatus | null, convertedContactExtId?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type SaveDailyLeadAsContactMutationVariables = Exact<{
  input: _SaveAsContactInput;
}>;


export type SaveDailyLeadAsContactMutation = { __typename?: 'Mutations', saveDailyLeadAsContact?: { __typename?: 'SaveDailyLeadAsContact', dailyLead?: { __typename?: 'DailyLead', id: string, workspaceId?: number | null, userId?: number | null, date?: string | null, rank?: number | null, personEmail?: string | null, personName?: string | null, personTitle?: string | null, personLinkedin?: string | null, companyName?: string | null, companyDomain?: string | null, reason?: string | null, rankScore?: number | null, leadScoreSnapshot?: number | null, source?: DailyLeadSource | null, status?: DailyLeadStatus | null, convertedContactExtId?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type GetDealsAggregatesQueryVariables = Exact<{
  filter?: InputMaybe<DealFilter>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetDealsAggregatesQuery = { __typename?: 'Query', dealsCompareAggregates?: { __typename?: 'DealAggregateResult', pipeline?: { __typename?: 'AggregateChange', previous: number, current: number, diff: number } | null, forecast?: { __typename?: 'AggregateChange', previous: number, current: number, diff: number } | null, averageDealSize?: { __typename?: 'AggregateChange', previous: number, current: number, diff: number } | null, closedWon?: { __typename?: 'AggregateChange', previous: number, current: number, diff: number } | null, averageDaysToClose?: { __typename?: 'AggregateChange', previous: number, current: number, diff: number } | null, bestCase?: { __typename?: 'AggregateChange', previous: number, current: number, diff: number } | null, commit?: { __typename?: 'AggregateChange', previous: number, current: number, diff: number } | null } | null };

export type CreateDealFieldMutationVariables = Exact<{
  input: CreateDealFieldInput;
}>;


export type CreateDealFieldMutation = { __typename?: 'Mutations', createDealField?: { __typename?: 'CreateDealField', dealField?: { __typename?: 'DealFieldClass', id: string, fieldName?: string | null, displayName?: string | null, description?: string | null } | null } | null };

export type GetDealFieldsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetDealFieldsQuery = { __typename?: 'Query', dealFields?: { __typename?: 'DealFieldConnection', edges: Array<{ __typename?: 'DealFieldEdge', node?: { __typename?: 'DealFieldClass', id: string, fieldName?: string | null, displayName?: string | null, description?: string | null, createdAt?: any | null } | null } | null> } | null };

export type GetDealOwnerCountsQueryVariables = Exact<{
  input: RecordAggregateInput;
}>;


export type GetDealOwnerCountsQuery = { __typename?: 'Query', recordAggregate?: { __typename?: 'RecordAggregateResult', total: number, truncated: boolean, otherCount: number, buckets: Array<{ __typename?: 'RecordAggregateBucket', key: string, label?: string | null, docCount: number }> } | null };

export type DealStageFieldsFragment = { __typename: 'DealStage', id: string, workspaceId: number, externalId?: string | null, name: string, i18nKey?: string | null, color: string, colorCode?: string | null, won: boolean, lost: boolean, order?: number | null, probability?: number | null, createTs: any, deleted?: boolean | null, pipelineId?: number | null, pipeline?: { __typename?: 'Pipeline', id: string, workspaceId: number, name: string } | null };

export type GetDealStagesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<DealStageSortEnum>> | InputMaybe<DealStageSortEnum>>;
  filter?: InputMaybe<DealStageFilter>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDealStagesQuery = { __typename?: 'Query', dealStages?: { __typename?: 'DealStageConnection', edges: Array<{ __typename?: 'DealStageEdge', node?: { __typename: 'DealStage', id: string, workspaceId: number, externalId?: string | null, name: string, i18nKey?: string | null, color: string, colorCode?: string | null, won: boolean, lost: boolean, order?: number | null, probability?: number | null, createTs: any, deleted?: boolean | null, pipelineId?: number | null, pipeline?: { __typename?: 'Pipeline', id: string, workspaceId: number, name: string } | null } | null } | null> } | null };

export type CreateDealStageMutationVariables = Exact<{
  input: CreateDealStageInput;
}>;


export type CreateDealStageMutation = { __typename?: 'Mutations', createDealStage?: { __typename?: 'CreateDealStage', dealStage?: { __typename: 'DealStage', id: string, workspaceId: number, externalId?: string | null, name: string, i18nKey?: string | null, color: string, colorCode?: string | null, won: boolean, lost: boolean, order?: number | null, probability?: number | null, createTs: any, deleted?: boolean | null, pipelineId?: number | null, pipeline?: { __typename?: 'Pipeline', id: string, workspaceId: number, name: string } | null } | null } | null };

export type UpdateDealStageMutationVariables = Exact<{
  input: UpdateDealStageInput;
}>;


export type UpdateDealStageMutation = { __typename?: 'Mutations', updateDealStage?: { __typename?: 'UpdateDealStage', dealStage?: { __typename: 'DealStage', id: string, workspaceId: number, externalId?: string | null, name: string, i18nKey?: string | null, color: string, colorCode?: string | null, won: boolean, lost: boolean, order?: number | null, probability?: number | null, createTs: any, deleted?: boolean | null, pipelineId?: number | null, pipeline?: { __typename?: 'Pipeline', id: string, workspaceId: number, name: string } | null } | null } | null };

export type DeleteDealStageMutationVariables = Exact<{
  input: DeleteDealStageInput;
}>;


export type DeleteDealStageMutation = { __typename?: 'Mutations', deleteDealStage?: { __typename?: 'DeleteDealStage', success?: boolean | null } | null };

export type PipelineFieldsFragment = { __typename: 'Pipeline', id: string, workspaceId: number, name: string, i18nKey?: string | null, fromExternalSource?: boolean | null, createTs: any, updateTs: any, deleted: boolean };

export type GetPipelinesQueryVariables = Exact<{
  filter?: InputMaybe<PipelineFilter>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPipelinesQuery = { __typename?: 'Query', pipelines?: { __typename?: 'PipelineConnection', edges: Array<{ __typename?: 'PipelineEdge', node?: { __typename: 'Pipeline', hasActiveDeals?: boolean | null, includeInForecast: boolean, id: string, workspaceId: number, name: string, i18nKey?: string | null, fromExternalSource?: boolean | null, createTs: any, updateTs: any, deleted: boolean, stages?: { __typename?: 'DealStageConnection', edges: Array<{ __typename?: 'DealStageEdge', node?: { __typename: 'DealStage', id: string, workspaceId: number, externalId?: string | null, name: string, i18nKey?: string | null, color: string, colorCode?: string | null, won: boolean, lost: boolean, order?: number | null, probability?: number | null, createTs: any, deleted?: boolean | null, pipelineId?: number | null, pipeline?: { __typename?: 'Pipeline', id: string, workspaceId: number, name: string } | null } | null } | null> } | null } | null } | null> } | null };

export type CreatePipelineMutationVariables = Exact<{
  input: CreatePipelineInput;
}>;


export type CreatePipelineMutation = { __typename?: 'Mutations', createPipeline?: { __typename?: 'CreatePipeline', pipeline?: { __typename: 'Pipeline', id: string, workspaceId: number, name: string, i18nKey?: string | null, fromExternalSource?: boolean | null, createTs: any, updateTs: any, deleted: boolean, stages?: { __typename?: 'DealStageConnection', edges: Array<{ __typename?: 'DealStageEdge', node?: { __typename: 'DealStage', id: string, workspaceId: number, externalId?: string | null, name: string, i18nKey?: string | null, color: string, colorCode?: string | null, won: boolean, lost: boolean, order?: number | null, probability?: number | null, createTs: any, deleted?: boolean | null, pipelineId?: number | null, pipeline?: { __typename?: 'Pipeline', id: string, workspaceId: number, name: string } | null } | null } | null> } | null } | null } | null };

export type EditPipelineMutationVariables = Exact<{
  input: EditPipelineInput;
}>;


export type EditPipelineMutation = { __typename?: 'Mutations', editPipeline?: { __typename?: 'EditPipeline', pipeline?: { __typename: 'Pipeline', id: string, workspaceId: number, name: string, i18nKey?: string | null, fromExternalSource?: boolean | null, createTs: any, updateTs: any, deleted: boolean, stages?: { __typename?: 'DealStageConnection', edges: Array<{ __typename?: 'DealStageEdge', node?: { __typename: 'DealStage', id: string, workspaceId: number, externalId?: string | null, name: string, i18nKey?: string | null, color: string, colorCode?: string | null, won: boolean, lost: boolean, order?: number | null, probability?: number | null, createTs: any, deleted?: boolean | null, pipelineId?: number | null, pipeline?: { __typename?: 'Pipeline', id: string, workspaceId: number, name: string } | null } | null } | null> } | null } | null } | null };

export type DeletePipelineMutationVariables = Exact<{
  input: DeletePipelineInput;
}>;


export type DeletePipelineMutation = { __typename?: 'Mutations', deletePipeline?: { __typename?: 'DeletePipeline', ok?: boolean | null, pipeline?: { __typename?: 'Pipeline', id: string, deleted: boolean } | null } | null };

export type MoveDealsAndDeletePipelineMutationVariables = Exact<{
  input: MoveDealsAndDeletePipelineInput;
}>;


export type MoveDealsAndDeletePipelineMutation = { __typename?: 'Mutations', moveDealsAndDeletePipeline?: { __typename?: 'MoveDealsAndDeletePipeline', ok?: boolean | null, movedDealsCount?: number | null, fromPipeline?: { __typename?: 'Pipeline', id: string, deleted: boolean } | null, toPipeline?: { __typename?: 'Pipeline', id: string } | null } | null };

export type DealPropertiesFieldsFragment = { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null };

export type DealFieldsFragment = { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null };

export type DealRelationsFragment = { __typename?: 'Deal', accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null, dealInfo?: { __typename?: 'DealInfo', id?: string | null, dealId?: string | null, createdAt?: any | null, updatedAt?: any | null, fields?: Array<{ __typename?: 'DealFieldValue', fieldName: string, displayName?: string | null, description?: string | null, bullets: Array<string | null> } | null> | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastActivityEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null, nextStepEngagements?: Array<{ __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null> | null, lineItems?: Array<{ __typename: 'LineItem', id: string, workspaceId?: number | null, dealId?: string | null, productId?: string | null, properties?: { __typename?: 'LineItemProperties', name?: string | null, quantity?: number | null, listPrice?: number | null, unitPrice?: number | null, totalPrice?: number | null, discountPercent?: number | null, productCode?: string | null } | null, product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null } | null> | null };

export type DealSnapshotFieldsFragment = { __typename?: 'DealSnapshot', id: string, dealId: number, ownerId?: number | null, asOfTs?: any | null, customProperties?: any | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null };

export type GetDealsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DealFilter>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetDealsQuery = { __typename?: 'Query', deals?: { __typename?: 'DealConnection', totalCount?: number | null, edges: Array<{ __typename?: 'DealEdge', cursor: string, node?: { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, snapshots?: Array<{ __typename?: 'DealSnapshot', id: string, dealId: number, ownerId?: number | null, asOfTs?: any | null, customProperties?: any | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null } | null> | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null, dealInfo?: { __typename?: 'DealInfo', id?: string | null, dealId?: string | null, createdAt?: any | null, updatedAt?: any | null, fields?: Array<{ __typename?: 'DealFieldValue', fieldName: string, displayName?: string | null, description?: string | null, bullets: Array<string | null> } | null> | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastActivityEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null, nextStepEngagements?: Array<{ __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null> | null, lineItems?: Array<{ __typename: 'LineItem', id: string, workspaceId?: number | null, dealId?: string | null, productId?: string | null, properties?: { __typename?: 'LineItemProperties', name?: string | null, quantity?: number | null, listPrice?: number | null, unitPrice?: number | null, totalPrice?: number | null, discountPercent?: number | null, productCode?: string | null } | null, product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null } | null> | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetDealQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDealQuery = { __typename?: 'Query', deal?: { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, properties?: { __typename?: 'DealProperties', aiSummary?: string | null, name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, userLists?: { __typename?: 'UserListConnection', edges: Array<{ __typename?: 'UserListEdge', node?: { __typename?: 'UserList', list: { __typename: 'List', id: string, name: string, properties: any, public: boolean, modelType: ListModelType, deleted: boolean, ownerId: number, createTs: any, updateTs: any, workspaceId: number, static: boolean } } | null } | null> } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null, dealInfo?: { __typename?: 'DealInfo', id?: string | null, dealId?: string | null, createdAt?: any | null, updatedAt?: any | null, fields?: Array<{ __typename?: 'DealFieldValue', fieldName: string, displayName?: string | null, description?: string | null, bullets: Array<string | null> } | null> | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastActivityEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null, nextStepEngagements?: Array<{ __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null> | null, lineItems?: Array<{ __typename: 'LineItem', id: string, workspaceId?: number | null, dealId?: string | null, productId?: string | null, properties?: { __typename?: 'LineItemProperties', name?: string | null, quantity?: number | null, listPrice?: number | null, unitPrice?: number | null, totalPrice?: number | null, discountPercent?: number | null, productCode?: string | null } | null, product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null } | null> | null } | null };

export type CreateDealMutationVariables = Exact<{
  input: CreateDealInput;
}>;


export type CreateDealMutation = { __typename?: 'Mutations', createDeal?: { __typename?: 'CreateDeal', deal?: { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null, dealInfo?: { __typename?: 'DealInfo', id?: string | null, dealId?: string | null, createdAt?: any | null, updatedAt?: any | null, fields?: Array<{ __typename?: 'DealFieldValue', fieldName: string, displayName?: string | null, description?: string | null, bullets: Array<string | null> } | null> | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastActivityEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null, nextStepEngagements?: Array<{ __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null> | null, lineItems?: Array<{ __typename: 'LineItem', id: string, workspaceId?: number | null, dealId?: string | null, productId?: string | null, properties?: { __typename?: 'LineItemProperties', name?: string | null, quantity?: number | null, listPrice?: number | null, unitPrice?: number | null, totalPrice?: number | null, discountPercent?: number | null, productCode?: string | null } | null, product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null } | null> | null } | null } | null };

export type UpdateDealMutationVariables = Exact<{
  input: UpdateDealInput;
}>;


export type UpdateDealMutation = { __typename?: 'Mutations', updateDeal?: { __typename?: 'UpdateDeal', deal?: { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, userLists?: { __typename?: 'UserListConnection', edges: Array<{ __typename?: 'UserListEdge', node?: { __typename?: 'UserList', list: { __typename: 'List', id: string, name: string, properties: any, public: boolean, modelType: ListModelType, deleted: boolean, ownerId: number, createTs: any, updateTs: any, workspaceId: number, static: boolean } } | null } | null> } | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null, dealInfo?: { __typename?: 'DealInfo', id?: string | null, dealId?: string | null, createdAt?: any | null, updatedAt?: any | null, fields?: Array<{ __typename?: 'DealFieldValue', fieldName: string, displayName?: string | null, description?: string | null, bullets: Array<string | null> } | null> | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastActivityEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null, nextStepEngagements?: Array<{ __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null> | null, lineItems?: Array<{ __typename: 'LineItem', id: string, workspaceId?: number | null, dealId?: string | null, productId?: string | null, properties?: { __typename?: 'LineItemProperties', name?: string | null, quantity?: number | null, listPrice?: number | null, unitPrice?: number | null, totalPrice?: number | null, discountPercent?: number | null, productCode?: string | null } | null, product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null } | null> | null } | null } | null };

export type DeleteDealMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDealMutation = { __typename?: 'Mutations', deleteDeal?: { __typename?: 'DeleteDeal', success?: boolean | null } | null };

export type DealCreationFieldSettingsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  workspaceIdInt?: InputMaybe<Scalars['Int']['input']>;
  platform: CrmIngestionPlatform;
  first?: InputMaybe<Scalars['Int']['input']>;
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DealCreationFieldSettingsQuery = { __typename?: 'Query', dealCreationFields?: Array<{ __typename?: 'DealCreationField', id: string, kind: DealCreationFieldKindEnum, standardKey?: string | null, required: boolean, position: number, crmField?: { __typename?: 'CrmIngestionField', id: string, crmLabel: string, crmName: string, customFieldType: CustomFieldType, isEnumeration: boolean, enumerationData?: any | null, objectType: CrmIngestionObjectType, isStandardField: boolean } | null } | null> | null, crmIngestionFields?: { __typename?: 'CrmIngestionFieldConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'CrmIngestionFieldEdge', cursor: string, node?: { __typename?: 'CrmIngestionField', id: string, workspaceId: number, platform: CrmIngestionPlatform, objectType: CrmIngestionObjectType, sourceExternalId?: string | null, isStandardField: boolean, crmLabel: string, crmName: string, sourceName: string, crmFieldType: CrmIngestionFieldType, sourceFieldType: CrmIngestionFieldType, isEnumeration: boolean, enumerationData?: any | null, availableInGrid: boolean, availableInRevgpt: boolean, syncBack: boolean, syncBackDestinationName?: string | null, customFieldType: CustomFieldType, syncForward: boolean } | null } | null> } | null };

export type UpdateDealCreationFieldsMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  fields: Array<DealCreationFieldConfigInput> | DealCreationFieldConfigInput;
}>;


export type UpdateDealCreationFieldsMutation = { __typename?: 'Mutations', updateDealCreationFields?: { __typename?: 'UpdateDealCreationFields', ok?: boolean | null, fields?: Array<{ __typename?: 'DealCreationField', id: string, kind: DealCreationFieldKindEnum, standardKey?: string | null, required: boolean, position: number, crmField?: { __typename?: 'CrmIngestionField', id: string, crmLabel: string } | null } | null> | null } | null };

export type CreateDesktopCodeMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type CreateDesktopCodeMutation = { __typename?: 'Mutations', createDesktopPairingCode?: { __typename?: 'CreateDesktopPairingCode', code: string, expiresAt: any } | null };

export type GetEmailTemplatesQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type GetEmailTemplatesQuery = { __typename?: 'Query', emailTemplates?: Array<{ __typename?: 'EmailTemplateClass', id: string, title?: string | null, subject?: string | null, body?: string | null, attachmentUrls?: Array<string | null> | null }> | null };

export type CreateEmailTemplateMutationVariables = Exact<{
  input: CreateEmailTemplateInput;
}>;


export type CreateEmailTemplateMutation = { __typename?: 'Mutations', createEmailTemplate?: { __typename?: 'CreateEmailTemplate', emailTemplate?: { __typename?: 'EmailTemplateClass', id: string, title?: string | null, subject?: string | null, body?: string | null, attachmentUrls?: Array<string | null> | null } | null } | null };

export type UpdateEmailTemplateMutationVariables = Exact<{
  input: UpdateEmailTemplateInput;
}>;


export type UpdateEmailTemplateMutation = { __typename?: 'Mutations', updateEmailTemplate?: { __typename?: 'UpdateEmailTemplate', emailTemplate?: { __typename?: 'EmailTemplateClass', id: string, title?: string | null, subject?: string | null, body?: string | null, attachmentUrls?: Array<string | null> | null } | null } | null };

export type DeleteEmailTemplateMutationVariables = Exact<{
  input: DeleteEmailTemplateInput;
}>;


export type DeleteEmailTemplateMutation = { __typename?: 'Mutations', deleteEmailTemplate?: { __typename?: 'DeleteEmailTemplate', success?: boolean | null } | null };

export type CreateDefaultEmailTemplatesMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type CreateDefaultEmailTemplatesMutation = { __typename?: 'Mutations', createDefaultEmailTemplates?: { __typename?: 'CreateDefaultEmailTemplates', emailTemplates?: Array<{ __typename?: 'EmailTemplateClass', id: string, title?: string | null, subject?: string | null, body?: string | null, attachmentUrls?: Array<string | null> | null } | null> | null } | null };

export type SendEmailsMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  fromEmail: Scalars['String']['input'];
  fromName: Scalars['String']['input'];
  sendIndividually: Scalars['Boolean']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  toEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ccEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  bccEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  resolvedEmails?: InputMaybe<Array<InputMaybe<ResolvedEmailInput>> | InputMaybe<ResolvedEmailInput>>;
  attachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type SendEmailsMutation = { __typename?: 'Mutations', sendEmails?: { __typename?: 'SendEmails', ok?: boolean | null } | null };

export type BaseEngagementFieldsFragment = { __typename?: 'Engagement', id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null };

export type EngagementFieldsFragment = { __typename?: 'Engagement', body?: string | null, bodyHtml?: string | null, aiSummary?: string | null, aiFollowup?: string | null, aiBrief?: string | null, metadata?: any | null, id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, attachments?: Array<{ __typename?: 'FileType', id?: string | null, name?: string | null, type?: string | null, url?: string | null } | null> | null, accounts?: Array<{ __typename?: 'Account', id: string, workspaceId: number, domain?: string | null } | null> | null };

export type EngagementRelationsFragment = { __typename?: 'Engagement', accounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, users?: Array<{ __typename?: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null } | null> | null };

export type EngagementContactsFragment = { __typename?: 'Engagement', contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, city?: string | null, state?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null } | null> | null };

export type EngagementTranscriptFragment = { __typename?: 'Engagement', recallTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, gongTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, granolaTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, firefliesTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null };

export type EngagementSummariesFragment = { __typename?: 'Engagement', summaries?: Array<{ __typename?: 'EngagementSummaryType', id?: string | null, summary?: any | null, summaryTemplateId?: string | null } | null> | null };

export type EngagementTaskSuggestionsFragment = { __typename?: 'Engagement', taskSuggestions?: Array<{ __typename?: 'TaskSuggestion', id: string, title?: string | null, description?: string | null, priority?: string | null, suggestedDueDate?: any | null, confidenceScore?: number | null, sourceQuote?: string | null, isAccepted?: boolean | null, isDismissed?: boolean | null, createdAt?: any | null, suggestedContacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, suggestedAccounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null } | null> | null };

export type EngagementDealSuggestionsFragment = { __typename?: 'Engagement', dealSuggestions?: Array<{ __typename?: 'DealSuggestion', id: string, dealName?: string | null, description?: string | null, estimatedAmount?: number | null, estimatedCloseDate?: any | null, suggestedStageId?: number | null, confidenceScore?: number | null, sourceQuote?: string | null, isAccepted?: boolean | null, isDismissed?: boolean | null, suggestedOwner?: { __typename?: 'User', id: string } | null, suggestedAccount?: { __typename?: 'Account', id: string } | null, suggestedContacts?: Array<{ __typename?: 'Contact', id: string } | null> | null } | null> | null };

export type EngagementAiFragment = { __typename?: 'Engagement', aiSummary?: string | null, aiFollowup?: string | null, aiBrief?: string | null };

export type GetEngagementsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: EngagementFilter;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetEngagementsListQuery = { __typename?: 'Query', engagements?: { __typename?: 'EngagementConnection', totalCount?: number | null, edges: Array<{ __typename?: 'EngagementEdge', cursor: string, node?: { __typename?: 'Engagement', id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, accounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetEngagementsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: EngagementFilter;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetEngagementsQuery = { __typename?: 'Query', engagements?: { __typename?: 'EngagementConnection', totalCount?: number | null, edges: Array<{ __typename?: 'EngagementEdge', cursor: string, node?: { __typename?: 'Engagement', body?: string | null, bodyHtml?: string | null, aiSummary?: string | null, aiFollowup?: string | null, aiBrief?: string | null, metadata?: any | null, id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, attachments?: Array<{ __typename?: 'FileType', id?: string | null, name?: string | null, type?: string | null, url?: string | null } | null> | null, accounts?: Array<{ __typename?: 'Account', id: string, workspaceId: number, domain?: string | null } | null> | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetEngagementsBaseQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: EngagementFilter;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetEngagementsBaseQuery = { __typename?: 'Query', engagements?: { __typename?: 'EngagementConnection', totalCount?: number | null, edges: Array<{ __typename?: 'EngagementEdge', cursor: string, node?: { __typename?: 'Engagement', id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetEngagementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetEngagementQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', body?: string | null, bodyHtml?: string | null, aiSummary?: string | null, aiFollowup?: string | null, aiBrief?: string | null, metadata?: any | null, id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, attachments?: Array<{ __typename?: 'FileType', id?: string | null, name?: string | null, type?: string | null, url?: string | null } | null> | null, accounts?: Array<{ __typename: 'Account', id: string, workspaceId: number, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, users?: Array<{ __typename?: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null } | null> | null, recallTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, gongTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, granolaTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, firefliesTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, summaries?: Array<{ __typename?: 'EngagementSummaryType', id?: string | null, summary?: any | null, summaryTemplateId?: string | null } | null> | null, taskSuggestions?: Array<{ __typename?: 'TaskSuggestion', id: string, title?: string | null, description?: string | null, priority?: string | null, suggestedDueDate?: any | null, confidenceScore?: number | null, sourceQuote?: string | null, isAccepted?: boolean | null, isDismissed?: boolean | null, createdAt?: any | null, suggestedContacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, suggestedAccounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null } | null> | null } | null };

export type GetEngagementBriefQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetEngagementBriefQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, aiSummary?: string | null, aiFollowup?: string | null, aiBrief?: string | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, city?: string | null, state?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null } | null> | null } | null };

export type GetEngagementFollowUpQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetEngagementFollowUpQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, aiSummary?: string | null, aiFollowup?: string | null, aiBrief?: string | null, recallTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, gongTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, granolaTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, firefliesTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, city?: string | null, state?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null } | null> | null } | null };

export type GetEngagementTranscriptQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetEngagementTranscriptQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, aiSummary?: string | null, aiFollowup?: string | null, aiBrief?: string | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, city?: string | null, state?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null } | null> | null, recallTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, gongTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, granolaTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, firefliesTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null } | null };

export type GetEngagementNoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetEngagementNoteQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, city?: string | null, state?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null } | null> | null } | null };

export type GetEngagementContentAvailabilityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
  notesFilter: NoteFilter;
}>;


export type GetEngagementContentAvailabilityQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, hasTranscript: boolean, hasAiBrief: boolean, startTime?: any | null } | null, notes?: { __typename?: 'NoteConnection', totalCount?: number | null } | null };

export type GetEngagementTaskSuggestionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetEngagementTaskSuggestionsQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, taskSuggestions?: Array<{ __typename?: 'TaskSuggestion', id: string, title?: string | null, description?: string | null, priority?: string | null, suggestedDueDate?: any | null, confidenceScore?: number | null, sourceQuote?: string | null, isAccepted?: boolean | null, isDismissed?: boolean | null, createdAt?: any | null, suggestedContacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, suggestedAccounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, city?: string | null, state?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null } | null> | null } | null };

export type GetEngagementDealSuggestionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetEngagementDealSuggestionsQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, dealSuggestions?: Array<{ __typename?: 'DealSuggestion', id: string, dealName?: string | null, description?: string | null, estimatedAmount?: number | null, estimatedCloseDate?: any | null, suggestedStageId?: number | null, confidenceScore?: number | null, sourceQuote?: string | null, isAccepted?: boolean | null, isDismissed?: boolean | null, suggestedOwner?: { __typename?: 'User', id: string } | null, suggestedAccount?: { __typename?: 'Account', id: string } | null, suggestedContacts?: Array<{ __typename?: 'Contact', id: string } | null> | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, city?: string | null, state?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null } | null> | null } | null };

export type AcceptDealSuggestionMutationVariables = Exact<{
  input: AcceptDealSuggestionInput;
}>;


export type AcceptDealSuggestionMutation = { __typename?: 'Mutations', acceptDealSuggestion?: { __typename?: 'AcceptDealSuggestion', dealSuggestion?: { __typename?: 'DealSuggestion', id: string, isAccepted?: boolean | null, isDismissed?: boolean | null } | null } | null };

export type AcceptTaskSuggestionMutationVariables = Exact<{
  input: AcceptTaskSuggestionInput;
}>;


export type AcceptTaskSuggestionMutation = { __typename?: 'Mutations', acceptTaskSuggestion?: { __typename?: 'AcceptTaskSuggestion', taskSuggestion?: { __typename?: 'TaskSuggestion', id: string, title?: string | null, isAccepted?: boolean | null, isDismissed?: boolean | null } | null } | null };

export type ShareEngagementMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  engagementId: Scalars['String']['input'];
  notifyOnView?: InputMaybe<Scalars['Boolean']['input']>;
  summaryTemplateId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShareEngagementMutation = { __typename?: 'Mutations', shareEngagement?: { __typename?: 'CreateEngagementShare', ok?: boolean | null, message?: string | null, slug?: string | null, notifyOnView?: boolean | null } | null };

export type EngagementBasicQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type EngagementBasicQuery = { __typename?: 'Query', engagementBasic?: { __typename?: 'EngagementBasicType', displayName?: string | null, startTime?: any | null, sharedBy?: { __typename?: 'SharedByUser', givenName?: string | null, surname?: string | null, profileImageUrl?: string | null } | null } | null };

export type TrackEngagementViewMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type TrackEngagementViewMutation = { __typename?: 'Mutations', trackEngagementView?: { __typename?: 'TrackEngagementViewType', name?: string | null, aiSummary?: string | null, platform?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, firefliesVideoUrl?: string | null, summaries?: Array<{ __typename?: 'EngagementSummaryType', id?: string | null, engagementId?: string | null, summaryTemplateId?: string | null, summary?: any | null, createdAt?: any | null, updatedAt?: any | null } | null> | null, summaryTemplates?: Array<{ __typename?: 'SummaryTemplateType', id?: string | null, name?: string | null, isDefault?: boolean | null, sections?: Array<{ __typename?: 'TemplateSectionType', heading?: string | null, prompt?: string | null, order?: number | null } | null> | null } | null> | null, recallTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null, confidence?: number | null, language?: string | null } | null> | null } | null> | null, gongTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, granolaTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, firefliesTranscript?: Array<{ __typename?: 'TranscriptEntryType', speaker?: string | null, speakerId?: number | null, language?: string | null, words?: Array<{ __typename?: 'TranscriptWordType', text?: string | null, startTimestamp?: number | null, endTimestamp?: number | null } | null> | null } | null> | null, sharedBy?: { __typename?: 'SharedByUser', givenName?: string | null, surname?: string | null, profileImageUrl?: string | null } | null, note?: { __typename?: 'Note', id: string, title?: string | null, createdAt?: any | null, updatedAt?: any | null, aiGenerated?: boolean | null, aiNotesContent?: any | null, blocks?: any | null, user?: { __typename?: 'User', id: string, givenName?: string | null, surname?: string | null } | null } | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null } | null };

export type UpdateMeetingRecordingMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  override?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMeetingRecordingMutation = { __typename?: 'Mutations', updateMeetingRecording?: { __typename?: 'UpdateMeetingRecording', ok?: boolean | null, message?: string | null, code?: string | null } | null };

export type GetUserFavoritesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetUserFavoritesQuery = { __typename?: 'Query', userFavorites?: Array<{ __typename?: 'UserFavoriteType', id?: number | null, userId?: number | null, workspaceId?: number | null, entityType?: string | null, entityId?: string | null, extraData?: any | null, createTs?: any | null } | null> | null };

export type AddFavoriteMutationVariables = Exact<{
  input: AddFavoriteInput;
}>;


export type AddFavoriteMutation = { __typename?: 'Mutations', addFavorite?: { __typename?: 'AddFavorite', favorite?: { __typename?: 'UserFavoriteType', id?: number | null, userId?: number | null, workspaceId?: number | null, entityType?: string | null, entityId?: string | null, extraData?: any | null, createTs?: any | null } | null } | null };

export type RemoveFavoriteMutationVariables = Exact<{
  input: RemoveFavoriteInput;
}>;


export type RemoveFavoriteMutation = { __typename?: 'Mutations', removeFavorite?: { __typename?: 'RemoveFavorite', ok?: boolean | null } | null };

export type GetFieldHistoryQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  entityType: FieldHistoryEntityType;
  field: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  includeAutomated?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetFieldHistoryQuery = { __typename?: 'Query', fieldHistory: { __typename?: 'FieldHistory', hiddenCount: number, hasMore: boolean, entries: Array<{ __typename?: 'FieldHistoryEntry', id: string, field: string, action: FieldHistoryAction, value?: string | null, values: Array<string>, source: string, sourceKind: FieldHistorySourceKind, sourceGroup: FieldHistorySourceGroup, isAutomated: boolean, changedAt: any, collapsedCount: number, changedBy?: { __typename?: 'FieldHistoryActor', userId?: string | null, name: string, email?: string | null } | null, records?: Array<{ __typename?: 'FieldHistoryRecordRef', id: string, name?: string | null, status: FieldHistoryRecordStatus }> | null }> } };

export type FileFieldsFragment = { __typename: 'File', id: string, workspaceId?: number | null, userId?: number | null, filename?: string | null, mimeType?: string | null, size?: number | null, fileUrl?: string | null, uploadedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, source?: FileSource | null };

export type FileRelationsFragment = { __typename?: 'File', user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: Array<{ __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'AccountProperties', name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, externalId: string, primaryEmail?: string | null, profileImageUrl?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, phone?: string | null, city?: string | null, state?: string | null, country?: string | null, linkedinProfileUrl?: string | null, note?: string | null, highlight?: string | null, additionalEmails?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null, ownerId?: string | null, profileImageUrl?: string | null } | null } | null> | null, deals?: Array<{ __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null } | null> | null, engagements?: Array<{ __typename?: 'Engagement', body?: string | null, bodyHtml?: string | null, aiSummary?: string | null, aiFollowup?: string | null, aiBrief?: string | null, metadata?: any | null, id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, attachments?: Array<{ __typename?: 'FileType', id?: string | null, name?: string | null, type?: string | null, url?: string | null } | null> | null, accounts?: Array<{ __typename: 'Account', id: string, workspaceId: number, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, users?: Array<{ __typename?: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null } | null> | null } | null> | null };

export type GetFilesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: FileFilter;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetFilesQuery = { __typename?: 'Query', files?: { __typename?: 'FileConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FileEdge', cursor: string, node?: { __typename: 'File', id: string, workspaceId?: number | null, userId?: number | null, filename?: string | null, mimeType?: string | null, size?: number | null, fileUrl?: string | null, uploadedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, source?: FileSource | null, user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: Array<{ __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'AccountProperties', name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, externalId: string, primaryEmail?: string | null, profileImageUrl?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, phone?: string | null, city?: string | null, state?: string | null, country?: string | null, linkedinProfileUrl?: string | null, note?: string | null, highlight?: string | null, additionalEmails?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null, ownerId?: string | null, profileImageUrl?: string | null } | null } | null> | null, deals?: Array<{ __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null } | null> | null, engagements?: Array<{ __typename?: 'Engagement', body?: string | null, bodyHtml?: string | null, aiSummary?: string | null, aiFollowup?: string | null, aiBrief?: string | null, metadata?: any | null, id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, attachments?: Array<{ __typename?: 'FileType', id?: string | null, name?: string | null, type?: string | null, url?: string | null } | null> | null, accounts?: Array<{ __typename: 'Account', id: string, workspaceId: number, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, users?: Array<{ __typename?: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null } | null> | null } | null> | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetFileQuery = { __typename?: 'Query', file?: { __typename: 'File', id: string, workspaceId?: number | null, userId?: number | null, filename?: string | null, mimeType?: string | null, size?: number | null, fileUrl?: string | null, uploadedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, source?: FileSource | null, user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: Array<{ __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'AccountProperties', name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, externalId: string, primaryEmail?: string | null, profileImageUrl?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, phone?: string | null, city?: string | null, state?: string | null, country?: string | null, linkedinProfileUrl?: string | null, note?: string | null, highlight?: string | null, additionalEmails?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null, ownerId?: string | null, profileImageUrl?: string | null } | null } | null> | null, deals?: Array<{ __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null } | null> | null, engagements?: Array<{ __typename?: 'Engagement', body?: string | null, bodyHtml?: string | null, aiSummary?: string | null, aiFollowup?: string | null, aiBrief?: string | null, metadata?: any | null, id: string, workspaceId?: number | null, deleted: boolean, status?: string | null, privacy?: string | null, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, link?: string | null, platform?: string | null, source?: string | null, recallVideoUrl?: string | null, coffeeVideoUrl?: string | null, gongVideoUrl?: string | null, granolaVideoUrl?: string | null, firefliesVideoUrl?: string | null, engagementType?: DdbEngagementType | null, hasActiveBot: boolean, recordingEnabled: boolean, recordingRecorderType?: string | null, recordingOwnerUserId?: number | null, currentUserRecordingEnabled: boolean, userId?: number | null, isInternal: boolean, participantAccountIds?: Array<string | null> | null, participantContactIds?: Array<string | null> | null, participantUserIds?: Array<number | null> | null, associatedDealIds?: Array<string | null> | null, hasTranscript: boolean, hasAiSummary: boolean, hasAiFollowup: boolean, hasAiBrief: boolean, metadataFrom?: string | null, transcriptStatusMessage?: string | null, transcriptIncomplete?: boolean | null, currentUserStatus?: DdbEngagementStatus | null, userStatus?: any | null, attachments?: Array<{ __typename?: 'FileType', id?: string | null, name?: string | null, type?: string | null, url?: string | null } | null> | null, accounts?: Array<{ __typename: 'Account', id: string, workspaceId: number, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, users?: Array<{ __typename?: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null } | null> | null } | null> | null } | null };

export type CreateFileMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  fileUrl: Scalars['String']['input'];
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dealIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateFileMutation = { __typename?: 'Mutations', createFile?: { __typename?: 'CreateFile', file?: { __typename: 'File', id: string, workspaceId?: number | null, userId?: number | null, filename?: string | null, mimeType?: string | null, size?: number | null, fileUrl?: string | null, uploadedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, source?: FileSource | null } | null } | null };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutations', deleteFile?: { __typename?: 'DeleteFile', success?: boolean | null } | null };

export type GenerateFormulaQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  objectType: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type GenerateFormulaQuery = { __typename?: 'Query', generateFormula?: { __typename?: 'GenerateFormulaResult', expression?: string | null, resultType?: string | null, gaps?: Array<string | null> | null, error?: string | null } | null };

export type RunFormulaFieldMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  fieldId: Scalars['Int']['input'];
}>;


export type RunFormulaFieldMutation = { __typename?: 'Mutations', runFormulaField?: { __typename?: 'RunFormulaField', execution?: { __typename?: 'AiJobExecutionType', id?: string | null, workspaceId?: number | null, fieldId?: number | null, status?: string | null, totalRecords?: number | null, processedRecords?: number | null, failedRecords?: number | null, progressPercentage?: number | null, temporalWorkflowId?: string | null, createdAt?: any | null } | null } | null };

export type GetGptResponseQueryVariables = Exact<{
  transcript?: InputMaybe<Scalars['String']['input']>;
  summaryTemplate?: InputMaybe<SummaryTemplate>;
  timezone: Scalars['String']['input'];
  type: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type GetGptResponseQuery = { __typename?: 'Query', gptResponse?: { __typename?: 'GPTResponse', response?: string | null } | null };

export type GetDealsGridSummariesQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  filter?: InputMaybe<DealFilter>;
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetDealsGridSummariesQuery = { __typename?: 'Query', gridSummary?: { __typename?: 'GridSummary', deal?: { __typename?: 'DealGridSummary', fillRates?: Array<{ __typename?: 'FillRateDatum', columnName?: string | null, fillRate?: number | null, filled?: number | null, missing?: number | null } | null> | null, metrics?: Array<{ __typename?: 'MetricDatum', columnName?: string | null, sum?: number | null, avg?: number | null } | null> | null } | null } | null };

export type GetAccountsGridSummariesQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  filter?: InputMaybe<AccountFilter>;
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetAccountsGridSummariesQuery = { __typename?: 'Query', gridSummary?: { __typename?: 'GridSummary', account?: { __typename?: 'AccountGridSummary', fillRates?: Array<{ __typename?: 'FillRateDatum', columnName?: string | null, fillRate?: number | null, filled?: number | null, missing?: number | null } | null> | null } | null } | null };

export type GetContactsGridSummariesQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  filter?: InputMaybe<ContactFilterInput>;
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetContactsGridSummariesQuery = { __typename?: 'Query', gridSummary?: { __typename?: 'GridSummary', contact?: { __typename?: 'ContactGridSummary', fillRates?: Array<{ __typename?: 'FillRateDatum', columnName?: string | null, fillRate?: number | null, filled?: number | null, missing?: number | null } | null> | null } | null } | null };

export type IndustryFieldsFragment = { __typename: 'Industry', label?: string | null };

export type GetIndustriesQueryVariables = Exact<{
  filter: IndustryFilter;
}>;


export type GetIndustriesQuery = { __typename?: 'Query', industries?: { __typename?: 'IndustryConnection', edges: Array<{ __typename?: 'IndustryEdge', cursor: string, node?: { __typename: 'Industry', label?: string | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type IntegrationFieldsFragment = { __typename: 'Integration', workspaceId: number, platform: IntegrationPlatform, category: IntegrationPlatformCategory, addedTs?: any | null, status?: IntegrationStatus | null, disconnectReason?: DisconnectReason | null };

export type UserIntegrationFieldsFragment = { __typename: 'UserIntegration', platform: UserIntegrationPlatform, addedTs?: any | null, status?: UserIntegrationStatus | null, disconnectReason?: DisconnectReason | null, lookbackDays?: number | null, webhookUrl?: string | null, webhookSecret?: string | null, keepCoffeeRecording?: boolean | null };

export type IntegrationWithTokenFieldsFragment = { __typename: 'IntegrationWithToken', workspaceId: number, platform: IntegrationPlatform, category: IntegrationPlatformCategory, addedTs?: any | null, status: IntegrationStatus, accessToken: string };

export type GetIntegrationsQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type GetIntegrationsQuery = { __typename?: 'Query', integrations?: Array<{ __typename: 'Integration', workspaceId: number, platform: IntegrationPlatform, category: IntegrationPlatformCategory, addedTs?: any | null, status?: IntegrationStatus | null, disconnectReason?: DisconnectReason | null } | null> | null };

export type GetUserIntegrationsQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type GetUserIntegrationsQuery = { __typename?: 'Query', userIntegrations?: Array<{ __typename: 'UserIntegration', platform: UserIntegrationPlatform, addedTs?: any | null, status?: UserIntegrationStatus | null, disconnectReason?: DisconnectReason | null, lookbackDays?: number | null, webhookUrl?: string | null, webhookSecret?: string | null, keepCoffeeRecording?: boolean | null } | null> | null };

export type IngestionRunFieldsFragment = { __typename: 'CrmIngestionRun', platform: CrmIngestionPlatform, workspaceId: number, status: CrmIngestionStatus, asOfTs?: any | null, runId: number, properties?: { __typename?: 'CrmIngestionRunProperties', lastStep?: string | null, lastStepTs?: any | null, startTs?: any | null, endTs?: any | null } | null, stats?: { __typename?: 'CrmIngestionRunStats', numNewDeals?: number | null, numNewAccounts?: number | null, numNewContacts?: number | null, numUpdatedDeals?: number | null, numUpdatedAccounts?: number | null, numUpdatedContacts?: number | null } | null };

export type GetCrmIngestionRunsQueryVariables = Exact<{
  filter?: InputMaybe<CrmIngestionRunFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCrmIngestionRunsQuery = { __typename?: 'Query', crmIngestionRuns?: { __typename?: 'CrmIngestionRunConnection', edges: Array<{ __typename?: 'CrmIngestionRunEdge', node?: { __typename: 'CrmIngestionRun', platform: CrmIngestionPlatform, workspaceId: number, status: CrmIngestionStatus, asOfTs?: any | null, runId: number, properties?: { __typename?: 'CrmIngestionRunProperties', lastStep?: string | null, lastStepTs?: any | null, startTs?: any | null, endTs?: any | null } | null, stats?: { __typename?: 'CrmIngestionRunStats', numNewDeals?: number | null, numNewAccounts?: number | null, numNewContacts?: number | null, numUpdatedDeals?: number | null, numUpdatedAccounts?: number | null, numUpdatedContacts?: number | null } | null } | null } | null> } | null };

export type GetCrmIngestionSyncLogsQueryVariables = Exact<{
  filter?: InputMaybe<CrmIngestionRunFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCrmIngestionSyncLogsQuery = { __typename?: 'Query', crmIngestionSyncLog?: { __typename?: 'CrmIngestionRunConnection', edges: Array<{ __typename?: 'CrmIngestionRunEdge', node?: { __typename: 'CrmIngestionRun', platform: CrmIngestionPlatform, workspaceId: number, status: CrmIngestionStatus, asOfTs?: any | null, runId: number, properties?: { __typename?: 'CrmIngestionRunProperties', lastStep?: string | null, lastStepTs?: any | null, startTs?: any | null, endTs?: any | null } | null, stats?: { __typename?: 'CrmIngestionRunStats', numNewDeals?: number | null, numNewAccounts?: number | null, numNewContacts?: number | null, numUpdatedDeals?: number | null, numUpdatedAccounts?: number | null, numUpdatedContacts?: number | null } | null } | null } | null> } | null };

export type CrmIngestMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  platform: CrmIngestionPlatform;
}>;


export type CrmIngestMutation = { __typename?: 'Mutations', crmIngest?: { __typename?: 'CrmIngest', ok?: boolean | null, run?: { __typename?: 'CrmIngestionRun', runId: number, platform: CrmIngestionPlatform, workspaceId: number, status: CrmIngestionStatus } | null } | null };

export type DisconnectIntegrationMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
}>;


export type DisconnectIntegrationMutation = { __typename?: 'Mutations', disconnectIntegration?: { __typename?: 'DisconnectIntegration', ok?: boolean | null } | null };

export type ConnectGranolaMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  apiKey: Scalars['String']['input'];
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  keepCoffeeRecording?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConnectGranolaMutation = { __typename?: 'Mutations', connectGranola?: { __typename?: 'ConnectGranola', ok?: boolean | null, integration?: { __typename?: 'Integration', platform: IntegrationPlatform, status?: IntegrationStatus | null } | null } | null };

export type SyncGranolaMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SyncGranolaMutation = { __typename?: 'Mutations', syncGranola?: { __typename?: 'SyncGranola', ok?: boolean | null } | null };

export type ConnectFirefliesMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  apiKey: Scalars['String']['input'];
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  keepCoffeeRecording?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConnectFirefliesMutation = { __typename?: 'Mutations', connectFireflies?: { __typename?: 'ConnectFireflies', ok?: boolean | null, integration?: { __typename?: 'Integration', platform: IntegrationPlatform, status?: IntegrationStatus | null } | null } | null };

export type SyncFirefliesMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SyncFirefliesMutation = { __typename?: 'Mutations', syncFireflies?: { __typename?: 'SyncFireflies', ok?: boolean | null } | null };

export type ConnectFirefliesWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  apiKey: Scalars['String']['input'];
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  keepCoffeeRecording?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConnectFirefliesWorkspaceMutation = { __typename?: 'Mutations', connectFirefliesWorkspace?: { __typename?: 'ConnectFirefliesWorkspace', ok?: boolean | null, error?: string | null, integration?: { __typename?: 'Integration', platform: IntegrationPlatform, status?: IntegrationStatus | null } | null } | null };

export type CheckFirefliesKeyMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  apiKey: Scalars['String']['input'];
}>;


export type CheckFirefliesKeyMutation = { __typename?: 'Mutations', checkFirefliesKey?: { __typename?: 'CheckFirefliesKey', valid?: boolean | null, firefliesAdmin?: boolean | null, email?: string | null, name?: string | null, canConnectWorkspace?: boolean | null } | null };

export type SyncFirefliesWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SyncFirefliesWorkspaceMutation = { __typename?: 'Mutations', syncFirefliesWorkspace?: { __typename?: 'SyncFirefliesWorkspace', ok?: boolean | null } | null };

export type DisconnectUserIntegrationMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
}>;


export type DisconnectUserIntegrationMutation = { __typename?: 'Mutations', disconnectUserIntegration?: { __typename?: 'DisconnectUserIntegration', ok?: boolean | null } | null };

export type UserIntegrationSyncMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
}>;


export type UserIntegrationSyncMutation = { __typename?: 'Mutations', userIntegrationSync?: { __typename?: 'UserIntegrationSync', ok?: boolean | null } | null };

export type WorkflowStatusQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;


export type WorkflowStatusQuery = { __typename?: 'Query', workflowStatus?: { __typename?: 'WorkflowStatusType', status?: string | null, ok?: boolean | null } | null };

export type GetStripeDataCountsQueryVariables = Exact<{
  input: StripeDataCountsInput;
}>;


export type GetStripeDataCountsQuery = { __typename?: 'Query', stripeDataCounts?: { __typename?: 'StripeDataCounts', customers: number, subscriptions: number, paidCharges: number } | null };

export type GetQuickBooksDataCountsQueryVariables = Exact<{
  input: QuickBooksDataCountsInput;
}>;


export type GetQuickBooksDataCountsQuery = { __typename?: 'Query', quickbooksDataCounts?: { __typename?: 'QuickBooksDataCounts', customers: number, paidInvoices: number } | null };

export type GetCrmDataCountsQueryVariables = Exact<{
  input: CrmDataCountsInput;
}>;


export type GetCrmDataCountsQuery = { __typename?: 'Query', crmDataCounts?: { __typename?: 'CrmDataCounts', contacts: number, accounts: number, deals: number } | null };

export type GetIntegrationQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  platform: IntegrationPlatform;
}>;


export type GetIntegrationQuery = { __typename?: 'Query', integration?: { __typename: 'IntegrationWithToken', workspaceId: number, platform: IntegrationPlatform, category: IntegrationPlatformCategory, addedTs?: any | null, status: IntegrationStatus, accessToken: string } | null };

export type GetGongWebhookUrlQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetGongWebhookUrlQuery = { __typename?: 'Query', gongWebhookUrl?: string | null };

export type JobTitleFieldsFragment = { __typename: 'JobTitle', label?: string | null };

export type GetJobTitlesQueryVariables = Exact<{
  filter: JobTitleFilter;
}>;


export type GetJobTitlesQuery = { __typename?: 'Query', jobTitle?: { __typename?: 'JobTitleConnection', edges: Array<{ __typename?: 'JobTitleEdge', cursor: string, node?: { __typename: 'JobTitle', label?: string | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type ListFolderFieldsFragment = { __typename: 'ListFolder', id: string, name: string, public: boolean, ownerId: number, workspaceId: number, modelType: ListModelType };

export type GetListFoldersQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  modelType: Scalars['String']['input'];
}>;


export type GetListFoldersQuery = { __typename?: 'Query', listFolders: Array<{ __typename: 'ListFolder', id: string, name: string, public: boolean, ownerId: number, workspaceId: number, modelType: ListModelType }> };

export type GetListFolderAssignmentsQueryVariables = Exact<{
  filter?: InputMaybe<UserListFilter>;
}>;


export type GetListFolderAssignmentsQuery = { __typename?: 'Query', userLists?: { __typename?: 'UserListConnection', edges: Array<{ __typename?: 'UserListEdge', node?: { __typename?: 'UserList', list: { __typename: 'List', id: string, name: string, public: boolean, static: boolean, folderId?: number | null } } | null } | null> } | null };

export type CreateListFolderMutationVariables = Exact<{
  input: CreateListFolderInput;
}>;


export type CreateListFolderMutation = { __typename?: 'Mutations', createListFolder?: { __typename?: 'CreateListFolder', listFolder?: { __typename: 'ListFolder', id: string, name: string, public: boolean, ownerId: number, workspaceId: number, modelType: ListModelType } | null } | null };

export type UpdateListFolderMutationVariables = Exact<{
  input: UpdateListFolderInput;
}>;


export type UpdateListFolderMutation = { __typename?: 'Mutations', updateListFolder?: { __typename?: 'UpdateListFolder', listFolder?: { __typename: 'ListFolder', id: string, name: string, public: boolean, ownerId: number, workspaceId: number, modelType: ListModelType } | null } | null };

export type DeleteListFolderMutationVariables = Exact<{
  input: DeleteListFolderInput;
}>;


export type DeleteListFolderMutation = { __typename?: 'Mutations', deleteListFolder?: { __typename?: 'DeleteListFolder', ok?: boolean | null } | null };

export type MoveListToFolderMutationVariables = Exact<{
  input: UpdateListInput;
}>;


export type MoveListToFolderMutation = { __typename?: 'Mutations', updateList?: { __typename?: 'UpdateList', list?: { __typename: 'List', id: string, folderId?: number | null } | null } | null };

export type ListFieldsFragment = { __typename: 'List', id: string, name: string, properties: any, public: boolean, modelType: ListModelType, deleted: boolean, ownerId: number, createTs: any, updateTs: any, workspaceId: number, static: boolean };

export type GetUserListsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserListFilter>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetUserListsQuery = { __typename?: 'Query', userLists?: { __typename?: 'UserListConnection', totalCount?: number | null, edges: Array<{ __typename?: 'UserListEdge', cursor: string, node?: { __typename?: 'UserList', pinned: boolean, hidden: boolean, list: { __typename: 'List', id: string, name: string, properties: any, public: boolean, modelType: ListModelType, deleted: boolean, ownerId: number, createTs: any, updateTs: any, workspaceId: number, static: boolean }, user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, avatarBackground?: string | null } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetUserListsWithContactCountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserListFilter>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetUserListsWithContactCountsQuery = { __typename?: 'Query', userLists?: { __typename?: 'UserListConnection', totalCount?: number | null, edges: Array<{ __typename?: 'UserListEdge', cursor: string, node?: { __typename?: 'UserList', pinned: boolean, hidden: boolean, list: { __typename: 'List', contactCount?: number | null, id: string, name: string, properties: any, public: boolean, modelType: ListModelType, deleted: boolean, ownerId: number, createTs: any, updateTs: any, workspaceId: number, static: boolean } } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type CreateListMutationVariables = Exact<{
  input: CreateListInput;
}>;


export type CreateListMutation = { __typename?: 'Mutations', createList?: { __typename?: 'CreateList', list?: { __typename: 'List', id: string, name: string, properties: any, public: boolean, modelType: ListModelType, deleted: boolean, ownerId: number, createTs: any, updateTs: any, workspaceId: number, static: boolean } | null } | null };

export type UpdateListMutationVariables = Exact<{
  input: UpdateListInput;
}>;


export type UpdateListMutation = { __typename?: 'Mutations', updateList?: { __typename?: 'UpdateList', list?: { __typename: 'List', id: string, name: string, properties: any, public: boolean, modelType: ListModelType, deleted: boolean, ownerId: number, createTs: any, updateTs: any, workspaceId: number, static: boolean } | null } | null };

export type UpdateUserListMutationVariables = Exact<{
  input: UpdateUserListInput;
}>;


export type UpdateUserListMutation = { __typename?: 'Mutations', updateUserList?: { __typename?: 'UpdateUserList', userList?: { __typename?: 'UserList', userId: string, listId: string, pinned: boolean, hidden: boolean, createTs: any, updateTs: any, id: string } | null } | null };

export type AddRecordsToListMutationVariables = Exact<{
  input: AddRecordsToListInput;
}>;


export type AddRecordsToListMutation = { __typename?: 'Mutations', addRecordsToList?: { __typename?: 'AddRecordsToList', ok?: boolean | null } | null };

export type RemoveRecordsFromListMutationVariables = Exact<{
  input: RemoveRecordsFromListInput;
}>;


export type RemoveRecordsFromListMutation = { __typename?: 'Mutations', removeRecordsFromList?: { __typename?: 'RemoveRecordsFromList', ok?: boolean | null } | null };

export type GetRecordListMembershipsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  modelType: Scalars['String']['input'];
  recordIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetRecordListMembershipsQuery = { __typename?: 'Query', recordListMemberships: Array<{ __typename?: 'RecordListMembership', recordId: string, listIds: Array<string> }> };

export type GetListAccountCountQueryVariables = Exact<{
  filter?: InputMaybe<AccountFilter>;
}>;


export type GetListAccountCountQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountConnection', totalCount?: number | null } | null };

export type GetListContactCountQueryVariables = Exact<{
  filter?: InputMaybe<ContactFilterInput>;
}>;


export type GetListContactCountQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactConnection', totalCount?: number | null } | null };

export type GetListDealCountQueryVariables = Exact<{
  filter?: InputMaybe<DealFilter>;
}>;


export type GetListDealCountQuery = { __typename?: 'Query', deals?: { __typename?: 'DealConnection', totalCount?: number | null } | null };

export type SendContactsToMailchimpMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  contactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  listId: Scalars['String']['input'];
}>;


export type SendContactsToMailchimpMutation = { __typename?: 'Mutations', sendContactToMailchimp?: { __typename?: 'SendContact', ok?: boolean | null } | null };

export type GetMailchimpAudiencesQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type GetMailchimpAudiencesQuery = { __typename?: 'Query', mailchimpAudiences?: Array<{ __typename?: 'MailchimpAudience', id: string, name: string }> | null };

export type GetNextLastActivityResponseQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  type: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type GetNextLastActivityResponseQuery = { __typename?: 'Query', nextLastActivityResponse?: { __typename?: 'NextLastActivityResponse', response?: { __typename?: 'ActivityDetails', lastActivity?: string | null, lastActivityId?: string | null, nextStep?: string | null, nextStepId?: string | null } | null } | null };

export type NoteFieldsFragment = { __typename: 'Note', id: string, workspaceId?: number | null, userId?: number | null, privacy?: string | null, createdAt?: any | null, updatedAt?: any | null, title?: string | null, aiGenerated?: boolean | null, type?: NoteTypeEnum | null, status?: NoteStatusEnum | null, priority?: NotePriorityEnum | null, dueDate?: any | null };

export type NoteRelationsFragment = { __typename?: 'Note', user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, deals?: Array<{ __typename: 'Deal', id: string, properties?: { __typename?: 'DealProperties', name?: string | null } | null } | null> | null, engagements?: Array<{ __typename: 'Engagement', id: string, displayName?: string | null, engagementType?: DdbEngagementType | null } | null> | null };

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutations', createNote?: { __typename?: 'CreateNote', note?: { __typename: 'Note', blocks?: any | null, id: string, workspaceId?: number | null, userId?: number | null, privacy?: string | null, createdAt?: any | null, updatedAt?: any | null, title?: string | null, aiGenerated?: boolean | null, type?: NoteTypeEnum | null, status?: NoteStatusEnum | null, priority?: NotePriorityEnum | null, dueDate?: any | null, user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, deals?: Array<{ __typename: 'Deal', id: string, properties?: { __typename?: 'DealProperties', name?: string | null } | null } | null> | null, engagements?: Array<{ __typename: 'Engagement', id: string, displayName?: string | null, engagementType?: DdbEngagementType | null } | null> | null } | null } | null };

export type UpdateNoteMutationVariables = Exact<{
  input: UpdateNoteInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutations', updateNote?: { __typename?: 'UpdateNote', note?: { __typename: 'Note', blocks?: any | null, aiNotesContent?: any | null, id: string, workspaceId?: number | null, userId?: number | null, privacy?: string | null, createdAt?: any | null, updatedAt?: any | null, title?: string | null, aiGenerated?: boolean | null, type?: NoteTypeEnum | null, status?: NoteStatusEnum | null, priority?: NotePriorityEnum | null, dueDate?: any | null, user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, deals?: Array<{ __typename: 'Deal', id: string, properties?: { __typename?: 'DealProperties', name?: string | null } | null } | null> | null, engagements?: Array<{ __typename: 'Engagement', id: string, displayName?: string | null, engagementType?: DdbEngagementType | null } | null> | null } | null } | null };

export type GetNotesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: NoteFilter;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetNotesQuery = { __typename?: 'Query', notes?: { __typename?: 'NoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'NoteEdge', cursor: string, node?: { __typename: 'Note', ddbEngagementIds?: Array<string | null> | null, ddbDealIds?: Array<string | null> | null, ddbContactIds?: Array<string | null> | null, ddbAccountIds?: Array<string | null> | null, id: string, workspaceId?: number | null, userId?: number | null, privacy?: string | null, createdAt?: any | null, updatedAt?: any | null, title?: string | null, aiGenerated?: boolean | null, type?: NoteTypeEnum | null, status?: NoteStatusEnum | null, priority?: NotePriorityEnum | null, dueDate?: any | null, user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, deals?: Array<{ __typename: 'Deal', id: string, properties?: { __typename?: 'DealProperties', name?: string | null } | null } | null> | null, engagements?: Array<{ __typename: 'Engagement', id: string, displayName?: string | null, engagementType?: DdbEngagementType | null } | null> | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetNoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetNoteQuery = { __typename?: 'Query', note?: { __typename: 'Note', blocks?: any | null, aiNotesContent?: any | null, id: string, workspaceId?: number | null, userId?: number | null, privacy?: string | null, createdAt?: any | null, updatedAt?: any | null, title?: string | null, aiGenerated?: boolean | null, type?: NoteTypeEnum | null, status?: NoteStatusEnum | null, priority?: NotePriorityEnum | null, dueDate?: any | null, user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, deals?: Array<{ __typename: 'Deal', id: string, properties?: { __typename?: 'DealProperties', name?: string | null } | null } | null> | null, engagements?: Array<{ __typename: 'Engagement', id: string, displayName?: string | null, engagementType?: DdbEngagementType | null } | null> | null } | null };

export type GetNotesForEngagementQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: NoteFilter;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetNotesForEngagementQuery = { __typename?: 'Query', notes?: { __typename?: 'NoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'NoteEdge', node?: { __typename?: 'Note', id: string, title?: string | null, aiGenerated?: boolean | null, blocks?: any | null, aiNotesContent?: any | null, source?: string | null } | null } | null> } | null };

export type DeleteNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type DeleteNoteMutation = { __typename?: 'Mutations', deleteNote?: { __typename?: 'DeleteNote', success?: boolean | null } | null };

export type GetTasksQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: NoteFilter;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type GetTasksQuery = { __typename?: 'Query', notes?: { __typename?: 'NoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'NoteEdge', cursor: string, node?: { __typename: 'Note', blocks?: any | null, ddbEngagementIds?: Array<string | null> | null, ddbDealIds?: Array<string | null> | null, ddbContactIds?: Array<string | null> | null, ddbAccountIds?: Array<string | null> | null, id: string, workspaceId?: number | null, userId?: number | null, privacy?: string | null, createdAt?: any | null, updatedAt?: any | null, title?: string | null, aiGenerated?: boolean | null, type?: NoteTypeEnum | null, status?: NoteStatusEnum | null, priority?: NotePriorityEnum | null, dueDate?: any | null, user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, deals?: Array<{ __typename: 'Deal', id: string, properties?: { __typename?: 'DealProperties', name?: string | null } | null } | null> | null, engagements?: Array<{ __typename: 'Engagement', id: string, displayName?: string | null, engagementType?: DdbEngagementType | null } | null> | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetTaskQuery = { __typename?: 'Query', note?: { __typename: 'Note', blocks?: any | null, aiNotesContent?: any | null, ddbEngagementIds?: Array<string | null> | null, ddbDealIds?: Array<string | null> | null, ddbContactIds?: Array<string | null> | null, ddbAccountIds?: Array<string | null> | null, id: string, workspaceId?: number | null, userId?: number | null, privacy?: string | null, createdAt?: any | null, updatedAt?: any | null, title?: string | null, aiGenerated?: boolean | null, type?: NoteTypeEnum | null, status?: NoteStatusEnum | null, priority?: NotePriorityEnum | null, dueDate?: any | null, user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, accounts?: Array<{ __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null> | null, contacts?: Array<{ __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null> | null, deals?: Array<{ __typename: 'Deal', id: string, properties?: { __typename?: 'DealProperties', name?: string | null } | null } | null> | null, engagements?: Array<{ __typename: 'Engagement', id: string, displayName?: string | null, engagementType?: DdbEngagementType | null } | null> | null } | null };

export type NotificationFieldsFragment = { __typename: 'NotificationType', id?: string | null, type?: string | null, params?: any | null, target?: any | null, fallbackTitle?: string | null, fallbackBody?: string | null, readTs?: any | null, createTs?: any | null };

export type GetNotificationsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  beforeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationConnection', hasMore?: boolean | null, nodes?: Array<{ __typename: 'NotificationType', id?: string | null, type?: string | null, params?: any | null, target?: any | null, fallbackTitle?: string | null, fallbackBody?: string | null, readTs?: any | null, createTs?: any | null } | null> | null } | null };

export type GetNotificationUnreadCountQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetNotificationUnreadCountQuery = { __typename?: 'Query', notificationUnreadCount?: number | null };

export type GetNotificationNewCountQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetNotificationNewCountQuery = { __typename?: 'Query', notificationNewCount?: number | null };

export type MarkNotificationsSeenMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type MarkNotificationsSeenMutation = { __typename?: 'Mutations', markNotificationsSeen?: { __typename?: 'MarkNotificationsSeen', ok?: boolean | null, newCount?: number | null } | null };

export type MarkNotificationsReadMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkNotificationsReadMutation = { __typename?: 'Mutations', markNotificationsRead?: { __typename?: 'MarkNotificationsRead', unreadCount?: number | null, notifications?: Array<{ __typename?: 'NotificationType', id?: string | null, readTs?: any | null } | null> | null } | null };

export type MarkAllNotificationsReadMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type MarkAllNotificationsReadMutation = { __typename?: 'Mutations', markAllNotificationsRead?: { __typename?: 'MarkAllNotificationsRead', unreadCount?: number | null } | null };

export type SendTestNotificationMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type SendTestNotificationMutation = { __typename?: 'Mutations', sendTestNotification?: { __typename?: 'SendTestNotification', ok?: boolean | null, notification?: { __typename: 'NotificationType', id?: string | null, type?: string | null, params?: any | null, target?: any | null, fallbackTitle?: string | null, fallbackBody?: string | null, readTs?: any | null, createTs?: any | null } | null } | null };

export type GetDealSuggestionForPrefillQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetDealSuggestionForPrefillQuery = { __typename?: 'Query', dealSuggestion?: { __typename?: 'DealSuggestion', id: string, dealName?: string | null, estimatedAmount?: number | null, estimatedCloseDate?: any | null, suggestedAccountId?: string | null, isDismissed?: boolean | null, convertedDealId?: string | null, suggestedAccount?: { __typename?: 'Account', id: string, properties?: { __typename?: 'AccountProperties', name?: string | null } | null } | null } | null };

export type RegisterPushSubscriptionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
  auth: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterPushSubscriptionMutation = { __typename?: 'Mutations', registerPushSubscription?: { __typename?: 'RegisterPushSubscription', ok?: boolean | null } | null };

export type UnregisterPushSubscriptionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
}>;


export type UnregisterPushSubscriptionMutation = { __typename?: 'Mutations', unregisterPushSubscription?: { __typename?: 'UnregisterPushSubscription', ok?: boolean | null } | null };

export type GetCrmOauthUrlQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
  redirectTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCrmOauthUrlQuery = { __typename?: 'Query', crmOauthUrl?: string | null };

export type CompleteSlackInstallMutationVariables = Exact<{
  input: CompleteSlackInstallInput;
}>;


export type CompleteSlackInstallMutation = { __typename?: 'Mutations', completeSlackInstall?: { __typename?: 'CompleteSlackInstall', success?: boolean | null, error?: string | null } | null };

export type OptimizedSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OptimizedSearchQuery = { __typename?: 'Query', search?: { __typename?: 'SearchResponse', totalResults: number, accounts?: { __typename?: 'SearchEntityResults', entityType: string, total: number, results?: Array<{ __typename?: 'SearchResult', id: string, score?: number | null, data: any, highlight?: any | null } | null> | null } | null, contacts?: { __typename?: 'SearchEntityResults', entityType: string, total: number, results?: Array<{ __typename?: 'SearchResult', id: string, score?: number | null, data: any, highlight?: any | null } | null> | null } | null, deals?: { __typename?: 'SearchEntityResults', entityType: string, total: number, results?: Array<{ __typename?: 'SearchResult', id: string, score?: number | null, data: any, highlight?: any | null } | null> | null } | null, meetings?: { __typename?: 'SearchEntityResults', entityType: string, total: number, results?: Array<{ __typename?: 'SearchResult', id: string, score?: number | null, data: any, highlight?: any | null } | null> | null } | null, emails?: { __typename?: 'SearchEntityResults', entityType: string, total: number, results?: Array<{ __typename?: 'SearchResult', id: string, score?: number | null, data: any, highlight?: any | null } | null> | null } | null, notes?: { __typename?: 'SearchEntityResults', entityType: string, total: number, results?: Array<{ __typename?: 'SearchResult', id: string, score?: number | null, data: any, highlight?: any | null } | null> | null } | null, files?: { __typename?: 'SearchEntityResults', entityType: string, total: number, results?: Array<{ __typename?: 'SearchResult', id: string, score?: number | null, data: any, highlight?: any | null } | null> | null } | null } | null };

export type PostalCodesFieldsFragment = { __typename: 'PostalCode', label?: string | null };

export type GetPostalCodesQueryVariables = Exact<{
  filter: PostalCodeFilter;
}>;


export type GetPostalCodesQuery = { __typename?: 'Query', postalCodes?: { __typename?: 'PostalCodeConnection', edges: Array<{ __typename?: 'PostalCodeEdge', cursor: string, node?: { __typename: 'PostalCode', label?: string | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type ProductFieldsFragment = { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null };

export type LineItemFieldsFragment = { __typename: 'LineItem', id: string, workspaceId?: number | null, dealId?: string | null, productId?: string | null, properties?: { __typename?: 'LineItemProperties', name?: string | null, quantity?: number | null, listPrice?: number | null, unitPrice?: number | null, totalPrice?: number | null, discountPercent?: number | null, productCode?: string | null } | null, product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null };

export type GetProductsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetProductsQuery = { __typename?: 'Query', products?: Array<{ __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null> | null };

export type GetDealLineItemsQueryVariables = Exact<{
  dealId: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetDealLineItemsQuery = { __typename?: 'Query', dealLineItems?: Array<{ __typename: 'LineItem', id: string, workspaceId?: number | null, dealId?: string | null, productId?: string | null, properties?: { __typename?: 'LineItemProperties', name?: string | null, quantity?: number | null, listPrice?: number | null, unitPrice?: number | null, totalPrice?: number | null, discountPercent?: number | null, productCode?: string | null } | null, product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null } | null> | null };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutations', createProduct?: { __typename?: 'CreateProduct', product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null } | null };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutations', updateProduct?: { __typename?: 'UpdateProduct', product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null } | null };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutations', deleteProduct?: { __typename?: 'DeleteProduct', success?: boolean | null } | null };

export type SetDealLineItemsMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  dealId: Scalars['String']['input'];
  lineItems: Array<LineItemInput> | LineItemInput;
}>;


export type SetDealLineItemsMutation = { __typename?: 'Mutations', setDealLineItems?: { __typename?: 'SetDealLineItems', lineItems?: Array<{ __typename: 'LineItem', id: string, workspaceId?: number | null, dealId?: string | null, productId?: string | null, properties?: { __typename?: 'LineItemProperties', name?: string | null, quantity?: number | null, listPrice?: number | null, unitPrice?: number | null, totalPrice?: number | null, discountPercent?: number | null, productCode?: string | null } | null, product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null } | null> | null } | null };

export type GetUserQuotasQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  periodType: QuotaPeriodType;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type GetUserQuotasQuery = { __typename?: 'Query', userQuotas: Array<{ __typename?: 'UserQuotaType', id?: number | null, workspaceId?: number | null, userId?: number | null, periodType?: string | null, periodStart?: any | null, amount?: number | null }> };

export type SetUserQuotasMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  quotas: Array<UserQuotaInput> | UserQuotaInput;
}>;


export type SetUserQuotasMutation = { __typename?: 'Mutations', setUserQuotas?: { __typename?: 'SetUserQuotas', quotas: Array<{ __typename?: 'UserQuotaType', id?: number | null, workspaceId?: number | null, userId?: number | null, periodType?: string | null, periodStart?: any | null, amount?: number | null }> } | null };

export type ReportDefinitionFieldsFragment = { __typename?: 'ReportDefinition', id: string, workspaceId: number, ownerUserId: number, name: string, description?: string | null, visibility: string, definition: any, templateKey?: string | null, schedule?: any | null, status: string, legacy: boolean, createTs?: any | null, updateTs?: any | null };

export type ReportRunFieldsFragment = { __typename?: 'ReportRun', id: string, reportId: string, workspaceId: number, requestedBy?: number | null, triggerSource: string, status: string, definitionSnapshot: any, blockResults: any, narrative?: string | null, error?: string | null, creditsCharged: number, startedAt?: any | null, finishedAt?: any | null, createTs?: any | null };

export type GetReportTemplatesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetReportTemplatesQuery = { __typename?: 'Query', reportTemplates: Array<{ __typename?: 'ReportTemplateEntry', templateKey: string, name: string, description?: string | null, definition: any }> };

export type GetReportDefinitionsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetReportDefinitionsQuery = { __typename?: 'Query', reportDefinitions: Array<{ __typename?: 'ReportDefinition', id: string, workspaceId: number, ownerUserId: number, name: string, description?: string | null, visibility: string, definition: any, templateKey?: string | null, schedule?: any | null, status: string, legacy: boolean, createTs?: any | null, updateTs?: any | null, latestRun?: { __typename?: 'ReportRun', id: string, status: string, narrative?: string | null, finishedAt?: any | null, createTs?: any | null } | null }> };

export type GetReportDefinitionQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GetReportDefinitionQuery = { __typename?: 'Query', reportDefinition?: { __typename?: 'ReportDefinition', id: string, workspaceId: number, ownerUserId: number, name: string, description?: string | null, visibility: string, definition: any, templateKey?: string | null, schedule?: any | null, status: string, legacy: boolean, createTs?: any | null, updateTs?: any | null, latestRun?: { __typename?: 'ReportRun', id: string, reportId: string, workspaceId: number, requestedBy?: number | null, triggerSource: string, status: string, definitionSnapshot: any, blockResults: any, narrative?: string | null, error?: string | null, creditsCharged: number, startedAt?: any | null, finishedAt?: any | null, createTs?: any | null } | null } | null };

export type GetReportRunsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  beforeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetReportRunsQuery = { __typename?: 'Query', reportRuns: Array<{ __typename?: 'ReportRun', id: string, status: string, triggerSource: string, narrative?: string | null, error?: string | null, creditsCharged: number, startedAt?: any | null, finishedAt?: any | null, createTs?: any | null }> };

export type GetReportRunQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GetReportRunQuery = { __typename?: 'Query', reportRun?: { __typename?: 'ReportRun', id: string, reportId: string, workspaceId: number, requestedBy?: number | null, triggerSource: string, status: string, definitionSnapshot: any, blockResults: any, narrative?: string | null, error?: string | null, creditsCharged: number, startedAt?: any | null, finishedAt?: any | null, createTs?: any | null } | null };

export type GetReportCatalogQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetReportCatalogQuery = { __typename?: 'Query', reportCatalog?: { __typename?: 'ReportCatalog', version: number, objects: any, pipelines: any, timeRangeKeys: Array<string>, vizKinds: Array<string>, filterOps: Array<string>, metricOps: Array<string>, groupIntervals: Array<string>, templateKeys: Array<string> } | null };

export type CreateReportDefinitionMutationVariables = Exact<{
  input: CreateReportDefinitionInput;
}>;


export type CreateReportDefinitionMutation = { __typename?: 'Mutations', createReportDefinition?: { __typename?: 'CreateReportDefinition', report?: { __typename?: 'ReportDefinition', id: string, workspaceId: number, ownerUserId: number, name: string, description?: string | null, visibility: string, definition: any, templateKey?: string | null, schedule?: any | null, status: string, legacy: boolean, createTs?: any | null, updateTs?: any | null } | null } | null };

export type UpdateReportDefinitionMutationVariables = Exact<{
  input: UpdateReportDefinitionInput;
}>;


export type UpdateReportDefinitionMutation = { __typename?: 'Mutations', updateReportDefinition?: { __typename?: 'UpdateReportDefinition', report?: { __typename?: 'ReportDefinition', id: string, workspaceId: number, ownerUserId: number, name: string, description?: string | null, visibility: string, definition: any, templateKey?: string | null, schedule?: any | null, status: string, legacy: boolean, createTs?: any | null, updateTs?: any | null } | null } | null };

export type DeleteReportDefinitionMutationVariables = Exact<{
  input: DeleteReportDefinitionInput;
}>;


export type DeleteReportDefinitionMutation = { __typename?: 'Mutations', deleteReportDefinition?: { __typename?: 'DeleteReportDefinition', ok?: boolean | null } | null };

export type RunReportMutationVariables = Exact<{
  input: RunReportInput;
}>;


export type RunReportMutation = { __typename?: 'Mutations', runReport?: { __typename?: 'RunReport', run?: { __typename?: 'ReportRun', id: string, reportId: string, workspaceId: number, requestedBy?: number | null, triggerSource: string, status: string, definitionSnapshot: any, blockResults: any, narrative?: string | null, error?: string | null, creditsCharged: number, startedAt?: any | null, finishedAt?: any | null, createTs?: any | null } | null } | null };

export type GetPipelineHealthReportQueryVariables = Exact<{
  filter: ReportFilterInput;
}>;


export type GetPipelineHealthReportQuery = { __typename?: 'Query', pipelineHealthReport?: { __typename?: 'PipelineHealthReport', totalOpenCount: number, totalOpenAmount: number, weightedPipeline: number, truncated: boolean, funnel: Array<{ __typename?: 'ReportStageFunnelEntry', stageId: string, stageName: string, order?: number | null, probability?: number | null, openCount: number, openAmount: number, weightedAmount?: number | null, avgAgeInStageDays?: number | null, conversionToNextPct?: number | null, avgDaysInStage?: number | null }> } | null };

export type AutomationRuleFieldsFragment = { __typename: 'AutomationRule', id: string, workspaceId: number, ownerUserId: number, name: string, status: string, objectType: string, trigger?: any | null, conditions?: any | null, actions?: any | null, nextRunAt?: string | null, createTs?: string | null, updateTs?: string | null };

export type GetAutomationRulesQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type GetAutomationRulesQuery = { __typename?: 'Query', automationRules?: Array<{ __typename: 'AutomationRule', id: string, workspaceId: number, ownerUserId: number, name: string, status: string, objectType: string, trigger?: any | null, conditions?: any | null, actions?: any | null, nextRunAt?: string | null, createTs?: string | null, updateTs?: string | null } | null> | null };

export type CreateAutomationRuleMutationVariables = Exact<{
  input: CreateAutomationRuleInput;
}>;


export type CreateAutomationRuleMutation = { __typename?: 'Mutations', createAutomationRule?: { __typename?: 'CreateAutomationRule', rule?: { __typename: 'AutomationRule', id: string, workspaceId: number, ownerUserId: number, name: string, status: string, objectType: string, trigger?: any | null, conditions?: any | null, actions?: any | null, nextRunAt?: string | null, createTs?: string | null, updateTs?: string | null } | null } | null };

export type UpdateAutomationRuleMutationVariables = Exact<{
  input: UpdateAutomationRuleInput;
}>;


export type UpdateAutomationRuleMutation = { __typename?: 'Mutations', updateAutomationRule?: { __typename?: 'UpdateAutomationRule', rule?: { __typename: 'AutomationRule', id: string, workspaceId: number, ownerUserId: number, name: string, status: string, objectType: string, trigger?: any | null, conditions?: any | null, actions?: any | null, nextRunAt?: string | null, createTs?: string | null, updateTs?: string | null } | null } | null };

export type DeleteAutomationRuleMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteAutomationRuleMutation = { __typename?: 'Mutations', deleteAutomationRule?: { __typename?: 'DeleteAutomationRule', ok?: boolean | null } | null };

export type ActivateAutomationRuleMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type ActivateAutomationRuleMutation = { __typename?: 'Mutations', activateAutomationRule?: { __typename?: 'ActivateAutomationRule', rule?: { __typename: 'AutomationRule', id: string, workspaceId: number, ownerUserId: number, name: string, status: string, objectType: string, trigger?: any | null, conditions?: any | null, actions?: any | null, nextRunAt?: string | null, createTs?: string | null, updateTs?: string | null } | null } | null };

export type PauseAutomationRuleMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type PauseAutomationRuleMutation = { __typename?: 'Mutations', pauseAutomationRule?: { __typename?: 'PauseAutomationRule', rule?: { __typename: 'AutomationRule', id: string, workspaceId: number, ownerUserId: number, name: string, status: string, objectType: string, trigger?: any | null, conditions?: any | null, actions?: any | null, nextRunAt?: string | null, createTs?: string | null, updateTs?: string | null } | null } | null };

export type TestRunAutomationRuleMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type TestRunAutomationRuleMutation = { __typename?: 'Mutations', testRunAutomationRule?: { __typename?: 'TestRunAutomationRule', result?: { __typename?: 'RuleTestRunResult', evaluatedCount: number, matchedCount: number, truncated: boolean, previews?: Array<{ __typename?: 'RuleActionPreview', entityId?: string | null, entityName?: string | null, kind: string, detail: string } | null> | null } | null } | null };

export type UnifiedSearchQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UnifiedSearchQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null } | null } | null } | null> } | null } | null } | null> } | null, accounts?: { __typename?: 'AccountConnection', totalCount?: number | null, edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null } | null } | null } | null> } | null, deals?: { __typename?: 'DealConnection', totalCount?: number | null, edges: Array<{ __typename?: 'DealEdge', node?: { __typename: 'Deal', id: string, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename?: 'Account', domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null } | null } | null } | null> } | null } | null } | null> } | null, emails?: { __typename?: 'EngagementConnection', edges: Array<{ __typename?: 'EngagementEdge', node?: { __typename: 'Engagement', id: string, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, platform?: string | null, engagementType?: DdbEngagementType | null } | null, highlights?: Array<{ __typename?: 'Highlight', field?: string | null, snippets?: Array<string | null> | null } | null> | null } | null> } | null, meetings?: { __typename?: 'EngagementConnection', edges: Array<{ __typename?: 'EngagementEdge', node?: { __typename: 'Engagement', id: string, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, platform?: string | null, engagementType?: DdbEngagementType | null, hasAiSummary: boolean, hasTranscript: boolean } | null, highlights?: Array<{ __typename?: 'Highlight', field?: string | null, snippets?: Array<string | null> | null } | null> | null } | null> } | null, notes?: { __typename?: 'NoteConnection', edges: Array<{ __typename?: 'NoteEdge', node?: { __typename: 'Note', id: string, updatedAt?: any | null, title?: string | null, type?: NoteTypeEnum | null } | null, highlights?: Array<{ __typename?: 'Highlight', field?: string | null, snippets?: Array<string | null> | null } | null> | null } | null> } | null, files?: { __typename?: 'FileConnection', edges: Array<{ __typename?: 'FileEdge', node?: { __typename: 'File', id: string, filename?: string | null, mimeType?: string | null, size?: number | null, uploadedAt?: any | null } | null, highlights?: Array<{ __typename?: 'Highlight', field?: string | null, snippets?: Array<string | null> | null } | null> | null } | null> } | null };

export type SearchCompaniesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCompaniesQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountConnection', totalCount?: number | null, edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null } | null } | null } | null> } | null };

export type SearchPeopleQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchPeopleQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null } | null } | null } | null> } | null } | null } | null> } | null };

export type SearchDealsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchDealsQuery = { __typename?: 'Query', deals?: { __typename?: 'DealConnection', totalCount?: number | null, edges: Array<{ __typename?: 'DealEdge', node?: { __typename: 'Deal', id: string, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null } | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename?: 'Account', domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null } | null } | null } | null> } | null } | null } | null> } | null };

export type SearchEmailsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchEmailsQuery = { __typename?: 'Query', emails?: { __typename?: 'EngagementConnection', edges: Array<{ __typename?: 'EngagementEdge', node?: { __typename: 'Engagement', id: string, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, platform?: string | null, engagementType?: DdbEngagementType | null } | null, highlights?: Array<{ __typename?: 'Highlight', field?: string | null, snippets?: Array<string | null> | null } | null> | null } | null> } | null };

export type SearchMeetingsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchMeetingsQuery = { __typename?: 'Query', meetings?: { __typename?: 'EngagementConnection', edges: Array<{ __typename?: 'EngagementEdge', node?: { __typename: 'Engagement', id: string, displayName?: string | null, description?: string | null, startTime?: any | null, endTime?: any | null, platform?: string | null, engagementType?: DdbEngagementType | null, hasAiSummary: boolean, hasTranscript: boolean } | null, highlights?: Array<{ __typename?: 'Highlight', field?: string | null, snippets?: Array<string | null> | null } | null> | null } | null> } | null };

export type SearchNotesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchNotesQuery = { __typename?: 'Query', notes?: { __typename?: 'NoteConnection', edges: Array<{ __typename?: 'NoteEdge', node?: { __typename: 'Note', id: string, updatedAt?: any | null, title?: string | null, type?: NoteTypeEnum | null } | null, highlights?: Array<{ __typename?: 'Highlight', field?: string | null, snippets?: Array<string | null> | null } | null> | null } | null> } | null };

export type SearchFilesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchFilesQuery = { __typename?: 'Query', files?: { __typename?: 'FileConnection', edges: Array<{ __typename?: 'FileEdge', node?: { __typename: 'File', id: string, filename?: string | null, mimeType?: string | null, size?: number | null, uploadedAt?: any | null } | null, highlights?: Array<{ __typename?: 'Highlight', field?: string | null, snippets?: Array<string | null> | null } | null> | null } | null> } | null };

export type NotesSubjectSearchQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NotesSubjectSearchQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, externalId: string, primaryEmail?: string | null, profileImageUrl?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'AccountProperties', name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null } | null } | null> } | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, phone?: string | null, city?: string | null, state?: string | null, country?: string | null, linkedinProfileUrl?: string | null, note?: string | null, highlight?: string | null, additionalEmails?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null, ownerId?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null, accounts?: { __typename?: 'AccountConnection', totalCount?: number | null, edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, workspaceId: number, domain?: string | null, location?: string | null, customProperties?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, asOfTs?: any | null, properties?: { __typename?: 'AccountProperties', name?: string | null, email?: string | null, ownerId?: string | null, city?: string | null, country?: string | null, industry?: string | null, phone?: string | null, aboutUs?: string | null, numberOfEmployees?: number | null, state?: string | null, timeZone?: string | null, foundedYear?: number | null, annualRevenue?: string | null, description?: string | null, linkedinUrl?: string | null, raisedAmount?: string | null, techTags?: Array<string | null> | null, logoUrl?: string | null, postalCode?: string | null, entityType?: string | null, entitySubtype?: string | null, continent?: string | null, companySizeCategory?: string | null, revenueRange?: string | null, revenueMin?: number | null, revenueMax?: number | null, employeeCount?: string | null, employeeCountMin?: number | null, employeeCountMax?: number | null, crmTech?: Array<string | null> | null, marketingAutomationTech?: Array<string | null> | null, abmTech?: Array<string | null> | null, salesAutomationTech?: Array<string | null> | null, analyticsTech?: Array<string | null> | null, cmsTech?: Array<string | null> | null, martechCategories?: Array<string | null> | null, conversationIntelligenceTech?: Array<string | null> | null, cloudProviderTech?: Array<string | null> | null, emailHostingTech?: Array<string | null> | null, emailSecurityTech?: Array<string | null> | null, applicationSecurityTech?: Array<string | null> | null, cloudSecurityTech?: Array<string | null> | null, developmentTech?: Array<string | null> | null, eCommercePlatformTech?: Array<string | null> | null, note?: string | null, highlight?: string | null, additionalDomains?: Array<string | null> | null, avatarBackground?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null } | null } | null> } | null, deals?: { __typename?: 'DealConnection', totalCount?: number | null, edges: Array<{ __typename?: 'DealEdge', node?: { __typename: 'Deal', id: string, workspaceId: number, asOfTs?: any | null, propertiesJson?: string | null, customProperties?: any | null, inStageSince?: any | null, lastEmailTime?: any | null, lastEmailId?: string | null, properties?: { __typename?: 'DealProperties', name?: string | null, description?: string | null, amount?: number | null, closeDate?: any | null, createDate?: string | null, stage?: string | null, type?: string | null, priority?: string | null, probability?: number | null, NextStep?: string | null, LastActivityDate?: string | null, note?: string | null, highlight?: string | null, statusColor?: string | null, forecastCategory?: string | null, nextActivityText?: string | null, lastActivityText?: string | null } | null, owner?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, additionalOwners?: Array<{ __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null> | null, accounts?: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node?: { __typename: 'Account', id: string, domain?: string | null, properties?: { __typename?: 'AccountProperties', name?: string | null, logoUrl?: string | null, avatarBackground?: string | null } | null } | null } | null> } | null, contacts?: { __typename?: 'ContactConnection', edges: Array<{ __typename?: 'ContactEdge', node?: { __typename: 'Contact', id: string, primaryEmail?: string | null, profileImageUrl?: string | null, properties?: { __typename?: 'ContactProperties', firstName?: string | null, lastName?: string | null, jobTitle?: string | null, linkedinProfileUrl?: string | null, profileImageUrl?: string | null } | null } | null } | null> } | null, dealInfo?: { __typename?: 'DealInfo', id?: string | null, dealId?: string | null, createdAt?: any | null, updatedAt?: any | null, fields?: Array<{ __typename?: 'DealFieldValue', fieldName: string, displayName?: string | null, description?: string | null, bullets: Array<string | null> } | null> | null } | null, lastEmail?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null } | null, lastActivityEngagement?: { __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null, nextStepEngagements?: Array<{ __typename?: 'Engagement', id: string, displayName?: string | null, startTime?: any | null, engagementType?: DdbEngagementType | null, participantUserIds?: Array<number | null> | null, userId?: number | null } | null> | null, lineItems?: Array<{ __typename: 'LineItem', id: string, workspaceId?: number | null, dealId?: string | null, productId?: string | null, properties?: { __typename?: 'LineItemProperties', name?: string | null, quantity?: number | null, listPrice?: number | null, unitPrice?: number | null, totalPrice?: number | null, discountPercent?: number | null, productCode?: string | null } | null, product?: { __typename: 'Product', id: string, workspaceId?: number | null, properties?: { __typename?: 'ProductProperties', name?: string | null, productCode?: string | null, description?: string | null, unitPrice?: number | null, isActive?: boolean | null } | null } | null } | null> | null } | null } | null> } | null };

export type UserGroupFieldsFragment = { __typename: 'UserGroupType', id?: number | null, name?: string | null, description?: string | null, memberUserIds: Array<string>, systemKey?: string | null, createTs?: any | null, updateTs?: any | null };

export type GetUserGroupsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  includeSystem?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename: 'UserGroupType', id?: number | null, name?: string | null, description?: string | null, memberUserIds: Array<string>, systemKey?: string | null, createTs?: any | null, updateTs?: any | null }> };

export type CreateUserGroupMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  memberUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CreateUserGroupMutation = { __typename?: 'Mutations', createUserGroup?: { __typename?: 'CreateUserGroup', userGroup?: { __typename: 'UserGroupType', id?: number | null, name?: string | null, description?: string | null, memberUserIds: Array<string>, systemKey?: string | null, createTs?: any | null, updateTs?: any | null } | null } | null };

export type UpdateUserGroupMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserGroupMutation = { __typename?: 'Mutations', updateUserGroup?: { __typename?: 'UpdateUserGroup', userGroup?: { __typename: 'UserGroupType', id?: number | null, name?: string | null, description?: string | null, memberUserIds: Array<string>, systemKey?: string | null, createTs?: any | null, updateTs?: any | null } | null } | null };

export type DeleteUserGroupMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteUserGroupMutation = { __typename?: 'Mutations', deleteUserGroup?: { __typename?: 'DeleteUserGroup', ok?: boolean | null } | null };

export type AddUserGroupMembersMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddUserGroupMembersMutation = { __typename?: 'Mutations', addUserGroupMembers?: { __typename?: 'AddUserGroupMembers', userGroup?: { __typename: 'UserGroupType', id?: number | null, name?: string | null, description?: string | null, memberUserIds: Array<string>, systemKey?: string | null, createTs?: any | null, updateTs?: any | null } | null } | null };

export type RemoveUserGroupMembersMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveUserGroupMembersMutation = { __typename?: 'Mutations', removeUserGroupMembers?: { __typename?: 'RemoveUserGroupMembers', userGroup?: { __typename: 'UserGroupType', id?: number | null, name?: string | null, description?: string | null, memberUserIds: Array<string>, systemKey?: string | null, createTs?: any | null, updateTs?: any | null } | null } | null };

export type GetRecordGrantsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  recordId: Scalars['String']['input'];
}>;


export type GetRecordGrantsQuery = { __typename?: 'Query', recordGrants?: { __typename?: 'RecordGrants', recordId: string, viewGroupIds: Array<string>, editGroupIds: Array<string>, viewUserIds: Array<string>, editUserIds: Array<string>, source: string, workspaceDefault?: string | null } | null };

export type SetRecordGrantsMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  recordId: Scalars['String']['input'];
  grants: Array<RecordGrantInput> | RecordGrantInput;
  userGrants?: InputMaybe<Array<RecordUserGrantInput> | RecordUserGrantInput>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetRecordGrantsMutation = { __typename?: 'Mutations', setRecordGrants?: { __typename?: 'SetRecordGrants', recordGrants?: { __typename?: 'RecordGrants', recordId: string, viewGroupIds: Array<string>, editGroupIds: Array<string>, viewUserIds: Array<string>, editUserIds: Array<string>, source: string, workspaceDefault?: string | null } | null } | null };

export type UpdateRecordSharingMutationVariables = Exact<{
  input: RecordSharingInput;
  workspaceId: Scalars['ID']['input'];
}>;


export type UpdateRecordSharingMutation = { __typename?: 'Mutations', updateRecordSharing?: { __typename?: 'UpdateRecordSharingPreferences', preferences?: { __typename?: 'WorkspacePreferences', id: string, recordSharingEnabled?: boolean | null } | null } | null };

export type UpdateDefaultRecordAclMutationVariables = Exact<{
  input: DefaultRecordAclInput;
  workspaceId: Scalars['ID']['input'];
}>;


export type UpdateDefaultRecordAclMutation = { __typename?: 'Mutations', updateDefaultRecordAcl?: { __typename?: 'UpdateDefaultRecordAcl', preferences?: { __typename?: 'WorkspacePreferences', id: string, notesDefaultAcl?: string | null, engagementsDefaultAcl?: string | null, filesDefaultAcl?: string | null } | null } | null };

export type CreateBillingPortalSessionMutationVariables = Exact<{
  input: CreateBillingPortalSessionInput;
}>;


export type CreateBillingPortalSessionMutation = { __typename?: 'Mutations', createBillingPortalSession?: { __typename?: 'CreateBillingPortalSession', url: string } | null };

export type CreateCheckoutSessionMutationVariables = Exact<{
  input: CreateCheckoutSessionInput;
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutations', createCheckoutSession?: { __typename?: 'CheckoutSession', checkoutUrl: string, sessionId: string } | null };

export type CreateCustomerSessionMutationVariables = Exact<{
  input: CreateCustomerSessionInput;
}>;


export type CreateCustomerSessionMutation = { __typename?: 'Mutations', createCustomerSession?: { __typename?: 'CustomerSession', clientSecret: string } | null };

export type StartFreeTrialMutationVariables = Exact<{
  input: StartFreeTrialInput;
}>;


export type StartFreeTrialMutation = { __typename?: 'Mutations', startFreeTrial?: { __typename?: 'StartFreeTrialResponse', success: boolean } | null };

export type PurchaseCreditPackMutationVariables = Exact<{
  input: PurchaseCreditPackInput;
}>;


export type PurchaseCreditPackMutation = { __typename?: 'Mutations', purchaseCreditPack?: { __typename?: 'CreditPackPurchaseResult', success: boolean, invoiceId?: string | null, checkoutUrl?: string | null, sessionId?: string | null } | null };

export type BaseSummaryTemplateFieldsFragment = { __typename?: 'SummaryTemplateClass', id: string, workspaceId?: number | null, name?: string | null, isWorkspaceWide?: boolean | null, createdByUserId?: number | null, createdAt?: any | null, deleted?: boolean | null, isDefault?: boolean | null };

export type TemplateSectionFieldsFragment = { __typename?: 'TemplateSection', heading: string, prompt: string, order: number, crmField?: string | null };

export type SummaryTemplateFieldsFragment = { __typename?: 'SummaryTemplateClass', id: string, workspaceId?: number | null, name?: string | null, isWorkspaceWide?: boolean | null, createdByUserId?: number | null, createdAt?: any | null, deleted?: boolean | null, isDefault?: boolean | null, sections?: Array<{ __typename?: 'TemplateSection', heading: string, prompt: string, order: number, crmField?: string | null } | null> | null };

export type SummaryTemplateWithRelationsFragment = { __typename?: 'SummaryTemplateClass', id: string, workspaceId?: number | null, name?: string | null, isWorkspaceWide?: boolean | null, createdByUserId?: number | null, createdAt?: any | null, deleted?: boolean | null, isDefault?: boolean | null, createdByUser?: { __typename?: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null } | null, sections?: Array<{ __typename?: 'TemplateSection', heading: string, prompt: string, order: number, crmField?: string | null } | null> | null };

export type GetWorkspaceSummaryTemplatesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetWorkspaceSummaryTemplatesQuery = { __typename?: 'Query', summaryTemplates?: { __typename?: 'SummaryTemplateConnection', edges: Array<{ __typename?: 'SummaryTemplateEdge', cursor: string, node?: { __typename?: 'SummaryTemplateClass', id: string, workspaceId?: number | null, name?: string | null, isWorkspaceWide?: boolean | null, createdByUserId?: number | null, createdAt?: any | null, deleted?: boolean | null, isDefault?: boolean | null, sections?: Array<{ __typename?: 'TemplateSection', heading: string, prompt: string, order: number, crmField?: string | null } | null> | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetUserSummaryTemplatesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  createdByUserId: Scalars['Int']['input'];
}>;


export type GetUserSummaryTemplatesQuery = { __typename?: 'Query', summaryTemplates?: { __typename?: 'SummaryTemplateConnection', edges: Array<{ __typename?: 'SummaryTemplateEdge', cursor: string, node?: { __typename?: 'SummaryTemplateClass', id: string, workspaceId?: number | null, name?: string | null, isWorkspaceWide?: boolean | null, createdByUserId?: number | null, createdAt?: any | null, deleted?: boolean | null, isDefault?: boolean | null, createdByUser?: { __typename?: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null } | null, sections?: Array<{ __typename?: 'TemplateSection', heading: string, prompt: string, order: number, crmField?: string | null } | null> | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type CreateSummaryTemplateMutationVariables = Exact<{
  input: CreateSummaryTemplateInput;
}>;


export type CreateSummaryTemplateMutation = { __typename?: 'Mutations', createSummaryTemplate?: { __typename?: 'CreateSummaryTemplate', summaryTemplate?: { __typename?: 'SummaryTemplateClass', id: string, workspaceId?: number | null, name?: string | null, isWorkspaceWide?: boolean | null, createdByUserId?: number | null, createdAt?: any | null, deleted?: boolean | null, isDefault?: boolean | null, sections?: Array<{ __typename?: 'TemplateSection', heading: string, prompt: string, order: number, crmField?: string | null } | null> | null } | null } | null };

export type UpdateSummaryTemplateMutationVariables = Exact<{
  input: UpdateSummaryTemplateInput;
}>;


export type UpdateSummaryTemplateMutation = { __typename?: 'Mutations', updateSummaryTemplate?: { __typename?: 'UpdateSummaryTemplate', summaryTemplate?: { __typename?: 'SummaryTemplateClass', id: string, workspaceId?: number | null, name?: string | null, isWorkspaceWide?: boolean | null, createdByUserId?: number | null, createdAt?: any | null, deleted?: boolean | null, isDefault?: boolean | null, sections?: Array<{ __typename?: 'TemplateSection', heading: string, prompt: string, order: number, crmField?: string | null } | null> | null } | null } | null };

export type DeleteSummaryTemplateMutationVariables = Exact<{
  input: DeleteSummaryTemplateInput;
}>;


export type DeleteSummaryTemplateMutation = { __typename?: 'Mutations', deleteSummaryTemplate?: { __typename?: 'DeleteSummaryTemplate', success?: boolean | null } | null };

export type GenerateSummaryMutationVariables = Exact<{
  input: GenerateSummaryInput;
}>;


export type GenerateSummaryMutation = { __typename?: 'Mutations', generateSummary?: { __typename?: 'GenerateSummary', summary?: { __typename?: 'EngagementSummaryType', id?: string | null, engagementId?: string | null, summaryTemplateId?: string | null, summary?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type UpdateEngagementSummaryMutationVariables = Exact<{
  input: UpdateEngagementSummaryInput;
}>;


export type UpdateEngagementSummaryMutation = { __typename?: 'Mutations', updateEngagementSummary?: { __typename?: 'UpdateEngagementSummary', aiSummary?: string | null, summary?: { __typename?: 'EngagementSummaryType', id?: string | null, engagementId?: string | null, summaryTemplateId?: string | null, summary?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type TechTagsFieldsFragment = { __typename: 'TechTag', label?: string | null };

export type GetTechTagsQueryVariables = Exact<{
  filter: TechTagFilter;
}>;


export type GetTechTagsQuery = { __typename?: 'Query', techTags?: { __typename?: 'TechTagConnection', edges: Array<{ __typename?: 'TechTagEdge', cursor: string, node?: { __typename: 'TechTag', label?: string | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<UserSortEnum>> | InputMaybe<UserSortEnum>>;
  workspaceId: Scalars['ID']['input'];
}>;


export type GetUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node?: { __typename: 'User', role?: string | null, source?: UserWorkspaceSourceEnum | null, inviteStatus?: UserInviteStatusEnum | null, lastLoginTs?: string | null, id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null, manager?: { __typename?: 'User', id: string } | null } | null } | null> } | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null };

export type GetCurrentUserQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetCurrentUserQuery = { __typename?: 'Query', me?: { __typename: 'User', role?: string | null, oauthPlatform?: string | null, id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null, manager?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null, workspaces?: Array<{ __typename: 'Workspace', id: string, name?: string | null, domain: string, handle?: string | null, logoUrl?: string | null, companyName?: string | null, currentApp: AppType, isMember?: boolean | null, onboarding?: { __typename?: 'WorkspaceOnboarding', hasCustomizedWorkspace?: boolean | null, hasConnectedCrm?: boolean | null, hasInvitedUsers?: boolean | null } | null, subscription?: { __typename: 'Subscription', id: string, provider: SubscriptionProvider, externalId: string, status: SubscriptionStatus, pricingTier: PricingTier, planId: string, billingCycle: BillingCycle, amountInCents?: number | null, currency?: string | null, seats?: number | null, freeTrialStart?: any | null, freeTrialEnd?: any | null, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, createdAt: any, updatedAt: any, trialDaysRemaining?: number | null, entitlements?: { __typename: 'EntitlementsType', maxUsers?: number | null, readOnlyUsers?: number | null, inviteUsers?: boolean | null, aiGeneratedFieldUpdates?: boolean | null, reports?: boolean | null, deals?: boolean | null, pipelineIntelligence?: boolean | null, crmIntegrations?: boolean | null, mcpAccess?: boolean | null, apiAccess?: boolean | null, slackIntegration?: boolean | null, slackDm?: boolean | null, slackChannel?: boolean | null, integrationLimit?: number | null } | null } | null } | null> | null } | null };

export type GetCurrentUserWithoutRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserWithoutRoleQuery = { __typename?: 'Query', me?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null, oauthPlatform?: string | null, workspaces?: Array<{ __typename: 'Workspace', id: string, name?: string | null, domain: string, handle?: string | null, logoUrl?: string | null, companyName?: string | null, currentApp: AppType, isMember?: boolean | null, onboarding?: { __typename?: 'WorkspaceOnboarding', hasCustomizedWorkspace?: boolean | null, hasConnectedCrm?: boolean | null, hasInvitedUsers?: boolean | null } | null, subscription?: { __typename: 'Subscription', id: string, provider: SubscriptionProvider, externalId: string, status: SubscriptionStatus, pricingTier: PricingTier, planId: string, billingCycle: BillingCycle, amountInCents?: number | null, currency?: string | null, seats?: number | null, freeTrialStart?: any | null, freeTrialEnd?: any | null, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, createdAt: any, updatedAt: any, trialDaysRemaining?: number | null, entitlements?: { __typename: 'EntitlementsType', maxUsers?: number | null, readOnlyUsers?: number | null, inviteUsers?: boolean | null, aiGeneratedFieldUpdates?: boolean | null, reports?: boolean | null, deals?: boolean | null, pipelineIntelligence?: boolean | null, crmIntegrations?: boolean | null, mcpAccess?: boolean | null, apiAccess?: boolean | null, slackIntegration?: boolean | null, slackDm?: boolean | null, slackChannel?: boolean | null, integrationLimit?: number | null } | null } | null } | null> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
  workspaceId: Scalars['ID']['input'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutations', updateUser?: { __typename?: 'UpdateUser', user?: { __typename: 'User', role?: string | null, id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null, oauthPlatform?: string | null, workspaces?: Array<{ __typename: 'Workspace', id: string, name?: string | null, domain: string, handle?: string | null, logoUrl?: string | null, companyName?: string | null, currentApp: AppType, isMember?: boolean | null, onboarding?: { __typename?: 'WorkspaceOnboarding', hasCustomizedWorkspace?: boolean | null, hasConnectedCrm?: boolean | null, hasInvitedUsers?: boolean | null } | null, subscription?: { __typename: 'Subscription', id: string, provider: SubscriptionProvider, externalId: string, status: SubscriptionStatus, pricingTier: PricingTier, planId: string, billingCycle: BillingCycle, amountInCents?: number | null, currency?: string | null, seats?: number | null, freeTrialStart?: any | null, freeTrialEnd?: any | null, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, createdAt: any, updatedAt: any, trialDaysRemaining?: number | null, entitlements?: { __typename: 'EntitlementsType', maxUsers?: number | null, readOnlyUsers?: number | null, inviteUsers?: boolean | null, aiGeneratedFieldUpdates?: boolean | null, reports?: boolean | null, deals?: boolean | null, pipelineIntelligence?: boolean | null, crmIntegrations?: boolean | null, mcpAccess?: boolean | null, apiAccess?: boolean | null, slackIntegration?: boolean | null, slackDm?: boolean | null, slackChannel?: boolean | null, integrationLimit?: number | null } | null } | null } | null> | null } | null } | null };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutations', inviteUser?: { __typename?: 'InviteUser', user?: { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null } | null } | null };

export type DeleteUserMutationVariables = Exact<{
  input: DeleteUserRoleInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutations', deleteUserRole?: { __typename?: 'DeleteUserRole', success?: boolean | null, error?: string | null } | null };

export type AddUserManagerMutationVariables = Exact<{
  input: AddUserManagerInput;
}>;


export type AddUserManagerMutation = { __typename?: 'Mutations', addUserManager?: { __typename?: 'AddUserManager', success?: boolean | null, error?: string | null } | null };

export type UserBaseFieldsFragment = { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, avatarBackground?: string | null };

export type UserFieldsFragment = { __typename: 'User', id: string, givenName?: string | null, preferredName?: string | null, surname?: string | null, email?: string | null, profileImageUrl?: string | null, lastLogin?: any | null, isOnboarded?: boolean | null, isSuperuser: boolean, avatarBackground?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, emailSignature?: string | null };

export type CurrentUserFieldsFragment = { __typename?: 'User', isOnboarded?: boolean | null, oauthPlatform?: string | null, workspaces?: Array<{ __typename: 'Workspace', id: string, name?: string | null, domain: string, handle?: string | null, logoUrl?: string | null, companyName?: string | null, currentApp: AppType, isMember?: boolean | null, onboarding?: { __typename?: 'WorkspaceOnboarding', hasCustomizedWorkspace?: boolean | null, hasConnectedCrm?: boolean | null, hasInvitedUsers?: boolean | null } | null, subscription?: { __typename: 'Subscription', id: string, provider: SubscriptionProvider, externalId: string, status: SubscriptionStatus, pricingTier: PricingTier, planId: string, billingCycle: BillingCycle, amountInCents?: number | null, currency?: string | null, seats?: number | null, freeTrialStart?: any | null, freeTrialEnd?: any | null, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, createdAt: any, updatedAt: any, trialDaysRemaining?: number | null, entitlements?: { __typename: 'EntitlementsType', maxUsers?: number | null, readOnlyUsers?: number | null, inviteUsers?: boolean | null, aiGeneratedFieldUpdates?: boolean | null, reports?: boolean | null, deals?: boolean | null, pipelineIntelligence?: boolean | null, crmIntegrations?: boolean | null, mcpAccess?: boolean | null, apiAccess?: boolean | null, slackIntegration?: boolean | null, slackDm?: boolean | null, slackChannel?: boolean | null, integrationLimit?: number | null } | null } | null } | null> | null };

export type GetUserPreferencesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetUserPreferencesQuery = { __typename?: 'Query', userPreferences?: { __typename: 'UserPreferences', id: string, language?: string | null, pcContactsAccountsFromMeetings?: boolean | null, pcContactsAccountsFromEmails?: boolean | null, vcRecordMeetings?: boolean | null, vcRecordMeetingsType?: string | null, vcBotName?: string | null, vcUseCustomBotName?: boolean | null, vcRecorderType?: string | null, vcRecorderAppearance?: string | null, vcRecorderCustomImageUrl?: string | null, closeDateInPast?: boolean | null, noActivity?: boolean | null, noNextSteps?: boolean | null, fewContacts?: boolean | null, externalMeetings?: boolean | null, actionItemsDue?: boolean | null, followUpEmails?: boolean | null, deliveryMethod?: Array<string | null> | null, notificationChannels?: any | null, timezone?: string | null, suggestedChanges?: boolean | null, createdDefaultEmailTemplates?: boolean | null } | null };

export type UpdateProductivityPreferencesMutationVariables = Exact<{
  input: PcPreferencesInput;
  workspaceId: Scalars['ID']['input'];
}>;


export type UpdateProductivityPreferencesMutation = { __typename?: 'Mutations', updatePcPreferences?: { __typename?: 'UpdatePCPreferences', preferences?: { __typename?: 'UserPreferences', pcContactsAccountsFromMeetings?: boolean | null, pcContactsAccountsFromEmails?: boolean | null } | null } | null };

export type UpdateVideoConferencingPreferencesMutationVariables = Exact<{
  input: VcPreferencesInput;
  workspaceId: Scalars['ID']['input'];
}>;


export type UpdateVideoConferencingPreferencesMutation = { __typename?: 'Mutations', updateVcPreferences?: { __typename?: 'UpdateVCPreferences', preferences?: { __typename?: 'UserPreferences', vcRecordMeetings?: boolean | null, vcRecordMeetingsType?: string | null, vcBotName?: string | null, vcUseCustomBotName?: boolean | null, vcRecorderType?: string | null, vcRecorderAppearance?: string | null, vcRecorderCustomImageUrl?: string | null } | null } | null };

export type UpdateUserLanguageMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
}>;


export type UpdateUserLanguageMutation = { __typename?: 'Mutations', updateUserLanguage?: { __typename?: 'UpdateUserLanguage', preferences?: { __typename: 'UserPreferences', id: string, language?: string | null } | null } | null };

export type UpdateNotificationsPreferencesMutationVariables = Exact<{
  input: NtfPreferencesInput;
  workspaceId: Scalars['ID']['input'];
}>;


export type UpdateNotificationsPreferencesMutation = { __typename?: 'Mutations', updateNtfPreferences?: { __typename?: 'UpdateNTFPreferences', preferences?: { __typename?: 'UserPreferences', preferences: any } | null } | null };

export type WorkspaceConnectionFieldsFragment = { __typename: 'WorkspaceConnectionType', id: string, provider: string, label: string, serverUrl: string, auth: string, status: string, disconnectReason?: string | null, lastSyncAt?: string | null, lastError?: string | null, domains?: Array<string | null> | null, domainLabels?: Array<string | null> | null, entities?: Array<string | null> | null, domainsConfirmed?: boolean | null, reconfirmReason?: string | null, discoveredTools?: any | null, domainMap?: any | null, entityMap?: any | null };

export type GetWorkspaceConnectionsQueryVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
}>;


export type GetWorkspaceConnectionsQuery = { __typename?: 'Query', workspaceConnections?: Array<{ __typename: 'WorkspaceConnectionType', id: string, provider: string, label: string, serverUrl: string, auth: string, status: string, disconnectReason?: string | null, lastSyncAt?: string | null, lastError?: string | null, domains?: Array<string | null> | null, domainLabels?: Array<string | null> | null, entities?: Array<string | null> | null, domainsConfirmed?: boolean | null, reconfirmReason?: string | null, discoveredTools?: any | null, domainMap?: any | null, entityMap?: any | null } | null> | null };

export type ConnectMcpServerMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  serverUrl: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConnectMcpServerMutation = { __typename?: 'Mutations', connectMcpServer?: { __typename?: 'ConnectMcpServer', result?: { __typename: 'McpConnectStart', authorizationUrl?: string | null, needs?: string | null, message?: string | null, redirectUri?: string | null } | null } | null };

export type SetMcpConnectionTokenMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  serverUrl: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SetMcpConnectionTokenMutation = { __typename?: 'Mutations', setMcpConnectionToken?: { __typename?: 'SetMcpConnectionToken', connection?: { __typename: 'WorkspaceConnectionType', id: string, provider: string, label: string, serverUrl: string, auth: string, status: string, disconnectReason?: string | null, lastSyncAt?: string | null, lastError?: string | null, domains?: Array<string | null> | null, domainLabels?: Array<string | null> | null, entities?: Array<string | null> | null, domainsConfirmed?: boolean | null, reconfirmReason?: string | null, discoveredTools?: any | null, domainMap?: any | null, entityMap?: any | null } | null } | null };

export type CompleteMcpConnectionMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  state: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type CompleteMcpConnectionMutation = { __typename?: 'Mutations', completeMcpConnection?: { __typename?: 'CompleteMcpConnection', connection?: { __typename: 'WorkspaceConnectionType', id: string, provider: string, label: string, serverUrl: string, auth: string, status: string, disconnectReason?: string | null, lastSyncAt?: string | null, lastError?: string | null, domains?: Array<string | null> | null, domainLabels?: Array<string | null> | null, entities?: Array<string | null> | null, domainsConfirmed?: boolean | null, reconfirmReason?: string | null, discoveredTools?: any | null, domainMap?: any | null, entityMap?: any | null } | null } | null };

export type ConfirmConnectionMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  connectionId: Scalars['ID']['input'];
  outcome: ConnectionConfirmationOutcome;
}>;


export type ConfirmConnectionMutation = { __typename?: 'Mutations', confirmConnection?: { __typename?: 'ConfirmConnection', connection?: { __typename: 'WorkspaceConnectionType', id: string, provider: string, label: string, serverUrl: string, auth: string, status: string, disconnectReason?: string | null, lastSyncAt?: string | null, lastError?: string | null, domains?: Array<string | null> | null, domainLabels?: Array<string | null> | null, entities?: Array<string | null> | null, domainsConfirmed?: boolean | null, reconfirmReason?: string | null, discoveredTools?: any | null, domainMap?: any | null, entityMap?: any | null } | null } | null };

export type DisconnectMcpConnectionMutationVariables = Exact<{
  workspaceId: Scalars['Int']['input'];
  connectionId: Scalars['ID']['input'];
  deleteData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DisconnectMcpConnectionMutation = { __typename?: 'Mutations', disconnectMcpConnection?: { __typename?: 'DisconnectMcpConnection', connection?: { __typename: 'WorkspaceConnectionType', id: string, provider: string, label: string, serverUrl: string, auth: string, status: string, disconnectReason?: string | null, lastSyncAt?: string | null, lastError?: string | null, domains?: Array<string | null> | null, domainLabels?: Array<string | null> | null, entities?: Array<string | null> | null, domainsConfirmed?: boolean | null, reconfirmReason?: string | null, discoveredTools?: any | null, domainMap?: any | null, entityMap?: any | null } | null } | null };

export type GetWorkspaceIntelligenceQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetWorkspaceIntelligenceQuery = { __typename?: 'Query', workspaceIntelligence?: { __typename?: 'WorkspaceIntelligenceType', id?: number | null, workspaceId?: number | null, description?: string | null, valuePropositions?: string | null, icp?: string | null, buyerPersonas?: string | null, competitorList?: string | null, productsServices?: string | null, salesProcess?: string | null, personalPreferences?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, formattedContext?: string | null, createdAt?: any | null, updatedAt?: any | null, customKnowledgeAreas?: Array<{ __typename?: 'WorkspaceCustomKnowledgeType', id?: number | null, workspaceId?: number | null, name?: string | null, content?: string | null, fileId?: string | null, filename?: string | null, extractedText?: string | null, extractionStatus?: string | null, extractedAt?: any | null, position?: number | null, createdAt?: any | null, updatedAt?: any | null } | null> | null, sectionFiles?: Array<{ __typename?: 'WorkspaceIntelligenceSectionFileType', section?: string | null, fileId?: string | null, filename?: string | null, extractedText?: string | null, extractionStatus?: string | null, extractedAt?: any | null } | null> | null } | null };

export type WorkspaceLeadFinderSuggestionsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type WorkspaceLeadFinderSuggestionsQuery = { __typename?: 'Query', workspaceLeadFinderSuggestions?: { __typename?: 'WorkspaceLeadFinderSuggestionsType', people?: Array<any | null> | null, companies?: Array<any | null> | null } | null };

export type UpdateWorkspaceIntelligenceMutationVariables = Exact<{
  input: UpdateWorkspaceIntelligenceInput;
}>;


export type UpdateWorkspaceIntelligenceMutation = { __typename?: 'Mutations', updateWorkspaceIntelligence?: { __typename?: 'UpdateWorkspaceIntelligence', intelligence?: { __typename?: 'WorkspaceIntelligenceType', id?: number | null, workspaceId?: number | null, description?: string | null, valuePropositions?: string | null, icp?: string | null, buyerPersonas?: string | null, competitorList?: string | null, productsServices?: string | null, salesProcess?: string | null, personalPreferences?: string | null, defaultSummaryTemplateId?: string | null, defaultBriefTemplateId?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type GenerateWorkspaceIntelligenceMutationVariables = Exact<{
  input: GenerateWorkspaceIntelligenceInput;
}>;


export type GenerateWorkspaceIntelligenceMutation = { __typename?: 'Mutations', generateWorkspaceIntelligence?: { __typename?: 'GenerateWorkspaceIntelligence', intelligence?: { __typename?: 'WorkspaceIntelligenceType', id?: number | null, workspaceId?: number | null, description?: string | null, valuePropositions?: string | null, icp?: string | null, buyerPersonas?: string | null, competitorList?: string | null, productsServices?: string | null, salesProcess?: string | null, personalPreferences?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type CreateWorkspaceCustomKnowledgeMutationVariables = Exact<{
  input: CreateWorkspaceCustomKnowledgeInput;
}>;


export type CreateWorkspaceCustomKnowledgeMutation = { __typename?: 'Mutations', createWorkspaceCustomKnowledge?: { __typename?: 'CreateWorkspaceCustomKnowledge', customKnowledge?: { __typename?: 'WorkspaceCustomKnowledgeType', id?: number | null, workspaceId?: number | null, name?: string | null, content?: string | null, fileId?: string | null, filename?: string | null, extractedText?: string | null, extractionStatus?: string | null, extractedAt?: any | null, position?: number | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type UpdateWorkspaceCustomKnowledgeMutationVariables = Exact<{
  input: UpdateWorkspaceCustomKnowledgeInput;
}>;


export type UpdateWorkspaceCustomKnowledgeMutation = { __typename?: 'Mutations', updateWorkspaceCustomKnowledge?: { __typename?: 'UpdateWorkspaceCustomKnowledge', customKnowledge?: { __typename?: 'WorkspaceCustomKnowledgeType', id?: number | null, workspaceId?: number | null, name?: string | null, content?: string | null, fileId?: string | null, filename?: string | null, extractedText?: string | null, extractionStatus?: string | null, extractedAt?: any | null, position?: number | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type DeleteWorkspaceCustomKnowledgeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWorkspaceCustomKnowledgeMutation = { __typename?: 'Mutations', deleteWorkspaceCustomKnowledge?: { __typename?: 'DeleteWorkspaceCustomKnowledge', success?: boolean | null } | null };

export type ReorderWorkspaceCustomKnowledgeMutationVariables = Exact<{
  input: ReorderWorkspaceCustomKnowledgeInput;
}>;


export type ReorderWorkspaceCustomKnowledgeMutation = { __typename?: 'Mutations', reorderWorkspaceCustomKnowledge?: { __typename?: 'ReorderWorkspaceCustomKnowledge', customKnowledgeAreas?: Array<{ __typename?: 'WorkspaceCustomKnowledgeType', id?: number | null, position?: number | null } | null> | null } | null };

export type SetWorkspaceIntelligenceSectionFileMutationVariables = Exact<{
  input: SetWorkspaceIntelligenceSectionFileInput;
}>;


export type SetWorkspaceIntelligenceSectionFileMutation = { __typename?: 'Mutations', setWorkspaceIntelligenceSectionFile?: { __typename?: 'SetWorkspaceIntelligenceSectionFile', sectionFile?: { __typename?: 'WorkspaceIntelligenceSectionFileType', section?: string | null, fileId?: string | null, filename?: string | null, extractedText?: string | null, extractionStatus?: string | null, extractedAt?: any | null } | null } | null };

export type UpdateWorkspaceMutationVariables = Exact<{
  input: UpdateWorkspaceInput;
}>;


export type UpdateWorkspaceMutation = { __typename?: 'Mutations', updateWorkspace?: { __typename?: 'UpdateWorkspace', workspace?: { __typename: 'Workspace', id: string, name?: string | null, domain: string, handle?: string | null, logoUrl?: string | null, companyName?: string | null, currentApp: AppType, isMember?: boolean | null, domains?: Array<{ __typename: 'WorkspaceDomain', domain: string, isPrimary?: boolean | null, verified?: boolean | null } | null> | null, onboarding?: { __typename?: 'WorkspaceOnboarding', hasCustomizedWorkspace?: boolean | null, hasConnectedCrm?: boolean | null, hasInvitedUsers?: boolean | null } | null, subscription?: { __typename: 'Subscription', id: string, provider: SubscriptionProvider, externalId: string, status: SubscriptionStatus, pricingTier: PricingTier, planId: string, billingCycle: BillingCycle, amountInCents?: number | null, currency?: string | null, seats?: number | null, freeTrialStart?: any | null, freeTrialEnd?: any | null, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, createdAt: any, updatedAt: any, trialDaysRemaining?: number | null, entitlements?: { __typename: 'EntitlementsType', maxUsers?: number | null, readOnlyUsers?: number | null, inviteUsers?: boolean | null, aiGeneratedFieldUpdates?: boolean | null, reports?: boolean | null, deals?: boolean | null, pipelineIntelligence?: boolean | null, crmIntegrations?: boolean | null, mcpAccess?: boolean | null, apiAccess?: boolean | null, slackIntegration?: boolean | null, slackDm?: boolean | null, slackChannel?: boolean | null, integrationLimit?: number | null } | null } | null } | null } | null };

export type WorkspaceDomainFieldsFragment = { __typename: 'WorkspaceDomain', domain: string, isPrimary?: boolean | null, verified?: boolean | null };

export type GetWorkspaceDomainsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkspaceDomainsQuery = { __typename?: 'Query', workspace?: { __typename: 'Workspace', id: string, domains?: Array<{ __typename: 'WorkspaceDomain', domain: string, isPrimary?: boolean | null, verified?: boolean | null } | null> | null } | null };

export type AddWorkspaceDomainMutationVariables = Exact<{
  input: AddWorkspaceDomainInput;
}>;


export type AddWorkspaceDomainMutation = { __typename?: 'Mutations', addWorkspaceDomain?: { __typename?: 'AddWorkspaceDomain', success?: boolean | null, error?: string | null, workspace?: { __typename: 'Workspace', id: string, domains?: Array<{ __typename: 'WorkspaceDomain', domain: string, isPrimary?: boolean | null, verified?: boolean | null } | null> | null } | null } | null };

export type RemoveWorkspaceDomainMutationVariables = Exact<{
  input: RemoveWorkspaceDomainInput;
}>;


export type RemoveWorkspaceDomainMutation = { __typename?: 'Mutations', removeWorkspaceDomain?: { __typename?: 'RemoveWorkspaceDomain', success?: boolean | null, error?: string | null, workspace?: { __typename: 'Workspace', id: string, domains?: Array<{ __typename: 'WorkspaceDomain', domain: string, isPrimary?: boolean | null, verified?: boolean | null } | null> | null } | null } | null };

export type SendWelcomeEmailMutationVariables = Exact<{
  input: SendWorkspaceWelcomeEmailInput;
}>;


export type SendWelcomeEmailMutation = { __typename?: 'Mutations', sendWelcomeEmail?: { __typename?: 'SendWorkspaceWelcomeEmail', workspace?: { __typename: 'Workspace', id: string, name?: string | null, domain: string, handle?: string | null, logoUrl?: string | null, companyName?: string | null, currentApp: AppType, isMember?: boolean | null, onboarding?: { __typename?: 'WorkspaceOnboarding', hasCustomizedWorkspace?: boolean | null, hasConnectedCrm?: boolean | null, hasInvitedUsers?: boolean | null } | null, subscription?: { __typename: 'Subscription', id: string, provider: SubscriptionProvider, externalId: string, status: SubscriptionStatus, pricingTier: PricingTier, planId: string, billingCycle: BillingCycle, amountInCents?: number | null, currency?: string | null, seats?: number | null, freeTrialStart?: any | null, freeTrialEnd?: any | null, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, createdAt: any, updatedAt: any, trialDaysRemaining?: number | null, entitlements?: { __typename: 'EntitlementsType', maxUsers?: number | null, readOnlyUsers?: number | null, inviteUsers?: boolean | null, aiGeneratedFieldUpdates?: boolean | null, reports?: boolean | null, deals?: boolean | null, pipelineIntelligence?: boolean | null, crmIntegrations?: boolean | null, mcpAccess?: boolean | null, apiAccess?: boolean | null, slackIntegration?: boolean | null, slackDm?: boolean | null, slackChannel?: boolean | null, integrationLimit?: number | null } | null } | null } | null } | null };

export type WorkspaceFieldsFragment = { __typename: 'Workspace', id: string, name?: string | null, domain: string, handle?: string | null, logoUrl?: string | null, companyName?: string | null, currentApp: AppType, isMember?: boolean | null, onboarding?: { __typename?: 'WorkspaceOnboarding', hasCustomizedWorkspace?: boolean | null, hasConnectedCrm?: boolean | null, hasInvitedUsers?: boolean | null } | null, subscription?: { __typename: 'Subscription', id: string, provider: SubscriptionProvider, externalId: string, status: SubscriptionStatus, pricingTier: PricingTier, planId: string, billingCycle: BillingCycle, amountInCents?: number | null, currency?: string | null, seats?: number | null, freeTrialStart?: any | null, freeTrialEnd?: any | null, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, createdAt: any, updatedAt: any, trialDaysRemaining?: number | null, entitlements?: { __typename: 'EntitlementsType', maxUsers?: number | null, readOnlyUsers?: number | null, inviteUsers?: boolean | null, aiGeneratedFieldUpdates?: boolean | null, reports?: boolean | null, deals?: boolean | null, pipelineIntelligence?: boolean | null, crmIntegrations?: boolean | null, mcpAccess?: boolean | null, apiAccess?: boolean | null, slackIntegration?: boolean | null, slackDm?: boolean | null, slackChannel?: boolean | null, integrationLimit?: number | null } | null } | null };

export type GetTemporalTaskRunQueryVariables = Exact<{
  workflowId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTemporalTaskRunQuery = { __typename?: 'Query', temporalTaskRun?: { __typename?: 'TemporalTrackerRun', runId: string, workspaceId: number, workflowType: string, workflowId: string, expectedNumSteps?: number | null, entries?: Array<{ __typename?: 'TemporalTrackerEntry', runId: string, stepName: string } | null> | null } | null };

export type GetWorkspacePreferencesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetWorkspacePreferencesQuery = { __typename?: 'Query', workspacePreferences?: { __typename: 'WorkspacePreferences', id: string, workspaceId: number, preferences: any, publicVisibility?: boolean | null, emailVisibility?: string | null, tasksVisibility?: string | null, recordSharingEnabled?: boolean | null, notesDefaultAcl?: string | null, engagementsDefaultAcl?: string | null, filesDefaultAcl?: string | null, fiscalYearStartMonth?: number | null, fiscalYearStartDay?: number | null, defaultLanguage?: string | null, autoRechargeEnabled?: boolean | null, autoRechargePackId?: string | null, createTs: any, updateTs: any, revenueGpt?: { __typename?: 'RevenueGptPreferences', strictMode?: boolean | null } | null } | null };

export type UpdateAutoRechargeMutationVariables = Exact<{
  input: UpdateAutoRechargeInput;
}>;


export type UpdateAutoRechargeMutation = { __typename?: 'Mutations', updateAutoRecharge?: { __typename?: 'UpdateAutoRechargePreferences', preferences?: { __typename: 'WorkspacePreferences', id: string, autoRechargeEnabled?: boolean | null, autoRechargePackId?: string | null } | null } | null };

export type GetIsIngestionRunningQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIsIngestionRunningQuery = { __typename?: 'Query', isIngestionRunning?: boolean | null };

export type GetEarliestCompareDateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEarliestCompareDateQuery = { __typename?: 'Query', workspace?: { __typename: 'Workspace', earliestCompareDate?: any | null } | null };

export type UpdatePrivacyMutationVariables = Exact<{
  input: PublicVisibilityInput;
  workspaceId: Scalars['ID']['input'];
}>;


export type UpdatePrivacyMutation = { __typename?: 'Mutations', updatePrivacy?: { __typename?: 'UpdatePublicVisibilityPreferences', preferences?: { __typename?: 'WorkspacePreferences', publicVisibility?: boolean | null } | null } | null };

export type UpdateEmailVisibilityMutationVariables = Exact<{
  input: EmailVisibilityInput;
  workspaceId: Scalars['ID']['input'];
}>;


export type UpdateEmailVisibilityMutation = { __typename?: 'Mutations', updateEmailVisibility?: { __typename?: 'UpdateEmailVisibilityPreferences', preferences?: { __typename?: 'WorkspacePreferences', emailVisibility?: string | null, publicVisibility?: boolean | null } | null } | null };

export type UpdateTasksVisibilityMutationVariables = Exact<{
  input: TasksVisibilityInput;
  workspaceId: Scalars['ID']['input'];
}>;


export type UpdateTasksVisibilityMutation = { __typename?: 'Mutations', updateTasksVisibility?: { __typename?: 'UpdateTasksVisibilityPreferences', preferences?: { __typename?: 'WorkspacePreferences', tasksVisibility?: string | null } | null } | null };

export type UpdateWorkspaceDefaultLanguageMutationVariables = Exact<{
  input: UpdateWorkspaceDefaultLanguageInput;
}>;


export type UpdateWorkspaceDefaultLanguageMutation = { __typename?: 'Mutations', updateDefaultLanguage?: { __typename?: 'UpdateWorkspaceDefaultLanguage', preferences?: { __typename: 'WorkspacePreferences', id: string, defaultLanguage?: string | null } | null } | null };

export type UpdateWorkspacePreferencesMutationVariables = Exact<{
  input: UpdateWorkspacePreferencesInput;
}>;


export type UpdateWorkspacePreferencesMutation = { __typename?: 'Mutations', updatePreferences?: { __typename?: 'UpdateWorkspacePreferences', preferences?: { __typename?: 'WorkspacePreferences', id: string, workspaceId: number, preferences: any, fiscalYearStartMonth?: number | null, fiscalYearStartDay?: number | null } | null } | null };

export type GetAvailableWorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableWorkspacesQuery = { __typename?: 'Query', availableWorkspaces?: Array<{ __typename?: 'Workspace', id: string, name?: string | null, domain: string, logoUrl?: string | null } | null> | null };

export type JoinWorkspaceMutationVariables = Exact<{
  input: JoinWorkspaceInput;
}>;


export type JoinWorkspaceMutation = { __typename?: 'Mutations', joinWorkspace?: { __typename?: 'JoinWorkspace', success?: boolean | null, error?: string | null, workspace?: { __typename: 'Workspace', id: string, name?: string | null, domain: string, handle?: string | null, logoUrl?: string | null, companyName?: string | null, currentApp: AppType, isMember?: boolean | null, onboarding?: { __typename?: 'WorkspaceOnboarding', hasCustomizedWorkspace?: boolean | null, hasConnectedCrm?: boolean | null, hasInvitedUsers?: boolean | null } | null, subscription?: { __typename: 'Subscription', id: string, provider: SubscriptionProvider, externalId: string, status: SubscriptionStatus, pricingTier: PricingTier, planId: string, billingCycle: BillingCycle, amountInCents?: number | null, currency?: string | null, seats?: number | null, freeTrialStart?: any | null, freeTrialEnd?: any | null, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, createdAt: any, updatedAt: any, trialDaysRemaining?: number | null, entitlements?: { __typename: 'EntitlementsType', maxUsers?: number | null, readOnlyUsers?: number | null, inviteUsers?: boolean | null, aiGeneratedFieldUpdates?: boolean | null, reports?: boolean | null, deals?: boolean | null, pipelineIntelligence?: boolean | null, crmIntegrations?: boolean | null, mcpAccess?: boolean | null, apiAccess?: boolean | null, slackIntegration?: boolean | null, slackDm?: boolean | null, slackChannel?: boolean | null, integrationLimit?: number | null } | null } | null } | null } | null };

export type CreateWorkspaceMutationVariables = Exact<{
  input: CreateWorkspaceInput;
}>;


export type CreateWorkspaceMutation = { __typename?: 'Mutations', createWorkspace?: { __typename?: 'CreateWorkspace', success?: boolean | null, error?: string | null, workspace?: { __typename: 'Workspace', id: string, name?: string | null, domain: string, handle?: string | null, logoUrl?: string | null, companyName?: string | null, currentApp: AppType, isMember?: boolean | null, onboarding?: { __typename?: 'WorkspaceOnboarding', hasCustomizedWorkspace?: boolean | null, hasConnectedCrm?: boolean | null, hasInvitedUsers?: boolean | null } | null, subscription?: { __typename: 'Subscription', id: string, provider: SubscriptionProvider, externalId: string, status: SubscriptionStatus, pricingTier: PricingTier, planId: string, billingCycle: BillingCycle, amountInCents?: number | null, currency?: string | null, seats?: number | null, freeTrialStart?: any | null, freeTrialEnd?: any | null, currentPeriodStart?: any | null, currentPeriodEnd?: any | null, createdAt: any, updatedAt: any, trialDaysRemaining?: number | null, entitlements?: { __typename: 'EntitlementsType', maxUsers?: number | null, readOnlyUsers?: number | null, inviteUsers?: boolean | null, aiGeneratedFieldUpdates?: boolean | null, reports?: boolean | null, deals?: boolean | null, pipelineIntelligence?: boolean | null, crmIntegrations?: boolean | null, mcpAccess?: boolean | null, apiAccess?: boolean | null, slackIntegration?: boolean | null, slackDm?: boolean | null, slackChannel?: boolean | null, integrationLimit?: number | null } | null } | null } | null } | null };

export type DeleteWorkspaceMutationVariables = Exact<{
  input: DeleteWorkspaceInput;
}>;


export type DeleteWorkspaceMutation = { __typename?: 'Mutations', deleteWorkspace?: { __typename?: 'DeleteWorkspace', success?: boolean | null } | null };

export const AccountBaseFieldsFragmentDoc = gql`
    fragment AccountBaseFields on Account {
  __typename
  id
  domain
  properties {
    name
    logoUrl
    avatarBackground
  }
}
    `;
export const AssociatedAccountsFragmentDoc = gql`
    fragment AssociatedAccounts on Account {
  associatedAccounts {
    ...AccountBaseFields
  }
}
    ${AccountBaseFieldsFragmentDoc}`;
export const AccountAssociationsFragmentDoc = gql`
    fragment AccountAssociations on Account {
  accountAssociations {
    label
    toId
    toAccount {
      ...AccountBaseFields
    }
  }
}
    ${AccountBaseFieldsFragmentDoc}`;
export const AccountEngagementsFragmentDoc = gql`
    fragment AccountEngagements on Account {
  lastEmail {
    id
    displayName
    startTime
  }
  lastEngagement {
    id
    displayName
    startTime
    engagementType
  }
  nextEngagement {
    id
    displayName
    startTime
    engagementType
  }
}
    `;
export const AgentTriggerFieldsFragmentDoc = gql`
    fragment AgentTriggerFields on AgentTrigger {
  __typename
  type
  event
  cron
  filter
  stageIds
  scope
  objectType
  repeat
  anchorField
  daysBefore
  pathPattern
  usage
  campaign
}
    `;
export const AgentDefinitionFieldsFragmentDoc = gql`
    fragment AgentDefinitionFields on AgentDefinition {
  __typename
  id
  workspaceId
  ownerUserId
  name
  systemPrompt
  allowedTools
  modelUseCase
  maxIterations
  visibility
  status
  updateTs
  conditions
  notifyTarget
  notifyEmail
  notifyUserIds
  notifySlack
  guardActions
  trigger {
    ...AgentTriggerFields
  }
}
    ${AgentTriggerFieldsFragmentDoc}`;
export const AgentTemplateFieldsFragmentDoc = gql`
    fragment AgentTemplateFields on AgentTemplate {
  __typename
  templateName
  name
  description
  category
  systemPrompt
  allowedTools
  visibility
  conditions
  notifySlack
  available
  unavailableReasons
  trigger {
    ...AgentTriggerFields
  }
}
    ${AgentTriggerFieldsFragmentDoc}`;
export const BriefTemplateSectionFieldsFragmentDoc = gql`
    fragment BriefTemplateSectionFields on BriefTemplateSection {
  heading
  prompt
  order
}
    `;
export const BriefTemplateFieldsFragmentDoc = gql`
    fragment BriefTemplateFields on BriefTemplateClass {
  id
  workspaceId
  name
  sections {
    ...BriefTemplateSectionFields
  }
  createdByUserId
  createdAt
  isWorkspaceWide
  isDefault
  deleted
}
    ${BriefTemplateSectionFieldsFragmentDoc}`;
export const CampaignRecipientFieldsFragmentDoc = gql`
    fragment CampaignRecipientFields on CampaignRecipient {
  __typename
  contactId
  name
  email
  title
  company
}
    `;
export const CampaignStepFieldsFragmentDoc = gql`
    fragment CampaignStepFields on CampaignStep {
  __typename
  id
  stepOrder
  templateId
  subject
  body
  attachments
  delayDays
}
    `;
export const CampaignEnrollmentCountsFieldsFragmentDoc = gql`
    fragment CampaignEnrollmentCountsFields on CampaignEnrollmentCounts {
  __typename
  enrolled
  active
  completed
  unenrolled
  failed
  bounced
  unsubscribed
  opened
  clicked
}
    `;
export const CampaignStepStatsFieldsFragmentDoc = gql`
    fragment CampaignStepStatsFields on CampaignStepStats {
  __typename
  stepOrder
  sent
  replies
  opened
  clicked
  bounced
  unsubscribed
}
    `;
export const CampaignFieldsFragmentDoc = gql`
    fragment CampaignFields on Campaign {
  __typename
  id
  workspaceId
  ownerUserId
  ownerName
  ownerEmail
  name
  listId
  additionalListIds
  status
  settings
  steps {
    ...CampaignStepFields
  }
  startedAt
  pausedAt
  lastDynamicRefreshAt
  createTs
  updateTs
  enrollmentCounts {
    ...CampaignEnrollmentCountsFields
  }
  stepStats {
    ...CampaignStepStatsFields
  }
  dailySendLimit
}
    ${CampaignStepFieldsFragmentDoc}
${CampaignEnrollmentCountsFieldsFragmentDoc}
${CampaignStepStatsFieldsFragmentDoc}`;
export const ClipFieldsFragmentDoc = gql`
    fragment ClipFields on ClipType {
  __typename
  id
  engagementId
  name
  startSec
  endSec
  status
  statusError
  clipVideoUrl
  shareSlug
  createdAt
  transcript {
    speaker
    text
    start
    end
  }
}
    `;
export const ContactChangeSuggestionFieldsFragmentDoc = gql`
    fragment ContactChangeSuggestionFields on ContactChangeSuggestionType {
  id
  kind
  status
  contactId
  snapshot
  availableModes
  acceptMode
  actedByUserId
  actedByName
  actedTs
  resolvedContactId
  dismissedByViewer
  createTs
}
    `;
export const ContactEngagementsFragmentDoc = gql`
    fragment ContactEngagements on Contact {
  lastEmail {
    id
    displayName
    startTime
  }
  lastEngagement {
    id
    displayName
    startTime
    engagementType
  }
  nextEngagement {
    id
    displayName
    startTime
    engagementType
  }
}
    `;
export const CrmIngestionFieldsFragmentDoc = gql`
    fragment CrmIngestionFields on CrmIngestionField {
  __typename
  id
  workspaceId
  platform
  objectType
  sourceExternalId
  isStandardField
  crmLabel
  crmName
  sourceName
  crmFieldType
  sourceFieldType
  isEnumeration
  enumerationData
  availableInGrid
  availableInRevgpt
  syncBack
  syncBackDestinationName
  customFieldType
  syncForward
  fieldConfig
}
    `;
export const CrmIngestionAvailableFieldsFragmentDoc = gql`
    fragment CrmIngestionAvailableFields on CrmIngestionAvailableField {
  platform
  objectType
  label
  name
  description
  isCalculated
  isEnumeration
  enumerationOptions
  enumerationChoices {
    value
    label
  }
  isMultiSelect
  fieldType
}
    `;
export const DailyLeadFieldsFragmentDoc = gql`
    fragment DailyLeadFields on DailyLead {
  id
  workspaceId
  userId
  date
  rank
  personEmail
  personName
  personTitle
  personLinkedin
  companyName
  companyDomain
  reason
  rankScore
  leadScoreSnapshot
  source
  status
  convertedContactExtId
  createdAt
  updatedAt
}
    `;
export const DealStageFieldsFragmentDoc = gql`
    fragment DealStageFields on DealStage {
  __typename
  id
  workspaceId
  externalId
  name
  i18nKey
  color
  colorCode
  won
  lost
  order
  probability
  createTs
  deleted
  pipelineId
  pipeline {
    id
    workspaceId
    name
  }
}
    `;
export const PipelineFieldsFragmentDoc = gql`
    fragment PipelineFields on Pipeline {
  __typename
  id
  workspaceId
  name
  i18nKey
  fromExternalSource
  createTs
  updateTs
  deleted
}
    `;
export const ContactBaseFieldsFragmentDoc = gql`
    fragment ContactBaseFields on Contact {
  __typename
  id
  primaryEmail
  profileImageUrl
  properties {
    firstName
    lastName
    jobTitle
    linkedinProfileUrl
    profileImageUrl
  }
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  __typename
  id
  workspaceId
  properties {
    name
    productCode
    description
    unitPrice
    isActive
  }
}
    `;
export const LineItemFieldsFragmentDoc = gql`
    fragment LineItemFields on LineItem {
  __typename
  id
  workspaceId
  dealId
  productId
  properties {
    name
    quantity
    listPrice
    unitPrice
    totalPrice
    discountPercent
    productCode
  }
  product {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;
export const DealRelationsFragmentDoc = gql`
    fragment DealRelations on Deal {
  accounts {
    edges {
      node {
        ...AccountBaseFields
      }
    }
  }
  contacts {
    edges {
      node {
        ...ContactBaseFields
      }
    }
  }
  dealInfo {
    id
    dealId
    fields {
      fieldName
      displayName
      description
      bullets
    }
    createdAt
    updatedAt
  }
  lastEmail {
    id
    displayName
    startTime
  }
  lastActivityEngagement {
    id
    displayName
    startTime
    engagementType
    participantUserIds
    userId
  }
  nextStepEngagements {
    id
    displayName
    startTime
    engagementType
    participantUserIds
    userId
  }
  lineItems {
    ...LineItemFields
  }
}
    ${AccountBaseFieldsFragmentDoc}
${ContactBaseFieldsFragmentDoc}
${LineItemFieldsFragmentDoc}`;
export const DealPropertiesFieldsFragmentDoc = gql`
    fragment DealPropertiesFields on DealProperties {
  name
  description
  amount
  closeDate
  createDate
  stage
  type
  priority
  probability
  NextStep
  LastActivityDate
  note
  highlight
  statusColor
  forecastCategory
  nextActivityText
  lastActivityText
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  __typename
  id
  givenName
  preferredName
  surname
  email
  profileImageUrl
  lastLogin
  isOnboarded
  isSuperuser
  avatarBackground
  defaultSummaryTemplateId
  defaultBriefTemplateId
  emailSignature
}
    `;
export const DealSnapshotFieldsFragmentDoc = gql`
    fragment DealSnapshotFields on DealSnapshot {
  id
  dealId
  ownerId
  asOfTs
  customProperties
  properties {
    ...DealPropertiesFields
  }
  owner {
    ...UserFields
  }
  contacts {
    edges {
      node {
        ...ContactBaseFields
      }
    }
  }
}
    ${DealPropertiesFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${ContactBaseFieldsFragmentDoc}`;
export const EngagementContactsFragmentDoc = gql`
    fragment EngagementContacts on Engagement {
  contacts {
    __typename
    id
    primaryEmail
    profileImageUrl
    properties {
      firstName
      lastName
      jobTitle
      linkedinProfileUrl
      city
      state
    }
    accounts {
      edges {
        node {
          ...AccountBaseFields
        }
      }
    }
  }
}
    ${AccountBaseFieldsFragmentDoc}`;
export const EngagementTranscriptFragmentDoc = gql`
    fragment EngagementTranscript on Engagement {
  recallTranscript {
    speaker
    words {
      text
      startTimestamp
      endTimestamp
    }
    speakerId
    language
  }
  gongTranscript {
    speaker
    words {
      text
      startTimestamp
      endTimestamp
    }
    speakerId
    language
  }
  granolaTranscript {
    speaker
    words {
      text
      startTimestamp
      endTimestamp
    }
    speakerId
    language
  }
  firefliesTranscript {
    speaker
    words {
      text
      startTimestamp
      endTimestamp
    }
    speakerId
    language
  }
}
    `;
export const EngagementSummariesFragmentDoc = gql`
    fragment EngagementSummaries on Engagement {
  summaries {
    id
    summary
    summaryTemplateId
  }
}
    `;
export const EngagementTaskSuggestionsFragmentDoc = gql`
    fragment EngagementTaskSuggestions on Engagement {
  taskSuggestions {
    id
    title
    description
    priority
    suggestedDueDate
    confidenceScore
    sourceQuote
    isAccepted
    isDismissed
    createdAt
    suggestedContacts {
      ...ContactBaseFields
    }
    suggestedAccounts {
      ...AccountBaseFields
    }
  }
}
    ${ContactBaseFieldsFragmentDoc}
${AccountBaseFieldsFragmentDoc}`;
export const EngagementDealSuggestionsFragmentDoc = gql`
    fragment EngagementDealSuggestions on Engagement {
  dealSuggestions {
    id
    dealName
    description
    estimatedAmount
    estimatedCloseDate
    suggestedStageId
    confidenceScore
    sourceQuote
    isAccepted
    isDismissed
    suggestedOwner {
      id
    }
    suggestedAccount {
      id
    }
    suggestedContacts {
      id
    }
  }
}
    `;
export const EngagementAiFragmentDoc = gql`
    fragment EngagementAI on Engagement {
  aiSummary
  aiFollowup
  aiBrief
}
    `;
export const FileFieldsFragmentDoc = gql`
    fragment FileFields on File {
  __typename
  id
  workspaceId
  userId
  filename
  mimeType
  size
  fileUrl
  uploadedAt
  createdAt
  updatedAt
  source
}
    `;
export const AccountFieldsFragmentDoc = gql`
    fragment AccountFields on Account {
  __typename
  id
  workspaceId
  domain
  location
  customProperties
  lastEmailTime
  lastEmailId
  properties {
    name
    email
    ownerId
    city
    country
    industry
    phone
    aboutUs
    numberOfEmployees
    state
    timeZone
    foundedYear
    annualRevenue
    description
    linkedinUrl
    raisedAmount
    techTags
    logoUrl
    postalCode
    entityType
    entitySubtype
    continent
    companySizeCategory
    revenueRange
    revenueMin
    revenueMax
    employeeCount
    employeeCountMin
    employeeCountMax
    crmTech
    marketingAutomationTech
    abmTech
    salesAutomationTech
    analyticsTech
    cmsTech
    martechCategories
    conversationIntelligenceTech
    cloudProviderTech
    emailHostingTech
    emailSecurityTech
    applicationSecurityTech
    cloudSecurityTech
    developmentTech
    eCommercePlatformTech
    note
    highlight
    additionalDomains
    avatarBackground
    nextActivityText
    lastActivityText
  }
  asOfTs
}
    `;
export const ContactFieldsFragmentDoc = gql`
    fragment ContactFields on Contact {
  __typename
  id
  externalId
  primaryEmail
  profileImageUrl
  customProperties
  lastEmailTime
  lastEmailId
  properties {
    firstName
    lastName
    jobTitle
    phone
    city
    state
    country
    linkedinProfileUrl
    note
    highlight
    additionalEmails
    avatarBackground
    nextActivityText
    lastActivityText
    ownerId
    profileImageUrl
  }
  asOfTs
}
    `;
export const DealFieldsFragmentDoc = gql`
    fragment DealFields on Deal {
  __typename
  id
  workspaceId
  asOfTs
  propertiesJson
  customProperties
  inStageSince
  lastEmailTime
  lastEmailId
  properties {
    ...DealPropertiesFields
  }
  owner {
    ...UserFields
  }
  additionalOwners {
    ...UserFields
  }
}
    ${DealPropertiesFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;
export const BaseEngagementFieldsFragmentDoc = gql`
    fragment BaseEngagementFields on Engagement {
  id
  workspaceId
  deleted
  status
  privacy
  displayName
  description
  startTime
  endTime
  link
  platform
  source
  recallVideoUrl
  coffeeVideoUrl
  gongVideoUrl
  granolaVideoUrl
  firefliesVideoUrl
  engagementType
  hasActiveBot
  recordingEnabled
  recordingRecorderType
  recordingOwnerUserId
  currentUserRecordingEnabled
  userId
  isInternal
  participantAccountIds
  participantContactIds
  participantUserIds
  associatedDealIds
  hasTranscript
  hasAiSummary
  hasAiFollowup
  hasAiBrief
  metadataFrom
  transcriptStatusMessage
  transcriptIncomplete
  currentUserStatus
  userStatus
}
    `;
export const EngagementFieldsFragmentDoc = gql`
    fragment EngagementFields on Engagement {
  ...BaseEngagementFields
  body
  bodyHtml
  attachments {
    id
    name
    type
    url
  }
  aiSummary
  aiFollowup
  aiBrief
  accounts {
    id
    workspaceId
    domain
  }
  metadata
}
    ${BaseEngagementFieldsFragmentDoc}`;
export const EngagementRelationsFragmentDoc = gql`
    fragment EngagementRelations on Engagement {
  accounts {
    ...AccountBaseFields
  }
  contacts {
    ...ContactBaseFields
    accounts {
      edges {
        node {
          ...AccountBaseFields
        }
      }
    }
  }
  users {
    id
    givenName
    preferredName
    surname
    email
    profileImageUrl
    lastLogin
  }
}
    ${AccountBaseFieldsFragmentDoc}
${ContactBaseFieldsFragmentDoc}`;
export const FileRelationsFragmentDoc = gql`
    fragment FileRelations on File {
  user {
    ...UserFields
  }
  accounts {
    ...AccountFields
  }
  contacts {
    ...ContactFields
  }
  deals {
    ...DealFields
  }
  engagements {
    ...EngagementFields
    ...EngagementRelations
  }
}
    ${UserFieldsFragmentDoc}
${AccountFieldsFragmentDoc}
${ContactFieldsFragmentDoc}
${DealFieldsFragmentDoc}
${EngagementFieldsFragmentDoc}
${EngagementRelationsFragmentDoc}`;
export const IndustryFieldsFragmentDoc = gql`
    fragment IndustryFields on Industry {
  __typename
  label
}
    `;
export const IntegrationFieldsFragmentDoc = gql`
    fragment IntegrationFields on Integration {
  __typename
  workspaceId
  platform
  category
  addedTs
  status
  disconnectReason
}
    `;
export const UserIntegrationFieldsFragmentDoc = gql`
    fragment UserIntegrationFields on UserIntegration {
  __typename
  platform
  addedTs
  status
  disconnectReason
  lookbackDays
  webhookUrl
  webhookSecret
  keepCoffeeRecording
}
    `;
export const IntegrationWithTokenFieldsFragmentDoc = gql`
    fragment IntegrationWithTokenFields on IntegrationWithToken {
  __typename
  workspaceId
  platform
  category
  addedTs
  status
  accessToken
}
    `;
export const IngestionRunFieldsFragmentDoc = gql`
    fragment IngestionRunFields on CrmIngestionRun {
  __typename
  platform
  workspaceId
  status
  asOfTs
  runId
  properties {
    lastStep
    lastStepTs
    startTs
    endTs
  }
  stats {
    numNewDeals
    numNewAccounts
    numNewContacts
    numUpdatedDeals
    numUpdatedAccounts
    numUpdatedContacts
  }
}
    `;
export const JobTitleFieldsFragmentDoc = gql`
    fragment JobTitleFields on JobTitle {
  __typename
  label
}
    `;
export const ListFolderFieldsFragmentDoc = gql`
    fragment ListFolderFields on ListFolder {
  __typename
  id
  name
  public
  ownerId
  workspaceId
  modelType
}
    `;
export const ListFieldsFragmentDoc = gql`
    fragment ListFields on List {
  __typename
  id
  name
  properties
  public
  modelType
  deleted
  ownerId
  createTs
  updateTs
  workspaceId
  static
}
    `;
export const NoteFieldsFragmentDoc = gql`
    fragment NoteFields on Note {
  __typename
  id
  workspaceId
  userId
  privacy
  createdAt
  updatedAt
  title
  aiGenerated
  type
  status
  priority
  dueDate
}
    `;
export const NoteRelationsFragmentDoc = gql`
    fragment NoteRelations on Note {
  user {
    ...UserFields
  }
  accounts {
    ...AccountBaseFields
  }
  contacts {
    ...ContactBaseFields
  }
  deals {
    __typename
    id
    properties {
      name
    }
  }
  engagements {
    __typename
    id
    displayName
    engagementType
  }
}
    ${UserFieldsFragmentDoc}
${AccountBaseFieldsFragmentDoc}
${ContactBaseFieldsFragmentDoc}`;
export const NotificationFieldsFragmentDoc = gql`
    fragment NotificationFields on NotificationType {
  __typename
  id
  type
  params
  target
  fallbackTitle
  fallbackBody
  readTs
  createTs
}
    `;
export const PostalCodesFieldsFragmentDoc = gql`
    fragment PostalCodesFields on PostalCode {
  __typename
  label
}
    `;
export const ReportDefinitionFieldsFragmentDoc = gql`
    fragment ReportDefinitionFields on ReportDefinition {
  id
  workspaceId
  ownerUserId
  name
  description
  visibility
  definition
  templateKey
  schedule
  status
  legacy
  createTs
  updateTs
}
    `;
export const ReportRunFieldsFragmentDoc = gql`
    fragment ReportRunFields on ReportRun {
  id
  reportId
  workspaceId
  requestedBy
  triggerSource
  status
  definitionSnapshot
  blockResults
  narrative
  error
  creditsCharged
  startedAt
  finishedAt
  createTs
}
    `;
export const AutomationRuleFieldsFragmentDoc = gql`
    fragment AutomationRuleFields on AutomationRule {
  __typename
  id
  workspaceId
  ownerUserId
  name
  status
  objectType
  trigger
  conditions
  actions
  nextRunAt
  createTs
  updateTs
}
    `;
export const UserGroupFieldsFragmentDoc = gql`
    fragment UserGroupFields on UserGroupType {
  __typename
  id
  name
  description
  memberUserIds
  systemKey
  createTs
  updateTs
}
    `;
export const BaseSummaryTemplateFieldsFragmentDoc = gql`
    fragment BaseSummaryTemplateFields on SummaryTemplateClass {
  id
  workspaceId
  name
  isWorkspaceWide
  createdByUserId
  createdAt
  deleted
  isDefault
}
    `;
export const TemplateSectionFieldsFragmentDoc = gql`
    fragment TemplateSectionFields on TemplateSection {
  heading
  prompt
  order
  crmField
}
    `;
export const SummaryTemplateFieldsFragmentDoc = gql`
    fragment SummaryTemplateFields on SummaryTemplateClass {
  ...BaseSummaryTemplateFields
  sections {
    ...TemplateSectionFields
  }
}
    ${BaseSummaryTemplateFieldsFragmentDoc}
${TemplateSectionFieldsFragmentDoc}`;
export const SummaryTemplateWithRelationsFragmentDoc = gql`
    fragment SummaryTemplateWithRelations on SummaryTemplateClass {
  ...SummaryTemplateFields
  createdByUser {
    id
    givenName
    preferredName
    surname
    email
    profileImageUrl
  }
}
    ${SummaryTemplateFieldsFragmentDoc}`;
export const TechTagsFieldsFragmentDoc = gql`
    fragment TechTagsFields on TechTag {
  __typename
  label
}
    `;
export const UserBaseFieldsFragmentDoc = gql`
    fragment UserBaseFields on User {
  __typename
  id
  givenName
  preferredName
  surname
  email
  profileImageUrl
  avatarBackground
}
    `;
export const WorkspaceFieldsFragmentDoc = gql`
    fragment WorkspaceFields on Workspace {
  __typename
  id
  name
  domain
  handle
  logoUrl
  companyName
  currentApp
  isMember
  onboarding {
    hasCustomizedWorkspace
    hasConnectedCrm
    hasInvitedUsers
  }
  subscription {
    __typename
    id
    provider
    externalId
    status
    pricingTier
    planId
    billingCycle
    amountInCents
    currency
    seats
    freeTrialStart
    freeTrialEnd
    currentPeriodStart
    currentPeriodEnd
    createdAt
    updatedAt
    entitlements {
      __typename
      maxUsers
      readOnlyUsers
      inviteUsers
      aiGeneratedFieldUpdates
      reports
      deals
      pipelineIntelligence
      crmIntegrations
      mcpAccess
      apiAccess
      slackIntegration
      slackDm
      slackChannel
      integrationLimit
    }
    trialDaysRemaining
  }
}
    `;
export const CurrentUserFieldsFragmentDoc = gql`
    fragment CurrentUserFields on User {
  isOnboarded
  workspaces {
    ...WorkspaceFields
  }
  oauthPlatform
}
    ${WorkspaceFieldsFragmentDoc}`;
export const WorkspaceConnectionFieldsFragmentDoc = gql`
    fragment WorkspaceConnectionFields on WorkspaceConnectionType {
  __typename
  id
  provider
  label
  serverUrl
  auth
  status
  disconnectReason
  lastSyncAt
  lastError
  domains
  domainLabels
  entities
  domainsConfirmed
  reconfirmReason
  discoveredTools
  domainMap
  entityMap
}
    `;
export const WorkspaceDomainFieldsFragmentDoc = gql`
    fragment WorkspaceDomainFields on WorkspaceDomain {
  __typename
  domain
  isPrimary
  verified
}
    `;
export const GetAccountsDocument = gql`
    query getAccounts($first: Int, $after: String, $filter: AccountFilter, $sort: [SortInput]) {
  accounts(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        ...AccountFields
        ...AccountEngagements
        owner {
          ...UserBaseFields
        }
        ...AssociatedAccounts
        ...AccountAssociations
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${AccountFieldsFragmentDoc}
${AccountEngagementsFragmentDoc}
${UserBaseFieldsFragmentDoc}
${AssociatedAccountsFragmentDoc}
${AccountAssociationsFragmentDoc}`;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
// @ts-ignore
export function useGetAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAccountsQuery | undefined, GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAccountsSuspenseQuery>;
export type GetAccountsQueryResult = ApolloReactCommon.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export const GetAccountDocument = gql`
    query getAccount($id: ID!, $filter: AccountFilter) {
  account(id: $id, filter: $filter) {
    ...AccountFields
    properties {
      aiSummary
    }
    ...AccountEngagements
    owner {
      ...UserFields
    }
    deals {
      edges {
        node {
          ...DealFields
          contacts {
            edges {
              node {
                ...ContactBaseFields
              }
            }
          }
        }
      }
    }
    contacts {
      ...ContactBaseFields
    }
    ...AssociatedAccounts
    ...AccountAssociations
    userLists {
      edges {
        node {
          list {
            ...ListFields
          }
        }
      }
    }
  }
}
    ${AccountFieldsFragmentDoc}
${AccountEngagementsFragmentDoc}
${UserFieldsFragmentDoc}
${DealFieldsFragmentDoc}
${ContactBaseFieldsFragmentDoc}
${AssociatedAccountsFragmentDoc}
${AccountAssociationsFragmentDoc}
${ListFieldsFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables> & ({ variables: GetAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
// @ts-ignore
export function useGetAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAccountQuery, GetAccountQueryVariables>;
export function useGetAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAccountQuery | undefined, GetAccountQueryVariables>;
export function useGetAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountSuspenseQuery>;
export type GetAccountQueryResult = ApolloReactCommon.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const CreateAccountDocument = gql`
    mutation createAccount($input: CreateAccountInput!) {
  createAccount(input: $input) {
    account {
      ...AccountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type CreateAccountMutationFn = ApolloReactCommon.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = ApolloReactCommon.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($input: UpdateAccountInput!) {
  updateAccount(input: $input) {
    account {
      ...AccountFields
      ...AccountEngagements
      deals {
        edges {
          node {
            ...DealFields
            contacts {
              edges {
                node {
                  ...ContactBaseFields
                }
              }
            }
          }
        }
      }
      contacts {
        ...ContactBaseFields
      }
      ...AssociatedAccounts
    }
  }
}
    ${AccountFieldsFragmentDoc}
${AccountEngagementsFragmentDoc}
${DealFieldsFragmentDoc}
${ContactBaseFieldsFragmentDoc}
${AssociatedAccountsFragmentDoc}`;
export type UpdateAccountMutationFn = ApolloReactCommon.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = ApolloReactCommon.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($id: ID!) {
  deleteAccount(id: $id) {
    success
  }
}
    `;
export type DeleteAccountMutationFn = ApolloReactCommon.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = ApolloReactCommon.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const MergeAccountsDocument = gql`
    mutation mergeAccounts($args: MergeAccountsInput!) {
  mergeAccounts(args: $args) {
    success
    primaryAccount {
      ...AccountFields
      ...AccountEngagements
      deals {
        edges {
          node {
            ...DealFields
            contacts {
              edges {
                node {
                  ...ContactBaseFields
                }
              }
            }
          }
        }
      }
      contacts {
        ...ContactBaseFields
      }
      ...AssociatedAccounts
    }
  }
}
    ${AccountFieldsFragmentDoc}
${AccountEngagementsFragmentDoc}
${DealFieldsFragmentDoc}
${ContactBaseFieldsFragmentDoc}
${AssociatedAccountsFragmentDoc}`;
export type MergeAccountsMutationFn = ApolloReactCommon.MutationFunction<MergeAccountsMutation, MergeAccountsMutationVariables>;

/**
 * __useMergeAccountsMutation__
 *
 * To run a mutation, you first call `useMergeAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeAccountsMutation, { data, loading, error }] = useMergeAccountsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useMergeAccountsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergeAccountsMutation, MergeAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeAccountsMutation, MergeAccountsMutationVariables>(MergeAccountsDocument, options);
      }
export type MergeAccountsMutationHookResult = ReturnType<typeof useMergeAccountsMutation>;
export type MergeAccountsMutationResult = ApolloReactCommon.MutationResult<MergeAccountsMutation>;
export type MergeAccountsMutationOptions = ApolloReactCommon.BaseMutationOptions<MergeAccountsMutation, MergeAccountsMutationVariables>;
export const SetEntityAssociationDocument = gql`
    mutation setEntityAssociation($workspaceId: ID!, $input: SetAssociationInput!) {
  setEntityAssociation(workspaceId: $workspaceId, input: $input) {
    association {
      label
      toId
      toAccount {
        ...AccountBaseFields
      }
    }
  }
}
    ${AccountBaseFieldsFragmentDoc}`;
export type SetEntityAssociationMutationFn = ApolloReactCommon.MutationFunction<SetEntityAssociationMutation, SetEntityAssociationMutationVariables>;

/**
 * __useSetEntityAssociationMutation__
 *
 * To run a mutation, you first call `useSetEntityAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEntityAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEntityAssociationMutation, { data, loading, error }] = useSetEntityAssociationMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEntityAssociationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEntityAssociationMutation, SetEntityAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetEntityAssociationMutation, SetEntityAssociationMutationVariables>(SetEntityAssociationDocument, options);
      }
export type SetEntityAssociationMutationHookResult = ReturnType<typeof useSetEntityAssociationMutation>;
export type SetEntityAssociationMutationResult = ApolloReactCommon.MutationResult<SetEntityAssociationMutation>;
export type SetEntityAssociationMutationOptions = ApolloReactCommon.BaseMutationOptions<SetEntityAssociationMutation, SetEntityAssociationMutationVariables>;
export const RemoveEntityAssociationDocument = gql`
    mutation removeEntityAssociation($workspaceId: ID!, $fromId: String!, $toId: String!, $label: String!, $fromType: String, $toType: String) {
  removeEntityAssociation(
    workspaceId: $workspaceId
    fromId: $fromId
    toId: $toId
    label: $label
    fromType: $fromType
    toType: $toType
  ) {
    ok
  }
}
    `;
export type RemoveEntityAssociationMutationFn = ApolloReactCommon.MutationFunction<RemoveEntityAssociationMutation, RemoveEntityAssociationMutationVariables>;

/**
 * __useRemoveEntityAssociationMutation__
 *
 * To run a mutation, you first call `useRemoveEntityAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEntityAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEntityAssociationMutation, { data, loading, error }] = useRemoveEntityAssociationMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      fromId: // value for 'fromId'
 *      toId: // value for 'toId'
 *      label: // value for 'label'
 *      fromType: // value for 'fromType'
 *      toType: // value for 'toType'
 *   },
 * });
 */
export function useRemoveEntityAssociationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveEntityAssociationMutation, RemoveEntityAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveEntityAssociationMutation, RemoveEntityAssociationMutationVariables>(RemoveEntityAssociationDocument, options);
      }
export type RemoveEntityAssociationMutationHookResult = ReturnType<typeof useRemoveEntityAssociationMutation>;
export type RemoveEntityAssociationMutationResult = ApolloReactCommon.MutationResult<RemoveEntityAssociationMutation>;
export type RemoveEntityAssociationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveEntityAssociationMutation, RemoveEntityAssociationMutationVariables>;
export const GetAgentTemplatesDocument = gql`
    query getAgentTemplates($workspaceId: Int!) {
  agentTemplates(workspaceId: $workspaceId) {
    ...AgentTemplateFields
  }
}
    ${AgentTemplateFieldsFragmentDoc}`;

/**
 * __useGetAgentTemplatesQuery__
 *
 * To run a query within a React component, call `useGetAgentTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentTemplatesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetAgentTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAgentTemplatesQuery, GetAgentTemplatesQueryVariables> & ({ variables: GetAgentTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentTemplatesQuery, GetAgentTemplatesQueryVariables>(GetAgentTemplatesDocument, options);
      }
export function useGetAgentTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAgentTemplatesQuery, GetAgentTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentTemplatesQuery, GetAgentTemplatesQueryVariables>(GetAgentTemplatesDocument, options);
        }
// @ts-ignore
export function useGetAgentTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAgentTemplatesQuery, GetAgentTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAgentTemplatesQuery, GetAgentTemplatesQueryVariables>;
export function useGetAgentTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAgentTemplatesQuery, GetAgentTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAgentTemplatesQuery | undefined, GetAgentTemplatesQueryVariables>;
export function useGetAgentTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAgentTemplatesQuery, GetAgentTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAgentTemplatesQuery, GetAgentTemplatesQueryVariables>(GetAgentTemplatesDocument, options);
        }
export type GetAgentTemplatesQueryHookResult = ReturnType<typeof useGetAgentTemplatesQuery>;
export type GetAgentTemplatesLazyQueryHookResult = ReturnType<typeof useGetAgentTemplatesLazyQuery>;
export type GetAgentTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetAgentTemplatesSuspenseQuery>;
export type GetAgentTemplatesQueryResult = ApolloReactCommon.QueryResult<GetAgentTemplatesQuery, GetAgentTemplatesQueryVariables>;
export const GetAgentDefinitionsDocument = gql`
    query getAgentDefinitions($workspaceId: Int!) {
  agentDefinitions(workspaceId: $workspaceId) {
    ...AgentDefinitionFields
  }
}
    ${AgentDefinitionFieldsFragmentDoc}`;

/**
 * __useGetAgentDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetAgentDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentDefinitionsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetAgentDefinitionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAgentDefinitionsQuery, GetAgentDefinitionsQueryVariables> & ({ variables: GetAgentDefinitionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentDefinitionsQuery, GetAgentDefinitionsQueryVariables>(GetAgentDefinitionsDocument, options);
      }
export function useGetAgentDefinitionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAgentDefinitionsQuery, GetAgentDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentDefinitionsQuery, GetAgentDefinitionsQueryVariables>(GetAgentDefinitionsDocument, options);
        }
// @ts-ignore
export function useGetAgentDefinitionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAgentDefinitionsQuery, GetAgentDefinitionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAgentDefinitionsQuery, GetAgentDefinitionsQueryVariables>;
export function useGetAgentDefinitionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAgentDefinitionsQuery, GetAgentDefinitionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAgentDefinitionsQuery | undefined, GetAgentDefinitionsQueryVariables>;
export function useGetAgentDefinitionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAgentDefinitionsQuery, GetAgentDefinitionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAgentDefinitionsQuery, GetAgentDefinitionsQueryVariables>(GetAgentDefinitionsDocument, options);
        }
export type GetAgentDefinitionsQueryHookResult = ReturnType<typeof useGetAgentDefinitionsQuery>;
export type GetAgentDefinitionsLazyQueryHookResult = ReturnType<typeof useGetAgentDefinitionsLazyQuery>;
export type GetAgentDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetAgentDefinitionsSuspenseQuery>;
export type GetAgentDefinitionsQueryResult = ApolloReactCommon.QueryResult<GetAgentDefinitionsQuery, GetAgentDefinitionsQueryVariables>;
export const GetAgentDefinitionDocument = gql`
    query getAgentDefinition($workspaceId: Int!, $id: ID!) {
  agentDefinition(workspaceId: $workspaceId, id: $id) {
    ...AgentDefinitionFields
  }
}
    ${AgentDefinitionFieldsFragmentDoc}`;

/**
 * __useGetAgentDefinitionQuery__
 *
 * To run a query within a React component, call `useGetAgentDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentDefinitionQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentDefinitionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAgentDefinitionQuery, GetAgentDefinitionQueryVariables> & ({ variables: GetAgentDefinitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentDefinitionQuery, GetAgentDefinitionQueryVariables>(GetAgentDefinitionDocument, options);
      }
export function useGetAgentDefinitionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAgentDefinitionQuery, GetAgentDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentDefinitionQuery, GetAgentDefinitionQueryVariables>(GetAgentDefinitionDocument, options);
        }
// @ts-ignore
export function useGetAgentDefinitionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAgentDefinitionQuery, GetAgentDefinitionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAgentDefinitionQuery, GetAgentDefinitionQueryVariables>;
export function useGetAgentDefinitionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAgentDefinitionQuery, GetAgentDefinitionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAgentDefinitionQuery | undefined, GetAgentDefinitionQueryVariables>;
export function useGetAgentDefinitionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAgentDefinitionQuery, GetAgentDefinitionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAgentDefinitionQuery, GetAgentDefinitionQueryVariables>(GetAgentDefinitionDocument, options);
        }
export type GetAgentDefinitionQueryHookResult = ReturnType<typeof useGetAgentDefinitionQuery>;
export type GetAgentDefinitionLazyQueryHookResult = ReturnType<typeof useGetAgentDefinitionLazyQuery>;
export type GetAgentDefinitionSuspenseQueryHookResult = ReturnType<typeof useGetAgentDefinitionSuspenseQuery>;
export type GetAgentDefinitionQueryResult = ApolloReactCommon.QueryResult<GetAgentDefinitionQuery, GetAgentDefinitionQueryVariables>;
export const CreateAgentDefinitionDocument = gql`
    mutation createAgentDefinition($input: CreateAgentDefinitionInput!) {
  createAgentDefinition(input: $input) {
    agent {
      ...AgentDefinitionFields
    }
  }
}
    ${AgentDefinitionFieldsFragmentDoc}`;
export type CreateAgentDefinitionMutationFn = ApolloReactCommon.MutationFunction<CreateAgentDefinitionMutation, CreateAgentDefinitionMutationVariables>;

/**
 * __useCreateAgentDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateAgentDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentDefinitionMutation, { data, loading, error }] = useCreateAgentDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentDefinitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAgentDefinitionMutation, CreateAgentDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAgentDefinitionMutation, CreateAgentDefinitionMutationVariables>(CreateAgentDefinitionDocument, options);
      }
export type CreateAgentDefinitionMutationHookResult = ReturnType<typeof useCreateAgentDefinitionMutation>;
export type CreateAgentDefinitionMutationResult = ApolloReactCommon.MutationResult<CreateAgentDefinitionMutation>;
export type CreateAgentDefinitionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAgentDefinitionMutation, CreateAgentDefinitionMutationVariables>;
export const UpdateAgentDefinitionDocument = gql`
    mutation updateAgentDefinition($input: UpdateAgentDefinitionInput!) {
  updateAgentDefinition(input: $input) {
    agent {
      ...AgentDefinitionFields
    }
  }
}
    ${AgentDefinitionFieldsFragmentDoc}`;
export type UpdateAgentDefinitionMutationFn = ApolloReactCommon.MutationFunction<UpdateAgentDefinitionMutation, UpdateAgentDefinitionMutationVariables>;

/**
 * __useUpdateAgentDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateAgentDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentDefinitionMutation, { data, loading, error }] = useUpdateAgentDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgentDefinitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAgentDefinitionMutation, UpdateAgentDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgentDefinitionMutation, UpdateAgentDefinitionMutationVariables>(UpdateAgentDefinitionDocument, options);
      }
export type UpdateAgentDefinitionMutationHookResult = ReturnType<typeof useUpdateAgentDefinitionMutation>;
export type UpdateAgentDefinitionMutationResult = ApolloReactCommon.MutationResult<UpdateAgentDefinitionMutation>;
export type UpdateAgentDefinitionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAgentDefinitionMutation, UpdateAgentDefinitionMutationVariables>;
export const DeleteAgentDefinitionDocument = gql`
    mutation deleteAgentDefinition($workspaceId: Int!, $id: ID!) {
  deleteAgentDefinition(workspaceId: $workspaceId, id: $id) {
    ok
  }
}
    `;
export type DeleteAgentDefinitionMutationFn = ApolloReactCommon.MutationFunction<DeleteAgentDefinitionMutation, DeleteAgentDefinitionMutationVariables>;

/**
 * __useDeleteAgentDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteAgentDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentDefinitionMutation, { data, loading, error }] = useDeleteAgentDefinitionMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAgentDefinitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAgentDefinitionMutation, DeleteAgentDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAgentDefinitionMutation, DeleteAgentDefinitionMutationVariables>(DeleteAgentDefinitionDocument, options);
      }
export type DeleteAgentDefinitionMutationHookResult = ReturnType<typeof useDeleteAgentDefinitionMutation>;
export type DeleteAgentDefinitionMutationResult = ApolloReactCommon.MutationResult<DeleteAgentDefinitionMutation>;
export type DeleteAgentDefinitionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAgentDefinitionMutation, DeleteAgentDefinitionMutationVariables>;
export const EnableAgentTemplateDocument = gql`
    mutation enableAgentTemplate($workspaceId: Int!, $templateName: String!) {
  enableAgentTemplate(workspaceId: $workspaceId, templateName: $templateName) {
    agent {
      ...AgentDefinitionFields
    }
  }
}
    ${AgentDefinitionFieldsFragmentDoc}`;
export type EnableAgentTemplateMutationFn = ApolloReactCommon.MutationFunction<EnableAgentTemplateMutation, EnableAgentTemplateMutationVariables>;

/**
 * __useEnableAgentTemplateMutation__
 *
 * To run a mutation, you first call `useEnableAgentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAgentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAgentTemplateMutation, { data, loading, error }] = useEnableAgentTemplateMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      templateName: // value for 'templateName'
 *   },
 * });
 */
export function useEnableAgentTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableAgentTemplateMutation, EnableAgentTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableAgentTemplateMutation, EnableAgentTemplateMutationVariables>(EnableAgentTemplateDocument, options);
      }
export type EnableAgentTemplateMutationHookResult = ReturnType<typeof useEnableAgentTemplateMutation>;
export type EnableAgentTemplateMutationResult = ApolloReactCommon.MutationResult<EnableAgentTemplateMutation>;
export type EnableAgentTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<EnableAgentTemplateMutation, EnableAgentTemplateMutationVariables>;
export const SetAgentEnabledDocument = gql`
    mutation setAgentEnabled($workspaceId: Int!, $id: ID!, $enabled: Boolean!) {
  setAgentEnabled(workspaceId: $workspaceId, id: $id, enabled: $enabled) {
    agent {
      ...AgentDefinitionFields
    }
  }
}
    ${AgentDefinitionFieldsFragmentDoc}`;
export type SetAgentEnabledMutationFn = ApolloReactCommon.MutationFunction<SetAgentEnabledMutation, SetAgentEnabledMutationVariables>;

/**
 * __useSetAgentEnabledMutation__
 *
 * To run a mutation, you first call `useSetAgentEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAgentEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAgentEnabledMutation, { data, loading, error }] = useSetAgentEnabledMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetAgentEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAgentEnabledMutation, SetAgentEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetAgentEnabledMutation, SetAgentEnabledMutationVariables>(SetAgentEnabledDocument, options);
      }
export type SetAgentEnabledMutationHookResult = ReturnType<typeof useSetAgentEnabledMutation>;
export type SetAgentEnabledMutationResult = ApolloReactCommon.MutationResult<SetAgentEnabledMutation>;
export type SetAgentEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<SetAgentEnabledMutation, SetAgentEnabledMutationVariables>;
export const TestAgentDefinitionDocument = gql`
    mutation testAgentDefinition($input: TestAgentDefinitionInput!) {
  testAgentDefinition(input: $input) {
    result {
      feasible
      reason
      outcome
      recordsRead {
        tool
        count
      }
      truncated
      notifyTarget
      notifyTargetLabel
      deliverySinks
      toolsCalled
      allowedTools
      output
      stopReason
      iterations
      validationError
      objectType
      repeat
      anchorField
      daysBefore
      sampleEntityId
      pathPattern
      usageDescription
      campaignDescription
      scope
      intendedEffects {
        tool
        args
      }
    }
  }
}
    `;
export type TestAgentDefinitionMutationFn = ApolloReactCommon.MutationFunction<TestAgentDefinitionMutation, TestAgentDefinitionMutationVariables>;

/**
 * __useTestAgentDefinitionMutation__
 *
 * To run a mutation, you first call `useTestAgentDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestAgentDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testAgentDefinitionMutation, { data, loading, error }] = useTestAgentDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestAgentDefinitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestAgentDefinitionMutation, TestAgentDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestAgentDefinitionMutation, TestAgentDefinitionMutationVariables>(TestAgentDefinitionDocument, options);
      }
export type TestAgentDefinitionMutationHookResult = ReturnType<typeof useTestAgentDefinitionMutation>;
export type TestAgentDefinitionMutationResult = ApolloReactCommon.MutationResult<TestAgentDefinitionMutation>;
export type TestAgentDefinitionMutationOptions = ApolloReactCommon.BaseMutationOptions<TestAgentDefinitionMutation, TestAgentDefinitionMutationVariables>;
export const AgentPreviewProgressDocument = gql`
    query agentPreviewProgress($workspaceId: Int!, $previewId: String!) {
  agentPreviewProgress(workspaceId: $workspaceId, previewId: $previewId) {
    phase
    label
    iteration
    toolsUsed
  }
}
    `;

/**
 * __useAgentPreviewProgressQuery__
 *
 * To run a query within a React component, call `useAgentPreviewProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentPreviewProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentPreviewProgressQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useAgentPreviewProgressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AgentPreviewProgressQuery, AgentPreviewProgressQueryVariables> & ({ variables: AgentPreviewProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgentPreviewProgressQuery, AgentPreviewProgressQueryVariables>(AgentPreviewProgressDocument, options);
      }
export function useAgentPreviewProgressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgentPreviewProgressQuery, AgentPreviewProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgentPreviewProgressQuery, AgentPreviewProgressQueryVariables>(AgentPreviewProgressDocument, options);
        }
// @ts-ignore
export function useAgentPreviewProgressSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AgentPreviewProgressQuery, AgentPreviewProgressQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgentPreviewProgressQuery, AgentPreviewProgressQueryVariables>;
export function useAgentPreviewProgressSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgentPreviewProgressQuery, AgentPreviewProgressQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgentPreviewProgressQuery | undefined, AgentPreviewProgressQueryVariables>;
export function useAgentPreviewProgressSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgentPreviewProgressQuery, AgentPreviewProgressQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AgentPreviewProgressQuery, AgentPreviewProgressQueryVariables>(AgentPreviewProgressDocument, options);
        }
export type AgentPreviewProgressQueryHookResult = ReturnType<typeof useAgentPreviewProgressQuery>;
export type AgentPreviewProgressLazyQueryHookResult = ReturnType<typeof useAgentPreviewProgressLazyQuery>;
export type AgentPreviewProgressSuspenseQueryHookResult = ReturnType<typeof useAgentPreviewProgressSuspenseQuery>;
export type AgentPreviewProgressQueryResult = ApolloReactCommon.QueryResult<AgentPreviewProgressQuery, AgentPreviewProgressQueryVariables>;
export const GetAiChatConversationsDocument = gql`
    query GetAiChatConversations($workspaceId: ID!, $search: String, $limit: Int) {
  aiChatConversations(workspaceId: $workspaceId, search: $search, limit: $limit) {
    id
    agentSessionId
    contextType
    contextId
    firstMessage
    updateTs
    createTs
  }
}
    `;

/**
 * __useGetAiChatConversationsQuery__
 *
 * To run a query within a React component, call `useGetAiChatConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiChatConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiChatConversationsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAiChatConversationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAiChatConversationsQuery, GetAiChatConversationsQueryVariables> & ({ variables: GetAiChatConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAiChatConversationsQuery, GetAiChatConversationsQueryVariables>(GetAiChatConversationsDocument, options);
      }
export function useGetAiChatConversationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAiChatConversationsQuery, GetAiChatConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAiChatConversationsQuery, GetAiChatConversationsQueryVariables>(GetAiChatConversationsDocument, options);
        }
// @ts-ignore
export function useGetAiChatConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAiChatConversationsQuery, GetAiChatConversationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAiChatConversationsQuery, GetAiChatConversationsQueryVariables>;
export function useGetAiChatConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAiChatConversationsQuery, GetAiChatConversationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAiChatConversationsQuery | undefined, GetAiChatConversationsQueryVariables>;
export function useGetAiChatConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAiChatConversationsQuery, GetAiChatConversationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAiChatConversationsQuery, GetAiChatConversationsQueryVariables>(GetAiChatConversationsDocument, options);
        }
export type GetAiChatConversationsQueryHookResult = ReturnType<typeof useGetAiChatConversationsQuery>;
export type GetAiChatConversationsLazyQueryHookResult = ReturnType<typeof useGetAiChatConversationsLazyQuery>;
export type GetAiChatConversationsSuspenseQueryHookResult = ReturnType<typeof useGetAiChatConversationsSuspenseQuery>;
export type GetAiChatConversationsQueryResult = ApolloReactCommon.QueryResult<GetAiChatConversationsQuery, GetAiChatConversationsQueryVariables>;
export const GetAiChatMessagesDocument = gql`
    query GetAiChatMessages($conversationId: Int!) {
  aiChatMessages(conversationId: $conversationId) {
    id
    role
    content
    createTs
    vote
    feedbackComment
  }
}
    `;

/**
 * __useGetAiChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetAiChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiChatMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetAiChatMessagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAiChatMessagesQuery, GetAiChatMessagesQueryVariables> & ({ variables: GetAiChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAiChatMessagesQuery, GetAiChatMessagesQueryVariables>(GetAiChatMessagesDocument, options);
      }
export function useGetAiChatMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAiChatMessagesQuery, GetAiChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAiChatMessagesQuery, GetAiChatMessagesQueryVariables>(GetAiChatMessagesDocument, options);
        }
// @ts-ignore
export function useGetAiChatMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAiChatMessagesQuery, GetAiChatMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAiChatMessagesQuery, GetAiChatMessagesQueryVariables>;
export function useGetAiChatMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAiChatMessagesQuery, GetAiChatMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAiChatMessagesQuery | undefined, GetAiChatMessagesQueryVariables>;
export function useGetAiChatMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAiChatMessagesQuery, GetAiChatMessagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAiChatMessagesQuery, GetAiChatMessagesQueryVariables>(GetAiChatMessagesDocument, options);
        }
export type GetAiChatMessagesQueryHookResult = ReturnType<typeof useGetAiChatMessagesQuery>;
export type GetAiChatMessagesLazyQueryHookResult = ReturnType<typeof useGetAiChatMessagesLazyQuery>;
export type GetAiChatMessagesSuspenseQueryHookResult = ReturnType<typeof useGetAiChatMessagesSuspenseQuery>;
export type GetAiChatMessagesQueryResult = ApolloReactCommon.QueryResult<GetAiChatMessagesQuery, GetAiChatMessagesQueryVariables>;
export const AddAiChatMessageFeedbackDocument = gql`
    mutation AddAiChatMessageFeedback($input: AddAiChatMessageFeedbackInput!) {
  addAiChatMessageFeedback(input: $input) {
    ok
  }
}
    `;
export type AddAiChatMessageFeedbackMutationFn = ApolloReactCommon.MutationFunction<AddAiChatMessageFeedbackMutation, AddAiChatMessageFeedbackMutationVariables>;

/**
 * __useAddAiChatMessageFeedbackMutation__
 *
 * To run a mutation, you first call `useAddAiChatMessageFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAiChatMessageFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAiChatMessageFeedbackMutation, { data, loading, error }] = useAddAiChatMessageFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAiChatMessageFeedbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAiChatMessageFeedbackMutation, AddAiChatMessageFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddAiChatMessageFeedbackMutation, AddAiChatMessageFeedbackMutationVariables>(AddAiChatMessageFeedbackDocument, options);
      }
export type AddAiChatMessageFeedbackMutationHookResult = ReturnType<typeof useAddAiChatMessageFeedbackMutation>;
export type AddAiChatMessageFeedbackMutationResult = ApolloReactCommon.MutationResult<AddAiChatMessageFeedbackMutation>;
export type AddAiChatMessageFeedbackMutationOptions = ApolloReactCommon.BaseMutationOptions<AddAiChatMessageFeedbackMutation, AddAiChatMessageFeedbackMutationVariables>;
export const PreviewAiFieldDocument = gql`
    query previewAiField($workspaceId: Int!, $fieldId: Int, $objectType: String, $aiPromptText: String, $aiOutputInstructionText: String, $aiModelProvider: String, $aiModelName: String, $listId: Int, $entityIds: [String], $filter: JSONString) {
  previewAiField(
    workspaceId: $workspaceId
    fieldId: $fieldId
    objectType: $objectType
    aiPromptText: $aiPromptText
    aiOutputInstructionText: $aiOutputInstructionText
    aiModelProvider: $aiModelProvider
    aiModelName: $aiModelName
    listId: $listId
    entityIds: $entityIds
    filter: $filter
  ) {
    previewResults {
      entityId
      entityName
      generatedValue
      error
    }
    totalEntitiesFound
  }
}
    `;

/**
 * __usePreviewAiFieldQuery__
 *
 * To run a query within a React component, call `usePreviewAiFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewAiFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewAiFieldQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      fieldId: // value for 'fieldId'
 *      objectType: // value for 'objectType'
 *      aiPromptText: // value for 'aiPromptText'
 *      aiOutputInstructionText: // value for 'aiOutputInstructionText'
 *      aiModelProvider: // value for 'aiModelProvider'
 *      aiModelName: // value for 'aiModelName'
 *      listId: // value for 'listId'
 *      entityIds: // value for 'entityIds'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePreviewAiFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PreviewAiFieldQuery, PreviewAiFieldQueryVariables> & ({ variables: PreviewAiFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PreviewAiFieldQuery, PreviewAiFieldQueryVariables>(PreviewAiFieldDocument, options);
      }
export function usePreviewAiFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PreviewAiFieldQuery, PreviewAiFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PreviewAiFieldQuery, PreviewAiFieldQueryVariables>(PreviewAiFieldDocument, options);
        }
// @ts-ignore
export function usePreviewAiFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PreviewAiFieldQuery, PreviewAiFieldQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PreviewAiFieldQuery, PreviewAiFieldQueryVariables>;
export function usePreviewAiFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PreviewAiFieldQuery, PreviewAiFieldQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PreviewAiFieldQuery | undefined, PreviewAiFieldQueryVariables>;
export function usePreviewAiFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PreviewAiFieldQuery, PreviewAiFieldQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PreviewAiFieldQuery, PreviewAiFieldQueryVariables>(PreviewAiFieldDocument, options);
        }
export type PreviewAiFieldQueryHookResult = ReturnType<typeof usePreviewAiFieldQuery>;
export type PreviewAiFieldLazyQueryHookResult = ReturnType<typeof usePreviewAiFieldLazyQuery>;
export type PreviewAiFieldSuspenseQueryHookResult = ReturnType<typeof usePreviewAiFieldSuspenseQuery>;
export type PreviewAiFieldQueryResult = ApolloReactCommon.QueryResult<PreviewAiFieldQuery, PreviewAiFieldQueryVariables>;
export const RunAiCustomFieldDocument = gql`
    mutation runAiCustomField($workspaceId: Int!, $fieldId: Int!, $listId: Int, $entityIds: [String], $rowLimit: Int, $filter: JSONString, $objectType: String) {
  runAiCustomField(
    workspaceId: $workspaceId
    fieldId: $fieldId
    listId: $listId
    entityIds: $entityIds
    rowLimit: $rowLimit
    filter: $filter
    objectType: $objectType
  ) {
    execution {
      id
      workspaceId
      userId
      fieldId
      listId
      status
      totalRecords
      processedRecords
      failedRecords
      progressPercentage
      temporalWorkflowId
      createdAt
    }
  }
}
    `;
export type RunAiCustomFieldMutationFn = ApolloReactCommon.MutationFunction<RunAiCustomFieldMutation, RunAiCustomFieldMutationVariables>;

/**
 * __useRunAiCustomFieldMutation__
 *
 * To run a mutation, you first call `useRunAiCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAiCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiCustomFieldMutation, { data, loading, error }] = useRunAiCustomFieldMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      fieldId: // value for 'fieldId'
 *      listId: // value for 'listId'
 *      entityIds: // value for 'entityIds'
 *      rowLimit: // value for 'rowLimit'
 *      filter: // value for 'filter'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useRunAiCustomFieldMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RunAiCustomFieldMutation, RunAiCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RunAiCustomFieldMutation, RunAiCustomFieldMutationVariables>(RunAiCustomFieldDocument, options);
      }
export type RunAiCustomFieldMutationHookResult = ReturnType<typeof useRunAiCustomFieldMutation>;
export type RunAiCustomFieldMutationResult = ApolloReactCommon.MutationResult<RunAiCustomFieldMutation>;
export type RunAiCustomFieldMutationOptions = ApolloReactCommon.BaseMutationOptions<RunAiCustomFieldMutation, RunAiCustomFieldMutationVariables>;
export const GetAiJobExecutionDocument = gql`
    query getAiJobExecution($executionId: String!) {
  aiJobExecution(executionId: $executionId) {
    id
    workspaceId
    userId
    fieldId
    listId
    status
    totalRecords
    processedRecords
    failedRecords
    progressPercentage
    temporalWorkflowId
    createdAt
  }
}
    `;

/**
 * __useGetAiJobExecutionQuery__
 *
 * To run a query within a React component, call `useGetAiJobExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiJobExecutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiJobExecutionQuery({
 *   variables: {
 *      executionId: // value for 'executionId'
 *   },
 * });
 */
export function useGetAiJobExecutionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAiJobExecutionQuery, GetAiJobExecutionQueryVariables> & ({ variables: GetAiJobExecutionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAiJobExecutionQuery, GetAiJobExecutionQueryVariables>(GetAiJobExecutionDocument, options);
      }
export function useGetAiJobExecutionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAiJobExecutionQuery, GetAiJobExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAiJobExecutionQuery, GetAiJobExecutionQueryVariables>(GetAiJobExecutionDocument, options);
        }
// @ts-ignore
export function useGetAiJobExecutionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAiJobExecutionQuery, GetAiJobExecutionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAiJobExecutionQuery, GetAiJobExecutionQueryVariables>;
export function useGetAiJobExecutionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAiJobExecutionQuery, GetAiJobExecutionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAiJobExecutionQuery | undefined, GetAiJobExecutionQueryVariables>;
export function useGetAiJobExecutionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAiJobExecutionQuery, GetAiJobExecutionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAiJobExecutionQuery, GetAiJobExecutionQueryVariables>(GetAiJobExecutionDocument, options);
        }
export type GetAiJobExecutionQueryHookResult = ReturnType<typeof useGetAiJobExecutionQuery>;
export type GetAiJobExecutionLazyQueryHookResult = ReturnType<typeof useGetAiJobExecutionLazyQuery>;
export type GetAiJobExecutionSuspenseQueryHookResult = ReturnType<typeof useGetAiJobExecutionSuspenseQuery>;
export type GetAiJobExecutionQueryResult = ApolloReactCommon.QueryResult<GetAiJobExecutionQuery, GetAiJobExecutionQueryVariables>;
export const ActiveAiExecutionsDocument = gql`
    query activeAiExecutions($workspaceId: Int!, $listId: Int, $fieldId: Int) {
  activeAiExecutions(
    workspaceId: $workspaceId
    listId: $listId
    fieldId: $fieldId
  ) {
    id
    workspaceId
    userId
    fieldId
    listId
    status
    totalRecords
    processedRecords
    failedRecords
    progressPercentage
    temporalWorkflowId
    createdAt
  }
}
    `;

/**
 * __useActiveAiExecutionsQuery__
 *
 * To run a query within a React component, call `useActiveAiExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAiExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveAiExecutionsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      listId: // value for 'listId'
 *      fieldId: // value for 'fieldId'
 *   },
 * });
 */
export function useActiveAiExecutionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ActiveAiExecutionsQuery, ActiveAiExecutionsQueryVariables> & ({ variables: ActiveAiExecutionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveAiExecutionsQuery, ActiveAiExecutionsQueryVariables>(ActiveAiExecutionsDocument, options);
      }
export function useActiveAiExecutionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveAiExecutionsQuery, ActiveAiExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveAiExecutionsQuery, ActiveAiExecutionsQueryVariables>(ActiveAiExecutionsDocument, options);
        }
// @ts-ignore
export function useActiveAiExecutionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActiveAiExecutionsQuery, ActiveAiExecutionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActiveAiExecutionsQuery, ActiveAiExecutionsQueryVariables>;
export function useActiveAiExecutionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActiveAiExecutionsQuery, ActiveAiExecutionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActiveAiExecutionsQuery | undefined, ActiveAiExecutionsQueryVariables>;
export function useActiveAiExecutionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActiveAiExecutionsQuery, ActiveAiExecutionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActiveAiExecutionsQuery, ActiveAiExecutionsQueryVariables>(ActiveAiExecutionsDocument, options);
        }
export type ActiveAiExecutionsQueryHookResult = ReturnType<typeof useActiveAiExecutionsQuery>;
export type ActiveAiExecutionsLazyQueryHookResult = ReturnType<typeof useActiveAiExecutionsLazyQuery>;
export type ActiveAiExecutionsSuspenseQueryHookResult = ReturnType<typeof useActiveAiExecutionsSuspenseQuery>;
export type ActiveAiExecutionsQueryResult = ApolloReactCommon.QueryResult<ActiveAiExecutionsQuery, ActiveAiExecutionsQueryVariables>;
export const CreateBadDataReportDocument = gql`
    mutation createBadDataReport($input: CreateBadDataReportInput!) {
  createBadDataReport(input: $input) {
    ok
  }
}
    `;
export type CreateBadDataReportMutationFn = ApolloReactCommon.MutationFunction<CreateBadDataReportMutation, CreateBadDataReportMutationVariables>;

/**
 * __useCreateBadDataReportMutation__
 *
 * To run a mutation, you first call `useCreateBadDataReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBadDataReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBadDataReportMutation, { data, loading, error }] = useCreateBadDataReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBadDataReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBadDataReportMutation, CreateBadDataReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBadDataReportMutation, CreateBadDataReportMutationVariables>(CreateBadDataReportDocument, options);
      }
export type CreateBadDataReportMutationHookResult = ReturnType<typeof useCreateBadDataReportMutation>;
export type CreateBadDataReportMutationResult = ApolloReactCommon.MutationResult<CreateBadDataReportMutation>;
export type CreateBadDataReportMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBadDataReportMutation, CreateBadDataReportMutationVariables>;
export const CheckPaymentStatusDocument = gql`
    query CheckPaymentStatus($workspaceId: Int!) {
  paymentMethodStatus(workspaceId: $workspaceId) {
    hasValidCard
  }
}
    `;

/**
 * __useCheckPaymentStatusQuery__
 *
 * To run a query within a React component, call `useCheckPaymentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPaymentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPaymentStatusQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCheckPaymentStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckPaymentStatusQuery, CheckPaymentStatusQueryVariables> & ({ variables: CheckPaymentStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckPaymentStatusQuery, CheckPaymentStatusQueryVariables>(CheckPaymentStatusDocument, options);
      }
export function useCheckPaymentStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckPaymentStatusQuery, CheckPaymentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckPaymentStatusQuery, CheckPaymentStatusQueryVariables>(CheckPaymentStatusDocument, options);
        }
// @ts-ignore
export function useCheckPaymentStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CheckPaymentStatusQuery, CheckPaymentStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckPaymentStatusQuery, CheckPaymentStatusQueryVariables>;
export function useCheckPaymentStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckPaymentStatusQuery, CheckPaymentStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckPaymentStatusQuery | undefined, CheckPaymentStatusQueryVariables>;
export function useCheckPaymentStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckPaymentStatusQuery, CheckPaymentStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckPaymentStatusQuery, CheckPaymentStatusQueryVariables>(CheckPaymentStatusDocument, options);
        }
export type CheckPaymentStatusQueryHookResult = ReturnType<typeof useCheckPaymentStatusQuery>;
export type CheckPaymentStatusLazyQueryHookResult = ReturnType<typeof useCheckPaymentStatusLazyQuery>;
export type CheckPaymentStatusSuspenseQueryHookResult = ReturnType<typeof useCheckPaymentStatusSuspenseQuery>;
export type CheckPaymentStatusQueryResult = ApolloReactCommon.QueryResult<CheckPaymentStatusQuery, CheckPaymentStatusQueryVariables>;
export const GetExchangeRateDocument = gql`
    query GetExchangeRate {
  creditExchangeRate {
    creditsToUsdRate
    companyRate
    personRate
    aiFieldRate
  }
}
    `;

/**
 * __useGetExchangeRateQuery__
 *
 * To run a query within a React component, call `useGetExchangeRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeRateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExchangeRateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExchangeRateQuery, GetExchangeRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExchangeRateQuery, GetExchangeRateQueryVariables>(GetExchangeRateDocument, options);
      }
export function useGetExchangeRateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExchangeRateQuery, GetExchangeRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExchangeRateQuery, GetExchangeRateQueryVariables>(GetExchangeRateDocument, options);
        }
// @ts-ignore
export function useGetExchangeRateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetExchangeRateQuery, GetExchangeRateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetExchangeRateQuery, GetExchangeRateQueryVariables>;
export function useGetExchangeRateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetExchangeRateQuery, GetExchangeRateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetExchangeRateQuery | undefined, GetExchangeRateQueryVariables>;
export function useGetExchangeRateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetExchangeRateQuery, GetExchangeRateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetExchangeRateQuery, GetExchangeRateQueryVariables>(GetExchangeRateDocument, options);
        }
export type GetExchangeRateQueryHookResult = ReturnType<typeof useGetExchangeRateQuery>;
export type GetExchangeRateLazyQueryHookResult = ReturnType<typeof useGetExchangeRateLazyQuery>;
export type GetExchangeRateSuspenseQueryHookResult = ReturnType<typeof useGetExchangeRateSuspenseQuery>;
export type GetExchangeRateQueryResult = ApolloReactCommon.QueryResult<GetExchangeRateQuery, GetExchangeRateQueryVariables>;
export const GetCreditUsageSummaryDocument = gql`
    query GetCreditUsageSummary($workspaceId: Int!) {
  creditUsageSummary(workspaceId: $workspaceId) {
    totalCreditsUsed
    totalCreditsLimit
    billingPeriodStart
    billingPeriodEnd
    seats
    subscriptionCreditsLimit
    purchasedCreditsRemaining
    creditSources {
      id
      kind
      label
      totalCredits
      usedCredits
      remainingCredits
      expiresAt
      purchasedAt
    }
    perAgent {
      agentName
      sourceFeature
      creditsUsed
      actionType
      creditCost
      enabled
    }
  }
}
    `;

/**
 * __useGetCreditUsageSummaryQuery__
 *
 * To run a query within a React component, call `useGetCreditUsageSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditUsageSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditUsageSummaryQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetCreditUsageSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCreditUsageSummaryQuery, GetCreditUsageSummaryQueryVariables> & ({ variables: GetCreditUsageSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditUsageSummaryQuery, GetCreditUsageSummaryQueryVariables>(GetCreditUsageSummaryDocument, options);
      }
export function useGetCreditUsageSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditUsageSummaryQuery, GetCreditUsageSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditUsageSummaryQuery, GetCreditUsageSummaryQueryVariables>(GetCreditUsageSummaryDocument, options);
        }
// @ts-ignore
export function useGetCreditUsageSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCreditUsageSummaryQuery, GetCreditUsageSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCreditUsageSummaryQuery, GetCreditUsageSummaryQueryVariables>;
export function useGetCreditUsageSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditUsageSummaryQuery, GetCreditUsageSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCreditUsageSummaryQuery | undefined, GetCreditUsageSummaryQueryVariables>;
export function useGetCreditUsageSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditUsageSummaryQuery, GetCreditUsageSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditUsageSummaryQuery, GetCreditUsageSummaryQueryVariables>(GetCreditUsageSummaryDocument, options);
        }
export type GetCreditUsageSummaryQueryHookResult = ReturnType<typeof useGetCreditUsageSummaryQuery>;
export type GetCreditUsageSummaryLazyQueryHookResult = ReturnType<typeof useGetCreditUsageSummaryLazyQuery>;
export type GetCreditUsageSummarySuspenseQueryHookResult = ReturnType<typeof useGetCreditUsageSummarySuspenseQuery>;
export type GetCreditUsageSummaryQueryResult = ApolloReactCommon.QueryResult<GetCreditUsageSummaryQuery, GetCreditUsageSummaryQueryVariables>;
export const GetWorkspaceBriefTemplatesDocument = gql`
    query getWorkspaceBriefTemplates($workspaceId: ID!) {
  briefTemplates(filter: {workspaceId: $workspaceId, isWorkspaceWide: true}) {
    edges {
      node {
        ...BriefTemplateFields
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  systemBriefSections {
    heading
    prompt
    order
  }
}
    ${BriefTemplateFieldsFragmentDoc}`;

/**
 * __useGetWorkspaceBriefTemplatesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceBriefTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceBriefTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceBriefTemplatesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceBriefTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkspaceBriefTemplatesQuery, GetWorkspaceBriefTemplatesQueryVariables> & ({ variables: GetWorkspaceBriefTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkspaceBriefTemplatesQuery, GetWorkspaceBriefTemplatesQueryVariables>(GetWorkspaceBriefTemplatesDocument, options);
      }
export function useGetWorkspaceBriefTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkspaceBriefTemplatesQuery, GetWorkspaceBriefTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkspaceBriefTemplatesQuery, GetWorkspaceBriefTemplatesQueryVariables>(GetWorkspaceBriefTemplatesDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceBriefTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceBriefTemplatesQuery, GetWorkspaceBriefTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspaceBriefTemplatesQuery, GetWorkspaceBriefTemplatesQueryVariables>;
export function useGetWorkspaceBriefTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceBriefTemplatesQuery, GetWorkspaceBriefTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspaceBriefTemplatesQuery | undefined, GetWorkspaceBriefTemplatesQueryVariables>;
export function useGetWorkspaceBriefTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceBriefTemplatesQuery, GetWorkspaceBriefTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkspaceBriefTemplatesQuery, GetWorkspaceBriefTemplatesQueryVariables>(GetWorkspaceBriefTemplatesDocument, options);
        }
export type GetWorkspaceBriefTemplatesQueryHookResult = ReturnType<typeof useGetWorkspaceBriefTemplatesQuery>;
export type GetWorkspaceBriefTemplatesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceBriefTemplatesLazyQuery>;
export type GetWorkspaceBriefTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceBriefTemplatesSuspenseQuery>;
export type GetWorkspaceBriefTemplatesQueryResult = ApolloReactCommon.QueryResult<GetWorkspaceBriefTemplatesQuery, GetWorkspaceBriefTemplatesQueryVariables>;
export const CreateBriefTemplateDocument = gql`
    mutation CreateBriefTemplate($input: CreateBriefTemplateInput!) {
  createBriefTemplate(input: $input) {
    briefTemplate {
      ...BriefTemplateFields
    }
  }
}
    ${BriefTemplateFieldsFragmentDoc}`;
export type CreateBriefTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateBriefTemplateMutation, CreateBriefTemplateMutationVariables>;

/**
 * __useCreateBriefTemplateMutation__
 *
 * To run a mutation, you first call `useCreateBriefTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBriefTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBriefTemplateMutation, { data, loading, error }] = useCreateBriefTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBriefTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBriefTemplateMutation, CreateBriefTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBriefTemplateMutation, CreateBriefTemplateMutationVariables>(CreateBriefTemplateDocument, options);
      }
export type CreateBriefTemplateMutationHookResult = ReturnType<typeof useCreateBriefTemplateMutation>;
export type CreateBriefTemplateMutationResult = ApolloReactCommon.MutationResult<CreateBriefTemplateMutation>;
export type CreateBriefTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBriefTemplateMutation, CreateBriefTemplateMutationVariables>;
export const UpdateBriefTemplateDocument = gql`
    mutation UpdateBriefTemplate($input: UpdateBriefTemplateInput!) {
  updateBriefTemplate(input: $input) {
    briefTemplate {
      ...BriefTemplateFields
    }
  }
}
    ${BriefTemplateFieldsFragmentDoc}`;
export type UpdateBriefTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateBriefTemplateMutation, UpdateBriefTemplateMutationVariables>;

/**
 * __useUpdateBriefTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateBriefTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBriefTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBriefTemplateMutation, { data, loading, error }] = useUpdateBriefTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBriefTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBriefTemplateMutation, UpdateBriefTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBriefTemplateMutation, UpdateBriefTemplateMutationVariables>(UpdateBriefTemplateDocument, options);
      }
export type UpdateBriefTemplateMutationHookResult = ReturnType<typeof useUpdateBriefTemplateMutation>;
export type UpdateBriefTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateBriefTemplateMutation>;
export type UpdateBriefTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBriefTemplateMutation, UpdateBriefTemplateMutationVariables>;
export const DeleteBriefTemplateDocument = gql`
    mutation DeleteBriefTemplate($input: DeleteBriefTemplateInput!) {
  deleteBriefTemplate(input: $input) {
    success
  }
}
    `;
export type DeleteBriefTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteBriefTemplateMutation, DeleteBriefTemplateMutationVariables>;

/**
 * __useDeleteBriefTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteBriefTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBriefTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBriefTemplateMutation, { data, loading, error }] = useDeleteBriefTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBriefTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBriefTemplateMutation, DeleteBriefTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBriefTemplateMutation, DeleteBriefTemplateMutationVariables>(DeleteBriefTemplateDocument, options);
      }
export type DeleteBriefTemplateMutationHookResult = ReturnType<typeof useDeleteBriefTemplateMutation>;
export type DeleteBriefTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteBriefTemplateMutation>;
export type DeleteBriefTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBriefTemplateMutation, DeleteBriefTemplateMutationVariables>;
export const GenerateBriefDocument = gql`
    mutation GenerateBrief($input: GenerateBriefInput!) {
  generateBrief(input: $input) {
    brief {
      id
      engagementId
      briefTemplateId
      brief
      createdAt
      updatedAt
    }
  }
}
    `;
export type GenerateBriefMutationFn = ApolloReactCommon.MutationFunction<GenerateBriefMutation, GenerateBriefMutationVariables>;

/**
 * __useGenerateBriefMutation__
 *
 * To run a mutation, you first call `useGenerateBriefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBriefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBriefMutation, { data, loading, error }] = useGenerateBriefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateBriefMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateBriefMutation, GenerateBriefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateBriefMutation, GenerateBriefMutationVariables>(GenerateBriefDocument, options);
      }
export type GenerateBriefMutationHookResult = ReturnType<typeof useGenerateBriefMutation>;
export type GenerateBriefMutationResult = ApolloReactCommon.MutationResult<GenerateBriefMutation>;
export type GenerateBriefMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateBriefMutation, GenerateBriefMutationVariables>;
export const GetCampaignsDocument = gql`
    query getCampaigns($workspaceId: Int!) {
  campaigns(workspaceId: $workspaceId) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;

/**
 * __useGetCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetCampaignsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables> & ({ variables: GetCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
      }
export function useGetCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
// @ts-ignore
export function useGetCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCampaignsQuery, GetCampaignsQueryVariables>;
export function useGetCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCampaignsQuery | undefined, GetCampaignsQueryVariables>;
export function useGetCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
export type GetCampaignsQueryHookResult = ReturnType<typeof useGetCampaignsQuery>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignsSuspenseQuery>;
export type GetCampaignsQueryResult = ApolloReactCommon.QueryResult<GetCampaignsQuery, GetCampaignsQueryVariables>;
export const GetCampaignDocument = gql`
    query getCampaign($id: ID!, $workspaceId: Int!) {
  campaign(id: $id, workspaceId: $workspaceId) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;

/**
 * __useGetCampaignQuery__
 *
 * To run a query within a React component, call `useGetCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetCampaignQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables> & ({ variables: GetCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
      }
export function useGetCampaignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
        }
// @ts-ignore
export function useGetCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCampaignQuery, GetCampaignQueryVariables>;
export function useGetCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCampaignQuery | undefined, GetCampaignQueryVariables>;
export function useGetCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
        }
export type GetCampaignQueryHookResult = ReturnType<typeof useGetCampaignQuery>;
export type GetCampaignLazyQueryHookResult = ReturnType<typeof useGetCampaignLazyQuery>;
export type GetCampaignSuspenseQueryHookResult = ReturnType<typeof useGetCampaignSuspenseQuery>;
export type GetCampaignQueryResult = ApolloReactCommon.QueryResult<GetCampaignQuery, GetCampaignQueryVariables>;
export const GetCampaignStepRecipientsDocument = gql`
    query getCampaignStepRecipients($id: ID!, $workspaceId: Int!, $stepOrder: Int!, $status: String!) {
  campaignStepRecipients(
    id: $id
    workspaceId: $workspaceId
    stepOrder: $stepOrder
    status: $status
  ) {
    ...CampaignRecipientFields
  }
}
    ${CampaignRecipientFieldsFragmentDoc}`;

/**
 * __useGetCampaignStepRecipientsQuery__
 *
 * To run a query within a React component, call `useGetCampaignStepRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignStepRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignStepRecipientsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *      stepOrder: // value for 'stepOrder'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetCampaignStepRecipientsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCampaignStepRecipientsQuery, GetCampaignStepRecipientsQueryVariables> & ({ variables: GetCampaignStepRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCampaignStepRecipientsQuery, GetCampaignStepRecipientsQueryVariables>(GetCampaignStepRecipientsDocument, options);
      }
export function useGetCampaignStepRecipientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCampaignStepRecipientsQuery, GetCampaignStepRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCampaignStepRecipientsQuery, GetCampaignStepRecipientsQueryVariables>(GetCampaignStepRecipientsDocument, options);
        }
// @ts-ignore
export function useGetCampaignStepRecipientsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCampaignStepRecipientsQuery, GetCampaignStepRecipientsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCampaignStepRecipientsQuery, GetCampaignStepRecipientsQueryVariables>;
export function useGetCampaignStepRecipientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCampaignStepRecipientsQuery, GetCampaignStepRecipientsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCampaignStepRecipientsQuery | undefined, GetCampaignStepRecipientsQueryVariables>;
export function useGetCampaignStepRecipientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCampaignStepRecipientsQuery, GetCampaignStepRecipientsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCampaignStepRecipientsQuery, GetCampaignStepRecipientsQueryVariables>(GetCampaignStepRecipientsDocument, options);
        }
export type GetCampaignStepRecipientsQueryHookResult = ReturnType<typeof useGetCampaignStepRecipientsQuery>;
export type GetCampaignStepRecipientsLazyQueryHookResult = ReturnType<typeof useGetCampaignStepRecipientsLazyQuery>;
export type GetCampaignStepRecipientsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignStepRecipientsSuspenseQuery>;
export type GetCampaignStepRecipientsQueryResult = ApolloReactCommon.QueryResult<GetCampaignStepRecipientsQuery, GetCampaignStepRecipientsQueryVariables>;
export const CreateCampaignDocument = gql`
    mutation createCampaign($input: CreateCampaignInput!) {
  createCampaign(input: $input) {
    campaign {
      ...CampaignFields
    }
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type CreateCampaignMutationFn = ApolloReactCommon.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = ApolloReactCommon.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation updateCampaign($input: UpdateCampaignInput!) {
  updateCampaign(input: $input) {
    campaign {
      ...CampaignFields
    }
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type UpdateCampaignMutationFn = ApolloReactCommon.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = ApolloReactCommon.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const DeleteCampaignDocument = gql`
    mutation deleteCampaign($workspaceId: Int!, $id: ID!) {
  deleteCampaign(workspaceId: $workspaceId, id: $id) {
    ok
  }
}
    `;
export type DeleteCampaignMutationFn = ApolloReactCommon.MutationFunction<DeleteCampaignMutation, DeleteCampaignMutationVariables>;

/**
 * __useDeleteCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignMutation, { data, loading, error }] = useDeleteCampaignMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCampaignMutation, DeleteCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCampaignMutation, DeleteCampaignMutationVariables>(DeleteCampaignDocument, options);
      }
export type DeleteCampaignMutationHookResult = ReturnType<typeof useDeleteCampaignMutation>;
export type DeleteCampaignMutationResult = ApolloReactCommon.MutationResult<DeleteCampaignMutation>;
export type DeleteCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCampaignMutation, DeleteCampaignMutationVariables>;
export const StartCampaignDocument = gql`
    mutation startCampaign($workspaceId: Int!, $id: ID!) {
  startCampaign(workspaceId: $workspaceId, id: $id) {
    campaign {
      ...CampaignFields
    }
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type StartCampaignMutationFn = ApolloReactCommon.MutationFunction<StartCampaignMutation, StartCampaignMutationVariables>;

/**
 * __useStartCampaignMutation__
 *
 * To run a mutation, you first call `useStartCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCampaignMutation, { data, loading, error }] = useStartCampaignMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartCampaignMutation, StartCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartCampaignMutation, StartCampaignMutationVariables>(StartCampaignDocument, options);
      }
export type StartCampaignMutationHookResult = ReturnType<typeof useStartCampaignMutation>;
export type StartCampaignMutationResult = ApolloReactCommon.MutationResult<StartCampaignMutation>;
export type StartCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<StartCampaignMutation, StartCampaignMutationVariables>;
export const PauseCampaignDocument = gql`
    mutation pauseCampaign($workspaceId: Int!, $id: ID!) {
  pauseCampaign(workspaceId: $workspaceId, id: $id) {
    campaign {
      ...CampaignFields
    }
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type PauseCampaignMutationFn = ApolloReactCommon.MutationFunction<PauseCampaignMutation, PauseCampaignMutationVariables>;

/**
 * __usePauseCampaignMutation__
 *
 * To run a mutation, you first call `usePauseCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseCampaignMutation, { data, loading, error }] = usePauseCampaignMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePauseCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PauseCampaignMutation, PauseCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PauseCampaignMutation, PauseCampaignMutationVariables>(PauseCampaignDocument, options);
      }
export type PauseCampaignMutationHookResult = ReturnType<typeof usePauseCampaignMutation>;
export type PauseCampaignMutationResult = ApolloReactCommon.MutationResult<PauseCampaignMutation>;
export type PauseCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<PauseCampaignMutation, PauseCampaignMutationVariables>;
export const ResumeCampaignDocument = gql`
    mutation resumeCampaign($workspaceId: Int!, $id: ID!) {
  resumeCampaign(workspaceId: $workspaceId, id: $id) {
    campaign {
      ...CampaignFields
    }
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type ResumeCampaignMutationFn = ApolloReactCommon.MutationFunction<ResumeCampaignMutation, ResumeCampaignMutationVariables>;

/**
 * __useResumeCampaignMutation__
 *
 * To run a mutation, you first call `useResumeCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeCampaignMutation, { data, loading, error }] = useResumeCampaignMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResumeCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResumeCampaignMutation, ResumeCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResumeCampaignMutation, ResumeCampaignMutationVariables>(ResumeCampaignDocument, options);
      }
export type ResumeCampaignMutationHookResult = ReturnType<typeof useResumeCampaignMutation>;
export type ResumeCampaignMutationResult = ApolloReactCommon.MutationResult<ResumeCampaignMutation>;
export type ResumeCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<ResumeCampaignMutation, ResumeCampaignMutationVariables>;
export const GetClipsDocument = gql`
    query getClips($workspaceId: Int!, $engagementId: String!) {
  clips(workspaceId: $workspaceId, engagementId: $engagementId) {
    ...ClipFields
  }
}
    ${ClipFieldsFragmentDoc}`;

/**
 * __useGetClipsQuery__
 *
 * To run a query within a React component, call `useGetClipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClipsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useGetClipsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClipsQuery, GetClipsQueryVariables> & ({ variables: GetClipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClipsQuery, GetClipsQueryVariables>(GetClipsDocument, options);
      }
export function useGetClipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClipsQuery, GetClipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClipsQuery, GetClipsQueryVariables>(GetClipsDocument, options);
        }
// @ts-ignore
export function useGetClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetClipsQuery, GetClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetClipsQuery, GetClipsQueryVariables>;
export function useGetClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClipsQuery, GetClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetClipsQuery | undefined, GetClipsQueryVariables>;
export function useGetClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClipsQuery, GetClipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClipsQuery, GetClipsQueryVariables>(GetClipsDocument, options);
        }
export type GetClipsQueryHookResult = ReturnType<typeof useGetClipsQuery>;
export type GetClipsLazyQueryHookResult = ReturnType<typeof useGetClipsLazyQuery>;
export type GetClipsSuspenseQueryHookResult = ReturnType<typeof useGetClipsSuspenseQuery>;
export type GetClipsQueryResult = ApolloReactCommon.QueryResult<GetClipsQuery, GetClipsQueryVariables>;
export const GetClipDocument = gql`
    query getClip($workspaceId: Int!, $id: String!) {
  clip(workspaceId: $workspaceId, id: $id) {
    ...ClipFields
  }
}
    ${ClipFieldsFragmentDoc}`;

/**
 * __useGetClipQuery__
 *
 * To run a query within a React component, call `useGetClipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClipQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClipQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClipQuery, GetClipQueryVariables> & ({ variables: GetClipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClipQuery, GetClipQueryVariables>(GetClipDocument, options);
      }
export function useGetClipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClipQuery, GetClipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClipQuery, GetClipQueryVariables>(GetClipDocument, options);
        }
// @ts-ignore
export function useGetClipSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetClipQuery, GetClipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetClipQuery, GetClipQueryVariables>;
export function useGetClipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClipQuery, GetClipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetClipQuery | undefined, GetClipQueryVariables>;
export function useGetClipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClipQuery, GetClipQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClipQuery, GetClipQueryVariables>(GetClipDocument, options);
        }
export type GetClipQueryHookResult = ReturnType<typeof useGetClipQuery>;
export type GetClipLazyQueryHookResult = ReturnType<typeof useGetClipLazyQuery>;
export type GetClipSuspenseQueryHookResult = ReturnType<typeof useGetClipSuspenseQuery>;
export type GetClipQueryResult = ApolloReactCommon.QueryResult<GetClipQuery, GetClipQueryVariables>;
export const CreateClipDocument = gql`
    mutation createClip($workspaceId: Int!, $engagementId: String!, $startSec: Float!, $endSec: Float!, $name: String) {
  createClip(
    workspaceId: $workspaceId
    engagementId: $engagementId
    startSec: $startSec
    endSec: $endSec
    name: $name
  ) {
    ...ClipFields
  }
}
    ${ClipFieldsFragmentDoc}`;
export type CreateClipMutationFn = ApolloReactCommon.MutationFunction<CreateClipMutation, CreateClipMutationVariables>;

/**
 * __useCreateClipMutation__
 *
 * To run a mutation, you first call `useCreateClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClipMutation, { data, loading, error }] = useCreateClipMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      engagementId: // value for 'engagementId'
 *      startSec: // value for 'startSec'
 *      endSec: // value for 'endSec'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateClipMutation, CreateClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateClipMutation, CreateClipMutationVariables>(CreateClipDocument, options);
      }
export type CreateClipMutationHookResult = ReturnType<typeof useCreateClipMutation>;
export type CreateClipMutationResult = ApolloReactCommon.MutationResult<CreateClipMutation>;
export type CreateClipMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateClipMutation, CreateClipMutationVariables>;
export const UpdateClipDocument = gql`
    mutation updateClip($workspaceId: Int!, $id: String!, $name: String!) {
  updateClip(workspaceId: $workspaceId, id: $id, name: $name) {
    ...ClipFields
  }
}
    ${ClipFieldsFragmentDoc}`;
export type UpdateClipMutationFn = ApolloReactCommon.MutationFunction<UpdateClipMutation, UpdateClipMutationVariables>;

/**
 * __useUpdateClipMutation__
 *
 * To run a mutation, you first call `useUpdateClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClipMutation, { data, loading, error }] = useUpdateClipMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateClipMutation, UpdateClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateClipMutation, UpdateClipMutationVariables>(UpdateClipDocument, options);
      }
export type UpdateClipMutationHookResult = ReturnType<typeof useUpdateClipMutation>;
export type UpdateClipMutationResult = ApolloReactCommon.MutationResult<UpdateClipMutation>;
export type UpdateClipMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateClipMutation, UpdateClipMutationVariables>;
export const DeleteClipDocument = gql`
    mutation deleteClip($workspaceId: Int!, $id: String!) {
  deleteClip(workspaceId: $workspaceId, id: $id) {
    ok
  }
}
    `;
export type DeleteClipMutationFn = ApolloReactCommon.MutationFunction<DeleteClipMutation, DeleteClipMutationVariables>;

/**
 * __useDeleteClipMutation__
 *
 * To run a mutation, you first call `useDeleteClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClipMutation, { data, loading, error }] = useDeleteClipMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteClipMutation, DeleteClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteClipMutation, DeleteClipMutationVariables>(DeleteClipDocument, options);
      }
export type DeleteClipMutationHookResult = ReturnType<typeof useDeleteClipMutation>;
export type DeleteClipMutationResult = ApolloReactCommon.MutationResult<DeleteClipMutation>;
export type DeleteClipMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteClipMutation, DeleteClipMutationVariables>;
export const ClipShareDocument = gql`
    query clipShare($slug: String!) {
  clipShare(slug: $slug) {
    name
    status
    clipVideoUrl
    startSec
    endSec
    transcript {
      speaker
      text
      start
      end
    }
  }
}
    `;

/**
 * __useClipShareQuery__
 *
 * To run a query within a React component, call `useClipShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useClipShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClipShareQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useClipShareQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClipShareQuery, ClipShareQueryVariables> & ({ variables: ClipShareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClipShareQuery, ClipShareQueryVariables>(ClipShareDocument, options);
      }
export function useClipShareLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClipShareQuery, ClipShareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClipShareQuery, ClipShareQueryVariables>(ClipShareDocument, options);
        }
// @ts-ignore
export function useClipShareSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ClipShareQuery, ClipShareQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ClipShareQuery, ClipShareQueryVariables>;
export function useClipShareSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClipShareQuery, ClipShareQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ClipShareQuery | undefined, ClipShareQueryVariables>;
export function useClipShareSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClipShareQuery, ClipShareQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClipShareQuery, ClipShareQueryVariables>(ClipShareDocument, options);
        }
export type ClipShareQueryHookResult = ReturnType<typeof useClipShareQuery>;
export type ClipShareLazyQueryHookResult = ReturnType<typeof useClipShareLazyQuery>;
export type ClipShareSuspenseQueryHookResult = ReturnType<typeof useClipShareSuspenseQuery>;
export type ClipShareQueryResult = ApolloReactCommon.QueryResult<ClipShareQuery, ClipShareQueryVariables>;
export const PendingContactChangeSuggestionDocument = gql`
    query PendingContactChangeSuggestion($workspaceId: String!, $contactId: String!) {
  pendingContactChangeSuggestion(workspaceId: $workspaceId, contactId: $contactId) {
    ...ContactChangeSuggestionFields
  }
}
    ${ContactChangeSuggestionFieldsFragmentDoc}`;

/**
 * __usePendingContactChangeSuggestionQuery__
 *
 * To run a query within a React component, call `usePendingContactChangeSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingContactChangeSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingContactChangeSuggestionQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function usePendingContactChangeSuggestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PendingContactChangeSuggestionQuery, PendingContactChangeSuggestionQueryVariables> & ({ variables: PendingContactChangeSuggestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PendingContactChangeSuggestionQuery, PendingContactChangeSuggestionQueryVariables>(PendingContactChangeSuggestionDocument, options);
      }
export function usePendingContactChangeSuggestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PendingContactChangeSuggestionQuery, PendingContactChangeSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PendingContactChangeSuggestionQuery, PendingContactChangeSuggestionQueryVariables>(PendingContactChangeSuggestionDocument, options);
        }
// @ts-ignore
export function usePendingContactChangeSuggestionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PendingContactChangeSuggestionQuery, PendingContactChangeSuggestionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PendingContactChangeSuggestionQuery, PendingContactChangeSuggestionQueryVariables>;
export function usePendingContactChangeSuggestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PendingContactChangeSuggestionQuery, PendingContactChangeSuggestionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PendingContactChangeSuggestionQuery | undefined, PendingContactChangeSuggestionQueryVariables>;
export function usePendingContactChangeSuggestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PendingContactChangeSuggestionQuery, PendingContactChangeSuggestionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PendingContactChangeSuggestionQuery, PendingContactChangeSuggestionQueryVariables>(PendingContactChangeSuggestionDocument, options);
        }
export type PendingContactChangeSuggestionQueryHookResult = ReturnType<typeof usePendingContactChangeSuggestionQuery>;
export type PendingContactChangeSuggestionLazyQueryHookResult = ReturnType<typeof usePendingContactChangeSuggestionLazyQuery>;
export type PendingContactChangeSuggestionSuspenseQueryHookResult = ReturnType<typeof usePendingContactChangeSuggestionSuspenseQuery>;
export type PendingContactChangeSuggestionQueryResult = ApolloReactCommon.QueryResult<PendingContactChangeSuggestionQuery, PendingContactChangeSuggestionQueryVariables>;
export const ContactChangeSuggestionDocument = gql`
    query ContactChangeSuggestion($workspaceId: String!, $id: ID!) {
  contactChangeSuggestion(workspaceId: $workspaceId, id: $id) {
    ...ContactChangeSuggestionFields
  }
}
    ${ContactChangeSuggestionFieldsFragmentDoc}`;

/**
 * __useContactChangeSuggestionQuery__
 *
 * To run a query within a React component, call `useContactChangeSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactChangeSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactChangeSuggestionQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactChangeSuggestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ContactChangeSuggestionQuery, ContactChangeSuggestionQueryVariables> & ({ variables: ContactChangeSuggestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContactChangeSuggestionQuery, ContactChangeSuggestionQueryVariables>(ContactChangeSuggestionDocument, options);
      }
export function useContactChangeSuggestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContactChangeSuggestionQuery, ContactChangeSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContactChangeSuggestionQuery, ContactChangeSuggestionQueryVariables>(ContactChangeSuggestionDocument, options);
        }
// @ts-ignore
export function useContactChangeSuggestionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ContactChangeSuggestionQuery, ContactChangeSuggestionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ContactChangeSuggestionQuery, ContactChangeSuggestionQueryVariables>;
export function useContactChangeSuggestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContactChangeSuggestionQuery, ContactChangeSuggestionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ContactChangeSuggestionQuery | undefined, ContactChangeSuggestionQueryVariables>;
export function useContactChangeSuggestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContactChangeSuggestionQuery, ContactChangeSuggestionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContactChangeSuggestionQuery, ContactChangeSuggestionQueryVariables>(ContactChangeSuggestionDocument, options);
        }
export type ContactChangeSuggestionQueryHookResult = ReturnType<typeof useContactChangeSuggestionQuery>;
export type ContactChangeSuggestionLazyQueryHookResult = ReturnType<typeof useContactChangeSuggestionLazyQuery>;
export type ContactChangeSuggestionSuspenseQueryHookResult = ReturnType<typeof useContactChangeSuggestionSuspenseQuery>;
export type ContactChangeSuggestionQueryResult = ApolloReactCommon.QueryResult<ContactChangeSuggestionQuery, ContactChangeSuggestionQueryVariables>;
export const ContactChangeImpactDocument = gql`
    query ContactChangeImpact($workspaceId: String!, $id: ID!) {
  contactChangeImpact(workspaceId: $workspaceId, id: $id) {
    engagementCount
    dealNames
    dealCount
    existingContactId
    existingContactName
    accountMatch
    accountCandidates {
      id
      name
      domain
    }
    syncedTo
  }
}
    `;

/**
 * __useContactChangeImpactQuery__
 *
 * To run a query within a React component, call `useContactChangeImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactChangeImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactChangeImpactQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactChangeImpactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ContactChangeImpactQuery, ContactChangeImpactQueryVariables> & ({ variables: ContactChangeImpactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContactChangeImpactQuery, ContactChangeImpactQueryVariables>(ContactChangeImpactDocument, options);
      }
export function useContactChangeImpactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContactChangeImpactQuery, ContactChangeImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContactChangeImpactQuery, ContactChangeImpactQueryVariables>(ContactChangeImpactDocument, options);
        }
// @ts-ignore
export function useContactChangeImpactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ContactChangeImpactQuery, ContactChangeImpactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ContactChangeImpactQuery, ContactChangeImpactQueryVariables>;
export function useContactChangeImpactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContactChangeImpactQuery, ContactChangeImpactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ContactChangeImpactQuery | undefined, ContactChangeImpactQueryVariables>;
export function useContactChangeImpactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContactChangeImpactQuery, ContactChangeImpactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContactChangeImpactQuery, ContactChangeImpactQueryVariables>(ContactChangeImpactDocument, options);
        }
export type ContactChangeImpactQueryHookResult = ReturnType<typeof useContactChangeImpactQuery>;
export type ContactChangeImpactLazyQueryHookResult = ReturnType<typeof useContactChangeImpactLazyQuery>;
export type ContactChangeImpactSuspenseQueryHookResult = ReturnType<typeof useContactChangeImpactSuspenseQuery>;
export type ContactChangeImpactQueryResult = ApolloReactCommon.QueryResult<ContactChangeImpactQuery, ContactChangeImpactQueryVariables>;
export const AcceptContactChangeSuggestionDocument = gql`
    mutation AcceptContactChangeSuggestion($workspaceId: String!, $id: ID!, $mode: String!, $createCompany: Boolean, $accountId: String) {
  acceptContactChangeSuggestion(
    workspaceId: $workspaceId
    id: $id
    mode: $mode
    createCompany: $createCompany
    accountId: $accountId
  ) {
    ok
    errorCode
    errorMessage
    resolvedContactId
    suggestion {
      ...ContactChangeSuggestionFields
    }
  }
}
    ${ContactChangeSuggestionFieldsFragmentDoc}`;
export type AcceptContactChangeSuggestionMutationFn = ApolloReactCommon.MutationFunction<AcceptContactChangeSuggestionMutation, AcceptContactChangeSuggestionMutationVariables>;

/**
 * __useAcceptContactChangeSuggestionMutation__
 *
 * To run a mutation, you first call `useAcceptContactChangeSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptContactChangeSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptContactChangeSuggestionMutation, { data, loading, error }] = useAcceptContactChangeSuggestionMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *      mode: // value for 'mode'
 *      createCompany: // value for 'createCompany'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAcceptContactChangeSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptContactChangeSuggestionMutation, AcceptContactChangeSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptContactChangeSuggestionMutation, AcceptContactChangeSuggestionMutationVariables>(AcceptContactChangeSuggestionDocument, options);
      }
export type AcceptContactChangeSuggestionMutationHookResult = ReturnType<typeof useAcceptContactChangeSuggestionMutation>;
export type AcceptContactChangeSuggestionMutationResult = ApolloReactCommon.MutationResult<AcceptContactChangeSuggestionMutation>;
export type AcceptContactChangeSuggestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptContactChangeSuggestionMutation, AcceptContactChangeSuggestionMutationVariables>;
export const DismissContactChangeSuggestionDocument = gql`
    mutation DismissContactChangeSuggestion($workspaceId: String!, $id: ID!) {
  dismissContactChangeSuggestion(workspaceId: $workspaceId, id: $id) {
    ok
    errorCode
    errorMessage
    suggestion {
      ...ContactChangeSuggestionFields
    }
  }
}
    ${ContactChangeSuggestionFieldsFragmentDoc}`;
export type DismissContactChangeSuggestionMutationFn = ApolloReactCommon.MutationFunction<DismissContactChangeSuggestionMutation, DismissContactChangeSuggestionMutationVariables>;

/**
 * __useDismissContactChangeSuggestionMutation__
 *
 * To run a mutation, you first call `useDismissContactChangeSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissContactChangeSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissContactChangeSuggestionMutation, { data, loading, error }] = useDismissContactChangeSuggestionMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissContactChangeSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissContactChangeSuggestionMutation, DismissContactChangeSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DismissContactChangeSuggestionMutation, DismissContactChangeSuggestionMutationVariables>(DismissContactChangeSuggestionDocument, options);
      }
export type DismissContactChangeSuggestionMutationHookResult = ReturnType<typeof useDismissContactChangeSuggestionMutation>;
export type DismissContactChangeSuggestionMutationResult = ApolloReactCommon.MutationResult<DismissContactChangeSuggestionMutation>;
export type DismissContactChangeSuggestionMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissContactChangeSuggestionMutation, DismissContactChangeSuggestionMutationVariables>;
export const ReopenContactChangeSuggestionDocument = gql`
    mutation ReopenContactChangeSuggestion($workspaceId: String!, $id: ID!) {
  reopenContactChangeSuggestion(workspaceId: $workspaceId, id: $id) {
    ok
    errorCode
    errorMessage
    suggestion {
      ...ContactChangeSuggestionFields
    }
  }
}
    ${ContactChangeSuggestionFieldsFragmentDoc}`;
export type ReopenContactChangeSuggestionMutationFn = ApolloReactCommon.MutationFunction<ReopenContactChangeSuggestionMutation, ReopenContactChangeSuggestionMutationVariables>;

/**
 * __useReopenContactChangeSuggestionMutation__
 *
 * To run a mutation, you first call `useReopenContactChangeSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenContactChangeSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenContactChangeSuggestionMutation, { data, loading, error }] = useReopenContactChangeSuggestionMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReopenContactChangeSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReopenContactChangeSuggestionMutation, ReopenContactChangeSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReopenContactChangeSuggestionMutation, ReopenContactChangeSuggestionMutationVariables>(ReopenContactChangeSuggestionDocument, options);
      }
export type ReopenContactChangeSuggestionMutationHookResult = ReturnType<typeof useReopenContactChangeSuggestionMutation>;
export type ReopenContactChangeSuggestionMutationResult = ApolloReactCommon.MutationResult<ReopenContactChangeSuggestionMutation>;
export type ReopenContactChangeSuggestionMutationOptions = ApolloReactCommon.BaseMutationOptions<ReopenContactChangeSuggestionMutation, ReopenContactChangeSuggestionMutationVariables>;
export const GetContactsDocument = gql`
    query getContacts($first: Int, $after: String, $filter: ContactFilterInput, $sort: [SortInput]) {
  contacts(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        ...ContactFields
        ...ContactEngagements
        owner {
          ...UserBaseFields
        }
        accounts {
          edges {
            node {
              ...AccountBaseFields
            }
          }
        }
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${ContactFieldsFragmentDoc}
${ContactEngagementsFragmentDoc}
${UserBaseFieldsFragmentDoc}
${AccountBaseFieldsFragmentDoc}`;

/**
 * __useGetContactsQuery__
 *
 * To run a query within a React component, call `useGetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetContactsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
      }
export function useGetContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
// @ts-ignore
export function useGetContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetContactsQuery, GetContactsQueryVariables>;
export function useGetContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetContactsQuery | undefined, GetContactsQueryVariables>;
export function useGetContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
export type GetContactsQueryHookResult = ReturnType<typeof useGetContactsQuery>;
export type GetContactsLazyQueryHookResult = ReturnType<typeof useGetContactsLazyQuery>;
export type GetContactsSuspenseQueryHookResult = ReturnType<typeof useGetContactsSuspenseQuery>;
export type GetContactsQueryResult = ApolloReactCommon.QueryResult<GetContactsQuery, GetContactsQueryVariables>;
export const GetContactDocument = gql`
    query getContact($id: ID!) {
  contact(id: $id) {
    ...ContactFields
    properties {
      aiSummary
    }
    ...ContactEngagements
    owner {
      ...UserFields
    }
    accounts {
      edges {
        node {
          ...AccountBaseFields
        }
      }
    }
    deals {
      edges {
        node {
          ...DealFields
          accounts {
            edges {
              node {
                ...AccountBaseFields
              }
            }
          }
        }
      }
    }
    userLists {
      edges {
        node {
          list {
            ...ListFields
          }
        }
      }
    }
  }
}
    ${ContactFieldsFragmentDoc}
${ContactEngagementsFragmentDoc}
${UserFieldsFragmentDoc}
${AccountBaseFieldsFragmentDoc}
${DealFieldsFragmentDoc}
${ListFieldsFragmentDoc}`;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetContactQuery, GetContactQueryVariables> & ({ variables: GetContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
      }
export function useGetContactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
// @ts-ignore
export function useGetContactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetContactQuery, GetContactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetContactQuery, GetContactQueryVariables>;
export function useGetContactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContactQuery, GetContactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetContactQuery | undefined, GetContactQueryVariables>;
export function useGetContactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactSuspenseQueryHookResult = ReturnType<typeof useGetContactSuspenseQuery>;
export type GetContactQueryResult = ApolloReactCommon.QueryResult<GetContactQuery, GetContactQueryVariables>;
export const CreateContactDocument = gql`
    mutation createContact($input: CreateContactInput!) {
  createContact(input: $input) {
    contact {
      ...ContactFields
      ...ContactEngagements
      owner {
        ...UserFields
      }
      accounts {
        edges {
          node {
            ...AccountBaseFields
          }
        }
      }
    }
  }
}
    ${ContactFieldsFragmentDoc}
${ContactEngagementsFragmentDoc}
${UserFieldsFragmentDoc}
${AccountBaseFieldsFragmentDoc}`;
export type CreateContactMutationFn = ApolloReactCommon.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = ApolloReactCommon.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation updateContact($input: UpdateContactInput!) {
  updateContact(input: $input) {
    contact {
      ...ContactFields
      ...ContactEngagements
      owner {
        ...UserFields
      }
      accounts {
        edges {
          node {
            ...AccountBaseFields
          }
        }
      }
      deals {
        edges {
          node {
            ...DealFields
            accounts {
              edges {
                node {
                  ...AccountBaseFields
                }
              }
            }
          }
        }
      }
      userLists {
        edges {
          node {
            list {
              ...ListFields
            }
          }
        }
      }
    }
  }
}
    ${ContactFieldsFragmentDoc}
${ContactEngagementsFragmentDoc}
${UserFieldsFragmentDoc}
${AccountBaseFieldsFragmentDoc}
${DealFieldsFragmentDoc}
${ListFieldsFragmentDoc}`;
export type UpdateContactMutationFn = ApolloReactCommon.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = ApolloReactCommon.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation deleteContact($id: ID!) {
  deleteContact(id: $id) {
    success
  }
}
    `;
export type DeleteContactMutationFn = ApolloReactCommon.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = ApolloReactCommon.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const MergeContactsDocument = gql`
    mutation mergeContacts($args: MergeContactsInput!) {
  mergeContacts(args: $args) {
    success
    primaryContact {
      ...ContactFields
      ...ContactEngagements
      owner {
        ...UserFields
      }
      accounts {
        edges {
          node {
            ...AccountBaseFields
          }
        }
      }
    }
  }
}
    ${ContactFieldsFragmentDoc}
${ContactEngagementsFragmentDoc}
${UserFieldsFragmentDoc}
${AccountBaseFieldsFragmentDoc}`;
export type MergeContactsMutationFn = ApolloReactCommon.MutationFunction<MergeContactsMutation, MergeContactsMutationVariables>;

/**
 * __useMergeContactsMutation__
 *
 * To run a mutation, you first call `useMergeContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeContactsMutation, { data, loading, error }] = useMergeContactsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useMergeContactsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergeContactsMutation, MergeContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeContactsMutation, MergeContactsMutationVariables>(MergeContactsDocument, options);
      }
export type MergeContactsMutationHookResult = ReturnType<typeof useMergeContactsMutation>;
export type MergeContactsMutationResult = ApolloReactCommon.MutationResult<MergeContactsMutation>;
export type MergeContactsMutationOptions = ApolloReactCommon.BaseMutationOptions<MergeContactsMutation, MergeContactsMutationVariables>;
export const GetCreditResponseDocument = gql`
    query getCreditResponse($workspaceId: String!) {
  creditResponse(workspaceId: $workspaceId) {
    credits
  }
}
    `;

/**
 * __useGetCreditResponseQuery__
 *
 * To run a query within a React component, call `useGetCreditResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditResponseQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetCreditResponseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCreditResponseQuery, GetCreditResponseQueryVariables> & ({ variables: GetCreditResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditResponseQuery, GetCreditResponseQueryVariables>(GetCreditResponseDocument, options);
      }
export function useGetCreditResponseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditResponseQuery, GetCreditResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditResponseQuery, GetCreditResponseQueryVariables>(GetCreditResponseDocument, options);
        }
// @ts-ignore
export function useGetCreditResponseSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCreditResponseQuery, GetCreditResponseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCreditResponseQuery, GetCreditResponseQueryVariables>;
export function useGetCreditResponseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditResponseQuery, GetCreditResponseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCreditResponseQuery | undefined, GetCreditResponseQueryVariables>;
export function useGetCreditResponseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditResponseQuery, GetCreditResponseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditResponseQuery, GetCreditResponseQueryVariables>(GetCreditResponseDocument, options);
        }
export type GetCreditResponseQueryHookResult = ReturnType<typeof useGetCreditResponseQuery>;
export type GetCreditResponseLazyQueryHookResult = ReturnType<typeof useGetCreditResponseLazyQuery>;
export type GetCreditResponseSuspenseQueryHookResult = ReturnType<typeof useGetCreditResponseSuspenseQuery>;
export type GetCreditResponseQueryResult = ApolloReactCommon.QueryResult<GetCreditResponseQuery, GetCreditResponseQueryVariables>;
export const GetCrmGraderReportDocument = gql`
    query getCrmGraderReport($input: CrmGraderReportInput!) {
  crmGraderReport(input: $input) {
    shareLink
    generatedAt
    workspaceName
    contacts {
      totalDocuments
      fieldAggregates {
        fieldName
        crm {
          count
          percentage
        }
        mdm {
          count
          percentage
        }
      }
    }
    accounts {
      totalDocuments
      fieldAggregates {
        fieldName
        crm {
          count
          percentage
        }
        mdm {
          count
          percentage
        }
      }
    }
    deals {
      totalDocuments
      fieldAggregates {
        fieldName
        crm {
          count
          percentage
        }
        mdm {
          count
          percentage
        }
      }
    }
  }
}
    `;

/**
 * __useGetCrmGraderReportQuery__
 *
 * To run a query within a React component, call `useGetCrmGraderReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmGraderReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmGraderReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCrmGraderReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCrmGraderReportQuery, GetCrmGraderReportQueryVariables> & ({ variables: GetCrmGraderReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCrmGraderReportQuery, GetCrmGraderReportQueryVariables>(GetCrmGraderReportDocument, options);
      }
export function useGetCrmGraderReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCrmGraderReportQuery, GetCrmGraderReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCrmGraderReportQuery, GetCrmGraderReportQueryVariables>(GetCrmGraderReportDocument, options);
        }
// @ts-ignore
export function useGetCrmGraderReportSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCrmGraderReportQuery, GetCrmGraderReportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmGraderReportQuery, GetCrmGraderReportQueryVariables>;
export function useGetCrmGraderReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmGraderReportQuery, GetCrmGraderReportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmGraderReportQuery | undefined, GetCrmGraderReportQueryVariables>;
export function useGetCrmGraderReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmGraderReportQuery, GetCrmGraderReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCrmGraderReportQuery, GetCrmGraderReportQueryVariables>(GetCrmGraderReportDocument, options);
        }
export type GetCrmGraderReportQueryHookResult = ReturnType<typeof useGetCrmGraderReportQuery>;
export type GetCrmGraderReportLazyQueryHookResult = ReturnType<typeof useGetCrmGraderReportLazyQuery>;
export type GetCrmGraderReportSuspenseQueryHookResult = ReturnType<typeof useGetCrmGraderReportSuspenseQuery>;
export type GetCrmGraderReportQueryResult = ApolloReactCommon.QueryResult<GetCrmGraderReportQuery, GetCrmGraderReportQueryVariables>;
export const GetCrmIngestionFieldsDocument = gql`
    query getCrmIngestionFields($workspaceId: Int, $platform: CrmIngestionPlatform!, $before: String, $after: String, $first: Int, $last: Int) {
  crmIngestionFields(
    workspaceId: $workspaceId
    platform: $platform
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        ...CrmIngestionFields
      }
      cursor
    }
  }
}
    ${CrmIngestionFieldsFragmentDoc}`;

/**
 * __useGetCrmIngestionFieldsQuery__
 *
 * To run a query within a React component, call `useGetCrmIngestionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmIngestionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmIngestionFieldsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetCrmIngestionFieldsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCrmIngestionFieldsQuery, GetCrmIngestionFieldsQueryVariables> & ({ variables: GetCrmIngestionFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCrmIngestionFieldsQuery, GetCrmIngestionFieldsQueryVariables>(GetCrmIngestionFieldsDocument, options);
      }
export function useGetCrmIngestionFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCrmIngestionFieldsQuery, GetCrmIngestionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCrmIngestionFieldsQuery, GetCrmIngestionFieldsQueryVariables>(GetCrmIngestionFieldsDocument, options);
        }
// @ts-ignore
export function useGetCrmIngestionFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionFieldsQuery, GetCrmIngestionFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmIngestionFieldsQuery, GetCrmIngestionFieldsQueryVariables>;
export function useGetCrmIngestionFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionFieldsQuery, GetCrmIngestionFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmIngestionFieldsQuery | undefined, GetCrmIngestionFieldsQueryVariables>;
export function useGetCrmIngestionFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionFieldsQuery, GetCrmIngestionFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCrmIngestionFieldsQuery, GetCrmIngestionFieldsQueryVariables>(GetCrmIngestionFieldsDocument, options);
        }
export type GetCrmIngestionFieldsQueryHookResult = ReturnType<typeof useGetCrmIngestionFieldsQuery>;
export type GetCrmIngestionFieldsLazyQueryHookResult = ReturnType<typeof useGetCrmIngestionFieldsLazyQuery>;
export type GetCrmIngestionFieldsSuspenseQueryHookResult = ReturnType<typeof useGetCrmIngestionFieldsSuspenseQuery>;
export type GetCrmIngestionFieldsQueryResult = ApolloReactCommon.QueryResult<GetCrmIngestionFieldsQuery, GetCrmIngestionFieldsQueryVariables>;
export const GetCrmIngestionConfigDocument = gql`
    query getCrmIngestionConfig($workspaceId: ID!, $platform: CrmIngestionPlatform) {
  crmIngestionConfig(workspaceId: $workspaceId, platform: $platform) {
    workspaceId
    syncForward
    syncBack
    syncForwardEntityTypes
    windowStartDate
    windowEndDate
    selectedStageIds
    pipelineId
  }
}
    `;

/**
 * __useGetCrmIngestionConfigQuery__
 *
 * To run a query within a React component, call `useGetCrmIngestionConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmIngestionConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmIngestionConfigQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetCrmIngestionConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCrmIngestionConfigQuery, GetCrmIngestionConfigQueryVariables> & ({ variables: GetCrmIngestionConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCrmIngestionConfigQuery, GetCrmIngestionConfigQueryVariables>(GetCrmIngestionConfigDocument, options);
      }
export function useGetCrmIngestionConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCrmIngestionConfigQuery, GetCrmIngestionConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCrmIngestionConfigQuery, GetCrmIngestionConfigQueryVariables>(GetCrmIngestionConfigDocument, options);
        }
// @ts-ignore
export function useGetCrmIngestionConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionConfigQuery, GetCrmIngestionConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmIngestionConfigQuery, GetCrmIngestionConfigQueryVariables>;
export function useGetCrmIngestionConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionConfigQuery, GetCrmIngestionConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmIngestionConfigQuery | undefined, GetCrmIngestionConfigQueryVariables>;
export function useGetCrmIngestionConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionConfigQuery, GetCrmIngestionConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCrmIngestionConfigQuery, GetCrmIngestionConfigQueryVariables>(GetCrmIngestionConfigDocument, options);
        }
export type GetCrmIngestionConfigQueryHookResult = ReturnType<typeof useGetCrmIngestionConfigQuery>;
export type GetCrmIngestionConfigLazyQueryHookResult = ReturnType<typeof useGetCrmIngestionConfigLazyQuery>;
export type GetCrmIngestionConfigSuspenseQueryHookResult = ReturnType<typeof useGetCrmIngestionConfigSuspenseQuery>;
export type GetCrmIngestionConfigQueryResult = ApolloReactCommon.QueryResult<GetCrmIngestionConfigQuery, GetCrmIngestionConfigQueryVariables>;
export const GetCrmPreviewDealStagesDocument = gql`
    query getCrmPreviewDealStages($workspaceId: Int!, $platform: CrmIngestionPlatform!) {
  crmPreviewDealStages(workspaceId: $workspaceId, platform: $platform) {
    salesforceId
    hubspotId
    pipelineId
    pipelineName
    name
    probability
    isClosed
    isWon
    sortOrder
  }
}
    `;

/**
 * __useGetCrmPreviewDealStagesQuery__
 *
 * To run a query within a React component, call `useGetCrmPreviewDealStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmPreviewDealStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmPreviewDealStagesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetCrmPreviewDealStagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCrmPreviewDealStagesQuery, GetCrmPreviewDealStagesQueryVariables> & ({ variables: GetCrmPreviewDealStagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCrmPreviewDealStagesQuery, GetCrmPreviewDealStagesQueryVariables>(GetCrmPreviewDealStagesDocument, options);
      }
export function useGetCrmPreviewDealStagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCrmPreviewDealStagesQuery, GetCrmPreviewDealStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCrmPreviewDealStagesQuery, GetCrmPreviewDealStagesQueryVariables>(GetCrmPreviewDealStagesDocument, options);
        }
// @ts-ignore
export function useGetCrmPreviewDealStagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCrmPreviewDealStagesQuery, GetCrmPreviewDealStagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmPreviewDealStagesQuery, GetCrmPreviewDealStagesQueryVariables>;
export function useGetCrmPreviewDealStagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmPreviewDealStagesQuery, GetCrmPreviewDealStagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmPreviewDealStagesQuery | undefined, GetCrmPreviewDealStagesQueryVariables>;
export function useGetCrmPreviewDealStagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmPreviewDealStagesQuery, GetCrmPreviewDealStagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCrmPreviewDealStagesQuery, GetCrmPreviewDealStagesQueryVariables>(GetCrmPreviewDealStagesDocument, options);
        }
export type GetCrmPreviewDealStagesQueryHookResult = ReturnType<typeof useGetCrmPreviewDealStagesQuery>;
export type GetCrmPreviewDealStagesLazyQueryHookResult = ReturnType<typeof useGetCrmPreviewDealStagesLazyQuery>;
export type GetCrmPreviewDealStagesSuspenseQueryHookResult = ReturnType<typeof useGetCrmPreviewDealStagesSuspenseQuery>;
export type GetCrmPreviewDealStagesQueryResult = ApolloReactCommon.QueryResult<GetCrmPreviewDealStagesQuery, GetCrmPreviewDealStagesQueryVariables>;
export const GeCrmIngestionAvailableFieldsDocument = gql`
    query geCrmIngestionAvailableFields($workspaceId: Int!, $platform: CrmIngestionPlatform!, $objectType: CrmIngestionObjectType!) {
  crmIngestionAvailableFields(
    workspaceId: $workspaceId
    platform: $platform
    objectType: $objectType
  ) {
    ...CrmIngestionAvailableFields
  }
}
    ${CrmIngestionAvailableFieldsFragmentDoc}`;

/**
 * __useGeCrmIngestionAvailableFieldsQuery__
 *
 * To run a query within a React component, call `useGeCrmIngestionAvailableFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeCrmIngestionAvailableFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeCrmIngestionAvailableFieldsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useGeCrmIngestionAvailableFieldsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GeCrmIngestionAvailableFieldsQuery, GeCrmIngestionAvailableFieldsQueryVariables> & ({ variables: GeCrmIngestionAvailableFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GeCrmIngestionAvailableFieldsQuery, GeCrmIngestionAvailableFieldsQueryVariables>(GeCrmIngestionAvailableFieldsDocument, options);
      }
export function useGeCrmIngestionAvailableFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GeCrmIngestionAvailableFieldsQuery, GeCrmIngestionAvailableFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GeCrmIngestionAvailableFieldsQuery, GeCrmIngestionAvailableFieldsQueryVariables>(GeCrmIngestionAvailableFieldsDocument, options);
        }
// @ts-ignore
export function useGeCrmIngestionAvailableFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GeCrmIngestionAvailableFieldsQuery, GeCrmIngestionAvailableFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GeCrmIngestionAvailableFieldsQuery, GeCrmIngestionAvailableFieldsQueryVariables>;
export function useGeCrmIngestionAvailableFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GeCrmIngestionAvailableFieldsQuery, GeCrmIngestionAvailableFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GeCrmIngestionAvailableFieldsQuery | undefined, GeCrmIngestionAvailableFieldsQueryVariables>;
export function useGeCrmIngestionAvailableFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GeCrmIngestionAvailableFieldsQuery, GeCrmIngestionAvailableFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GeCrmIngestionAvailableFieldsQuery, GeCrmIngestionAvailableFieldsQueryVariables>(GeCrmIngestionAvailableFieldsDocument, options);
        }
export type GeCrmIngestionAvailableFieldsQueryHookResult = ReturnType<typeof useGeCrmIngestionAvailableFieldsQuery>;
export type GeCrmIngestionAvailableFieldsLazyQueryHookResult = ReturnType<typeof useGeCrmIngestionAvailableFieldsLazyQuery>;
export type GeCrmIngestionAvailableFieldsSuspenseQueryHookResult = ReturnType<typeof useGeCrmIngestionAvailableFieldsSuspenseQuery>;
export type GeCrmIngestionAvailableFieldsQueryResult = ApolloReactCommon.QueryResult<GeCrmIngestionAvailableFieldsQuery, GeCrmIngestionAvailableFieldsQueryVariables>;
export const CreateIngestionFieldDocument = gql`
    mutation createIngestionField($args: CreateIngestionFieldInput!) {
  createIngestionField(args: $args) {
    ingestionField {
      ...CrmIngestionFields
    }
  }
}
    ${CrmIngestionFieldsFragmentDoc}`;
export type CreateIngestionFieldMutationFn = ApolloReactCommon.MutationFunction<CreateIngestionFieldMutation, CreateIngestionFieldMutationVariables>;

/**
 * __useCreateIngestionFieldMutation__
 *
 * To run a mutation, you first call `useCreateIngestionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIngestionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIngestionFieldMutation, { data, loading, error }] = useCreateIngestionFieldMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCreateIngestionFieldMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateIngestionFieldMutation, CreateIngestionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateIngestionFieldMutation, CreateIngestionFieldMutationVariables>(CreateIngestionFieldDocument, options);
      }
export type CreateIngestionFieldMutationHookResult = ReturnType<typeof useCreateIngestionFieldMutation>;
export type CreateIngestionFieldMutationResult = ApolloReactCommon.MutationResult<CreateIngestionFieldMutation>;
export type CreateIngestionFieldMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateIngestionFieldMutation, CreateIngestionFieldMutationVariables>;
export const UpdateIngestionFieldDocument = gql`
    mutation updateIngestionField($args: [UpdateIngestionFieldInput]!) {
  updateIngestionField(args: $args) {
    ingestionFields {
      ...CrmIngestionFields
    }
  }
}
    ${CrmIngestionFieldsFragmentDoc}`;
export type UpdateIngestionFieldMutationFn = ApolloReactCommon.MutationFunction<UpdateIngestionFieldMutation, UpdateIngestionFieldMutationVariables>;

/**
 * __useUpdateIngestionFieldMutation__
 *
 * To run a mutation, you first call `useUpdateIngestionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngestionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngestionFieldMutation, { data, loading, error }] = useUpdateIngestionFieldMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUpdateIngestionFieldMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIngestionFieldMutation, UpdateIngestionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateIngestionFieldMutation, UpdateIngestionFieldMutationVariables>(UpdateIngestionFieldDocument, options);
      }
export type UpdateIngestionFieldMutationHookResult = ReturnType<typeof useUpdateIngestionFieldMutation>;
export type UpdateIngestionFieldMutationResult = ApolloReactCommon.MutationResult<UpdateIngestionFieldMutation>;
export type UpdateIngestionFieldMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIngestionFieldMutation, UpdateIngestionFieldMutationVariables>;
export const DeleteIngestionFieldDocument = gql`
    mutation deleteIngestionField($id: ID!) {
  deleteIngestionField(id: $id) {
    success
  }
}
    `;
export type DeleteIngestionFieldMutationFn = ApolloReactCommon.MutationFunction<DeleteIngestionFieldMutation, DeleteIngestionFieldMutationVariables>;

/**
 * __useDeleteIngestionFieldMutation__
 *
 * To run a mutation, you first call `useDeleteIngestionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIngestionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIngestionFieldMutation, { data, loading, error }] = useDeleteIngestionFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIngestionFieldMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteIngestionFieldMutation, DeleteIngestionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteIngestionFieldMutation, DeleteIngestionFieldMutationVariables>(DeleteIngestionFieldDocument, options);
      }
export type DeleteIngestionFieldMutationHookResult = ReturnType<typeof useDeleteIngestionFieldMutation>;
export type DeleteIngestionFieldMutationResult = ApolloReactCommon.MutationResult<DeleteIngestionFieldMutation>;
export type DeleteIngestionFieldMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteIngestionFieldMutation, DeleteIngestionFieldMutationVariables>;
export const UpdateIngestionConfigDocument = gql`
    mutation updateIngestionConfig($args: UpdateCrmIngestionConfigInput!) {
  updateIngestionConfig(args: $args) {
    crmIngestionConfig {
      workspaceId
      syncForward
      syncBack
      syncForwardEntityTypes
      windowStartDate
      windowEndDate
      selectedStageIds
      pipelineId
    }
  }
}
    `;
export type UpdateIngestionConfigMutationFn = ApolloReactCommon.MutationFunction<UpdateIngestionConfigMutation, UpdateIngestionConfigMutationVariables>;

/**
 * __useUpdateIngestionConfigMutation__
 *
 * To run a mutation, you first call `useUpdateIngestionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngestionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngestionConfigMutation, { data, loading, error }] = useUpdateIngestionConfigMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUpdateIngestionConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIngestionConfigMutation, UpdateIngestionConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateIngestionConfigMutation, UpdateIngestionConfigMutationVariables>(UpdateIngestionConfigDocument, options);
      }
export type UpdateIngestionConfigMutationHookResult = ReturnType<typeof useUpdateIngestionConfigMutation>;
export type UpdateIngestionConfigMutationResult = ApolloReactCommon.MutationResult<UpdateIngestionConfigMutation>;
export type UpdateIngestionConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIngestionConfigMutation, UpdateIngestionConfigMutationVariables>;
export const CrmReIngestDocument = gql`
    mutation crmReIngest($ignoreUnchanged: Boolean, $runId: Int!, $useDownloadedData: Boolean, $useJava: Boolean) {
  crmReIngest(
    ignoreUnchanged: $ignoreUnchanged
    runId: $runId
    useDownloadedData: $useDownloadedData
    useJava: $useJava
  ) {
    ok
  }
}
    `;
export type CrmReIngestMutationFn = ApolloReactCommon.MutationFunction<CrmReIngestMutation, CrmReIngestMutationVariables>;

/**
 * __useCrmReIngestMutation__
 *
 * To run a mutation, you first call `useCrmReIngestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrmReIngestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crmReIngestMutation, { data, loading, error }] = useCrmReIngestMutation({
 *   variables: {
 *      ignoreUnchanged: // value for 'ignoreUnchanged'
 *      runId: // value for 'runId'
 *      useDownloadedData: // value for 'useDownloadedData'
 *      useJava: // value for 'useJava'
 *   },
 * });
 */
export function useCrmReIngestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CrmReIngestMutation, CrmReIngestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CrmReIngestMutation, CrmReIngestMutationVariables>(CrmReIngestDocument, options);
      }
export type CrmReIngestMutationHookResult = ReturnType<typeof useCrmReIngestMutation>;
export type CrmReIngestMutationResult = ApolloReactCommon.MutationResult<CrmReIngestMutation>;
export type CrmReIngestMutationOptions = ApolloReactCommon.BaseMutationOptions<CrmReIngestMutation, CrmReIngestMutationVariables>;
export const GetDailyLeadsDocument = gql`
    query getDailyLeads($filter: DailyLeadsFilter!) {
  dailyLeads(filter: $filter) {
    edges {
      node {
        ...DailyLeadFields
      }
    }
  }
}
    ${DailyLeadFieldsFragmentDoc}`;

/**
 * __useGetDailyLeadsQuery__
 *
 * To run a query within a React component, call `useGetDailyLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyLeadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDailyLeadsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDailyLeadsQuery, GetDailyLeadsQueryVariables> & ({ variables: GetDailyLeadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDailyLeadsQuery, GetDailyLeadsQueryVariables>(GetDailyLeadsDocument, options);
      }
export function useGetDailyLeadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDailyLeadsQuery, GetDailyLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDailyLeadsQuery, GetDailyLeadsQueryVariables>(GetDailyLeadsDocument, options);
        }
// @ts-ignore
export function useGetDailyLeadsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDailyLeadsQuery, GetDailyLeadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDailyLeadsQuery, GetDailyLeadsQueryVariables>;
export function useGetDailyLeadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDailyLeadsQuery, GetDailyLeadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDailyLeadsQuery | undefined, GetDailyLeadsQueryVariables>;
export function useGetDailyLeadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDailyLeadsQuery, GetDailyLeadsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDailyLeadsQuery, GetDailyLeadsQueryVariables>(GetDailyLeadsDocument, options);
        }
export type GetDailyLeadsQueryHookResult = ReturnType<typeof useGetDailyLeadsQuery>;
export type GetDailyLeadsLazyQueryHookResult = ReturnType<typeof useGetDailyLeadsLazyQuery>;
export type GetDailyLeadsSuspenseQueryHookResult = ReturnType<typeof useGetDailyLeadsSuspenseQuery>;
export type GetDailyLeadsQueryResult = ApolloReactCommon.QueryResult<GetDailyLeadsQuery, GetDailyLeadsQueryVariables>;
export const DismissDailyLeadDocument = gql`
    mutation dismissDailyLead($input: _MutationInput!) {
  dismissDailyLead(input: $input) {
    dailyLead {
      ...DailyLeadFields
    }
  }
}
    ${DailyLeadFieldsFragmentDoc}`;
export type DismissDailyLeadMutationFn = ApolloReactCommon.MutationFunction<DismissDailyLeadMutation, DismissDailyLeadMutationVariables>;

/**
 * __useDismissDailyLeadMutation__
 *
 * To run a mutation, you first call `useDismissDailyLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissDailyLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissDailyLeadMutation, { data, loading, error }] = useDismissDailyLeadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissDailyLeadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissDailyLeadMutation, DismissDailyLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DismissDailyLeadMutation, DismissDailyLeadMutationVariables>(DismissDailyLeadDocument, options);
      }
export type DismissDailyLeadMutationHookResult = ReturnType<typeof useDismissDailyLeadMutation>;
export type DismissDailyLeadMutationResult = ApolloReactCommon.MutationResult<DismissDailyLeadMutation>;
export type DismissDailyLeadMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissDailyLeadMutation, DismissDailyLeadMutationVariables>;
export const SaveDailyLeadAsContactDocument = gql`
    mutation saveDailyLeadAsContact($input: _SaveAsContactInput!) {
  saveDailyLeadAsContact(input: $input) {
    dailyLead {
      ...DailyLeadFields
    }
  }
}
    ${DailyLeadFieldsFragmentDoc}`;
export type SaveDailyLeadAsContactMutationFn = ApolloReactCommon.MutationFunction<SaveDailyLeadAsContactMutation, SaveDailyLeadAsContactMutationVariables>;

/**
 * __useSaveDailyLeadAsContactMutation__
 *
 * To run a mutation, you first call `useSaveDailyLeadAsContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDailyLeadAsContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDailyLeadAsContactMutation, { data, loading, error }] = useSaveDailyLeadAsContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDailyLeadAsContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDailyLeadAsContactMutation, SaveDailyLeadAsContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDailyLeadAsContactMutation, SaveDailyLeadAsContactMutationVariables>(SaveDailyLeadAsContactDocument, options);
      }
export type SaveDailyLeadAsContactMutationHookResult = ReturnType<typeof useSaveDailyLeadAsContactMutation>;
export type SaveDailyLeadAsContactMutationResult = ApolloReactCommon.MutationResult<SaveDailyLeadAsContactMutation>;
export type SaveDailyLeadAsContactMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveDailyLeadAsContactMutation, SaveDailyLeadAsContactMutationVariables>;
export const GetDealsAggregatesDocument = gql`
    query getDealsAggregates($filter: DealFilter, $sort: [SortInput]) {
  dealsCompareAggregates(filter: $filter, sort: $sort) {
    pipeline {
      previous
      current
      diff
    }
    forecast {
      previous
      current
      diff
    }
    averageDealSize {
      previous
      current
      diff
    }
    closedWon {
      previous
      current
      diff
    }
    averageDaysToClose {
      previous
      current
      diff
    }
    bestCase {
      previous
      current
      diff
    }
    commit {
      previous
      current
      diff
    }
  }
}
    `;

/**
 * __useGetDealsAggregatesQuery__
 *
 * To run a query within a React component, call `useGetDealsAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsAggregatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetDealsAggregatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDealsAggregatesQuery, GetDealsAggregatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealsAggregatesQuery, GetDealsAggregatesQueryVariables>(GetDealsAggregatesDocument, options);
      }
export function useGetDealsAggregatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealsAggregatesQuery, GetDealsAggregatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealsAggregatesQuery, GetDealsAggregatesQueryVariables>(GetDealsAggregatesDocument, options);
        }
// @ts-ignore
export function useGetDealsAggregatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDealsAggregatesQuery, GetDealsAggregatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealsAggregatesQuery, GetDealsAggregatesQueryVariables>;
export function useGetDealsAggregatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealsAggregatesQuery, GetDealsAggregatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealsAggregatesQuery | undefined, GetDealsAggregatesQueryVariables>;
export function useGetDealsAggregatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealsAggregatesQuery, GetDealsAggregatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealsAggregatesQuery, GetDealsAggregatesQueryVariables>(GetDealsAggregatesDocument, options);
        }
export type GetDealsAggregatesQueryHookResult = ReturnType<typeof useGetDealsAggregatesQuery>;
export type GetDealsAggregatesLazyQueryHookResult = ReturnType<typeof useGetDealsAggregatesLazyQuery>;
export type GetDealsAggregatesSuspenseQueryHookResult = ReturnType<typeof useGetDealsAggregatesSuspenseQuery>;
export type GetDealsAggregatesQueryResult = ApolloReactCommon.QueryResult<GetDealsAggregatesQuery, GetDealsAggregatesQueryVariables>;
export const CreateDealFieldDocument = gql`
    mutation CreateDealField($input: CreateDealFieldInput!) {
  createDealField(input: $input) {
    dealField {
      id
      fieldName
      displayName
      description
    }
  }
}
    `;
export type CreateDealFieldMutationFn = ApolloReactCommon.MutationFunction<CreateDealFieldMutation, CreateDealFieldMutationVariables>;

/**
 * __useCreateDealFieldMutation__
 *
 * To run a mutation, you first call `useCreateDealFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealFieldMutation, { data, loading, error }] = useCreateDealFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDealFieldMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDealFieldMutation, CreateDealFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDealFieldMutation, CreateDealFieldMutationVariables>(CreateDealFieldDocument, options);
      }
export type CreateDealFieldMutationHookResult = ReturnType<typeof useCreateDealFieldMutation>;
export type CreateDealFieldMutationResult = ApolloReactCommon.MutationResult<CreateDealFieldMutation>;
export type CreateDealFieldMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDealFieldMutation, CreateDealFieldMutationVariables>;
export const GetDealFieldsDocument = gql`
    query GetDealFields($workspaceId: ID!) {
  dealFields(filter: {workspaceId: $workspaceId}) {
    edges {
      node {
        id
        fieldName
        displayName
        description
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetDealFieldsQuery__
 *
 * To run a query within a React component, call `useGetDealFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealFieldsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetDealFieldsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealFieldsQuery, GetDealFieldsQueryVariables> & ({ variables: GetDealFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealFieldsQuery, GetDealFieldsQueryVariables>(GetDealFieldsDocument, options);
      }
export function useGetDealFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealFieldsQuery, GetDealFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealFieldsQuery, GetDealFieldsQueryVariables>(GetDealFieldsDocument, options);
        }
// @ts-ignore
export function useGetDealFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDealFieldsQuery, GetDealFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealFieldsQuery, GetDealFieldsQueryVariables>;
export function useGetDealFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealFieldsQuery, GetDealFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealFieldsQuery | undefined, GetDealFieldsQueryVariables>;
export function useGetDealFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealFieldsQuery, GetDealFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealFieldsQuery, GetDealFieldsQueryVariables>(GetDealFieldsDocument, options);
        }
export type GetDealFieldsQueryHookResult = ReturnType<typeof useGetDealFieldsQuery>;
export type GetDealFieldsLazyQueryHookResult = ReturnType<typeof useGetDealFieldsLazyQuery>;
export type GetDealFieldsSuspenseQueryHookResult = ReturnType<typeof useGetDealFieldsSuspenseQuery>;
export type GetDealFieldsQueryResult = ApolloReactCommon.QueryResult<GetDealFieldsQuery, GetDealFieldsQueryVariables>;
export const GetDealOwnerCountsDocument = gql`
    query getDealOwnerCounts($input: RecordAggregateInput!) {
  recordAggregate(input: $input) {
    total
    truncated
    otherCount
    buckets {
      key
      label
      docCount
    }
  }
}
    `;

/**
 * __useGetDealOwnerCountsQuery__
 *
 * To run a query within a React component, call `useGetDealOwnerCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealOwnerCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealOwnerCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDealOwnerCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealOwnerCountsQuery, GetDealOwnerCountsQueryVariables> & ({ variables: GetDealOwnerCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealOwnerCountsQuery, GetDealOwnerCountsQueryVariables>(GetDealOwnerCountsDocument, options);
      }
export function useGetDealOwnerCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealOwnerCountsQuery, GetDealOwnerCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealOwnerCountsQuery, GetDealOwnerCountsQueryVariables>(GetDealOwnerCountsDocument, options);
        }
// @ts-ignore
export function useGetDealOwnerCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDealOwnerCountsQuery, GetDealOwnerCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealOwnerCountsQuery, GetDealOwnerCountsQueryVariables>;
export function useGetDealOwnerCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealOwnerCountsQuery, GetDealOwnerCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealOwnerCountsQuery | undefined, GetDealOwnerCountsQueryVariables>;
export function useGetDealOwnerCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealOwnerCountsQuery, GetDealOwnerCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealOwnerCountsQuery, GetDealOwnerCountsQueryVariables>(GetDealOwnerCountsDocument, options);
        }
export type GetDealOwnerCountsQueryHookResult = ReturnType<typeof useGetDealOwnerCountsQuery>;
export type GetDealOwnerCountsLazyQueryHookResult = ReturnType<typeof useGetDealOwnerCountsLazyQuery>;
export type GetDealOwnerCountsSuspenseQueryHookResult = ReturnType<typeof useGetDealOwnerCountsSuspenseQuery>;
export type GetDealOwnerCountsQueryResult = ApolloReactCommon.QueryResult<GetDealOwnerCountsQuery, GetDealOwnerCountsQueryVariables>;
export const GetDealStagesDocument = gql`
    query getDealStages($sort: [DealStageSortEnum] = [ID_ASC], $filter: DealStageFilter, $before: String, $after: String, $first: Int, $last: Int) {
  dealStages(
    sort: $sort
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        ...DealStageFields
      }
    }
  }
}
    ${DealStageFieldsFragmentDoc}`;

/**
 * __useGetDealStagesQuery__
 *
 * To run a query within a React component, call `useGetDealStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealStagesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetDealStagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDealStagesQuery, GetDealStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealStagesQuery, GetDealStagesQueryVariables>(GetDealStagesDocument, options);
      }
export function useGetDealStagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealStagesQuery, GetDealStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealStagesQuery, GetDealStagesQueryVariables>(GetDealStagesDocument, options);
        }
// @ts-ignore
export function useGetDealStagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDealStagesQuery, GetDealStagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealStagesQuery, GetDealStagesQueryVariables>;
export function useGetDealStagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealStagesQuery, GetDealStagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealStagesQuery | undefined, GetDealStagesQueryVariables>;
export function useGetDealStagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealStagesQuery, GetDealStagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealStagesQuery, GetDealStagesQueryVariables>(GetDealStagesDocument, options);
        }
export type GetDealStagesQueryHookResult = ReturnType<typeof useGetDealStagesQuery>;
export type GetDealStagesLazyQueryHookResult = ReturnType<typeof useGetDealStagesLazyQuery>;
export type GetDealStagesSuspenseQueryHookResult = ReturnType<typeof useGetDealStagesSuspenseQuery>;
export type GetDealStagesQueryResult = ApolloReactCommon.QueryResult<GetDealStagesQuery, GetDealStagesQueryVariables>;
export const CreateDealStageDocument = gql`
    mutation createDealStage($input: CreateDealStageInput!) {
  createDealStage(input: $input) {
    dealStage {
      ...DealStageFields
    }
  }
}
    ${DealStageFieldsFragmentDoc}`;
export type CreateDealStageMutationFn = ApolloReactCommon.MutationFunction<CreateDealStageMutation, CreateDealStageMutationVariables>;

/**
 * __useCreateDealStageMutation__
 *
 * To run a mutation, you first call `useCreateDealStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealStageMutation, { data, loading, error }] = useCreateDealStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDealStageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDealStageMutation, CreateDealStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDealStageMutation, CreateDealStageMutationVariables>(CreateDealStageDocument, options);
      }
export type CreateDealStageMutationHookResult = ReturnType<typeof useCreateDealStageMutation>;
export type CreateDealStageMutationResult = ApolloReactCommon.MutationResult<CreateDealStageMutation>;
export type CreateDealStageMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDealStageMutation, CreateDealStageMutationVariables>;
export const UpdateDealStageDocument = gql`
    mutation updateDealStage($input: UpdateDealStageInput!) {
  updateDealStage(input: $input) {
    dealStage {
      ...DealStageFields
    }
  }
}
    ${DealStageFieldsFragmentDoc}`;
export type UpdateDealStageMutationFn = ApolloReactCommon.MutationFunction<UpdateDealStageMutation, UpdateDealStageMutationVariables>;

/**
 * __useUpdateDealStageMutation__
 *
 * To run a mutation, you first call `useUpdateDealStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealStageMutation, { data, loading, error }] = useUpdateDealStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDealStageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDealStageMutation, UpdateDealStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDealStageMutation, UpdateDealStageMutationVariables>(UpdateDealStageDocument, options);
      }
export type UpdateDealStageMutationHookResult = ReturnType<typeof useUpdateDealStageMutation>;
export type UpdateDealStageMutationResult = ApolloReactCommon.MutationResult<UpdateDealStageMutation>;
export type UpdateDealStageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDealStageMutation, UpdateDealStageMutationVariables>;
export const DeleteDealStageDocument = gql`
    mutation deleteDealStage($input: DeleteDealStageInput!) {
  deleteDealStage(input: $input) {
    success
  }
}
    `;
export type DeleteDealStageMutationFn = ApolloReactCommon.MutationFunction<DeleteDealStageMutation, DeleteDealStageMutationVariables>;

/**
 * __useDeleteDealStageMutation__
 *
 * To run a mutation, you first call `useDeleteDealStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDealStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDealStageMutation, { data, loading, error }] = useDeleteDealStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDealStageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDealStageMutation, DeleteDealStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDealStageMutation, DeleteDealStageMutationVariables>(DeleteDealStageDocument, options);
      }
export type DeleteDealStageMutationHookResult = ReturnType<typeof useDeleteDealStageMutation>;
export type DeleteDealStageMutationResult = ApolloReactCommon.MutationResult<DeleteDealStageMutation>;
export type DeleteDealStageMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDealStageMutation, DeleteDealStageMutationVariables>;
export const GetPipelinesDocument = gql`
    query getPipelines($filter: PipelineFilter, $before: String, $after: String, $first: Int, $last: Int) {
  pipelines(
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        ...PipelineFields
        hasActiveDeals
        includeInForecast
        stages(first: 100) {
          edges {
            node {
              ...DealStageFields
            }
          }
        }
      }
    }
  }
}
    ${PipelineFieldsFragmentDoc}
${DealStageFieldsFragmentDoc}`;

/**
 * __useGetPipelinesQuery__
 *
 * To run a query within a React component, call `useGetPipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelinesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetPipelinesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPipelinesQuery, GetPipelinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPipelinesQuery, GetPipelinesQueryVariables>(GetPipelinesDocument, options);
      }
export function useGetPipelinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPipelinesQuery, GetPipelinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPipelinesQuery, GetPipelinesQueryVariables>(GetPipelinesDocument, options);
        }
// @ts-ignore
export function useGetPipelinesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPipelinesQuery, GetPipelinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPipelinesQuery, GetPipelinesQueryVariables>;
export function useGetPipelinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPipelinesQuery, GetPipelinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPipelinesQuery | undefined, GetPipelinesQueryVariables>;
export function useGetPipelinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPipelinesQuery, GetPipelinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPipelinesQuery, GetPipelinesQueryVariables>(GetPipelinesDocument, options);
        }
export type GetPipelinesQueryHookResult = ReturnType<typeof useGetPipelinesQuery>;
export type GetPipelinesLazyQueryHookResult = ReturnType<typeof useGetPipelinesLazyQuery>;
export type GetPipelinesSuspenseQueryHookResult = ReturnType<typeof useGetPipelinesSuspenseQuery>;
export type GetPipelinesQueryResult = ApolloReactCommon.QueryResult<GetPipelinesQuery, GetPipelinesQueryVariables>;
export const CreatePipelineDocument = gql`
    mutation createPipeline($input: CreatePipelineInput!) {
  createPipeline(input: $input) {
    pipeline {
      ...PipelineFields
      stages {
        edges {
          node {
            ...DealStageFields
          }
        }
      }
    }
  }
}
    ${PipelineFieldsFragmentDoc}
${DealStageFieldsFragmentDoc}`;
export type CreatePipelineMutationFn = ApolloReactCommon.MutationFunction<CreatePipelineMutation, CreatePipelineMutationVariables>;

/**
 * __useCreatePipelineMutation__
 *
 * To run a mutation, you first call `useCreatePipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPipelineMutation, { data, loading, error }] = useCreatePipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePipelineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePipelineMutation, CreatePipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePipelineMutation, CreatePipelineMutationVariables>(CreatePipelineDocument, options);
      }
export type CreatePipelineMutationHookResult = ReturnType<typeof useCreatePipelineMutation>;
export type CreatePipelineMutationResult = ApolloReactCommon.MutationResult<CreatePipelineMutation>;
export type CreatePipelineMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePipelineMutation, CreatePipelineMutationVariables>;
export const EditPipelineDocument = gql`
    mutation editPipeline($input: EditPipelineInput!) {
  editPipeline(input: $input) {
    pipeline {
      ...PipelineFields
      stages {
        edges {
          node {
            ...DealStageFields
          }
        }
      }
    }
  }
}
    ${PipelineFieldsFragmentDoc}
${DealStageFieldsFragmentDoc}`;
export type EditPipelineMutationFn = ApolloReactCommon.MutationFunction<EditPipelineMutation, EditPipelineMutationVariables>;

/**
 * __useEditPipelineMutation__
 *
 * To run a mutation, you first call `useEditPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPipelineMutation, { data, loading, error }] = useEditPipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPipelineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditPipelineMutation, EditPipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditPipelineMutation, EditPipelineMutationVariables>(EditPipelineDocument, options);
      }
export type EditPipelineMutationHookResult = ReturnType<typeof useEditPipelineMutation>;
export type EditPipelineMutationResult = ApolloReactCommon.MutationResult<EditPipelineMutation>;
export type EditPipelineMutationOptions = ApolloReactCommon.BaseMutationOptions<EditPipelineMutation, EditPipelineMutationVariables>;
export const DeletePipelineDocument = gql`
    mutation DeletePipeline($input: DeletePipelineInput!) {
  deletePipeline(input: $input) {
    ok
    pipeline {
      id
      deleted
    }
  }
}
    `;
export type DeletePipelineMutationFn = ApolloReactCommon.MutationFunction<DeletePipelineMutation, DeletePipelineMutationVariables>;

/**
 * __useDeletePipelineMutation__
 *
 * To run a mutation, you first call `useDeletePipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePipelineMutation, { data, loading, error }] = useDeletePipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePipelineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePipelineMutation, DeletePipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePipelineMutation, DeletePipelineMutationVariables>(DeletePipelineDocument, options);
      }
export type DeletePipelineMutationHookResult = ReturnType<typeof useDeletePipelineMutation>;
export type DeletePipelineMutationResult = ApolloReactCommon.MutationResult<DeletePipelineMutation>;
export type DeletePipelineMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePipelineMutation, DeletePipelineMutationVariables>;
export const MoveDealsAndDeletePipelineDocument = gql`
    mutation MoveDealsAndDeletePipeline($input: MoveDealsAndDeletePipelineInput!) {
  moveDealsAndDeletePipeline(input: $input) {
    ok
    movedDealsCount
    fromPipeline {
      id
      deleted
    }
    toPipeline {
      id
    }
  }
}
    `;
export type MoveDealsAndDeletePipelineMutationFn = ApolloReactCommon.MutationFunction<MoveDealsAndDeletePipelineMutation, MoveDealsAndDeletePipelineMutationVariables>;

/**
 * __useMoveDealsAndDeletePipelineMutation__
 *
 * To run a mutation, you first call `useMoveDealsAndDeletePipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveDealsAndDeletePipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveDealsAndDeletePipelineMutation, { data, loading, error }] = useMoveDealsAndDeletePipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveDealsAndDeletePipelineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveDealsAndDeletePipelineMutation, MoveDealsAndDeletePipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveDealsAndDeletePipelineMutation, MoveDealsAndDeletePipelineMutationVariables>(MoveDealsAndDeletePipelineDocument, options);
      }
export type MoveDealsAndDeletePipelineMutationHookResult = ReturnType<typeof useMoveDealsAndDeletePipelineMutation>;
export type MoveDealsAndDeletePipelineMutationResult = ApolloReactCommon.MutationResult<MoveDealsAndDeletePipelineMutation>;
export type MoveDealsAndDeletePipelineMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveDealsAndDeletePipelineMutation, MoveDealsAndDeletePipelineMutationVariables>;
export const GetDealsDocument = gql`
    query getDeals($first: Int, $after: String, $filter: DealFilter, $sort: [SortInput]) {
  deals(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        ...DealFields
        ...DealRelations
        snapshots {
          ...DealSnapshotFields
        }
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${DealFieldsFragmentDoc}
${DealRelationsFragmentDoc}
${DealSnapshotFieldsFragmentDoc}`;

/**
 * __useGetDealsQuery__
 *
 * To run a query within a React component, call `useGetDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetDealsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDealsQuery, GetDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealsQuery, GetDealsQueryVariables>(GetDealsDocument, options);
      }
export function useGetDealsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealsQuery, GetDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealsQuery, GetDealsQueryVariables>(GetDealsDocument, options);
        }
// @ts-ignore
export function useGetDealsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDealsQuery, GetDealsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealsQuery, GetDealsQueryVariables>;
export function useGetDealsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealsQuery, GetDealsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealsQuery | undefined, GetDealsQueryVariables>;
export function useGetDealsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealsQuery, GetDealsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealsQuery, GetDealsQueryVariables>(GetDealsDocument, options);
        }
export type GetDealsQueryHookResult = ReturnType<typeof useGetDealsQuery>;
export type GetDealsLazyQueryHookResult = ReturnType<typeof useGetDealsLazyQuery>;
export type GetDealsSuspenseQueryHookResult = ReturnType<typeof useGetDealsSuspenseQuery>;
export type GetDealsQueryResult = ApolloReactCommon.QueryResult<GetDealsQuery, GetDealsQueryVariables>;
export const GetDealDocument = gql`
    query getDeal($id: ID!) {
  deal(id: $id) {
    ...DealFields
    properties {
      aiSummary
    }
    ...DealRelations
    userLists {
      edges {
        node {
          list {
            ...ListFields
          }
        }
      }
    }
  }
}
    ${DealFieldsFragmentDoc}
${DealRelationsFragmentDoc}
${ListFieldsFragmentDoc}`;

/**
 * __useGetDealQuery__
 *
 * To run a query within a React component, call `useGetDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDealQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealQuery, GetDealQueryVariables> & ({ variables: GetDealQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealQuery, GetDealQueryVariables>(GetDealDocument, options);
      }
export function useGetDealLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealQuery, GetDealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealQuery, GetDealQueryVariables>(GetDealDocument, options);
        }
// @ts-ignore
export function useGetDealSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDealQuery, GetDealQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealQuery, GetDealQueryVariables>;
export function useGetDealSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealQuery, GetDealQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealQuery | undefined, GetDealQueryVariables>;
export function useGetDealSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealQuery, GetDealQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealQuery, GetDealQueryVariables>(GetDealDocument, options);
        }
export type GetDealQueryHookResult = ReturnType<typeof useGetDealQuery>;
export type GetDealLazyQueryHookResult = ReturnType<typeof useGetDealLazyQuery>;
export type GetDealSuspenseQueryHookResult = ReturnType<typeof useGetDealSuspenseQuery>;
export type GetDealQueryResult = ApolloReactCommon.QueryResult<GetDealQuery, GetDealQueryVariables>;
export const CreateDealDocument = gql`
    mutation createDeal($input: CreateDealInput!) {
  createDeal(input: $input) {
    deal {
      ...DealFields
      ...DealRelations
    }
  }
}
    ${DealFieldsFragmentDoc}
${DealRelationsFragmentDoc}`;
export type CreateDealMutationFn = ApolloReactCommon.MutationFunction<CreateDealMutation, CreateDealMutationVariables>;

/**
 * __useCreateDealMutation__
 *
 * To run a mutation, you first call `useCreateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealMutation, { data, loading, error }] = useCreateDealMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDealMutation, CreateDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDealMutation, CreateDealMutationVariables>(CreateDealDocument, options);
      }
export type CreateDealMutationHookResult = ReturnType<typeof useCreateDealMutation>;
export type CreateDealMutationResult = ApolloReactCommon.MutationResult<CreateDealMutation>;
export type CreateDealMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDealMutation, CreateDealMutationVariables>;
export const UpdateDealDocument = gql`
    mutation updateDeal($input: UpdateDealInput!) {
  updateDeal(input: $input) {
    deal {
      ...DealFields
      ...DealRelations
      userLists {
        edges {
          node {
            list {
              ...ListFields
            }
          }
        }
      }
    }
  }
}
    ${DealFieldsFragmentDoc}
${DealRelationsFragmentDoc}
${ListFieldsFragmentDoc}`;
export type UpdateDealMutationFn = ApolloReactCommon.MutationFunction<UpdateDealMutation, UpdateDealMutationVariables>;

/**
 * __useUpdateDealMutation__
 *
 * To run a mutation, you first call `useUpdateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealMutation, { data, loading, error }] = useUpdateDealMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDealMutation, UpdateDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDealMutation, UpdateDealMutationVariables>(UpdateDealDocument, options);
      }
export type UpdateDealMutationHookResult = ReturnType<typeof useUpdateDealMutation>;
export type UpdateDealMutationResult = ApolloReactCommon.MutationResult<UpdateDealMutation>;
export type UpdateDealMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDealMutation, UpdateDealMutationVariables>;
export const DeleteDealDocument = gql`
    mutation deleteDeal($id: ID!) {
  deleteDeal(id: $id) {
    success
  }
}
    `;
export type DeleteDealMutationFn = ApolloReactCommon.MutationFunction<DeleteDealMutation, DeleteDealMutationVariables>;

/**
 * __useDeleteDealMutation__
 *
 * To run a mutation, you first call `useDeleteDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDealMutation, { data, loading, error }] = useDeleteDealMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDealMutation, DeleteDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDealMutation, DeleteDealMutationVariables>(DeleteDealDocument, options);
      }
export type DeleteDealMutationHookResult = ReturnType<typeof useDeleteDealMutation>;
export type DeleteDealMutationResult = ApolloReactCommon.MutationResult<DeleteDealMutation>;
export type DeleteDealMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDealMutation, DeleteDealMutationVariables>;
export const DealCreationFieldSettingsDocument = gql`
    query DealCreationFieldSettings($workspaceId: ID!, $workspaceIdInt: Int, $platform: CrmIngestionPlatform!, $first: Int, $pipelineId: ID) {
  dealCreationFields(workspaceId: $workspaceId, pipelineId: $pipelineId) {
    id
    kind
    standardKey
    required
    position
    crmField {
      id
      crmLabel
      crmName
      customFieldType
      isEnumeration
      enumerationData
      objectType
      isStandardField
    }
  }
  crmIngestionFields(
    workspaceId: $workspaceIdInt
    platform: $platform
    first: $first
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        workspaceId
        platform
        objectType
        sourceExternalId
        isStandardField
        crmLabel
        crmName
        sourceName
        crmFieldType
        sourceFieldType
        isEnumeration
        enumerationData
        availableInGrid
        availableInRevgpt
        syncBack
        syncBackDestinationName
        customFieldType
        syncForward
      }
      cursor
    }
  }
}
    `;

/**
 * __useDealCreationFieldSettingsQuery__
 *
 * To run a query within a React component, call `useDealCreationFieldSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealCreationFieldSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealCreationFieldSettingsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      workspaceIdInt: // value for 'workspaceIdInt'
 *      platform: // value for 'platform'
 *      first: // value for 'first'
 *      pipelineId: // value for 'pipelineId'
 *   },
 * });
 */
export function useDealCreationFieldSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DealCreationFieldSettingsQuery, DealCreationFieldSettingsQueryVariables> & ({ variables: DealCreationFieldSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DealCreationFieldSettingsQuery, DealCreationFieldSettingsQueryVariables>(DealCreationFieldSettingsDocument, options);
      }
export function useDealCreationFieldSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealCreationFieldSettingsQuery, DealCreationFieldSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DealCreationFieldSettingsQuery, DealCreationFieldSettingsQueryVariables>(DealCreationFieldSettingsDocument, options);
        }
// @ts-ignore
export function useDealCreationFieldSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DealCreationFieldSettingsQuery, DealCreationFieldSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DealCreationFieldSettingsQuery, DealCreationFieldSettingsQueryVariables>;
export function useDealCreationFieldSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DealCreationFieldSettingsQuery, DealCreationFieldSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DealCreationFieldSettingsQuery | undefined, DealCreationFieldSettingsQueryVariables>;
export function useDealCreationFieldSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DealCreationFieldSettingsQuery, DealCreationFieldSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DealCreationFieldSettingsQuery, DealCreationFieldSettingsQueryVariables>(DealCreationFieldSettingsDocument, options);
        }
export type DealCreationFieldSettingsQueryHookResult = ReturnType<typeof useDealCreationFieldSettingsQuery>;
export type DealCreationFieldSettingsLazyQueryHookResult = ReturnType<typeof useDealCreationFieldSettingsLazyQuery>;
export type DealCreationFieldSettingsSuspenseQueryHookResult = ReturnType<typeof useDealCreationFieldSettingsSuspenseQuery>;
export type DealCreationFieldSettingsQueryResult = ApolloReactCommon.QueryResult<DealCreationFieldSettingsQuery, DealCreationFieldSettingsQueryVariables>;
export const UpdateDealCreationFieldsDocument = gql`
    mutation UpdateDealCreationFields($workspaceId: ID!, $pipelineId: ID, $fields: [DealCreationFieldConfigInput!]!) {
  updateDealCreationFields(
    workspaceId: $workspaceId
    pipelineId: $pipelineId
    fields: $fields
  ) {
    ok
    fields {
      id
      kind
      standardKey
      required
      position
      crmField {
        id
        crmLabel
      }
    }
  }
}
    `;
export type UpdateDealCreationFieldsMutationFn = ApolloReactCommon.MutationFunction<UpdateDealCreationFieldsMutation, UpdateDealCreationFieldsMutationVariables>;

/**
 * __useUpdateDealCreationFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateDealCreationFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealCreationFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealCreationFieldsMutation, { data, loading, error }] = useUpdateDealCreationFieldsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      pipelineId: // value for 'pipelineId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateDealCreationFieldsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDealCreationFieldsMutation, UpdateDealCreationFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDealCreationFieldsMutation, UpdateDealCreationFieldsMutationVariables>(UpdateDealCreationFieldsDocument, options);
      }
export type UpdateDealCreationFieldsMutationHookResult = ReturnType<typeof useUpdateDealCreationFieldsMutation>;
export type UpdateDealCreationFieldsMutationResult = ApolloReactCommon.MutationResult<UpdateDealCreationFieldsMutation>;
export type UpdateDealCreationFieldsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDealCreationFieldsMutation, UpdateDealCreationFieldsMutationVariables>;
export const CreateDesktopCodeDocument = gql`
    mutation CreateDesktopCode($workspaceId: ID!) {
  createDesktopPairingCode(workspaceId: $workspaceId) {
    code
    expiresAt
  }
}
    `;
export type CreateDesktopCodeMutationFn = ApolloReactCommon.MutationFunction<CreateDesktopCodeMutation, CreateDesktopCodeMutationVariables>;

/**
 * __useCreateDesktopCodeMutation__
 *
 * To run a mutation, you first call `useCreateDesktopCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDesktopCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDesktopCodeMutation, { data, loading, error }] = useCreateDesktopCodeMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCreateDesktopCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDesktopCodeMutation, CreateDesktopCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDesktopCodeMutation, CreateDesktopCodeMutationVariables>(CreateDesktopCodeDocument, options);
      }
export type CreateDesktopCodeMutationHookResult = ReturnType<typeof useCreateDesktopCodeMutation>;
export type CreateDesktopCodeMutationResult = ApolloReactCommon.MutationResult<CreateDesktopCodeMutation>;
export type CreateDesktopCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDesktopCodeMutation, CreateDesktopCodeMutationVariables>;
export const GetEmailTemplatesDocument = gql`
    query GetEmailTemplates($workspaceId: Int!) {
  emailTemplates(workspaceId: $workspaceId) {
    id
    title
    subject
    body
    attachmentUrls
  }
}
    `;

/**
 * __useGetEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplatesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetEmailTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables> & ({ variables: GetEmailTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
      }
export function useGetEmailTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
        }
// @ts-ignore
export function useGetEmailTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>;
export function useGetEmailTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEmailTemplatesQuery | undefined, GetEmailTemplatesQueryVariables>;
export function useGetEmailTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
        }
export type GetEmailTemplatesQueryHookResult = ReturnType<typeof useGetEmailTemplatesQuery>;
export type GetEmailTemplatesLazyQueryHookResult = ReturnType<typeof useGetEmailTemplatesLazyQuery>;
export type GetEmailTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetEmailTemplatesSuspenseQuery>;
export type GetEmailTemplatesQueryResult = ApolloReactCommon.QueryResult<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>;
export const CreateEmailTemplateDocument = gql`
    mutation CreateEmailTemplate($input: CreateEmailTemplateInput!) {
  createEmailTemplate(input: $input) {
    emailTemplate {
      id
      title
      subject
      body
      attachmentUrls
    }
  }
}
    `;
export type CreateEmailTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>;

/**
 * __useCreateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useCreateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailTemplateMutation, { data, loading, error }] = useCreateEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmailTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>(CreateEmailTemplateDocument, options);
      }
export type CreateEmailTemplateMutationHookResult = ReturnType<typeof useCreateEmailTemplateMutation>;
export type CreateEmailTemplateMutationResult = ApolloReactCommon.MutationResult<CreateEmailTemplateMutation>;
export type CreateEmailTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>;
export const UpdateEmailTemplateDocument = gql`
    mutation UpdateEmailTemplate($input: UpdateEmailTemplateInput!) {
  updateEmailTemplate(input: $input) {
    emailTemplate {
      id
      title
      subject
      body
      attachmentUrls
    }
  }
}
    `;
export type UpdateEmailTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;

/**
 * __useUpdateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailTemplateMutation, { data, loading, error }] = useUpdateEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>(UpdateEmailTemplateDocument, options);
      }
export type UpdateEmailTemplateMutationHookResult = ReturnType<typeof useUpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;
export const DeleteEmailTemplateDocument = gql`
    mutation DeleteEmailTemplate($input: DeleteEmailTemplateInput!) {
  deleteEmailTemplate(input: $input) {
    success
  }
}
    `;
export type DeleteEmailTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;

/**
 * __useDeleteEmailTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailTemplateMutation, { data, loading, error }] = useDeleteEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEmailTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>(DeleteEmailTemplateDocument, options);
      }
export type DeleteEmailTemplateMutationHookResult = ReturnType<typeof useDeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;
export const CreateDefaultEmailTemplatesDocument = gql`
    mutation CreateDefaultEmailTemplates($workspaceId: Int!) {
  createDefaultEmailTemplates(workspaceId: $workspaceId) {
    emailTemplates {
      id
      title
      subject
      body
      attachmentUrls
    }
  }
}
    `;
export type CreateDefaultEmailTemplatesMutationFn = ApolloReactCommon.MutationFunction<CreateDefaultEmailTemplatesMutation, CreateDefaultEmailTemplatesMutationVariables>;

/**
 * __useCreateDefaultEmailTemplatesMutation__
 *
 * To run a mutation, you first call `useCreateDefaultEmailTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDefaultEmailTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDefaultEmailTemplatesMutation, { data, loading, error }] = useCreateDefaultEmailTemplatesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCreateDefaultEmailTemplatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDefaultEmailTemplatesMutation, CreateDefaultEmailTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDefaultEmailTemplatesMutation, CreateDefaultEmailTemplatesMutationVariables>(CreateDefaultEmailTemplatesDocument, options);
      }
export type CreateDefaultEmailTemplatesMutationHookResult = ReturnType<typeof useCreateDefaultEmailTemplatesMutation>;
export type CreateDefaultEmailTemplatesMutationResult = ApolloReactCommon.MutationResult<CreateDefaultEmailTemplatesMutation>;
export type CreateDefaultEmailTemplatesMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDefaultEmailTemplatesMutation, CreateDefaultEmailTemplatesMutationVariables>;
export const SendEmailsDocument = gql`
    mutation SendEmails($workspaceId: Int!, $fromEmail: String!, $fromName: String!, $sendIndividually: Boolean!, $subject: String, $body: String, $toEmails: [String], $ccEmails: [String], $bccEmails: [String], $resolvedEmails: [ResolvedEmailInput], $attachmentUrls: [String]) {
  sendEmails(
    workspaceId: $workspaceId
    fromEmail: $fromEmail
    fromName: $fromName
    sendIndividually: $sendIndividually
    subject: $subject
    body: $body
    toEmails: $toEmails
    ccEmails: $ccEmails
    bccEmails: $bccEmails
    resolvedEmails: $resolvedEmails
    attachmentUrls: $attachmentUrls
  ) {
    ok
  }
}
    `;
export type SendEmailsMutationFn = ApolloReactCommon.MutationFunction<SendEmailsMutation, SendEmailsMutationVariables>;

/**
 * __useSendEmailsMutation__
 *
 * To run a mutation, you first call `useSendEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailsMutation, { data, loading, error }] = useSendEmailsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      fromEmail: // value for 'fromEmail'
 *      fromName: // value for 'fromName'
 *      sendIndividually: // value for 'sendIndividually'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      toEmails: // value for 'toEmails'
 *      ccEmails: // value for 'ccEmails'
 *      bccEmails: // value for 'bccEmails'
 *      resolvedEmails: // value for 'resolvedEmails'
 *      attachmentUrls: // value for 'attachmentUrls'
 *   },
 * });
 */
export function useSendEmailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailsMutation, SendEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendEmailsMutation, SendEmailsMutationVariables>(SendEmailsDocument, options);
      }
export type SendEmailsMutationHookResult = ReturnType<typeof useSendEmailsMutation>;
export type SendEmailsMutationResult = ApolloReactCommon.MutationResult<SendEmailsMutation>;
export type SendEmailsMutationOptions = ApolloReactCommon.BaseMutationOptions<SendEmailsMutation, SendEmailsMutationVariables>;
export const GetEngagementsListDocument = gql`
    query getEngagementsList($first: Int, $after: String, $filter: EngagementFilter!, $sort: [SortInput]) {
  engagements(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        ...BaseEngagementFields
        accounts {
          ...AccountBaseFields
        }
        contacts {
          ...ContactBaseFields
        }
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${BaseEngagementFieldsFragmentDoc}
${AccountBaseFieldsFragmentDoc}
${ContactBaseFieldsFragmentDoc}`;

/**
 * __useGetEngagementsListQuery__
 *
 * To run a query within a React component, call `useGetEngagementsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEngagementsListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementsListQuery, GetEngagementsListQueryVariables> & ({ variables: GetEngagementsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementsListQuery, GetEngagementsListQueryVariables>(GetEngagementsListDocument, options);
      }
export function useGetEngagementsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementsListQuery, GetEngagementsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementsListQuery, GetEngagementsListQueryVariables>(GetEngagementsListDocument, options);
        }
// @ts-ignore
export function useGetEngagementsListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementsListQuery, GetEngagementsListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementsListQuery, GetEngagementsListQueryVariables>;
export function useGetEngagementsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementsListQuery, GetEngagementsListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementsListQuery | undefined, GetEngagementsListQueryVariables>;
export function useGetEngagementsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementsListQuery, GetEngagementsListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementsListQuery, GetEngagementsListQueryVariables>(GetEngagementsListDocument, options);
        }
export type GetEngagementsListQueryHookResult = ReturnType<typeof useGetEngagementsListQuery>;
export type GetEngagementsListLazyQueryHookResult = ReturnType<typeof useGetEngagementsListLazyQuery>;
export type GetEngagementsListSuspenseQueryHookResult = ReturnType<typeof useGetEngagementsListSuspenseQuery>;
export type GetEngagementsListQueryResult = ApolloReactCommon.QueryResult<GetEngagementsListQuery, GetEngagementsListQueryVariables>;
export const GetEngagementsDocument = gql`
    query getEngagements($first: Int, $after: String, $filter: EngagementFilter!, $sort: [SortInput]) {
  engagements(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        ...EngagementFields
        contacts {
          ...ContactBaseFields
        }
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${EngagementFieldsFragmentDoc}
${ContactBaseFieldsFragmentDoc}`;

/**
 * __useGetEngagementsQuery__
 *
 * To run a query within a React component, call `useGetEngagementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEngagementsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementsQuery, GetEngagementsQueryVariables> & ({ variables: GetEngagementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementsQuery, GetEngagementsQueryVariables>(GetEngagementsDocument, options);
      }
export function useGetEngagementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementsQuery, GetEngagementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementsQuery, GetEngagementsQueryVariables>(GetEngagementsDocument, options);
        }
// @ts-ignore
export function useGetEngagementsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementsQuery, GetEngagementsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementsQuery, GetEngagementsQueryVariables>;
export function useGetEngagementsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementsQuery, GetEngagementsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementsQuery | undefined, GetEngagementsQueryVariables>;
export function useGetEngagementsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementsQuery, GetEngagementsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementsQuery, GetEngagementsQueryVariables>(GetEngagementsDocument, options);
        }
export type GetEngagementsQueryHookResult = ReturnType<typeof useGetEngagementsQuery>;
export type GetEngagementsLazyQueryHookResult = ReturnType<typeof useGetEngagementsLazyQuery>;
export type GetEngagementsSuspenseQueryHookResult = ReturnType<typeof useGetEngagementsSuspenseQuery>;
export type GetEngagementsQueryResult = ApolloReactCommon.QueryResult<GetEngagementsQuery, GetEngagementsQueryVariables>;
export const GetEngagementsBaseDocument = gql`
    query getEngagementsBase($first: Int, $after: String, $filter: EngagementFilter!, $sort: [SortInput]) {
  engagements(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        ...BaseEngagementFields
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${BaseEngagementFieldsFragmentDoc}`;

/**
 * __useGetEngagementsBaseQuery__
 *
 * To run a query within a React component, call `useGetEngagementsBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementsBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementsBaseQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEngagementsBaseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementsBaseQuery, GetEngagementsBaseQueryVariables> & ({ variables: GetEngagementsBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementsBaseQuery, GetEngagementsBaseQueryVariables>(GetEngagementsBaseDocument, options);
      }
export function useGetEngagementsBaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementsBaseQuery, GetEngagementsBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementsBaseQuery, GetEngagementsBaseQueryVariables>(GetEngagementsBaseDocument, options);
        }
// @ts-ignore
export function useGetEngagementsBaseSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementsBaseQuery, GetEngagementsBaseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementsBaseQuery, GetEngagementsBaseQueryVariables>;
export function useGetEngagementsBaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementsBaseQuery, GetEngagementsBaseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementsBaseQuery | undefined, GetEngagementsBaseQueryVariables>;
export function useGetEngagementsBaseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementsBaseQuery, GetEngagementsBaseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementsBaseQuery, GetEngagementsBaseQueryVariables>(GetEngagementsBaseDocument, options);
        }
export type GetEngagementsBaseQueryHookResult = ReturnType<typeof useGetEngagementsBaseQuery>;
export type GetEngagementsBaseLazyQueryHookResult = ReturnType<typeof useGetEngagementsBaseLazyQuery>;
export type GetEngagementsBaseSuspenseQueryHookResult = ReturnType<typeof useGetEngagementsBaseSuspenseQuery>;
export type GetEngagementsBaseQueryResult = ApolloReactCommon.QueryResult<GetEngagementsBaseQuery, GetEngagementsBaseQueryVariables>;
export const GetEngagementDocument = gql`
    query getEngagement($id: ID!, $workspaceId: ID!) {
  engagement(id: $id, workspaceId: $workspaceId) {
    ...EngagementFields
    ...EngagementRelations
    ...EngagementTranscript
    ...EngagementSummaries
    ...EngagementTaskSuggestions
  }
}
    ${EngagementFieldsFragmentDoc}
${EngagementRelationsFragmentDoc}
${EngagementTranscriptFragmentDoc}
${EngagementSummariesFragmentDoc}
${EngagementTaskSuggestionsFragmentDoc}`;

/**
 * __useGetEngagementQuery__
 *
 * To run a query within a React component, call `useGetEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetEngagementQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementQuery, GetEngagementQueryVariables> & ({ variables: GetEngagementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementQuery, GetEngagementQueryVariables>(GetEngagementDocument, options);
      }
export function useGetEngagementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementQuery, GetEngagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementQuery, GetEngagementQueryVariables>(GetEngagementDocument, options);
        }
// @ts-ignore
export function useGetEngagementSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementQuery, GetEngagementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementQuery, GetEngagementQueryVariables>;
export function useGetEngagementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementQuery, GetEngagementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementQuery | undefined, GetEngagementQueryVariables>;
export function useGetEngagementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementQuery, GetEngagementQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementQuery, GetEngagementQueryVariables>(GetEngagementDocument, options);
        }
export type GetEngagementQueryHookResult = ReturnType<typeof useGetEngagementQuery>;
export type GetEngagementLazyQueryHookResult = ReturnType<typeof useGetEngagementLazyQuery>;
export type GetEngagementSuspenseQueryHookResult = ReturnType<typeof useGetEngagementSuspenseQuery>;
export type GetEngagementQueryResult = ApolloReactCommon.QueryResult<GetEngagementQuery, GetEngagementQueryVariables>;
export const GetEngagementBriefDocument = gql`
    query getEngagementBrief($id: ID!, $workspaceId: ID!) {
  engagement(id: $id, workspaceId: $workspaceId) {
    ...BaseEngagementFields
    ...EngagementAI
    ...EngagementContacts
  }
}
    ${BaseEngagementFieldsFragmentDoc}
${EngagementAiFragmentDoc}
${EngagementContactsFragmentDoc}`;

/**
 * __useGetEngagementBriefQuery__
 *
 * To run a query within a React component, call `useGetEngagementBriefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementBriefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementBriefQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetEngagementBriefQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementBriefQuery, GetEngagementBriefQueryVariables> & ({ variables: GetEngagementBriefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementBriefQuery, GetEngagementBriefQueryVariables>(GetEngagementBriefDocument, options);
      }
export function useGetEngagementBriefLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementBriefQuery, GetEngagementBriefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementBriefQuery, GetEngagementBriefQueryVariables>(GetEngagementBriefDocument, options);
        }
// @ts-ignore
export function useGetEngagementBriefSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementBriefQuery, GetEngagementBriefQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementBriefQuery, GetEngagementBriefQueryVariables>;
export function useGetEngagementBriefSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementBriefQuery, GetEngagementBriefQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementBriefQuery | undefined, GetEngagementBriefQueryVariables>;
export function useGetEngagementBriefSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementBriefQuery, GetEngagementBriefQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementBriefQuery, GetEngagementBriefQueryVariables>(GetEngagementBriefDocument, options);
        }
export type GetEngagementBriefQueryHookResult = ReturnType<typeof useGetEngagementBriefQuery>;
export type GetEngagementBriefLazyQueryHookResult = ReturnType<typeof useGetEngagementBriefLazyQuery>;
export type GetEngagementBriefSuspenseQueryHookResult = ReturnType<typeof useGetEngagementBriefSuspenseQuery>;
export type GetEngagementBriefQueryResult = ApolloReactCommon.QueryResult<GetEngagementBriefQuery, GetEngagementBriefQueryVariables>;
export const GetEngagementFollowUpDocument = gql`
    query getEngagementFollowUp($id: ID!, $workspaceId: ID!) {
  engagement(id: $id, workspaceId: $workspaceId) {
    ...BaseEngagementFields
    ...EngagementAI
    ...EngagementTranscript
    ...EngagementContacts
  }
}
    ${BaseEngagementFieldsFragmentDoc}
${EngagementAiFragmentDoc}
${EngagementTranscriptFragmentDoc}
${EngagementContactsFragmentDoc}`;

/**
 * __useGetEngagementFollowUpQuery__
 *
 * To run a query within a React component, call `useGetEngagementFollowUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementFollowUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementFollowUpQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetEngagementFollowUpQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementFollowUpQuery, GetEngagementFollowUpQueryVariables> & ({ variables: GetEngagementFollowUpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementFollowUpQuery, GetEngagementFollowUpQueryVariables>(GetEngagementFollowUpDocument, options);
      }
export function useGetEngagementFollowUpLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementFollowUpQuery, GetEngagementFollowUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementFollowUpQuery, GetEngagementFollowUpQueryVariables>(GetEngagementFollowUpDocument, options);
        }
// @ts-ignore
export function useGetEngagementFollowUpSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementFollowUpQuery, GetEngagementFollowUpQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementFollowUpQuery, GetEngagementFollowUpQueryVariables>;
export function useGetEngagementFollowUpSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementFollowUpQuery, GetEngagementFollowUpQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementFollowUpQuery | undefined, GetEngagementFollowUpQueryVariables>;
export function useGetEngagementFollowUpSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementFollowUpQuery, GetEngagementFollowUpQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementFollowUpQuery, GetEngagementFollowUpQueryVariables>(GetEngagementFollowUpDocument, options);
        }
export type GetEngagementFollowUpQueryHookResult = ReturnType<typeof useGetEngagementFollowUpQuery>;
export type GetEngagementFollowUpLazyQueryHookResult = ReturnType<typeof useGetEngagementFollowUpLazyQuery>;
export type GetEngagementFollowUpSuspenseQueryHookResult = ReturnType<typeof useGetEngagementFollowUpSuspenseQuery>;
export type GetEngagementFollowUpQueryResult = ApolloReactCommon.QueryResult<GetEngagementFollowUpQuery, GetEngagementFollowUpQueryVariables>;
export const GetEngagementTranscriptDocument = gql`
    query getEngagementTranscript($id: ID!, $workspaceId: ID!) {
  engagement(id: $id, workspaceId: $workspaceId) {
    ...BaseEngagementFields
    ...EngagementContacts
    ...EngagementTranscript
    ...EngagementAI
  }
}
    ${BaseEngagementFieldsFragmentDoc}
${EngagementContactsFragmentDoc}
${EngagementTranscriptFragmentDoc}
${EngagementAiFragmentDoc}`;

/**
 * __useGetEngagementTranscriptQuery__
 *
 * To run a query within a React component, call `useGetEngagementTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementTranscriptQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetEngagementTranscriptQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementTranscriptQuery, GetEngagementTranscriptQueryVariables> & ({ variables: GetEngagementTranscriptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementTranscriptQuery, GetEngagementTranscriptQueryVariables>(GetEngagementTranscriptDocument, options);
      }
export function useGetEngagementTranscriptLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementTranscriptQuery, GetEngagementTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementTranscriptQuery, GetEngagementTranscriptQueryVariables>(GetEngagementTranscriptDocument, options);
        }
// @ts-ignore
export function useGetEngagementTranscriptSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementTranscriptQuery, GetEngagementTranscriptQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementTranscriptQuery, GetEngagementTranscriptQueryVariables>;
export function useGetEngagementTranscriptSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementTranscriptQuery, GetEngagementTranscriptQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementTranscriptQuery | undefined, GetEngagementTranscriptQueryVariables>;
export function useGetEngagementTranscriptSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementTranscriptQuery, GetEngagementTranscriptQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementTranscriptQuery, GetEngagementTranscriptQueryVariables>(GetEngagementTranscriptDocument, options);
        }
export type GetEngagementTranscriptQueryHookResult = ReturnType<typeof useGetEngagementTranscriptQuery>;
export type GetEngagementTranscriptLazyQueryHookResult = ReturnType<typeof useGetEngagementTranscriptLazyQuery>;
export type GetEngagementTranscriptSuspenseQueryHookResult = ReturnType<typeof useGetEngagementTranscriptSuspenseQuery>;
export type GetEngagementTranscriptQueryResult = ApolloReactCommon.QueryResult<GetEngagementTranscriptQuery, GetEngagementTranscriptQueryVariables>;
export const GetEngagementNoteDocument = gql`
    query getEngagementNote($id: ID!, $workspaceId: ID!) {
  engagement(id: $id, workspaceId: $workspaceId) {
    ...BaseEngagementFields
    ...EngagementContacts
  }
}
    ${BaseEngagementFieldsFragmentDoc}
${EngagementContactsFragmentDoc}`;

/**
 * __useGetEngagementNoteQuery__
 *
 * To run a query within a React component, call `useGetEngagementNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetEngagementNoteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementNoteQuery, GetEngagementNoteQueryVariables> & ({ variables: GetEngagementNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementNoteQuery, GetEngagementNoteQueryVariables>(GetEngagementNoteDocument, options);
      }
export function useGetEngagementNoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementNoteQuery, GetEngagementNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementNoteQuery, GetEngagementNoteQueryVariables>(GetEngagementNoteDocument, options);
        }
// @ts-ignore
export function useGetEngagementNoteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementNoteQuery, GetEngagementNoteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementNoteQuery, GetEngagementNoteQueryVariables>;
export function useGetEngagementNoteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementNoteQuery, GetEngagementNoteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementNoteQuery | undefined, GetEngagementNoteQueryVariables>;
export function useGetEngagementNoteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementNoteQuery, GetEngagementNoteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementNoteQuery, GetEngagementNoteQueryVariables>(GetEngagementNoteDocument, options);
        }
export type GetEngagementNoteQueryHookResult = ReturnType<typeof useGetEngagementNoteQuery>;
export type GetEngagementNoteLazyQueryHookResult = ReturnType<typeof useGetEngagementNoteLazyQuery>;
export type GetEngagementNoteSuspenseQueryHookResult = ReturnType<typeof useGetEngagementNoteSuspenseQuery>;
export type GetEngagementNoteQueryResult = ApolloReactCommon.QueryResult<GetEngagementNoteQuery, GetEngagementNoteQueryVariables>;
export const GetEngagementContentAvailabilityDocument = gql`
    query getEngagementContentAvailability($id: ID!, $workspaceId: ID!, $notesFilter: NoteFilter!) {
  engagement(id: $id, workspaceId: $workspaceId) {
    id
    hasTranscript
    hasAiBrief
    startTime
  }
  notes(filter: $notesFilter, first: 0) {
    totalCount
  }
}
    `;

/**
 * __useGetEngagementContentAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetEngagementContentAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementContentAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementContentAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *      notesFilter: // value for 'notesFilter'
 *   },
 * });
 */
export function useGetEngagementContentAvailabilityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementContentAvailabilityQuery, GetEngagementContentAvailabilityQueryVariables> & ({ variables: GetEngagementContentAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementContentAvailabilityQuery, GetEngagementContentAvailabilityQueryVariables>(GetEngagementContentAvailabilityDocument, options);
      }
export function useGetEngagementContentAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementContentAvailabilityQuery, GetEngagementContentAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementContentAvailabilityQuery, GetEngagementContentAvailabilityQueryVariables>(GetEngagementContentAvailabilityDocument, options);
        }
// @ts-ignore
export function useGetEngagementContentAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementContentAvailabilityQuery, GetEngagementContentAvailabilityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementContentAvailabilityQuery, GetEngagementContentAvailabilityQueryVariables>;
export function useGetEngagementContentAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementContentAvailabilityQuery, GetEngagementContentAvailabilityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementContentAvailabilityQuery | undefined, GetEngagementContentAvailabilityQueryVariables>;
export function useGetEngagementContentAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementContentAvailabilityQuery, GetEngagementContentAvailabilityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementContentAvailabilityQuery, GetEngagementContentAvailabilityQueryVariables>(GetEngagementContentAvailabilityDocument, options);
        }
export type GetEngagementContentAvailabilityQueryHookResult = ReturnType<typeof useGetEngagementContentAvailabilityQuery>;
export type GetEngagementContentAvailabilityLazyQueryHookResult = ReturnType<typeof useGetEngagementContentAvailabilityLazyQuery>;
export type GetEngagementContentAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetEngagementContentAvailabilitySuspenseQuery>;
export type GetEngagementContentAvailabilityQueryResult = ApolloReactCommon.QueryResult<GetEngagementContentAvailabilityQuery, GetEngagementContentAvailabilityQueryVariables>;
export const GetEngagementTaskSuggestionsDocument = gql`
    query getEngagementTaskSuggestions($id: ID!, $workspaceId: ID!) {
  engagement(id: $id, workspaceId: $workspaceId) {
    ...BaseEngagementFields
    ...EngagementTaskSuggestions
    ...EngagementContacts
  }
}
    ${BaseEngagementFieldsFragmentDoc}
${EngagementTaskSuggestionsFragmentDoc}
${EngagementContactsFragmentDoc}`;

/**
 * __useGetEngagementTaskSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetEngagementTaskSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementTaskSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementTaskSuggestionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetEngagementTaskSuggestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementTaskSuggestionsQuery, GetEngagementTaskSuggestionsQueryVariables> & ({ variables: GetEngagementTaskSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementTaskSuggestionsQuery, GetEngagementTaskSuggestionsQueryVariables>(GetEngagementTaskSuggestionsDocument, options);
      }
export function useGetEngagementTaskSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementTaskSuggestionsQuery, GetEngagementTaskSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementTaskSuggestionsQuery, GetEngagementTaskSuggestionsQueryVariables>(GetEngagementTaskSuggestionsDocument, options);
        }
// @ts-ignore
export function useGetEngagementTaskSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementTaskSuggestionsQuery, GetEngagementTaskSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementTaskSuggestionsQuery, GetEngagementTaskSuggestionsQueryVariables>;
export function useGetEngagementTaskSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementTaskSuggestionsQuery, GetEngagementTaskSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementTaskSuggestionsQuery | undefined, GetEngagementTaskSuggestionsQueryVariables>;
export function useGetEngagementTaskSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementTaskSuggestionsQuery, GetEngagementTaskSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementTaskSuggestionsQuery, GetEngagementTaskSuggestionsQueryVariables>(GetEngagementTaskSuggestionsDocument, options);
        }
export type GetEngagementTaskSuggestionsQueryHookResult = ReturnType<typeof useGetEngagementTaskSuggestionsQuery>;
export type GetEngagementTaskSuggestionsLazyQueryHookResult = ReturnType<typeof useGetEngagementTaskSuggestionsLazyQuery>;
export type GetEngagementTaskSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetEngagementTaskSuggestionsSuspenseQuery>;
export type GetEngagementTaskSuggestionsQueryResult = ApolloReactCommon.QueryResult<GetEngagementTaskSuggestionsQuery, GetEngagementTaskSuggestionsQueryVariables>;
export const GetEngagementDealSuggestionsDocument = gql`
    query getEngagementDealSuggestions($id: ID!, $workspaceId: ID!) {
  engagement(id: $id, workspaceId: $workspaceId) {
    ...BaseEngagementFields
    ...EngagementDealSuggestions
    ...EngagementContacts
  }
}
    ${BaseEngagementFieldsFragmentDoc}
${EngagementDealSuggestionsFragmentDoc}
${EngagementContactsFragmentDoc}`;

/**
 * __useGetEngagementDealSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetEngagementDealSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementDealSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementDealSuggestionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetEngagementDealSuggestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEngagementDealSuggestionsQuery, GetEngagementDealSuggestionsQueryVariables> & ({ variables: GetEngagementDealSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEngagementDealSuggestionsQuery, GetEngagementDealSuggestionsQueryVariables>(GetEngagementDealSuggestionsDocument, options);
      }
export function useGetEngagementDealSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEngagementDealSuggestionsQuery, GetEngagementDealSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEngagementDealSuggestionsQuery, GetEngagementDealSuggestionsQueryVariables>(GetEngagementDealSuggestionsDocument, options);
        }
// @ts-ignore
export function useGetEngagementDealSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementDealSuggestionsQuery, GetEngagementDealSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementDealSuggestionsQuery, GetEngagementDealSuggestionsQueryVariables>;
export function useGetEngagementDealSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementDealSuggestionsQuery, GetEngagementDealSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEngagementDealSuggestionsQuery | undefined, GetEngagementDealSuggestionsQueryVariables>;
export function useGetEngagementDealSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEngagementDealSuggestionsQuery, GetEngagementDealSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEngagementDealSuggestionsQuery, GetEngagementDealSuggestionsQueryVariables>(GetEngagementDealSuggestionsDocument, options);
        }
export type GetEngagementDealSuggestionsQueryHookResult = ReturnType<typeof useGetEngagementDealSuggestionsQuery>;
export type GetEngagementDealSuggestionsLazyQueryHookResult = ReturnType<typeof useGetEngagementDealSuggestionsLazyQuery>;
export type GetEngagementDealSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetEngagementDealSuggestionsSuspenseQuery>;
export type GetEngagementDealSuggestionsQueryResult = ApolloReactCommon.QueryResult<GetEngagementDealSuggestionsQuery, GetEngagementDealSuggestionsQueryVariables>;
export const AcceptDealSuggestionDocument = gql`
    mutation AcceptDealSuggestion($input: AcceptDealSuggestionInput!) {
  acceptDealSuggestion(input: $input) {
    dealSuggestion {
      id
      isAccepted
      isDismissed
    }
  }
}
    `;
export type AcceptDealSuggestionMutationFn = ApolloReactCommon.MutationFunction<AcceptDealSuggestionMutation, AcceptDealSuggestionMutationVariables>;

/**
 * __useAcceptDealSuggestionMutation__
 *
 * To run a mutation, you first call `useAcceptDealSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptDealSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptDealSuggestionMutation, { data, loading, error }] = useAcceptDealSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptDealSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptDealSuggestionMutation, AcceptDealSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptDealSuggestionMutation, AcceptDealSuggestionMutationVariables>(AcceptDealSuggestionDocument, options);
      }
export type AcceptDealSuggestionMutationHookResult = ReturnType<typeof useAcceptDealSuggestionMutation>;
export type AcceptDealSuggestionMutationResult = ApolloReactCommon.MutationResult<AcceptDealSuggestionMutation>;
export type AcceptDealSuggestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptDealSuggestionMutation, AcceptDealSuggestionMutationVariables>;
export const AcceptTaskSuggestionDocument = gql`
    mutation AcceptTaskSuggestion($input: AcceptTaskSuggestionInput!) {
  acceptTaskSuggestion(input: $input) {
    taskSuggestion {
      id
      title
      isAccepted
      isDismissed
    }
  }
}
    `;
export type AcceptTaskSuggestionMutationFn = ApolloReactCommon.MutationFunction<AcceptTaskSuggestionMutation, AcceptTaskSuggestionMutationVariables>;

/**
 * __useAcceptTaskSuggestionMutation__
 *
 * To run a mutation, you first call `useAcceptTaskSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTaskSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTaskSuggestionMutation, { data, loading, error }] = useAcceptTaskSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptTaskSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptTaskSuggestionMutation, AcceptTaskSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptTaskSuggestionMutation, AcceptTaskSuggestionMutationVariables>(AcceptTaskSuggestionDocument, options);
      }
export type AcceptTaskSuggestionMutationHookResult = ReturnType<typeof useAcceptTaskSuggestionMutation>;
export type AcceptTaskSuggestionMutationResult = ApolloReactCommon.MutationResult<AcceptTaskSuggestionMutation>;
export type AcceptTaskSuggestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptTaskSuggestionMutation, AcceptTaskSuggestionMutationVariables>;
export const ShareEngagementDocument = gql`
    mutation shareEngagement($workspaceId: Int!, $engagementId: String!, $notifyOnView: Boolean, $summaryTemplateId: String) {
  shareEngagement(
    workspaceId: $workspaceId
    engagementId: $engagementId
    notifyOnView: $notifyOnView
    summaryTemplateId: $summaryTemplateId
  ) {
    ok
    message
    slug
    notifyOnView
  }
}
    `;
export type ShareEngagementMutationFn = ApolloReactCommon.MutationFunction<ShareEngagementMutation, ShareEngagementMutationVariables>;

/**
 * __useShareEngagementMutation__
 *
 * To run a mutation, you first call `useShareEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareEngagementMutation, { data, loading, error }] = useShareEngagementMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      engagementId: // value for 'engagementId'
 *      notifyOnView: // value for 'notifyOnView'
 *      summaryTemplateId: // value for 'summaryTemplateId'
 *   },
 * });
 */
export function useShareEngagementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShareEngagementMutation, ShareEngagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShareEngagementMutation, ShareEngagementMutationVariables>(ShareEngagementDocument, options);
      }
export type ShareEngagementMutationHookResult = ReturnType<typeof useShareEngagementMutation>;
export type ShareEngagementMutationResult = ApolloReactCommon.MutationResult<ShareEngagementMutation>;
export type ShareEngagementMutationOptions = ApolloReactCommon.BaseMutationOptions<ShareEngagementMutation, ShareEngagementMutationVariables>;
export const EngagementBasicDocument = gql`
    query engagementBasic($slug: String!) {
  engagementBasic(slug: $slug) {
    displayName
    startTime
    sharedBy {
      givenName
      surname
      profileImageUrl
    }
  }
}
    `;

/**
 * __useEngagementBasicQuery__
 *
 * To run a query within a React component, call `useEngagementBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementBasicQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useEngagementBasicQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EngagementBasicQuery, EngagementBasicQueryVariables> & ({ variables: EngagementBasicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EngagementBasicQuery, EngagementBasicQueryVariables>(EngagementBasicDocument, options);
      }
export function useEngagementBasicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EngagementBasicQuery, EngagementBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EngagementBasicQuery, EngagementBasicQueryVariables>(EngagementBasicDocument, options);
        }
// @ts-ignore
export function useEngagementBasicSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EngagementBasicQuery, EngagementBasicQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EngagementBasicQuery, EngagementBasicQueryVariables>;
export function useEngagementBasicSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EngagementBasicQuery, EngagementBasicQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EngagementBasicQuery | undefined, EngagementBasicQueryVariables>;
export function useEngagementBasicSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EngagementBasicQuery, EngagementBasicQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EngagementBasicQuery, EngagementBasicQueryVariables>(EngagementBasicDocument, options);
        }
export type EngagementBasicQueryHookResult = ReturnType<typeof useEngagementBasicQuery>;
export type EngagementBasicLazyQueryHookResult = ReturnType<typeof useEngagementBasicLazyQuery>;
export type EngagementBasicSuspenseQueryHookResult = ReturnType<typeof useEngagementBasicSuspenseQuery>;
export type EngagementBasicQueryResult = ApolloReactCommon.QueryResult<EngagementBasicQuery, EngagementBasicQueryVariables>;
export const TrackEngagementViewDocument = gql`
    mutation TrackEngagementView($slug: String!, $email: String!, $name: String!) {
  trackEngagementView(slug: $slug, email: $email, name: $name) {
    name
    aiSummary
    platform
    summaries {
      id
      engagementId
      summaryTemplateId
      summary
      createdAt
      updatedAt
    }
    summaryTemplates {
      id
      name
      isDefault
      sections {
        heading
        prompt
        order
      }
    }
    recallTranscript {
      speaker
      speakerId
      language
      words {
        text
        startTimestamp
        endTimestamp
        confidence
        language
      }
    }
    gongTranscript {
      speaker
      speakerId
      language
      words {
        text
        startTimestamp
        endTimestamp
      }
    }
    granolaTranscript {
      speaker
      speakerId
      language
      words {
        text
        startTimestamp
        endTimestamp
      }
    }
    firefliesTranscript {
      speaker
      speakerId
      language
      words {
        text
        startTimestamp
        endTimestamp
      }
    }
    recallVideoUrl
    coffeeVideoUrl
    gongVideoUrl
    firefliesVideoUrl
    sharedBy {
      givenName
      surname
      profileImageUrl
    }
    note {
      id
      title
      createdAt
      updatedAt
      aiGenerated
      aiNotesContent
      blocks
      user {
        id
        givenName
        surname
      }
    }
    contacts {
      ...ContactBaseFields
      accounts {
        edges {
          node {
            ...AccountBaseFields
          }
        }
      }
    }
  }
}
    ${ContactBaseFieldsFragmentDoc}
${AccountBaseFieldsFragmentDoc}`;
export type TrackEngagementViewMutationFn = ApolloReactCommon.MutationFunction<TrackEngagementViewMutation, TrackEngagementViewMutationVariables>;

/**
 * __useTrackEngagementViewMutation__
 *
 * To run a mutation, you first call `useTrackEngagementViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackEngagementViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackEngagementViewMutation, { data, loading, error }] = useTrackEngagementViewMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTrackEngagementViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TrackEngagementViewMutation, TrackEngagementViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TrackEngagementViewMutation, TrackEngagementViewMutationVariables>(TrackEngagementViewDocument, options);
      }
export type TrackEngagementViewMutationHookResult = ReturnType<typeof useTrackEngagementViewMutation>;
export type TrackEngagementViewMutationResult = ApolloReactCommon.MutationResult<TrackEngagementViewMutation>;
export type TrackEngagementViewMutationOptions = ApolloReactCommon.BaseMutationOptions<TrackEngagementViewMutation, TrackEngagementViewMutationVariables>;
export const UpdateMeetingRecordingDocument = gql`
    mutation updateMeetingRecording($workspaceId: Int!, $id: String!, $enabled: Boolean!, $override: Boolean) {
  updateMeetingRecording(
    workspaceId: $workspaceId
    id: $id
    enabled: $enabled
    override: $override
  ) {
    ok
    message
    code
  }
}
    `;
export type UpdateMeetingRecordingMutationFn = ApolloReactCommon.MutationFunction<UpdateMeetingRecordingMutation, UpdateMeetingRecordingMutationVariables>;

/**
 * __useUpdateMeetingRecordingMutation__
 *
 * To run a mutation, you first call `useUpdateMeetingRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeetingRecordingMutation, { data, loading, error }] = useUpdateMeetingRecordingMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *      override: // value for 'override'
 *   },
 * });
 */
export function useUpdateMeetingRecordingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMeetingRecordingMutation, UpdateMeetingRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMeetingRecordingMutation, UpdateMeetingRecordingMutationVariables>(UpdateMeetingRecordingDocument, options);
      }
export type UpdateMeetingRecordingMutationHookResult = ReturnType<typeof useUpdateMeetingRecordingMutation>;
export type UpdateMeetingRecordingMutationResult = ApolloReactCommon.MutationResult<UpdateMeetingRecordingMutation>;
export type UpdateMeetingRecordingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMeetingRecordingMutation, UpdateMeetingRecordingMutationVariables>;
export const GetUserFavoritesDocument = gql`
    query GetUserFavorites($workspaceId: ID!) {
  userFavorites(workspaceId: $workspaceId) {
    id
    userId
    workspaceId
    entityType
    entityId
    extraData
    createTs
  }
}
    `;

/**
 * __useGetUserFavoritesQuery__
 *
 * To run a query within a React component, call `useGetUserFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavoritesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetUserFavoritesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserFavoritesQuery, GetUserFavoritesQueryVariables> & ({ variables: GetUserFavoritesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserFavoritesQuery, GetUserFavoritesQueryVariables>(GetUserFavoritesDocument, options);
      }
export function useGetUserFavoritesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserFavoritesQuery, GetUserFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserFavoritesQuery, GetUserFavoritesQueryVariables>(GetUserFavoritesDocument, options);
        }
// @ts-ignore
export function useGetUserFavoritesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserFavoritesQuery, GetUserFavoritesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserFavoritesQuery, GetUserFavoritesQueryVariables>;
export function useGetUserFavoritesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserFavoritesQuery, GetUserFavoritesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserFavoritesQuery | undefined, GetUserFavoritesQueryVariables>;
export function useGetUserFavoritesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserFavoritesQuery, GetUserFavoritesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserFavoritesQuery, GetUserFavoritesQueryVariables>(GetUserFavoritesDocument, options);
        }
export type GetUserFavoritesQueryHookResult = ReturnType<typeof useGetUserFavoritesQuery>;
export type GetUserFavoritesLazyQueryHookResult = ReturnType<typeof useGetUserFavoritesLazyQuery>;
export type GetUserFavoritesSuspenseQueryHookResult = ReturnType<typeof useGetUserFavoritesSuspenseQuery>;
export type GetUserFavoritesQueryResult = ApolloReactCommon.QueryResult<GetUserFavoritesQuery, GetUserFavoritesQueryVariables>;
export const AddFavoriteDocument = gql`
    mutation AddFavorite($input: AddFavoriteInput!) {
  addFavorite(input: $input) {
    favorite {
      id
      userId
      workspaceId
      entityType
      entityId
      extraData
      createTs
    }
  }
}
    `;
export type AddFavoriteMutationFn = ApolloReactCommon.MutationFunction<AddFavoriteMutation, AddFavoriteMutationVariables>;

/**
 * __useAddFavoriteMutation__
 *
 * To run a mutation, you first call `useAddFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteMutation, { data, loading, error }] = useAddFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFavoriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddFavoriteMutation, AddFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddFavoriteMutation, AddFavoriteMutationVariables>(AddFavoriteDocument, options);
      }
export type AddFavoriteMutationHookResult = ReturnType<typeof useAddFavoriteMutation>;
export type AddFavoriteMutationResult = ApolloReactCommon.MutationResult<AddFavoriteMutation>;
export type AddFavoriteMutationOptions = ApolloReactCommon.BaseMutationOptions<AddFavoriteMutation, AddFavoriteMutationVariables>;
export const RemoveFavoriteDocument = gql`
    mutation RemoveFavorite($input: RemoveFavoriteInput!) {
  removeFavorite(input: $input) {
    ok
  }
}
    `;
export type RemoveFavoriteMutationFn = ApolloReactCommon.MutationFunction<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>;

/**
 * __useRemoveFavoriteMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteMutation, { data, loading, error }] = useRemoveFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFavoriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>(RemoveFavoriteDocument, options);
      }
export type RemoveFavoriteMutationHookResult = ReturnType<typeof useRemoveFavoriteMutation>;
export type RemoveFavoriteMutationResult = ApolloReactCommon.MutationResult<RemoveFavoriteMutation>;
export type RemoveFavoriteMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>;
export const GetFieldHistoryDocument = gql`
    query getFieldHistory($entityId: ID!, $entityType: FieldHistoryEntityType!, $field: String!, $limit: Int, $includeAutomated: Boolean) {
  fieldHistory(
    entityId: $entityId
    entityType: $entityType
    field: $field
    limit: $limit
    includeAutomated: $includeAutomated
  ) {
    entries {
      id
      field
      action
      value
      values
      source
      sourceKind
      sourceGroup
      isAutomated
      changedAt
      changedBy {
        userId
        name
        email
      }
      collapsedCount
      records {
        id
        name
        status
      }
    }
    hiddenCount
    hasMore
  }
}
    `;

/**
 * __useGetFieldHistoryQuery__
 *
 * To run a query within a React component, call `useGetFieldHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldHistoryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      field: // value for 'field'
 *      limit: // value for 'limit'
 *      includeAutomated: // value for 'includeAutomated'
 *   },
 * });
 */
export function useGetFieldHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFieldHistoryQuery, GetFieldHistoryQueryVariables> & ({ variables: GetFieldHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFieldHistoryQuery, GetFieldHistoryQueryVariables>(GetFieldHistoryDocument, options);
      }
export function useGetFieldHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFieldHistoryQuery, GetFieldHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFieldHistoryQuery, GetFieldHistoryQueryVariables>(GetFieldHistoryDocument, options);
        }
// @ts-ignore
export function useGetFieldHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFieldHistoryQuery, GetFieldHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFieldHistoryQuery, GetFieldHistoryQueryVariables>;
export function useGetFieldHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFieldHistoryQuery, GetFieldHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFieldHistoryQuery | undefined, GetFieldHistoryQueryVariables>;
export function useGetFieldHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFieldHistoryQuery, GetFieldHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFieldHistoryQuery, GetFieldHistoryQueryVariables>(GetFieldHistoryDocument, options);
        }
export type GetFieldHistoryQueryHookResult = ReturnType<typeof useGetFieldHistoryQuery>;
export type GetFieldHistoryLazyQueryHookResult = ReturnType<typeof useGetFieldHistoryLazyQuery>;
export type GetFieldHistorySuspenseQueryHookResult = ReturnType<typeof useGetFieldHistorySuspenseQuery>;
export type GetFieldHistoryQueryResult = ApolloReactCommon.QueryResult<GetFieldHistoryQuery, GetFieldHistoryQueryVariables>;
export const GetFilesDocument = gql`
    query getFiles($first: Int, $after: String, $filter: FileFilter!, $sort: [SortInput]) {
  files(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        ...FileFields
        ...FileRelations
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${FileFieldsFragmentDoc}
${FileRelationsFragmentDoc}`;

/**
 * __useGetFilesQuery__
 *
 * To run a query within a React component, call `useGetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFilesQuery, GetFilesQueryVariables> & ({ variables: GetFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
      }
export function useGetFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
        }
// @ts-ignore
export function useGetFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFilesQuery, GetFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFilesQuery, GetFilesQueryVariables>;
export function useGetFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFilesQuery, GetFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFilesQuery | undefined, GetFilesQueryVariables>;
export function useGetFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
        }
export type GetFilesQueryHookResult = ReturnType<typeof useGetFilesQuery>;
export type GetFilesLazyQueryHookResult = ReturnType<typeof useGetFilesLazyQuery>;
export type GetFilesSuspenseQueryHookResult = ReturnType<typeof useGetFilesSuspenseQuery>;
export type GetFilesQueryResult = ApolloReactCommon.QueryResult<GetFilesQuery, GetFilesQueryVariables>;
export const GetFileDocument = gql`
    query getFile($id: ID!, $workspaceId: ID!) {
  file(id: $id, workspaceId: $workspaceId) {
    ...FileFields
    ...FileRelations
  }
}
    ${FileFieldsFragmentDoc}
${FileRelationsFragmentDoc}`;

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetFileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFileQuery, GetFileQueryVariables> & ({ variables: GetFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
      }
export function useGetFileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
// @ts-ignore
export function useGetFileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFileQuery, GetFileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFileQuery, GetFileQueryVariables>;
export function useGetFileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFileQuery, GetFileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetFileQuery | undefined, GetFileQueryVariables>;
export function useGetFileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>;
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>;
export type GetFileSuspenseQueryHookResult = ReturnType<typeof useGetFileSuspenseQuery>;
export type GetFileQueryResult = ApolloReactCommon.QueryResult<GetFileQuery, GetFileQueryVariables>;
export const CreateFileDocument = gql`
    mutation createFile($workspaceId: ID!, $filename: String!, $mimeType: String, $size: Int, $fileUrl: String!, $accountIds: [String], $contactIds: [String], $dealIds: [String]) {
  createFile(
    input: {workspaceId: $workspaceId, filename: $filename, mimeType: $mimeType, size: $size, fileUrl: $fileUrl, accountIds: $accountIds, contactIds: $contactIds, dealIds: $dealIds}
  ) {
    file {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type CreateFileMutationFn = ApolloReactCommon.MutationFunction<CreateFileMutation, CreateFileMutationVariables>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filename: // value for 'filename'
 *      mimeType: // value for 'mimeType'
 *      size: // value for 'size'
 *      fileUrl: // value for 'fileUrl'
 *      accountIds: // value for 'accountIds'
 *      contactIds: // value for 'contactIds'
 *      dealIds: // value for 'dealIds'
 *   },
 * });
 */
export function useCreateFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFileMutation, CreateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFileMutation, CreateFileMutationVariables>(CreateFileDocument, options);
      }
export type CreateFileMutationHookResult = ReturnType<typeof useCreateFileMutation>;
export type CreateFileMutationResult = ApolloReactCommon.MutationResult<CreateFileMutation>;
export type CreateFileMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFileMutation, CreateFileMutationVariables>;
export const DeleteFileDocument = gql`
    mutation deleteFile($id: ID!, $workspaceId: ID!) {
  deleteFile(id: $id, workspaceId: $workspaceId) {
    success
  }
}
    `;
export type DeleteFileMutationFn = ApolloReactCommon.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = ApolloReactCommon.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const GenerateFormulaDocument = gql`
    query generateFormula($workspaceId: Int!, $objectType: String!, $description: String!) {
  generateFormula(
    workspaceId: $workspaceId
    objectType: $objectType
    description: $description
  ) {
    expression
    resultType
    gaps
    error
  }
}
    `;

/**
 * __useGenerateFormulaQuery__
 *
 * To run a query within a React component, call `useGenerateFormulaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateFormulaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateFormulaQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      objectType: // value for 'objectType'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useGenerateFormulaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GenerateFormulaQuery, GenerateFormulaQueryVariables> & ({ variables: GenerateFormulaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GenerateFormulaQuery, GenerateFormulaQueryVariables>(GenerateFormulaDocument, options);
      }
export function useGenerateFormulaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GenerateFormulaQuery, GenerateFormulaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GenerateFormulaQuery, GenerateFormulaQueryVariables>(GenerateFormulaDocument, options);
        }
// @ts-ignore
export function useGenerateFormulaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GenerateFormulaQuery, GenerateFormulaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GenerateFormulaQuery, GenerateFormulaQueryVariables>;
export function useGenerateFormulaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GenerateFormulaQuery, GenerateFormulaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GenerateFormulaQuery | undefined, GenerateFormulaQueryVariables>;
export function useGenerateFormulaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GenerateFormulaQuery, GenerateFormulaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GenerateFormulaQuery, GenerateFormulaQueryVariables>(GenerateFormulaDocument, options);
        }
export type GenerateFormulaQueryHookResult = ReturnType<typeof useGenerateFormulaQuery>;
export type GenerateFormulaLazyQueryHookResult = ReturnType<typeof useGenerateFormulaLazyQuery>;
export type GenerateFormulaSuspenseQueryHookResult = ReturnType<typeof useGenerateFormulaSuspenseQuery>;
export type GenerateFormulaQueryResult = ApolloReactCommon.QueryResult<GenerateFormulaQuery, GenerateFormulaQueryVariables>;
export const RunFormulaFieldDocument = gql`
    mutation runFormulaField($workspaceId: Int!, $fieldId: Int!) {
  runFormulaField(workspaceId: $workspaceId, fieldId: $fieldId) {
    execution {
      id
      workspaceId
      fieldId
      status
      totalRecords
      processedRecords
      failedRecords
      progressPercentage
      temporalWorkflowId
      createdAt
    }
  }
}
    `;
export type RunFormulaFieldMutationFn = ApolloReactCommon.MutationFunction<RunFormulaFieldMutation, RunFormulaFieldMutationVariables>;

/**
 * __useRunFormulaFieldMutation__
 *
 * To run a mutation, you first call `useRunFormulaFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunFormulaFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runFormulaFieldMutation, { data, loading, error }] = useRunFormulaFieldMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      fieldId: // value for 'fieldId'
 *   },
 * });
 */
export function useRunFormulaFieldMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RunFormulaFieldMutation, RunFormulaFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RunFormulaFieldMutation, RunFormulaFieldMutationVariables>(RunFormulaFieldDocument, options);
      }
export type RunFormulaFieldMutationHookResult = ReturnType<typeof useRunFormulaFieldMutation>;
export type RunFormulaFieldMutationResult = ApolloReactCommon.MutationResult<RunFormulaFieldMutation>;
export type RunFormulaFieldMutationOptions = ApolloReactCommon.BaseMutationOptions<RunFormulaFieldMutation, RunFormulaFieldMutationVariables>;
export const GetGptResponseDocument = gql`
    query getGptResponse($transcript: String, $summaryTemplate: SummaryTemplate, $timezone: String!, $type: String!, $workspaceId: String!) {
  gptResponse(
    timezone: $timezone
    transcript: $transcript
    summaryTemplate: $summaryTemplate
    type: $type
    workspaceId: $workspaceId
  ) {
    response
  }
}
    `;

/**
 * __useGetGptResponseQuery__
 *
 * To run a query within a React component, call `useGetGptResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGptResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGptResponseQuery({
 *   variables: {
 *      transcript: // value for 'transcript'
 *      summaryTemplate: // value for 'summaryTemplate'
 *      timezone: // value for 'timezone'
 *      type: // value for 'type'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetGptResponseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetGptResponseQuery, GetGptResponseQueryVariables> & ({ variables: GetGptResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGptResponseQuery, GetGptResponseQueryVariables>(GetGptResponseDocument, options);
      }
export function useGetGptResponseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGptResponseQuery, GetGptResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGptResponseQuery, GetGptResponseQueryVariables>(GetGptResponseDocument, options);
        }
// @ts-ignore
export function useGetGptResponseSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetGptResponseQuery, GetGptResponseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetGptResponseQuery, GetGptResponseQueryVariables>;
export function useGetGptResponseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetGptResponseQuery, GetGptResponseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetGptResponseQuery | undefined, GetGptResponseQueryVariables>;
export function useGetGptResponseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetGptResponseQuery, GetGptResponseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetGptResponseQuery, GetGptResponseQueryVariables>(GetGptResponseDocument, options);
        }
export type GetGptResponseQueryHookResult = ReturnType<typeof useGetGptResponseQuery>;
export type GetGptResponseLazyQueryHookResult = ReturnType<typeof useGetGptResponseLazyQuery>;
export type GetGptResponseSuspenseQueryHookResult = ReturnType<typeof useGetGptResponseSuspenseQuery>;
export type GetGptResponseQueryResult = ApolloReactCommon.QueryResult<GetGptResponseQuery, GetGptResponseQueryVariables>;
export const GetDealsGridSummariesDocument = gql`
    query getDealsGridSummaries($workspaceId: Int!, $filter: DealFilter, $columns: [String]) {
  gridSummary(workspaceId: $workspaceId) {
    deal(filter: $filter, columns: $columns) {
      fillRates {
        columnName
        fillRate
        filled
        missing
      }
      metrics {
        columnName
        sum
        avg
      }
    }
  }
}
    `;

/**
 * __useGetDealsGridSummariesQuery__
 *
 * To run a query within a React component, call `useGetDealsGridSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsGridSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsGridSummariesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filter: // value for 'filter'
 *      columns: // value for 'columns'
 *   },
 * });
 */
export function useGetDealsGridSummariesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealsGridSummariesQuery, GetDealsGridSummariesQueryVariables> & ({ variables: GetDealsGridSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealsGridSummariesQuery, GetDealsGridSummariesQueryVariables>(GetDealsGridSummariesDocument, options);
      }
export function useGetDealsGridSummariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealsGridSummariesQuery, GetDealsGridSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealsGridSummariesQuery, GetDealsGridSummariesQueryVariables>(GetDealsGridSummariesDocument, options);
        }
// @ts-ignore
export function useGetDealsGridSummariesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDealsGridSummariesQuery, GetDealsGridSummariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealsGridSummariesQuery, GetDealsGridSummariesQueryVariables>;
export function useGetDealsGridSummariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealsGridSummariesQuery, GetDealsGridSummariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealsGridSummariesQuery | undefined, GetDealsGridSummariesQueryVariables>;
export function useGetDealsGridSummariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealsGridSummariesQuery, GetDealsGridSummariesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealsGridSummariesQuery, GetDealsGridSummariesQueryVariables>(GetDealsGridSummariesDocument, options);
        }
export type GetDealsGridSummariesQueryHookResult = ReturnType<typeof useGetDealsGridSummariesQuery>;
export type GetDealsGridSummariesLazyQueryHookResult = ReturnType<typeof useGetDealsGridSummariesLazyQuery>;
export type GetDealsGridSummariesSuspenseQueryHookResult = ReturnType<typeof useGetDealsGridSummariesSuspenseQuery>;
export type GetDealsGridSummariesQueryResult = ApolloReactCommon.QueryResult<GetDealsGridSummariesQuery, GetDealsGridSummariesQueryVariables>;
export const GetAccountsGridSummariesDocument = gql`
    query getAccountsGridSummaries($workspaceId: Int!, $filter: AccountFilter, $columns: [String]) {
  gridSummary(workspaceId: $workspaceId) {
    account(filter: $filter, columns: $columns) {
      fillRates {
        columnName
        fillRate
        filled
        missing
      }
    }
  }
}
    `;

/**
 * __useGetAccountsGridSummariesQuery__
 *
 * To run a query within a React component, call `useGetAccountsGridSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsGridSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsGridSummariesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filter: // value for 'filter'
 *      columns: // value for 'columns'
 *   },
 * });
 */
export function useGetAccountsGridSummariesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAccountsGridSummariesQuery, GetAccountsGridSummariesQueryVariables> & ({ variables: GetAccountsGridSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountsGridSummariesQuery, GetAccountsGridSummariesQueryVariables>(GetAccountsGridSummariesDocument, options);
      }
export function useGetAccountsGridSummariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountsGridSummariesQuery, GetAccountsGridSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountsGridSummariesQuery, GetAccountsGridSummariesQueryVariables>(GetAccountsGridSummariesDocument, options);
        }
// @ts-ignore
export function useGetAccountsGridSummariesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAccountsGridSummariesQuery, GetAccountsGridSummariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAccountsGridSummariesQuery, GetAccountsGridSummariesQueryVariables>;
export function useGetAccountsGridSummariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAccountsGridSummariesQuery, GetAccountsGridSummariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAccountsGridSummariesQuery | undefined, GetAccountsGridSummariesQueryVariables>;
export function useGetAccountsGridSummariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAccountsGridSummariesQuery, GetAccountsGridSummariesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAccountsGridSummariesQuery, GetAccountsGridSummariesQueryVariables>(GetAccountsGridSummariesDocument, options);
        }
export type GetAccountsGridSummariesQueryHookResult = ReturnType<typeof useGetAccountsGridSummariesQuery>;
export type GetAccountsGridSummariesLazyQueryHookResult = ReturnType<typeof useGetAccountsGridSummariesLazyQuery>;
export type GetAccountsGridSummariesSuspenseQueryHookResult = ReturnType<typeof useGetAccountsGridSummariesSuspenseQuery>;
export type GetAccountsGridSummariesQueryResult = ApolloReactCommon.QueryResult<GetAccountsGridSummariesQuery, GetAccountsGridSummariesQueryVariables>;
export const GetContactsGridSummariesDocument = gql`
    query getContactsGridSummaries($workspaceId: Int!, $filter: ContactFilterInput, $columns: [String]) {
  gridSummary(workspaceId: $workspaceId) {
    contact(filter: $filter, columns: $columns) {
      fillRates {
        columnName
        fillRate
        filled
        missing
      }
    }
  }
}
    `;

/**
 * __useGetContactsGridSummariesQuery__
 *
 * To run a query within a React component, call `useGetContactsGridSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsGridSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsGridSummariesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filter: // value for 'filter'
 *      columns: // value for 'columns'
 *   },
 * });
 */
export function useGetContactsGridSummariesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetContactsGridSummariesQuery, GetContactsGridSummariesQueryVariables> & ({ variables: GetContactsGridSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContactsGridSummariesQuery, GetContactsGridSummariesQueryVariables>(GetContactsGridSummariesDocument, options);
      }
export function useGetContactsGridSummariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactsGridSummariesQuery, GetContactsGridSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContactsGridSummariesQuery, GetContactsGridSummariesQueryVariables>(GetContactsGridSummariesDocument, options);
        }
// @ts-ignore
export function useGetContactsGridSummariesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetContactsGridSummariesQuery, GetContactsGridSummariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetContactsGridSummariesQuery, GetContactsGridSummariesQueryVariables>;
export function useGetContactsGridSummariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContactsGridSummariesQuery, GetContactsGridSummariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetContactsGridSummariesQuery | undefined, GetContactsGridSummariesQueryVariables>;
export function useGetContactsGridSummariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContactsGridSummariesQuery, GetContactsGridSummariesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetContactsGridSummariesQuery, GetContactsGridSummariesQueryVariables>(GetContactsGridSummariesDocument, options);
        }
export type GetContactsGridSummariesQueryHookResult = ReturnType<typeof useGetContactsGridSummariesQuery>;
export type GetContactsGridSummariesLazyQueryHookResult = ReturnType<typeof useGetContactsGridSummariesLazyQuery>;
export type GetContactsGridSummariesSuspenseQueryHookResult = ReturnType<typeof useGetContactsGridSummariesSuspenseQuery>;
export type GetContactsGridSummariesQueryResult = ApolloReactCommon.QueryResult<GetContactsGridSummariesQuery, GetContactsGridSummariesQueryVariables>;
export const GetIndustriesDocument = gql`
    query getIndustries($filter: IndustryFilter!) {
  industries(filter: $filter) {
    edges {
      node {
        ...IndustryFields
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${IndustryFieldsFragmentDoc}`;

/**
 * __useGetIndustriesQuery__
 *
 * To run a query within a React component, call `useGetIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetIndustriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables> & ({ variables: GetIndustriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
      }
export function useGetIndustriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
        }
// @ts-ignore
export function useGetIndustriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIndustriesQuery, GetIndustriesQueryVariables>;
export function useGetIndustriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIndustriesQuery | undefined, GetIndustriesQueryVariables>;
export function useGetIndustriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
        }
export type GetIndustriesQueryHookResult = ReturnType<typeof useGetIndustriesQuery>;
export type GetIndustriesLazyQueryHookResult = ReturnType<typeof useGetIndustriesLazyQuery>;
export type GetIndustriesSuspenseQueryHookResult = ReturnType<typeof useGetIndustriesSuspenseQuery>;
export type GetIndustriesQueryResult = ApolloReactCommon.QueryResult<GetIndustriesQuery, GetIndustriesQueryVariables>;
export const GetIntegrationsDocument = gql`
    query getIntegrations($workspaceId: Int!) {
  integrations(workspaceId: $workspaceId) {
    ...IntegrationFields
  }
}
    ${IntegrationFieldsFragmentDoc}`;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables> & ({ variables: GetIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
// @ts-ignore
export function useGetIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export function useGetIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIntegrationsQuery | undefined, GetIntegrationsQueryVariables>;
export function useGetIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationsSuspenseQuery>;
export type GetIntegrationsQueryResult = ApolloReactCommon.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const GetUserIntegrationsDocument = gql`
    query getUserIntegrations($workspaceId: Int!) {
  userIntegrations(workspaceId: $workspaceId) {
    ...UserIntegrationFields
  }
}
    ${UserIntegrationFieldsFragmentDoc}`;

/**
 * __useGetUserIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetUserIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIntegrationsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetUserIntegrationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables> & ({ variables: GetUserIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>(GetUserIntegrationsDocument, options);
      }
export function useGetUserIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>(GetUserIntegrationsDocument, options);
        }
// @ts-ignore
export function useGetUserIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>;
export function useGetUserIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserIntegrationsQuery | undefined, GetUserIntegrationsQueryVariables>;
export function useGetUserIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>(GetUserIntegrationsDocument, options);
        }
export type GetUserIntegrationsQueryHookResult = ReturnType<typeof useGetUserIntegrationsQuery>;
export type GetUserIntegrationsLazyQueryHookResult = ReturnType<typeof useGetUserIntegrationsLazyQuery>;
export type GetUserIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetUserIntegrationsSuspenseQuery>;
export type GetUserIntegrationsQueryResult = ApolloReactCommon.QueryResult<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>;
export const GetCrmIngestionRunsDocument = gql`
    query getCrmIngestionRuns($filter: CrmIngestionRunFilterInput, $sort: [SortInput], $first: Int) {
  crmIngestionRuns(filter: $filter, sort: $sort, first: $first) {
    edges {
      node {
        ...IngestionRunFields
      }
    }
  }
}
    ${IngestionRunFieldsFragmentDoc}`;

/**
 * __useGetCrmIngestionRunsQuery__
 *
 * To run a query within a React component, call `useGetCrmIngestionRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmIngestionRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmIngestionRunsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetCrmIngestionRunsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCrmIngestionRunsQuery, GetCrmIngestionRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCrmIngestionRunsQuery, GetCrmIngestionRunsQueryVariables>(GetCrmIngestionRunsDocument, options);
      }
export function useGetCrmIngestionRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCrmIngestionRunsQuery, GetCrmIngestionRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCrmIngestionRunsQuery, GetCrmIngestionRunsQueryVariables>(GetCrmIngestionRunsDocument, options);
        }
// @ts-ignore
export function useGetCrmIngestionRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionRunsQuery, GetCrmIngestionRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmIngestionRunsQuery, GetCrmIngestionRunsQueryVariables>;
export function useGetCrmIngestionRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionRunsQuery, GetCrmIngestionRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmIngestionRunsQuery | undefined, GetCrmIngestionRunsQueryVariables>;
export function useGetCrmIngestionRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionRunsQuery, GetCrmIngestionRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCrmIngestionRunsQuery, GetCrmIngestionRunsQueryVariables>(GetCrmIngestionRunsDocument, options);
        }
export type GetCrmIngestionRunsQueryHookResult = ReturnType<typeof useGetCrmIngestionRunsQuery>;
export type GetCrmIngestionRunsLazyQueryHookResult = ReturnType<typeof useGetCrmIngestionRunsLazyQuery>;
export type GetCrmIngestionRunsSuspenseQueryHookResult = ReturnType<typeof useGetCrmIngestionRunsSuspenseQuery>;
export type GetCrmIngestionRunsQueryResult = ApolloReactCommon.QueryResult<GetCrmIngestionRunsQuery, GetCrmIngestionRunsQueryVariables>;
export const GetCrmIngestionSyncLogsDocument = gql`
    query getCrmIngestionSyncLogs($filter: CrmIngestionRunFilterInput, $first: Int) {
  crmIngestionSyncLog(filter: $filter, first: $first) {
    edges {
      node {
        ...IngestionRunFields
      }
    }
  }
}
    ${IngestionRunFieldsFragmentDoc}`;

/**
 * __useGetCrmIngestionSyncLogsQuery__
 *
 * To run a query within a React component, call `useGetCrmIngestionSyncLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmIngestionSyncLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmIngestionSyncLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetCrmIngestionSyncLogsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCrmIngestionSyncLogsQuery, GetCrmIngestionSyncLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCrmIngestionSyncLogsQuery, GetCrmIngestionSyncLogsQueryVariables>(GetCrmIngestionSyncLogsDocument, options);
      }
export function useGetCrmIngestionSyncLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCrmIngestionSyncLogsQuery, GetCrmIngestionSyncLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCrmIngestionSyncLogsQuery, GetCrmIngestionSyncLogsQueryVariables>(GetCrmIngestionSyncLogsDocument, options);
        }
// @ts-ignore
export function useGetCrmIngestionSyncLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionSyncLogsQuery, GetCrmIngestionSyncLogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmIngestionSyncLogsQuery, GetCrmIngestionSyncLogsQueryVariables>;
export function useGetCrmIngestionSyncLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionSyncLogsQuery, GetCrmIngestionSyncLogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmIngestionSyncLogsQuery | undefined, GetCrmIngestionSyncLogsQueryVariables>;
export function useGetCrmIngestionSyncLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmIngestionSyncLogsQuery, GetCrmIngestionSyncLogsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCrmIngestionSyncLogsQuery, GetCrmIngestionSyncLogsQueryVariables>(GetCrmIngestionSyncLogsDocument, options);
        }
export type GetCrmIngestionSyncLogsQueryHookResult = ReturnType<typeof useGetCrmIngestionSyncLogsQuery>;
export type GetCrmIngestionSyncLogsLazyQueryHookResult = ReturnType<typeof useGetCrmIngestionSyncLogsLazyQuery>;
export type GetCrmIngestionSyncLogsSuspenseQueryHookResult = ReturnType<typeof useGetCrmIngestionSyncLogsSuspenseQuery>;
export type GetCrmIngestionSyncLogsQueryResult = ApolloReactCommon.QueryResult<GetCrmIngestionSyncLogsQuery, GetCrmIngestionSyncLogsQueryVariables>;
export const CrmIngestDocument = gql`
    mutation crmIngest($workspaceId: Int!, $platform: CrmIngestionPlatform!) {
  crmIngest(workspaceId: $workspaceId, platform: $platform) {
    ok
    run {
      runId
      platform
      workspaceId
      status
    }
  }
}
    `;
export type CrmIngestMutationFn = ApolloReactCommon.MutationFunction<CrmIngestMutation, CrmIngestMutationVariables>;

/**
 * __useCrmIngestMutation__
 *
 * To run a mutation, you first call `useCrmIngestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrmIngestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crmIngestMutation, { data, loading, error }] = useCrmIngestMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useCrmIngestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CrmIngestMutation, CrmIngestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CrmIngestMutation, CrmIngestMutationVariables>(CrmIngestDocument, options);
      }
export type CrmIngestMutationHookResult = ReturnType<typeof useCrmIngestMutation>;
export type CrmIngestMutationResult = ApolloReactCommon.MutationResult<CrmIngestMutation>;
export type CrmIngestMutationOptions = ApolloReactCommon.BaseMutationOptions<CrmIngestMutation, CrmIngestMutationVariables>;
export const DisconnectIntegrationDocument = gql`
    mutation disconnectIntegration($workspaceId: Int!, $platform: String!) {
  disconnectIntegration(workspaceId: $workspaceId, platform: $platform) {
    ok
  }
}
    `;
export type DisconnectIntegrationMutationFn = ApolloReactCommon.MutationFunction<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>;

/**
 * __useDisconnectIntegrationMutation__
 *
 * To run a mutation, you first call `useDisconnectIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectIntegrationMutation, { data, loading, error }] = useDisconnectIntegrationMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useDisconnectIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>(DisconnectIntegrationDocument, options);
      }
export type DisconnectIntegrationMutationHookResult = ReturnType<typeof useDisconnectIntegrationMutation>;
export type DisconnectIntegrationMutationResult = ApolloReactCommon.MutationResult<DisconnectIntegrationMutation>;
export type DisconnectIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>;
export const ConnectGranolaDocument = gql`
    mutation connectGranola($workspaceId: Int!, $apiKey: String!, $lookbackDays: Int, $keepCoffeeRecording: Boolean) {
  connectGranola(
    workspaceId: $workspaceId
    apiKey: $apiKey
    lookbackDays: $lookbackDays
    keepCoffeeRecording: $keepCoffeeRecording
  ) {
    ok
    integration {
      platform
      status
    }
  }
}
    `;
export type ConnectGranolaMutationFn = ApolloReactCommon.MutationFunction<ConnectGranolaMutation, ConnectGranolaMutationVariables>;

/**
 * __useConnectGranolaMutation__
 *
 * To run a mutation, you first call `useConnectGranolaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectGranolaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectGranolaMutation, { data, loading, error }] = useConnectGranolaMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      apiKey: // value for 'apiKey'
 *      lookbackDays: // value for 'lookbackDays'
 *      keepCoffeeRecording: // value for 'keepCoffeeRecording'
 *   },
 * });
 */
export function useConnectGranolaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectGranolaMutation, ConnectGranolaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConnectGranolaMutation, ConnectGranolaMutationVariables>(ConnectGranolaDocument, options);
      }
export type ConnectGranolaMutationHookResult = ReturnType<typeof useConnectGranolaMutation>;
export type ConnectGranolaMutationResult = ApolloReactCommon.MutationResult<ConnectGranolaMutation>;
export type ConnectGranolaMutationOptions = ApolloReactCommon.BaseMutationOptions<ConnectGranolaMutation, ConnectGranolaMutationVariables>;
export const SyncGranolaDocument = gql`
    mutation syncGranola($workspaceId: Int!, $lookbackDays: Int) {
  syncGranola(workspaceId: $workspaceId, lookbackDays: $lookbackDays) {
    ok
  }
}
    `;
export type SyncGranolaMutationFn = ApolloReactCommon.MutationFunction<SyncGranolaMutation, SyncGranolaMutationVariables>;

/**
 * __useSyncGranolaMutation__
 *
 * To run a mutation, you first call `useSyncGranolaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncGranolaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncGranolaMutation, { data, loading, error }] = useSyncGranolaMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      lookbackDays: // value for 'lookbackDays'
 *   },
 * });
 */
export function useSyncGranolaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncGranolaMutation, SyncGranolaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncGranolaMutation, SyncGranolaMutationVariables>(SyncGranolaDocument, options);
      }
export type SyncGranolaMutationHookResult = ReturnType<typeof useSyncGranolaMutation>;
export type SyncGranolaMutationResult = ApolloReactCommon.MutationResult<SyncGranolaMutation>;
export type SyncGranolaMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncGranolaMutation, SyncGranolaMutationVariables>;
export const ConnectFirefliesDocument = gql`
    mutation connectFireflies($workspaceId: Int!, $apiKey: String!, $lookbackDays: Int, $keepCoffeeRecording: Boolean) {
  connectFireflies(
    workspaceId: $workspaceId
    apiKey: $apiKey
    lookbackDays: $lookbackDays
    keepCoffeeRecording: $keepCoffeeRecording
  ) {
    ok
    integration {
      platform
      status
    }
  }
}
    `;
export type ConnectFirefliesMutationFn = ApolloReactCommon.MutationFunction<ConnectFirefliesMutation, ConnectFirefliesMutationVariables>;

/**
 * __useConnectFirefliesMutation__
 *
 * To run a mutation, you first call `useConnectFirefliesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectFirefliesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectFirefliesMutation, { data, loading, error }] = useConnectFirefliesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      apiKey: // value for 'apiKey'
 *      lookbackDays: // value for 'lookbackDays'
 *      keepCoffeeRecording: // value for 'keepCoffeeRecording'
 *   },
 * });
 */
export function useConnectFirefliesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectFirefliesMutation, ConnectFirefliesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConnectFirefliesMutation, ConnectFirefliesMutationVariables>(ConnectFirefliesDocument, options);
      }
export type ConnectFirefliesMutationHookResult = ReturnType<typeof useConnectFirefliesMutation>;
export type ConnectFirefliesMutationResult = ApolloReactCommon.MutationResult<ConnectFirefliesMutation>;
export type ConnectFirefliesMutationOptions = ApolloReactCommon.BaseMutationOptions<ConnectFirefliesMutation, ConnectFirefliesMutationVariables>;
export const SyncFirefliesDocument = gql`
    mutation syncFireflies($workspaceId: Int!, $lookbackDays: Int) {
  syncFireflies(workspaceId: $workspaceId, lookbackDays: $lookbackDays) {
    ok
  }
}
    `;
export type SyncFirefliesMutationFn = ApolloReactCommon.MutationFunction<SyncFirefliesMutation, SyncFirefliesMutationVariables>;

/**
 * __useSyncFirefliesMutation__
 *
 * To run a mutation, you first call `useSyncFirefliesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncFirefliesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncFirefliesMutation, { data, loading, error }] = useSyncFirefliesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      lookbackDays: // value for 'lookbackDays'
 *   },
 * });
 */
export function useSyncFirefliesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncFirefliesMutation, SyncFirefliesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncFirefliesMutation, SyncFirefliesMutationVariables>(SyncFirefliesDocument, options);
      }
export type SyncFirefliesMutationHookResult = ReturnType<typeof useSyncFirefliesMutation>;
export type SyncFirefliesMutationResult = ApolloReactCommon.MutationResult<SyncFirefliesMutation>;
export type SyncFirefliesMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncFirefliesMutation, SyncFirefliesMutationVariables>;
export const ConnectFirefliesWorkspaceDocument = gql`
    mutation connectFirefliesWorkspace($workspaceId: Int!, $apiKey: String!, $lookbackDays: Int, $keepCoffeeRecording: Boolean) {
  connectFirefliesWorkspace(
    workspaceId: $workspaceId
    apiKey: $apiKey
    lookbackDays: $lookbackDays
    keepCoffeeRecording: $keepCoffeeRecording
  ) {
    ok
    error
    integration {
      platform
      status
    }
  }
}
    `;
export type ConnectFirefliesWorkspaceMutationFn = ApolloReactCommon.MutationFunction<ConnectFirefliesWorkspaceMutation, ConnectFirefliesWorkspaceMutationVariables>;

/**
 * __useConnectFirefliesWorkspaceMutation__
 *
 * To run a mutation, you first call `useConnectFirefliesWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectFirefliesWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectFirefliesWorkspaceMutation, { data, loading, error }] = useConnectFirefliesWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      apiKey: // value for 'apiKey'
 *      lookbackDays: // value for 'lookbackDays'
 *      keepCoffeeRecording: // value for 'keepCoffeeRecording'
 *   },
 * });
 */
export function useConnectFirefliesWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectFirefliesWorkspaceMutation, ConnectFirefliesWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConnectFirefliesWorkspaceMutation, ConnectFirefliesWorkspaceMutationVariables>(ConnectFirefliesWorkspaceDocument, options);
      }
export type ConnectFirefliesWorkspaceMutationHookResult = ReturnType<typeof useConnectFirefliesWorkspaceMutation>;
export type ConnectFirefliesWorkspaceMutationResult = ApolloReactCommon.MutationResult<ConnectFirefliesWorkspaceMutation>;
export type ConnectFirefliesWorkspaceMutationOptions = ApolloReactCommon.BaseMutationOptions<ConnectFirefliesWorkspaceMutation, ConnectFirefliesWorkspaceMutationVariables>;
export const CheckFirefliesKeyDocument = gql`
    mutation checkFirefliesKey($workspaceId: Int!, $apiKey: String!) {
  checkFirefliesKey(workspaceId: $workspaceId, apiKey: $apiKey) {
    valid
    firefliesAdmin
    email
    name
    canConnectWorkspace
  }
}
    `;
export type CheckFirefliesKeyMutationFn = ApolloReactCommon.MutationFunction<CheckFirefliesKeyMutation, CheckFirefliesKeyMutationVariables>;

/**
 * __useCheckFirefliesKeyMutation__
 *
 * To run a mutation, you first call `useCheckFirefliesKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckFirefliesKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkFirefliesKeyMutation, { data, loading, error }] = useCheckFirefliesKeyMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useCheckFirefliesKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CheckFirefliesKeyMutation, CheckFirefliesKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CheckFirefliesKeyMutation, CheckFirefliesKeyMutationVariables>(CheckFirefliesKeyDocument, options);
      }
export type CheckFirefliesKeyMutationHookResult = ReturnType<typeof useCheckFirefliesKeyMutation>;
export type CheckFirefliesKeyMutationResult = ApolloReactCommon.MutationResult<CheckFirefliesKeyMutation>;
export type CheckFirefliesKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<CheckFirefliesKeyMutation, CheckFirefliesKeyMutationVariables>;
export const SyncFirefliesWorkspaceDocument = gql`
    mutation syncFirefliesWorkspace($workspaceId: Int!, $lookbackDays: Int) {
  syncFirefliesWorkspace(workspaceId: $workspaceId, lookbackDays: $lookbackDays) {
    ok
  }
}
    `;
export type SyncFirefliesWorkspaceMutationFn = ApolloReactCommon.MutationFunction<SyncFirefliesWorkspaceMutation, SyncFirefliesWorkspaceMutationVariables>;

/**
 * __useSyncFirefliesWorkspaceMutation__
 *
 * To run a mutation, you first call `useSyncFirefliesWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncFirefliesWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncFirefliesWorkspaceMutation, { data, loading, error }] = useSyncFirefliesWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      lookbackDays: // value for 'lookbackDays'
 *   },
 * });
 */
export function useSyncFirefliesWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncFirefliesWorkspaceMutation, SyncFirefliesWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncFirefliesWorkspaceMutation, SyncFirefliesWorkspaceMutationVariables>(SyncFirefliesWorkspaceDocument, options);
      }
export type SyncFirefliesWorkspaceMutationHookResult = ReturnType<typeof useSyncFirefliesWorkspaceMutation>;
export type SyncFirefliesWorkspaceMutationResult = ApolloReactCommon.MutationResult<SyncFirefliesWorkspaceMutation>;
export type SyncFirefliesWorkspaceMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncFirefliesWorkspaceMutation, SyncFirefliesWorkspaceMutationVariables>;
export const DisconnectUserIntegrationDocument = gql`
    mutation disconnectUserIntegration($workspaceId: Int!, $platform: String!) {
  disconnectUserIntegration(workspaceId: $workspaceId, platform: $platform) {
    ok
  }
}
    `;
export type DisconnectUserIntegrationMutationFn = ApolloReactCommon.MutationFunction<DisconnectUserIntegrationMutation, DisconnectUserIntegrationMutationVariables>;

/**
 * __useDisconnectUserIntegrationMutation__
 *
 * To run a mutation, you first call `useDisconnectUserIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectUserIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectUserIntegrationMutation, { data, loading, error }] = useDisconnectUserIntegrationMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useDisconnectUserIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisconnectUserIntegrationMutation, DisconnectUserIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisconnectUserIntegrationMutation, DisconnectUserIntegrationMutationVariables>(DisconnectUserIntegrationDocument, options);
      }
export type DisconnectUserIntegrationMutationHookResult = ReturnType<typeof useDisconnectUserIntegrationMutation>;
export type DisconnectUserIntegrationMutationResult = ApolloReactCommon.MutationResult<DisconnectUserIntegrationMutation>;
export type DisconnectUserIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<DisconnectUserIntegrationMutation, DisconnectUserIntegrationMutationVariables>;
export const UserIntegrationSyncDocument = gql`
    mutation userIntegrationSync($workspaceId: Int!, $platform: String!) {
  userIntegrationSync(workspaceId: $workspaceId, platform: $platform) {
    ok
  }
}
    `;
export type UserIntegrationSyncMutationFn = ApolloReactCommon.MutationFunction<UserIntegrationSyncMutation, UserIntegrationSyncMutationVariables>;

/**
 * __useUserIntegrationSyncMutation__
 *
 * To run a mutation, you first call `useUserIntegrationSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserIntegrationSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userIntegrationSyncMutation, { data, loading, error }] = useUserIntegrationSyncMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useUserIntegrationSyncMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserIntegrationSyncMutation, UserIntegrationSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserIntegrationSyncMutation, UserIntegrationSyncMutationVariables>(UserIntegrationSyncDocument, options);
      }
export type UserIntegrationSyncMutationHookResult = ReturnType<typeof useUserIntegrationSyncMutation>;
export type UserIntegrationSyncMutationResult = ApolloReactCommon.MutationResult<UserIntegrationSyncMutation>;
export type UserIntegrationSyncMutationOptions = ApolloReactCommon.BaseMutationOptions<UserIntegrationSyncMutation, UserIntegrationSyncMutationVariables>;
export const WorkflowStatusDocument = gql`
    query workflowStatus($workflowId: String!) {
  workflowStatus(workflowId: $workflowId) {
    status
    ok
  }
}
    `;

/**
 * __useWorkflowStatusQuery__
 *
 * To run a query within a React component, call `useWorkflowStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowStatusQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useWorkflowStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkflowStatusQuery, WorkflowStatusQueryVariables> & ({ variables: WorkflowStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkflowStatusQuery, WorkflowStatusQueryVariables>(WorkflowStatusDocument, options);
      }
export function useWorkflowStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkflowStatusQuery, WorkflowStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkflowStatusQuery, WorkflowStatusQueryVariables>(WorkflowStatusDocument, options);
        }
// @ts-ignore
export function useWorkflowStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkflowStatusQuery, WorkflowStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkflowStatusQuery, WorkflowStatusQueryVariables>;
export function useWorkflowStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkflowStatusQuery, WorkflowStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkflowStatusQuery | undefined, WorkflowStatusQueryVariables>;
export function useWorkflowStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkflowStatusQuery, WorkflowStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkflowStatusQuery, WorkflowStatusQueryVariables>(WorkflowStatusDocument, options);
        }
export type WorkflowStatusQueryHookResult = ReturnType<typeof useWorkflowStatusQuery>;
export type WorkflowStatusLazyQueryHookResult = ReturnType<typeof useWorkflowStatusLazyQuery>;
export type WorkflowStatusSuspenseQueryHookResult = ReturnType<typeof useWorkflowStatusSuspenseQuery>;
export type WorkflowStatusQueryResult = ApolloReactCommon.QueryResult<WorkflowStatusQuery, WorkflowStatusQueryVariables>;
export const GetStripeDataCountsDocument = gql`
    query getStripeDataCounts($input: StripeDataCountsInput!) {
  stripeDataCounts(input: $input) {
    customers
    subscriptions
    paidCharges
  }
}
    `;

/**
 * __useGetStripeDataCountsQuery__
 *
 * To run a query within a React component, call `useGetStripeDataCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeDataCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeDataCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStripeDataCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStripeDataCountsQuery, GetStripeDataCountsQueryVariables> & ({ variables: GetStripeDataCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStripeDataCountsQuery, GetStripeDataCountsQueryVariables>(GetStripeDataCountsDocument, options);
      }
export function useGetStripeDataCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStripeDataCountsQuery, GetStripeDataCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStripeDataCountsQuery, GetStripeDataCountsQueryVariables>(GetStripeDataCountsDocument, options);
        }
// @ts-ignore
export function useGetStripeDataCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetStripeDataCountsQuery, GetStripeDataCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetStripeDataCountsQuery, GetStripeDataCountsQueryVariables>;
export function useGetStripeDataCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStripeDataCountsQuery, GetStripeDataCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetStripeDataCountsQuery | undefined, GetStripeDataCountsQueryVariables>;
export function useGetStripeDataCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStripeDataCountsQuery, GetStripeDataCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStripeDataCountsQuery, GetStripeDataCountsQueryVariables>(GetStripeDataCountsDocument, options);
        }
export type GetStripeDataCountsQueryHookResult = ReturnType<typeof useGetStripeDataCountsQuery>;
export type GetStripeDataCountsLazyQueryHookResult = ReturnType<typeof useGetStripeDataCountsLazyQuery>;
export type GetStripeDataCountsSuspenseQueryHookResult = ReturnType<typeof useGetStripeDataCountsSuspenseQuery>;
export type GetStripeDataCountsQueryResult = ApolloReactCommon.QueryResult<GetStripeDataCountsQuery, GetStripeDataCountsQueryVariables>;
export const GetQuickBooksDataCountsDocument = gql`
    query getQuickBooksDataCounts($input: QuickBooksDataCountsInput!) {
  quickbooksDataCounts(input: $input) {
    customers
    paidInvoices
  }
}
    `;

/**
 * __useGetQuickBooksDataCountsQuery__
 *
 * To run a query within a React component, call `useGetQuickBooksDataCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickBooksDataCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickBooksDataCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuickBooksDataCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetQuickBooksDataCountsQuery, GetQuickBooksDataCountsQueryVariables> & ({ variables: GetQuickBooksDataCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuickBooksDataCountsQuery, GetQuickBooksDataCountsQueryVariables>(GetQuickBooksDataCountsDocument, options);
      }
export function useGetQuickBooksDataCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuickBooksDataCountsQuery, GetQuickBooksDataCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuickBooksDataCountsQuery, GetQuickBooksDataCountsQueryVariables>(GetQuickBooksDataCountsDocument, options);
        }
// @ts-ignore
export function useGetQuickBooksDataCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetQuickBooksDataCountsQuery, GetQuickBooksDataCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetQuickBooksDataCountsQuery, GetQuickBooksDataCountsQueryVariables>;
export function useGetQuickBooksDataCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetQuickBooksDataCountsQuery, GetQuickBooksDataCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetQuickBooksDataCountsQuery | undefined, GetQuickBooksDataCountsQueryVariables>;
export function useGetQuickBooksDataCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetQuickBooksDataCountsQuery, GetQuickBooksDataCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetQuickBooksDataCountsQuery, GetQuickBooksDataCountsQueryVariables>(GetQuickBooksDataCountsDocument, options);
        }
export type GetQuickBooksDataCountsQueryHookResult = ReturnType<typeof useGetQuickBooksDataCountsQuery>;
export type GetQuickBooksDataCountsLazyQueryHookResult = ReturnType<typeof useGetQuickBooksDataCountsLazyQuery>;
export type GetQuickBooksDataCountsSuspenseQueryHookResult = ReturnType<typeof useGetQuickBooksDataCountsSuspenseQuery>;
export type GetQuickBooksDataCountsQueryResult = ApolloReactCommon.QueryResult<GetQuickBooksDataCountsQuery, GetQuickBooksDataCountsQueryVariables>;
export const GetCrmDataCountsDocument = gql`
    query getCrmDataCounts($input: CrmDataCountsInput!) {
  crmDataCounts(input: $input) {
    contacts
    accounts
    deals
  }
}
    `;

/**
 * __useGetCrmDataCountsQuery__
 *
 * To run a query within a React component, call `useGetCrmDataCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmDataCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmDataCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCrmDataCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCrmDataCountsQuery, GetCrmDataCountsQueryVariables> & ({ variables: GetCrmDataCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCrmDataCountsQuery, GetCrmDataCountsQueryVariables>(GetCrmDataCountsDocument, options);
      }
export function useGetCrmDataCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCrmDataCountsQuery, GetCrmDataCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCrmDataCountsQuery, GetCrmDataCountsQueryVariables>(GetCrmDataCountsDocument, options);
        }
// @ts-ignore
export function useGetCrmDataCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCrmDataCountsQuery, GetCrmDataCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmDataCountsQuery, GetCrmDataCountsQueryVariables>;
export function useGetCrmDataCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmDataCountsQuery, GetCrmDataCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmDataCountsQuery | undefined, GetCrmDataCountsQueryVariables>;
export function useGetCrmDataCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmDataCountsQuery, GetCrmDataCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCrmDataCountsQuery, GetCrmDataCountsQueryVariables>(GetCrmDataCountsDocument, options);
        }
export type GetCrmDataCountsQueryHookResult = ReturnType<typeof useGetCrmDataCountsQuery>;
export type GetCrmDataCountsLazyQueryHookResult = ReturnType<typeof useGetCrmDataCountsLazyQuery>;
export type GetCrmDataCountsSuspenseQueryHookResult = ReturnType<typeof useGetCrmDataCountsSuspenseQuery>;
export type GetCrmDataCountsQueryResult = ApolloReactCommon.QueryResult<GetCrmDataCountsQuery, GetCrmDataCountsQueryVariables>;
export const GetIntegrationDocument = gql`
    query getIntegration($workspaceId: Int!, $platform: IntegrationPlatform!) {
  integration(workspaceId: $workspaceId, platform: $platform) {
    ...IntegrationWithTokenFields
  }
}
    ${IntegrationWithTokenFieldsFragmentDoc}`;

/**
 * __useGetIntegrationQuery__
 *
 * To run a query within a React component, call `useGetIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetIntegrationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables> & ({ variables: GetIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
      }
export function useGetIntegrationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
        }
// @ts-ignore
export function useGetIntegrationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIntegrationQuery, GetIntegrationQueryVariables>;
export function useGetIntegrationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIntegrationQuery | undefined, GetIntegrationQueryVariables>;
export function useGetIntegrationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
        }
export type GetIntegrationQueryHookResult = ReturnType<typeof useGetIntegrationQuery>;
export type GetIntegrationLazyQueryHookResult = ReturnType<typeof useGetIntegrationLazyQuery>;
export type GetIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationSuspenseQuery>;
export type GetIntegrationQueryResult = ApolloReactCommon.QueryResult<GetIntegrationQuery, GetIntegrationQueryVariables>;
export const GetGongWebhookUrlDocument = gql`
    query getGongWebhookUrl($workspaceId: ID!) {
  gongWebhookUrl(workspaceId: $workspaceId)
}
    `;

/**
 * __useGetGongWebhookUrlQuery__
 *
 * To run a query within a React component, call `useGetGongWebhookUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGongWebhookUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGongWebhookUrlQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetGongWebhookUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetGongWebhookUrlQuery, GetGongWebhookUrlQueryVariables> & ({ variables: GetGongWebhookUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGongWebhookUrlQuery, GetGongWebhookUrlQueryVariables>(GetGongWebhookUrlDocument, options);
      }
export function useGetGongWebhookUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGongWebhookUrlQuery, GetGongWebhookUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGongWebhookUrlQuery, GetGongWebhookUrlQueryVariables>(GetGongWebhookUrlDocument, options);
        }
// @ts-ignore
export function useGetGongWebhookUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetGongWebhookUrlQuery, GetGongWebhookUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetGongWebhookUrlQuery, GetGongWebhookUrlQueryVariables>;
export function useGetGongWebhookUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetGongWebhookUrlQuery, GetGongWebhookUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetGongWebhookUrlQuery | undefined, GetGongWebhookUrlQueryVariables>;
export function useGetGongWebhookUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetGongWebhookUrlQuery, GetGongWebhookUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetGongWebhookUrlQuery, GetGongWebhookUrlQueryVariables>(GetGongWebhookUrlDocument, options);
        }
export type GetGongWebhookUrlQueryHookResult = ReturnType<typeof useGetGongWebhookUrlQuery>;
export type GetGongWebhookUrlLazyQueryHookResult = ReturnType<typeof useGetGongWebhookUrlLazyQuery>;
export type GetGongWebhookUrlSuspenseQueryHookResult = ReturnType<typeof useGetGongWebhookUrlSuspenseQuery>;
export type GetGongWebhookUrlQueryResult = ApolloReactCommon.QueryResult<GetGongWebhookUrlQuery, GetGongWebhookUrlQueryVariables>;
export const GetJobTitlesDocument = gql`
    query getJobTitles($filter: JobTitleFilter!) {
  jobTitle(filter: $filter) {
    edges {
      node {
        ...JobTitleFields
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${JobTitleFieldsFragmentDoc}`;

/**
 * __useGetJobTitlesQuery__
 *
 * To run a query within a React component, call `useGetJobTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobTitlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetJobTitlesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetJobTitlesQuery, GetJobTitlesQueryVariables> & ({ variables: GetJobTitlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetJobTitlesQuery, GetJobTitlesQueryVariables>(GetJobTitlesDocument, options);
      }
export function useGetJobTitlesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetJobTitlesQuery, GetJobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetJobTitlesQuery, GetJobTitlesQueryVariables>(GetJobTitlesDocument, options);
        }
// @ts-ignore
export function useGetJobTitlesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetJobTitlesQuery, GetJobTitlesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetJobTitlesQuery, GetJobTitlesQueryVariables>;
export function useGetJobTitlesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetJobTitlesQuery, GetJobTitlesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetJobTitlesQuery | undefined, GetJobTitlesQueryVariables>;
export function useGetJobTitlesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetJobTitlesQuery, GetJobTitlesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetJobTitlesQuery, GetJobTitlesQueryVariables>(GetJobTitlesDocument, options);
        }
export type GetJobTitlesQueryHookResult = ReturnType<typeof useGetJobTitlesQuery>;
export type GetJobTitlesLazyQueryHookResult = ReturnType<typeof useGetJobTitlesLazyQuery>;
export type GetJobTitlesSuspenseQueryHookResult = ReturnType<typeof useGetJobTitlesSuspenseQuery>;
export type GetJobTitlesQueryResult = ApolloReactCommon.QueryResult<GetJobTitlesQuery, GetJobTitlesQueryVariables>;
export const GetListFoldersDocument = gql`
    query getListFolders($workspaceId: ID!, $modelType: String!) {
  listFolders(workspaceId: $workspaceId, modelType: $modelType) {
    ...ListFolderFields
  }
}
    ${ListFolderFieldsFragmentDoc}`;

/**
 * __useGetListFoldersQuery__
 *
 * To run a query within a React component, call `useGetListFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListFoldersQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelType: // value for 'modelType'
 *   },
 * });
 */
export function useGetListFoldersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetListFoldersQuery, GetListFoldersQueryVariables> & ({ variables: GetListFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetListFoldersQuery, GetListFoldersQueryVariables>(GetListFoldersDocument, options);
      }
export function useGetListFoldersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetListFoldersQuery, GetListFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetListFoldersQuery, GetListFoldersQueryVariables>(GetListFoldersDocument, options);
        }
// @ts-ignore
export function useGetListFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetListFoldersQuery, GetListFoldersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetListFoldersQuery, GetListFoldersQueryVariables>;
export function useGetListFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListFoldersQuery, GetListFoldersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetListFoldersQuery | undefined, GetListFoldersQueryVariables>;
export function useGetListFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListFoldersQuery, GetListFoldersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetListFoldersQuery, GetListFoldersQueryVariables>(GetListFoldersDocument, options);
        }
export type GetListFoldersQueryHookResult = ReturnType<typeof useGetListFoldersQuery>;
export type GetListFoldersLazyQueryHookResult = ReturnType<typeof useGetListFoldersLazyQuery>;
export type GetListFoldersSuspenseQueryHookResult = ReturnType<typeof useGetListFoldersSuspenseQuery>;
export type GetListFoldersQueryResult = ApolloReactCommon.QueryResult<GetListFoldersQuery, GetListFoldersQueryVariables>;
export const GetListFolderAssignmentsDocument = gql`
    query getListFolderAssignments($filter: UserListFilter) {
  userLists(filter: $filter) {
    edges {
      node {
        list {
          __typename
          id
          name
          public
          static
          folderId
        }
      }
    }
  }
}
    `;

/**
 * __useGetListFolderAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetListFolderAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListFolderAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListFolderAssignmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetListFolderAssignmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetListFolderAssignmentsQuery, GetListFolderAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetListFolderAssignmentsQuery, GetListFolderAssignmentsQueryVariables>(GetListFolderAssignmentsDocument, options);
      }
export function useGetListFolderAssignmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetListFolderAssignmentsQuery, GetListFolderAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetListFolderAssignmentsQuery, GetListFolderAssignmentsQueryVariables>(GetListFolderAssignmentsDocument, options);
        }
// @ts-ignore
export function useGetListFolderAssignmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetListFolderAssignmentsQuery, GetListFolderAssignmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetListFolderAssignmentsQuery, GetListFolderAssignmentsQueryVariables>;
export function useGetListFolderAssignmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListFolderAssignmentsQuery, GetListFolderAssignmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetListFolderAssignmentsQuery | undefined, GetListFolderAssignmentsQueryVariables>;
export function useGetListFolderAssignmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListFolderAssignmentsQuery, GetListFolderAssignmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetListFolderAssignmentsQuery, GetListFolderAssignmentsQueryVariables>(GetListFolderAssignmentsDocument, options);
        }
export type GetListFolderAssignmentsQueryHookResult = ReturnType<typeof useGetListFolderAssignmentsQuery>;
export type GetListFolderAssignmentsLazyQueryHookResult = ReturnType<typeof useGetListFolderAssignmentsLazyQuery>;
export type GetListFolderAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetListFolderAssignmentsSuspenseQuery>;
export type GetListFolderAssignmentsQueryResult = ApolloReactCommon.QueryResult<GetListFolderAssignmentsQuery, GetListFolderAssignmentsQueryVariables>;
export const CreateListFolderDocument = gql`
    mutation createListFolder($input: CreateListFolderInput!) {
  createListFolder(input: $input) {
    listFolder {
      ...ListFolderFields
    }
  }
}
    ${ListFolderFieldsFragmentDoc}`;
export type CreateListFolderMutationFn = ApolloReactCommon.MutationFunction<CreateListFolderMutation, CreateListFolderMutationVariables>;

/**
 * __useCreateListFolderMutation__
 *
 * To run a mutation, you first call `useCreateListFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListFolderMutation, { data, loading, error }] = useCreateListFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateListFolderMutation, CreateListFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateListFolderMutation, CreateListFolderMutationVariables>(CreateListFolderDocument, options);
      }
export type CreateListFolderMutationHookResult = ReturnType<typeof useCreateListFolderMutation>;
export type CreateListFolderMutationResult = ApolloReactCommon.MutationResult<CreateListFolderMutation>;
export type CreateListFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateListFolderMutation, CreateListFolderMutationVariables>;
export const UpdateListFolderDocument = gql`
    mutation updateListFolder($input: UpdateListFolderInput!) {
  updateListFolder(input: $input) {
    listFolder {
      ...ListFolderFields
    }
  }
}
    ${ListFolderFieldsFragmentDoc}`;
export type UpdateListFolderMutationFn = ApolloReactCommon.MutationFunction<UpdateListFolderMutation, UpdateListFolderMutationVariables>;

/**
 * __useUpdateListFolderMutation__
 *
 * To run a mutation, you first call `useUpdateListFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListFolderMutation, { data, loading, error }] = useUpdateListFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateListFolderMutation, UpdateListFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateListFolderMutation, UpdateListFolderMutationVariables>(UpdateListFolderDocument, options);
      }
export type UpdateListFolderMutationHookResult = ReturnType<typeof useUpdateListFolderMutation>;
export type UpdateListFolderMutationResult = ApolloReactCommon.MutationResult<UpdateListFolderMutation>;
export type UpdateListFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateListFolderMutation, UpdateListFolderMutationVariables>;
export const DeleteListFolderDocument = gql`
    mutation deleteListFolder($input: DeleteListFolderInput!) {
  deleteListFolder(input: $input) {
    ok
  }
}
    `;
export type DeleteListFolderMutationFn = ApolloReactCommon.MutationFunction<DeleteListFolderMutation, DeleteListFolderMutationVariables>;

/**
 * __useDeleteListFolderMutation__
 *
 * To run a mutation, you first call `useDeleteListFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListFolderMutation, { data, loading, error }] = useDeleteListFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteListFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteListFolderMutation, DeleteListFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteListFolderMutation, DeleteListFolderMutationVariables>(DeleteListFolderDocument, options);
      }
export type DeleteListFolderMutationHookResult = ReturnType<typeof useDeleteListFolderMutation>;
export type DeleteListFolderMutationResult = ApolloReactCommon.MutationResult<DeleteListFolderMutation>;
export type DeleteListFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteListFolderMutation, DeleteListFolderMutationVariables>;
export const MoveListToFolderDocument = gql`
    mutation moveListToFolder($input: UpdateListInput!) {
  updateList(input: $input) {
    list {
      __typename
      id
      folderId
    }
  }
}
    `;
export type MoveListToFolderMutationFn = ApolloReactCommon.MutationFunction<MoveListToFolderMutation, MoveListToFolderMutationVariables>;

/**
 * __useMoveListToFolderMutation__
 *
 * To run a mutation, you first call `useMoveListToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveListToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveListToFolderMutation, { data, loading, error }] = useMoveListToFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveListToFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveListToFolderMutation, MoveListToFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveListToFolderMutation, MoveListToFolderMutationVariables>(MoveListToFolderDocument, options);
      }
export type MoveListToFolderMutationHookResult = ReturnType<typeof useMoveListToFolderMutation>;
export type MoveListToFolderMutationResult = ApolloReactCommon.MutationResult<MoveListToFolderMutation>;
export type MoveListToFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveListToFolderMutation, MoveListToFolderMutationVariables>;
export const GetUserListsDocument = gql`
    query getUserLists($first: Int, $after: String, $filter: UserListFilter, $sort: [SortInput]) {
  userLists(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        list {
          ...ListFields
        }
        pinned
        hidden
        user {
          ...UserBaseFields
        }
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${ListFieldsFragmentDoc}
${UserBaseFieldsFragmentDoc}`;

/**
 * __useGetUserListsQuery__
 *
 * To run a query within a React component, call `useGetUserListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUserListsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserListsQuery, GetUserListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserListsQuery, GetUserListsQueryVariables>(GetUserListsDocument, options);
      }
export function useGetUserListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserListsQuery, GetUserListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserListsQuery, GetUserListsQueryVariables>(GetUserListsDocument, options);
        }
// @ts-ignore
export function useGetUserListsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserListsQuery, GetUserListsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserListsQuery, GetUserListsQueryVariables>;
export function useGetUserListsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserListsQuery, GetUserListsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserListsQuery | undefined, GetUserListsQueryVariables>;
export function useGetUserListsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserListsQuery, GetUserListsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserListsQuery, GetUserListsQueryVariables>(GetUserListsDocument, options);
        }
export type GetUserListsQueryHookResult = ReturnType<typeof useGetUserListsQuery>;
export type GetUserListsLazyQueryHookResult = ReturnType<typeof useGetUserListsLazyQuery>;
export type GetUserListsSuspenseQueryHookResult = ReturnType<typeof useGetUserListsSuspenseQuery>;
export type GetUserListsQueryResult = ApolloReactCommon.QueryResult<GetUserListsQuery, GetUserListsQueryVariables>;
export const GetUserListsWithContactCountsDocument = gql`
    query getUserListsWithContactCounts($first: Int, $after: String, $filter: UserListFilter, $sort: [SortInput]) {
  userLists(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        list {
          ...ListFields
          contactCount
        }
        pinned
        hidden
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${ListFieldsFragmentDoc}`;

/**
 * __useGetUserListsWithContactCountsQuery__
 *
 * To run a query within a React component, call `useGetUserListsWithContactCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListsWithContactCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListsWithContactCountsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUserListsWithContactCountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserListsWithContactCountsQuery, GetUserListsWithContactCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserListsWithContactCountsQuery, GetUserListsWithContactCountsQueryVariables>(GetUserListsWithContactCountsDocument, options);
      }
export function useGetUserListsWithContactCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserListsWithContactCountsQuery, GetUserListsWithContactCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserListsWithContactCountsQuery, GetUserListsWithContactCountsQueryVariables>(GetUserListsWithContactCountsDocument, options);
        }
// @ts-ignore
export function useGetUserListsWithContactCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserListsWithContactCountsQuery, GetUserListsWithContactCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserListsWithContactCountsQuery, GetUserListsWithContactCountsQueryVariables>;
export function useGetUserListsWithContactCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserListsWithContactCountsQuery, GetUserListsWithContactCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserListsWithContactCountsQuery | undefined, GetUserListsWithContactCountsQueryVariables>;
export function useGetUserListsWithContactCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserListsWithContactCountsQuery, GetUserListsWithContactCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserListsWithContactCountsQuery, GetUserListsWithContactCountsQueryVariables>(GetUserListsWithContactCountsDocument, options);
        }
export type GetUserListsWithContactCountsQueryHookResult = ReturnType<typeof useGetUserListsWithContactCountsQuery>;
export type GetUserListsWithContactCountsLazyQueryHookResult = ReturnType<typeof useGetUserListsWithContactCountsLazyQuery>;
export type GetUserListsWithContactCountsSuspenseQueryHookResult = ReturnType<typeof useGetUserListsWithContactCountsSuspenseQuery>;
export type GetUserListsWithContactCountsQueryResult = ApolloReactCommon.QueryResult<GetUserListsWithContactCountsQuery, GetUserListsWithContactCountsQueryVariables>;
export const CreateListDocument = gql`
    mutation createList($input: CreateListInput!) {
  createList(input: $input) {
    list {
      ...ListFields
    }
  }
}
    ${ListFieldsFragmentDoc}`;
export type CreateListMutationFn = ApolloReactCommon.MutationFunction<CreateListMutation, CreateListMutationVariables>;

/**
 * __useCreateListMutation__
 *
 * To run a mutation, you first call `useCreateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListMutation, { data, loading, error }] = useCreateListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateListMutation, CreateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateListMutation, CreateListMutationVariables>(CreateListDocument, options);
      }
export type CreateListMutationHookResult = ReturnType<typeof useCreateListMutation>;
export type CreateListMutationResult = ApolloReactCommon.MutationResult<CreateListMutation>;
export type CreateListMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateListMutation, CreateListMutationVariables>;
export const UpdateListDocument = gql`
    mutation updateList($input: UpdateListInput!) {
  updateList(input: $input) {
    list {
      ...ListFields
    }
  }
}
    ${ListFieldsFragmentDoc}`;
export type UpdateListMutationFn = ApolloReactCommon.MutationFunction<UpdateListMutation, UpdateListMutationVariables>;

/**
 * __useUpdateListMutation__
 *
 * To run a mutation, you first call `useUpdateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListMutation, { data, loading, error }] = useUpdateListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateListMutation, UpdateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateListMutation, UpdateListMutationVariables>(UpdateListDocument, options);
      }
export type UpdateListMutationHookResult = ReturnType<typeof useUpdateListMutation>;
export type UpdateListMutationResult = ApolloReactCommon.MutationResult<UpdateListMutation>;
export type UpdateListMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateListMutation, UpdateListMutationVariables>;
export const UpdateUserListDocument = gql`
    mutation updateUserList($input: UpdateUserListInput!) {
  updateUserList(input: $input) {
    userList {
      userId
      listId
      pinned
      hidden
      createTs
      updateTs
      id
    }
  }
}
    `;
export type UpdateUserListMutationFn = ApolloReactCommon.MutationFunction<UpdateUserListMutation, UpdateUserListMutationVariables>;

/**
 * __useUpdateUserListMutation__
 *
 * To run a mutation, you first call `useUpdateUserListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserListMutation, { data, loading, error }] = useUpdateUserListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserListMutation, UpdateUserListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserListMutation, UpdateUserListMutationVariables>(UpdateUserListDocument, options);
      }
export type UpdateUserListMutationHookResult = ReturnType<typeof useUpdateUserListMutation>;
export type UpdateUserListMutationResult = ApolloReactCommon.MutationResult<UpdateUserListMutation>;
export type UpdateUserListMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserListMutation, UpdateUserListMutationVariables>;
export const AddRecordsToListDocument = gql`
    mutation addRecordsToList($input: AddRecordsToListInput!) {
  addRecordsToList(input: $input) {
    ok
  }
}
    `;
export type AddRecordsToListMutationFn = ApolloReactCommon.MutationFunction<AddRecordsToListMutation, AddRecordsToListMutationVariables>;

/**
 * __useAddRecordsToListMutation__
 *
 * To run a mutation, you first call `useAddRecordsToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRecordsToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRecordsToListMutation, { data, loading, error }] = useAddRecordsToListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRecordsToListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddRecordsToListMutation, AddRecordsToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddRecordsToListMutation, AddRecordsToListMutationVariables>(AddRecordsToListDocument, options);
      }
export type AddRecordsToListMutationHookResult = ReturnType<typeof useAddRecordsToListMutation>;
export type AddRecordsToListMutationResult = ApolloReactCommon.MutationResult<AddRecordsToListMutation>;
export type AddRecordsToListMutationOptions = ApolloReactCommon.BaseMutationOptions<AddRecordsToListMutation, AddRecordsToListMutationVariables>;
export const RemoveRecordsFromListDocument = gql`
    mutation removeRecordsFromList($input: RemoveRecordsFromListInput!) {
  removeRecordsFromList(input: $input) {
    ok
  }
}
    `;
export type RemoveRecordsFromListMutationFn = ApolloReactCommon.MutationFunction<RemoveRecordsFromListMutation, RemoveRecordsFromListMutationVariables>;

/**
 * __useRemoveRecordsFromListMutation__
 *
 * To run a mutation, you first call `useRemoveRecordsFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRecordsFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRecordsFromListMutation, { data, loading, error }] = useRemoveRecordsFromListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveRecordsFromListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveRecordsFromListMutation, RemoveRecordsFromListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveRecordsFromListMutation, RemoveRecordsFromListMutationVariables>(RemoveRecordsFromListDocument, options);
      }
export type RemoveRecordsFromListMutationHookResult = ReturnType<typeof useRemoveRecordsFromListMutation>;
export type RemoveRecordsFromListMutationResult = ApolloReactCommon.MutationResult<RemoveRecordsFromListMutation>;
export type RemoveRecordsFromListMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveRecordsFromListMutation, RemoveRecordsFromListMutationVariables>;
export const GetRecordListMembershipsDocument = gql`
    query getRecordListMemberships($workspaceId: ID!, $modelType: String!, $recordIds: [ID!]!) {
  recordListMemberships(
    workspaceId: $workspaceId
    modelType: $modelType
    recordIds: $recordIds
  ) {
    recordId
    listIds
  }
}
    `;

/**
 * __useGetRecordListMembershipsQuery__
 *
 * To run a query within a React component, call `useGetRecordListMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordListMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordListMembershipsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelType: // value for 'modelType'
 *      recordIds: // value for 'recordIds'
 *   },
 * });
 */
export function useGetRecordListMembershipsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRecordListMembershipsQuery, GetRecordListMembershipsQueryVariables> & ({ variables: GetRecordListMembershipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRecordListMembershipsQuery, GetRecordListMembershipsQueryVariables>(GetRecordListMembershipsDocument, options);
      }
export function useGetRecordListMembershipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecordListMembershipsQuery, GetRecordListMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRecordListMembershipsQuery, GetRecordListMembershipsQueryVariables>(GetRecordListMembershipsDocument, options);
        }
// @ts-ignore
export function useGetRecordListMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetRecordListMembershipsQuery, GetRecordListMembershipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetRecordListMembershipsQuery, GetRecordListMembershipsQueryVariables>;
export function useGetRecordListMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRecordListMembershipsQuery, GetRecordListMembershipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetRecordListMembershipsQuery | undefined, GetRecordListMembershipsQueryVariables>;
export function useGetRecordListMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRecordListMembershipsQuery, GetRecordListMembershipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRecordListMembershipsQuery, GetRecordListMembershipsQueryVariables>(GetRecordListMembershipsDocument, options);
        }
export type GetRecordListMembershipsQueryHookResult = ReturnType<typeof useGetRecordListMembershipsQuery>;
export type GetRecordListMembershipsLazyQueryHookResult = ReturnType<typeof useGetRecordListMembershipsLazyQuery>;
export type GetRecordListMembershipsSuspenseQueryHookResult = ReturnType<typeof useGetRecordListMembershipsSuspenseQuery>;
export type GetRecordListMembershipsQueryResult = ApolloReactCommon.QueryResult<GetRecordListMembershipsQuery, GetRecordListMembershipsQueryVariables>;
export const GetListAccountCountDocument = gql`
    query getListAccountCount($filter: AccountFilter) {
  accounts(first: 1, filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useGetListAccountCountQuery__
 *
 * To run a query within a React component, call `useGetListAccountCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListAccountCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListAccountCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetListAccountCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetListAccountCountQuery, GetListAccountCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetListAccountCountQuery, GetListAccountCountQueryVariables>(GetListAccountCountDocument, options);
      }
export function useGetListAccountCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetListAccountCountQuery, GetListAccountCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetListAccountCountQuery, GetListAccountCountQueryVariables>(GetListAccountCountDocument, options);
        }
// @ts-ignore
export function useGetListAccountCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetListAccountCountQuery, GetListAccountCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetListAccountCountQuery, GetListAccountCountQueryVariables>;
export function useGetListAccountCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListAccountCountQuery, GetListAccountCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetListAccountCountQuery | undefined, GetListAccountCountQueryVariables>;
export function useGetListAccountCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListAccountCountQuery, GetListAccountCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetListAccountCountQuery, GetListAccountCountQueryVariables>(GetListAccountCountDocument, options);
        }
export type GetListAccountCountQueryHookResult = ReturnType<typeof useGetListAccountCountQuery>;
export type GetListAccountCountLazyQueryHookResult = ReturnType<typeof useGetListAccountCountLazyQuery>;
export type GetListAccountCountSuspenseQueryHookResult = ReturnType<typeof useGetListAccountCountSuspenseQuery>;
export type GetListAccountCountQueryResult = ApolloReactCommon.QueryResult<GetListAccountCountQuery, GetListAccountCountQueryVariables>;
export const GetListContactCountDocument = gql`
    query getListContactCount($filter: ContactFilterInput) {
  contacts(first: 1, filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useGetListContactCountQuery__
 *
 * To run a query within a React component, call `useGetListContactCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListContactCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListContactCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetListContactCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetListContactCountQuery, GetListContactCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetListContactCountQuery, GetListContactCountQueryVariables>(GetListContactCountDocument, options);
      }
export function useGetListContactCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetListContactCountQuery, GetListContactCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetListContactCountQuery, GetListContactCountQueryVariables>(GetListContactCountDocument, options);
        }
// @ts-ignore
export function useGetListContactCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetListContactCountQuery, GetListContactCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetListContactCountQuery, GetListContactCountQueryVariables>;
export function useGetListContactCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListContactCountQuery, GetListContactCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetListContactCountQuery | undefined, GetListContactCountQueryVariables>;
export function useGetListContactCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListContactCountQuery, GetListContactCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetListContactCountQuery, GetListContactCountQueryVariables>(GetListContactCountDocument, options);
        }
export type GetListContactCountQueryHookResult = ReturnType<typeof useGetListContactCountQuery>;
export type GetListContactCountLazyQueryHookResult = ReturnType<typeof useGetListContactCountLazyQuery>;
export type GetListContactCountSuspenseQueryHookResult = ReturnType<typeof useGetListContactCountSuspenseQuery>;
export type GetListContactCountQueryResult = ApolloReactCommon.QueryResult<GetListContactCountQuery, GetListContactCountQueryVariables>;
export const GetListDealCountDocument = gql`
    query getListDealCount($filter: DealFilter) {
  deals(first: 1, filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useGetListDealCountQuery__
 *
 * To run a query within a React component, call `useGetListDealCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListDealCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListDealCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetListDealCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetListDealCountQuery, GetListDealCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetListDealCountQuery, GetListDealCountQueryVariables>(GetListDealCountDocument, options);
      }
export function useGetListDealCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetListDealCountQuery, GetListDealCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetListDealCountQuery, GetListDealCountQueryVariables>(GetListDealCountDocument, options);
        }
// @ts-ignore
export function useGetListDealCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetListDealCountQuery, GetListDealCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetListDealCountQuery, GetListDealCountQueryVariables>;
export function useGetListDealCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListDealCountQuery, GetListDealCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetListDealCountQuery | undefined, GetListDealCountQueryVariables>;
export function useGetListDealCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListDealCountQuery, GetListDealCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetListDealCountQuery, GetListDealCountQueryVariables>(GetListDealCountDocument, options);
        }
export type GetListDealCountQueryHookResult = ReturnType<typeof useGetListDealCountQuery>;
export type GetListDealCountLazyQueryHookResult = ReturnType<typeof useGetListDealCountLazyQuery>;
export type GetListDealCountSuspenseQueryHookResult = ReturnType<typeof useGetListDealCountSuspenseQuery>;
export type GetListDealCountQueryResult = ApolloReactCommon.QueryResult<GetListDealCountQuery, GetListDealCountQueryVariables>;
export const SendContactsToMailchimpDocument = gql`
    mutation SendContactsToMailchimp($workspaceId: Int!, $contactIds: [ID!]!, $listId: String!) {
  sendContactToMailchimp(
    workspaceId: $workspaceId
    contactIds: $contactIds
    platform: "mailchimp"
    listId: $listId
  ) {
    ok
  }
}
    `;
export type SendContactsToMailchimpMutationFn = ApolloReactCommon.MutationFunction<SendContactsToMailchimpMutation, SendContactsToMailchimpMutationVariables>;

/**
 * __useSendContactsToMailchimpMutation__
 *
 * To run a mutation, you first call `useSendContactsToMailchimpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactsToMailchimpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactsToMailchimpMutation, { data, loading, error }] = useSendContactsToMailchimpMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      contactIds: // value for 'contactIds'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useSendContactsToMailchimpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendContactsToMailchimpMutation, SendContactsToMailchimpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendContactsToMailchimpMutation, SendContactsToMailchimpMutationVariables>(SendContactsToMailchimpDocument, options);
      }
export type SendContactsToMailchimpMutationHookResult = ReturnType<typeof useSendContactsToMailchimpMutation>;
export type SendContactsToMailchimpMutationResult = ApolloReactCommon.MutationResult<SendContactsToMailchimpMutation>;
export type SendContactsToMailchimpMutationOptions = ApolloReactCommon.BaseMutationOptions<SendContactsToMailchimpMutation, SendContactsToMailchimpMutationVariables>;
export const GetMailchimpAudiencesDocument = gql`
    query GetMailchimpAudiences($workspaceId: Int!) {
  mailchimpAudiences(workspaceId: $workspaceId) {
    id
    name
  }
}
    `;

/**
 * __useGetMailchimpAudiencesQuery__
 *
 * To run a query within a React component, call `useGetMailchimpAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailchimpAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailchimpAudiencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetMailchimpAudiencesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMailchimpAudiencesQuery, GetMailchimpAudiencesQueryVariables> & ({ variables: GetMailchimpAudiencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMailchimpAudiencesQuery, GetMailchimpAudiencesQueryVariables>(GetMailchimpAudiencesDocument, options);
      }
export function useGetMailchimpAudiencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMailchimpAudiencesQuery, GetMailchimpAudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMailchimpAudiencesQuery, GetMailchimpAudiencesQueryVariables>(GetMailchimpAudiencesDocument, options);
        }
// @ts-ignore
export function useGetMailchimpAudiencesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMailchimpAudiencesQuery, GetMailchimpAudiencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMailchimpAudiencesQuery, GetMailchimpAudiencesQueryVariables>;
export function useGetMailchimpAudiencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMailchimpAudiencesQuery, GetMailchimpAudiencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMailchimpAudiencesQuery | undefined, GetMailchimpAudiencesQueryVariables>;
export function useGetMailchimpAudiencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMailchimpAudiencesQuery, GetMailchimpAudiencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMailchimpAudiencesQuery, GetMailchimpAudiencesQueryVariables>(GetMailchimpAudiencesDocument, options);
        }
export type GetMailchimpAudiencesQueryHookResult = ReturnType<typeof useGetMailchimpAudiencesQuery>;
export type GetMailchimpAudiencesLazyQueryHookResult = ReturnType<typeof useGetMailchimpAudiencesLazyQuery>;
export type GetMailchimpAudiencesSuspenseQueryHookResult = ReturnType<typeof useGetMailchimpAudiencesSuspenseQuery>;
export type GetMailchimpAudiencesQueryResult = ApolloReactCommon.QueryResult<GetMailchimpAudiencesQuery, GetMailchimpAudiencesQueryVariables>;
export const GetNextLastActivityResponseDocument = gql`
    query getNextLastActivityResponse($entityId: String!, $timezone: String!, $type: String!, $workspaceId: String!) {
  nextLastActivityResponse(
    timezone: $timezone
    entityId: $entityId
    type: $type
    workspaceId: $workspaceId
  ) {
    response {
      lastActivity
      lastActivityId
      nextStep
      nextStepId
    }
  }
}
    `;

/**
 * __useGetNextLastActivityResponseQuery__
 *
 * To run a query within a React component, call `useGetNextLastActivityResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextLastActivityResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextLastActivityResponseQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      timezone: // value for 'timezone'
 *      type: // value for 'type'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetNextLastActivityResponseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNextLastActivityResponseQuery, GetNextLastActivityResponseQueryVariables> & ({ variables: GetNextLastActivityResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNextLastActivityResponseQuery, GetNextLastActivityResponseQueryVariables>(GetNextLastActivityResponseDocument, options);
      }
export function useGetNextLastActivityResponseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNextLastActivityResponseQuery, GetNextLastActivityResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNextLastActivityResponseQuery, GetNextLastActivityResponseQueryVariables>(GetNextLastActivityResponseDocument, options);
        }
// @ts-ignore
export function useGetNextLastActivityResponseSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNextLastActivityResponseQuery, GetNextLastActivityResponseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNextLastActivityResponseQuery, GetNextLastActivityResponseQueryVariables>;
export function useGetNextLastActivityResponseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNextLastActivityResponseQuery, GetNextLastActivityResponseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNextLastActivityResponseQuery | undefined, GetNextLastActivityResponseQueryVariables>;
export function useGetNextLastActivityResponseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNextLastActivityResponseQuery, GetNextLastActivityResponseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNextLastActivityResponseQuery, GetNextLastActivityResponseQueryVariables>(GetNextLastActivityResponseDocument, options);
        }
export type GetNextLastActivityResponseQueryHookResult = ReturnType<typeof useGetNextLastActivityResponseQuery>;
export type GetNextLastActivityResponseLazyQueryHookResult = ReturnType<typeof useGetNextLastActivityResponseLazyQuery>;
export type GetNextLastActivityResponseSuspenseQueryHookResult = ReturnType<typeof useGetNextLastActivityResponseSuspenseQuery>;
export type GetNextLastActivityResponseQueryResult = ApolloReactCommon.QueryResult<GetNextLastActivityResponseQuery, GetNextLastActivityResponseQueryVariables>;
export const CreateNoteDocument = gql`
    mutation createNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    note {
      blocks
      ...NoteFields
      ...NoteRelations
    }
  }
}
    ${NoteFieldsFragmentDoc}
${NoteRelationsFragmentDoc}`;
export type CreateNoteMutationFn = ApolloReactCommon.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = ApolloReactCommon.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation updateNote($input: UpdateNoteInput!) {
  updateNote(input: $input) {
    note {
      blocks
      aiNotesContent
      ...NoteFields
      ...NoteRelations
    }
  }
}
    ${NoteFieldsFragmentDoc}
${NoteRelationsFragmentDoc}`;
export type UpdateNoteMutationFn = ApolloReactCommon.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = ApolloReactCommon.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const GetNotesDocument = gql`
    query getNotes($first: Int, $after: String, $filter: NoteFilter!, $sort: [SortInput]) {
  notes(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        ...NoteFields
        ddbEngagementIds
        ddbDealIds
        ddbContactIds
        ddbAccountIds
        ...NoteRelations
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${NoteFieldsFragmentDoc}
${NoteRelationsFragmentDoc}`;

/**
 * __useGetNotesQuery__
 *
 * To run a query within a React component, call `useGetNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetNotesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNotesQuery, GetNotesQueryVariables> & ({ variables: GetNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
      }
export function useGetNotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
        }
// @ts-ignore
export function useGetNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotesQuery, GetNotesQueryVariables>;
export function useGetNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotesQuery | undefined, GetNotesQueryVariables>;
export function useGetNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
        }
export type GetNotesQueryHookResult = ReturnType<typeof useGetNotesQuery>;
export type GetNotesLazyQueryHookResult = ReturnType<typeof useGetNotesLazyQuery>;
export type GetNotesSuspenseQueryHookResult = ReturnType<typeof useGetNotesSuspenseQuery>;
export type GetNotesQueryResult = ApolloReactCommon.QueryResult<GetNotesQuery, GetNotesQueryVariables>;
export const GetNoteDocument = gql`
    query getNote($id: ID!, $workspaceId: ID!) {
  note(id: $id, workspaceId: $workspaceId) {
    blocks
    aiNotesContent
    ...NoteFields
    ...NoteRelations
  }
}
    ${NoteFieldsFragmentDoc}
${NoteRelationsFragmentDoc}`;

/**
 * __useGetNoteQuery__
 *
 * To run a query within a React component, call `useGetNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetNoteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNoteQuery, GetNoteQueryVariables> & ({ variables: GetNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
      }
export function useGetNoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
        }
// @ts-ignore
export function useGetNoteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNoteQuery, GetNoteQueryVariables>;
export function useGetNoteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNoteQuery | undefined, GetNoteQueryVariables>;
export function useGetNoteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
        }
export type GetNoteQueryHookResult = ReturnType<typeof useGetNoteQuery>;
export type GetNoteLazyQueryHookResult = ReturnType<typeof useGetNoteLazyQuery>;
export type GetNoteSuspenseQueryHookResult = ReturnType<typeof useGetNoteSuspenseQuery>;
export type GetNoteQueryResult = ApolloReactCommon.QueryResult<GetNoteQuery, GetNoteQueryVariables>;
export const GetNotesForEngagementDocument = gql`
    query getNotesForEngagement($first: Int, $after: String, $filter: NoteFilter!, $sort: [SortInput]) {
  notes(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        id
        title
        aiGenerated
        blocks
        aiNotesContent
        source
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetNotesForEngagementQuery__
 *
 * To run a query within a React component, call `useGetNotesForEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesForEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesForEngagementQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetNotesForEngagementQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNotesForEngagementQuery, GetNotesForEngagementQueryVariables> & ({ variables: GetNotesForEngagementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotesForEngagementQuery, GetNotesForEngagementQueryVariables>(GetNotesForEngagementDocument, options);
      }
export function useGetNotesForEngagementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotesForEngagementQuery, GetNotesForEngagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotesForEngagementQuery, GetNotesForEngagementQueryVariables>(GetNotesForEngagementDocument, options);
        }
// @ts-ignore
export function useGetNotesForEngagementSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNotesForEngagementQuery, GetNotesForEngagementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotesForEngagementQuery, GetNotesForEngagementQueryVariables>;
export function useGetNotesForEngagementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotesForEngagementQuery, GetNotesForEngagementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotesForEngagementQuery | undefined, GetNotesForEngagementQueryVariables>;
export function useGetNotesForEngagementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotesForEngagementQuery, GetNotesForEngagementQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotesForEngagementQuery, GetNotesForEngagementQueryVariables>(GetNotesForEngagementDocument, options);
        }
export type GetNotesForEngagementQueryHookResult = ReturnType<typeof useGetNotesForEngagementQuery>;
export type GetNotesForEngagementLazyQueryHookResult = ReturnType<typeof useGetNotesForEngagementLazyQuery>;
export type GetNotesForEngagementSuspenseQueryHookResult = ReturnType<typeof useGetNotesForEngagementSuspenseQuery>;
export type GetNotesForEngagementQueryResult = ApolloReactCommon.QueryResult<GetNotesForEngagementQuery, GetNotesForEngagementQueryVariables>;
export const DeleteNoteDocument = gql`
    mutation deleteNote($id: ID!, $workspaceId: ID!) {
  deleteNote(id: $id, workspaceId: $workspaceId) {
    success
  }
}
    `;
export type DeleteNoteMutationFn = ApolloReactCommon.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = ApolloReactCommon.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const GetTasksDocument = gql`
    query getTasks($first: Int, $after: String, $filter: NoteFilter!, $sort: [SortInput]) {
  notes(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        blocks
        ...NoteFields
        ddbEngagementIds
        ddbDealIds
        ddbContactIds
        ddbAccountIds
        ...NoteRelations
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${NoteFieldsFragmentDoc}
${NoteRelationsFragmentDoc}`;

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTasksQuery, GetTasksQueryVariables> & ({ variables: GetTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
      }
export function useGetTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
// @ts-ignore
export function useGetTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTasksQuery, GetTasksQueryVariables>;
export function useGetTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTasksQuery | undefined, GetTasksQueryVariables>;
export function useGetTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>;
export type GetTasksLazyQueryHookResult = ReturnType<typeof useGetTasksLazyQuery>;
export type GetTasksSuspenseQueryHookResult = ReturnType<typeof useGetTasksSuspenseQuery>;
export type GetTasksQueryResult = ApolloReactCommon.QueryResult<GetTasksQuery, GetTasksQueryVariables>;
export const GetTaskDocument = gql`
    query getTask($id: ID!, $workspaceId: ID!) {
  note(id: $id, workspaceId: $workspaceId) {
    blocks
    aiNotesContent
    ...NoteFields
    ddbEngagementIds
    ddbDealIds
    ddbContactIds
    ddbAccountIds
    ...NoteRelations
  }
}
    ${NoteFieldsFragmentDoc}
${NoteRelationsFragmentDoc}`;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetTaskQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables> & ({ variables: GetTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
// @ts-ignore
export function useGetTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTaskQuery, GetTaskQueryVariables>;
export function useGetTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTaskQuery | undefined, GetTaskQueryVariables>;
export function useGetTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskSuspenseQueryHookResult = ReturnType<typeof useGetTaskSuspenseQuery>;
export type GetTaskQueryResult = ApolloReactCommon.QueryResult<GetTaskQuery, GetTaskQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($workspaceId: String!, $limit: Int, $beforeId: ID) {
  notifications(workspaceId: $workspaceId, limit: $limit, beforeId: $beforeId) {
    nodes {
      ...NotificationFields
    }
    hasMore
  }
}
    ${NotificationFieldsFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      limit: // value for 'limit'
 *      beforeId: // value for 'beforeId'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables> & ({ variables: GetNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
// @ts-ignore
export function useGetNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationsQuery | undefined, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = ApolloReactCommon.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetNotificationUnreadCountDocument = gql`
    query getNotificationUnreadCount($workspaceId: String!) {
  notificationUnreadCount(workspaceId: $workspaceId)
}
    `;

/**
 * __useGetNotificationUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationUnreadCountQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetNotificationUnreadCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables> & ({ variables: GetNotificationUnreadCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>(GetNotificationUnreadCountDocument, options);
      }
export function useGetNotificationUnreadCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>(GetNotificationUnreadCountDocument, options);
        }
// @ts-ignore
export function useGetNotificationUnreadCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>;
export function useGetNotificationUnreadCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationUnreadCountQuery | undefined, GetNotificationUnreadCountQueryVariables>;
export function useGetNotificationUnreadCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>(GetNotificationUnreadCountDocument, options);
        }
export type GetNotificationUnreadCountQueryHookResult = ReturnType<typeof useGetNotificationUnreadCountQuery>;
export type GetNotificationUnreadCountLazyQueryHookResult = ReturnType<typeof useGetNotificationUnreadCountLazyQuery>;
export type GetNotificationUnreadCountSuspenseQueryHookResult = ReturnType<typeof useGetNotificationUnreadCountSuspenseQuery>;
export type GetNotificationUnreadCountQueryResult = ApolloReactCommon.QueryResult<GetNotificationUnreadCountQuery, GetNotificationUnreadCountQueryVariables>;
export const GetNotificationNewCountDocument = gql`
    query getNotificationNewCount($workspaceId: String!) {
  notificationNewCount(workspaceId: $workspaceId)
}
    `;

/**
 * __useGetNotificationNewCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationNewCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationNewCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationNewCountQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetNotificationNewCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNotificationNewCountQuery, GetNotificationNewCountQueryVariables> & ({ variables: GetNotificationNewCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationNewCountQuery, GetNotificationNewCountQueryVariables>(GetNotificationNewCountDocument, options);
      }
export function useGetNotificationNewCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationNewCountQuery, GetNotificationNewCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationNewCountQuery, GetNotificationNewCountQueryVariables>(GetNotificationNewCountDocument, options);
        }
// @ts-ignore
export function useGetNotificationNewCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationNewCountQuery, GetNotificationNewCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationNewCountQuery, GetNotificationNewCountQueryVariables>;
export function useGetNotificationNewCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationNewCountQuery, GetNotificationNewCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationNewCountQuery | undefined, GetNotificationNewCountQueryVariables>;
export function useGetNotificationNewCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationNewCountQuery, GetNotificationNewCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationNewCountQuery, GetNotificationNewCountQueryVariables>(GetNotificationNewCountDocument, options);
        }
export type GetNotificationNewCountQueryHookResult = ReturnType<typeof useGetNotificationNewCountQuery>;
export type GetNotificationNewCountLazyQueryHookResult = ReturnType<typeof useGetNotificationNewCountLazyQuery>;
export type GetNotificationNewCountSuspenseQueryHookResult = ReturnType<typeof useGetNotificationNewCountSuspenseQuery>;
export type GetNotificationNewCountQueryResult = ApolloReactCommon.QueryResult<GetNotificationNewCountQuery, GetNotificationNewCountQueryVariables>;
export const MarkNotificationsSeenDocument = gql`
    mutation markNotificationsSeen($workspaceId: String!) {
  markNotificationsSeen(workspaceId: $workspaceId) {
    ok
    newCount
  }
}
    `;
export type MarkNotificationsSeenMutationFn = ApolloReactCommon.MutationFunction<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>;

/**
 * __useMarkNotificationsSeenMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsSeenMutation, { data, loading, error }] = useMarkNotificationsSeenMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useMarkNotificationsSeenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>(MarkNotificationsSeenDocument, options);
      }
export type MarkNotificationsSeenMutationHookResult = ReturnType<typeof useMarkNotificationsSeenMutation>;
export type MarkNotificationsSeenMutationResult = ApolloReactCommon.MutationResult<MarkNotificationsSeenMutation>;
export type MarkNotificationsSeenMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>;
export const MarkNotificationsReadDocument = gql`
    mutation markNotificationsRead($workspaceId: String!, $ids: [ID!]!) {
  markNotificationsRead(workspaceId: $workspaceId, ids: $ids) {
    notifications {
      id
      readTs
    }
    unreadCount
  }
}
    `;
export type MarkNotificationsReadMutationFn = ApolloReactCommon.MutationFunction<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>;

/**
 * __useMarkNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsReadMutation, { data, loading, error }] = useMarkNotificationsReadMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkNotificationsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>(MarkNotificationsReadDocument, options);
      }
export type MarkNotificationsReadMutationHookResult = ReturnType<typeof useMarkNotificationsReadMutation>;
export type MarkNotificationsReadMutationResult = ApolloReactCommon.MutationResult<MarkNotificationsReadMutation>;
export type MarkNotificationsReadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>;
export const MarkAllNotificationsReadDocument = gql`
    mutation markAllNotificationsRead($workspaceId: String!) {
  markAllNotificationsRead(workspaceId: $workspaceId) {
    unreadCount
  }
}
    `;
export type MarkAllNotificationsReadMutationFn = ApolloReactCommon.MutationFunction<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>;

/**
 * __useMarkAllNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsReadMutation, { data, loading, error }] = useMarkAllNotificationsReadMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useMarkAllNotificationsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>(MarkAllNotificationsReadDocument, options);
      }
export type MarkAllNotificationsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationResult = ApolloReactCommon.MutationResult<MarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>;
export const SendTestNotificationDocument = gql`
    mutation sendTestNotification($workspaceId: String!, $type: String!) {
  sendTestNotification(workspaceId: $workspaceId, type: $type) {
    ok
    notification {
      ...NotificationFields
    }
  }
}
    ${NotificationFieldsFragmentDoc}`;
export type SendTestNotificationMutationFn = ApolloReactCommon.MutationFunction<SendTestNotificationMutation, SendTestNotificationMutationVariables>;

/**
 * __useSendTestNotificationMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationMutation, { data, loading, error }] = useSendTestNotificationMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSendTestNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendTestNotificationMutation, SendTestNotificationMutationVariables>(SendTestNotificationDocument, options);
      }
export type SendTestNotificationMutationHookResult = ReturnType<typeof useSendTestNotificationMutation>;
export type SendTestNotificationMutationResult = ApolloReactCommon.MutationResult<SendTestNotificationMutation>;
export type SendTestNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>;
export const GetDealSuggestionForPrefillDocument = gql`
    query getDealSuggestionForPrefill($id: ID!, $workspaceId: ID!) {
  dealSuggestion(id: $id, workspaceId: $workspaceId) {
    id
    dealName
    estimatedAmount
    estimatedCloseDate
    suggestedAccountId
    isDismissed
    convertedDealId
    suggestedAccount {
      id
      properties {
        name
      }
    }
  }
}
    `;

/**
 * __useGetDealSuggestionForPrefillQuery__
 *
 * To run a query within a React component, call `useGetDealSuggestionForPrefillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealSuggestionForPrefillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealSuggestionForPrefillQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetDealSuggestionForPrefillQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealSuggestionForPrefillQuery, GetDealSuggestionForPrefillQueryVariables> & ({ variables: GetDealSuggestionForPrefillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealSuggestionForPrefillQuery, GetDealSuggestionForPrefillQueryVariables>(GetDealSuggestionForPrefillDocument, options);
      }
export function useGetDealSuggestionForPrefillLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealSuggestionForPrefillQuery, GetDealSuggestionForPrefillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealSuggestionForPrefillQuery, GetDealSuggestionForPrefillQueryVariables>(GetDealSuggestionForPrefillDocument, options);
        }
// @ts-ignore
export function useGetDealSuggestionForPrefillSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDealSuggestionForPrefillQuery, GetDealSuggestionForPrefillQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealSuggestionForPrefillQuery, GetDealSuggestionForPrefillQueryVariables>;
export function useGetDealSuggestionForPrefillSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealSuggestionForPrefillQuery, GetDealSuggestionForPrefillQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealSuggestionForPrefillQuery | undefined, GetDealSuggestionForPrefillQueryVariables>;
export function useGetDealSuggestionForPrefillSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealSuggestionForPrefillQuery, GetDealSuggestionForPrefillQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealSuggestionForPrefillQuery, GetDealSuggestionForPrefillQueryVariables>(GetDealSuggestionForPrefillDocument, options);
        }
export type GetDealSuggestionForPrefillQueryHookResult = ReturnType<typeof useGetDealSuggestionForPrefillQuery>;
export type GetDealSuggestionForPrefillLazyQueryHookResult = ReturnType<typeof useGetDealSuggestionForPrefillLazyQuery>;
export type GetDealSuggestionForPrefillSuspenseQueryHookResult = ReturnType<typeof useGetDealSuggestionForPrefillSuspenseQuery>;
export type GetDealSuggestionForPrefillQueryResult = ApolloReactCommon.QueryResult<GetDealSuggestionForPrefillQuery, GetDealSuggestionForPrefillQueryVariables>;
export const RegisterPushSubscriptionDocument = gql`
    mutation registerPushSubscription($workspaceId: String!, $endpoint: String!, $p256dh: String!, $auth: String!, $userAgent: String) {
  registerPushSubscription(
    workspaceId: $workspaceId
    endpoint: $endpoint
    p256dh: $p256dh
    auth: $auth
    userAgent: $userAgent
  ) {
    ok
  }
}
    `;
export type RegisterPushSubscriptionMutationFn = ApolloReactCommon.MutationFunction<RegisterPushSubscriptionMutation, RegisterPushSubscriptionMutationVariables>;

/**
 * __useRegisterPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useRegisterPushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPushSubscriptionMutation, { data, loading, error }] = useRegisterPushSubscriptionMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      endpoint: // value for 'endpoint'
 *      p256dh: // value for 'p256dh'
 *      auth: // value for 'auth'
 *      userAgent: // value for 'userAgent'
 *   },
 * });
 */
export function useRegisterPushSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterPushSubscriptionMutation, RegisterPushSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterPushSubscriptionMutation, RegisterPushSubscriptionMutationVariables>(RegisterPushSubscriptionDocument, options);
      }
export type RegisterPushSubscriptionMutationHookResult = ReturnType<typeof useRegisterPushSubscriptionMutation>;
export type RegisterPushSubscriptionMutationResult = ApolloReactCommon.MutationResult<RegisterPushSubscriptionMutation>;
export type RegisterPushSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<RegisterPushSubscriptionMutation, RegisterPushSubscriptionMutationVariables>;
export const UnregisterPushSubscriptionDocument = gql`
    mutation unregisterPushSubscription($workspaceId: String!, $endpoint: String!) {
  unregisterPushSubscription(workspaceId: $workspaceId, endpoint: $endpoint) {
    ok
  }
}
    `;
export type UnregisterPushSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UnregisterPushSubscriptionMutation, UnregisterPushSubscriptionMutationVariables>;

/**
 * __useUnregisterPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useUnregisterPushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterPushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterPushSubscriptionMutation, { data, loading, error }] = useUnregisterPushSubscriptionMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      endpoint: // value for 'endpoint'
 *   },
 * });
 */
export function useUnregisterPushSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnregisterPushSubscriptionMutation, UnregisterPushSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnregisterPushSubscriptionMutation, UnregisterPushSubscriptionMutationVariables>(UnregisterPushSubscriptionDocument, options);
      }
export type UnregisterPushSubscriptionMutationHookResult = ReturnType<typeof useUnregisterPushSubscriptionMutation>;
export type UnregisterPushSubscriptionMutationResult = ApolloReactCommon.MutationResult<UnregisterPushSubscriptionMutation>;
export type UnregisterPushSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UnregisterPushSubscriptionMutation, UnregisterPushSubscriptionMutationVariables>;
export const GetCrmOauthUrlDocument = gql`
    query getCrmOauthUrl($workspaceId: Int!, $platform: String!, $redirectTo: String) {
  crmOauthUrl(
    workspaceId: $workspaceId
    platform: $platform
    redirectTo: $redirectTo
  )
}
    `;

/**
 * __useGetCrmOauthUrlQuery__
 *
 * To run a query within a React component, call `useGetCrmOauthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmOauthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmOauthUrlQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *      redirectTo: // value for 'redirectTo'
 *   },
 * });
 */
export function useGetCrmOauthUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCrmOauthUrlQuery, GetCrmOauthUrlQueryVariables> & ({ variables: GetCrmOauthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCrmOauthUrlQuery, GetCrmOauthUrlQueryVariables>(GetCrmOauthUrlDocument, options);
      }
export function useGetCrmOauthUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCrmOauthUrlQuery, GetCrmOauthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCrmOauthUrlQuery, GetCrmOauthUrlQueryVariables>(GetCrmOauthUrlDocument, options);
        }
// @ts-ignore
export function useGetCrmOauthUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCrmOauthUrlQuery, GetCrmOauthUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmOauthUrlQuery, GetCrmOauthUrlQueryVariables>;
export function useGetCrmOauthUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmOauthUrlQuery, GetCrmOauthUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCrmOauthUrlQuery | undefined, GetCrmOauthUrlQueryVariables>;
export function useGetCrmOauthUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCrmOauthUrlQuery, GetCrmOauthUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCrmOauthUrlQuery, GetCrmOauthUrlQueryVariables>(GetCrmOauthUrlDocument, options);
        }
export type GetCrmOauthUrlQueryHookResult = ReturnType<typeof useGetCrmOauthUrlQuery>;
export type GetCrmOauthUrlLazyQueryHookResult = ReturnType<typeof useGetCrmOauthUrlLazyQuery>;
export type GetCrmOauthUrlSuspenseQueryHookResult = ReturnType<typeof useGetCrmOauthUrlSuspenseQuery>;
export type GetCrmOauthUrlQueryResult = ApolloReactCommon.QueryResult<GetCrmOauthUrlQuery, GetCrmOauthUrlQueryVariables>;
export const CompleteSlackInstallDocument = gql`
    mutation completeSlackInstall($input: CompleteSlackInstallInput!) {
  completeSlackInstall(input: $input) {
    success
    error
  }
}
    `;
export type CompleteSlackInstallMutationFn = ApolloReactCommon.MutationFunction<CompleteSlackInstallMutation, CompleteSlackInstallMutationVariables>;

/**
 * __useCompleteSlackInstallMutation__
 *
 * To run a mutation, you first call `useCompleteSlackInstallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSlackInstallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSlackInstallMutation, { data, loading, error }] = useCompleteSlackInstallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteSlackInstallMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteSlackInstallMutation, CompleteSlackInstallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteSlackInstallMutation, CompleteSlackInstallMutationVariables>(CompleteSlackInstallDocument, options);
      }
export type CompleteSlackInstallMutationHookResult = ReturnType<typeof useCompleteSlackInstallMutation>;
export type CompleteSlackInstallMutationResult = ApolloReactCommon.MutationResult<CompleteSlackInstallMutation>;
export type CompleteSlackInstallMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteSlackInstallMutation, CompleteSlackInstallMutationVariables>;
export const OptimizedSearchDocument = gql`
    query OptimizedSearch($query: String!, $workspaceId: ID!, $limit: Int) {
  search(query: $query, workspaceId: $workspaceId, limit: $limit) {
    totalResults
    accounts {
      entityType
      total
      results {
        id
        score
        data
        highlight
      }
    }
    contacts {
      entityType
      total
      results {
        id
        score
        data
        highlight
      }
    }
    deals {
      entityType
      total
      results {
        id
        score
        data
        highlight
      }
    }
    meetings {
      entityType
      total
      results {
        id
        score
        data
        highlight
      }
    }
    emails {
      entityType
      total
      results {
        id
        score
        data
        highlight
      }
    }
    notes {
      entityType
      total
      results {
        id
        score
        data
        highlight
      }
    }
    files {
      entityType
      total
      results {
        id
        score
        data
        highlight
      }
    }
  }
}
    `;

/**
 * __useOptimizedSearchQuery__
 *
 * To run a query within a React component, call `useOptimizedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimizedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimizedSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      workspaceId: // value for 'workspaceId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOptimizedSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OptimizedSearchQuery, OptimizedSearchQueryVariables> & ({ variables: OptimizedSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OptimizedSearchQuery, OptimizedSearchQueryVariables>(OptimizedSearchDocument, options);
      }
export function useOptimizedSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OptimizedSearchQuery, OptimizedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OptimizedSearchQuery, OptimizedSearchQueryVariables>(OptimizedSearchDocument, options);
        }
// @ts-ignore
export function useOptimizedSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OptimizedSearchQuery, OptimizedSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OptimizedSearchQuery, OptimizedSearchQueryVariables>;
export function useOptimizedSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OptimizedSearchQuery, OptimizedSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OptimizedSearchQuery | undefined, OptimizedSearchQueryVariables>;
export function useOptimizedSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OptimizedSearchQuery, OptimizedSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OptimizedSearchQuery, OptimizedSearchQueryVariables>(OptimizedSearchDocument, options);
        }
export type OptimizedSearchQueryHookResult = ReturnType<typeof useOptimizedSearchQuery>;
export type OptimizedSearchLazyQueryHookResult = ReturnType<typeof useOptimizedSearchLazyQuery>;
export type OptimizedSearchSuspenseQueryHookResult = ReturnType<typeof useOptimizedSearchSuspenseQuery>;
export type OptimizedSearchQueryResult = ApolloReactCommon.QueryResult<OptimizedSearchQuery, OptimizedSearchQueryVariables>;
export const GetPostalCodesDocument = gql`
    query getPostalCodes($filter: PostalCodeFilter!) {
  postalCodes(filter: $filter) {
    edges {
      node {
        ...PostalCodesFields
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${PostalCodesFieldsFragmentDoc}`;

/**
 * __useGetPostalCodesQuery__
 *
 * To run a query within a React component, call `useGetPostalCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostalCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostalCodesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPostalCodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostalCodesQuery, GetPostalCodesQueryVariables> & ({ variables: GetPostalCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostalCodesQuery, GetPostalCodesQueryVariables>(GetPostalCodesDocument, options);
      }
export function useGetPostalCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostalCodesQuery, GetPostalCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostalCodesQuery, GetPostalCodesQueryVariables>(GetPostalCodesDocument, options);
        }
// @ts-ignore
export function useGetPostalCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPostalCodesQuery, GetPostalCodesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPostalCodesQuery, GetPostalCodesQueryVariables>;
export function useGetPostalCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostalCodesQuery, GetPostalCodesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPostalCodesQuery | undefined, GetPostalCodesQueryVariables>;
export function useGetPostalCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostalCodesQuery, GetPostalCodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostalCodesQuery, GetPostalCodesQueryVariables>(GetPostalCodesDocument, options);
        }
export type GetPostalCodesQueryHookResult = ReturnType<typeof useGetPostalCodesQuery>;
export type GetPostalCodesLazyQueryHookResult = ReturnType<typeof useGetPostalCodesLazyQuery>;
export type GetPostalCodesSuspenseQueryHookResult = ReturnType<typeof useGetPostalCodesSuspenseQuery>;
export type GetPostalCodesQueryResult = ApolloReactCommon.QueryResult<GetPostalCodesQuery, GetPostalCodesQueryVariables>;
export const GetProductsDocument = gql`
    query getProducts($workspaceId: ID!) {
  products(workspaceId: $workspaceId) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables> & ({ variables: GetProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
// @ts-ignore
export function useGetProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetProductsQuery, GetProductsQueryVariables>;
export function useGetProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetProductsQuery | undefined, GetProductsQueryVariables>;
export function useGetProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = ApolloReactCommon.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetDealLineItemsDocument = gql`
    query getDealLineItems($dealId: String!, $workspaceId: ID!) {
  dealLineItems(dealId: $dealId, workspaceId: $workspaceId) {
    ...LineItemFields
  }
}
    ${LineItemFieldsFragmentDoc}`;

/**
 * __useGetDealLineItemsQuery__
 *
 * To run a query within a React component, call `useGetDealLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealLineItemsQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetDealLineItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealLineItemsQuery, GetDealLineItemsQueryVariables> & ({ variables: GetDealLineItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealLineItemsQuery, GetDealLineItemsQueryVariables>(GetDealLineItemsDocument, options);
      }
export function useGetDealLineItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealLineItemsQuery, GetDealLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealLineItemsQuery, GetDealLineItemsQueryVariables>(GetDealLineItemsDocument, options);
        }
// @ts-ignore
export function useGetDealLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDealLineItemsQuery, GetDealLineItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealLineItemsQuery, GetDealLineItemsQueryVariables>;
export function useGetDealLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealLineItemsQuery, GetDealLineItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetDealLineItemsQuery | undefined, GetDealLineItemsQueryVariables>;
export function useGetDealLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealLineItemsQuery, GetDealLineItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealLineItemsQuery, GetDealLineItemsQueryVariables>(GetDealLineItemsDocument, options);
        }
export type GetDealLineItemsQueryHookResult = ReturnType<typeof useGetDealLineItemsQuery>;
export type GetDealLineItemsLazyQueryHookResult = ReturnType<typeof useGetDealLineItemsLazyQuery>;
export type GetDealLineItemsSuspenseQueryHookResult = ReturnType<typeof useGetDealLineItemsSuspenseQuery>;
export type GetDealLineItemsQueryResult = ApolloReactCommon.QueryResult<GetDealLineItemsQuery, GetDealLineItemsQueryVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    product {
      ...ProductFields
    }
  }
}
    ${ProductFieldsFragmentDoc}`;
export type CreateProductMutationFn = ApolloReactCommon.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = ApolloReactCommon.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    product {
      ...ProductFields
    }
  }
}
    ${ProductFieldsFragmentDoc}`;
export type UpdateProductMutationFn = ApolloReactCommon.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = ApolloReactCommon.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation deleteProduct($id: ID!, $workspaceId: ID!) {
  deleteProduct(id: $id, workspaceId: $workspaceId) {
    success
  }
}
    `;
export type DeleteProductMutationFn = ApolloReactCommon.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = ApolloReactCommon.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const SetDealLineItemsDocument = gql`
    mutation setDealLineItems($workspaceId: ID!, $dealId: String!, $lineItems: [LineItemInput!]!) {
  setDealLineItems(
    workspaceId: $workspaceId
    dealId: $dealId
    lineItems: $lineItems
  ) {
    lineItems {
      ...LineItemFields
    }
  }
}
    ${LineItemFieldsFragmentDoc}`;
export type SetDealLineItemsMutationFn = ApolloReactCommon.MutationFunction<SetDealLineItemsMutation, SetDealLineItemsMutationVariables>;

/**
 * __useSetDealLineItemsMutation__
 *
 * To run a mutation, you first call `useSetDealLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDealLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDealLineItemsMutation, { data, loading, error }] = useSetDealLineItemsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      dealId: // value for 'dealId'
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
export function useSetDealLineItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetDealLineItemsMutation, SetDealLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDealLineItemsMutation, SetDealLineItemsMutationVariables>(SetDealLineItemsDocument, options);
      }
export type SetDealLineItemsMutationHookResult = ReturnType<typeof useSetDealLineItemsMutation>;
export type SetDealLineItemsMutationResult = ApolloReactCommon.MutationResult<SetDealLineItemsMutation>;
export type SetDealLineItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<SetDealLineItemsMutation, SetDealLineItemsMutationVariables>;
export const GetUserQuotasDocument = gql`
    query getUserQuotas($workspaceId: ID!, $periodType: QuotaPeriodType!, $from: Date!, $to: Date!) {
  userQuotas(
    workspaceId: $workspaceId
    periodType: $periodType
    from: $from
    to: $to
  ) {
    id
    workspaceId
    userId
    periodType
    periodStart
    amount
  }
}
    `;

/**
 * __useGetUserQuotasQuery__
 *
 * To run a query within a React component, call `useGetUserQuotasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuotasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuotasQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      periodType: // value for 'periodType'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetUserQuotasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserQuotasQuery, GetUserQuotasQueryVariables> & ({ variables: GetUserQuotasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserQuotasQuery, GetUserQuotasQueryVariables>(GetUserQuotasDocument, options);
      }
export function useGetUserQuotasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserQuotasQuery, GetUserQuotasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserQuotasQuery, GetUserQuotasQueryVariables>(GetUserQuotasDocument, options);
        }
// @ts-ignore
export function useGetUserQuotasSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuotasQuery, GetUserQuotasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserQuotasQuery, GetUserQuotasQueryVariables>;
export function useGetUserQuotasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuotasQuery, GetUserQuotasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserQuotasQuery | undefined, GetUserQuotasQueryVariables>;
export function useGetUserQuotasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuotasQuery, GetUserQuotasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserQuotasQuery, GetUserQuotasQueryVariables>(GetUserQuotasDocument, options);
        }
export type GetUserQuotasQueryHookResult = ReturnType<typeof useGetUserQuotasQuery>;
export type GetUserQuotasLazyQueryHookResult = ReturnType<typeof useGetUserQuotasLazyQuery>;
export type GetUserQuotasSuspenseQueryHookResult = ReturnType<typeof useGetUserQuotasSuspenseQuery>;
export type GetUserQuotasQueryResult = ApolloReactCommon.QueryResult<GetUserQuotasQuery, GetUserQuotasQueryVariables>;
export const SetUserQuotasDocument = gql`
    mutation setUserQuotas($workspaceId: ID!, $quotas: [UserQuotaInput!]!) {
  setUserQuotas(workspaceId: $workspaceId, quotas: $quotas) {
    quotas {
      id
      workspaceId
      userId
      periodType
      periodStart
      amount
    }
  }
}
    `;
export type SetUserQuotasMutationFn = ApolloReactCommon.MutationFunction<SetUserQuotasMutation, SetUserQuotasMutationVariables>;

/**
 * __useSetUserQuotasMutation__
 *
 * To run a mutation, you first call `useSetUserQuotasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserQuotasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserQuotasMutation, { data, loading, error }] = useSetUserQuotasMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      quotas: // value for 'quotas'
 *   },
 * });
 */
export function useSetUserQuotasMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserQuotasMutation, SetUserQuotasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetUserQuotasMutation, SetUserQuotasMutationVariables>(SetUserQuotasDocument, options);
      }
export type SetUserQuotasMutationHookResult = ReturnType<typeof useSetUserQuotasMutation>;
export type SetUserQuotasMutationResult = ApolloReactCommon.MutationResult<SetUserQuotasMutation>;
export type SetUserQuotasMutationOptions = ApolloReactCommon.BaseMutationOptions<SetUserQuotasMutation, SetUserQuotasMutationVariables>;
export const GetReportTemplatesDocument = gql`
    query getReportTemplates($workspaceId: ID!) {
  reportTemplates(workspaceId: $workspaceId) {
    templateKey
    name
    description
    definition
  }
}
    `;

/**
 * __useGetReportTemplatesQuery__
 *
 * To run a query within a React component, call `useGetReportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplatesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetReportTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetReportTemplatesQuery, GetReportTemplatesQueryVariables> & ({ variables: GetReportTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, options);
      }
export function useGetReportTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, options);
        }
// @ts-ignore
export function useGetReportTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>;
export function useGetReportTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportTemplatesQuery | undefined, GetReportTemplatesQueryVariables>;
export function useGetReportTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, options);
        }
export type GetReportTemplatesQueryHookResult = ReturnType<typeof useGetReportTemplatesQuery>;
export type GetReportTemplatesLazyQueryHookResult = ReturnType<typeof useGetReportTemplatesLazyQuery>;
export type GetReportTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetReportTemplatesSuspenseQuery>;
export type GetReportTemplatesQueryResult = ApolloReactCommon.QueryResult<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>;
export const GetReportDefinitionsDocument = gql`
    query getReportDefinitions($workspaceId: ID!) {
  reportDefinitions(workspaceId: $workspaceId) {
    ...ReportDefinitionFields
    latestRun {
      id
      status
      narrative
      finishedAt
      createTs
    }
  }
}
    ${ReportDefinitionFieldsFragmentDoc}`;

/**
 * __useGetReportDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetReportDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportDefinitionsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetReportDefinitionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetReportDefinitionsQuery, GetReportDefinitionsQueryVariables> & ({ variables: GetReportDefinitionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportDefinitionsQuery, GetReportDefinitionsQueryVariables>(GetReportDefinitionsDocument, options);
      }
export function useGetReportDefinitionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportDefinitionsQuery, GetReportDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportDefinitionsQuery, GetReportDefinitionsQueryVariables>(GetReportDefinitionsDocument, options);
        }
// @ts-ignore
export function useGetReportDefinitionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetReportDefinitionsQuery, GetReportDefinitionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportDefinitionsQuery, GetReportDefinitionsQueryVariables>;
export function useGetReportDefinitionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportDefinitionsQuery, GetReportDefinitionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportDefinitionsQuery | undefined, GetReportDefinitionsQueryVariables>;
export function useGetReportDefinitionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportDefinitionsQuery, GetReportDefinitionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReportDefinitionsQuery, GetReportDefinitionsQueryVariables>(GetReportDefinitionsDocument, options);
        }
export type GetReportDefinitionsQueryHookResult = ReturnType<typeof useGetReportDefinitionsQuery>;
export type GetReportDefinitionsLazyQueryHookResult = ReturnType<typeof useGetReportDefinitionsLazyQuery>;
export type GetReportDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetReportDefinitionsSuspenseQuery>;
export type GetReportDefinitionsQueryResult = ApolloReactCommon.QueryResult<GetReportDefinitionsQuery, GetReportDefinitionsQueryVariables>;
export const GetReportDefinitionDocument = gql`
    query getReportDefinition($workspaceId: ID!, $id: ID!) {
  reportDefinition(workspaceId: $workspaceId, id: $id) {
    ...ReportDefinitionFields
    latestRun {
      ...ReportRunFields
    }
  }
}
    ${ReportDefinitionFieldsFragmentDoc}
${ReportRunFieldsFragmentDoc}`;

/**
 * __useGetReportDefinitionQuery__
 *
 * To run a query within a React component, call `useGetReportDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportDefinitionQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportDefinitionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetReportDefinitionQuery, GetReportDefinitionQueryVariables> & ({ variables: GetReportDefinitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>(GetReportDefinitionDocument, options);
      }
export function useGetReportDefinitionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>(GetReportDefinitionDocument, options);
        }
// @ts-ignore
export function useGetReportDefinitionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>;
export function useGetReportDefinitionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportDefinitionQuery | undefined, GetReportDefinitionQueryVariables>;
export function useGetReportDefinitionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>(GetReportDefinitionDocument, options);
        }
export type GetReportDefinitionQueryHookResult = ReturnType<typeof useGetReportDefinitionQuery>;
export type GetReportDefinitionLazyQueryHookResult = ReturnType<typeof useGetReportDefinitionLazyQuery>;
export type GetReportDefinitionSuspenseQueryHookResult = ReturnType<typeof useGetReportDefinitionSuspenseQuery>;
export type GetReportDefinitionQueryResult = ApolloReactCommon.QueryResult<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>;
export const GetReportRunsDocument = gql`
    query getReportRuns($workspaceId: ID!, $reportId: ID!, $limit: Int, $beforeId: ID) {
  reportRuns(
    workspaceId: $workspaceId
    reportId: $reportId
    limit: $limit
    beforeId: $beforeId
  ) {
    id
    status
    triggerSource
    narrative
    error
    creditsCharged
    startedAt
    finishedAt
    createTs
  }
}
    `;

/**
 * __useGetReportRunsQuery__
 *
 * To run a query within a React component, call `useGetReportRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportRunsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      reportId: // value for 'reportId'
 *      limit: // value for 'limit'
 *      beforeId: // value for 'beforeId'
 *   },
 * });
 */
export function useGetReportRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetReportRunsQuery, GetReportRunsQueryVariables> & ({ variables: GetReportRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportRunsQuery, GetReportRunsQueryVariables>(GetReportRunsDocument, options);
      }
export function useGetReportRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportRunsQuery, GetReportRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportRunsQuery, GetReportRunsQueryVariables>(GetReportRunsDocument, options);
        }
// @ts-ignore
export function useGetReportRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetReportRunsQuery, GetReportRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportRunsQuery, GetReportRunsQueryVariables>;
export function useGetReportRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportRunsQuery, GetReportRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportRunsQuery | undefined, GetReportRunsQueryVariables>;
export function useGetReportRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportRunsQuery, GetReportRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReportRunsQuery, GetReportRunsQueryVariables>(GetReportRunsDocument, options);
        }
export type GetReportRunsQueryHookResult = ReturnType<typeof useGetReportRunsQuery>;
export type GetReportRunsLazyQueryHookResult = ReturnType<typeof useGetReportRunsLazyQuery>;
export type GetReportRunsSuspenseQueryHookResult = ReturnType<typeof useGetReportRunsSuspenseQuery>;
export type GetReportRunsQueryResult = ApolloReactCommon.QueryResult<GetReportRunsQuery, GetReportRunsQueryVariables>;
export const GetReportRunDocument = gql`
    query getReportRun($workspaceId: ID!, $id: ID!) {
  reportRun(workspaceId: $workspaceId, id: $id) {
    ...ReportRunFields
  }
}
    ${ReportRunFieldsFragmentDoc}`;

/**
 * __useGetReportRunQuery__
 *
 * To run a query within a React component, call `useGetReportRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportRunQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportRunQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetReportRunQuery, GetReportRunQueryVariables> & ({ variables: GetReportRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportRunQuery, GetReportRunQueryVariables>(GetReportRunDocument, options);
      }
export function useGetReportRunLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportRunQuery, GetReportRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportRunQuery, GetReportRunQueryVariables>(GetReportRunDocument, options);
        }
// @ts-ignore
export function useGetReportRunSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetReportRunQuery, GetReportRunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportRunQuery, GetReportRunQueryVariables>;
export function useGetReportRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportRunQuery, GetReportRunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportRunQuery | undefined, GetReportRunQueryVariables>;
export function useGetReportRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportRunQuery, GetReportRunQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReportRunQuery, GetReportRunQueryVariables>(GetReportRunDocument, options);
        }
export type GetReportRunQueryHookResult = ReturnType<typeof useGetReportRunQuery>;
export type GetReportRunLazyQueryHookResult = ReturnType<typeof useGetReportRunLazyQuery>;
export type GetReportRunSuspenseQueryHookResult = ReturnType<typeof useGetReportRunSuspenseQuery>;
export type GetReportRunQueryResult = ApolloReactCommon.QueryResult<GetReportRunQuery, GetReportRunQueryVariables>;
export const GetReportCatalogDocument = gql`
    query getReportCatalog($workspaceId: ID!) {
  reportCatalog(workspaceId: $workspaceId) {
    version
    objects
    pipelines
    timeRangeKeys
    vizKinds
    filterOps
    metricOps
    groupIntervals
    templateKeys
  }
}
    `;

/**
 * __useGetReportCatalogQuery__
 *
 * To run a query within a React component, call `useGetReportCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportCatalogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetReportCatalogQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetReportCatalogQuery, GetReportCatalogQueryVariables> & ({ variables: GetReportCatalogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportCatalogQuery, GetReportCatalogQueryVariables>(GetReportCatalogDocument, options);
      }
export function useGetReportCatalogLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportCatalogQuery, GetReportCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportCatalogQuery, GetReportCatalogQueryVariables>(GetReportCatalogDocument, options);
        }
// @ts-ignore
export function useGetReportCatalogSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetReportCatalogQuery, GetReportCatalogQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportCatalogQuery, GetReportCatalogQueryVariables>;
export function useGetReportCatalogSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportCatalogQuery, GetReportCatalogQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetReportCatalogQuery | undefined, GetReportCatalogQueryVariables>;
export function useGetReportCatalogSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportCatalogQuery, GetReportCatalogQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReportCatalogQuery, GetReportCatalogQueryVariables>(GetReportCatalogDocument, options);
        }
export type GetReportCatalogQueryHookResult = ReturnType<typeof useGetReportCatalogQuery>;
export type GetReportCatalogLazyQueryHookResult = ReturnType<typeof useGetReportCatalogLazyQuery>;
export type GetReportCatalogSuspenseQueryHookResult = ReturnType<typeof useGetReportCatalogSuspenseQuery>;
export type GetReportCatalogQueryResult = ApolloReactCommon.QueryResult<GetReportCatalogQuery, GetReportCatalogQueryVariables>;
export const CreateReportDefinitionDocument = gql`
    mutation createReportDefinition($input: CreateReportDefinitionInput!) {
  createReportDefinition(input: $input) {
    report {
      ...ReportDefinitionFields
    }
  }
}
    ${ReportDefinitionFieldsFragmentDoc}`;
export type CreateReportDefinitionMutationFn = ApolloReactCommon.MutationFunction<CreateReportDefinitionMutation, CreateReportDefinitionMutationVariables>;

/**
 * __useCreateReportDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateReportDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportDefinitionMutation, { data, loading, error }] = useCreateReportDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportDefinitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateReportDefinitionMutation, CreateReportDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateReportDefinitionMutation, CreateReportDefinitionMutationVariables>(CreateReportDefinitionDocument, options);
      }
export type CreateReportDefinitionMutationHookResult = ReturnType<typeof useCreateReportDefinitionMutation>;
export type CreateReportDefinitionMutationResult = ApolloReactCommon.MutationResult<CreateReportDefinitionMutation>;
export type CreateReportDefinitionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateReportDefinitionMutation, CreateReportDefinitionMutationVariables>;
export const UpdateReportDefinitionDocument = gql`
    mutation updateReportDefinition($input: UpdateReportDefinitionInput!) {
  updateReportDefinition(input: $input) {
    report {
      ...ReportDefinitionFields
    }
  }
}
    ${ReportDefinitionFieldsFragmentDoc}`;
export type UpdateReportDefinitionMutationFn = ApolloReactCommon.MutationFunction<UpdateReportDefinitionMutation, UpdateReportDefinitionMutationVariables>;

/**
 * __useUpdateReportDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateReportDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportDefinitionMutation, { data, loading, error }] = useUpdateReportDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportDefinitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateReportDefinitionMutation, UpdateReportDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateReportDefinitionMutation, UpdateReportDefinitionMutationVariables>(UpdateReportDefinitionDocument, options);
      }
export type UpdateReportDefinitionMutationHookResult = ReturnType<typeof useUpdateReportDefinitionMutation>;
export type UpdateReportDefinitionMutationResult = ApolloReactCommon.MutationResult<UpdateReportDefinitionMutation>;
export type UpdateReportDefinitionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateReportDefinitionMutation, UpdateReportDefinitionMutationVariables>;
export const DeleteReportDefinitionDocument = gql`
    mutation deleteReportDefinition($input: DeleteReportDefinitionInput!) {
  deleteReportDefinition(input: $input) {
    ok
  }
}
    `;
export type DeleteReportDefinitionMutationFn = ApolloReactCommon.MutationFunction<DeleteReportDefinitionMutation, DeleteReportDefinitionMutationVariables>;

/**
 * __useDeleteReportDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteReportDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportDefinitionMutation, { data, loading, error }] = useDeleteReportDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportDefinitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteReportDefinitionMutation, DeleteReportDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteReportDefinitionMutation, DeleteReportDefinitionMutationVariables>(DeleteReportDefinitionDocument, options);
      }
export type DeleteReportDefinitionMutationHookResult = ReturnType<typeof useDeleteReportDefinitionMutation>;
export type DeleteReportDefinitionMutationResult = ApolloReactCommon.MutationResult<DeleteReportDefinitionMutation>;
export type DeleteReportDefinitionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteReportDefinitionMutation, DeleteReportDefinitionMutationVariables>;
export const RunReportDocument = gql`
    mutation runReport($input: RunReportInput!) {
  runReport(input: $input) {
    run {
      ...ReportRunFields
    }
  }
}
    ${ReportRunFieldsFragmentDoc}`;
export type RunReportMutationFn = ApolloReactCommon.MutationFunction<RunReportMutation, RunReportMutationVariables>;

/**
 * __useRunReportMutation__
 *
 * To run a mutation, you first call `useRunReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runReportMutation, { data, loading, error }] = useRunReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RunReportMutation, RunReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RunReportMutation, RunReportMutationVariables>(RunReportDocument, options);
      }
export type RunReportMutationHookResult = ReturnType<typeof useRunReportMutation>;
export type RunReportMutationResult = ApolloReactCommon.MutationResult<RunReportMutation>;
export type RunReportMutationOptions = ApolloReactCommon.BaseMutationOptions<RunReportMutation, RunReportMutationVariables>;
export const GetPipelineHealthReportDocument = gql`
    query getPipelineHealthReport($filter: ReportFilterInput!) {
  pipelineHealthReport(filter: $filter) {
    totalOpenCount
    totalOpenAmount
    weightedPipeline
    truncated
    funnel {
      stageId
      stageName
      order
      probability
      openCount
      openAmount
      weightedAmount
      avgAgeInStageDays
      conversionToNextPct
      avgDaysInStage
    }
  }
}
    `;

/**
 * __useGetPipelineHealthReportQuery__
 *
 * To run a query within a React component, call `useGetPipelineHealthReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelineHealthReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelineHealthReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPipelineHealthReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPipelineHealthReportQuery, GetPipelineHealthReportQueryVariables> & ({ variables: GetPipelineHealthReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPipelineHealthReportQuery, GetPipelineHealthReportQueryVariables>(GetPipelineHealthReportDocument, options);
      }
export function useGetPipelineHealthReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPipelineHealthReportQuery, GetPipelineHealthReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPipelineHealthReportQuery, GetPipelineHealthReportQueryVariables>(GetPipelineHealthReportDocument, options);
        }
// @ts-ignore
export function useGetPipelineHealthReportSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPipelineHealthReportQuery, GetPipelineHealthReportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPipelineHealthReportQuery, GetPipelineHealthReportQueryVariables>;
export function useGetPipelineHealthReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPipelineHealthReportQuery, GetPipelineHealthReportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPipelineHealthReportQuery | undefined, GetPipelineHealthReportQueryVariables>;
export function useGetPipelineHealthReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPipelineHealthReportQuery, GetPipelineHealthReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPipelineHealthReportQuery, GetPipelineHealthReportQueryVariables>(GetPipelineHealthReportDocument, options);
        }
export type GetPipelineHealthReportQueryHookResult = ReturnType<typeof useGetPipelineHealthReportQuery>;
export type GetPipelineHealthReportLazyQueryHookResult = ReturnType<typeof useGetPipelineHealthReportLazyQuery>;
export type GetPipelineHealthReportSuspenseQueryHookResult = ReturnType<typeof useGetPipelineHealthReportSuspenseQuery>;
export type GetPipelineHealthReportQueryResult = ApolloReactCommon.QueryResult<GetPipelineHealthReportQuery, GetPipelineHealthReportQueryVariables>;
export const GetAutomationRulesDocument = gql`
    query getAutomationRules($workspaceId: Int!) {
  automationRules(workspaceId: $workspaceId) {
    ...AutomationRuleFields
  }
}
    ${AutomationRuleFieldsFragmentDoc}`;

/**
 * __useGetAutomationRulesQuery__
 *
 * To run a query within a React component, call `useGetAutomationRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationRulesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetAutomationRulesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAutomationRulesQuery, GetAutomationRulesQueryVariables> & ({ variables: GetAutomationRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAutomationRulesQuery, GetAutomationRulesQueryVariables>(GetAutomationRulesDocument, options);
      }
export function useGetAutomationRulesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAutomationRulesQuery, GetAutomationRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAutomationRulesQuery, GetAutomationRulesQueryVariables>(GetAutomationRulesDocument, options);
        }
// @ts-ignore
export function useGetAutomationRulesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAutomationRulesQuery, GetAutomationRulesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAutomationRulesQuery, GetAutomationRulesQueryVariables>;
export function useGetAutomationRulesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAutomationRulesQuery, GetAutomationRulesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAutomationRulesQuery | undefined, GetAutomationRulesQueryVariables>;
export function useGetAutomationRulesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAutomationRulesQuery, GetAutomationRulesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAutomationRulesQuery, GetAutomationRulesQueryVariables>(GetAutomationRulesDocument, options);
        }
export type GetAutomationRulesQueryHookResult = ReturnType<typeof useGetAutomationRulesQuery>;
export type GetAutomationRulesLazyQueryHookResult = ReturnType<typeof useGetAutomationRulesLazyQuery>;
export type GetAutomationRulesSuspenseQueryHookResult = ReturnType<typeof useGetAutomationRulesSuspenseQuery>;
export type GetAutomationRulesQueryResult = ApolloReactCommon.QueryResult<GetAutomationRulesQuery, GetAutomationRulesQueryVariables>;
export const CreateAutomationRuleDocument = gql`
    mutation createAutomationRule($input: CreateAutomationRuleInput!) {
  createAutomationRule(input: $input) {
    rule {
      ...AutomationRuleFields
    }
  }
}
    ${AutomationRuleFieldsFragmentDoc}`;
export type CreateAutomationRuleMutationFn = ApolloReactCommon.MutationFunction<CreateAutomationRuleMutation, CreateAutomationRuleMutationVariables>;

/**
 * __useCreateAutomationRuleMutation__
 *
 * To run a mutation, you first call `useCreateAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomationRuleMutation, { data, loading, error }] = useCreateAutomationRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutomationRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAutomationRuleMutation, CreateAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAutomationRuleMutation, CreateAutomationRuleMutationVariables>(CreateAutomationRuleDocument, options);
      }
export type CreateAutomationRuleMutationHookResult = ReturnType<typeof useCreateAutomationRuleMutation>;
export type CreateAutomationRuleMutationResult = ApolloReactCommon.MutationResult<CreateAutomationRuleMutation>;
export type CreateAutomationRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAutomationRuleMutation, CreateAutomationRuleMutationVariables>;
export const UpdateAutomationRuleDocument = gql`
    mutation updateAutomationRule($input: UpdateAutomationRuleInput!) {
  updateAutomationRule(input: $input) {
    rule {
      ...AutomationRuleFields
    }
  }
}
    ${AutomationRuleFieldsFragmentDoc}`;
export type UpdateAutomationRuleMutationFn = ApolloReactCommon.MutationFunction<UpdateAutomationRuleMutation, UpdateAutomationRuleMutationVariables>;

/**
 * __useUpdateAutomationRuleMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationRuleMutation, { data, loading, error }] = useUpdateAutomationRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutomationRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAutomationRuleMutation, UpdateAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAutomationRuleMutation, UpdateAutomationRuleMutationVariables>(UpdateAutomationRuleDocument, options);
      }
export type UpdateAutomationRuleMutationHookResult = ReturnType<typeof useUpdateAutomationRuleMutation>;
export type UpdateAutomationRuleMutationResult = ApolloReactCommon.MutationResult<UpdateAutomationRuleMutation>;
export type UpdateAutomationRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAutomationRuleMutation, UpdateAutomationRuleMutationVariables>;
export const DeleteAutomationRuleDocument = gql`
    mutation deleteAutomationRule($workspaceId: Int!, $id: ID!) {
  deleteAutomationRule(workspaceId: $workspaceId, id: $id) {
    ok
  }
}
    `;
export type DeleteAutomationRuleMutationFn = ApolloReactCommon.MutationFunction<DeleteAutomationRuleMutation, DeleteAutomationRuleMutationVariables>;

/**
 * __useDeleteAutomationRuleMutation__
 *
 * To run a mutation, you first call `useDeleteAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomationRuleMutation, { data, loading, error }] = useDeleteAutomationRuleMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAutomationRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAutomationRuleMutation, DeleteAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAutomationRuleMutation, DeleteAutomationRuleMutationVariables>(DeleteAutomationRuleDocument, options);
      }
export type DeleteAutomationRuleMutationHookResult = ReturnType<typeof useDeleteAutomationRuleMutation>;
export type DeleteAutomationRuleMutationResult = ApolloReactCommon.MutationResult<DeleteAutomationRuleMutation>;
export type DeleteAutomationRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAutomationRuleMutation, DeleteAutomationRuleMutationVariables>;
export const ActivateAutomationRuleDocument = gql`
    mutation activateAutomationRule($workspaceId: Int!, $id: ID!) {
  activateAutomationRule(workspaceId: $workspaceId, id: $id) {
    rule {
      ...AutomationRuleFields
    }
  }
}
    ${AutomationRuleFieldsFragmentDoc}`;
export type ActivateAutomationRuleMutationFn = ApolloReactCommon.MutationFunction<ActivateAutomationRuleMutation, ActivateAutomationRuleMutationVariables>;

/**
 * __useActivateAutomationRuleMutation__
 *
 * To run a mutation, you first call `useActivateAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAutomationRuleMutation, { data, loading, error }] = useActivateAutomationRuleMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateAutomationRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ActivateAutomationRuleMutation, ActivateAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ActivateAutomationRuleMutation, ActivateAutomationRuleMutationVariables>(ActivateAutomationRuleDocument, options);
      }
export type ActivateAutomationRuleMutationHookResult = ReturnType<typeof useActivateAutomationRuleMutation>;
export type ActivateAutomationRuleMutationResult = ApolloReactCommon.MutationResult<ActivateAutomationRuleMutation>;
export type ActivateAutomationRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<ActivateAutomationRuleMutation, ActivateAutomationRuleMutationVariables>;
export const PauseAutomationRuleDocument = gql`
    mutation pauseAutomationRule($workspaceId: Int!, $id: ID!) {
  pauseAutomationRule(workspaceId: $workspaceId, id: $id) {
    rule {
      ...AutomationRuleFields
    }
  }
}
    ${AutomationRuleFieldsFragmentDoc}`;
export type PauseAutomationRuleMutationFn = ApolloReactCommon.MutationFunction<PauseAutomationRuleMutation, PauseAutomationRuleMutationVariables>;

/**
 * __usePauseAutomationRuleMutation__
 *
 * To run a mutation, you first call `usePauseAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseAutomationRuleMutation, { data, loading, error }] = usePauseAutomationRuleMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePauseAutomationRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PauseAutomationRuleMutation, PauseAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PauseAutomationRuleMutation, PauseAutomationRuleMutationVariables>(PauseAutomationRuleDocument, options);
      }
export type PauseAutomationRuleMutationHookResult = ReturnType<typeof usePauseAutomationRuleMutation>;
export type PauseAutomationRuleMutationResult = ApolloReactCommon.MutationResult<PauseAutomationRuleMutation>;
export type PauseAutomationRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<PauseAutomationRuleMutation, PauseAutomationRuleMutationVariables>;
export const TestRunAutomationRuleDocument = gql`
    mutation testRunAutomationRule($workspaceId: Int!, $id: ID!) {
  testRunAutomationRule(workspaceId: $workspaceId, id: $id) {
    result {
      evaluatedCount
      matchedCount
      truncated
      previews {
        entityId
        entityName
        kind
        detail
      }
    }
  }
}
    `;
export type TestRunAutomationRuleMutationFn = ApolloReactCommon.MutationFunction<TestRunAutomationRuleMutation, TestRunAutomationRuleMutationVariables>;

/**
 * __useTestRunAutomationRuleMutation__
 *
 * To run a mutation, you first call `useTestRunAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestRunAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testRunAutomationRuleMutation, { data, loading, error }] = useTestRunAutomationRuleMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTestRunAutomationRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestRunAutomationRuleMutation, TestRunAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestRunAutomationRuleMutation, TestRunAutomationRuleMutationVariables>(TestRunAutomationRuleDocument, options);
      }
export type TestRunAutomationRuleMutationHookResult = ReturnType<typeof useTestRunAutomationRuleMutation>;
export type TestRunAutomationRuleMutationResult = ApolloReactCommon.MutationResult<TestRunAutomationRuleMutation>;
export type TestRunAutomationRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<TestRunAutomationRuleMutation, TestRunAutomationRuleMutationVariables>;
export const UnifiedSearchDocument = gql`
    query unifiedSearch($workspaceId: ID!, $search: String!, $first: Int) {
  contacts(first: $first, filter: {workspaceId: $workspaceId, search: $search}) {
    totalCount
    edges {
      node {
        __typename
        id
        primaryEmail
        properties {
          firstName
          lastName
          jobTitle
        }
        accounts {
          edges {
            node {
              __typename
              id
              domain
              properties {
                name
              }
            }
          }
        }
      }
    }
  }
  accounts(first: $first, filter: {workspaceId: $workspaceId, search: $search}) {
    totalCount
    edges {
      node {
        __typename
        id
        domain
        properties {
          name
        }
      }
    }
  }
  deals(first: $first, filter: {workspaceId: $workspaceId, search: $search}) {
    totalCount
    edges {
      node {
        __typename
        id
        properties {
          name
          description
          amount
        }
        accounts {
          edges {
            node {
              domain
              properties {
                name
              }
            }
          }
        }
      }
    }
  }
  emails: engagements(
    first: $first
    filter: {workspaceId: $workspaceId, search: $search, engagementType: EMAIL}
    sort: [{sort: "desc", field: "properties.start_time.value_datetime"}]
  ) {
    edges {
      node {
        __typename
        id
        displayName
        description
        startTime
        endTime
        platform
        engagementType
      }
      highlights {
        field
        snippets
      }
    }
  }
  meetings: engagements(
    first: $first
    filter: {workspaceId: $workspaceId, search: $search, engagementType: MEETING}
    sort: [{sort: "desc", field: "properties.start_time.value_datetime"}]
  ) {
    edges {
      node {
        __typename
        id
        displayName
        description
        startTime
        endTime
        platform
        engagementType
        hasAiSummary
        hasTranscript
      }
      highlights {
        field
        snippets
      }
    }
  }
  notes(
    first: $first
    filter: {workspaceId: $workspaceId, search: $search}
    sort: [{sort: "desc", field: "properties.updated_at.value_datetime"}]
  ) {
    edges {
      node {
        __typename
        id
        updatedAt
        title
        type
      }
      highlights {
        field
        snippets
      }
    }
  }
  files(
    first: $first
    filter: {workspaceId: $workspaceId, search: $search}
    sort: [{sort: "desc", field: "properties.uploaded_at.value_datetime"}]
  ) {
    edges {
      node {
        __typename
        id
        filename
        mimeType
        size
        uploadedAt
      }
      highlights {
        field
        snippets
      }
    }
  }
}
    `;

/**
 * __useUnifiedSearchQuery__
 *
 * To run a query within a React component, call `useUnifiedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnifiedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnifiedSearchQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUnifiedSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnifiedSearchQuery, UnifiedSearchQueryVariables> & ({ variables: UnifiedSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnifiedSearchQuery, UnifiedSearchQueryVariables>(UnifiedSearchDocument, options);
      }
export function useUnifiedSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnifiedSearchQuery, UnifiedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnifiedSearchQuery, UnifiedSearchQueryVariables>(UnifiedSearchDocument, options);
        }
// @ts-ignore
export function useUnifiedSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UnifiedSearchQuery, UnifiedSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UnifiedSearchQuery, UnifiedSearchQueryVariables>;
export function useUnifiedSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnifiedSearchQuery, UnifiedSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UnifiedSearchQuery | undefined, UnifiedSearchQueryVariables>;
export function useUnifiedSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnifiedSearchQuery, UnifiedSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnifiedSearchQuery, UnifiedSearchQueryVariables>(UnifiedSearchDocument, options);
        }
export type UnifiedSearchQueryHookResult = ReturnType<typeof useUnifiedSearchQuery>;
export type UnifiedSearchLazyQueryHookResult = ReturnType<typeof useUnifiedSearchLazyQuery>;
export type UnifiedSearchSuspenseQueryHookResult = ReturnType<typeof useUnifiedSearchSuspenseQuery>;
export type UnifiedSearchQueryResult = ApolloReactCommon.QueryResult<UnifiedSearchQuery, UnifiedSearchQueryVariables>;
export const SearchCompaniesDocument = gql`
    query searchCompanies($workspaceId: ID!, $search: String!, $first: Int) {
  accounts(first: $first, filter: {workspaceId: $workspaceId, search: $search}) {
    totalCount
    edges {
      node {
        __typename
        id
        domain
        properties {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSearchCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompaniesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchCompaniesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables> & ({ variables: SearchCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
      }
export function useSearchCompaniesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
        }
// @ts-ignore
export function useSearchCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchCompaniesQuery, SearchCompaniesQueryVariables>;
export function useSearchCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchCompaniesQuery | undefined, SearchCompaniesQueryVariables>;
export function useSearchCompaniesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
        }
export type SearchCompaniesQueryHookResult = ReturnType<typeof useSearchCompaniesQuery>;
export type SearchCompaniesLazyQueryHookResult = ReturnType<typeof useSearchCompaniesLazyQuery>;
export type SearchCompaniesSuspenseQueryHookResult = ReturnType<typeof useSearchCompaniesSuspenseQuery>;
export type SearchCompaniesQueryResult = ApolloReactCommon.QueryResult<SearchCompaniesQuery, SearchCompaniesQueryVariables>;
export const SearchPeopleDocument = gql`
    query searchPeople($workspaceId: ID!, $search: String!, $first: Int) {
  contacts(first: $first, filter: {workspaceId: $workspaceId, search: $search}) {
    totalCount
    edges {
      node {
        __typename
        id
        primaryEmail
        properties {
          firstName
          lastName
          jobTitle
        }
        accounts {
          edges {
            node {
              __typename
              id
              domain
              properties {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchPeopleQuery__
 *
 * To run a query within a React component, call `useSearchPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPeopleQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchPeopleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchPeopleQuery, SearchPeopleQueryVariables> & ({ variables: SearchPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchPeopleQuery, SearchPeopleQueryVariables>(SearchPeopleDocument, options);
      }
export function useSearchPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchPeopleQuery, SearchPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchPeopleQuery, SearchPeopleQueryVariables>(SearchPeopleDocument, options);
        }
// @ts-ignore
export function useSearchPeopleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchPeopleQuery, SearchPeopleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchPeopleQuery, SearchPeopleQueryVariables>;
export function useSearchPeopleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchPeopleQuery, SearchPeopleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchPeopleQuery | undefined, SearchPeopleQueryVariables>;
export function useSearchPeopleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchPeopleQuery, SearchPeopleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchPeopleQuery, SearchPeopleQueryVariables>(SearchPeopleDocument, options);
        }
export type SearchPeopleQueryHookResult = ReturnType<typeof useSearchPeopleQuery>;
export type SearchPeopleLazyQueryHookResult = ReturnType<typeof useSearchPeopleLazyQuery>;
export type SearchPeopleSuspenseQueryHookResult = ReturnType<typeof useSearchPeopleSuspenseQuery>;
export type SearchPeopleQueryResult = ApolloReactCommon.QueryResult<SearchPeopleQuery, SearchPeopleQueryVariables>;
export const SearchDealsDocument = gql`
    query searchDeals($workspaceId: ID!, $search: String!, $first: Int) {
  deals(first: $first, filter: {workspaceId: $workspaceId, search: $search}) {
    totalCount
    edges {
      node {
        __typename
        id
        properties {
          name
          description
          amount
        }
        accounts {
          edges {
            node {
              domain
              properties {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchDealsQuery__
 *
 * To run a query within a React component, call `useSearchDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDealsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchDealsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchDealsQuery, SearchDealsQueryVariables> & ({ variables: SearchDealsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchDealsQuery, SearchDealsQueryVariables>(SearchDealsDocument, options);
      }
export function useSearchDealsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchDealsQuery, SearchDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchDealsQuery, SearchDealsQueryVariables>(SearchDealsDocument, options);
        }
// @ts-ignore
export function useSearchDealsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchDealsQuery, SearchDealsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchDealsQuery, SearchDealsQueryVariables>;
export function useSearchDealsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchDealsQuery, SearchDealsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchDealsQuery | undefined, SearchDealsQueryVariables>;
export function useSearchDealsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchDealsQuery, SearchDealsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchDealsQuery, SearchDealsQueryVariables>(SearchDealsDocument, options);
        }
export type SearchDealsQueryHookResult = ReturnType<typeof useSearchDealsQuery>;
export type SearchDealsLazyQueryHookResult = ReturnType<typeof useSearchDealsLazyQuery>;
export type SearchDealsSuspenseQueryHookResult = ReturnType<typeof useSearchDealsSuspenseQuery>;
export type SearchDealsQueryResult = ApolloReactCommon.QueryResult<SearchDealsQuery, SearchDealsQueryVariables>;
export const SearchEmailsDocument = gql`
    query searchEmails($workspaceId: ID!, $search: String!, $first: Int) {
  emails: engagements(
    first: $first
    filter: {workspaceId: $workspaceId, search: $search, engagementType: EMAIL}
    sort: [{sort: "desc", field: "properties.start_time.value_datetime"}]
  ) {
    edges {
      node {
        __typename
        id
        displayName
        description
        startTime
        endTime
        platform
        engagementType
      }
      highlights {
        field
        snippets
      }
    }
  }
}
    `;

/**
 * __useSearchEmailsQuery__
 *
 * To run a query within a React component, call `useSearchEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmailsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchEmailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchEmailsQuery, SearchEmailsQueryVariables> & ({ variables: SearchEmailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchEmailsQuery, SearchEmailsQueryVariables>(SearchEmailsDocument, options);
      }
export function useSearchEmailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchEmailsQuery, SearchEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchEmailsQuery, SearchEmailsQueryVariables>(SearchEmailsDocument, options);
        }
// @ts-ignore
export function useSearchEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchEmailsQuery, SearchEmailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchEmailsQuery, SearchEmailsQueryVariables>;
export function useSearchEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchEmailsQuery, SearchEmailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchEmailsQuery | undefined, SearchEmailsQueryVariables>;
export function useSearchEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchEmailsQuery, SearchEmailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchEmailsQuery, SearchEmailsQueryVariables>(SearchEmailsDocument, options);
        }
export type SearchEmailsQueryHookResult = ReturnType<typeof useSearchEmailsQuery>;
export type SearchEmailsLazyQueryHookResult = ReturnType<typeof useSearchEmailsLazyQuery>;
export type SearchEmailsSuspenseQueryHookResult = ReturnType<typeof useSearchEmailsSuspenseQuery>;
export type SearchEmailsQueryResult = ApolloReactCommon.QueryResult<SearchEmailsQuery, SearchEmailsQueryVariables>;
export const SearchMeetingsDocument = gql`
    query searchMeetings($workspaceId: ID!, $search: String!, $first: Int) {
  meetings: engagements(
    first: $first
    filter: {workspaceId: $workspaceId, search: $search, engagementType: MEETING}
    sort: [{sort: "desc", field: "properties.start_time.value_datetime"}]
  ) {
    edges {
      node {
        __typename
        id
        displayName
        description
        startTime
        endTime
        platform
        engagementType
        hasAiSummary
        hasTranscript
      }
      highlights {
        field
        snippets
      }
    }
  }
}
    `;

/**
 * __useSearchMeetingsQuery__
 *
 * To run a query within a React component, call `useSearchMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMeetingsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchMeetingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchMeetingsQuery, SearchMeetingsQueryVariables> & ({ variables: SearchMeetingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchMeetingsQuery, SearchMeetingsQueryVariables>(SearchMeetingsDocument, options);
      }
export function useSearchMeetingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchMeetingsQuery, SearchMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchMeetingsQuery, SearchMeetingsQueryVariables>(SearchMeetingsDocument, options);
        }
// @ts-ignore
export function useSearchMeetingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchMeetingsQuery, SearchMeetingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchMeetingsQuery, SearchMeetingsQueryVariables>;
export function useSearchMeetingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchMeetingsQuery, SearchMeetingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchMeetingsQuery | undefined, SearchMeetingsQueryVariables>;
export function useSearchMeetingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchMeetingsQuery, SearchMeetingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchMeetingsQuery, SearchMeetingsQueryVariables>(SearchMeetingsDocument, options);
        }
export type SearchMeetingsQueryHookResult = ReturnType<typeof useSearchMeetingsQuery>;
export type SearchMeetingsLazyQueryHookResult = ReturnType<typeof useSearchMeetingsLazyQuery>;
export type SearchMeetingsSuspenseQueryHookResult = ReturnType<typeof useSearchMeetingsSuspenseQuery>;
export type SearchMeetingsQueryResult = ApolloReactCommon.QueryResult<SearchMeetingsQuery, SearchMeetingsQueryVariables>;
export const SearchNotesDocument = gql`
    query searchNotes($workspaceId: ID!, $search: String!, $first: Int) {
  notes(
    first: $first
    filter: {workspaceId: $workspaceId, search: $search}
    sort: [{sort: "desc", field: "properties.updated_at.value_datetime"}]
  ) {
    edges {
      node {
        __typename
        id
        updatedAt
        title
        type
      }
      highlights {
        field
        snippets
      }
    }
  }
}
    `;

/**
 * __useSearchNotesQuery__
 *
 * To run a query within a React component, call `useSearchNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchNotesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchNotesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchNotesQuery, SearchNotesQueryVariables> & ({ variables: SearchNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchNotesQuery, SearchNotesQueryVariables>(SearchNotesDocument, options);
      }
export function useSearchNotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchNotesQuery, SearchNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchNotesQuery, SearchNotesQueryVariables>(SearchNotesDocument, options);
        }
// @ts-ignore
export function useSearchNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchNotesQuery, SearchNotesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchNotesQuery, SearchNotesQueryVariables>;
export function useSearchNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchNotesQuery, SearchNotesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchNotesQuery | undefined, SearchNotesQueryVariables>;
export function useSearchNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchNotesQuery, SearchNotesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchNotesQuery, SearchNotesQueryVariables>(SearchNotesDocument, options);
        }
export type SearchNotesQueryHookResult = ReturnType<typeof useSearchNotesQuery>;
export type SearchNotesLazyQueryHookResult = ReturnType<typeof useSearchNotesLazyQuery>;
export type SearchNotesSuspenseQueryHookResult = ReturnType<typeof useSearchNotesSuspenseQuery>;
export type SearchNotesQueryResult = ApolloReactCommon.QueryResult<SearchNotesQuery, SearchNotesQueryVariables>;
export const SearchFilesDocument = gql`
    query searchFiles($workspaceId: ID!, $search: String!, $first: Int) {
  files(
    first: $first
    filter: {workspaceId: $workspaceId, search: $search}
    sort: [{sort: "desc", field: "properties.uploaded_at.value_datetime"}]
  ) {
    edges {
      node {
        __typename
        id
        filename
        mimeType
        size
        uploadedAt
      }
      highlights {
        field
        snippets
      }
    }
  }
}
    `;

/**
 * __useSearchFilesQuery__
 *
 * To run a query within a React component, call `useSearchFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFilesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchFilesQuery, SearchFilesQueryVariables> & ({ variables: SearchFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchFilesQuery, SearchFilesQueryVariables>(SearchFilesDocument, options);
      }
export function useSearchFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchFilesQuery, SearchFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchFilesQuery, SearchFilesQueryVariables>(SearchFilesDocument, options);
        }
// @ts-ignore
export function useSearchFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchFilesQuery, SearchFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchFilesQuery, SearchFilesQueryVariables>;
export function useSearchFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchFilesQuery, SearchFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchFilesQuery | undefined, SearchFilesQueryVariables>;
export function useSearchFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchFilesQuery, SearchFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchFilesQuery, SearchFilesQueryVariables>(SearchFilesDocument, options);
        }
export type SearchFilesQueryHookResult = ReturnType<typeof useSearchFilesQuery>;
export type SearchFilesLazyQueryHookResult = ReturnType<typeof useSearchFilesLazyQuery>;
export type SearchFilesSuspenseQueryHookResult = ReturnType<typeof useSearchFilesSuspenseQuery>;
export type SearchFilesQueryResult = ApolloReactCommon.QueryResult<SearchFilesQuery, SearchFilesQueryVariables>;
export const NotesSubjectSearchDocument = gql`
    query notesSubjectSearch($workspaceId: ID!, $search: String!, $first: Int) {
  contacts(first: $first, filter: {workspaceId: $workspaceId, search: $search}) {
    totalCount
    edges {
      node {
        ...ContactFields
        accounts {
          edges {
            node {
              ...AccountFields
            }
          }
        }
      }
    }
  }
  accounts(first: $first, filter: {workspaceId: $workspaceId, search: $search}) {
    totalCount
    edges {
      node {
        ...AccountFields
      }
    }
  }
  deals(first: $first, filter: {workspaceId: $workspaceId, search: $search}) {
    totalCount
    edges {
      node {
        ...DealFields
        ...DealRelations
      }
    }
  }
}
    ${ContactFieldsFragmentDoc}
${AccountFieldsFragmentDoc}
${DealFieldsFragmentDoc}
${DealRelationsFragmentDoc}`;

/**
 * __useNotesSubjectSearchQuery__
 *
 * To run a query within a React component, call `useNotesSubjectSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesSubjectSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesSubjectSearchQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useNotesSubjectSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NotesSubjectSearchQuery, NotesSubjectSearchQueryVariables> & ({ variables: NotesSubjectSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NotesSubjectSearchQuery, NotesSubjectSearchQueryVariables>(NotesSubjectSearchDocument, options);
      }
export function useNotesSubjectSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NotesSubjectSearchQuery, NotesSubjectSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NotesSubjectSearchQuery, NotesSubjectSearchQueryVariables>(NotesSubjectSearchDocument, options);
        }
// @ts-ignore
export function useNotesSubjectSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NotesSubjectSearchQuery, NotesSubjectSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NotesSubjectSearchQuery, NotesSubjectSearchQueryVariables>;
export function useNotesSubjectSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotesSubjectSearchQuery, NotesSubjectSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NotesSubjectSearchQuery | undefined, NotesSubjectSearchQueryVariables>;
export function useNotesSubjectSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotesSubjectSearchQuery, NotesSubjectSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NotesSubjectSearchQuery, NotesSubjectSearchQueryVariables>(NotesSubjectSearchDocument, options);
        }
export type NotesSubjectSearchQueryHookResult = ReturnType<typeof useNotesSubjectSearchQuery>;
export type NotesSubjectSearchLazyQueryHookResult = ReturnType<typeof useNotesSubjectSearchLazyQuery>;
export type NotesSubjectSearchSuspenseQueryHookResult = ReturnType<typeof useNotesSubjectSearchSuspenseQuery>;
export type NotesSubjectSearchQueryResult = ApolloReactCommon.QueryResult<NotesSubjectSearchQuery, NotesSubjectSearchQueryVariables>;
export const GetUserGroupsDocument = gql`
    query getUserGroups($workspaceId: ID!, $includeSystem: Boolean) {
  userGroups(workspaceId: $workspaceId, includeSystem: $includeSystem) {
    ...UserGroupFields
  }
}
    ${UserGroupFieldsFragmentDoc}`;

/**
 * __useGetUserGroupsQuery__
 *
 * To run a query within a React component, call `useGetUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      includeSystem: // value for 'includeSystem'
 *   },
 * });
 */
export function useGetUserGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables> & ({ variables: GetUserGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
      }
export function useGetUserGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
// @ts-ignore
export function useGetUserGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserGroupsQuery, GetUserGroupsQueryVariables>;
export function useGetUserGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserGroupsQuery | undefined, GetUserGroupsQueryVariables>;
export function useGetUserGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
export type GetUserGroupsQueryHookResult = ReturnType<typeof useGetUserGroupsQuery>;
export type GetUserGroupsLazyQueryHookResult = ReturnType<typeof useGetUserGroupsLazyQuery>;
export type GetUserGroupsSuspenseQueryHookResult = ReturnType<typeof useGetUserGroupsSuspenseQuery>;
export type GetUserGroupsQueryResult = ApolloReactCommon.QueryResult<GetUserGroupsQuery, GetUserGroupsQueryVariables>;
export const CreateUserGroupDocument = gql`
    mutation createUserGroup($workspaceId: ID!, $name: String!, $description: String, $memberUserIds: [ID!]) {
  createUserGroup(
    workspaceId: $workspaceId
    name: $name
    description: $description
    memberUserIds: $memberUserIds
  ) {
    userGroup {
      ...UserGroupFields
    }
  }
}
    ${UserGroupFieldsFragmentDoc}`;
export type CreateUserGroupMutationFn = ApolloReactCommon.MutationFunction<CreateUserGroupMutation, CreateUserGroupMutationVariables>;

/**
 * __useCreateUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserGroupMutation, { data, loading, error }] = useCreateUserGroupMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      memberUserIds: // value for 'memberUserIds'
 *   },
 * });
 */
export function useCreateUserGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(CreateUserGroupDocument, options);
      }
export type CreateUserGroupMutationHookResult = ReturnType<typeof useCreateUserGroupMutation>;
export type CreateUserGroupMutationResult = ApolloReactCommon.MutationResult<CreateUserGroupMutation>;
export type CreateUserGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>;
export const UpdateUserGroupDocument = gql`
    mutation updateUserGroup($workspaceId: ID!, $id: ID!, $name: String, $description: String) {
  updateUserGroup(
    workspaceId: $workspaceId
    id: $id
    name: $name
    description: $description
  ) {
    userGroup {
      ...UserGroupFields
    }
  }
}
    ${UserGroupFieldsFragmentDoc}`;
export type UpdateUserGroupMutationFn = ApolloReactCommon.MutationFunction<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;

/**
 * __useUpdateUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGroupMutation, { data, loading, error }] = useUpdateUserGroupMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateUserGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>(UpdateUserGroupDocument, options);
      }
export type UpdateUserGroupMutationHookResult = ReturnType<typeof useUpdateUserGroupMutation>;
export type UpdateUserGroupMutationResult = ApolloReactCommon.MutationResult<UpdateUserGroupMutation>;
export type UpdateUserGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;
export const DeleteUserGroupDocument = gql`
    mutation deleteUserGroup($workspaceId: ID!, $id: ID!) {
  deleteUserGroup(workspaceId: $workspaceId, id: $id) {
    ok
  }
}
    `;
export type DeleteUserGroupMutationFn = ApolloReactCommon.MutationFunction<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGroupMutation, { data, loading, error }] = useDeleteUserGroupMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(DeleteUserGroupDocument, options);
      }
export type DeleteUserGroupMutationHookResult = ReturnType<typeof useDeleteUserGroupMutation>;
export type DeleteUserGroupMutationResult = ApolloReactCommon.MutationResult<DeleteUserGroupMutation>;
export type DeleteUserGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;
export const AddUserGroupMembersDocument = gql`
    mutation addUserGroupMembers($workspaceId: ID!, $groupId: ID!, $userIds: [ID!]!) {
  addUserGroupMembers(
    workspaceId: $workspaceId
    groupId: $groupId
    userIds: $userIds
  ) {
    userGroup {
      ...UserGroupFields
    }
  }
}
    ${UserGroupFieldsFragmentDoc}`;
export type AddUserGroupMembersMutationFn = ApolloReactCommon.MutationFunction<AddUserGroupMembersMutation, AddUserGroupMembersMutationVariables>;

/**
 * __useAddUserGroupMembersMutation__
 *
 * To run a mutation, you first call `useAddUserGroupMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserGroupMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserGroupMembersMutation, { data, loading, error }] = useAddUserGroupMembersMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      groupId: // value for 'groupId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useAddUserGroupMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserGroupMembersMutation, AddUserGroupMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserGroupMembersMutation, AddUserGroupMembersMutationVariables>(AddUserGroupMembersDocument, options);
      }
export type AddUserGroupMembersMutationHookResult = ReturnType<typeof useAddUserGroupMembersMutation>;
export type AddUserGroupMembersMutationResult = ApolloReactCommon.MutationResult<AddUserGroupMembersMutation>;
export type AddUserGroupMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserGroupMembersMutation, AddUserGroupMembersMutationVariables>;
export const RemoveUserGroupMembersDocument = gql`
    mutation removeUserGroupMembers($workspaceId: ID!, $groupId: ID!, $userIds: [ID!]!) {
  removeUserGroupMembers(
    workspaceId: $workspaceId
    groupId: $groupId
    userIds: $userIds
  ) {
    userGroup {
      ...UserGroupFields
    }
  }
}
    ${UserGroupFieldsFragmentDoc}`;
export type RemoveUserGroupMembersMutationFn = ApolloReactCommon.MutationFunction<RemoveUserGroupMembersMutation, RemoveUserGroupMembersMutationVariables>;

/**
 * __useRemoveUserGroupMembersMutation__
 *
 * To run a mutation, you first call `useRemoveUserGroupMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserGroupMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserGroupMembersMutation, { data, loading, error }] = useRemoveUserGroupMembersMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      groupId: // value for 'groupId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useRemoveUserGroupMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserGroupMembersMutation, RemoveUserGroupMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserGroupMembersMutation, RemoveUserGroupMembersMutationVariables>(RemoveUserGroupMembersDocument, options);
      }
export type RemoveUserGroupMembersMutationHookResult = ReturnType<typeof useRemoveUserGroupMembersMutation>;
export type RemoveUserGroupMembersMutationResult = ApolloReactCommon.MutationResult<RemoveUserGroupMembersMutation>;
export type RemoveUserGroupMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserGroupMembersMutation, RemoveUserGroupMembersMutationVariables>;
export const GetRecordGrantsDocument = gql`
    query getRecordGrants($workspaceId: ID!, $recordId: String!) {
  recordGrants(workspaceId: $workspaceId, recordId: $recordId) {
    recordId
    viewGroupIds
    editGroupIds
    viewUserIds
    editUserIds
    source
    workspaceDefault
  }
}
    `;

/**
 * __useGetRecordGrantsQuery__
 *
 * To run a query within a React component, call `useGetRecordGrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordGrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordGrantsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useGetRecordGrantsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRecordGrantsQuery, GetRecordGrantsQueryVariables> & ({ variables: GetRecordGrantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRecordGrantsQuery, GetRecordGrantsQueryVariables>(GetRecordGrantsDocument, options);
      }
export function useGetRecordGrantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecordGrantsQuery, GetRecordGrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRecordGrantsQuery, GetRecordGrantsQueryVariables>(GetRecordGrantsDocument, options);
        }
// @ts-ignore
export function useGetRecordGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetRecordGrantsQuery, GetRecordGrantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetRecordGrantsQuery, GetRecordGrantsQueryVariables>;
export function useGetRecordGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRecordGrantsQuery, GetRecordGrantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetRecordGrantsQuery | undefined, GetRecordGrantsQueryVariables>;
export function useGetRecordGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRecordGrantsQuery, GetRecordGrantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRecordGrantsQuery, GetRecordGrantsQueryVariables>(GetRecordGrantsDocument, options);
        }
export type GetRecordGrantsQueryHookResult = ReturnType<typeof useGetRecordGrantsQuery>;
export type GetRecordGrantsLazyQueryHookResult = ReturnType<typeof useGetRecordGrantsLazyQuery>;
export type GetRecordGrantsSuspenseQueryHookResult = ReturnType<typeof useGetRecordGrantsSuspenseQuery>;
export type GetRecordGrantsQueryResult = ApolloReactCommon.QueryResult<GetRecordGrantsQuery, GetRecordGrantsQueryVariables>;
export const SetRecordGrantsDocument = gql`
    mutation setRecordGrants($workspaceId: ID!, $recordId: String!, $grants: [RecordGrantInput!]!, $userGrants: [RecordUserGrantInput!], $reset: Boolean) {
  setRecordGrants(
    workspaceId: $workspaceId
    recordId: $recordId
    grants: $grants
    userGrants: $userGrants
    reset: $reset
  ) {
    recordGrants {
      recordId
      viewGroupIds
      editGroupIds
      viewUserIds
      editUserIds
      source
      workspaceDefault
    }
  }
}
    `;
export type SetRecordGrantsMutationFn = ApolloReactCommon.MutationFunction<SetRecordGrantsMutation, SetRecordGrantsMutationVariables>;

/**
 * __useSetRecordGrantsMutation__
 *
 * To run a mutation, you first call `useSetRecordGrantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRecordGrantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRecordGrantsMutation, { data, loading, error }] = useSetRecordGrantsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      recordId: // value for 'recordId'
 *      grants: // value for 'grants'
 *      userGrants: // value for 'userGrants'
 *      reset: // value for 'reset'
 *   },
 * });
 */
export function useSetRecordGrantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetRecordGrantsMutation, SetRecordGrantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetRecordGrantsMutation, SetRecordGrantsMutationVariables>(SetRecordGrantsDocument, options);
      }
export type SetRecordGrantsMutationHookResult = ReturnType<typeof useSetRecordGrantsMutation>;
export type SetRecordGrantsMutationResult = ApolloReactCommon.MutationResult<SetRecordGrantsMutation>;
export type SetRecordGrantsMutationOptions = ApolloReactCommon.BaseMutationOptions<SetRecordGrantsMutation, SetRecordGrantsMutationVariables>;
export const UpdateRecordSharingDocument = gql`
    mutation updateRecordSharing($input: RecordSharingInput!, $workspaceId: ID!) {
  updateRecordSharing(input: $input, workspaceId: $workspaceId) {
    preferences {
      id
      recordSharingEnabled
    }
  }
}
    `;
export type UpdateRecordSharingMutationFn = ApolloReactCommon.MutationFunction<UpdateRecordSharingMutation, UpdateRecordSharingMutationVariables>;

/**
 * __useUpdateRecordSharingMutation__
 *
 * To run a mutation, you first call `useUpdateRecordSharingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecordSharingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecordSharingMutation, { data, loading, error }] = useUpdateRecordSharingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdateRecordSharingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRecordSharingMutation, UpdateRecordSharingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRecordSharingMutation, UpdateRecordSharingMutationVariables>(UpdateRecordSharingDocument, options);
      }
export type UpdateRecordSharingMutationHookResult = ReturnType<typeof useUpdateRecordSharingMutation>;
export type UpdateRecordSharingMutationResult = ApolloReactCommon.MutationResult<UpdateRecordSharingMutation>;
export type UpdateRecordSharingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRecordSharingMutation, UpdateRecordSharingMutationVariables>;
export const UpdateDefaultRecordAclDocument = gql`
    mutation updateDefaultRecordAcl($input: DefaultRecordAclInput!, $workspaceId: ID!) {
  updateDefaultRecordAcl(input: $input, workspaceId: $workspaceId) {
    preferences {
      id
      notesDefaultAcl
      engagementsDefaultAcl
      filesDefaultAcl
    }
  }
}
    `;
export type UpdateDefaultRecordAclMutationFn = ApolloReactCommon.MutationFunction<UpdateDefaultRecordAclMutation, UpdateDefaultRecordAclMutationVariables>;

/**
 * __useUpdateDefaultRecordAclMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultRecordAclMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultRecordAclMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultRecordAclMutation, { data, loading, error }] = useUpdateDefaultRecordAclMutation({
 *   variables: {
 *      input: // value for 'input'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdateDefaultRecordAclMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDefaultRecordAclMutation, UpdateDefaultRecordAclMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDefaultRecordAclMutation, UpdateDefaultRecordAclMutationVariables>(UpdateDefaultRecordAclDocument, options);
      }
export type UpdateDefaultRecordAclMutationHookResult = ReturnType<typeof useUpdateDefaultRecordAclMutation>;
export type UpdateDefaultRecordAclMutationResult = ApolloReactCommon.MutationResult<UpdateDefaultRecordAclMutation>;
export type UpdateDefaultRecordAclMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDefaultRecordAclMutation, UpdateDefaultRecordAclMutationVariables>;
export const CreateBillingPortalSessionDocument = gql`
    mutation createBillingPortalSession($input: CreateBillingPortalSessionInput!) {
  createBillingPortalSession(input: $input) {
    url
  }
}
    `;
export type CreateBillingPortalSessionMutationFn = ApolloReactCommon.MutationFunction<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;

/**
 * __useCreateBillingPortalSessionMutation__
 *
 * To run a mutation, you first call `useCreateBillingPortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingPortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingPortalSessionMutation, { data, loading, error }] = useCreateBillingPortalSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillingPortalSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>(CreateBillingPortalSessionDocument, options);
      }
export type CreateBillingPortalSessionMutationHookResult = ReturnType<typeof useCreateBillingPortalSessionMutation>;
export type CreateBillingPortalSessionMutationResult = ApolloReactCommon.MutationResult<CreateBillingPortalSessionMutation>;
export type CreateBillingPortalSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;
export const CreateCheckoutSessionDocument = gql`
    mutation createCheckoutSession($input: CreateCheckoutSessionInput!) {
  createCheckoutSession(input: $input) {
    checkoutUrl
    sessionId
  }
}
    `;
export type CreateCheckoutSessionMutationFn = ApolloReactCommon.MutationFunction<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;

/**
 * __useCreateCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutSessionMutation, { data, loading, error }] = useCreateCheckoutSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(CreateCheckoutSessionDocument, options);
      }
export type CreateCheckoutSessionMutationHookResult = ReturnType<typeof useCreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationResult = ApolloReactCommon.MutationResult<CreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const CreateCustomerSessionDocument = gql`
    mutation createCustomerSession($input: CreateCustomerSessionInput!) {
  createCustomerSession(input: $input) {
    clientSecret
  }
}
    `;
export type CreateCustomerSessionMutationFn = ApolloReactCommon.MutationFunction<CreateCustomerSessionMutation, CreateCustomerSessionMutationVariables>;

/**
 * __useCreateCustomerSessionMutation__
 *
 * To run a mutation, you first call `useCreateCustomerSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerSessionMutation, { data, loading, error }] = useCreateCustomerSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomerSessionMutation, CreateCustomerSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomerSessionMutation, CreateCustomerSessionMutationVariables>(CreateCustomerSessionDocument, options);
      }
export type CreateCustomerSessionMutationHookResult = ReturnType<typeof useCreateCustomerSessionMutation>;
export type CreateCustomerSessionMutationResult = ApolloReactCommon.MutationResult<CreateCustomerSessionMutation>;
export type CreateCustomerSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomerSessionMutation, CreateCustomerSessionMutationVariables>;
export const StartFreeTrialDocument = gql`
    mutation startFreeTrial($input: StartFreeTrialInput!) {
  startFreeTrial(input: $input) {
    success
  }
}
    `;
export type StartFreeTrialMutationFn = ApolloReactCommon.MutationFunction<StartFreeTrialMutation, StartFreeTrialMutationVariables>;

/**
 * __useStartFreeTrialMutation__
 *
 * To run a mutation, you first call `useStartFreeTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartFreeTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startFreeTrialMutation, { data, loading, error }] = useStartFreeTrialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartFreeTrialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartFreeTrialMutation, StartFreeTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartFreeTrialMutation, StartFreeTrialMutationVariables>(StartFreeTrialDocument, options);
      }
export type StartFreeTrialMutationHookResult = ReturnType<typeof useStartFreeTrialMutation>;
export type StartFreeTrialMutationResult = ApolloReactCommon.MutationResult<StartFreeTrialMutation>;
export type StartFreeTrialMutationOptions = ApolloReactCommon.BaseMutationOptions<StartFreeTrialMutation, StartFreeTrialMutationVariables>;
export const PurchaseCreditPackDocument = gql`
    mutation purchaseCreditPack($input: PurchaseCreditPackInput!) {
  purchaseCreditPack(input: $input) {
    success
    invoiceId
    checkoutUrl
    sessionId
  }
}
    `;
export type PurchaseCreditPackMutationFn = ApolloReactCommon.MutationFunction<PurchaseCreditPackMutation, PurchaseCreditPackMutationVariables>;

/**
 * __usePurchaseCreditPackMutation__
 *
 * To run a mutation, you first call `usePurchaseCreditPackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseCreditPackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseCreditPackMutation, { data, loading, error }] = usePurchaseCreditPackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseCreditPackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PurchaseCreditPackMutation, PurchaseCreditPackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PurchaseCreditPackMutation, PurchaseCreditPackMutationVariables>(PurchaseCreditPackDocument, options);
      }
export type PurchaseCreditPackMutationHookResult = ReturnType<typeof usePurchaseCreditPackMutation>;
export type PurchaseCreditPackMutationResult = ApolloReactCommon.MutationResult<PurchaseCreditPackMutation>;
export type PurchaseCreditPackMutationOptions = ApolloReactCommon.BaseMutationOptions<PurchaseCreditPackMutation, PurchaseCreditPackMutationVariables>;
export const GetWorkspaceSummaryTemplatesDocument = gql`
    query getWorkspaceSummaryTemplates($workspaceId: ID!) {
  summaryTemplates(filter: {workspaceId: $workspaceId, isWorkspaceWide: true}) {
    edges {
      node {
        ...SummaryTemplateFields
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${SummaryTemplateFieldsFragmentDoc}`;

/**
 * __useGetWorkspaceSummaryTemplatesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSummaryTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSummaryTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSummaryTemplatesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceSummaryTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkspaceSummaryTemplatesQuery, GetWorkspaceSummaryTemplatesQueryVariables> & ({ variables: GetWorkspaceSummaryTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkspaceSummaryTemplatesQuery, GetWorkspaceSummaryTemplatesQueryVariables>(GetWorkspaceSummaryTemplatesDocument, options);
      }
export function useGetWorkspaceSummaryTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkspaceSummaryTemplatesQuery, GetWorkspaceSummaryTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkspaceSummaryTemplatesQuery, GetWorkspaceSummaryTemplatesQueryVariables>(GetWorkspaceSummaryTemplatesDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceSummaryTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceSummaryTemplatesQuery, GetWorkspaceSummaryTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspaceSummaryTemplatesQuery, GetWorkspaceSummaryTemplatesQueryVariables>;
export function useGetWorkspaceSummaryTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceSummaryTemplatesQuery, GetWorkspaceSummaryTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspaceSummaryTemplatesQuery | undefined, GetWorkspaceSummaryTemplatesQueryVariables>;
export function useGetWorkspaceSummaryTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceSummaryTemplatesQuery, GetWorkspaceSummaryTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkspaceSummaryTemplatesQuery, GetWorkspaceSummaryTemplatesQueryVariables>(GetWorkspaceSummaryTemplatesDocument, options);
        }
export type GetWorkspaceSummaryTemplatesQueryHookResult = ReturnType<typeof useGetWorkspaceSummaryTemplatesQuery>;
export type GetWorkspaceSummaryTemplatesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSummaryTemplatesLazyQuery>;
export type GetWorkspaceSummaryTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSummaryTemplatesSuspenseQuery>;
export type GetWorkspaceSummaryTemplatesQueryResult = ApolloReactCommon.QueryResult<GetWorkspaceSummaryTemplatesQuery, GetWorkspaceSummaryTemplatesQueryVariables>;
export const GetUserSummaryTemplatesDocument = gql`
    query getUserSummaryTemplates($workspaceId: ID!, $createdByUserId: Int!) {
  summaryTemplates(
    filter: {workspaceId: $workspaceId, createdByUserId: $createdByUserId, isWorkspaceWide: false}
  ) {
    edges {
      node {
        ...SummaryTemplateWithRelations
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${SummaryTemplateWithRelationsFragmentDoc}`;

/**
 * __useGetUserSummaryTemplatesQuery__
 *
 * To run a query within a React component, call `useGetUserSummaryTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSummaryTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSummaryTemplatesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      createdByUserId: // value for 'createdByUserId'
 *   },
 * });
 */
export function useGetUserSummaryTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserSummaryTemplatesQuery, GetUserSummaryTemplatesQueryVariables> & ({ variables: GetUserSummaryTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserSummaryTemplatesQuery, GetUserSummaryTemplatesQueryVariables>(GetUserSummaryTemplatesDocument, options);
      }
export function useGetUserSummaryTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserSummaryTemplatesQuery, GetUserSummaryTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserSummaryTemplatesQuery, GetUserSummaryTemplatesQueryVariables>(GetUserSummaryTemplatesDocument, options);
        }
// @ts-ignore
export function useGetUserSummaryTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserSummaryTemplatesQuery, GetUserSummaryTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserSummaryTemplatesQuery, GetUserSummaryTemplatesQueryVariables>;
export function useGetUserSummaryTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserSummaryTemplatesQuery, GetUserSummaryTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserSummaryTemplatesQuery | undefined, GetUserSummaryTemplatesQueryVariables>;
export function useGetUserSummaryTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserSummaryTemplatesQuery, GetUserSummaryTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserSummaryTemplatesQuery, GetUserSummaryTemplatesQueryVariables>(GetUserSummaryTemplatesDocument, options);
        }
export type GetUserSummaryTemplatesQueryHookResult = ReturnType<typeof useGetUserSummaryTemplatesQuery>;
export type GetUserSummaryTemplatesLazyQueryHookResult = ReturnType<typeof useGetUserSummaryTemplatesLazyQuery>;
export type GetUserSummaryTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetUserSummaryTemplatesSuspenseQuery>;
export type GetUserSummaryTemplatesQueryResult = ApolloReactCommon.QueryResult<GetUserSummaryTemplatesQuery, GetUserSummaryTemplatesQueryVariables>;
export const CreateSummaryTemplateDocument = gql`
    mutation CreateSummaryTemplate($input: CreateSummaryTemplateInput!) {
  createSummaryTemplate(input: $input) {
    summaryTemplate {
      ...SummaryTemplateFields
    }
  }
}
    ${SummaryTemplateFieldsFragmentDoc}`;
export type CreateSummaryTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateSummaryTemplateMutation, CreateSummaryTemplateMutationVariables>;

/**
 * __useCreateSummaryTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSummaryTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSummaryTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSummaryTemplateMutation, { data, loading, error }] = useCreateSummaryTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSummaryTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSummaryTemplateMutation, CreateSummaryTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSummaryTemplateMutation, CreateSummaryTemplateMutationVariables>(CreateSummaryTemplateDocument, options);
      }
export type CreateSummaryTemplateMutationHookResult = ReturnType<typeof useCreateSummaryTemplateMutation>;
export type CreateSummaryTemplateMutationResult = ApolloReactCommon.MutationResult<CreateSummaryTemplateMutation>;
export type CreateSummaryTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSummaryTemplateMutation, CreateSummaryTemplateMutationVariables>;
export const UpdateSummaryTemplateDocument = gql`
    mutation UpdateSummaryTemplate($input: UpdateSummaryTemplateInput!) {
  updateSummaryTemplate(input: $input) {
    summaryTemplate {
      ...SummaryTemplateFields
    }
  }
}
    ${SummaryTemplateFieldsFragmentDoc}`;
export type UpdateSummaryTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateSummaryTemplateMutation, UpdateSummaryTemplateMutationVariables>;

/**
 * __useUpdateSummaryTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSummaryTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSummaryTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSummaryTemplateMutation, { data, loading, error }] = useUpdateSummaryTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSummaryTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSummaryTemplateMutation, UpdateSummaryTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSummaryTemplateMutation, UpdateSummaryTemplateMutationVariables>(UpdateSummaryTemplateDocument, options);
      }
export type UpdateSummaryTemplateMutationHookResult = ReturnType<typeof useUpdateSummaryTemplateMutation>;
export type UpdateSummaryTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateSummaryTemplateMutation>;
export type UpdateSummaryTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSummaryTemplateMutation, UpdateSummaryTemplateMutationVariables>;
export const DeleteSummaryTemplateDocument = gql`
    mutation DeleteSummaryTemplate($input: DeleteSummaryTemplateInput!) {
  deleteSummaryTemplate(input: $input) {
    success
  }
}
    `;
export type DeleteSummaryTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteSummaryTemplateMutation, DeleteSummaryTemplateMutationVariables>;

/**
 * __useDeleteSummaryTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteSummaryTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSummaryTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSummaryTemplateMutation, { data, loading, error }] = useDeleteSummaryTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSummaryTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSummaryTemplateMutation, DeleteSummaryTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSummaryTemplateMutation, DeleteSummaryTemplateMutationVariables>(DeleteSummaryTemplateDocument, options);
      }
export type DeleteSummaryTemplateMutationHookResult = ReturnType<typeof useDeleteSummaryTemplateMutation>;
export type DeleteSummaryTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteSummaryTemplateMutation>;
export type DeleteSummaryTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSummaryTemplateMutation, DeleteSummaryTemplateMutationVariables>;
export const GenerateSummaryDocument = gql`
    mutation GenerateSummary($input: GenerateSummaryInput!) {
  generateSummary(input: $input) {
    summary {
      id
      engagementId
      summaryTemplateId
      summary
      createdAt
      updatedAt
    }
  }
}
    `;
export type GenerateSummaryMutationFn = ApolloReactCommon.MutationFunction<GenerateSummaryMutation, GenerateSummaryMutationVariables>;

/**
 * __useGenerateSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSummaryMutation, { data, loading, error }] = useGenerateSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSummaryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateSummaryMutation, GenerateSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateSummaryMutation, GenerateSummaryMutationVariables>(GenerateSummaryDocument, options);
      }
export type GenerateSummaryMutationHookResult = ReturnType<typeof useGenerateSummaryMutation>;
export type GenerateSummaryMutationResult = ApolloReactCommon.MutationResult<GenerateSummaryMutation>;
export type GenerateSummaryMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateSummaryMutation, GenerateSummaryMutationVariables>;
export const UpdateEngagementSummaryDocument = gql`
    mutation UpdateEngagementSummary($input: UpdateEngagementSummaryInput!) {
  updateEngagementSummary(input: $input) {
    summary {
      id
      engagementId
      summaryTemplateId
      summary
      createdAt
      updatedAt
    }
    aiSummary
  }
}
    `;
export type UpdateEngagementSummaryMutationFn = ApolloReactCommon.MutationFunction<UpdateEngagementSummaryMutation, UpdateEngagementSummaryMutationVariables>;

/**
 * __useUpdateEngagementSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementSummaryMutation, { data, loading, error }] = useUpdateEngagementSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEngagementSummaryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEngagementSummaryMutation, UpdateEngagementSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEngagementSummaryMutation, UpdateEngagementSummaryMutationVariables>(UpdateEngagementSummaryDocument, options);
      }
export type UpdateEngagementSummaryMutationHookResult = ReturnType<typeof useUpdateEngagementSummaryMutation>;
export type UpdateEngagementSummaryMutationResult = ApolloReactCommon.MutationResult<UpdateEngagementSummaryMutation>;
export type UpdateEngagementSummaryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEngagementSummaryMutation, UpdateEngagementSummaryMutationVariables>;
export const GetTechTagsDocument = gql`
    query getTechTags($filter: TechTagFilter!) {
  techTags(filter: $filter) {
    edges {
      node {
        ...TechTagsFields
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${TechTagsFieldsFragmentDoc}`;

/**
 * __useGetTechTagsQuery__
 *
 * To run a query within a React component, call `useGetTechTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTechTagsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTechTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTechTagsQuery, GetTechTagsQueryVariables> & ({ variables: GetTechTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTechTagsQuery, GetTechTagsQueryVariables>(GetTechTagsDocument, options);
      }
export function useGetTechTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTechTagsQuery, GetTechTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTechTagsQuery, GetTechTagsQueryVariables>(GetTechTagsDocument, options);
        }
// @ts-ignore
export function useGetTechTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTechTagsQuery, GetTechTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTechTagsQuery, GetTechTagsQueryVariables>;
export function useGetTechTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTechTagsQuery, GetTechTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTechTagsQuery | undefined, GetTechTagsQueryVariables>;
export function useGetTechTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTechTagsQuery, GetTechTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTechTagsQuery, GetTechTagsQueryVariables>(GetTechTagsDocument, options);
        }
export type GetTechTagsQueryHookResult = ReturnType<typeof useGetTechTagsQuery>;
export type GetTechTagsLazyQueryHookResult = ReturnType<typeof useGetTechTagsLazyQuery>;
export type GetTechTagsSuspenseQueryHookResult = ReturnType<typeof useGetTechTagsSuspenseQuery>;
export type GetTechTagsQueryResult = ApolloReactCommon.QueryResult<GetTechTagsQuery, GetTechTagsQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers($first: Int, $after: String, $filter: UserFilterInput, $sort: [UserSortEnum], $workspaceId: ID!) {
  users(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        ...UserFields
        role(workspaceId: $workspaceId)
        source(workspaceId: $workspaceId)
        inviteStatus(workspaceId: $workspaceId)
        lastLoginTs(workspaceId: $workspaceId)
        manager(workspaceId: $workspaceId) {
          id
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables> & ({ variables: GetUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = ApolloReactCommon.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserDocument = gql`
    query getUser($id: Int!) {
  user(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
// @ts-ignore
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserQuery, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserQuery | undefined, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = ApolloReactCommon.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetCurrentUserDocument = gql`
    query getCurrentUser($workspaceId: ID!) {
  me {
    ...UserFields
    ...CurrentUserFields
    role(workspaceId: $workspaceId)
    manager(workspaceId: $workspaceId) {
      ...UserFields
    }
    oauthPlatform
  }
}
    ${UserFieldsFragmentDoc}
${CurrentUserFieldsFragmentDoc}`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCurrentUserQuery | undefined, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = ApolloReactCommon.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetCurrentUserWithoutRoleDocument = gql`
    query getCurrentUserWithoutRole {
  me {
    ...UserFields
    ...CurrentUserFields
  }
}
    ${UserFieldsFragmentDoc}
${CurrentUserFieldsFragmentDoc}`;

/**
 * __useGetCurrentUserWithoutRoleQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserWithoutRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserWithoutRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserWithoutRoleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserWithoutRoleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrentUserWithoutRoleQuery, GetCurrentUserWithoutRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCurrentUserWithoutRoleQuery, GetCurrentUserWithoutRoleQueryVariables>(GetCurrentUserWithoutRoleDocument, options);
      }
export function useGetCurrentUserWithoutRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentUserWithoutRoleQuery, GetCurrentUserWithoutRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCurrentUserWithoutRoleQuery, GetCurrentUserWithoutRoleQueryVariables>(GetCurrentUserWithoutRoleDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserWithoutRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserWithoutRoleQuery, GetCurrentUserWithoutRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCurrentUserWithoutRoleQuery, GetCurrentUserWithoutRoleQueryVariables>;
export function useGetCurrentUserWithoutRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserWithoutRoleQuery, GetCurrentUserWithoutRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCurrentUserWithoutRoleQuery | undefined, GetCurrentUserWithoutRoleQueryVariables>;
export function useGetCurrentUserWithoutRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserWithoutRoleQuery, GetCurrentUserWithoutRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCurrentUserWithoutRoleQuery, GetCurrentUserWithoutRoleQueryVariables>(GetCurrentUserWithoutRoleDocument, options);
        }
export type GetCurrentUserWithoutRoleQueryHookResult = ReturnType<typeof useGetCurrentUserWithoutRoleQuery>;
export type GetCurrentUserWithoutRoleLazyQueryHookResult = ReturnType<typeof useGetCurrentUserWithoutRoleLazyQuery>;
export type GetCurrentUserWithoutRoleSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserWithoutRoleSuspenseQuery>;
export type GetCurrentUserWithoutRoleQueryResult = ApolloReactCommon.QueryResult<GetCurrentUserWithoutRoleQuery, GetCurrentUserWithoutRoleQueryVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!, $workspaceId: ID!) {
  updateUser(input: $input) {
    user {
      ...UserFields
      ...CurrentUserFields
      role(workspaceId: $workspaceId)
    }
  }
}
    ${UserFieldsFragmentDoc}
${CurrentUserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const InviteUserDocument = gql`
    mutation inviteUser($input: InviteUserInput!) {
  inviteUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type InviteUserMutationFn = ApolloReactCommon.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = ApolloReactCommon.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($input: DeleteUserRoleInput!) {
  deleteUserRole(input: $input) {
    success
    error
  }
}
    `;
export type DeleteUserMutationFn = ApolloReactCommon.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = ApolloReactCommon.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const AddUserManagerDocument = gql`
    mutation addUserManager($input: AddUserManagerInput!) {
  addUserManager(input: $input) {
    success
    error
  }
}
    `;
export type AddUserManagerMutationFn = ApolloReactCommon.MutationFunction<AddUserManagerMutation, AddUserManagerMutationVariables>;

/**
 * __useAddUserManagerMutation__
 *
 * To run a mutation, you first call `useAddUserManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserManagerMutation, { data, loading, error }] = useAddUserManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserManagerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserManagerMutation, AddUserManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserManagerMutation, AddUserManagerMutationVariables>(AddUserManagerDocument, options);
      }
export type AddUserManagerMutationHookResult = ReturnType<typeof useAddUserManagerMutation>;
export type AddUserManagerMutationResult = ApolloReactCommon.MutationResult<AddUserManagerMutation>;
export type AddUserManagerMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserManagerMutation, AddUserManagerMutationVariables>;
export const GetUserPreferencesDocument = gql`
    query getUserPreferences($workspaceId: ID!) {
  userPreferences(workspaceId: $workspaceId) {
    __typename
    id
    language
    pcContactsAccountsFromMeetings
    pcContactsAccountsFromEmails
    vcRecordMeetings
    vcRecordMeetingsType
    vcBotName
    vcUseCustomBotName
    vcRecorderType
    vcRecorderAppearance
    vcRecorderCustomImageUrl
    closeDateInPast
    noActivity
    noNextSteps
    fewContacts
    externalMeetings
    actionItemsDue
    followUpEmails
    deliveryMethod
    notificationChannels
    timezone
    suggestedChanges
    createdDefaultEmailTemplates
  }
}
    `;

/**
 * __useGetUserPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetUserPreferencesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables> & ({ variables: GetUserPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
      }
export function useGetUserPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
        }
// @ts-ignore
export function useGetUserPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>;
export function useGetUserPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserPreferencesQuery | undefined, GetUserPreferencesQueryVariables>;
export function useGetUserPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
        }
export type GetUserPreferencesQueryHookResult = ReturnType<typeof useGetUserPreferencesQuery>;
export type GetUserPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserPreferencesLazyQuery>;
export type GetUserPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetUserPreferencesSuspenseQuery>;
export type GetUserPreferencesQueryResult = ApolloReactCommon.QueryResult<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>;
export const UpdateProductivityPreferencesDocument = gql`
    mutation updateProductivityPreferences($input: PCPreferencesInput!, $workspaceId: ID!) {
  updatePcPreferences(input: $input, workspaceId: $workspaceId) {
    preferences {
      pcContactsAccountsFromMeetings
      pcContactsAccountsFromEmails
    }
  }
}
    `;
export type UpdateProductivityPreferencesMutationFn = ApolloReactCommon.MutationFunction<UpdateProductivityPreferencesMutation, UpdateProductivityPreferencesMutationVariables>;

/**
 * __useUpdateProductivityPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateProductivityPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductivityPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductivityPreferencesMutation, { data, loading, error }] = useUpdateProductivityPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdateProductivityPreferencesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductivityPreferencesMutation, UpdateProductivityPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProductivityPreferencesMutation, UpdateProductivityPreferencesMutationVariables>(UpdateProductivityPreferencesDocument, options);
      }
export type UpdateProductivityPreferencesMutationHookResult = ReturnType<typeof useUpdateProductivityPreferencesMutation>;
export type UpdateProductivityPreferencesMutationResult = ApolloReactCommon.MutationResult<UpdateProductivityPreferencesMutation>;
export type UpdateProductivityPreferencesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductivityPreferencesMutation, UpdateProductivityPreferencesMutationVariables>;
export const UpdateVideoConferencingPreferencesDocument = gql`
    mutation updateVideoConferencingPreferences($input: VCPreferencesInput!, $workspaceId: ID!) {
  updateVcPreferences(input: $input, workspaceId: $workspaceId) {
    preferences {
      vcRecordMeetings
      vcRecordMeetingsType
      vcBotName
      vcUseCustomBotName
      vcRecorderType
      vcRecorderAppearance
      vcRecorderCustomImageUrl
    }
  }
}
    `;
export type UpdateVideoConferencingPreferencesMutationFn = ApolloReactCommon.MutationFunction<UpdateVideoConferencingPreferencesMutation, UpdateVideoConferencingPreferencesMutationVariables>;

/**
 * __useUpdateVideoConferencingPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateVideoConferencingPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoConferencingPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoConferencingPreferencesMutation, { data, loading, error }] = useUpdateVideoConferencingPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdateVideoConferencingPreferencesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateVideoConferencingPreferencesMutation, UpdateVideoConferencingPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateVideoConferencingPreferencesMutation, UpdateVideoConferencingPreferencesMutationVariables>(UpdateVideoConferencingPreferencesDocument, options);
      }
export type UpdateVideoConferencingPreferencesMutationHookResult = ReturnType<typeof useUpdateVideoConferencingPreferencesMutation>;
export type UpdateVideoConferencingPreferencesMutationResult = ApolloReactCommon.MutationResult<UpdateVideoConferencingPreferencesMutation>;
export type UpdateVideoConferencingPreferencesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateVideoConferencingPreferencesMutation, UpdateVideoConferencingPreferencesMutationVariables>;
export const UpdateUserLanguageDocument = gql`
    mutation updateUserLanguage($workspaceId: ID!, $language: String!) {
  updateUserLanguage(workspaceId: $workspaceId, language: $language) {
    preferences {
      __typename
      id
      language
    }
  }
}
    `;
export type UpdateUserLanguageMutationFn = ApolloReactCommon.MutationFunction<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>;

/**
 * __useUpdateUserLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateUserLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLanguageMutation, { data, loading, error }] = useUpdateUserLanguageMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateUserLanguageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(UpdateUserLanguageDocument, options);
      }
export type UpdateUserLanguageMutationHookResult = ReturnType<typeof useUpdateUserLanguageMutation>;
export type UpdateUserLanguageMutationResult = ApolloReactCommon.MutationResult<UpdateUserLanguageMutation>;
export type UpdateUserLanguageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>;
export const UpdateNotificationsPreferencesDocument = gql`
    mutation updateNotificationsPreferences($input: NTFPreferencesInput!, $workspaceId: ID!) {
  updateNtfPreferences(input: $input, workspaceId: $workspaceId) {
    preferences {
      preferences
    }
  }
}
    `;
export type UpdateNotificationsPreferencesMutationFn = ApolloReactCommon.MutationFunction<UpdateNotificationsPreferencesMutation, UpdateNotificationsPreferencesMutationVariables>;

/**
 * __useUpdateNotificationsPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsPreferencesMutation, { data, loading, error }] = useUpdateNotificationsPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdateNotificationsPreferencesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNotificationsPreferencesMutation, UpdateNotificationsPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNotificationsPreferencesMutation, UpdateNotificationsPreferencesMutationVariables>(UpdateNotificationsPreferencesDocument, options);
      }
export type UpdateNotificationsPreferencesMutationHookResult = ReturnType<typeof useUpdateNotificationsPreferencesMutation>;
export type UpdateNotificationsPreferencesMutationResult = ApolloReactCommon.MutationResult<UpdateNotificationsPreferencesMutation>;
export type UpdateNotificationsPreferencesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNotificationsPreferencesMutation, UpdateNotificationsPreferencesMutationVariables>;
export const GetWorkspaceConnectionsDocument = gql`
    query getWorkspaceConnections($workspaceId: Int!) {
  workspaceConnections(workspaceId: $workspaceId) {
    ...WorkspaceConnectionFields
  }
}
    ${WorkspaceConnectionFieldsFragmentDoc}`;

/**
 * __useGetWorkspaceConnectionsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceConnectionsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceConnectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkspaceConnectionsQuery, GetWorkspaceConnectionsQueryVariables> & ({ variables: GetWorkspaceConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkspaceConnectionsQuery, GetWorkspaceConnectionsQueryVariables>(GetWorkspaceConnectionsDocument, options);
      }
export function useGetWorkspaceConnectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkspaceConnectionsQuery, GetWorkspaceConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkspaceConnectionsQuery, GetWorkspaceConnectionsQueryVariables>(GetWorkspaceConnectionsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceConnectionsQuery, GetWorkspaceConnectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspaceConnectionsQuery, GetWorkspaceConnectionsQueryVariables>;
export function useGetWorkspaceConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceConnectionsQuery, GetWorkspaceConnectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspaceConnectionsQuery | undefined, GetWorkspaceConnectionsQueryVariables>;
export function useGetWorkspaceConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceConnectionsQuery, GetWorkspaceConnectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkspaceConnectionsQuery, GetWorkspaceConnectionsQueryVariables>(GetWorkspaceConnectionsDocument, options);
        }
export type GetWorkspaceConnectionsQueryHookResult = ReturnType<typeof useGetWorkspaceConnectionsQuery>;
export type GetWorkspaceConnectionsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceConnectionsLazyQuery>;
export type GetWorkspaceConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceConnectionsSuspenseQuery>;
export type GetWorkspaceConnectionsQueryResult = ApolloReactCommon.QueryResult<GetWorkspaceConnectionsQuery, GetWorkspaceConnectionsQueryVariables>;
export const ConnectMcpServerDocument = gql`
    mutation connectMcpServer($workspaceId: Int!, $serverUrl: String!, $clientId: String, $clientSecret: String) {
  connectMcpServer(
    workspaceId: $workspaceId
    serverUrl: $serverUrl
    clientId: $clientId
    clientSecret: $clientSecret
  ) {
    result {
      __typename
      authorizationUrl
      needs
      message
      redirectUri
    }
  }
}
    `;
export type ConnectMcpServerMutationFn = ApolloReactCommon.MutationFunction<ConnectMcpServerMutation, ConnectMcpServerMutationVariables>;

/**
 * __useConnectMcpServerMutation__
 *
 * To run a mutation, you first call `useConnectMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectMcpServerMutation, { data, loading, error }] = useConnectMcpServerMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      serverUrl: // value for 'serverUrl'
 *      clientId: // value for 'clientId'
 *      clientSecret: // value for 'clientSecret'
 *   },
 * });
 */
export function useConnectMcpServerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectMcpServerMutation, ConnectMcpServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConnectMcpServerMutation, ConnectMcpServerMutationVariables>(ConnectMcpServerDocument, options);
      }
export type ConnectMcpServerMutationHookResult = ReturnType<typeof useConnectMcpServerMutation>;
export type ConnectMcpServerMutationResult = ApolloReactCommon.MutationResult<ConnectMcpServerMutation>;
export type ConnectMcpServerMutationOptions = ApolloReactCommon.BaseMutationOptions<ConnectMcpServerMutation, ConnectMcpServerMutationVariables>;
export const SetMcpConnectionTokenDocument = gql`
    mutation setMcpConnectionToken($workspaceId: Int!, $serverUrl: String!, $token: String!) {
  setMcpConnectionToken(
    workspaceId: $workspaceId
    serverUrl: $serverUrl
    token: $token
  ) {
    connection {
      ...WorkspaceConnectionFields
    }
  }
}
    ${WorkspaceConnectionFieldsFragmentDoc}`;
export type SetMcpConnectionTokenMutationFn = ApolloReactCommon.MutationFunction<SetMcpConnectionTokenMutation, SetMcpConnectionTokenMutationVariables>;

/**
 * __useSetMcpConnectionTokenMutation__
 *
 * To run a mutation, you first call `useSetMcpConnectionTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMcpConnectionTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMcpConnectionTokenMutation, { data, loading, error }] = useSetMcpConnectionTokenMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      serverUrl: // value for 'serverUrl'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSetMcpConnectionTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMcpConnectionTokenMutation, SetMcpConnectionTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetMcpConnectionTokenMutation, SetMcpConnectionTokenMutationVariables>(SetMcpConnectionTokenDocument, options);
      }
export type SetMcpConnectionTokenMutationHookResult = ReturnType<typeof useSetMcpConnectionTokenMutation>;
export type SetMcpConnectionTokenMutationResult = ApolloReactCommon.MutationResult<SetMcpConnectionTokenMutation>;
export type SetMcpConnectionTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<SetMcpConnectionTokenMutation, SetMcpConnectionTokenMutationVariables>;
export const CompleteMcpConnectionDocument = gql`
    mutation completeMcpConnection($workspaceId: Int!, $state: String!, $code: String!) {
  completeMcpConnection(workspaceId: $workspaceId, state: $state, code: $code) {
    connection {
      ...WorkspaceConnectionFields
    }
  }
}
    ${WorkspaceConnectionFieldsFragmentDoc}`;
export type CompleteMcpConnectionMutationFn = ApolloReactCommon.MutationFunction<CompleteMcpConnectionMutation, CompleteMcpConnectionMutationVariables>;

/**
 * __useCompleteMcpConnectionMutation__
 *
 * To run a mutation, you first call `useCompleteMcpConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMcpConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMcpConnectionMutation, { data, loading, error }] = useCompleteMcpConnectionMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      state: // value for 'state'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCompleteMcpConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteMcpConnectionMutation, CompleteMcpConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteMcpConnectionMutation, CompleteMcpConnectionMutationVariables>(CompleteMcpConnectionDocument, options);
      }
export type CompleteMcpConnectionMutationHookResult = ReturnType<typeof useCompleteMcpConnectionMutation>;
export type CompleteMcpConnectionMutationResult = ApolloReactCommon.MutationResult<CompleteMcpConnectionMutation>;
export type CompleteMcpConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteMcpConnectionMutation, CompleteMcpConnectionMutationVariables>;
export const ConfirmConnectionDocument = gql`
    mutation confirmConnection($workspaceId: Int!, $connectionId: ID!, $outcome: ConnectionConfirmationOutcome!) {
  confirmConnection(
    workspaceId: $workspaceId
    connectionId: $connectionId
    outcome: $outcome
  ) {
    connection {
      ...WorkspaceConnectionFields
    }
  }
}
    ${WorkspaceConnectionFieldsFragmentDoc}`;
export type ConfirmConnectionMutationFn = ApolloReactCommon.MutationFunction<ConfirmConnectionMutation, ConfirmConnectionMutationVariables>;

/**
 * __useConfirmConnectionMutation__
 *
 * To run a mutation, you first call `useConfirmConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmConnectionMutation, { data, loading, error }] = useConfirmConnectionMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      connectionId: // value for 'connectionId'
 *      outcome: // value for 'outcome'
 *   },
 * });
 */
export function useConfirmConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmConnectionMutation, ConfirmConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmConnectionMutation, ConfirmConnectionMutationVariables>(ConfirmConnectionDocument, options);
      }
export type ConfirmConnectionMutationHookResult = ReturnType<typeof useConfirmConnectionMutation>;
export type ConfirmConnectionMutationResult = ApolloReactCommon.MutationResult<ConfirmConnectionMutation>;
export type ConfirmConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmConnectionMutation, ConfirmConnectionMutationVariables>;
export const DisconnectMcpConnectionDocument = gql`
    mutation disconnectMcpConnection($workspaceId: Int!, $connectionId: ID!, $deleteData: Boolean) {
  disconnectMcpConnection(
    workspaceId: $workspaceId
    connectionId: $connectionId
    deleteData: $deleteData
  ) {
    connection {
      ...WorkspaceConnectionFields
    }
  }
}
    ${WorkspaceConnectionFieldsFragmentDoc}`;
export type DisconnectMcpConnectionMutationFn = ApolloReactCommon.MutationFunction<DisconnectMcpConnectionMutation, DisconnectMcpConnectionMutationVariables>;

/**
 * __useDisconnectMcpConnectionMutation__
 *
 * To run a mutation, you first call `useDisconnectMcpConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectMcpConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectMcpConnectionMutation, { data, loading, error }] = useDisconnectMcpConnectionMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      connectionId: // value for 'connectionId'
 *      deleteData: // value for 'deleteData'
 *   },
 * });
 */
export function useDisconnectMcpConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisconnectMcpConnectionMutation, DisconnectMcpConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisconnectMcpConnectionMutation, DisconnectMcpConnectionMutationVariables>(DisconnectMcpConnectionDocument, options);
      }
export type DisconnectMcpConnectionMutationHookResult = ReturnType<typeof useDisconnectMcpConnectionMutation>;
export type DisconnectMcpConnectionMutationResult = ApolloReactCommon.MutationResult<DisconnectMcpConnectionMutation>;
export type DisconnectMcpConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<DisconnectMcpConnectionMutation, DisconnectMcpConnectionMutationVariables>;
export const GetWorkspaceIntelligenceDocument = gql`
    query getWorkspaceIntelligence($workspaceId: ID!) {
  workspaceIntelligence(workspaceId: $workspaceId) {
    id
    workspaceId
    description
    valuePropositions
    icp
    buyerPersonas
    competitorList
    productsServices
    salesProcess
    personalPreferences
    defaultSummaryTemplateId
    defaultBriefTemplateId
    customKnowledgeAreas {
      id
      workspaceId
      name
      content
      fileId
      filename
      extractedText
      extractionStatus
      extractedAt
      position
      createdAt
      updatedAt
    }
    sectionFiles {
      section
      fileId
      filename
      extractedText
      extractionStatus
      extractedAt
    }
    formattedContext
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetWorkspaceIntelligenceQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceIntelligenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceIntelligenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceIntelligenceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceIntelligenceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkspaceIntelligenceQuery, GetWorkspaceIntelligenceQueryVariables> & ({ variables: GetWorkspaceIntelligenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkspaceIntelligenceQuery, GetWorkspaceIntelligenceQueryVariables>(GetWorkspaceIntelligenceDocument, options);
      }
export function useGetWorkspaceIntelligenceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkspaceIntelligenceQuery, GetWorkspaceIntelligenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkspaceIntelligenceQuery, GetWorkspaceIntelligenceQueryVariables>(GetWorkspaceIntelligenceDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceIntelligenceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceIntelligenceQuery, GetWorkspaceIntelligenceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspaceIntelligenceQuery, GetWorkspaceIntelligenceQueryVariables>;
export function useGetWorkspaceIntelligenceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceIntelligenceQuery, GetWorkspaceIntelligenceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspaceIntelligenceQuery | undefined, GetWorkspaceIntelligenceQueryVariables>;
export function useGetWorkspaceIntelligenceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceIntelligenceQuery, GetWorkspaceIntelligenceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkspaceIntelligenceQuery, GetWorkspaceIntelligenceQueryVariables>(GetWorkspaceIntelligenceDocument, options);
        }
export type GetWorkspaceIntelligenceQueryHookResult = ReturnType<typeof useGetWorkspaceIntelligenceQuery>;
export type GetWorkspaceIntelligenceLazyQueryHookResult = ReturnType<typeof useGetWorkspaceIntelligenceLazyQuery>;
export type GetWorkspaceIntelligenceSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceIntelligenceSuspenseQuery>;
export type GetWorkspaceIntelligenceQueryResult = ApolloReactCommon.QueryResult<GetWorkspaceIntelligenceQuery, GetWorkspaceIntelligenceQueryVariables>;
export const WorkspaceLeadFinderSuggestionsDocument = gql`
    query workspaceLeadFinderSuggestions($workspaceId: ID!) {
  workspaceLeadFinderSuggestions(workspaceId: $workspaceId) {
    people
    companies
  }
}
    `;

/**
 * __useWorkspaceLeadFinderSuggestionsQuery__
 *
 * To run a query within a React component, call `useWorkspaceLeadFinderSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceLeadFinderSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceLeadFinderSuggestionsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useWorkspaceLeadFinderSuggestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspaceLeadFinderSuggestionsQuery, WorkspaceLeadFinderSuggestionsQueryVariables> & ({ variables: WorkspaceLeadFinderSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceLeadFinderSuggestionsQuery, WorkspaceLeadFinderSuggestionsQueryVariables>(WorkspaceLeadFinderSuggestionsDocument, options);
      }
export function useWorkspaceLeadFinderSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceLeadFinderSuggestionsQuery, WorkspaceLeadFinderSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceLeadFinderSuggestionsQuery, WorkspaceLeadFinderSuggestionsQueryVariables>(WorkspaceLeadFinderSuggestionsDocument, options);
        }
// @ts-ignore
export function useWorkspaceLeadFinderSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceLeadFinderSuggestionsQuery, WorkspaceLeadFinderSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceLeadFinderSuggestionsQuery, WorkspaceLeadFinderSuggestionsQueryVariables>;
export function useWorkspaceLeadFinderSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceLeadFinderSuggestionsQuery, WorkspaceLeadFinderSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceLeadFinderSuggestionsQuery | undefined, WorkspaceLeadFinderSuggestionsQueryVariables>;
export function useWorkspaceLeadFinderSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceLeadFinderSuggestionsQuery, WorkspaceLeadFinderSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspaceLeadFinderSuggestionsQuery, WorkspaceLeadFinderSuggestionsQueryVariables>(WorkspaceLeadFinderSuggestionsDocument, options);
        }
export type WorkspaceLeadFinderSuggestionsQueryHookResult = ReturnType<typeof useWorkspaceLeadFinderSuggestionsQuery>;
export type WorkspaceLeadFinderSuggestionsLazyQueryHookResult = ReturnType<typeof useWorkspaceLeadFinderSuggestionsLazyQuery>;
export type WorkspaceLeadFinderSuggestionsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceLeadFinderSuggestionsSuspenseQuery>;
export type WorkspaceLeadFinderSuggestionsQueryResult = ApolloReactCommon.QueryResult<WorkspaceLeadFinderSuggestionsQuery, WorkspaceLeadFinderSuggestionsQueryVariables>;
export const UpdateWorkspaceIntelligenceDocument = gql`
    mutation updateWorkspaceIntelligence($input: UpdateWorkspaceIntelligenceInput!) {
  updateWorkspaceIntelligence(input: $input) {
    intelligence {
      id
      workspaceId
      description
      valuePropositions
      icp
      buyerPersonas
      competitorList
      productsServices
      salesProcess
      personalPreferences
      defaultSummaryTemplateId
      defaultBriefTemplateId
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateWorkspaceIntelligenceMutationFn = ApolloReactCommon.MutationFunction<UpdateWorkspaceIntelligenceMutation, UpdateWorkspaceIntelligenceMutationVariables>;

/**
 * __useUpdateWorkspaceIntelligenceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceIntelligenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceIntelligenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceIntelligenceMutation, { data, loading, error }] = useUpdateWorkspaceIntelligenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceIntelligenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkspaceIntelligenceMutation, UpdateWorkspaceIntelligenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkspaceIntelligenceMutation, UpdateWorkspaceIntelligenceMutationVariables>(UpdateWorkspaceIntelligenceDocument, options);
      }
export type UpdateWorkspaceIntelligenceMutationHookResult = ReturnType<typeof useUpdateWorkspaceIntelligenceMutation>;
export type UpdateWorkspaceIntelligenceMutationResult = ApolloReactCommon.MutationResult<UpdateWorkspaceIntelligenceMutation>;
export type UpdateWorkspaceIntelligenceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWorkspaceIntelligenceMutation, UpdateWorkspaceIntelligenceMutationVariables>;
export const GenerateWorkspaceIntelligenceDocument = gql`
    mutation generateWorkspaceIntelligence($input: GenerateWorkspaceIntelligenceInput!) {
  generateWorkspaceIntelligence(input: $input) {
    intelligence {
      id
      workspaceId
      description
      valuePropositions
      icp
      buyerPersonas
      competitorList
      productsServices
      salesProcess
      personalPreferences
      createdAt
      updatedAt
    }
  }
}
    `;
export type GenerateWorkspaceIntelligenceMutationFn = ApolloReactCommon.MutationFunction<GenerateWorkspaceIntelligenceMutation, GenerateWorkspaceIntelligenceMutationVariables>;

/**
 * __useGenerateWorkspaceIntelligenceMutation__
 *
 * To run a mutation, you first call `useGenerateWorkspaceIntelligenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateWorkspaceIntelligenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateWorkspaceIntelligenceMutation, { data, loading, error }] = useGenerateWorkspaceIntelligenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateWorkspaceIntelligenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateWorkspaceIntelligenceMutation, GenerateWorkspaceIntelligenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateWorkspaceIntelligenceMutation, GenerateWorkspaceIntelligenceMutationVariables>(GenerateWorkspaceIntelligenceDocument, options);
      }
export type GenerateWorkspaceIntelligenceMutationHookResult = ReturnType<typeof useGenerateWorkspaceIntelligenceMutation>;
export type GenerateWorkspaceIntelligenceMutationResult = ApolloReactCommon.MutationResult<GenerateWorkspaceIntelligenceMutation>;
export type GenerateWorkspaceIntelligenceMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateWorkspaceIntelligenceMutation, GenerateWorkspaceIntelligenceMutationVariables>;
export const CreateWorkspaceCustomKnowledgeDocument = gql`
    mutation createWorkspaceCustomKnowledge($input: CreateWorkspaceCustomKnowledgeInput!) {
  createWorkspaceCustomKnowledge(input: $input) {
    customKnowledge {
      id
      workspaceId
      name
      content
      fileId
      filename
      extractedText
      extractionStatus
      extractedAt
      position
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateWorkspaceCustomKnowledgeMutationFn = ApolloReactCommon.MutationFunction<CreateWorkspaceCustomKnowledgeMutation, CreateWorkspaceCustomKnowledgeMutationVariables>;

/**
 * __useCreateWorkspaceCustomKnowledgeMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceCustomKnowledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceCustomKnowledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceCustomKnowledgeMutation, { data, loading, error }] = useCreateWorkspaceCustomKnowledgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceCustomKnowledgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWorkspaceCustomKnowledgeMutation, CreateWorkspaceCustomKnowledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkspaceCustomKnowledgeMutation, CreateWorkspaceCustomKnowledgeMutationVariables>(CreateWorkspaceCustomKnowledgeDocument, options);
      }
export type CreateWorkspaceCustomKnowledgeMutationHookResult = ReturnType<typeof useCreateWorkspaceCustomKnowledgeMutation>;
export type CreateWorkspaceCustomKnowledgeMutationResult = ApolloReactCommon.MutationResult<CreateWorkspaceCustomKnowledgeMutation>;
export type CreateWorkspaceCustomKnowledgeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateWorkspaceCustomKnowledgeMutation, CreateWorkspaceCustomKnowledgeMutationVariables>;
export const UpdateWorkspaceCustomKnowledgeDocument = gql`
    mutation updateWorkspaceCustomKnowledge($input: UpdateWorkspaceCustomKnowledgeInput!) {
  updateWorkspaceCustomKnowledge(input: $input) {
    customKnowledge {
      id
      workspaceId
      name
      content
      fileId
      filename
      extractedText
      extractionStatus
      extractedAt
      position
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateWorkspaceCustomKnowledgeMutationFn = ApolloReactCommon.MutationFunction<UpdateWorkspaceCustomKnowledgeMutation, UpdateWorkspaceCustomKnowledgeMutationVariables>;

/**
 * __useUpdateWorkspaceCustomKnowledgeMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceCustomKnowledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceCustomKnowledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceCustomKnowledgeMutation, { data, loading, error }] = useUpdateWorkspaceCustomKnowledgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceCustomKnowledgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkspaceCustomKnowledgeMutation, UpdateWorkspaceCustomKnowledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkspaceCustomKnowledgeMutation, UpdateWorkspaceCustomKnowledgeMutationVariables>(UpdateWorkspaceCustomKnowledgeDocument, options);
      }
export type UpdateWorkspaceCustomKnowledgeMutationHookResult = ReturnType<typeof useUpdateWorkspaceCustomKnowledgeMutation>;
export type UpdateWorkspaceCustomKnowledgeMutationResult = ApolloReactCommon.MutationResult<UpdateWorkspaceCustomKnowledgeMutation>;
export type UpdateWorkspaceCustomKnowledgeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWorkspaceCustomKnowledgeMutation, UpdateWorkspaceCustomKnowledgeMutationVariables>;
export const DeleteWorkspaceCustomKnowledgeDocument = gql`
    mutation deleteWorkspaceCustomKnowledge($id: ID!) {
  deleteWorkspaceCustomKnowledge(id: $id) {
    success
  }
}
    `;
export type DeleteWorkspaceCustomKnowledgeMutationFn = ApolloReactCommon.MutationFunction<DeleteWorkspaceCustomKnowledgeMutation, DeleteWorkspaceCustomKnowledgeMutationVariables>;

/**
 * __useDeleteWorkspaceCustomKnowledgeMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceCustomKnowledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceCustomKnowledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceCustomKnowledgeMutation, { data, loading, error }] = useDeleteWorkspaceCustomKnowledgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkspaceCustomKnowledgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWorkspaceCustomKnowledgeMutation, DeleteWorkspaceCustomKnowledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkspaceCustomKnowledgeMutation, DeleteWorkspaceCustomKnowledgeMutationVariables>(DeleteWorkspaceCustomKnowledgeDocument, options);
      }
export type DeleteWorkspaceCustomKnowledgeMutationHookResult = ReturnType<typeof useDeleteWorkspaceCustomKnowledgeMutation>;
export type DeleteWorkspaceCustomKnowledgeMutationResult = ApolloReactCommon.MutationResult<DeleteWorkspaceCustomKnowledgeMutation>;
export type DeleteWorkspaceCustomKnowledgeMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteWorkspaceCustomKnowledgeMutation, DeleteWorkspaceCustomKnowledgeMutationVariables>;
export const ReorderWorkspaceCustomKnowledgeDocument = gql`
    mutation reorderWorkspaceCustomKnowledge($input: ReorderWorkspaceCustomKnowledgeInput!) {
  reorderWorkspaceCustomKnowledge(input: $input) {
    customKnowledgeAreas {
      id
      position
    }
  }
}
    `;
export type ReorderWorkspaceCustomKnowledgeMutationFn = ApolloReactCommon.MutationFunction<ReorderWorkspaceCustomKnowledgeMutation, ReorderWorkspaceCustomKnowledgeMutationVariables>;

/**
 * __useReorderWorkspaceCustomKnowledgeMutation__
 *
 * To run a mutation, you first call `useReorderWorkspaceCustomKnowledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderWorkspaceCustomKnowledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderWorkspaceCustomKnowledgeMutation, { data, loading, error }] = useReorderWorkspaceCustomKnowledgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderWorkspaceCustomKnowledgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderWorkspaceCustomKnowledgeMutation, ReorderWorkspaceCustomKnowledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderWorkspaceCustomKnowledgeMutation, ReorderWorkspaceCustomKnowledgeMutationVariables>(ReorderWorkspaceCustomKnowledgeDocument, options);
      }
export type ReorderWorkspaceCustomKnowledgeMutationHookResult = ReturnType<typeof useReorderWorkspaceCustomKnowledgeMutation>;
export type ReorderWorkspaceCustomKnowledgeMutationResult = ApolloReactCommon.MutationResult<ReorderWorkspaceCustomKnowledgeMutation>;
export type ReorderWorkspaceCustomKnowledgeMutationOptions = ApolloReactCommon.BaseMutationOptions<ReorderWorkspaceCustomKnowledgeMutation, ReorderWorkspaceCustomKnowledgeMutationVariables>;
export const SetWorkspaceIntelligenceSectionFileDocument = gql`
    mutation setWorkspaceIntelligenceSectionFile($input: SetWorkspaceIntelligenceSectionFileInput!) {
  setWorkspaceIntelligenceSectionFile(input: $input) {
    sectionFile {
      section
      fileId
      filename
      extractedText
      extractionStatus
      extractedAt
    }
  }
}
    `;
export type SetWorkspaceIntelligenceSectionFileMutationFn = ApolloReactCommon.MutationFunction<SetWorkspaceIntelligenceSectionFileMutation, SetWorkspaceIntelligenceSectionFileMutationVariables>;

/**
 * __useSetWorkspaceIntelligenceSectionFileMutation__
 *
 * To run a mutation, you first call `useSetWorkspaceIntelligenceSectionFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkspaceIntelligenceSectionFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkspaceIntelligenceSectionFileMutation, { data, loading, error }] = useSetWorkspaceIntelligenceSectionFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWorkspaceIntelligenceSectionFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetWorkspaceIntelligenceSectionFileMutation, SetWorkspaceIntelligenceSectionFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetWorkspaceIntelligenceSectionFileMutation, SetWorkspaceIntelligenceSectionFileMutationVariables>(SetWorkspaceIntelligenceSectionFileDocument, options);
      }
export type SetWorkspaceIntelligenceSectionFileMutationHookResult = ReturnType<typeof useSetWorkspaceIntelligenceSectionFileMutation>;
export type SetWorkspaceIntelligenceSectionFileMutationResult = ApolloReactCommon.MutationResult<SetWorkspaceIntelligenceSectionFileMutation>;
export type SetWorkspaceIntelligenceSectionFileMutationOptions = ApolloReactCommon.BaseMutationOptions<SetWorkspaceIntelligenceSectionFileMutation, SetWorkspaceIntelligenceSectionFileMutationVariables>;
export const UpdateWorkspaceDocument = gql`
    mutation updateWorkspace($input: UpdateWorkspaceInput!) {
  updateWorkspace(input: $input) {
    workspace {
      ...WorkspaceFields
      domains {
        ...WorkspaceDomainFields
      }
    }
  }
}
    ${WorkspaceFieldsFragmentDoc}
${WorkspaceDomainFieldsFragmentDoc}`;
export type UpdateWorkspaceMutationFn = ApolloReactCommon.MutationFunction<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>;

/**
 * __useUpdateWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMutation, { data, loading, error }] = useUpdateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>(UpdateWorkspaceDocument, options);
      }
export type UpdateWorkspaceMutationHookResult = ReturnType<typeof useUpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationResult = ApolloReactCommon.MutationResult<UpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>;
export const GetWorkspaceDomainsDocument = gql`
    query getWorkspaceDomains($id: ID!) {
  workspace(id: $id) {
    __typename
    id
    domains {
      ...WorkspaceDomainFields
    }
  }
}
    ${WorkspaceDomainFieldsFragmentDoc}`;

/**
 * __useGetWorkspaceDomainsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceDomainsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkspaceDomainsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkspaceDomainsQuery, GetWorkspaceDomainsQueryVariables> & ({ variables: GetWorkspaceDomainsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkspaceDomainsQuery, GetWorkspaceDomainsQueryVariables>(GetWorkspaceDomainsDocument, options);
      }
export function useGetWorkspaceDomainsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkspaceDomainsQuery, GetWorkspaceDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkspaceDomainsQuery, GetWorkspaceDomainsQueryVariables>(GetWorkspaceDomainsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceDomainsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceDomainsQuery, GetWorkspaceDomainsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspaceDomainsQuery, GetWorkspaceDomainsQueryVariables>;
export function useGetWorkspaceDomainsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceDomainsQuery, GetWorkspaceDomainsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspaceDomainsQuery | undefined, GetWorkspaceDomainsQueryVariables>;
export function useGetWorkspaceDomainsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspaceDomainsQuery, GetWorkspaceDomainsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkspaceDomainsQuery, GetWorkspaceDomainsQueryVariables>(GetWorkspaceDomainsDocument, options);
        }
export type GetWorkspaceDomainsQueryHookResult = ReturnType<typeof useGetWorkspaceDomainsQuery>;
export type GetWorkspaceDomainsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceDomainsLazyQuery>;
export type GetWorkspaceDomainsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceDomainsSuspenseQuery>;
export type GetWorkspaceDomainsQueryResult = ApolloReactCommon.QueryResult<GetWorkspaceDomainsQuery, GetWorkspaceDomainsQueryVariables>;
export const AddWorkspaceDomainDocument = gql`
    mutation addWorkspaceDomain($input: AddWorkspaceDomainInput!) {
  addWorkspaceDomain(input: $input) {
    success
    error
    workspace {
      __typename
      id
      domains {
        ...WorkspaceDomainFields
      }
    }
  }
}
    ${WorkspaceDomainFieldsFragmentDoc}`;
export type AddWorkspaceDomainMutationFn = ApolloReactCommon.MutationFunction<AddWorkspaceDomainMutation, AddWorkspaceDomainMutationVariables>;

/**
 * __useAddWorkspaceDomainMutation__
 *
 * To run a mutation, you first call `useAddWorkspaceDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkspaceDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkspaceDomainMutation, { data, loading, error }] = useAddWorkspaceDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddWorkspaceDomainMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddWorkspaceDomainMutation, AddWorkspaceDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddWorkspaceDomainMutation, AddWorkspaceDomainMutationVariables>(AddWorkspaceDomainDocument, options);
      }
export type AddWorkspaceDomainMutationHookResult = ReturnType<typeof useAddWorkspaceDomainMutation>;
export type AddWorkspaceDomainMutationResult = ApolloReactCommon.MutationResult<AddWorkspaceDomainMutation>;
export type AddWorkspaceDomainMutationOptions = ApolloReactCommon.BaseMutationOptions<AddWorkspaceDomainMutation, AddWorkspaceDomainMutationVariables>;
export const RemoveWorkspaceDomainDocument = gql`
    mutation removeWorkspaceDomain($input: RemoveWorkspaceDomainInput!) {
  removeWorkspaceDomain(input: $input) {
    success
    error
    workspace {
      __typename
      id
      domains {
        ...WorkspaceDomainFields
      }
    }
  }
}
    ${WorkspaceDomainFieldsFragmentDoc}`;
export type RemoveWorkspaceDomainMutationFn = ApolloReactCommon.MutationFunction<RemoveWorkspaceDomainMutation, RemoveWorkspaceDomainMutationVariables>;

/**
 * __useRemoveWorkspaceDomainMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspaceDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspaceDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspaceDomainMutation, { data, loading, error }] = useRemoveWorkspaceDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveWorkspaceDomainMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveWorkspaceDomainMutation, RemoveWorkspaceDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveWorkspaceDomainMutation, RemoveWorkspaceDomainMutationVariables>(RemoveWorkspaceDomainDocument, options);
      }
export type RemoveWorkspaceDomainMutationHookResult = ReturnType<typeof useRemoveWorkspaceDomainMutation>;
export type RemoveWorkspaceDomainMutationResult = ApolloReactCommon.MutationResult<RemoveWorkspaceDomainMutation>;
export type RemoveWorkspaceDomainMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveWorkspaceDomainMutation, RemoveWorkspaceDomainMutationVariables>;
export const SendWelcomeEmailDocument = gql`
    mutation sendWelcomeEmail($input: SendWorkspaceWelcomeEmailInput!) {
  sendWelcomeEmail(input: $input) {
    workspace {
      ...WorkspaceFields
    }
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type SendWelcomeEmailMutationFn = ApolloReactCommon.MutationFunction<SendWelcomeEmailMutation, SendWelcomeEmailMutationVariables>;

/**
 * __useSendWelcomeEmailMutation__
 *
 * To run a mutation, you first call `useSendWelcomeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendWelcomeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendWelcomeEmailMutation, { data, loading, error }] = useSendWelcomeEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendWelcomeEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendWelcomeEmailMutation, SendWelcomeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendWelcomeEmailMutation, SendWelcomeEmailMutationVariables>(SendWelcomeEmailDocument, options);
      }
export type SendWelcomeEmailMutationHookResult = ReturnType<typeof useSendWelcomeEmailMutation>;
export type SendWelcomeEmailMutationResult = ApolloReactCommon.MutationResult<SendWelcomeEmailMutation>;
export type SendWelcomeEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendWelcomeEmailMutation, SendWelcomeEmailMutationVariables>;
export const GetTemporalTaskRunDocument = gql`
    query getTemporalTaskRun($workflowId: String) {
  temporalTaskRun(workflowId: $workflowId) {
    runId
    workspaceId
    workflowType
    workflowId
    expectedNumSteps
    entries {
      runId
      stepName
    }
  }
}
    `;

/**
 * __useGetTemporalTaskRunQuery__
 *
 * To run a query within a React component, call `useGetTemporalTaskRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemporalTaskRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemporalTaskRunQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetTemporalTaskRunQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTemporalTaskRunQuery, GetTemporalTaskRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTemporalTaskRunQuery, GetTemporalTaskRunQueryVariables>(GetTemporalTaskRunDocument, options);
      }
export function useGetTemporalTaskRunLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTemporalTaskRunQuery, GetTemporalTaskRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTemporalTaskRunQuery, GetTemporalTaskRunQueryVariables>(GetTemporalTaskRunDocument, options);
        }
// @ts-ignore
export function useGetTemporalTaskRunSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTemporalTaskRunQuery, GetTemporalTaskRunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTemporalTaskRunQuery, GetTemporalTaskRunQueryVariables>;
export function useGetTemporalTaskRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTemporalTaskRunQuery, GetTemporalTaskRunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTemporalTaskRunQuery | undefined, GetTemporalTaskRunQueryVariables>;
export function useGetTemporalTaskRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTemporalTaskRunQuery, GetTemporalTaskRunQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTemporalTaskRunQuery, GetTemporalTaskRunQueryVariables>(GetTemporalTaskRunDocument, options);
        }
export type GetTemporalTaskRunQueryHookResult = ReturnType<typeof useGetTemporalTaskRunQuery>;
export type GetTemporalTaskRunLazyQueryHookResult = ReturnType<typeof useGetTemporalTaskRunLazyQuery>;
export type GetTemporalTaskRunSuspenseQueryHookResult = ReturnType<typeof useGetTemporalTaskRunSuspenseQuery>;
export type GetTemporalTaskRunQueryResult = ApolloReactCommon.QueryResult<GetTemporalTaskRunQuery, GetTemporalTaskRunQueryVariables>;
export const GetWorkspacePreferencesDocument = gql`
    query getWorkspacePreferences($workspaceId: ID!) {
  workspacePreferences(workspaceId: $workspaceId) {
    __typename
    id
    workspaceId
    preferences
    publicVisibility
    emailVisibility
    tasksVisibility
    recordSharingEnabled
    notesDefaultAcl
    engagementsDefaultAcl
    filesDefaultAcl
    fiscalYearStartMonth
    fiscalYearStartDay
    defaultLanguage
    autoRechargeEnabled
    autoRechargePackId
    revenueGpt {
      strictMode
    }
    createTs
    updateTs
  }
}
    `;

/**
 * __useGetWorkspacePreferencesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePreferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspacePreferencesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkspacePreferencesQuery, GetWorkspacePreferencesQueryVariables> & ({ variables: GetWorkspacePreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkspacePreferencesQuery, GetWorkspacePreferencesQueryVariables>(GetWorkspacePreferencesDocument, options);
      }
export function useGetWorkspacePreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkspacePreferencesQuery, GetWorkspacePreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkspacePreferencesQuery, GetWorkspacePreferencesQueryVariables>(GetWorkspacePreferencesDocument, options);
        }
// @ts-ignore
export function useGetWorkspacePreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspacePreferencesQuery, GetWorkspacePreferencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspacePreferencesQuery, GetWorkspacePreferencesQueryVariables>;
export function useGetWorkspacePreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspacePreferencesQuery, GetWorkspacePreferencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetWorkspacePreferencesQuery | undefined, GetWorkspacePreferencesQueryVariables>;
export function useGetWorkspacePreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkspacePreferencesQuery, GetWorkspacePreferencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkspacePreferencesQuery, GetWorkspacePreferencesQueryVariables>(GetWorkspacePreferencesDocument, options);
        }
export type GetWorkspacePreferencesQueryHookResult = ReturnType<typeof useGetWorkspacePreferencesQuery>;
export type GetWorkspacePreferencesLazyQueryHookResult = ReturnType<typeof useGetWorkspacePreferencesLazyQuery>;
export type GetWorkspacePreferencesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspacePreferencesSuspenseQuery>;
export type GetWorkspacePreferencesQueryResult = ApolloReactCommon.QueryResult<GetWorkspacePreferencesQuery, GetWorkspacePreferencesQueryVariables>;
export const UpdateAutoRechargeDocument = gql`
    mutation updateAutoRecharge($input: UpdateAutoRechargeInput!) {
  updateAutoRecharge(input: $input) {
    preferences {
      __typename
      id
      autoRechargeEnabled
      autoRechargePackId
    }
  }
}
    `;
export type UpdateAutoRechargeMutationFn = ApolloReactCommon.MutationFunction<UpdateAutoRechargeMutation, UpdateAutoRechargeMutationVariables>;

/**
 * __useUpdateAutoRechargeMutation__
 *
 * To run a mutation, you first call `useUpdateAutoRechargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoRechargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoRechargeMutation, { data, loading, error }] = useUpdateAutoRechargeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutoRechargeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAutoRechargeMutation, UpdateAutoRechargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAutoRechargeMutation, UpdateAutoRechargeMutationVariables>(UpdateAutoRechargeDocument, options);
      }
export type UpdateAutoRechargeMutationHookResult = ReturnType<typeof useUpdateAutoRechargeMutation>;
export type UpdateAutoRechargeMutationResult = ApolloReactCommon.MutationResult<UpdateAutoRechargeMutation>;
export type UpdateAutoRechargeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAutoRechargeMutation, UpdateAutoRechargeMutationVariables>;
export const GetIsIngestionRunningDocument = gql`
    query getIsIngestionRunning($workspaceId: ID!, $platform: String) {
  isIngestionRunning(workspaceId: $workspaceId, platform: $platform)
}
    `;

/**
 * __useGetIsIngestionRunningQuery__
 *
 * To run a query within a React component, call `useGetIsIngestionRunningQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsIngestionRunningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsIngestionRunningQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetIsIngestionRunningQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIsIngestionRunningQuery, GetIsIngestionRunningQueryVariables> & ({ variables: GetIsIngestionRunningQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIsIngestionRunningQuery, GetIsIngestionRunningQueryVariables>(GetIsIngestionRunningDocument, options);
      }
export function useGetIsIngestionRunningLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIsIngestionRunningQuery, GetIsIngestionRunningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIsIngestionRunningQuery, GetIsIngestionRunningQueryVariables>(GetIsIngestionRunningDocument, options);
        }
// @ts-ignore
export function useGetIsIngestionRunningSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetIsIngestionRunningQuery, GetIsIngestionRunningQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIsIngestionRunningQuery, GetIsIngestionRunningQueryVariables>;
export function useGetIsIngestionRunningSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIsIngestionRunningQuery, GetIsIngestionRunningQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIsIngestionRunningQuery | undefined, GetIsIngestionRunningQueryVariables>;
export function useGetIsIngestionRunningSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIsIngestionRunningQuery, GetIsIngestionRunningQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIsIngestionRunningQuery, GetIsIngestionRunningQueryVariables>(GetIsIngestionRunningDocument, options);
        }
export type GetIsIngestionRunningQueryHookResult = ReturnType<typeof useGetIsIngestionRunningQuery>;
export type GetIsIngestionRunningLazyQueryHookResult = ReturnType<typeof useGetIsIngestionRunningLazyQuery>;
export type GetIsIngestionRunningSuspenseQueryHookResult = ReturnType<typeof useGetIsIngestionRunningSuspenseQuery>;
export type GetIsIngestionRunningQueryResult = ApolloReactCommon.QueryResult<GetIsIngestionRunningQuery, GetIsIngestionRunningQueryVariables>;
export const GetEarliestCompareDateDocument = gql`
    query getEarliestCompareDate($id: ID!) {
  workspace(id: $id) {
    __typename
    earliestCompareDate
  }
}
    `;

/**
 * __useGetEarliestCompareDateQuery__
 *
 * To run a query within a React component, call `useGetEarliestCompareDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarliestCompareDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarliestCompareDateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEarliestCompareDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEarliestCompareDateQuery, GetEarliestCompareDateQueryVariables> & ({ variables: GetEarliestCompareDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEarliestCompareDateQuery, GetEarliestCompareDateQueryVariables>(GetEarliestCompareDateDocument, options);
      }
export function useGetEarliestCompareDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEarliestCompareDateQuery, GetEarliestCompareDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEarliestCompareDateQuery, GetEarliestCompareDateQueryVariables>(GetEarliestCompareDateDocument, options);
        }
// @ts-ignore
export function useGetEarliestCompareDateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEarliestCompareDateQuery, GetEarliestCompareDateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEarliestCompareDateQuery, GetEarliestCompareDateQueryVariables>;
export function useGetEarliestCompareDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEarliestCompareDateQuery, GetEarliestCompareDateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEarliestCompareDateQuery | undefined, GetEarliestCompareDateQueryVariables>;
export function useGetEarliestCompareDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEarliestCompareDateQuery, GetEarliestCompareDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEarliestCompareDateQuery, GetEarliestCompareDateQueryVariables>(GetEarliestCompareDateDocument, options);
        }
export type GetEarliestCompareDateQueryHookResult = ReturnType<typeof useGetEarliestCompareDateQuery>;
export type GetEarliestCompareDateLazyQueryHookResult = ReturnType<typeof useGetEarliestCompareDateLazyQuery>;
export type GetEarliestCompareDateSuspenseQueryHookResult = ReturnType<typeof useGetEarliestCompareDateSuspenseQuery>;
export type GetEarliestCompareDateQueryResult = ApolloReactCommon.QueryResult<GetEarliestCompareDateQuery, GetEarliestCompareDateQueryVariables>;
export const UpdatePrivacyDocument = gql`
    mutation updatePrivacy($input: PublicVisibilityInput!, $workspaceId: ID!) {
  updatePrivacy(input: $input, workspaceId: $workspaceId) {
    preferences {
      publicVisibility
    }
  }
}
    `;
export type UpdatePrivacyMutationFn = ApolloReactCommon.MutationFunction<UpdatePrivacyMutation, UpdatePrivacyMutationVariables>;

/**
 * __useUpdatePrivacyMutation__
 *
 * To run a mutation, you first call `useUpdatePrivacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrivacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrivacyMutation, { data, loading, error }] = useUpdatePrivacyMutation({
 *   variables: {
 *      input: // value for 'input'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdatePrivacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePrivacyMutation, UpdatePrivacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePrivacyMutation, UpdatePrivacyMutationVariables>(UpdatePrivacyDocument, options);
      }
export type UpdatePrivacyMutationHookResult = ReturnType<typeof useUpdatePrivacyMutation>;
export type UpdatePrivacyMutationResult = ApolloReactCommon.MutationResult<UpdatePrivacyMutation>;
export type UpdatePrivacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePrivacyMutation, UpdatePrivacyMutationVariables>;
export const UpdateEmailVisibilityDocument = gql`
    mutation updateEmailVisibility($input: EmailVisibilityInput!, $workspaceId: ID!) {
  updateEmailVisibility(input: $input, workspaceId: $workspaceId) {
    preferences {
      emailVisibility
      publicVisibility
    }
  }
}
    `;
export type UpdateEmailVisibilityMutationFn = ApolloReactCommon.MutationFunction<UpdateEmailVisibilityMutation, UpdateEmailVisibilityMutationVariables>;

/**
 * __useUpdateEmailVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateEmailVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailVisibilityMutation, { data, loading, error }] = useUpdateEmailVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdateEmailVisibilityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEmailVisibilityMutation, UpdateEmailVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEmailVisibilityMutation, UpdateEmailVisibilityMutationVariables>(UpdateEmailVisibilityDocument, options);
      }
export type UpdateEmailVisibilityMutationHookResult = ReturnType<typeof useUpdateEmailVisibilityMutation>;
export type UpdateEmailVisibilityMutationResult = ApolloReactCommon.MutationResult<UpdateEmailVisibilityMutation>;
export type UpdateEmailVisibilityMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEmailVisibilityMutation, UpdateEmailVisibilityMutationVariables>;
export const UpdateTasksVisibilityDocument = gql`
    mutation updateTasksVisibility($input: TasksVisibilityInput!, $workspaceId: ID!) {
  updateTasksVisibility(input: $input, workspaceId: $workspaceId) {
    preferences {
      tasksVisibility
    }
  }
}
    `;
export type UpdateTasksVisibilityMutationFn = ApolloReactCommon.MutationFunction<UpdateTasksVisibilityMutation, UpdateTasksVisibilityMutationVariables>;

/**
 * __useUpdateTasksVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateTasksVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTasksVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTasksVisibilityMutation, { data, loading, error }] = useUpdateTasksVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdateTasksVisibilityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTasksVisibilityMutation, UpdateTasksVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTasksVisibilityMutation, UpdateTasksVisibilityMutationVariables>(UpdateTasksVisibilityDocument, options);
      }
export type UpdateTasksVisibilityMutationHookResult = ReturnType<typeof useUpdateTasksVisibilityMutation>;
export type UpdateTasksVisibilityMutationResult = ApolloReactCommon.MutationResult<UpdateTasksVisibilityMutation>;
export type UpdateTasksVisibilityMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTasksVisibilityMutation, UpdateTasksVisibilityMutationVariables>;
export const UpdateWorkspaceDefaultLanguageDocument = gql`
    mutation updateWorkspaceDefaultLanguage($input: UpdateWorkspaceDefaultLanguageInput!) {
  updateDefaultLanguage(input: $input) {
    preferences {
      __typename
      id
      defaultLanguage
    }
  }
}
    `;
export type UpdateWorkspaceDefaultLanguageMutationFn = ApolloReactCommon.MutationFunction<UpdateWorkspaceDefaultLanguageMutation, UpdateWorkspaceDefaultLanguageMutationVariables>;

/**
 * __useUpdateWorkspaceDefaultLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceDefaultLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceDefaultLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceDefaultLanguageMutation, { data, loading, error }] = useUpdateWorkspaceDefaultLanguageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceDefaultLanguageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkspaceDefaultLanguageMutation, UpdateWorkspaceDefaultLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkspaceDefaultLanguageMutation, UpdateWorkspaceDefaultLanguageMutationVariables>(UpdateWorkspaceDefaultLanguageDocument, options);
      }
export type UpdateWorkspaceDefaultLanguageMutationHookResult = ReturnType<typeof useUpdateWorkspaceDefaultLanguageMutation>;
export type UpdateWorkspaceDefaultLanguageMutationResult = ApolloReactCommon.MutationResult<UpdateWorkspaceDefaultLanguageMutation>;
export type UpdateWorkspaceDefaultLanguageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWorkspaceDefaultLanguageMutation, UpdateWorkspaceDefaultLanguageMutationVariables>;
export const UpdateWorkspacePreferencesDocument = gql`
    mutation updateWorkspacePreferences($input: UpdateWorkspacePreferencesInput!) {
  updatePreferences(input: $input) {
    preferences {
      id
      workspaceId
      preferences
      fiscalYearStartMonth
      fiscalYearStartDay
    }
  }
}
    `;
export type UpdateWorkspacePreferencesMutationFn = ApolloReactCommon.MutationFunction<UpdateWorkspacePreferencesMutation, UpdateWorkspacePreferencesMutationVariables>;

/**
 * __useUpdateWorkspacePreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspacePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspacePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspacePreferencesMutation, { data, loading, error }] = useUpdateWorkspacePreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspacePreferencesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkspacePreferencesMutation, UpdateWorkspacePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkspacePreferencesMutation, UpdateWorkspacePreferencesMutationVariables>(UpdateWorkspacePreferencesDocument, options);
      }
export type UpdateWorkspacePreferencesMutationHookResult = ReturnType<typeof useUpdateWorkspacePreferencesMutation>;
export type UpdateWorkspacePreferencesMutationResult = ApolloReactCommon.MutationResult<UpdateWorkspacePreferencesMutation>;
export type UpdateWorkspacePreferencesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWorkspacePreferencesMutation, UpdateWorkspacePreferencesMutationVariables>;
export const GetAvailableWorkspacesDocument = gql`
    query getAvailableWorkspaces {
  availableWorkspaces {
    id
    name
    domain
    logoUrl
  }
}
    `;

/**
 * __useGetAvailableWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetAvailableWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableWorkspacesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAvailableWorkspacesQuery, GetAvailableWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAvailableWorkspacesQuery, GetAvailableWorkspacesQueryVariables>(GetAvailableWorkspacesDocument, options);
      }
export function useGetAvailableWorkspacesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAvailableWorkspacesQuery, GetAvailableWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAvailableWorkspacesQuery, GetAvailableWorkspacesQueryVariables>(GetAvailableWorkspacesDocument, options);
        }
// @ts-ignore
export function useGetAvailableWorkspacesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAvailableWorkspacesQuery, GetAvailableWorkspacesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAvailableWorkspacesQuery, GetAvailableWorkspacesQueryVariables>;
export function useGetAvailableWorkspacesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAvailableWorkspacesQuery, GetAvailableWorkspacesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAvailableWorkspacesQuery | undefined, GetAvailableWorkspacesQueryVariables>;
export function useGetAvailableWorkspacesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAvailableWorkspacesQuery, GetAvailableWorkspacesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAvailableWorkspacesQuery, GetAvailableWorkspacesQueryVariables>(GetAvailableWorkspacesDocument, options);
        }
export type GetAvailableWorkspacesQueryHookResult = ReturnType<typeof useGetAvailableWorkspacesQuery>;
export type GetAvailableWorkspacesLazyQueryHookResult = ReturnType<typeof useGetAvailableWorkspacesLazyQuery>;
export type GetAvailableWorkspacesSuspenseQueryHookResult = ReturnType<typeof useGetAvailableWorkspacesSuspenseQuery>;
export type GetAvailableWorkspacesQueryResult = ApolloReactCommon.QueryResult<GetAvailableWorkspacesQuery, GetAvailableWorkspacesQueryVariables>;
export const JoinWorkspaceDocument = gql`
    mutation joinWorkspace($input: JoinWorkspaceInput!) {
  joinWorkspace(input: $input) {
    success
    error
    workspace {
      ...WorkspaceFields
    }
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type JoinWorkspaceMutationFn = ApolloReactCommon.MutationFunction<JoinWorkspaceMutation, JoinWorkspaceMutationVariables>;

/**
 * __useJoinWorkspaceMutation__
 *
 * To run a mutation, you first call `useJoinWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinWorkspaceMutation, { data, loading, error }] = useJoinWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<JoinWorkspaceMutation, JoinWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<JoinWorkspaceMutation, JoinWorkspaceMutationVariables>(JoinWorkspaceDocument, options);
      }
export type JoinWorkspaceMutationHookResult = ReturnType<typeof useJoinWorkspaceMutation>;
export type JoinWorkspaceMutationResult = ApolloReactCommon.MutationResult<JoinWorkspaceMutation>;
export type JoinWorkspaceMutationOptions = ApolloReactCommon.BaseMutationOptions<JoinWorkspaceMutation, JoinWorkspaceMutationVariables>;
export const CreateWorkspaceDocument = gql`
    mutation createWorkspace($input: CreateWorkspaceInput!) {
  createWorkspace(input: $input) {
    success
    error
    workspace {
      ...WorkspaceFields
    }
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type CreateWorkspaceMutationFn = ApolloReactCommon.MutationFunction<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument, options);
      }
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>;
export type CreateWorkspaceMutationResult = ApolloReactCommon.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;
export const DeleteWorkspaceDocument = gql`
    mutation deleteWorkspace($input: DeleteWorkspaceInput!) {
  deleteWorkspace(input: $input) {
    success
  }
}
    `;
export type DeleteWorkspaceMutationFn = ApolloReactCommon.MutationFunction<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>(DeleteWorkspaceDocument, options);
      }
export type DeleteWorkspaceMutationHookResult = ReturnType<typeof useDeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationResult = ApolloReactCommon.MutationResult<DeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;